import { Object } from 'graphql/customScalars';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** ISO date/timestamp string, passed through as-is. */
  Date: { input: string; output: string; }
  /** A field whose value conforms to the standard internet email address format as specified in HTML Spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: { input: string; output: string; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: Record<string, unknown>; output: Record<string, unknown>; }
  /** A string that cannot be passed as an empty value */
  NonEmptyString: { input: string; output: string; }
  /** Floats that will have a value of 0 or more. */
  NonNegativeFloat: { input: number; output: number; }
  /** Integers that will have a value of 0 or more. */
  NonNegativeInt: { input: number; output: number; }
  /** Arbitrary JSON-serializable value, passed through as-is. */
  Object: { input: Object; output: Object; }
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  URL: { input: URL | string; output: URL | string; }
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: { input: string; output: string; }
};

export type AddMessageInput = {
  bidIds: Array<Scalars['Int']['input']>;
  brandId?: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
  venueId?: InputMaybe<Scalars['Int']['input']>;
};

export type AddProductTemplateInput = {
  avatarBucketKey?: InputMaybe<Scalars['String']['input']>;
  averageWholesalePrice: Scalars['Float']['input'];
  brandId: Scalars['Int']['input'];
  files?: InputMaybe<Array<FileInput>>;
  isAnyWholesalerCompatible: Scalars['Boolean']['input'];
  isDirectSupplyCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  packagingType: Scalars['String']['input'];
  productCategoryId: Scalars['Int']['input'];
  productName: Scalars['String']['input'];
  productUrl?: InputMaybe<Scalars['String']['input']>;
  unitType: Scalars['String']['input'];
  unitsPerCase: Scalars['Int']['input'];
  volumePerUnit: Scalars['Float']['input'];
  wholesalersIds: Array<Scalars['Int']['input']>;
};

export type AddTenderDraftInput = {
  estimatedVolume?: InputMaybe<Scalars['Int']['input']>;
  files: Array<FileInput>;
  isAnyWholesalerCompatible: Scalars['Boolean']['input'];
  isDirectSupplyCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate: Scalars['Boolean']['input'];
  listingEndsAtUtc?: InputMaybe<Scalars['Date']['input']>;
  listingStartsAtUtc?: InputMaybe<Scalars['Date']['input']>;
  listingTypeId: Scalars['NonNegativeInt']['input'];
  name: Scalars['String']['input'];
  packagingType?: InputMaybe<Scalars['String']['input']>;
  productCategoryIds: Array<Scalars['NonNegativeInt']['input']>;
  supportDetails?: InputMaybe<Scalars['String']['input']>;
  supportsDiscount: TenderSupportOption;
  supportsFreeStock: TenderSupportOption;
  supportsListingFee: TenderSupportOption;
  supportsPosBudget: TenderSupportOption;
  supportsRetroDiscount: TenderSupportOption;
  tenderDetails?: InputMaybe<Scalars['String']['input']>;
  tenderEndsAtUtc?: InputMaybe<Scalars['Date']['input']>;
  tenderStartsAtUtc?: InputMaybe<Scalars['Date']['input']>;
  unitType?: InputMaybe<Scalars['String']['input']>;
  venueId: Scalars['NonNegativeInt']['input'];
  volumeDetails?: InputMaybe<Scalars['String']['input']>;
  volumeUnits?: InputMaybe<Scalars['Float']['input']>;
  wholesalersIds: Array<Scalars['NonNegativeInt']['input']>;
};

export type AddTenderInput = {
  estimatedVolume: Scalars['Int']['input'];
  files: Array<FileInput>;
  isAnyWholesalerCompatible: Scalars['Boolean']['input'];
  isDirectSupplyCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate: Scalars['Boolean']['input'];
  listingEndsAtUtc: Scalars['Date']['input'];
  listingStartsAtUtc: Scalars['Date']['input'];
  listingTypeId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  packagingType: Scalars['String']['input'];
  productCategoryIds: Array<Scalars['Int']['input']>;
  supportDetails?: InputMaybe<Scalars['String']['input']>;
  supportsDiscount: TenderSupportOption;
  supportsFreeStock: TenderSupportOption;
  supportsListingFee: TenderSupportOption;
  supportsPosBudget: TenderSupportOption;
  supportsRetroDiscount: TenderSupportOption;
  tenderDetails?: InputMaybe<Scalars['String']['input']>;
  tenderEndsAtUtc: Scalars['Date']['input'];
  tenderStartsAtUtc: Scalars['Date']['input'];
  unitType: Scalars['String']['input'];
  venueId: Scalars['Int']['input'];
  volumeDetails?: InputMaybe<Scalars['String']['input']>;
  volumeUnits: Scalars['Float']['input'];
  wholesalersIds: Array<Scalars['Int']['input']>;
};

export type AddTenderRetoolInput = {
  region: Region;
  tenderData: AddTenderInput;
};

export type Address = {
  __typename?: 'Address';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  coordinates: Point;
  country?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
};

export type AddressAdministrativeAreLevel2ShortNameFilters = {
  OR?: InputMaybe<Array<AddressAdministrativeAreLevel2ShortNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type AddressAdministrativeAreLevel2ShortNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type AddressAdministrativeAreaLevel1Filters = {
  OR?: InputMaybe<Array<AddressAdministrativeAreaLevel1filtersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type AddressAdministrativeAreaLevel1ShortNameFilters = {
  OR?: InputMaybe<Array<AddressAdministrativeAreaLevel1ShortNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type AddressAdministrativeAreaLevel1ShortNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type AddressAdministrativeAreaLevel1filtersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type AddressAdministrativeAreaLevel2Filters = {
  OR?: InputMaybe<Array<AddressAdministrativeAreaLevel2filtersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type AddressAdministrativeAreaLevel2filtersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type AddressByPlaceIdInput = {
  googlePlacesSessionToken: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
  region: Region;
};

export type AddressCountryFilters = {
  OR?: InputMaybe<Array<AddressCountryfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type AddressCountryfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type AddressCreatedAtUtcFilters = {
  OR?: InputMaybe<Array<AddressCreatedAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type AddressCreatedAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type AddressFilters = {
  OR?: InputMaybe<Array<AddressFiltersOr>>;
  administrativeAreLevel2ShortName?: InputMaybe<AddressAdministrativeAreLevel2ShortNameFilters>;
  administrativeAreaLevel1?: InputMaybe<AddressAdministrativeAreaLevel1Filters>;
  administrativeAreaLevel1ShortName?: InputMaybe<AddressAdministrativeAreaLevel1ShortNameFilters>;
  administrativeAreaLevel2?: InputMaybe<AddressAdministrativeAreaLevel2Filters>;
  country?: InputMaybe<AddressCountryFilters>;
  createdAtUtc?: InputMaybe<AddressCreatedAtUtcFilters>;
  id?: InputMaybe<AddressIdFilters>;
  locality?: InputMaybe<AddressLocalityFilters>;
  name?: InputMaybe<AddressNameFilters>;
  placeId?: InputMaybe<AddressPlaceIdFilters>;
  postCode?: InputMaybe<AddressPostCodeFilters>;
  updatedAtUtc?: InputMaybe<AddressUpdatedAtUtcFilters>;
};

export type AddressFiltersOr = {
  administrativeAreLevel2ShortName?: InputMaybe<AddressAdministrativeAreLevel2ShortNameFilters>;
  administrativeAreaLevel1?: InputMaybe<AddressAdministrativeAreaLevel1Filters>;
  administrativeAreaLevel1ShortName?: InputMaybe<AddressAdministrativeAreaLevel1ShortNameFilters>;
  administrativeAreaLevel2?: InputMaybe<AddressAdministrativeAreaLevel2Filters>;
  country?: InputMaybe<AddressCountryFilters>;
  createdAtUtc?: InputMaybe<AddressCreatedAtUtcFilters>;
  id?: InputMaybe<AddressIdFilters>;
  locality?: InputMaybe<AddressLocalityFilters>;
  name?: InputMaybe<AddressNameFilters>;
  placeId?: InputMaybe<AddressPlaceIdFilters>;
  postCode?: InputMaybe<AddressPostCodeFilters>;
  updatedAtUtc?: InputMaybe<AddressUpdatedAtUtcFilters>;
};

export type AddressIdFilters = {
  OR?: InputMaybe<Array<AddressIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type AddressIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type AddressInsertInput = {
  administrativeAreLevel2ShortName?: InputMaybe<Scalars['String']['input']>;
  administrativeAreaLevel1?: InputMaybe<Scalars['String']['input']>;
  administrativeAreaLevel1ShortName?: InputMaybe<Scalars['String']['input']>;
  administrativeAreaLevel2?: InputMaybe<Scalars['String']['input']>;
  coordinates: CoordinatesInput;
  country?: InputMaybe<Scalars['String']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
  postCode: Scalars['String']['input'];
};

export type AddressLocalityFilters = {
  OR?: InputMaybe<Array<AddressLocalityfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type AddressLocalityfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type AddressNameFilters = {
  OR?: InputMaybe<Array<AddressNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type AddressNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type AddressPlaceIdFilters = {
  OR?: InputMaybe<Array<AddressPlaceIdfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type AddressPlaceIdfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type AddressPostCodeFilters = {
  OR?: InputMaybe<Array<AddressPostCodefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type AddressPostCodefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type AddressUpdatedAtUtcFilters = {
  OR?: InputMaybe<Array<AddressUpdatedAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type AddressUpdatedAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BespokeCheckData = {
  __typename?: 'BespokeCheckData';
  pricePerMonth: Scalars['Float']['output'];
  successFee: Scalars['Float']['output'];
};

export type Bid = {
  __typename?: 'Bid';
  areWholesalersCompatible?: Maybe<Scalars['Boolean']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  averageWholesalePrice?: Maybe<Scalars['Float']['output']>;
  bidRatingFeedbackValues?: Maybe<Array<BidRatingFeedbackValue>>;
  brand?: Maybe<Brand>;
  brandId: Scalars['Int']['output'];
  commonBidId?: Maybe<Scalars['Int']['output']>;
  createdAtUtc?: Maybe<Scalars['Date']['output']>;
  discountAmountPerUnit?: Maybe<Scalars['Float']['output']>;
  discountNotes?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<File>>;
  freeStockNotes?: Maybe<Scalars['String']['output']>;
  freeStockUnitsAmount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  isAnyWholesalerCompatible: Scalars['Boolean']['output'];
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  isDiscountProvided?: Maybe<Scalars['Boolean']['output']>;
  isDiscountReceived?: Maybe<Scalars['Boolean']['output']>;
  isFreeStockProvided?: Maybe<Scalars['Boolean']['output']>;
  isFreeStockReceived?: Maybe<Scalars['Boolean']['output']>;
  isListingFeeProvided?: Maybe<Scalars['Boolean']['output']>;
  isListingFeeReceived?: Maybe<Scalars['Boolean']['output']>;
  isPosBudgetProvided?: Maybe<Scalars['Boolean']['output']>;
  isPosBudgetReceived?: Maybe<Scalars['Boolean']['output']>;
  isRatingOutdated?: Maybe<Scalars['Boolean']['output']>;
  isRetroDiscountProvided?: Maybe<Scalars['Boolean']['output']>;
  isRetroDiscountReceived?: Maybe<Scalars['Boolean']['output']>;
  listingFeeNotes?: Maybe<Scalars['String']['output']>;
  listingFeeTotalAmount?: Maybe<Scalars['Float']['output']>;
  messagesCount?: Maybe<Scalars['Int']['output']>;
  netPrice?: Maybe<Scalars['Float']['output']>;
  netPricePerEquivalentUnit?: Maybe<Scalars['Float']['output']>;
  netPricePerLitre?: Maybe<Scalars['Float']['output']>;
  otherSupport?: Maybe<Scalars['String']['output']>;
  packagingType?: Maybe<Scalars['String']['output']>;
  posBudgetNotes?: Maybe<Scalars['String']['output']>;
  posBudgetTotalAmount?: Maybe<Scalars['Float']['output']>;
  productCategory?: Maybe<ProductCategory>;
  productCategoryId?: Maybe<Scalars['Int']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  productUrl?: Maybe<Scalars['String']['output']>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  region: Region;
  retroDiscountAmountPerUnit?: Maybe<Scalars['Float']['output']>;
  retroDiscountNotes?: Maybe<Scalars['String']['output']>;
  status: BidStatus;
  subscriptionTier: SubscriptionTier;
  successFee?: Maybe<Scalars['Float']['output']>;
  support?: Maybe<ComputedSupport>;
  supportsDiscount?: Maybe<Scalars['Boolean']['output']>;
  supportsFreeStock?: Maybe<Scalars['Boolean']['output']>;
  supportsListingFee?: Maybe<Scalars['Boolean']['output']>;
  supportsPosBudget?: Maybe<Scalars['Boolean']['output']>;
  supportsRetroDiscount?: Maybe<Scalars['Boolean']['output']>;
  tender: Tender;
  tenderId: Scalars['Int']['output'];
  /** @deprecated Use support.total instead */
  totalSupportValue?: Maybe<Scalars['Float']['output']>;
  unitType?: Maybe<Scalars['String']['output']>;
  unitsPerCase?: Maybe<Scalars['Int']['output']>;
  updatedAtUtc?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
  volumePerUnit?: Maybe<Scalars['Float']['output']>;
  volumeUnits?: Maybe<Scalars['Float']['output']>;
  wholesalers?: Maybe<Array<Wholesaler>>;
};

export type BidRatingFeedbackValue = {
  __typename?: 'BidRatingFeedbackValue';
  ratingFeedbackValueId: Scalars['Int']['output'];
};

export type BidRatingFeedbackValueBidIdFilters = {
  OR?: InputMaybe<Array<BidRatingFeedbackValueBidIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BidRatingFeedbackValueBidIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BidRatingFeedbackValueFilters = {
  OR?: InputMaybe<Array<BidRatingFeedbackValueFiltersOr>>;
  bidId?: InputMaybe<BidRatingFeedbackValueBidIdFilters>;
  id?: InputMaybe<BidRatingFeedbackValueIdFilters>;
  ratingFeedbackValueId?: InputMaybe<BidRatingFeedbackValueRatingFeedbackValueIdFilters>;
};

export type BidRatingFeedbackValueFiltersOr = {
  bidId?: InputMaybe<BidRatingFeedbackValueBidIdFilters>;
  id?: InputMaybe<BidRatingFeedbackValueIdFilters>;
  ratingFeedbackValueId?: InputMaybe<BidRatingFeedbackValueRatingFeedbackValueIdFilters>;
};

export type BidRatingFeedbackValueIdFilters = {
  OR?: InputMaybe<Array<BidRatingFeedbackValueIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BidRatingFeedbackValueIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BidRatingFeedbackValueOrderBy = {
  bidId?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  ratingFeedbackValueId?: InputMaybe<InnerOrder>;
};

export type BidRatingFeedbackValueRatingFeedbackValueIdFilters = {
  OR?: InputMaybe<Array<BidRatingFeedbackValueRatingFeedbackValueIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BidRatingFeedbackValueRatingFeedbackValueIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BidRatingFeedbackValueSelectItem = {
  __typename?: 'BidRatingFeedbackValueSelectItem';
  bidId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  ratingFeedbackValueId: Scalars['Int']['output'];
};

export enum BidStatus {
  Closed = 'CLOSED',
  Deleted = 'DELETED',
  Lost = 'LOST',
  New = 'NEW',
  Won = 'WON'
}

export enum BidSupportType {
  Discount = 'DISCOUNT',
  FreeStock = 'FREE_STOCK',
  ListingFee = 'LISTING_FEE',
  PosBudget = 'POS_BUDGET',
  RetroDiscount = 'RETRO_DISCOUNT'
}

export type Bids = {
  __typename?: 'Bids';
  data: Array<Bid>;
  pageInfo: OffsetPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BidsFilterOptionsInput = {
  brandId?: InputMaybe<Scalars['Int']['input']>;
  tenderId?: InputMaybe<Scalars['Int']['input']>;
  venueId?: InputMaybe<Scalars['Int']['input']>;
};

export type BidsInput = {
  filter?: InputMaybe<BidsViewFiltersInput>;
  pagination: OffsetPaginationInput;
  sort?: InputMaybe<BidsSortInput>;
};

export enum BidsOrderByEnum {
  BidIds = 'BID_IDS',
  EstimatedVolume = 'ESTIMATED_VOLUME',
  NetPrice = 'NET_PRICE',
  Price = 'PRICE',
  Rating = 'RATING',
  RecentlyAdded = 'RECENTLY_ADDED',
  Status = 'STATUS',
  SupportProvided = 'SUPPORT_PROVIDED',
  SupportReceived = 'SUPPORT_RECEIVED',
  TimeLeft = 'TIME_LEFT',
  TotalSupport = 'TOTAL_SUPPORT',
  WholesalerCompatibility = 'WHOLESALER_COMPATIBILITY'
}

export type BidsSortInput = {
  bidIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  isSupportProvidedFirst?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<BidsOrderByEnum>;
  orderDirection?: InputMaybe<SortDirectionEnum>;
  supportType?: InputMaybe<BidSupportType>;
};

export type BidsViewFiltersInput = {
  bidIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  bidStatus?: InputMaybe<BidStatus>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  excludeBrandId?: InputMaybe<Scalars['Int']['input']>;
  excludeWinningBids?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<PriceRangeOption>;
  productName?: InputMaybe<Array<Scalars['String']['input']>>;
  tenderIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  venueIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  wholesalerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type Brand = Node & {
  __typename?: 'Brand';
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  awrsCompanyName?: Maybe<Scalars['String']['output']>;
  awrsDeregistrationDate?: Maybe<Scalars['String']['output']>;
  awrsNumber?: Maybe<Scalars['String']['output']>;
  awrsPlaceBusiness?: Maybe<Scalars['String']['output']>;
  awrsRegistrationDate?: Maybe<Scalars['String']['output']>;
  awrsStatus?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<Address>;
  billingName?: Maybe<Scalars['String']['output']>;
  canSeeOtherBids: Scalars['Boolean']['output'];
  complianceCheckDate?: Maybe<Scalars['String']['output']>;
  complianceConfirmation?: Maybe<Scalars['String']['output']>;
  complianceNextDate?: Maybe<Scalars['String']['output']>;
  complianceRiskLevel?: Maybe<Scalars['String']['output']>;
  failedPaymentIntentCounter: Scalars['Int']['output'];
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  isAnonymousBidAllowed?: Maybe<Scalars['Boolean']['output']>;
  isEnterpriseSubscriptionRequestSent: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  productCategories: Array<ProductCategory>;
  region: Region;
  registeredCompany?: Maybe<RegisteredCompany>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripePaymentLink?: Maybe<Scalars['String']['output']>;
  stripeProductPriceId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionTier: SubscriptionTier;
  successFee: Scalars['Float']['output'];
  tradingAddress?: Maybe<Address>;
  tradingName?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
  users: Array<CompanyUser>;
  vatCompanyName?: Maybe<Scalars['String']['output']>;
  vatConsultationNumber?: Maybe<Scalars['String']['output']>;
  vatCountryCode?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  vatProcessingDate?: Maybe<Scalars['String']['output']>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};

export type BrandAddressIdFilters = {
  OR?: InputMaybe<Array<BrandAddressIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandAddressIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandAvatarBucketKeyFilters = {
  OR?: InputMaybe<Array<BrandAvatarBucketKeyfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandAvatarBucketKeyPreSignedUrlExpirationDateAtUtcFilters = {
  OR?: InputMaybe<Array<BrandAvatarBucketKeyPreSignedUrlExpirationDateAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandAvatarBucketKeyPreSignedUrlExpirationDateAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandAvatarBucketKeyPreSignedUrlFilters = {
  OR?: InputMaybe<Array<BrandAvatarBucketKeyPreSignedUrlfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandAvatarBucketKeyPreSignedUrlfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandAvatarBucketKeyfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandAwrsCompanyNameFilters = {
  OR?: InputMaybe<Array<BrandAwrsCompanyNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandAwrsCompanyNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandAwrsDeregistrationDateFilters = {
  OR?: InputMaybe<Array<BrandAwrsDeregistrationDatefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandAwrsDeregistrationDatefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandAwrsNumberFilters = {
  OR?: InputMaybe<Array<BrandAwrsNumberfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandAwrsNumberfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandAwrsPlaceBusinessFilters = {
  OR?: InputMaybe<Array<BrandAwrsPlaceBusinessfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandAwrsPlaceBusinessfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandAwrsRegistrationDateFilters = {
  OR?: InputMaybe<Array<BrandAwrsRegistrationDatefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandAwrsRegistrationDatefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandAwrsStatusFilters = {
  OR?: InputMaybe<Array<BrandAwrsStatusfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandAwrsStatusfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandBillingAddressIdFilters = {
  OR?: InputMaybe<Array<BrandBillingAddressIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandBillingAddressIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandBillingNameFilters = {
  OR?: InputMaybe<Array<BrandBillingNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandBillingNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandCanSeeOtherBidsFilters = {
  OR?: InputMaybe<Array<BrandCanSeeOtherBidsfiltersOr>>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandCanSeeOtherBidsfiltersOr = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandComplianceCheckDateFilters = {
  OR?: InputMaybe<Array<BrandComplianceCheckDatefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandComplianceCheckDatefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandComplianceConfirmationFilters = {
  OR?: InputMaybe<Array<BrandComplianceConfirmationfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandComplianceConfirmationfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandComplianceNextDateFilters = {
  OR?: InputMaybe<Array<BrandComplianceNextDatefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandComplianceNextDatefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandComplianceRiskLevelFilters = {
  OR?: InputMaybe<Array<BrandComplianceRiskLevelfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandComplianceRiskLevelfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandCreatedAtUtcFilters = {
  OR?: InputMaybe<Array<BrandCreatedAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandCreatedAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandEdge = Edge & {
  __typename?: 'BrandEdge';
  cursor: Scalars['String']['output'];
  node: Brand;
};

export type BrandFailedPaymentIntentCounterFilters = {
  OR?: InputMaybe<Array<BrandFailedPaymentIntentCounterfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandFailedPaymentIntentCounterfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandFilters = {
  OR?: InputMaybe<Array<BrandFiltersOr>>;
  addressId?: InputMaybe<BrandAddressIdFilters>;
  avatarBucketKey?: InputMaybe<BrandAvatarBucketKeyFilters>;
  avatarBucketKeyPreSignedUrl?: InputMaybe<BrandAvatarBucketKeyPreSignedUrlFilters>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: InputMaybe<BrandAvatarBucketKeyPreSignedUrlExpirationDateAtUtcFilters>;
  awrsCompanyName?: InputMaybe<BrandAwrsCompanyNameFilters>;
  awrsDeregistrationDate?: InputMaybe<BrandAwrsDeregistrationDateFilters>;
  awrsNumber?: InputMaybe<BrandAwrsNumberFilters>;
  awrsPlaceBusiness?: InputMaybe<BrandAwrsPlaceBusinessFilters>;
  awrsRegistrationDate?: InputMaybe<BrandAwrsRegistrationDateFilters>;
  awrsStatus?: InputMaybe<BrandAwrsStatusFilters>;
  billingAddressId?: InputMaybe<BrandBillingAddressIdFilters>;
  billingName?: InputMaybe<BrandBillingNameFilters>;
  canSeeOtherBids?: InputMaybe<BrandCanSeeOtherBidsFilters>;
  complianceCheckDate?: InputMaybe<BrandComplianceCheckDateFilters>;
  complianceConfirmation?: InputMaybe<BrandComplianceConfirmationFilters>;
  complianceNextDate?: InputMaybe<BrandComplianceNextDateFilters>;
  complianceRiskLevel?: InputMaybe<BrandComplianceRiskLevelFilters>;
  createdAtUtc?: InputMaybe<BrandCreatedAtUtcFilters>;
  failedPaymentIntentCounter?: InputMaybe<BrandFailedPaymentIntentCounterFilters>;
  groupName?: InputMaybe<BrandGroupNameFilters>;
  id?: InputMaybe<BrandIdFilters>;
  instagramUrl?: InputMaybe<BrandInstagramUrlFilters>;
  isAnonymousBidAllowed?: InputMaybe<BrandIsAnonymousBidAllowedFilters>;
  isEnterpriseSubscriptionRequestSent?: InputMaybe<BrandIsEnterpriseSubscriptionRequestSentFilters>;
  name?: InputMaybe<BrandNameFilters>;
  phoneNumber?: InputMaybe<BrandPhoneNumberFilters>;
  region?: InputMaybe<BrandRegionFilters>;
  registeredCompanyId?: InputMaybe<BrandRegisteredCompanyIdFilters>;
  stripeCustomerId?: InputMaybe<BrandStripeCustomerIdFilters>;
  stripePaymentLink?: InputMaybe<BrandStripePaymentLinkFilters>;
  stripePaymentLinkHash?: InputMaybe<BrandStripePaymentLinkHashFilters>;
  stripePaymentType?: InputMaybe<BrandStripePaymentTypeFilters>;
  stripeProductPriceId?: InputMaybe<BrandStripeProductPriceIdFilters>;
  stripeSubscriptionId?: InputMaybe<BrandStripeSubscriptionIdFilters>;
  subscriptionTier?: InputMaybe<BrandSubscriptionTierFilters>;
  successFee?: InputMaybe<BrandSuccessFeeFilters>;
  tradingAddressId?: InputMaybe<BrandTradingAddressIdFilters>;
  tradingName?: InputMaybe<BrandTradingNameFilters>;
  updatedAtUtc?: InputMaybe<BrandUpdatedAtUtcFilters>;
  vatCompanyName?: InputMaybe<BrandVatCompanyNameFilters>;
  vatConsultationNumber?: InputMaybe<BrandVatConsultationNumberFilters>;
  vatCountryCode?: InputMaybe<BrandVatCountryCodeFilters>;
  vatNumber?: InputMaybe<BrandVatNumberFilters>;
  vatProcessingDate?: InputMaybe<BrandVatProcessingDateFilters>;
  webPageUrl?: InputMaybe<BrandWebPageUrlFilters>;
};

export type BrandFiltersOr = {
  addressId?: InputMaybe<BrandAddressIdFilters>;
  avatarBucketKey?: InputMaybe<BrandAvatarBucketKeyFilters>;
  avatarBucketKeyPreSignedUrl?: InputMaybe<BrandAvatarBucketKeyPreSignedUrlFilters>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: InputMaybe<BrandAvatarBucketKeyPreSignedUrlExpirationDateAtUtcFilters>;
  awrsCompanyName?: InputMaybe<BrandAwrsCompanyNameFilters>;
  awrsDeregistrationDate?: InputMaybe<BrandAwrsDeregistrationDateFilters>;
  awrsNumber?: InputMaybe<BrandAwrsNumberFilters>;
  awrsPlaceBusiness?: InputMaybe<BrandAwrsPlaceBusinessFilters>;
  awrsRegistrationDate?: InputMaybe<BrandAwrsRegistrationDateFilters>;
  awrsStatus?: InputMaybe<BrandAwrsStatusFilters>;
  billingAddressId?: InputMaybe<BrandBillingAddressIdFilters>;
  billingName?: InputMaybe<BrandBillingNameFilters>;
  canSeeOtherBids?: InputMaybe<BrandCanSeeOtherBidsFilters>;
  complianceCheckDate?: InputMaybe<BrandComplianceCheckDateFilters>;
  complianceConfirmation?: InputMaybe<BrandComplianceConfirmationFilters>;
  complianceNextDate?: InputMaybe<BrandComplianceNextDateFilters>;
  complianceRiskLevel?: InputMaybe<BrandComplianceRiskLevelFilters>;
  createdAtUtc?: InputMaybe<BrandCreatedAtUtcFilters>;
  failedPaymentIntentCounter?: InputMaybe<BrandFailedPaymentIntentCounterFilters>;
  groupName?: InputMaybe<BrandGroupNameFilters>;
  id?: InputMaybe<BrandIdFilters>;
  instagramUrl?: InputMaybe<BrandInstagramUrlFilters>;
  isAnonymousBidAllowed?: InputMaybe<BrandIsAnonymousBidAllowedFilters>;
  isEnterpriseSubscriptionRequestSent?: InputMaybe<BrandIsEnterpriseSubscriptionRequestSentFilters>;
  name?: InputMaybe<BrandNameFilters>;
  phoneNumber?: InputMaybe<BrandPhoneNumberFilters>;
  region?: InputMaybe<BrandRegionFilters>;
  registeredCompanyId?: InputMaybe<BrandRegisteredCompanyIdFilters>;
  stripeCustomerId?: InputMaybe<BrandStripeCustomerIdFilters>;
  stripePaymentLink?: InputMaybe<BrandStripePaymentLinkFilters>;
  stripePaymentLinkHash?: InputMaybe<BrandStripePaymentLinkHashFilters>;
  stripePaymentType?: InputMaybe<BrandStripePaymentTypeFilters>;
  stripeProductPriceId?: InputMaybe<BrandStripeProductPriceIdFilters>;
  stripeSubscriptionId?: InputMaybe<BrandStripeSubscriptionIdFilters>;
  subscriptionTier?: InputMaybe<BrandSubscriptionTierFilters>;
  successFee?: InputMaybe<BrandSuccessFeeFilters>;
  tradingAddressId?: InputMaybe<BrandTradingAddressIdFilters>;
  tradingName?: InputMaybe<BrandTradingNameFilters>;
  updatedAtUtc?: InputMaybe<BrandUpdatedAtUtcFilters>;
  vatCompanyName?: InputMaybe<BrandVatCompanyNameFilters>;
  vatConsultationNumber?: InputMaybe<BrandVatConsultationNumberFilters>;
  vatCountryCode?: InputMaybe<BrandVatCountryCodeFilters>;
  vatNumber?: InputMaybe<BrandVatNumberFilters>;
  vatProcessingDate?: InputMaybe<BrandVatProcessingDateFilters>;
  webPageUrl?: InputMaybe<BrandWebPageUrlFilters>;
};

export type BrandGroupNameFilters = {
  OR?: InputMaybe<Array<BrandGroupNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandGroupNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandIdFilters = {
  OR?: InputMaybe<Array<BrandIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandInsertInput = {
  address?: InputMaybe<AddressInsertInput>;
  avatarBucketKey?: InputMaybe<Scalars['String']['input']>;
  awrsCompanyName?: InputMaybe<Scalars['String']['input']>;
  awrsDeregistrationDate?: InputMaybe<Scalars['String']['input']>;
  awrsNumber?: InputMaybe<Scalars['String']['input']>;
  awrsPlaceBusiness?: InputMaybe<Scalars['String']['input']>;
  awrsRegistrationDate?: InputMaybe<Scalars['String']['input']>;
  awrsStatus?: InputMaybe<Scalars['String']['input']>;
  billingAddressId?: InputMaybe<Scalars['Int']['input']>;
  billingName?: InputMaybe<Scalars['String']['input']>;
  complianceCheckDate?: InputMaybe<Scalars['String']['input']>;
  complianceConfirmation?: InputMaybe<Scalars['String']['input']>;
  complianceNextDate?: InputMaybe<Scalars['String']['input']>;
  complianceRiskLevel?: InputMaybe<Scalars['String']['input']>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  instagramUrl?: InputMaybe<Scalars['String']['input']>;
  isAnonymousBidAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  registeredCompany: RegisteredCompanyInsertInput;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentLink?: InputMaybe<Scalars['String']['input']>;
  stripePaymentLinkHash?: InputMaybe<Scalars['String']['input']>;
  stripePaymentType?: InputMaybe<Scalars['String']['input']>;
  stripeProductPriceId?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  subscriptionTier?: InputMaybe<Scalars['String']['input']>;
  successFee?: InputMaybe<Scalars['Float']['input']>;
  tradingAddress?: InputMaybe<AddressInsertInput>;
  tradingName?: InputMaybe<Scalars['String']['input']>;
  vatCompanyName?: InputMaybe<Scalars['String']['input']>;
  vatConsultationNumber?: InputMaybe<Scalars['String']['input']>;
  vatCountryCode?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  vatProcessingDate?: InputMaybe<Scalars['String']['input']>;
  webPageUrl?: InputMaybe<Scalars['String']['input']>;
};

export type BrandInstagramUrlFilters = {
  OR?: InputMaybe<Array<BrandInstagramUrlfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandInstagramUrlfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandIntegrationForRetool = {
  __typename?: 'BrandIntegrationForRetool';
  brandId: Scalars['Int']['output'];
  brandName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  externalCompanyId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  integrationType: IntegrationType;
  /** JSON */
  metadata?: Maybe<Scalars['String']['output']>;
};

export type BrandIntegrationsBrandIdFilters = {
  OR?: InputMaybe<Array<BrandIntegrationsBrandIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandIntegrationsBrandIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandIntegrationsBrandRelation = {
  __typename?: 'BrandIntegrationsBrandRelation';
  address?: Maybe<BrandIntegrationsBrandRelationAddressRelation>;
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  awrsCompanyName?: Maybe<Scalars['String']['output']>;
  awrsDeregistrationDate?: Maybe<Scalars['String']['output']>;
  awrsNumber?: Maybe<Scalars['String']['output']>;
  awrsPlaceBusiness?: Maybe<Scalars['String']['output']>;
  awrsRegistrationDate?: Maybe<Scalars['String']['output']>;
  awrsStatus?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<BrandIntegrationsBrandRelationBillingAddressRelation>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  brandIntegrations: Array<BrandIntegrationsBrandRelationBrandIntegrationsRelation>;
  brandUsers: Array<BrandIntegrationsBrandRelationBrandUsersRelation>;
  canSeeOtherBids?: Maybe<Scalars['Boolean']['output']>;
  complianceCheckDate?: Maybe<Scalars['String']['output']>;
  complianceConfirmation?: Maybe<Scalars['String']['output']>;
  complianceNextDate?: Maybe<Scalars['String']['output']>;
  complianceRiskLevel?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  failedPaymentIntentCounter: Scalars['Int']['output'];
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  isAnonymousBidAllowed?: Maybe<Scalars['Boolean']['output']>;
  isEnterpriseSubscriptionRequestSent?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompany?: Maybe<BrandIntegrationsBrandRelationRegisteredCompanyRelation>;
  registeredCompanyId: Scalars['Int']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripePaymentLink?: Maybe<Scalars['String']['output']>;
  stripePaymentLinkHash?: Maybe<Scalars['String']['output']>;
  stripePaymentType?: Maybe<Scalars['String']['output']>;
  stripeProductPriceId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  tradingAddress?: Maybe<BrandIntegrationsBrandRelationTradingAddressRelation>;
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  vatCompanyName?: Maybe<Scalars['String']['output']>;
  vatConsultationNumber?: Maybe<Scalars['String']['output']>;
  vatCountryCode?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  vatProcessingDate?: Maybe<Scalars['String']['output']>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};


export type BrandIntegrationsBrandRelationAddressArgs = {
  where?: InputMaybe<AddressFilters>;
};


export type BrandIntegrationsBrandRelationBillingAddressArgs = {
  where?: InputMaybe<AddressFilters>;
};


export type BrandIntegrationsBrandRelationBrandIntegrationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BrandIntegrationsOrderBy>;
  where?: InputMaybe<BrandIntegrationsFilters>;
};


export type BrandIntegrationsBrandRelationBrandUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BrandUserOrderBy>;
  where?: InputMaybe<BrandUserFilters>;
};


export type BrandIntegrationsBrandRelationRegisteredCompanyArgs = {
  where?: InputMaybe<RegisteredCompanyFilters>;
};


export type BrandIntegrationsBrandRelationTradingAddressArgs = {
  where?: InputMaybe<AddressFilters>;
};

export type BrandIntegrationsBrandRelationAddressRelation = {
  __typename?: 'BrandIntegrationsBrandRelationAddressRelation';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type BrandIntegrationsBrandRelationBillingAddressRelation = {
  __typename?: 'BrandIntegrationsBrandRelationBillingAddressRelation';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type BrandIntegrationsBrandRelationBrandIntegrationsRelation = {
  __typename?: 'BrandIntegrationsBrandRelationBrandIntegrationsRelation';
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  externalCompanyId: Scalars['String']['output'];
  externalUserId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  integrationType: BrandIntegrationsIntegrationTypeEnum;
  /** JSON */
  metadata?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type BrandIntegrationsBrandRelationBrandUsersRelation = {
  __typename?: 'BrandIntegrationsBrandRelationBrandUsersRelation';
  brand?: Maybe<BrandIntegrationsBrandRelationBrandUsersRelationBrandRelation>;
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  role: BrandUserRoleEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<BrandIntegrationsBrandRelationBrandUsersRelationUserRelation>;
  userId: Scalars['Int']['output'];
};


export type BrandIntegrationsBrandRelationBrandUsersRelationBrandArgs = {
  where?: InputMaybe<BrandFilters>;
};


export type BrandIntegrationsBrandRelationBrandUsersRelationUserArgs = {
  where?: InputMaybe<UserFilters>;
};

export type BrandIntegrationsBrandRelationBrandUsersRelationBrandRelation = {
  __typename?: 'BrandIntegrationsBrandRelationBrandUsersRelationBrandRelation';
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  awrsCompanyName?: Maybe<Scalars['String']['output']>;
  awrsDeregistrationDate?: Maybe<Scalars['String']['output']>;
  awrsNumber?: Maybe<Scalars['String']['output']>;
  awrsPlaceBusiness?: Maybe<Scalars['String']['output']>;
  awrsRegistrationDate?: Maybe<Scalars['String']['output']>;
  awrsStatus?: Maybe<Scalars['String']['output']>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  canSeeOtherBids?: Maybe<Scalars['Boolean']['output']>;
  complianceCheckDate?: Maybe<Scalars['String']['output']>;
  complianceConfirmation?: Maybe<Scalars['String']['output']>;
  complianceNextDate?: Maybe<Scalars['String']['output']>;
  complianceRiskLevel?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  failedPaymentIntentCounter: Scalars['Int']['output'];
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  isAnonymousBidAllowed?: Maybe<Scalars['Boolean']['output']>;
  isEnterpriseSubscriptionRequestSent?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompanyId: Scalars['Int']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripePaymentLink?: Maybe<Scalars['String']['output']>;
  stripePaymentLinkHash?: Maybe<Scalars['String']['output']>;
  stripePaymentType?: Maybe<Scalars['String']['output']>;
  stripeProductPriceId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  vatCompanyName?: Maybe<Scalars['String']['output']>;
  vatConsultationNumber?: Maybe<Scalars['String']['output']>;
  vatCountryCode?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  vatProcessingDate?: Maybe<Scalars['String']['output']>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};

export type BrandIntegrationsBrandRelationBrandUsersRelationUserRelation = {
  __typename?: 'BrandIntegrationsBrandRelationBrandUsersRelationUserRelation';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type BrandIntegrationsBrandRelationRegisteredCompanyRelation = {
  __typename?: 'BrandIntegrationsBrandRelationRegisteredCompanyRelation';
  addressId?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  dateOfCreation?: Maybe<Scalars['String']['output']>;
  firstAddressLine?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  secondAddressLine?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type BrandIntegrationsBrandRelationTradingAddressRelation = {
  __typename?: 'BrandIntegrationsBrandRelationTradingAddressRelation';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type BrandIntegrationsCreatedAtUtcFilters = {
  OR?: InputMaybe<Array<BrandIntegrationsCreatedAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandIntegrationsCreatedAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandIntegrationsExternalCompanyIdFilters = {
  OR?: InputMaybe<Array<BrandIntegrationsExternalCompanyIdfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandIntegrationsExternalCompanyIdfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandIntegrationsExternalUserIdFilters = {
  OR?: InputMaybe<Array<BrandIntegrationsExternalUserIdfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandIntegrationsExternalUserIdfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandIntegrationsFilters = {
  OR?: InputMaybe<Array<BrandIntegrationsFiltersOr>>;
  brandId?: InputMaybe<BrandIntegrationsBrandIdFilters>;
  createdAtUtc?: InputMaybe<BrandIntegrationsCreatedAtUtcFilters>;
  externalCompanyId?: InputMaybe<BrandIntegrationsExternalCompanyIdFilters>;
  externalUserId?: InputMaybe<BrandIntegrationsExternalUserIdFilters>;
  id?: InputMaybe<BrandIntegrationsIdFilters>;
  integrationType?: InputMaybe<BrandIntegrationsIntegrationTypeFilters>;
  metadata?: InputMaybe<BrandIntegrationsMetadataFilters>;
  updatedAtUtc?: InputMaybe<BrandIntegrationsUpdatedAtUtcFilters>;
  userId?: InputMaybe<BrandIntegrationsUserIdFilters>;
};

export type BrandIntegrationsFiltersOr = {
  brandId?: InputMaybe<BrandIntegrationsBrandIdFilters>;
  createdAtUtc?: InputMaybe<BrandIntegrationsCreatedAtUtcFilters>;
  externalCompanyId?: InputMaybe<BrandIntegrationsExternalCompanyIdFilters>;
  externalUserId?: InputMaybe<BrandIntegrationsExternalUserIdFilters>;
  id?: InputMaybe<BrandIntegrationsIdFilters>;
  integrationType?: InputMaybe<BrandIntegrationsIntegrationTypeFilters>;
  metadata?: InputMaybe<BrandIntegrationsMetadataFilters>;
  updatedAtUtc?: InputMaybe<BrandIntegrationsUpdatedAtUtcFilters>;
  userId?: InputMaybe<BrandIntegrationsUserIdFilters>;
};

export type BrandIntegrationsForRetoolInput = {
  brandId?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  externalCompanyId?: InputMaybe<Scalars['NonEmptyString']['input']>;
  integrationType?: InputMaybe<IntegrationType>;
};

export type BrandIntegrationsIdFilters = {
  OR?: InputMaybe<Array<BrandIntegrationsIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandIntegrationsIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export enum BrandIntegrationsIntegrationTypeEnum {
  /** Value: PARAMOUNT_LIQUOR */
  ParamountLiquor = 'PARAMOUNT_LIQUOR',
  /** Value: VENUS_AND_BOOKER */
  VenusAndBooker = 'VENUS_AND_BOOKER'
}

export type BrandIntegrationsIntegrationTypeFilters = {
  OR?: InputMaybe<Array<BrandIntegrationsIntegrationTypefiltersOr>>;
  eq?: InputMaybe<BrandIntegrationsIntegrationTypeEnum>;
  gt?: InputMaybe<BrandIntegrationsIntegrationTypeEnum>;
  gte?: InputMaybe<BrandIntegrationsIntegrationTypeEnum>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<BrandIntegrationsIntegrationTypeEnum>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<BrandIntegrationsIntegrationTypeEnum>;
  lte?: InputMaybe<BrandIntegrationsIntegrationTypeEnum>;
  ne?: InputMaybe<BrandIntegrationsIntegrationTypeEnum>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<BrandIntegrationsIntegrationTypeEnum>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandIntegrationsIntegrationTypefiltersOr = {
  eq?: InputMaybe<BrandIntegrationsIntegrationTypeEnum>;
  gt?: InputMaybe<BrandIntegrationsIntegrationTypeEnum>;
  gte?: InputMaybe<BrandIntegrationsIntegrationTypeEnum>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<BrandIntegrationsIntegrationTypeEnum>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<BrandIntegrationsIntegrationTypeEnum>;
  lte?: InputMaybe<BrandIntegrationsIntegrationTypeEnum>;
  ne?: InputMaybe<BrandIntegrationsIntegrationTypeEnum>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<BrandIntegrationsIntegrationTypeEnum>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandIntegrationsMetadataFilters = {
  OR?: InputMaybe<Array<BrandIntegrationsMetadatafiltersOr>>;
  /** JSON */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandIntegrationsMetadatafiltersOr = {
  /** JSON */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandIntegrationsOrderBy = {
  brandId?: InputMaybe<InnerOrder>;
  createdAtUtc?: InputMaybe<InnerOrder>;
  externalCompanyId?: InputMaybe<InnerOrder>;
  externalUserId?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  integrationType?: InputMaybe<InnerOrder>;
  metadata?: InputMaybe<InnerOrder>;
  updatedAtUtc?: InputMaybe<InnerOrder>;
  userId?: InputMaybe<InnerOrder>;
};

export type BrandIntegrationsSelectItem = {
  __typename?: 'BrandIntegrationsSelectItem';
  brand?: Maybe<BrandIntegrationsBrandRelation>;
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  externalCompanyId: Scalars['String']['output'];
  externalUserId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  integrationType: BrandIntegrationsIntegrationTypeEnum;
  /** JSON */
  metadata?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<BrandIntegrationsUserRelation>;
  userId: Scalars['Int']['output'];
};


export type BrandIntegrationsSelectItemBrandArgs = {
  where?: InputMaybe<BrandFilters>;
};


export type BrandIntegrationsSelectItemUserArgs = {
  where?: InputMaybe<UserFilters>;
};

export type BrandIntegrationsUpdatedAtUtcFilters = {
  OR?: InputMaybe<Array<BrandIntegrationsUpdatedAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandIntegrationsUpdatedAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandIntegrationsUserIdFilters = {
  OR?: InputMaybe<Array<BrandIntegrationsUserIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandIntegrationsUserIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandIntegrationsUserRelation = {
  __typename?: 'BrandIntegrationsUserRelation';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type BrandIsAnonymousBidAllowedFilters = {
  OR?: InputMaybe<Array<BrandIsAnonymousBidAllowedfiltersOr>>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandIsAnonymousBidAllowedfiltersOr = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandIsEnterpriseSubscriptionRequestSentFilters = {
  OR?: InputMaybe<Array<BrandIsEnterpriseSubscriptionRequestSentfiltersOr>>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandIsEnterpriseSubscriptionRequestSentfiltersOr = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandItem = {
  __typename?: 'BrandItem';
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  awrsCompanyName?: Maybe<Scalars['String']['output']>;
  awrsDeregistrationDate?: Maybe<Scalars['String']['output']>;
  awrsNumber?: Maybe<Scalars['String']['output']>;
  awrsPlaceBusiness?: Maybe<Scalars['String']['output']>;
  awrsRegistrationDate?: Maybe<Scalars['String']['output']>;
  awrsStatus?: Maybe<Scalars['String']['output']>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  canSeeOtherBids?: Maybe<Scalars['Boolean']['output']>;
  complianceCheckDate?: Maybe<Scalars['String']['output']>;
  complianceConfirmation?: Maybe<Scalars['String']['output']>;
  complianceNextDate?: Maybe<Scalars['String']['output']>;
  complianceRiskLevel?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  failedPaymentIntentCounter: Scalars['Int']['output'];
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  isAnonymousBidAllowed?: Maybe<Scalars['Boolean']['output']>;
  isEnterpriseSubscriptionRequestSent?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompanyId: Scalars['Int']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripePaymentLink?: Maybe<Scalars['String']['output']>;
  stripePaymentLinkHash?: Maybe<Scalars['String']['output']>;
  stripePaymentType?: Maybe<Scalars['String']['output']>;
  stripeProductPriceId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  vatCompanyName?: Maybe<Scalars['String']['output']>;
  vatConsultationNumber?: Maybe<Scalars['String']['output']>;
  vatCountryCode?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  vatProcessingDate?: Maybe<Scalars['String']['output']>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};

export type BrandNameFilters = {
  OR?: InputMaybe<Array<BrandNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandOptionForRetool = {
  __typename?: 'BrandOptionForRetool';
  brandId: Scalars['Int']['output'];
  brandName?: Maybe<Scalars['String']['output']>;
};

export type BrandPhoneNumberFilters = {
  OR?: InputMaybe<Array<BrandPhoneNumberfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandPhoneNumberfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandRegionFilters = {
  OR?: InputMaybe<Array<BrandRegionfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandRegionfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandRegisteredCompanyIdFilters = {
  OR?: InputMaybe<Array<BrandRegisteredCompanyIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandRegisteredCompanyIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandSelectItem = {
  __typename?: 'BrandSelectItem';
  avatarUrl?: Maybe<Scalars['String']['output']>;
};

export type BrandSettings = {
  __typename?: 'BrandSettings';
  brandId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMatchBidsTenderReportMailNotificationEnabled: Scalars['Boolean']['output'];
  isNewTenderInAppNotificationEnabled: Scalars['Boolean']['output'];
  isNewTenderMailNotificationEnabled: Scalars['Boolean']['output'];
  isRatingProvidedInAppNotificationEnabled: Scalars['Boolean']['output'];
  isRatingProvidedMailNotificationEnabled: Scalars['Boolean']['output'];
  isTenderUpdatedInAppNotificationEnabled: Scalars['Boolean']['output'];
  isTenderUpdatedMailNotificationEnabled: Scalars['Boolean']['output'];
};

export type BrandStripeCustomerIdFilters = {
  OR?: InputMaybe<Array<BrandStripeCustomerIdfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandStripeCustomerIdfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandStripePaymentLinkFilters = {
  OR?: InputMaybe<Array<BrandStripePaymentLinkfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandStripePaymentLinkHashFilters = {
  OR?: InputMaybe<Array<BrandStripePaymentLinkHashfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandStripePaymentLinkHashfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandStripePaymentLinkfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandStripePaymentTypeFilters = {
  OR?: InputMaybe<Array<BrandStripePaymentTypefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandStripePaymentTypefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandStripeProductPriceIdFilters = {
  OR?: InputMaybe<Array<BrandStripeProductPriceIdfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandStripeProductPriceIdfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandStripeSubscriptionIdFilters = {
  OR?: InputMaybe<Array<BrandStripeSubscriptionIdfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandStripeSubscriptionIdfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandSubscriptionTierFilters = {
  OR?: InputMaybe<Array<BrandSubscriptionTierfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandSubscriptionTierfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandSuccessFeeFilters = {
  OR?: InputMaybe<Array<BrandSuccessFeefiltersOr>>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Float']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Float']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandSuccessFeefiltersOr = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Float']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Float']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandTradingAddressIdFilters = {
  OR?: InputMaybe<Array<BrandTradingAddressIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandTradingAddressIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandTradingNameFilters = {
  OR?: InputMaybe<Array<BrandTradingNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandTradingNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandUpdatedAtUtcFilters = {
  OR?: InputMaybe<Array<BrandUpdatedAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandUpdatedAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandUserBrandIdFilters = {
  OR?: InputMaybe<Array<BrandUserBrandIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandUserBrandIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandUserBrandRelation = {
  __typename?: 'BrandUserBrandRelation';
  address?: Maybe<BrandUserBrandRelationAddressRelation>;
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  awrsCompanyName?: Maybe<Scalars['String']['output']>;
  awrsDeregistrationDate?: Maybe<Scalars['String']['output']>;
  awrsNumber?: Maybe<Scalars['String']['output']>;
  awrsPlaceBusiness?: Maybe<Scalars['String']['output']>;
  awrsRegistrationDate?: Maybe<Scalars['String']['output']>;
  awrsStatus?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<BrandUserBrandRelationBillingAddressRelation>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  brandIntegrations: Array<BrandUserBrandRelationBrandIntegrationsRelation>;
  brandUsers: Array<BrandUserBrandRelationBrandUsersRelation>;
  canSeeOtherBids?: Maybe<Scalars['Boolean']['output']>;
  complianceCheckDate?: Maybe<Scalars['String']['output']>;
  complianceConfirmation?: Maybe<Scalars['String']['output']>;
  complianceNextDate?: Maybe<Scalars['String']['output']>;
  complianceRiskLevel?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  failedPaymentIntentCounter: Scalars['Int']['output'];
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  isAnonymousBidAllowed?: Maybe<Scalars['Boolean']['output']>;
  isEnterpriseSubscriptionRequestSent?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompany?: Maybe<BrandUserBrandRelationRegisteredCompanyRelation>;
  registeredCompanyId: Scalars['Int']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripePaymentLink?: Maybe<Scalars['String']['output']>;
  stripePaymentLinkHash?: Maybe<Scalars['String']['output']>;
  stripePaymentType?: Maybe<Scalars['String']['output']>;
  stripeProductPriceId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  tradingAddress?: Maybe<BrandUserBrandRelationTradingAddressRelation>;
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  vatCompanyName?: Maybe<Scalars['String']['output']>;
  vatConsultationNumber?: Maybe<Scalars['String']['output']>;
  vatCountryCode?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  vatProcessingDate?: Maybe<Scalars['String']['output']>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};


export type BrandUserBrandRelationAddressArgs = {
  where?: InputMaybe<AddressFilters>;
};


export type BrandUserBrandRelationBillingAddressArgs = {
  where?: InputMaybe<AddressFilters>;
};


export type BrandUserBrandRelationBrandIntegrationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BrandIntegrationsOrderBy>;
  where?: InputMaybe<BrandIntegrationsFilters>;
};


export type BrandUserBrandRelationBrandUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BrandUserOrderBy>;
  where?: InputMaybe<BrandUserFilters>;
};


export type BrandUserBrandRelationRegisteredCompanyArgs = {
  where?: InputMaybe<RegisteredCompanyFilters>;
};


export type BrandUserBrandRelationTradingAddressArgs = {
  where?: InputMaybe<AddressFilters>;
};

export type BrandUserBrandRelationAddressRelation = {
  __typename?: 'BrandUserBrandRelationAddressRelation';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type BrandUserBrandRelationBillingAddressRelation = {
  __typename?: 'BrandUserBrandRelationBillingAddressRelation';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type BrandUserBrandRelationBrandIntegrationsRelation = {
  __typename?: 'BrandUserBrandRelationBrandIntegrationsRelation';
  brand?: Maybe<BrandUserBrandRelationBrandIntegrationsRelationBrandRelation>;
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  externalCompanyId: Scalars['String']['output'];
  externalUserId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  integrationType: BrandIntegrationsIntegrationTypeEnum;
  /** JSON */
  metadata?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<BrandUserBrandRelationBrandIntegrationsRelationUserRelation>;
  userId: Scalars['Int']['output'];
};


export type BrandUserBrandRelationBrandIntegrationsRelationBrandArgs = {
  where?: InputMaybe<BrandFilters>;
};


export type BrandUserBrandRelationBrandIntegrationsRelationUserArgs = {
  where?: InputMaybe<UserFilters>;
};

export type BrandUserBrandRelationBrandIntegrationsRelationBrandRelation = {
  __typename?: 'BrandUserBrandRelationBrandIntegrationsRelationBrandRelation';
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  awrsCompanyName?: Maybe<Scalars['String']['output']>;
  awrsDeregistrationDate?: Maybe<Scalars['String']['output']>;
  awrsNumber?: Maybe<Scalars['String']['output']>;
  awrsPlaceBusiness?: Maybe<Scalars['String']['output']>;
  awrsRegistrationDate?: Maybe<Scalars['String']['output']>;
  awrsStatus?: Maybe<Scalars['String']['output']>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  canSeeOtherBids?: Maybe<Scalars['Boolean']['output']>;
  complianceCheckDate?: Maybe<Scalars['String']['output']>;
  complianceConfirmation?: Maybe<Scalars['String']['output']>;
  complianceNextDate?: Maybe<Scalars['String']['output']>;
  complianceRiskLevel?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  failedPaymentIntentCounter: Scalars['Int']['output'];
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  isAnonymousBidAllowed?: Maybe<Scalars['Boolean']['output']>;
  isEnterpriseSubscriptionRequestSent?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompanyId: Scalars['Int']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripePaymentLink?: Maybe<Scalars['String']['output']>;
  stripePaymentLinkHash?: Maybe<Scalars['String']['output']>;
  stripePaymentType?: Maybe<Scalars['String']['output']>;
  stripeProductPriceId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  vatCompanyName?: Maybe<Scalars['String']['output']>;
  vatConsultationNumber?: Maybe<Scalars['String']['output']>;
  vatCountryCode?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  vatProcessingDate?: Maybe<Scalars['String']['output']>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};

export type BrandUserBrandRelationBrandIntegrationsRelationUserRelation = {
  __typename?: 'BrandUserBrandRelationBrandIntegrationsRelationUserRelation';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type BrandUserBrandRelationBrandUsersRelation = {
  __typename?: 'BrandUserBrandRelationBrandUsersRelation';
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  role: BrandUserRoleEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type BrandUserBrandRelationRegisteredCompanyRelation = {
  __typename?: 'BrandUserBrandRelationRegisteredCompanyRelation';
  addressId?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  dateOfCreation?: Maybe<Scalars['String']['output']>;
  firstAddressLine?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  secondAddressLine?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type BrandUserBrandRelationTradingAddressRelation = {
  __typename?: 'BrandUserBrandRelationTradingAddressRelation';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type BrandUserCreatedAtUtcFilters = {
  OR?: InputMaybe<Array<BrandUserCreatedAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandUserCreatedAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandUserFilters = {
  OR?: InputMaybe<Array<BrandUserFiltersOr>>;
  brandId?: InputMaybe<BrandUserBrandIdFilters>;
  createdAtUtc?: InputMaybe<BrandUserCreatedAtUtcFilters>;
  role?: InputMaybe<BrandUserRoleFilters>;
  updatedAtUtc?: InputMaybe<BrandUserUpdatedAtUtcFilters>;
  userId?: InputMaybe<BrandUserUserIdFilters>;
};

export type BrandUserFiltersOr = {
  brandId?: InputMaybe<BrandUserBrandIdFilters>;
  createdAtUtc?: InputMaybe<BrandUserCreatedAtUtcFilters>;
  role?: InputMaybe<BrandUserRoleFilters>;
  updatedAtUtc?: InputMaybe<BrandUserUpdatedAtUtcFilters>;
  userId?: InputMaybe<BrandUserUserIdFilters>;
};

export type BrandUserItem = {
  __typename?: 'BrandUserItem';
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  role?: Maybe<UserRole>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type BrandUserOrderBy = {
  brandId?: InputMaybe<InnerOrder>;
  createdAtUtc?: InputMaybe<InnerOrder>;
  role?: InputMaybe<InnerOrder>;
  updatedAtUtc?: InputMaybe<InnerOrder>;
  userId?: InputMaybe<InnerOrder>;
};

export enum BrandUserRoleEnum {
  /** Value: ADMIN */
  Admin = 'ADMIN',
  /** Value: OWNER */
  Owner = 'OWNER',
  /** Value: USER */
  User = 'USER'
}

export type BrandUserRoleFilters = {
  OR?: InputMaybe<Array<BrandUserRolefiltersOr>>;
  eq?: InputMaybe<BrandUserRoleEnum>;
  gt?: InputMaybe<BrandUserRoleEnum>;
  gte?: InputMaybe<BrandUserRoleEnum>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<BrandUserRoleEnum>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<BrandUserRoleEnum>;
  lte?: InputMaybe<BrandUserRoleEnum>;
  ne?: InputMaybe<BrandUserRoleEnum>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<BrandUserRoleEnum>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandUserRolefiltersOr = {
  eq?: InputMaybe<BrandUserRoleEnum>;
  gt?: InputMaybe<BrandUserRoleEnum>;
  gte?: InputMaybe<BrandUserRoleEnum>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<BrandUserRoleEnum>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<BrandUserRoleEnum>;
  lte?: InputMaybe<BrandUserRoleEnum>;
  ne?: InputMaybe<BrandUserRoleEnum>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<BrandUserRoleEnum>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandUserSelectItem = {
  __typename?: 'BrandUserSelectItem';
  brand?: Maybe<BrandUserBrandRelation>;
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  role: BrandUserRoleEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<BrandUserUserRelation>;
  userId: Scalars['Int']['output'];
};


export type BrandUserSelectItemBrandArgs = {
  where?: InputMaybe<BrandFilters>;
};


export type BrandUserSelectItemUserArgs = {
  where?: InputMaybe<UserFilters>;
};

export type BrandUserUpdatedAtUtcFilters = {
  OR?: InputMaybe<Array<BrandUserUpdatedAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandUserUpdatedAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandUserUserIdFilters = {
  OR?: InputMaybe<Array<BrandUserUserIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandUserUserIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandUserUserRelation = {
  __typename?: 'BrandUserUserRelation';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type BrandVatCompanyNameFilters = {
  OR?: InputMaybe<Array<BrandVatCompanyNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandVatCompanyNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandVatConsultationNumberFilters = {
  OR?: InputMaybe<Array<BrandVatConsultationNumberfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandVatConsultationNumberfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandVatCountryCodeFilters = {
  OR?: InputMaybe<Array<BrandVatCountryCodefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandVatCountryCodefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandVatNumberFilters = {
  OR?: InputMaybe<Array<BrandVatNumberfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandVatNumberfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandVatProcessingDateFilters = {
  OR?: InputMaybe<Array<BrandVatProcessingDatefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandVatProcessingDatefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandWebPageUrlFilters = {
  OR?: InputMaybe<Array<BrandWebPageUrlfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type BrandWebPageUrlfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type Brands = {
  __typename?: 'Brands';
  data: Array<Brand>;
  pageInfo: OffsetPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BrandsCursor = CursorPagination & {
  __typename?: 'BrandsCursor';
  edges: Array<BrandEdge>;
  pageInfo: CursorPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BulkImportMatchDealsCreated = {
  __typename?: 'BulkImportMatchDealsCreated';
  matchDealId: Scalars['Int']['output'];
  row: Scalars['Int']['output'];
};

export type BulkImportMatchDealsError = {
  __typename?: 'BulkImportMatchDealsError';
  cell?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  columnKey?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  row?: Maybe<Scalars['Int']['output']>;
  sheet?: Maybe<Scalars['String']['output']>;
};

export enum BulkImportMatchDealsMode {
  Apply = 'APPLY',
  Validate = 'VALIDATE'
}

export type BulkImportMatchDealsResult = {
  __typename?: 'BulkImportMatchDealsResult';
  created?: Maybe<Array<BulkImportMatchDealsCreated>>;
  createdCount: Scalars['Int']['output'];
  errors: Array<BulkImportMatchDealsError>;
  hasMoreErrors: Scalars['Boolean']['output'];
  status: BulkImportMatchDealsStatus;
  unchangedCount: Scalars['Int']['output'];
  updatedCount: Scalars['Int']['output'];
  validationToken?: Maybe<Scalars['String']['output']>;
};

export enum BulkImportMatchDealsStatus {
  Applied = 'APPLIED',
  Invalid = 'INVALID',
  Valid = 'VALID'
}

export type CancelSubscriptionInput = {
  brandId: Scalars['Int']['input'];
  region: Region;
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
};

export type CancelSubscriptionNewInAppInput = {
  brandId: Scalars['Int']['input'];
  subscriptionId: Scalars['String']['input'];
};

export type CancelSubscriptionNewRetoolInput = {
  brandId: Scalars['Int']['input'];
  subscriptionId: Scalars['String']['input'];
};

export type ChangeEmailInput = {
  email: Scalars['String']['input'];
};

export type ChooseMultipleTenderWinnersInput = {
  bidIds: Array<Scalars['NonNegativeInt']['input']>;
};

export type ChooseWinnerInput = {
  bidIds: Array<Scalars['NonNegativeInt']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  tenderId: Scalars['NonNegativeInt']['input'];
};

export type ClaimVenueAccountInput = {
  email: Scalars['String']['input'];
};

export type CommonBidBrandIdFilters = {
  OR?: InputMaybe<Array<CommonBidBrandIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidBrandIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidBrandRelation = {
  __typename?: 'CommonBidBrandRelation';
  address?: Maybe<CommonBidBrandRelationAddressRelation>;
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  awrsCompanyName?: Maybe<Scalars['String']['output']>;
  awrsDeregistrationDate?: Maybe<Scalars['String']['output']>;
  awrsNumber?: Maybe<Scalars['String']['output']>;
  awrsPlaceBusiness?: Maybe<Scalars['String']['output']>;
  awrsRegistrationDate?: Maybe<Scalars['String']['output']>;
  awrsStatus?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<CommonBidBrandRelationBillingAddressRelation>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  brandIntegrations: Array<CommonBidBrandRelationBrandIntegrationsRelation>;
  brandUsers: Array<CommonBidBrandRelationBrandUsersRelation>;
  canSeeOtherBids?: Maybe<Scalars['Boolean']['output']>;
  complianceCheckDate?: Maybe<Scalars['String']['output']>;
  complianceConfirmation?: Maybe<Scalars['String']['output']>;
  complianceNextDate?: Maybe<Scalars['String']['output']>;
  complianceRiskLevel?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  failedPaymentIntentCounter: Scalars['Int']['output'];
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  isAnonymousBidAllowed?: Maybe<Scalars['Boolean']['output']>;
  isEnterpriseSubscriptionRequestSent?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompany?: Maybe<CommonBidBrandRelationRegisteredCompanyRelation>;
  registeredCompanyId: Scalars['Int']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripePaymentLink?: Maybe<Scalars['String']['output']>;
  stripePaymentLinkHash?: Maybe<Scalars['String']['output']>;
  stripePaymentType?: Maybe<Scalars['String']['output']>;
  stripeProductPriceId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  tradingAddress?: Maybe<CommonBidBrandRelationTradingAddressRelation>;
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  vatCompanyName?: Maybe<Scalars['String']['output']>;
  vatConsultationNumber?: Maybe<Scalars['String']['output']>;
  vatCountryCode?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  vatProcessingDate?: Maybe<Scalars['String']['output']>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};


export type CommonBidBrandRelationAddressArgs = {
  where?: InputMaybe<AddressFilters>;
};


export type CommonBidBrandRelationBillingAddressArgs = {
  where?: InputMaybe<AddressFilters>;
};


export type CommonBidBrandRelationBrandIntegrationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BrandIntegrationsOrderBy>;
  where?: InputMaybe<BrandIntegrationsFilters>;
};


export type CommonBidBrandRelationBrandUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BrandUserOrderBy>;
  where?: InputMaybe<BrandUserFilters>;
};


export type CommonBidBrandRelationRegisteredCompanyArgs = {
  where?: InputMaybe<RegisteredCompanyFilters>;
};


export type CommonBidBrandRelationTradingAddressArgs = {
  where?: InputMaybe<AddressFilters>;
};

export type CommonBidBrandRelationAddressRelation = {
  __typename?: 'CommonBidBrandRelationAddressRelation';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type CommonBidBrandRelationBillingAddressRelation = {
  __typename?: 'CommonBidBrandRelationBillingAddressRelation';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type CommonBidBrandRelationBrandIntegrationsRelation = {
  __typename?: 'CommonBidBrandRelationBrandIntegrationsRelation';
  brand?: Maybe<CommonBidBrandRelationBrandIntegrationsRelationBrandRelation>;
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  externalCompanyId: Scalars['String']['output'];
  externalUserId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  integrationType: BrandIntegrationsIntegrationTypeEnum;
  /** JSON */
  metadata?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<CommonBidBrandRelationBrandIntegrationsRelationUserRelation>;
  userId: Scalars['Int']['output'];
};


export type CommonBidBrandRelationBrandIntegrationsRelationBrandArgs = {
  where?: InputMaybe<BrandFilters>;
};


export type CommonBidBrandRelationBrandIntegrationsRelationUserArgs = {
  where?: InputMaybe<UserFilters>;
};

export type CommonBidBrandRelationBrandIntegrationsRelationBrandRelation = {
  __typename?: 'CommonBidBrandRelationBrandIntegrationsRelationBrandRelation';
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  awrsCompanyName?: Maybe<Scalars['String']['output']>;
  awrsDeregistrationDate?: Maybe<Scalars['String']['output']>;
  awrsNumber?: Maybe<Scalars['String']['output']>;
  awrsPlaceBusiness?: Maybe<Scalars['String']['output']>;
  awrsRegistrationDate?: Maybe<Scalars['String']['output']>;
  awrsStatus?: Maybe<Scalars['String']['output']>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  canSeeOtherBids?: Maybe<Scalars['Boolean']['output']>;
  complianceCheckDate?: Maybe<Scalars['String']['output']>;
  complianceConfirmation?: Maybe<Scalars['String']['output']>;
  complianceNextDate?: Maybe<Scalars['String']['output']>;
  complianceRiskLevel?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  failedPaymentIntentCounter: Scalars['Int']['output'];
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  isAnonymousBidAllowed?: Maybe<Scalars['Boolean']['output']>;
  isEnterpriseSubscriptionRequestSent?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompanyId: Scalars['Int']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripePaymentLink?: Maybe<Scalars['String']['output']>;
  stripePaymentLinkHash?: Maybe<Scalars['String']['output']>;
  stripePaymentType?: Maybe<Scalars['String']['output']>;
  stripeProductPriceId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  vatCompanyName?: Maybe<Scalars['String']['output']>;
  vatConsultationNumber?: Maybe<Scalars['String']['output']>;
  vatCountryCode?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  vatProcessingDate?: Maybe<Scalars['String']['output']>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};

export type CommonBidBrandRelationBrandIntegrationsRelationUserRelation = {
  __typename?: 'CommonBidBrandRelationBrandIntegrationsRelationUserRelation';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type CommonBidBrandRelationBrandUsersRelation = {
  __typename?: 'CommonBidBrandRelationBrandUsersRelation';
  brand?: Maybe<CommonBidBrandRelationBrandUsersRelationBrandRelation>;
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  role: BrandUserRoleEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<CommonBidBrandRelationBrandUsersRelationUserRelation>;
  userId: Scalars['Int']['output'];
};


export type CommonBidBrandRelationBrandUsersRelationBrandArgs = {
  where?: InputMaybe<BrandFilters>;
};


export type CommonBidBrandRelationBrandUsersRelationUserArgs = {
  where?: InputMaybe<UserFilters>;
};

export type CommonBidBrandRelationBrandUsersRelationBrandRelation = {
  __typename?: 'CommonBidBrandRelationBrandUsersRelationBrandRelation';
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  awrsCompanyName?: Maybe<Scalars['String']['output']>;
  awrsDeregistrationDate?: Maybe<Scalars['String']['output']>;
  awrsNumber?: Maybe<Scalars['String']['output']>;
  awrsPlaceBusiness?: Maybe<Scalars['String']['output']>;
  awrsRegistrationDate?: Maybe<Scalars['String']['output']>;
  awrsStatus?: Maybe<Scalars['String']['output']>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  canSeeOtherBids?: Maybe<Scalars['Boolean']['output']>;
  complianceCheckDate?: Maybe<Scalars['String']['output']>;
  complianceConfirmation?: Maybe<Scalars['String']['output']>;
  complianceNextDate?: Maybe<Scalars['String']['output']>;
  complianceRiskLevel?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  failedPaymentIntentCounter: Scalars['Int']['output'];
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  isAnonymousBidAllowed?: Maybe<Scalars['Boolean']['output']>;
  isEnterpriseSubscriptionRequestSent?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompanyId: Scalars['Int']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripePaymentLink?: Maybe<Scalars['String']['output']>;
  stripePaymentLinkHash?: Maybe<Scalars['String']['output']>;
  stripePaymentType?: Maybe<Scalars['String']['output']>;
  stripeProductPriceId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  vatCompanyName?: Maybe<Scalars['String']['output']>;
  vatConsultationNumber?: Maybe<Scalars['String']['output']>;
  vatCountryCode?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  vatProcessingDate?: Maybe<Scalars['String']['output']>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};

export type CommonBidBrandRelationBrandUsersRelationUserRelation = {
  __typename?: 'CommonBidBrandRelationBrandUsersRelationUserRelation';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type CommonBidBrandRelationRegisteredCompanyRelation = {
  __typename?: 'CommonBidBrandRelationRegisteredCompanyRelation';
  addressId?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  dateOfCreation?: Maybe<Scalars['String']['output']>;
  firstAddressLine?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  secondAddressLine?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type CommonBidBrandRelationTradingAddressRelation = {
  __typename?: 'CommonBidBrandRelationTradingAddressRelation';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type CommonBidConnectBidRelation = {
  __typename?: 'CommonBidConnectBidRelation';
  bidId: Scalars['Int']['output'];
  commonBid?: Maybe<CommonBidConnectBidRelationCommonBidRelation>;
  matchBid?: Maybe<CommonBidConnectBidRelationMatchBidRelation>;
  matchBidId?: Maybe<Scalars['Int']['output']>;
  messageCount: Scalars['Int']['output'];
  tender?: Maybe<CommonBidConnectBidRelationTenderRelation>;
  tenderId: Scalars['Int']['output'];
};


export type CommonBidConnectBidRelationCommonBidArgs = {
  where?: InputMaybe<CommonBidFilters>;
};


export type CommonBidConnectBidRelationMatchBidArgs = {
  where?: InputMaybe<MatchBidFilters>;
};


export type CommonBidConnectBidRelationTenderArgs = {
  where?: InputMaybe<TenderFilters>;
};

export type CommonBidConnectBidRelationCommonBidRelation = {
  __typename?: 'CommonBidConnectBidRelationCommonBidRelation';
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  otherSupportAndTerms?: Maybe<Scalars['String']['output']>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  region: CommonBidRegionEnum;
  status: CommonBidStatusEnum;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  type: CommonBidTypeEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type CommonBidConnectBidRelationMatchBidRelation = {
  __typename?: 'CommonBidConnectBidRelationMatchBidRelation';
  autoTenderBid?: Maybe<Scalars['Boolean']['output']>;
  bidId: Scalars['Int']['output'];
  commonBid?: Maybe<CommonBidConnectBidRelationMatchBidRelationCommonBidRelation>;
  credit?: Maybe<Scalars['Boolean']['output']>;
  listingLength: Scalars['Int']['output'];
  maximumAcceptedDeals: Scalars['Int']['output'];
  product?: Maybe<CommonBidConnectBidRelationMatchBidRelationProductRelation>;
  venueCriteria?: Maybe<CommonBidConnectBidRelationMatchBidRelationVenueCriteriaRelation>;
};


export type CommonBidConnectBidRelationMatchBidRelationCommonBidArgs = {
  where?: InputMaybe<CommonBidFilters>;
};


export type CommonBidConnectBidRelationMatchBidRelationProductArgs = {
  where?: InputMaybe<MatchBidProductFilters>;
};


export type CommonBidConnectBidRelationMatchBidRelationVenueCriteriaArgs = {
  where?: InputMaybe<MatchBidVenueCriteriaFilters>;
};

export type CommonBidConnectBidRelationMatchBidRelationCommonBidRelation = {
  __typename?: 'CommonBidConnectBidRelationMatchBidRelationCommonBidRelation';
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  otherSupportAndTerms?: Maybe<Scalars['String']['output']>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  region: CommonBidRegionEnum;
  status: CommonBidStatusEnum;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  type: CommonBidTypeEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type CommonBidConnectBidRelationMatchBidRelationProductRelation = {
  __typename?: 'CommonBidConnectBidRelationMatchBidRelationProductRelation';
  bid?: Maybe<CommonBidConnectBidRelationMatchBidRelationProductRelationBidRelation>;
  bidId: Scalars['Int']['output'];
  commonProduct?: Maybe<CommonBidConnectBidRelationMatchBidRelationProductRelationCommonProductRelation>;
  externalProductId?: Maybe<Scalars['String']['output']>;
  externalProvider?: Maybe<MatchBidProductExternalProviderEnum>;
  productId: Scalars['Int']['output'];
};


export type CommonBidConnectBidRelationMatchBidRelationProductRelationBidArgs = {
  where?: InputMaybe<MatchBidFilters>;
};


export type CommonBidConnectBidRelationMatchBidRelationProductRelationCommonProductArgs = {
  where?: InputMaybe<CommonBidProductFilters>;
};

export type CommonBidConnectBidRelationMatchBidRelationProductRelationBidRelation = {
  __typename?: 'CommonBidConnectBidRelationMatchBidRelationProductRelationBidRelation';
  autoTenderBid?: Maybe<Scalars['Boolean']['output']>;
  bidId: Scalars['Int']['output'];
  credit?: Maybe<Scalars['Boolean']['output']>;
  listingLength: Scalars['Int']['output'];
  maximumAcceptedDeals: Scalars['Int']['output'];
};

export type CommonBidConnectBidRelationMatchBidRelationProductRelationCommonProductRelation = {
  __typename?: 'CommonBidConnectBidRelationMatchBidRelationProductRelationCommonProductRelation';
  /** JSON */
  attachments?: Maybe<Scalars['String']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  averageWholesalePrice: Scalars['Float']['output'];
  bidId: Scalars['Int']['output'];
  /** JSON */
  image?: Maybe<Scalars['String']['output']>;
  isAnyWholesalerCompatible: Scalars['Boolean']['output'];
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  packagingType: Scalars['String']['output'];
  productCategoryId: Scalars['Int']['output'];
  productTemplateId?: Maybe<Scalars['Int']['output']>;
  unitType: Scalars['String']['output'];
  unitsPerCase: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
  volumePerUnit: Scalars['Float']['output'];
  volumeUnits: Scalars['Float']['output'];
};

export type CommonBidConnectBidRelationMatchBidRelationVenueCriteriaRelation = {
  __typename?: 'CommonBidConnectBidRelationMatchBidRelationVenueCriteriaRelation';
  bid?: Maybe<CommonBidConnectBidRelationMatchBidRelationVenueCriteriaRelationBidRelation>;
  bidId: Scalars['Int']['output'];
  capturedTargetedVenues?: Maybe<Scalars['Int']['output']>;
  customerTypes?: Maybe<Array<Scalars['NonEmptyString']['output']>>;
  listingType?: Maybe<CommonBidConnectBidRelationMatchBidRelationVenueCriteriaRelationListingTypeRelation>;
  listingTypeId: Scalars['Int']['output'];
  loyaltyLevels?: Maybe<Array<Scalars['NonEmptyString']['output']>>;
  minimumVolume: Scalars['Int']['output'];
  regions?: Maybe<Array<Scalars['NonEmptyString']['output']>>;
  targetProductCategory?: Maybe<Scalars['Int']['output']>;
  venueTypes?: Maybe<Array<Scalars['NonEmptyString']['output']>>;
};


export type CommonBidConnectBidRelationMatchBidRelationVenueCriteriaRelationBidArgs = {
  where?: InputMaybe<MatchBidFilters>;
};


export type CommonBidConnectBidRelationMatchBidRelationVenueCriteriaRelationListingTypeArgs = {
  where?: InputMaybe<ListingTypeFilters>;
};

export type CommonBidConnectBidRelationMatchBidRelationVenueCriteriaRelationBidRelation = {
  __typename?: 'CommonBidConnectBidRelationMatchBidRelationVenueCriteriaRelationBidRelation';
  autoTenderBid?: Maybe<Scalars['Boolean']['output']>;
  bidId: Scalars['Int']['output'];
  credit?: Maybe<Scalars['Boolean']['output']>;
  listingLength: Scalars['Int']['output'];
  maximumAcceptedDeals: Scalars['Int']['output'];
};

export type CommonBidConnectBidRelationMatchBidRelationVenueCriteriaRelationListingTypeRelation = {
  __typename?: 'CommonBidConnectBidRelationMatchBidRelationVenueCriteriaRelationListingTypeRelation';
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  localizationKey: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  region?: Maybe<Scalars['String']['output']>;
  suggestedListingLengthInMonths: Scalars['Int']['output'];
  suggestedTenderLengthInMonths: Scalars['Int']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type CommonBidConnectBidRelationTenderRelation = {
  __typename?: 'CommonBidConnectBidRelationTenderRelation';
  connectBids: Array<CommonBidConnectBidRelationTenderRelationConnectBidsRelation>;
  createdAtUtc: Scalars['String']['output'];
  estimatedVolume: Scalars['Int']['output'];
  feedback?: Maybe<Scalars['String']['output']>;
  hostingChargeInvoiceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAnyWholesalerCompatible?: Maybe<Scalars['Boolean']['output']>;
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  listingEndsAtUtc: Scalars['String']['output'];
  listingStartsAtUtc: Scalars['String']['output'];
  listingType?: Maybe<CommonBidConnectBidRelationTenderRelationListingTypeRelation>;
  listingTypeId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  notifications: Array<CommonBidConnectBidRelationTenderRelationNotificationsRelation>;
  originalTenderEndsAtUtc?: Maybe<Scalars['String']['output']>;
  packagingType?: Maybe<Scalars['String']['output']>;
  productCategories: Array<CommonBidConnectBidRelationTenderRelationProductCategoriesRelation>;
  productPackaging?: Maybe<CommonBidConnectBidRelationTenderRelationProductPackagingRelation>;
  receivedSupportStatus: Scalars['String']['output'];
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  supportDetails?: Maybe<Scalars['String']['output']>;
  supportsDiscount: Scalars['String']['output'];
  supportsFreeStock: Scalars['String']['output'];
  supportsListingFee: Scalars['String']['output'];
  supportsPosBudget: Scalars['String']['output'];
  supportsRetroDiscount: Scalars['String']['output'];
  tenderDetails?: Maybe<Scalars['String']['output']>;
  tenderEndsAtUtc?: Maybe<Scalars['String']['output']>;
  tenderStartsAtUtc?: Maybe<Scalars['String']['output']>;
  tenderWholesalers: Array<CommonBidConnectBidRelationTenderRelationTenderWholesalersRelation>;
  unit?: Maybe<CommonBidConnectBidRelationTenderRelationUnitRelation>;
  unitType: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<CommonBidConnectBidRelationTenderRelationUserRelation>;
  userId: Scalars['Int']['output'];
  venue?: Maybe<CommonBidConnectBidRelationTenderRelationVenueRelation>;
  venueId: Scalars['Int']['output'];
  volumeDetails?: Maybe<Scalars['String']['output']>;
  volumeUnits: Scalars['Float']['output'];
};


export type CommonBidConnectBidRelationTenderRelationConnectBidsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ConnectBidOrderBy>;
  where?: InputMaybe<ConnectBidFilters>;
};


export type CommonBidConnectBidRelationTenderRelationListingTypeArgs = {
  where?: InputMaybe<ListingTypeFilters>;
};


export type CommonBidConnectBidRelationTenderRelationNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<NotificationOrderBy>;
  where?: InputMaybe<NotificationFilters>;
};


export type CommonBidConnectBidRelationTenderRelationProductCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TenderProductCategoriesOrderBy>;
  where?: InputMaybe<TenderProductCategoriesFilters>;
};


export type CommonBidConnectBidRelationTenderRelationProductPackagingArgs = {
  where?: InputMaybe<ProductPackagingFilters>;
};


export type CommonBidConnectBidRelationTenderRelationTenderWholesalersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TenderWholesalerOrderBy>;
  where?: InputMaybe<TenderWholesalerFilters>;
};


export type CommonBidConnectBidRelationTenderRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type CommonBidConnectBidRelationTenderRelationUserArgs = {
  where?: InputMaybe<UserFilters>;
};


export type CommonBidConnectBidRelationTenderRelationVenueArgs = {
  where?: InputMaybe<VenueFilters>;
};

export type CommonBidConnectBidRelationTenderRelationConnectBidsRelation = {
  __typename?: 'CommonBidConnectBidRelationTenderRelationConnectBidsRelation';
  bidId: Scalars['Int']['output'];
  matchBidId?: Maybe<Scalars['Int']['output']>;
  tenderId: Scalars['Int']['output'];
};

export type CommonBidConnectBidRelationTenderRelationListingTypeRelation = {
  __typename?: 'CommonBidConnectBidRelationTenderRelationListingTypeRelation';
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  localizationKey: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  region?: Maybe<Scalars['String']['output']>;
  regions: Array<CommonBidConnectBidRelationTenderRelationListingTypeRelationRegionsRelation>;
  suggestedListingLengthInMonths: Scalars['Int']['output'];
  suggestedTenderLengthInMonths: Scalars['Int']['output'];
  tenderDrafts: Array<CommonBidConnectBidRelationTenderRelationListingTypeRelationTenderDraftsRelation>;
  tenders: Array<CommonBidConnectBidRelationTenderRelationListingTypeRelationTendersRelation>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};


export type CommonBidConnectBidRelationTenderRelationListingTypeRelationRegionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ListingTypeRegion2OrderBy>;
  where?: InputMaybe<ListingTypeRegion2Filters>;
};


export type CommonBidConnectBidRelationTenderRelationListingTypeRelationTenderDraftsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TenderDraftOrderBy>;
  where?: InputMaybe<TenderDraftFilters>;
};


export type CommonBidConnectBidRelationTenderRelationListingTypeRelationTendersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TenderOrderBy>;
  where?: InputMaybe<TenderFilters>;
};

export type CommonBidConnectBidRelationTenderRelationListingTypeRelationRegionsRelation = {
  __typename?: 'CommonBidConnectBidRelationTenderRelationListingTypeRelationRegionsRelation';
  listingTypeId: Scalars['Int']['output'];
  region: Scalars['String']['output'];
};

export type CommonBidConnectBidRelationTenderRelationListingTypeRelationTenderDraftsRelation = {
  __typename?: 'CommonBidConnectBidRelationTenderRelationListingTypeRelationTenderDraftsRelation';
  createdAtUtc: Scalars['String']['output'];
  estimatedVolume?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isAnyWholesalerCompatible?: Maybe<Scalars['Boolean']['output']>;
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  listingEndsAtUtc?: Maybe<Scalars['String']['output']>;
  listingStartsAtUtc?: Maybe<Scalars['String']['output']>;
  listingTypeId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  packagingType?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  supportDetails?: Maybe<Scalars['String']['output']>;
  supportsDiscount: Scalars['String']['output'];
  supportsFreeStock: Scalars['String']['output'];
  supportsListingFee: Scalars['String']['output'];
  supportsPosBudget: Scalars['String']['output'];
  supportsRetroDiscount: Scalars['String']['output'];
  tenderDetails?: Maybe<Scalars['String']['output']>;
  tenderEndsAtUtc?: Maybe<Scalars['String']['output']>;
  tenderStartsAtUtc?: Maybe<Scalars['String']['output']>;
  unitType?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
  venueId: Scalars['Int']['output'];
  volumeDetails?: Maybe<Scalars['String']['output']>;
  volumeUnits?: Maybe<Scalars['Float']['output']>;
};

export type CommonBidConnectBidRelationTenderRelationListingTypeRelationTendersRelation = {
  __typename?: 'CommonBidConnectBidRelationTenderRelationListingTypeRelationTendersRelation';
  createdAtUtc: Scalars['String']['output'];
  estimatedVolume: Scalars['Int']['output'];
  feedback?: Maybe<Scalars['String']['output']>;
  hostingChargeInvoiceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAnyWholesalerCompatible?: Maybe<Scalars['Boolean']['output']>;
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  listingEndsAtUtc: Scalars['String']['output'];
  listingStartsAtUtc: Scalars['String']['output'];
  listingTypeId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  originalTenderEndsAtUtc?: Maybe<Scalars['String']['output']>;
  packagingType?: Maybe<Scalars['String']['output']>;
  receivedSupportStatus: Scalars['String']['output'];
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  supportDetails?: Maybe<Scalars['String']['output']>;
  supportsDiscount: Scalars['String']['output'];
  supportsFreeStock: Scalars['String']['output'];
  supportsListingFee: Scalars['String']['output'];
  supportsPosBudget: Scalars['String']['output'];
  supportsRetroDiscount: Scalars['String']['output'];
  tenderDetails?: Maybe<Scalars['String']['output']>;
  tenderEndsAtUtc?: Maybe<Scalars['String']['output']>;
  tenderStartsAtUtc?: Maybe<Scalars['String']['output']>;
  unitType: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
  venueId: Scalars['Int']['output'];
  volumeDetails?: Maybe<Scalars['String']['output']>;
  volumeUnits: Scalars['Float']['output'];
};

export type CommonBidConnectBidRelationTenderRelationNotificationsRelation = {
  __typename?: 'CommonBidConnectBidRelationTenderRelationNotificationsRelation';
  bidId?: Maybe<Scalars['Int']['output']>;
  brandId?: Maybe<Scalars['Int']['output']>;
  category: Scalars['String']['output'];
  createdAtUtc: Scalars['String']['output'];
  fromId?: Maybe<Scalars['Int']['output']>;
  fromType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isRead: Scalars['Boolean']['output'];
  messageId?: Maybe<Scalars['Int']['output']>;
  tenderId?: Maybe<Scalars['Int']['output']>;
  toId: Scalars['Int']['output'];
  toType: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  venueId?: Maybe<Scalars['Int']['output']>;
};

export type CommonBidConnectBidRelationTenderRelationProductCategoriesRelation = {
  __typename?: 'CommonBidConnectBidRelationTenderRelationProductCategoriesRelation';
  productCategoryId: Scalars['Int']['output'];
  tenderId: Scalars['Int']['output'];
};

export type CommonBidConnectBidRelationTenderRelationProductPackagingRelation = {
  __typename?: 'CommonBidConnectBidRelationTenderRelationProductPackagingRelation';
  type: Scalars['String']['output'];
};

export type CommonBidConnectBidRelationTenderRelationTenderWholesalersRelation = {
  __typename?: 'CommonBidConnectBidRelationTenderRelationTenderWholesalersRelation';
  tenderId: Scalars['Int']['output'];
  wholesalerId: Scalars['Int']['output'];
};

export type CommonBidConnectBidRelationTenderRelationUnitRelation = {
  __typename?: 'CommonBidConnectBidRelationTenderRelationUnitRelation';
  type: Scalars['String']['output'];
};

export type CommonBidConnectBidRelationTenderRelationUserRelation = {
  __typename?: 'CommonBidConnectBidRelationTenderRelationUserRelation';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type CommonBidConnectBidRelationTenderRelationVenueRelation = {
  __typename?: 'CommonBidConnectBidRelationTenderRelationVenueRelation';
  address?: Maybe<CommonBidConnectBidRelationTenderRelationVenueRelationAddressRelation>;
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<CommonBidConnectBidRelationTenderRelationVenueRelationBillingAddressRelation>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompany?: Maybe<CommonBidConnectBidRelationTenderRelationVenueRelationRegisteredCompanyRelation>;
  registeredCompanyId: Scalars['Int']['output'];
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  venueCategory?: Maybe<CommonBidConnectBidRelationTenderRelationVenueRelationVenueCategoryRelation>;
  venueCategoryId?: Maybe<Scalars['Int']['output']>;
  venueCategoryName?: Maybe<Scalars['String']['output']>;
  venueIntegrations: Array<CommonBidConnectBidRelationTenderRelationVenueRelationVenueIntegrationsRelation>;
  venueUsers: Array<CommonBidConnectBidRelationTenderRelationVenueRelationVenueUsersRelation>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};


export type CommonBidConnectBidRelationTenderRelationVenueRelationAddressArgs = {
  where?: InputMaybe<AddressFilters>;
};


export type CommonBidConnectBidRelationTenderRelationVenueRelationBillingAddressArgs = {
  where?: InputMaybe<AddressFilters>;
};


export type CommonBidConnectBidRelationTenderRelationVenueRelationRegisteredCompanyArgs = {
  where?: InputMaybe<RegisteredCompanyFilters>;
};


export type CommonBidConnectBidRelationTenderRelationVenueRelationVenueCategoryArgs = {
  where?: InputMaybe<VenueCategoryFilters>;
};


export type CommonBidConnectBidRelationTenderRelationVenueRelationVenueIntegrationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<VenueIntegrationsOrderBy>;
  where?: InputMaybe<VenueIntegrationsFilters>;
};


export type CommonBidConnectBidRelationTenderRelationVenueRelationVenueUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<VenueUserOrderBy>;
  where?: InputMaybe<VenueUserFilters>;
};

export type CommonBidConnectBidRelationTenderRelationVenueRelationAddressRelation = {
  __typename?: 'CommonBidConnectBidRelationTenderRelationVenueRelationAddressRelation';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type CommonBidConnectBidRelationTenderRelationVenueRelationBillingAddressRelation = {
  __typename?: 'CommonBidConnectBidRelationTenderRelationVenueRelationBillingAddressRelation';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type CommonBidConnectBidRelationTenderRelationVenueRelationRegisteredCompanyRelation = {
  __typename?: 'CommonBidConnectBidRelationTenderRelationVenueRelationRegisteredCompanyRelation';
  addressId?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  dateOfCreation?: Maybe<Scalars['String']['output']>;
  firstAddressLine?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  secondAddressLine?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type CommonBidConnectBidRelationTenderRelationVenueRelationVenueCategoryRelation = {
  __typename?: 'CommonBidConnectBidRelationTenderRelationVenueRelationVenueCategoryRelation';
  id: Scalars['Int']['output'];
  localizationKey: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type CommonBidConnectBidRelationTenderRelationVenueRelationVenueIntegrationsRelation = {
  __typename?: 'CommonBidConnectBidRelationTenderRelationVenueRelationVenueIntegrationsRelation';
  createdAtUtc: Scalars['String']['output'];
  externalCompanyId: Scalars['String']['output'];
  externalUserId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  integrationType: VenueIntegrationsIntegrationTypeEnum;
  /** JSON */
  metadata?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
  venueId: Scalars['Int']['output'];
};

export type CommonBidConnectBidRelationTenderRelationVenueRelationVenueUsersRelation = {
  __typename?: 'CommonBidConnectBidRelationTenderRelationVenueRelationVenueUsersRelation';
  createdAtUtc: Scalars['String']['output'];
  role: VenueUserRoleEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
  venueId: Scalars['Int']['output'];
};

export type CommonBidCreatedAtUtcFilters = {
  OR?: InputMaybe<Array<CommonBidCreatedAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidCreatedAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidFilters = {
  OR?: InputMaybe<Array<CommonBidFiltersOr>>;
  brandId?: InputMaybe<CommonBidBrandIdFilters>;
  createdAtUtc?: InputMaybe<CommonBidCreatedAtUtcFilters>;
  id?: InputMaybe<CommonBidIdFilters>;
  isAnonymous?: InputMaybe<CommonBidIsAnonymousFilters>;
  otherSupportAndTerms?: InputMaybe<CommonBidOtherSupportAndTermsFilters>;
  ratedAtUtc?: InputMaybe<CommonBidRatedAtUtcFilters>;
  rating?: InputMaybe<CommonBidRatingFilters>;
  ratingComment?: InputMaybe<CommonBidRatingCommentFilters>;
  region?: InputMaybe<CommonBidRegionFilters>;
  status?: InputMaybe<CommonBidStatusFilters>;
  subscriptionTier?: InputMaybe<CommonBidSubscriptionTierFilters>;
  successFee?: InputMaybe<CommonBidSuccessFeeFilters>;
  type?: InputMaybe<CommonBidTypeFilters>;
  updatedAtUtc?: InputMaybe<CommonBidUpdatedAtUtcFilters>;
  userId?: InputMaybe<CommonBidUserIdFilters>;
};

export type CommonBidFiltersOr = {
  brandId?: InputMaybe<CommonBidBrandIdFilters>;
  createdAtUtc?: InputMaybe<CommonBidCreatedAtUtcFilters>;
  id?: InputMaybe<CommonBidIdFilters>;
  isAnonymous?: InputMaybe<CommonBidIsAnonymousFilters>;
  otherSupportAndTerms?: InputMaybe<CommonBidOtherSupportAndTermsFilters>;
  ratedAtUtc?: InputMaybe<CommonBidRatedAtUtcFilters>;
  rating?: InputMaybe<CommonBidRatingFilters>;
  ratingComment?: InputMaybe<CommonBidRatingCommentFilters>;
  region?: InputMaybe<CommonBidRegionFilters>;
  status?: InputMaybe<CommonBidStatusFilters>;
  subscriptionTier?: InputMaybe<CommonBidSubscriptionTierFilters>;
  successFee?: InputMaybe<CommonBidSuccessFeeFilters>;
  type?: InputMaybe<CommonBidTypeFilters>;
  updatedAtUtc?: InputMaybe<CommonBidUpdatedAtUtcFilters>;
  userId?: InputMaybe<CommonBidUserIdFilters>;
};

export type CommonBidIdFilters = {
  OR?: InputMaybe<Array<CommonBidIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidIsAnonymousFilters = {
  OR?: InputMaybe<Array<CommonBidIsAnonymousfiltersOr>>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidIsAnonymousfiltersOr = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidItem = {
  __typename?: 'CommonBidItem';
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  otherSupportAndTerms?: Maybe<Scalars['String']['output']>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  region: CommonBidRegionEnum;
  status: CommonBidStatusEnum;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  type: CommonBidTypeEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type CommonBidMatchBidRelation = {
  __typename?: 'CommonBidMatchBidRelation';
  autoTenderBid?: Maybe<Scalars['Boolean']['output']>;
  bidId: Scalars['Int']['output'];
  commonBid?: Maybe<CommonBidMatchBidRelationCommonBidRelation>;
  credit?: Maybe<Scalars['Boolean']['output']>;
  listingLength: Scalars['Int']['output'];
  maximumAcceptedDeals: Scalars['Int']['output'];
  product?: Maybe<CommonBidMatchBidRelationProductRelation>;
  venueCriteria?: Maybe<CommonBidMatchBidRelationVenueCriteriaRelation>;
};


export type CommonBidMatchBidRelationCommonBidArgs = {
  where?: InputMaybe<CommonBidFilters>;
};


export type CommonBidMatchBidRelationProductArgs = {
  where?: InputMaybe<MatchBidProductFilters>;
};


export type CommonBidMatchBidRelationVenueCriteriaArgs = {
  where?: InputMaybe<MatchBidVenueCriteriaFilters>;
};

export type CommonBidMatchBidRelationCommonBidRelation = {
  __typename?: 'CommonBidMatchBidRelationCommonBidRelation';
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  otherSupportAndTerms?: Maybe<Scalars['String']['output']>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  region: CommonBidRegionEnum;
  status: CommonBidStatusEnum;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  type: CommonBidTypeEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type CommonBidMatchBidRelationProductRelation = {
  __typename?: 'CommonBidMatchBidRelationProductRelation';
  bid?: Maybe<CommonBidMatchBidRelationProductRelationBidRelation>;
  bidId: Scalars['Int']['output'];
  commonProduct?: Maybe<CommonBidMatchBidRelationProductRelationCommonProductRelation>;
  externalProductId?: Maybe<Scalars['String']['output']>;
  externalProvider?: Maybe<MatchBidProductExternalProviderEnum>;
  productId: Scalars['Int']['output'];
};


export type CommonBidMatchBidRelationProductRelationBidArgs = {
  where?: InputMaybe<MatchBidFilters>;
};


export type CommonBidMatchBidRelationProductRelationCommonProductArgs = {
  where?: InputMaybe<CommonBidProductFilters>;
};

export type CommonBidMatchBidRelationProductRelationBidRelation = {
  __typename?: 'CommonBidMatchBidRelationProductRelationBidRelation';
  autoTenderBid?: Maybe<Scalars['Boolean']['output']>;
  bidId: Scalars['Int']['output'];
  credit?: Maybe<Scalars['Boolean']['output']>;
  listingLength: Scalars['Int']['output'];
  maximumAcceptedDeals: Scalars['Int']['output'];
};

export type CommonBidMatchBidRelationProductRelationCommonProductRelation = {
  __typename?: 'CommonBidMatchBidRelationProductRelationCommonProductRelation';
  /** JSON */
  attachments?: Maybe<Scalars['String']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  averageWholesalePrice: Scalars['Float']['output'];
  bid?: Maybe<CommonBidMatchBidRelationProductRelationCommonProductRelationBidRelation>;
  bidId: Scalars['Int']['output'];
  /** JSON */
  image?: Maybe<Scalars['String']['output']>;
  isAnyWholesalerCompatible: Scalars['Boolean']['output'];
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  packagingType: Scalars['String']['output'];
  productCategory?: Maybe<CommonBidMatchBidRelationProductRelationCommonProductRelationProductCategoryRelation>;
  productCategoryId: Scalars['Int']['output'];
  productTemplateId?: Maybe<Scalars['Int']['output']>;
  unitType: Scalars['String']['output'];
  unitsPerCase: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
  volumePerUnit: Scalars['Float']['output'];
  volumeUnits: Scalars['Float']['output'];
};


export type CommonBidMatchBidRelationProductRelationCommonProductRelationBidArgs = {
  where?: InputMaybe<CommonBidFilters>;
};


export type CommonBidMatchBidRelationProductRelationCommonProductRelationProductCategoryArgs = {
  where?: InputMaybe<ProductCategoryFilters>;
};

export type CommonBidMatchBidRelationProductRelationCommonProductRelationBidRelation = {
  __typename?: 'CommonBidMatchBidRelationProductRelationCommonProductRelationBidRelation';
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  otherSupportAndTerms?: Maybe<Scalars['String']['output']>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  region: CommonBidRegionEnum;
  status: CommonBidStatusEnum;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  type: CommonBidTypeEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type CommonBidMatchBidRelationProductRelationCommonProductRelationProductCategoryRelation = {
  __typename?: 'CommonBidMatchBidRelationProductRelationCommonProductRelationProductCategoryRelation';
  createdAtUtc: Scalars['String']['output'];
  defaultPackagingType?: Maybe<Scalars['String']['output']>;
  defaultVolume?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isPublished: Scalars['Boolean']['output'];
  localizationKey: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  unitType?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type CommonBidMatchBidRelationVenueCriteriaRelation = {
  __typename?: 'CommonBidMatchBidRelationVenueCriteriaRelation';
  bid?: Maybe<CommonBidMatchBidRelationVenueCriteriaRelationBidRelation>;
  bidId: Scalars['Int']['output'];
  capturedTargetedVenues?: Maybe<Scalars['Int']['output']>;
  customerTypes?: Maybe<Array<Scalars['NonEmptyString']['output']>>;
  listingType?: Maybe<CommonBidMatchBidRelationVenueCriteriaRelationListingTypeRelation>;
  listingTypeId: Scalars['Int']['output'];
  loyaltyLevels?: Maybe<Array<Scalars['NonEmptyString']['output']>>;
  minimumVolume: Scalars['Int']['output'];
  regions?: Maybe<Array<Scalars['NonEmptyString']['output']>>;
  targetProductCategory?: Maybe<Scalars['Int']['output']>;
  venueTypes?: Maybe<Array<Scalars['NonEmptyString']['output']>>;
};


export type CommonBidMatchBidRelationVenueCriteriaRelationBidArgs = {
  where?: InputMaybe<MatchBidFilters>;
};


export type CommonBidMatchBidRelationVenueCriteriaRelationListingTypeArgs = {
  where?: InputMaybe<ListingTypeFilters>;
};

export type CommonBidMatchBidRelationVenueCriteriaRelationBidRelation = {
  __typename?: 'CommonBidMatchBidRelationVenueCriteriaRelationBidRelation';
  autoTenderBid?: Maybe<Scalars['Boolean']['output']>;
  bidId: Scalars['Int']['output'];
  credit?: Maybe<Scalars['Boolean']['output']>;
  listingLength: Scalars['Int']['output'];
  maximumAcceptedDeals: Scalars['Int']['output'];
};

export type CommonBidMatchBidRelationVenueCriteriaRelationListingTypeRelation = {
  __typename?: 'CommonBidMatchBidRelationVenueCriteriaRelationListingTypeRelation';
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  localizationKey: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  region?: Maybe<Scalars['String']['output']>;
  regions: Array<CommonBidMatchBidRelationVenueCriteriaRelationListingTypeRelationRegionsRelation>;
  suggestedListingLengthInMonths: Scalars['Int']['output'];
  suggestedTenderLengthInMonths: Scalars['Int']['output'];
  tenderDrafts: Array<CommonBidMatchBidRelationVenueCriteriaRelationListingTypeRelationTenderDraftsRelation>;
  tenders: Array<CommonBidMatchBidRelationVenueCriteriaRelationListingTypeRelationTendersRelation>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};


export type CommonBidMatchBidRelationVenueCriteriaRelationListingTypeRelationRegionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ListingTypeRegion2OrderBy>;
  where?: InputMaybe<ListingTypeRegion2Filters>;
};


export type CommonBidMatchBidRelationVenueCriteriaRelationListingTypeRelationTenderDraftsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TenderDraftOrderBy>;
  where?: InputMaybe<TenderDraftFilters>;
};


export type CommonBidMatchBidRelationVenueCriteriaRelationListingTypeRelationTendersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TenderOrderBy>;
  where?: InputMaybe<TenderFilters>;
};

export type CommonBidMatchBidRelationVenueCriteriaRelationListingTypeRelationRegionsRelation = {
  __typename?: 'CommonBidMatchBidRelationVenueCriteriaRelationListingTypeRelationRegionsRelation';
  listingTypeId: Scalars['Int']['output'];
  region: Scalars['String']['output'];
};

export type CommonBidMatchBidRelationVenueCriteriaRelationListingTypeRelationTenderDraftsRelation = {
  __typename?: 'CommonBidMatchBidRelationVenueCriteriaRelationListingTypeRelationTenderDraftsRelation';
  createdAtUtc: Scalars['String']['output'];
  estimatedVolume?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isAnyWholesalerCompatible?: Maybe<Scalars['Boolean']['output']>;
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  listingEndsAtUtc?: Maybe<Scalars['String']['output']>;
  listingStartsAtUtc?: Maybe<Scalars['String']['output']>;
  listingTypeId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  packagingType?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  supportDetails?: Maybe<Scalars['String']['output']>;
  supportsDiscount: Scalars['String']['output'];
  supportsFreeStock: Scalars['String']['output'];
  supportsListingFee: Scalars['String']['output'];
  supportsPosBudget: Scalars['String']['output'];
  supportsRetroDiscount: Scalars['String']['output'];
  tenderDetails?: Maybe<Scalars['String']['output']>;
  tenderEndsAtUtc?: Maybe<Scalars['String']['output']>;
  tenderStartsAtUtc?: Maybe<Scalars['String']['output']>;
  unitType?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
  venueId: Scalars['Int']['output'];
  volumeDetails?: Maybe<Scalars['String']['output']>;
  volumeUnits?: Maybe<Scalars['Float']['output']>;
};

export type CommonBidMatchBidRelationVenueCriteriaRelationListingTypeRelationTendersRelation = {
  __typename?: 'CommonBidMatchBidRelationVenueCriteriaRelationListingTypeRelationTendersRelation';
  createdAtUtc: Scalars['String']['output'];
  estimatedVolume: Scalars['Int']['output'];
  feedback?: Maybe<Scalars['String']['output']>;
  hostingChargeInvoiceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAnyWholesalerCompatible?: Maybe<Scalars['Boolean']['output']>;
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  listingEndsAtUtc: Scalars['String']['output'];
  listingStartsAtUtc: Scalars['String']['output'];
  listingTypeId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  originalTenderEndsAtUtc?: Maybe<Scalars['String']['output']>;
  packagingType?: Maybe<Scalars['String']['output']>;
  receivedSupportStatus: Scalars['String']['output'];
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  supportDetails?: Maybe<Scalars['String']['output']>;
  supportsDiscount: Scalars['String']['output'];
  supportsFreeStock: Scalars['String']['output'];
  supportsListingFee: Scalars['String']['output'];
  supportsPosBudget: Scalars['String']['output'];
  supportsRetroDiscount: Scalars['String']['output'];
  tenderDetails?: Maybe<Scalars['String']['output']>;
  tenderEndsAtUtc?: Maybe<Scalars['String']['output']>;
  tenderStartsAtUtc?: Maybe<Scalars['String']['output']>;
  unitType: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
  venueId: Scalars['Int']['output'];
  volumeDetails?: Maybe<Scalars['String']['output']>;
  volumeUnits: Scalars['Float']['output'];
};

export type CommonBidOrderBy = {
  brandId?: InputMaybe<InnerOrder>;
  createdAtUtc?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  isAnonymous?: InputMaybe<InnerOrder>;
  otherSupportAndTerms?: InputMaybe<InnerOrder>;
  ratedAtUtc?: InputMaybe<InnerOrder>;
  rating?: InputMaybe<InnerOrder>;
  ratingComment?: InputMaybe<InnerOrder>;
  region?: InputMaybe<InnerOrder>;
  status?: InputMaybe<InnerOrder>;
  subscriptionTier?: InputMaybe<InnerOrder>;
  successFee?: InputMaybe<InnerOrder>;
  type?: InputMaybe<InnerOrder>;
  updatedAtUtc?: InputMaybe<InnerOrder>;
  userId?: InputMaybe<InnerOrder>;
};

export type CommonBidOtherSupportAndTermsFilters = {
  OR?: InputMaybe<Array<CommonBidOtherSupportAndTermsfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidOtherSupportAndTermsfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductAttachmentsFilters = {
  OR?: InputMaybe<Array<CommonBidProductAttachmentsfiltersOr>>;
  /** JSON */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductAttachmentsfiltersOr = {
  /** JSON */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductAvatarBucketKeyFilters = {
  OR?: InputMaybe<Array<CommonBidProductAvatarBucketKeyfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductAvatarBucketKeyPreSignedUrlExpirationDateAtUtcFilters = {
  OR?: InputMaybe<Array<CommonBidProductAvatarBucketKeyPreSignedUrlExpirationDateAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductAvatarBucketKeyPreSignedUrlExpirationDateAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductAvatarBucketKeyPreSignedUrlFilters = {
  OR?: InputMaybe<Array<CommonBidProductAvatarBucketKeyPreSignedUrlfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductAvatarBucketKeyPreSignedUrlfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductAvatarBucketKeyfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductAverageWholesalePriceFilters = {
  OR?: InputMaybe<Array<CommonBidProductAverageWholesalePricefiltersOr>>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Float']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Float']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductAverageWholesalePricefiltersOr = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Float']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Float']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductBidIdFilters = {
  OR?: InputMaybe<Array<CommonBidProductBidIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductBidIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductFilters = {
  OR?: InputMaybe<Array<CommonBidProductFiltersOr>>;
  attachments?: InputMaybe<CommonBidProductAttachmentsFilters>;
  avatarBucketKey?: InputMaybe<CommonBidProductAvatarBucketKeyFilters>;
  avatarBucketKeyPreSignedUrl?: InputMaybe<CommonBidProductAvatarBucketKeyPreSignedUrlFilters>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: InputMaybe<CommonBidProductAvatarBucketKeyPreSignedUrlExpirationDateAtUtcFilters>;
  averageWholesalePrice?: InputMaybe<CommonBidProductAverageWholesalePriceFilters>;
  bidId?: InputMaybe<CommonBidProductBidIdFilters>;
  image?: InputMaybe<CommonBidProductImageFilters>;
  isAnyWholesalerCompatible?: InputMaybe<CommonBidProductIsAnyWholesalerCompatibleFilters>;
  isDirectSupplyCompatible?: InputMaybe<CommonBidProductIsDirectSupplyCompatibleFilters>;
  name?: InputMaybe<CommonBidProductNameFilters>;
  packagingType?: InputMaybe<CommonBidProductPackagingTypeFilters>;
  productCategoryId?: InputMaybe<CommonBidProductProductCategoryIdFilters>;
  productTemplateId?: InputMaybe<CommonBidProductProductTemplateIdFilters>;
  unitType?: InputMaybe<CommonBidProductUnitTypeFilters>;
  unitsPerCase?: InputMaybe<CommonBidProductUnitsPerCaseFilters>;
  url?: InputMaybe<CommonBidProductUrlFilters>;
  volumePerUnit?: InputMaybe<CommonBidProductVolumePerUnitFilters>;
  volumeUnits?: InputMaybe<CommonBidProductVolumeUnitsFilters>;
};

export type CommonBidProductFiltersOr = {
  attachments?: InputMaybe<CommonBidProductAttachmentsFilters>;
  avatarBucketKey?: InputMaybe<CommonBidProductAvatarBucketKeyFilters>;
  avatarBucketKeyPreSignedUrl?: InputMaybe<CommonBidProductAvatarBucketKeyPreSignedUrlFilters>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: InputMaybe<CommonBidProductAvatarBucketKeyPreSignedUrlExpirationDateAtUtcFilters>;
  averageWholesalePrice?: InputMaybe<CommonBidProductAverageWholesalePriceFilters>;
  bidId?: InputMaybe<CommonBidProductBidIdFilters>;
  image?: InputMaybe<CommonBidProductImageFilters>;
  isAnyWholesalerCompatible?: InputMaybe<CommonBidProductIsAnyWholesalerCompatibleFilters>;
  isDirectSupplyCompatible?: InputMaybe<CommonBidProductIsDirectSupplyCompatibleFilters>;
  name?: InputMaybe<CommonBidProductNameFilters>;
  packagingType?: InputMaybe<CommonBidProductPackagingTypeFilters>;
  productCategoryId?: InputMaybe<CommonBidProductProductCategoryIdFilters>;
  productTemplateId?: InputMaybe<CommonBidProductProductTemplateIdFilters>;
  unitType?: InputMaybe<CommonBidProductUnitTypeFilters>;
  unitsPerCase?: InputMaybe<CommonBidProductUnitsPerCaseFilters>;
  url?: InputMaybe<CommonBidProductUrlFilters>;
  volumePerUnit?: InputMaybe<CommonBidProductVolumePerUnitFilters>;
  volumeUnits?: InputMaybe<CommonBidProductVolumeUnitsFilters>;
};

export type CommonBidProductImageFilters = {
  OR?: InputMaybe<Array<CommonBidProductImagefiltersOr>>;
  /** JSON */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductImagefiltersOr = {
  /** JSON */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductInsertInput = {
  attachments?: InputMaybe<Array<S3FileInput>>;
  avatarBucketKey?: InputMaybe<Scalars['String']['input']>;
  avatarBucketKeyPreSignedUrl?: InputMaybe<Scalars['String']['input']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: InputMaybe<Scalars['String']['input']>;
  averageWholesalePrice: Scalars['Float']['input'];
  image?: InputMaybe<S3FileInput>;
  isAnyWholesalerCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  isDirectSupplyCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  packagingType?: InputMaybe<Scalars['String']['input']>;
  productCategoryId: Scalars['Int']['input'];
  productTemplateId?: InputMaybe<Scalars['Int']['input']>;
  unitType?: InputMaybe<Scalars['String']['input']>;
  unitsPerCase?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  volumePerUnit: Scalars['Float']['input'];
};

export type CommonBidProductIsAnyWholesalerCompatibleFilters = {
  OR?: InputMaybe<Array<CommonBidProductIsAnyWholesalerCompatiblefiltersOr>>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductIsAnyWholesalerCompatiblefiltersOr = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductIsDirectSupplyCompatibleFilters = {
  OR?: InputMaybe<Array<CommonBidProductIsDirectSupplyCompatiblefiltersOr>>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductIsDirectSupplyCompatiblefiltersOr = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductItem = {
  __typename?: 'CommonBidProductItem';
  attachments?: Maybe<Array<S3File>>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  averageWholesalePrice: Scalars['Float']['output'];
  bidId: Scalars['Int']['output'];
  image?: Maybe<S3File>;
  isAnyWholesalerCompatible: Scalars['Boolean']['output'];
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  packagingType: Scalars['String']['output'];
  productCategoryId: Scalars['Int']['output'];
  productTemplateId?: Maybe<Scalars['Int']['output']>;
  unitType: Scalars['String']['output'];
  unitsPerCase: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
  volumePerUnit: Scalars['Float']['output'];
  volumeUnits: Scalars['Float']['output'];
};

export type CommonBidProductNameFilters = {
  OR?: InputMaybe<Array<CommonBidProductNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductPackagingTypeFilters = {
  OR?: InputMaybe<Array<CommonBidProductPackagingTypefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductPackagingTypefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductProductCategoryIdFilters = {
  OR?: InputMaybe<Array<CommonBidProductProductCategoryIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductProductCategoryIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductProductTemplateIdFilters = {
  OR?: InputMaybe<Array<CommonBidProductProductTemplateIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductProductTemplateIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductRelation = {
  __typename?: 'CommonBidProductRelation';
  attachments?: Maybe<Array<S3File>>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  averageWholesalePrice: Scalars['Float']['output'];
  bid?: Maybe<CommonBidProductRelationBidRelation>;
  bidId: Scalars['Int']['output'];
  image?: Maybe<S3File>;
  isAnyWholesalerCompatible: Scalars['Boolean']['output'];
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  packagingType: Scalars['String']['output'];
  productCategory?: Maybe<CommonBidProductRelationProductCategoryRelation>;
  productCategoryId: Scalars['Int']['output'];
  productTemplateId?: Maybe<Scalars['Int']['output']>;
  unitType: Scalars['String']['output'];
  unitsPerCase: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
  volumePerUnit: Scalars['Float']['output'];
  volumeUnits: Scalars['Float']['output'];
};


export type CommonBidProductRelationBidArgs = {
  where?: InputMaybe<CommonBidFilters>;
};


export type CommonBidProductRelationProductCategoryArgs = {
  where?: InputMaybe<ProductCategoryFilters>;
};

export type CommonBidProductRelationBidRelation = {
  __typename?: 'CommonBidProductRelationBidRelation';
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  otherSupportAndTerms?: Maybe<Scalars['String']['output']>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  region: CommonBidRegionEnum;
  status: CommonBidStatusEnum;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  type: CommonBidTypeEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type CommonBidProductRelationProductCategoryRelation = {
  __typename?: 'CommonBidProductRelationProductCategoryRelation';
  createdAtUtc: Scalars['String']['output'];
  defaultPackagingType?: Maybe<Scalars['String']['output']>;
  defaultVolume?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isPublished: Scalars['Boolean']['output'];
  localizationKey: Scalars['String']['output'];
  parentCategory?: Maybe<CommonBidProductRelationProductCategoryRelationParentCategoryRelation>;
  parentId?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  regions: Array<CommonBidProductRelationProductCategoryRelationRegionsRelation>;
  subCategories: Array<CommonBidProductRelationProductCategoryRelationSubCategoriesRelation>;
  unit?: Maybe<CommonBidProductRelationProductCategoryRelationUnitRelation>;
  unitType?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};


export type CommonBidProductRelationProductCategoryRelationParentCategoryArgs = {
  where?: InputMaybe<ProductCategoryFilters>;
};


export type CommonBidProductRelationProductCategoryRelationRegionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProductCategoryRegion2OrderBy>;
  where?: InputMaybe<ProductCategoryRegion2Filters>;
};


export type CommonBidProductRelationProductCategoryRelationSubCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProductCategoryOrderBy>;
  where?: InputMaybe<ProductCategoryFilters>;
};


export type CommonBidProductRelationProductCategoryRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};

export type CommonBidProductRelationProductCategoryRelationParentCategoryRelation = {
  __typename?: 'CommonBidProductRelationProductCategoryRelationParentCategoryRelation';
  createdAtUtc: Scalars['String']['output'];
  defaultPackagingType?: Maybe<Scalars['String']['output']>;
  defaultVolume?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isPublished: Scalars['Boolean']['output'];
  localizationKey: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  unitType?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type CommonBidProductRelationProductCategoryRelationRegionsRelation = {
  __typename?: 'CommonBidProductRelationProductCategoryRelationRegionsRelation';
  productCategoryId: Scalars['Int']['output'];
  region: Scalars['String']['output'];
};

export type CommonBidProductRelationProductCategoryRelationSubCategoriesRelation = {
  __typename?: 'CommonBidProductRelationProductCategoryRelationSubCategoriesRelation';
  createdAtUtc: Scalars['String']['output'];
  defaultPackagingType?: Maybe<Scalars['String']['output']>;
  defaultVolume?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isPublished: Scalars['Boolean']['output'];
  localizationKey: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  unitType?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type CommonBidProductRelationProductCategoryRelationUnitRelation = {
  __typename?: 'CommonBidProductRelationProductCategoryRelationUnitRelation';
  type: Scalars['String']['output'];
};

export type CommonBidProductSelectItem = {
  __typename?: 'CommonBidProductSelectItem';
  avatarUrl?: Maybe<Scalars['String']['output']>;
};

export type CommonBidProductUnitTypeFilters = {
  OR?: InputMaybe<Array<CommonBidProductUnitTypefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductUnitTypefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductUnitsPerCaseFilters = {
  OR?: InputMaybe<Array<CommonBidProductUnitsPerCasefiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductUnitsPerCasefiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductUpdateInput = {
  attachments?: InputMaybe<Array<S3FileInput>>;
};

export type CommonBidProductUrlFilters = {
  OR?: InputMaybe<Array<CommonBidProductUrlfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductUrlfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductVolumePerUnitFilters = {
  OR?: InputMaybe<Array<CommonBidProductVolumePerUnitfiltersOr>>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Float']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Float']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductVolumePerUnitfiltersOr = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Float']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Float']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductVolumeUnitsFilters = {
  OR?: InputMaybe<Array<CommonBidProductVolumeUnitsfiltersOr>>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Float']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Float']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidProductVolumeUnitsfiltersOr = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Float']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Float']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidRateInput = {
  bidId: Scalars['NonNegativeInt']['input'];
  rating?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  ratingComment?: InputMaybe<Scalars['String']['input']>;
  ratingOptions: Array<Scalars['NonNegativeInt']['input']>;
};

export type CommonBidRatedAtUtcFilters = {
  OR?: InputMaybe<Array<CommonBidRatedAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidRatedAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidRatingCommentFilters = {
  OR?: InputMaybe<Array<CommonBidRatingCommentfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidRatingCommentfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidRatingFilters = {
  OR?: InputMaybe<Array<CommonBidRatingfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidRatingfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export enum CommonBidRegionEnum {
  /** Value: Australia */
  Australia = 'Australia',
  /** Value: Spain */
  Spain = 'Spain',
  /** Value: UnitedKingdom */
  UnitedKingdom = 'UnitedKingdom'
}

export type CommonBidRegionFilters = {
  OR?: InputMaybe<Array<CommonBidRegionfiltersOr>>;
  eq?: InputMaybe<CommonBidRegionEnum>;
  gt?: InputMaybe<CommonBidRegionEnum>;
  gte?: InputMaybe<CommonBidRegionEnum>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<CommonBidRegionEnum>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<CommonBidRegionEnum>;
  lte?: InputMaybe<CommonBidRegionEnum>;
  ne?: InputMaybe<CommonBidRegionEnum>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<CommonBidRegionEnum>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidRegionfiltersOr = {
  eq?: InputMaybe<CommonBidRegionEnum>;
  gt?: InputMaybe<CommonBidRegionEnum>;
  gte?: InputMaybe<CommonBidRegionEnum>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<CommonBidRegionEnum>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<CommonBidRegionEnum>;
  lte?: InputMaybe<CommonBidRegionEnum>;
  ne?: InputMaybe<CommonBidRegionEnum>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<CommonBidRegionEnum>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidSampleRequestInput = {
  bidId: Scalars['NonNegativeInt']['input'];
  googlePlacesSessionToken: Scalars['NonEmptyString']['input'];
  sampleDeliveryPlaceId: Scalars['NonEmptyString']['input'];
  sampleMessage: Scalars['NonEmptyString']['input'];
  venueId: Scalars['NonNegativeInt']['input'];
};

export type CommonBidSelectItem = {
  __typename?: 'CommonBidSelectItem';
  brand?: Maybe<CommonBidBrandRelation>;
  brandId: Scalars['Int']['output'];
  connectBid?: Maybe<CommonBidConnectBidRelation>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  matchBid?: Maybe<CommonBidMatchBidRelation>;
  otherSupportAndTerms?: Maybe<Scalars['String']['output']>;
  product?: Maybe<CommonBidProductRelation>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  region: CommonBidRegionEnum;
  status: CommonBidStatusEnum;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  supportedWholesalers: Array<CommonBidSupportedWholesalersRelation>;
  supports: Array<CommonBidSupportsRelation>;
  type: CommonBidTypeEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<CommonBidUserRelation>;
  userId: Scalars['Int']['output'];
};


export type CommonBidSelectItemBrandArgs = {
  where?: InputMaybe<BrandFilters>;
};


export type CommonBidSelectItemConnectBidArgs = {
  where?: InputMaybe<ConnectBidFilters>;
};


export type CommonBidSelectItemMatchBidArgs = {
  where?: InputMaybe<MatchBidFilters>;
};


export type CommonBidSelectItemProductArgs = {
  where?: InputMaybe<CommonBidProductFilters>;
};


export type CommonBidSelectItemSupportedWholesalersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CommonBidWholesalerOrderBy>;
  where?: InputMaybe<CommonBidWholesalerFilters>;
};


export type CommonBidSelectItemSupportsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CommonBidSupportOrderBy>;
  where?: InputMaybe<CommonBidSupportFilters>;
};


export type CommonBidSelectItemUserArgs = {
  where?: InputMaybe<UserFilters>;
};

export enum CommonBidSortingOptions {
  RecentlyAdded = 'RecentlyAdded',
  RecentlyUpdated = 'RecentlyUpdated'
}

export enum CommonBidStatusEnum {
  /** Value: CLOSED */
  Closed = 'CLOSED',
  /** Value: DELETED */
  Deleted = 'DELETED',
  /** Value: LOST */
  Lost = 'LOST',
  /** Value: NEW */
  New = 'NEW',
  /** Value: WON */
  Won = 'WON'
}

export type CommonBidStatusFilters = {
  OR?: InputMaybe<Array<CommonBidStatusfiltersOr>>;
  eq?: InputMaybe<CommonBidStatusEnum>;
  gt?: InputMaybe<CommonBidStatusEnum>;
  gte?: InputMaybe<CommonBidStatusEnum>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<CommonBidStatusEnum>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<CommonBidStatusEnum>;
  lte?: InputMaybe<CommonBidStatusEnum>;
  ne?: InputMaybe<CommonBidStatusEnum>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<CommonBidStatusEnum>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidStatusfiltersOr = {
  eq?: InputMaybe<CommonBidStatusEnum>;
  gt?: InputMaybe<CommonBidStatusEnum>;
  gte?: InputMaybe<CommonBidStatusEnum>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<CommonBidStatusEnum>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<CommonBidStatusEnum>;
  lte?: InputMaybe<CommonBidStatusEnum>;
  ne?: InputMaybe<CommonBidStatusEnum>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<CommonBidStatusEnum>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidSubscriptionTierFilters = {
  OR?: InputMaybe<Array<CommonBidSubscriptionTierfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidSubscriptionTierfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidSuccessFeeFilters = {
  OR?: InputMaybe<Array<CommonBidSuccessFeefiltersOr>>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Float']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Float']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidSuccessFeefiltersOr = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Float']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Float']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidSupportAmountFilters = {
  OR?: InputMaybe<Array<CommonBidSupportAmountfiltersOr>>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Float']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Float']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidSupportAmountfiltersOr = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Float']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Float']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidSupportAttachmentsFilters = {
  OR?: InputMaybe<Array<CommonBidSupportAttachmentsfiltersOr>>;
  /** JSON */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidSupportAttachmentsfiltersOr = {
  /** JSON */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidSupportBidIdFilters = {
  OR?: InputMaybe<Array<CommonBidSupportBidIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidSupportBidIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidSupportFilters = {
  OR?: InputMaybe<Array<CommonBidSupportFiltersOr>>;
  amount?: InputMaybe<CommonBidSupportAmountFilters>;
  attachments?: InputMaybe<CommonBidSupportAttachmentsFilters>;
  bidId?: InputMaybe<CommonBidSupportBidIdFilters>;
  id?: InputMaybe<CommonBidSupportIdFilters>;
  isProvided?: InputMaybe<CommonBidSupportIsProvidedFilters>;
  isReceived?: InputMaybe<CommonBidSupportIsReceivedFilters>;
  notes?: InputMaybe<CommonBidSupportNotesFilters>;
  supportType?: InputMaybe<CommonBidSupportSupportTypeFilters>;
};

export type CommonBidSupportFiltersOr = {
  amount?: InputMaybe<CommonBidSupportAmountFilters>;
  attachments?: InputMaybe<CommonBidSupportAttachmentsFilters>;
  bidId?: InputMaybe<CommonBidSupportBidIdFilters>;
  id?: InputMaybe<CommonBidSupportIdFilters>;
  isProvided?: InputMaybe<CommonBidSupportIsProvidedFilters>;
  isReceived?: InputMaybe<CommonBidSupportIsReceivedFilters>;
  notes?: InputMaybe<CommonBidSupportNotesFilters>;
  supportType?: InputMaybe<CommonBidSupportSupportTypeFilters>;
};

export type CommonBidSupportIdFilters = {
  OR?: InputMaybe<Array<CommonBidSupportIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidSupportIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidSupportInsertInput = {
  amount: Scalars['Float']['input'];
  attachments?: InputMaybe<Array<S3FileInput>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  supportType: CommonBidSupportSupportTypeEnum;
};

export type CommonBidSupportIsProvidedFilters = {
  OR?: InputMaybe<Array<CommonBidSupportIsProvidedfiltersOr>>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidSupportIsProvidedfiltersOr = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidSupportIsReceivedFilters = {
  OR?: InputMaybe<Array<CommonBidSupportIsReceivedfiltersOr>>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidSupportIsReceivedfiltersOr = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidSupportItem = {
  __typename?: 'CommonBidSupportItem';
  amount: Scalars['Float']['output'];
  attachments?: Maybe<Array<S3File>>;
  bidId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isProvided: Scalars['Boolean']['output'];
  isReceived: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  supportType: CommonBidSupportSupportTypeEnum;
};

export type CommonBidSupportNotesFilters = {
  OR?: InputMaybe<Array<CommonBidSupportNotesfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidSupportNotesfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidSupportOrderBy = {
  amount?: InputMaybe<InnerOrder>;
  attachments?: InputMaybe<InnerOrder>;
  bidId?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  isProvided?: InputMaybe<InnerOrder>;
  isReceived?: InputMaybe<InnerOrder>;
  notes?: InputMaybe<InnerOrder>;
  supportType?: InputMaybe<InnerOrder>;
};

export enum CommonBidSupportSupportTypeEnum {
  /** Value: DISCOUNT */
  Discount = 'DISCOUNT',
  /** Value: FREE_STOCK */
  FreeStock = 'FREE_STOCK',
  /** Value: LISTING_FEE */
  ListingFee = 'LISTING_FEE',
  /** Value: POS_BUDGET */
  PosBudget = 'POS_BUDGET',
  /** Value: RETRO_DISCOUNT */
  RetroDiscount = 'RETRO_DISCOUNT'
}

export type CommonBidSupportSupportTypeFilters = {
  OR?: InputMaybe<Array<CommonBidSupportSupportTypefiltersOr>>;
  eq?: InputMaybe<CommonBidSupportSupportTypeEnum>;
  gt?: InputMaybe<CommonBidSupportSupportTypeEnum>;
  gte?: InputMaybe<CommonBidSupportSupportTypeEnum>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<CommonBidSupportSupportTypeEnum>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<CommonBidSupportSupportTypeEnum>;
  lte?: InputMaybe<CommonBidSupportSupportTypeEnum>;
  ne?: InputMaybe<CommonBidSupportSupportTypeEnum>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<CommonBidSupportSupportTypeEnum>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidSupportSupportTypefiltersOr = {
  eq?: InputMaybe<CommonBidSupportSupportTypeEnum>;
  gt?: InputMaybe<CommonBidSupportSupportTypeEnum>;
  gte?: InputMaybe<CommonBidSupportSupportTypeEnum>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<CommonBidSupportSupportTypeEnum>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<CommonBidSupportSupportTypeEnum>;
  lte?: InputMaybe<CommonBidSupportSupportTypeEnum>;
  ne?: InputMaybe<CommonBidSupportSupportTypeEnum>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<CommonBidSupportSupportTypeEnum>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidSupportedWholesalersRelation = {
  __typename?: 'CommonBidSupportedWholesalersRelation';
  bid?: Maybe<CommonBidSupportedWholesalersRelationBidRelation>;
  bidId: Scalars['Int']['output'];
  wholesaler?: Maybe<CommonBidSupportedWholesalersRelationWholesalerRelation>;
  wholesalerId: Scalars['Int']['output'];
};


export type CommonBidSupportedWholesalersRelationBidArgs = {
  where?: InputMaybe<CommonBidFilters>;
};


export type CommonBidSupportedWholesalersRelationWholesalerArgs = {
  where?: InputMaybe<WholesalerFilters>;
};

export type CommonBidSupportedWholesalersRelationBidRelation = {
  __typename?: 'CommonBidSupportedWholesalersRelationBidRelation';
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  otherSupportAndTerms?: Maybe<Scalars['String']['output']>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  region: CommonBidRegionEnum;
  status: CommonBidStatusEnum;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  type: CommonBidTypeEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type CommonBidSupportedWholesalersRelationWholesalerRelation = {
  __typename?: 'CommonBidSupportedWholesalersRelationWholesalerRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  region: Scalars['String']['output'];
};

export type CommonBidSupportsRelation = {
  __typename?: 'CommonBidSupportsRelation';
  amount: Scalars['Float']['output'];
  attachments?: Maybe<Array<S3File>>;
  bid?: Maybe<CommonBidSupportsRelationBidRelation>;
  bidId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isProvided: Scalars['Boolean']['output'];
  isReceived: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  supportType: CommonBidSupportSupportTypeEnum;
};


export type CommonBidSupportsRelationBidArgs = {
  where?: InputMaybe<CommonBidFilters>;
};

export type CommonBidSupportsRelationBidRelation = {
  __typename?: 'CommonBidSupportsRelationBidRelation';
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  otherSupportAndTerms?: Maybe<Scalars['String']['output']>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  region: CommonBidRegionEnum;
  status: CommonBidStatusEnum;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  type: CommonBidTypeEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export enum CommonBidType {
  Connect = 'CONNECT',
  Match = 'MATCH'
}

export enum CommonBidTypeEnum {
  /** Value: CONNECT */
  Connect = 'CONNECT',
  /** Value: MATCH */
  Match = 'MATCH'
}

export type CommonBidTypeFilters = {
  OR?: InputMaybe<Array<CommonBidTypefiltersOr>>;
  eq?: InputMaybe<CommonBidTypeEnum>;
  gt?: InputMaybe<CommonBidTypeEnum>;
  gte?: InputMaybe<CommonBidTypeEnum>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<CommonBidTypeEnum>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<CommonBidTypeEnum>;
  lte?: InputMaybe<CommonBidTypeEnum>;
  ne?: InputMaybe<CommonBidTypeEnum>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<CommonBidTypeEnum>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidTypefiltersOr = {
  eq?: InputMaybe<CommonBidTypeEnum>;
  gt?: InputMaybe<CommonBidTypeEnum>;
  gte?: InputMaybe<CommonBidTypeEnum>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<CommonBidTypeEnum>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<CommonBidTypeEnum>;
  lte?: InputMaybe<CommonBidTypeEnum>;
  ne?: InputMaybe<CommonBidTypeEnum>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<CommonBidTypeEnum>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidUpdatedAtUtcFilters = {
  OR?: InputMaybe<Array<CommonBidUpdatedAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidUpdatedAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidUserIdFilters = {
  OR?: InputMaybe<Array<CommonBidUserIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidUserIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidUserRelation = {
  __typename?: 'CommonBidUserRelation';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type CommonBidWholesalerBidIdFilters = {
  OR?: InputMaybe<Array<CommonBidWholesalerBidIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidWholesalerBidIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidWholesalerFilters = {
  OR?: InputMaybe<Array<CommonBidWholesalerFiltersOr>>;
  bidId?: InputMaybe<CommonBidWholesalerBidIdFilters>;
  wholesalerId?: InputMaybe<CommonBidWholesalerWholesalerIdFilters>;
};

export type CommonBidWholesalerFiltersOr = {
  bidId?: InputMaybe<CommonBidWholesalerBidIdFilters>;
  wholesalerId?: InputMaybe<CommonBidWholesalerWholesalerIdFilters>;
};

export type CommonBidWholesalerOrderBy = {
  bidId?: InputMaybe<InnerOrder>;
  wholesalerId?: InputMaybe<InnerOrder>;
};

export type CommonBidWholesalerWholesalerIdFilters = {
  OR?: InputMaybe<Array<CommonBidWholesalerWholesalerIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidWholesalerWholesalerIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type CommonBidsWithPagination = {
  __typename?: 'CommonBidsWithPagination';
  data: Array<CommonBidSelectItem>;
  pageInfo: OffsetPagination;
};

export type CommonBidsWithPaginationWhereInput = {
  brandId?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  customerType?: InputMaybe<Array<Scalars['NonEmptyString']['input']>>;
  listingType?: InputMaybe<Array<Scalars['NonNegativeInt']['input']>>;
  productName?: InputMaybe<Array<Scalars['NonEmptyString']['input']>>;
  region?: InputMaybe<Array<Scalars['NonEmptyString']['input']>>;
  status?: InputMaybe<BidStatus>;
  tenderName?: InputMaybe<Array<Scalars['NonEmptyString']['input']>>;
  type?: InputMaybe<CommonBidType>;
  venueName?: InputMaybe<Array<Scalars['NonEmptyString']['input']>>;
  venueType?: InputMaybe<Array<Scalars['NonEmptyString']['input']>>;
};

export enum CompanyType {
  Brand = 'BRAND',
  Venue = 'VENUE'
}

export type CompanyUser = {
  __typename?: 'CompanyUser';
  role: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type CompanyVatDetails = {
  __typename?: 'CompanyVatDetails';
  vatCompanyName: Scalars['String']['output'];
  vatConsultationNumber: Scalars['String']['output'];
  vatCountryCode: Scalars['String']['output'];
  vatNumber: Scalars['String']['output'];
  vatProcessingDate: Scalars['String']['output'];
};

export type ComputedSupport = {
  __typename?: 'ComputedSupport';
  discount: Scalars['Float']['output'];
  freeStock: Scalars['Float']['output'];
  listingFee: Scalars['Float']['output'];
  marketing: Scalars['Float']['output'];
  retro: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type ConnectBidBidIdFilters = {
  OR?: InputMaybe<Array<ConnectBidBidIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectBidBidIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectBidCommonBidRelation = {
  __typename?: 'ConnectBidCommonBidRelation';
  brand?: Maybe<ConnectBidCommonBidRelationBrandRelation>;
  brandId: Scalars['Int']['output'];
  connectBid?: Maybe<ConnectBidCommonBidRelationConnectBidRelation>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  matchBid?: Maybe<ConnectBidCommonBidRelationMatchBidRelation>;
  otherSupportAndTerms?: Maybe<Scalars['String']['output']>;
  product?: Maybe<ConnectBidCommonBidRelationProductRelation>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  region: CommonBidRegionEnum;
  status: CommonBidStatusEnum;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  supportedWholesalers: Array<ConnectBidCommonBidRelationSupportedWholesalersRelation>;
  supports: Array<ConnectBidCommonBidRelationSupportsRelation>;
  type: CommonBidTypeEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<ConnectBidCommonBidRelationUserRelation>;
  userId: Scalars['Int']['output'];
};


export type ConnectBidCommonBidRelationBrandArgs = {
  where?: InputMaybe<BrandFilters>;
};


export type ConnectBidCommonBidRelationConnectBidArgs = {
  where?: InputMaybe<ConnectBidFilters>;
};


export type ConnectBidCommonBidRelationMatchBidArgs = {
  where?: InputMaybe<MatchBidFilters>;
};


export type ConnectBidCommonBidRelationProductArgs = {
  where?: InputMaybe<CommonBidProductFilters>;
};


export type ConnectBidCommonBidRelationSupportedWholesalersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CommonBidWholesalerOrderBy>;
  where?: InputMaybe<CommonBidWholesalerFilters>;
};


export type ConnectBidCommonBidRelationSupportsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CommonBidSupportOrderBy>;
  where?: InputMaybe<CommonBidSupportFilters>;
};


export type ConnectBidCommonBidRelationUserArgs = {
  where?: InputMaybe<UserFilters>;
};

export type ConnectBidCommonBidRelationBrandRelation = {
  __typename?: 'ConnectBidCommonBidRelationBrandRelation';
  address?: Maybe<ConnectBidCommonBidRelationBrandRelationAddressRelation>;
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  awrsCompanyName?: Maybe<Scalars['String']['output']>;
  awrsDeregistrationDate?: Maybe<Scalars['String']['output']>;
  awrsNumber?: Maybe<Scalars['String']['output']>;
  awrsPlaceBusiness?: Maybe<Scalars['String']['output']>;
  awrsRegistrationDate?: Maybe<Scalars['String']['output']>;
  awrsStatus?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<ConnectBidCommonBidRelationBrandRelationBillingAddressRelation>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  brandIntegrations: Array<ConnectBidCommonBidRelationBrandRelationBrandIntegrationsRelation>;
  brandUsers: Array<ConnectBidCommonBidRelationBrandRelationBrandUsersRelation>;
  canSeeOtherBids?: Maybe<Scalars['Boolean']['output']>;
  complianceCheckDate?: Maybe<Scalars['String']['output']>;
  complianceConfirmation?: Maybe<Scalars['String']['output']>;
  complianceNextDate?: Maybe<Scalars['String']['output']>;
  complianceRiskLevel?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  failedPaymentIntentCounter: Scalars['Int']['output'];
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  isAnonymousBidAllowed?: Maybe<Scalars['Boolean']['output']>;
  isEnterpriseSubscriptionRequestSent?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompany?: Maybe<ConnectBidCommonBidRelationBrandRelationRegisteredCompanyRelation>;
  registeredCompanyId: Scalars['Int']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripePaymentLink?: Maybe<Scalars['String']['output']>;
  stripePaymentLinkHash?: Maybe<Scalars['String']['output']>;
  stripePaymentType?: Maybe<Scalars['String']['output']>;
  stripeProductPriceId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  tradingAddress?: Maybe<ConnectBidCommonBidRelationBrandRelationTradingAddressRelation>;
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  vatCompanyName?: Maybe<Scalars['String']['output']>;
  vatConsultationNumber?: Maybe<Scalars['String']['output']>;
  vatCountryCode?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  vatProcessingDate?: Maybe<Scalars['String']['output']>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};


export type ConnectBidCommonBidRelationBrandRelationAddressArgs = {
  where?: InputMaybe<AddressFilters>;
};


export type ConnectBidCommonBidRelationBrandRelationBillingAddressArgs = {
  where?: InputMaybe<AddressFilters>;
};


export type ConnectBidCommonBidRelationBrandRelationBrandIntegrationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BrandIntegrationsOrderBy>;
  where?: InputMaybe<BrandIntegrationsFilters>;
};


export type ConnectBidCommonBidRelationBrandRelationBrandUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BrandUserOrderBy>;
  where?: InputMaybe<BrandUserFilters>;
};


export type ConnectBidCommonBidRelationBrandRelationRegisteredCompanyArgs = {
  where?: InputMaybe<RegisteredCompanyFilters>;
};


export type ConnectBidCommonBidRelationBrandRelationTradingAddressArgs = {
  where?: InputMaybe<AddressFilters>;
};

export type ConnectBidCommonBidRelationBrandRelationAddressRelation = {
  __typename?: 'ConnectBidCommonBidRelationBrandRelationAddressRelation';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type ConnectBidCommonBidRelationBrandRelationBillingAddressRelation = {
  __typename?: 'ConnectBidCommonBidRelationBrandRelationBillingAddressRelation';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type ConnectBidCommonBidRelationBrandRelationBrandIntegrationsRelation = {
  __typename?: 'ConnectBidCommonBidRelationBrandRelationBrandIntegrationsRelation';
  brand?: Maybe<ConnectBidCommonBidRelationBrandRelationBrandIntegrationsRelationBrandRelation>;
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  externalCompanyId: Scalars['String']['output'];
  externalUserId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  integrationType: BrandIntegrationsIntegrationTypeEnum;
  /** JSON */
  metadata?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<ConnectBidCommonBidRelationBrandRelationBrandIntegrationsRelationUserRelation>;
  userId: Scalars['Int']['output'];
};


export type ConnectBidCommonBidRelationBrandRelationBrandIntegrationsRelationBrandArgs = {
  where?: InputMaybe<BrandFilters>;
};


export type ConnectBidCommonBidRelationBrandRelationBrandIntegrationsRelationUserArgs = {
  where?: InputMaybe<UserFilters>;
};

export type ConnectBidCommonBidRelationBrandRelationBrandIntegrationsRelationBrandRelation = {
  __typename?: 'ConnectBidCommonBidRelationBrandRelationBrandIntegrationsRelationBrandRelation';
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  awrsCompanyName?: Maybe<Scalars['String']['output']>;
  awrsDeregistrationDate?: Maybe<Scalars['String']['output']>;
  awrsNumber?: Maybe<Scalars['String']['output']>;
  awrsPlaceBusiness?: Maybe<Scalars['String']['output']>;
  awrsRegistrationDate?: Maybe<Scalars['String']['output']>;
  awrsStatus?: Maybe<Scalars['String']['output']>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  canSeeOtherBids?: Maybe<Scalars['Boolean']['output']>;
  complianceCheckDate?: Maybe<Scalars['String']['output']>;
  complianceConfirmation?: Maybe<Scalars['String']['output']>;
  complianceNextDate?: Maybe<Scalars['String']['output']>;
  complianceRiskLevel?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  failedPaymentIntentCounter: Scalars['Int']['output'];
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  isAnonymousBidAllowed?: Maybe<Scalars['Boolean']['output']>;
  isEnterpriseSubscriptionRequestSent?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompanyId: Scalars['Int']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripePaymentLink?: Maybe<Scalars['String']['output']>;
  stripePaymentLinkHash?: Maybe<Scalars['String']['output']>;
  stripePaymentType?: Maybe<Scalars['String']['output']>;
  stripeProductPriceId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  vatCompanyName?: Maybe<Scalars['String']['output']>;
  vatConsultationNumber?: Maybe<Scalars['String']['output']>;
  vatCountryCode?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  vatProcessingDate?: Maybe<Scalars['String']['output']>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};

export type ConnectBidCommonBidRelationBrandRelationBrandIntegrationsRelationUserRelation = {
  __typename?: 'ConnectBidCommonBidRelationBrandRelationBrandIntegrationsRelationUserRelation';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type ConnectBidCommonBidRelationBrandRelationBrandUsersRelation = {
  __typename?: 'ConnectBidCommonBidRelationBrandRelationBrandUsersRelation';
  brand?: Maybe<ConnectBidCommonBidRelationBrandRelationBrandUsersRelationBrandRelation>;
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  role: BrandUserRoleEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<ConnectBidCommonBidRelationBrandRelationBrandUsersRelationUserRelation>;
  userId: Scalars['Int']['output'];
};


export type ConnectBidCommonBidRelationBrandRelationBrandUsersRelationBrandArgs = {
  where?: InputMaybe<BrandFilters>;
};


export type ConnectBidCommonBidRelationBrandRelationBrandUsersRelationUserArgs = {
  where?: InputMaybe<UserFilters>;
};

export type ConnectBidCommonBidRelationBrandRelationBrandUsersRelationBrandRelation = {
  __typename?: 'ConnectBidCommonBidRelationBrandRelationBrandUsersRelationBrandRelation';
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  awrsCompanyName?: Maybe<Scalars['String']['output']>;
  awrsDeregistrationDate?: Maybe<Scalars['String']['output']>;
  awrsNumber?: Maybe<Scalars['String']['output']>;
  awrsPlaceBusiness?: Maybe<Scalars['String']['output']>;
  awrsRegistrationDate?: Maybe<Scalars['String']['output']>;
  awrsStatus?: Maybe<Scalars['String']['output']>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  canSeeOtherBids?: Maybe<Scalars['Boolean']['output']>;
  complianceCheckDate?: Maybe<Scalars['String']['output']>;
  complianceConfirmation?: Maybe<Scalars['String']['output']>;
  complianceNextDate?: Maybe<Scalars['String']['output']>;
  complianceRiskLevel?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  failedPaymentIntentCounter: Scalars['Int']['output'];
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  isAnonymousBidAllowed?: Maybe<Scalars['Boolean']['output']>;
  isEnterpriseSubscriptionRequestSent?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompanyId: Scalars['Int']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripePaymentLink?: Maybe<Scalars['String']['output']>;
  stripePaymentLinkHash?: Maybe<Scalars['String']['output']>;
  stripePaymentType?: Maybe<Scalars['String']['output']>;
  stripeProductPriceId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  vatCompanyName?: Maybe<Scalars['String']['output']>;
  vatConsultationNumber?: Maybe<Scalars['String']['output']>;
  vatCountryCode?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  vatProcessingDate?: Maybe<Scalars['String']['output']>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};

export type ConnectBidCommonBidRelationBrandRelationBrandUsersRelationUserRelation = {
  __typename?: 'ConnectBidCommonBidRelationBrandRelationBrandUsersRelationUserRelation';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type ConnectBidCommonBidRelationBrandRelationRegisteredCompanyRelation = {
  __typename?: 'ConnectBidCommonBidRelationBrandRelationRegisteredCompanyRelation';
  addressId?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  dateOfCreation?: Maybe<Scalars['String']['output']>;
  firstAddressLine?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  secondAddressLine?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type ConnectBidCommonBidRelationBrandRelationTradingAddressRelation = {
  __typename?: 'ConnectBidCommonBidRelationBrandRelationTradingAddressRelation';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type ConnectBidCommonBidRelationConnectBidRelation = {
  __typename?: 'ConnectBidCommonBidRelationConnectBidRelation';
  bidId: Scalars['Int']['output'];
  matchBidId?: Maybe<Scalars['Int']['output']>;
  tenderId: Scalars['Int']['output'];
};

export type ConnectBidCommonBidRelationMatchBidRelation = {
  __typename?: 'ConnectBidCommonBidRelationMatchBidRelation';
  autoTenderBid?: Maybe<Scalars['Boolean']['output']>;
  bidId: Scalars['Int']['output'];
  commonBid?: Maybe<ConnectBidCommonBidRelationMatchBidRelationCommonBidRelation>;
  credit?: Maybe<Scalars['Boolean']['output']>;
  listingLength: Scalars['Int']['output'];
  maximumAcceptedDeals: Scalars['Int']['output'];
  product?: Maybe<ConnectBidCommonBidRelationMatchBidRelationProductRelation>;
  venueCriteria?: Maybe<ConnectBidCommonBidRelationMatchBidRelationVenueCriteriaRelation>;
};


export type ConnectBidCommonBidRelationMatchBidRelationCommonBidArgs = {
  where?: InputMaybe<CommonBidFilters>;
};


export type ConnectBidCommonBidRelationMatchBidRelationProductArgs = {
  where?: InputMaybe<MatchBidProductFilters>;
};


export type ConnectBidCommonBidRelationMatchBidRelationVenueCriteriaArgs = {
  where?: InputMaybe<MatchBidVenueCriteriaFilters>;
};

export type ConnectBidCommonBidRelationMatchBidRelationCommonBidRelation = {
  __typename?: 'ConnectBidCommonBidRelationMatchBidRelationCommonBidRelation';
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  otherSupportAndTerms?: Maybe<Scalars['String']['output']>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  region: CommonBidRegionEnum;
  status: CommonBidStatusEnum;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  type: CommonBidTypeEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type ConnectBidCommonBidRelationMatchBidRelationProductRelation = {
  __typename?: 'ConnectBidCommonBidRelationMatchBidRelationProductRelation';
  bid?: Maybe<ConnectBidCommonBidRelationMatchBidRelationProductRelationBidRelation>;
  bidId: Scalars['Int']['output'];
  commonProduct?: Maybe<ConnectBidCommonBidRelationMatchBidRelationProductRelationCommonProductRelation>;
  externalProductId?: Maybe<Scalars['String']['output']>;
  externalProvider?: Maybe<MatchBidProductExternalProviderEnum>;
  productId: Scalars['Int']['output'];
};


export type ConnectBidCommonBidRelationMatchBidRelationProductRelationBidArgs = {
  where?: InputMaybe<MatchBidFilters>;
};


export type ConnectBidCommonBidRelationMatchBidRelationProductRelationCommonProductArgs = {
  where?: InputMaybe<CommonBidProductFilters>;
};

export type ConnectBidCommonBidRelationMatchBidRelationProductRelationBidRelation = {
  __typename?: 'ConnectBidCommonBidRelationMatchBidRelationProductRelationBidRelation';
  autoTenderBid?: Maybe<Scalars['Boolean']['output']>;
  bidId: Scalars['Int']['output'];
  credit?: Maybe<Scalars['Boolean']['output']>;
  listingLength: Scalars['Int']['output'];
  maximumAcceptedDeals: Scalars['Int']['output'];
};

export type ConnectBidCommonBidRelationMatchBidRelationProductRelationCommonProductRelation = {
  __typename?: 'ConnectBidCommonBidRelationMatchBidRelationProductRelationCommonProductRelation';
  /** JSON */
  attachments?: Maybe<Scalars['String']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  averageWholesalePrice: Scalars['Float']['output'];
  bidId: Scalars['Int']['output'];
  /** JSON */
  image?: Maybe<Scalars['String']['output']>;
  isAnyWholesalerCompatible: Scalars['Boolean']['output'];
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  packagingType: Scalars['String']['output'];
  productCategoryId: Scalars['Int']['output'];
  productTemplateId?: Maybe<Scalars['Int']['output']>;
  unitType: Scalars['String']['output'];
  unitsPerCase: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
  volumePerUnit: Scalars['Float']['output'];
  volumeUnits: Scalars['Float']['output'];
};

export type ConnectBidCommonBidRelationMatchBidRelationVenueCriteriaRelation = {
  __typename?: 'ConnectBidCommonBidRelationMatchBidRelationVenueCriteriaRelation';
  bid?: Maybe<ConnectBidCommonBidRelationMatchBidRelationVenueCriteriaRelationBidRelation>;
  bidId: Scalars['Int']['output'];
  capturedTargetedVenues?: Maybe<Scalars['Int']['output']>;
  /** JSON */
  customerTypes?: Maybe<Scalars['String']['output']>;
  listingType?: Maybe<ConnectBidCommonBidRelationMatchBidRelationVenueCriteriaRelationListingTypeRelation>;
  listingTypeId: Scalars['Int']['output'];
  /** JSON */
  loyaltyLevels?: Maybe<Scalars['String']['output']>;
  minimumVolume: Scalars['Int']['output'];
  /** JSON */
  regions?: Maybe<Scalars['String']['output']>;
  targetProductCategory?: Maybe<Scalars['Int']['output']>;
  /** JSON */
  venueTypes?: Maybe<Scalars['String']['output']>;
};


export type ConnectBidCommonBidRelationMatchBidRelationVenueCriteriaRelationBidArgs = {
  where?: InputMaybe<MatchBidFilters>;
};


export type ConnectBidCommonBidRelationMatchBidRelationVenueCriteriaRelationListingTypeArgs = {
  where?: InputMaybe<ListingTypeFilters>;
};

export type ConnectBidCommonBidRelationMatchBidRelationVenueCriteriaRelationBidRelation = {
  __typename?: 'ConnectBidCommonBidRelationMatchBidRelationVenueCriteriaRelationBidRelation';
  autoTenderBid?: Maybe<Scalars['Boolean']['output']>;
  bidId: Scalars['Int']['output'];
  credit?: Maybe<Scalars['Boolean']['output']>;
  listingLength: Scalars['Int']['output'];
  maximumAcceptedDeals: Scalars['Int']['output'];
};

export type ConnectBidCommonBidRelationMatchBidRelationVenueCriteriaRelationListingTypeRelation = {
  __typename?: 'ConnectBidCommonBidRelationMatchBidRelationVenueCriteriaRelationListingTypeRelation';
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  localizationKey: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  region?: Maybe<Scalars['String']['output']>;
  suggestedListingLengthInMonths: Scalars['Int']['output'];
  suggestedTenderLengthInMonths: Scalars['Int']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type ConnectBidCommonBidRelationProductRelation = {
  __typename?: 'ConnectBidCommonBidRelationProductRelation';
  attachments?: Maybe<Array<S3File>>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  averageWholesalePrice: Scalars['Float']['output'];
  bid?: Maybe<ConnectBidCommonBidRelationProductRelationBidRelation>;
  bidId: Scalars['Int']['output'];
  image?: Maybe<S3File>;
  isAnyWholesalerCompatible: Scalars['Boolean']['output'];
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  packagingType: Scalars['String']['output'];
  productCategory?: Maybe<ConnectBidCommonBidRelationProductRelationProductCategoryRelation>;
  productCategoryId: Scalars['Int']['output'];
  productTemplateId?: Maybe<Scalars['Int']['output']>;
  unitType: Scalars['String']['output'];
  unitsPerCase: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
  volumePerUnit: Scalars['Float']['output'];
  volumeUnits: Scalars['Float']['output'];
};


export type ConnectBidCommonBidRelationProductRelationBidArgs = {
  where?: InputMaybe<CommonBidFilters>;
};


export type ConnectBidCommonBidRelationProductRelationProductCategoryArgs = {
  where?: InputMaybe<ProductCategoryFilters>;
};

export type ConnectBidCommonBidRelationProductRelationBidRelation = {
  __typename?: 'ConnectBidCommonBidRelationProductRelationBidRelation';
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  otherSupportAndTerms?: Maybe<Scalars['String']['output']>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  region: CommonBidRegionEnum;
  status: CommonBidStatusEnum;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  type: CommonBidTypeEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type ConnectBidCommonBidRelationProductRelationProductCategoryRelation = {
  __typename?: 'ConnectBidCommonBidRelationProductRelationProductCategoryRelation';
  createdAtUtc: Scalars['String']['output'];
  defaultPackagingType?: Maybe<Scalars['String']['output']>;
  defaultVolume?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isPublished: Scalars['Boolean']['output'];
  localizationKey: Scalars['String']['output'];
  parentCategory?: Maybe<ConnectBidCommonBidRelationProductRelationProductCategoryRelationParentCategoryRelation>;
  parentId?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  regions: Array<ConnectBidCommonBidRelationProductRelationProductCategoryRelationRegionsRelation>;
  subCategories: Array<ConnectBidCommonBidRelationProductRelationProductCategoryRelationSubCategoriesRelation>;
  unit?: Maybe<ConnectBidCommonBidRelationProductRelationProductCategoryRelationUnitRelation>;
  unitType?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};


export type ConnectBidCommonBidRelationProductRelationProductCategoryRelationParentCategoryArgs = {
  where?: InputMaybe<ProductCategoryFilters>;
};


export type ConnectBidCommonBidRelationProductRelationProductCategoryRelationRegionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProductCategoryRegion2OrderBy>;
  where?: InputMaybe<ProductCategoryRegion2Filters>;
};


export type ConnectBidCommonBidRelationProductRelationProductCategoryRelationSubCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProductCategoryOrderBy>;
  where?: InputMaybe<ProductCategoryFilters>;
};


export type ConnectBidCommonBidRelationProductRelationProductCategoryRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};

export type ConnectBidCommonBidRelationProductRelationProductCategoryRelationParentCategoryRelation = {
  __typename?: 'ConnectBidCommonBidRelationProductRelationProductCategoryRelationParentCategoryRelation';
  createdAtUtc: Scalars['String']['output'];
  defaultPackagingType?: Maybe<Scalars['String']['output']>;
  defaultVolume?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isPublished: Scalars['Boolean']['output'];
  localizationKey: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  unitType?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type ConnectBidCommonBidRelationProductRelationProductCategoryRelationRegionsRelation = {
  __typename?: 'ConnectBidCommonBidRelationProductRelationProductCategoryRelationRegionsRelation';
  productCategoryId: Scalars['Int']['output'];
  region: Scalars['String']['output'];
};

export type ConnectBidCommonBidRelationProductRelationProductCategoryRelationSubCategoriesRelation = {
  __typename?: 'ConnectBidCommonBidRelationProductRelationProductCategoryRelationSubCategoriesRelation';
  createdAtUtc: Scalars['String']['output'];
  defaultPackagingType?: Maybe<Scalars['String']['output']>;
  defaultVolume?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isPublished: Scalars['Boolean']['output'];
  localizationKey: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  unitType?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type ConnectBidCommonBidRelationProductRelationProductCategoryRelationUnitRelation = {
  __typename?: 'ConnectBidCommonBidRelationProductRelationProductCategoryRelationUnitRelation';
  type: Scalars['String']['output'];
};

export type ConnectBidCommonBidRelationSupportedWholesalersRelation = {
  __typename?: 'ConnectBidCommonBidRelationSupportedWholesalersRelation';
  bid?: Maybe<ConnectBidCommonBidRelationSupportedWholesalersRelationBidRelation>;
  bidId: Scalars['Int']['output'];
  wholesaler?: Maybe<ConnectBidCommonBidRelationSupportedWholesalersRelationWholesalerRelation>;
  wholesalerId: Scalars['Int']['output'];
};


export type ConnectBidCommonBidRelationSupportedWholesalersRelationBidArgs = {
  where?: InputMaybe<CommonBidFilters>;
};


export type ConnectBidCommonBidRelationSupportedWholesalersRelationWholesalerArgs = {
  where?: InputMaybe<WholesalerFilters>;
};

export type ConnectBidCommonBidRelationSupportedWholesalersRelationBidRelation = {
  __typename?: 'ConnectBidCommonBidRelationSupportedWholesalersRelationBidRelation';
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  otherSupportAndTerms?: Maybe<Scalars['String']['output']>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  region: CommonBidRegionEnum;
  status: CommonBidStatusEnum;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  type: CommonBidTypeEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type ConnectBidCommonBidRelationSupportedWholesalersRelationWholesalerRelation = {
  __typename?: 'ConnectBidCommonBidRelationSupportedWholesalersRelationWholesalerRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  region: Scalars['String']['output'];
};

export type ConnectBidCommonBidRelationSupportsRelation = {
  __typename?: 'ConnectBidCommonBidRelationSupportsRelation';
  amount: Scalars['Float']['output'];
  attachments?: Maybe<Array<S3File>>;
  bid?: Maybe<ConnectBidCommonBidRelationSupportsRelationBidRelation>;
  bidId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isProvided: Scalars['Boolean']['output'];
  isReceived: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  supportType: CommonBidSupportSupportTypeEnum;
};


export type ConnectBidCommonBidRelationSupportsRelationBidArgs = {
  where?: InputMaybe<CommonBidFilters>;
};

export type ConnectBidCommonBidRelationSupportsRelationBidRelation = {
  __typename?: 'ConnectBidCommonBidRelationSupportsRelationBidRelation';
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  otherSupportAndTerms?: Maybe<Scalars['String']['output']>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  region: CommonBidRegionEnum;
  status: CommonBidStatusEnum;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  type: CommonBidTypeEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type ConnectBidCommonBidRelationUserRelation = {
  __typename?: 'ConnectBidCommonBidRelationUserRelation';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type ConnectBidFilters = {
  OR?: InputMaybe<Array<ConnectBidFiltersOr>>;
  bidId?: InputMaybe<ConnectBidBidIdFilters>;
  matchBidId?: InputMaybe<ConnectBidMatchBidIdFilters>;
  tenderId?: InputMaybe<ConnectBidTenderIdFilters>;
};

export type ConnectBidFiltersOr = {
  bidId?: InputMaybe<ConnectBidBidIdFilters>;
  matchBidId?: InputMaybe<ConnectBidMatchBidIdFilters>;
  tenderId?: InputMaybe<ConnectBidTenderIdFilters>;
};

export type ConnectBidInsertInput = {
  brandId: Scalars['Int']['input'];
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  matchBidId?: InputMaybe<Scalars['Int']['input']>;
  otherSupportAndTerms?: InputMaybe<Scalars['String']['input']>;
  product: CommonBidProductInsertInput;
  subscriptionTier?: InputMaybe<Scalars['String']['input']>;
  supportedWholesalersIds?: InputMaybe<Array<Scalars['NonNegativeInt']['input']>>;
  supports: Array<CommonBidSupportInsertInput>;
  tenderId: Scalars['Int']['input'];
};

export type ConnectBidItem = {
  __typename?: 'ConnectBidItem';
  bidId: Scalars['Int']['output'];
  matchBidId?: Maybe<Scalars['Int']['output']>;
  messageCount: Scalars['Int']['output'];
  tenderId: Scalars['Int']['output'];
};

export type ConnectBidMatchBidIdFilters = {
  OR?: InputMaybe<Array<ConnectBidMatchBidIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectBidMatchBidIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectBidMatchBidRelation = {
  __typename?: 'ConnectBidMatchBidRelation';
  autoTenderBid?: Maybe<Scalars['Boolean']['output']>;
  bidId: Scalars['Int']['output'];
  commonBid?: Maybe<ConnectBidMatchBidRelationCommonBidRelation>;
  credit?: Maybe<Scalars['Boolean']['output']>;
  listingLength: Scalars['Int']['output'];
  maximumAcceptedDeals: Scalars['Int']['output'];
  product?: Maybe<ConnectBidMatchBidRelationProductRelation>;
  venueCriteria?: Maybe<ConnectBidMatchBidRelationVenueCriteriaRelation>;
};


export type ConnectBidMatchBidRelationCommonBidArgs = {
  where?: InputMaybe<CommonBidFilters>;
};


export type ConnectBidMatchBidRelationProductArgs = {
  where?: InputMaybe<MatchBidProductFilters>;
};


export type ConnectBidMatchBidRelationVenueCriteriaArgs = {
  where?: InputMaybe<MatchBidVenueCriteriaFilters>;
};

export type ConnectBidMatchBidRelationCommonBidRelation = {
  __typename?: 'ConnectBidMatchBidRelationCommonBidRelation';
  brand?: Maybe<ConnectBidMatchBidRelationCommonBidRelationBrandRelation>;
  brandId: Scalars['Int']['output'];
  connectBid?: Maybe<ConnectBidMatchBidRelationCommonBidRelationConnectBidRelation>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  matchBid?: Maybe<ConnectBidMatchBidRelationCommonBidRelationMatchBidRelation>;
  otherSupportAndTerms?: Maybe<Scalars['String']['output']>;
  product?: Maybe<ConnectBidMatchBidRelationCommonBidRelationProductRelation>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  region: CommonBidRegionEnum;
  status: CommonBidStatusEnum;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  supportedWholesalers: Array<ConnectBidMatchBidRelationCommonBidRelationSupportedWholesalersRelation>;
  supports: Array<ConnectBidMatchBidRelationCommonBidRelationSupportsRelation>;
  type: CommonBidTypeEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<ConnectBidMatchBidRelationCommonBidRelationUserRelation>;
  userId: Scalars['Int']['output'];
};


export type ConnectBidMatchBidRelationCommonBidRelationBrandArgs = {
  where?: InputMaybe<BrandFilters>;
};


export type ConnectBidMatchBidRelationCommonBidRelationConnectBidArgs = {
  where?: InputMaybe<ConnectBidFilters>;
};


export type ConnectBidMatchBidRelationCommonBidRelationMatchBidArgs = {
  where?: InputMaybe<MatchBidFilters>;
};


export type ConnectBidMatchBidRelationCommonBidRelationProductArgs = {
  where?: InputMaybe<CommonBidProductFilters>;
};


export type ConnectBidMatchBidRelationCommonBidRelationSupportedWholesalersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CommonBidWholesalerOrderBy>;
  where?: InputMaybe<CommonBidWholesalerFilters>;
};


export type ConnectBidMatchBidRelationCommonBidRelationSupportsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CommonBidSupportOrderBy>;
  where?: InputMaybe<CommonBidSupportFilters>;
};


export type ConnectBidMatchBidRelationCommonBidRelationUserArgs = {
  where?: InputMaybe<UserFilters>;
};

export type ConnectBidMatchBidRelationCommonBidRelationBrandRelation = {
  __typename?: 'ConnectBidMatchBidRelationCommonBidRelationBrandRelation';
  address?: Maybe<ConnectBidMatchBidRelationCommonBidRelationBrandRelationAddressRelation>;
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  awrsCompanyName?: Maybe<Scalars['String']['output']>;
  awrsDeregistrationDate?: Maybe<Scalars['String']['output']>;
  awrsNumber?: Maybe<Scalars['String']['output']>;
  awrsPlaceBusiness?: Maybe<Scalars['String']['output']>;
  awrsRegistrationDate?: Maybe<Scalars['String']['output']>;
  awrsStatus?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<ConnectBidMatchBidRelationCommonBidRelationBrandRelationBillingAddressRelation>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  brandIntegrations: Array<ConnectBidMatchBidRelationCommonBidRelationBrandRelationBrandIntegrationsRelation>;
  brandUsers: Array<ConnectBidMatchBidRelationCommonBidRelationBrandRelationBrandUsersRelation>;
  canSeeOtherBids?: Maybe<Scalars['Boolean']['output']>;
  complianceCheckDate?: Maybe<Scalars['String']['output']>;
  complianceConfirmation?: Maybe<Scalars['String']['output']>;
  complianceNextDate?: Maybe<Scalars['String']['output']>;
  complianceRiskLevel?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  failedPaymentIntentCounter: Scalars['Int']['output'];
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  isAnonymousBidAllowed?: Maybe<Scalars['Boolean']['output']>;
  isEnterpriseSubscriptionRequestSent?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompany?: Maybe<ConnectBidMatchBidRelationCommonBidRelationBrandRelationRegisteredCompanyRelation>;
  registeredCompanyId: Scalars['Int']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripePaymentLink?: Maybe<Scalars['String']['output']>;
  stripePaymentLinkHash?: Maybe<Scalars['String']['output']>;
  stripePaymentType?: Maybe<Scalars['String']['output']>;
  stripeProductPriceId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  tradingAddress?: Maybe<ConnectBidMatchBidRelationCommonBidRelationBrandRelationTradingAddressRelation>;
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  vatCompanyName?: Maybe<Scalars['String']['output']>;
  vatConsultationNumber?: Maybe<Scalars['String']['output']>;
  vatCountryCode?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  vatProcessingDate?: Maybe<Scalars['String']['output']>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};


export type ConnectBidMatchBidRelationCommonBidRelationBrandRelationAddressArgs = {
  where?: InputMaybe<AddressFilters>;
};


export type ConnectBidMatchBidRelationCommonBidRelationBrandRelationBillingAddressArgs = {
  where?: InputMaybe<AddressFilters>;
};


export type ConnectBidMatchBidRelationCommonBidRelationBrandRelationBrandIntegrationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BrandIntegrationsOrderBy>;
  where?: InputMaybe<BrandIntegrationsFilters>;
};


export type ConnectBidMatchBidRelationCommonBidRelationBrandRelationBrandUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BrandUserOrderBy>;
  where?: InputMaybe<BrandUserFilters>;
};


export type ConnectBidMatchBidRelationCommonBidRelationBrandRelationRegisteredCompanyArgs = {
  where?: InputMaybe<RegisteredCompanyFilters>;
};


export type ConnectBidMatchBidRelationCommonBidRelationBrandRelationTradingAddressArgs = {
  where?: InputMaybe<AddressFilters>;
};

export type ConnectBidMatchBidRelationCommonBidRelationBrandRelationAddressRelation = {
  __typename?: 'ConnectBidMatchBidRelationCommonBidRelationBrandRelationAddressRelation';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type ConnectBidMatchBidRelationCommonBidRelationBrandRelationBillingAddressRelation = {
  __typename?: 'ConnectBidMatchBidRelationCommonBidRelationBrandRelationBillingAddressRelation';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type ConnectBidMatchBidRelationCommonBidRelationBrandRelationBrandIntegrationsRelation = {
  __typename?: 'ConnectBidMatchBidRelationCommonBidRelationBrandRelationBrandIntegrationsRelation';
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  externalCompanyId: Scalars['String']['output'];
  externalUserId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  integrationType: BrandIntegrationsIntegrationTypeEnum;
  /** JSON */
  metadata?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type ConnectBidMatchBidRelationCommonBidRelationBrandRelationBrandUsersRelation = {
  __typename?: 'ConnectBidMatchBidRelationCommonBidRelationBrandRelationBrandUsersRelation';
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  role: BrandUserRoleEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type ConnectBidMatchBidRelationCommonBidRelationBrandRelationRegisteredCompanyRelation = {
  __typename?: 'ConnectBidMatchBidRelationCommonBidRelationBrandRelationRegisteredCompanyRelation';
  addressId?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  dateOfCreation?: Maybe<Scalars['String']['output']>;
  firstAddressLine?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  secondAddressLine?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type ConnectBidMatchBidRelationCommonBidRelationBrandRelationTradingAddressRelation = {
  __typename?: 'ConnectBidMatchBidRelationCommonBidRelationBrandRelationTradingAddressRelation';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type ConnectBidMatchBidRelationCommonBidRelationConnectBidRelation = {
  __typename?: 'ConnectBidMatchBidRelationCommonBidRelationConnectBidRelation';
  bidId: Scalars['Int']['output'];
  matchBidId?: Maybe<Scalars['Int']['output']>;
  tenderId: Scalars['Int']['output'];
};

export type ConnectBidMatchBidRelationCommonBidRelationMatchBidRelation = {
  __typename?: 'ConnectBidMatchBidRelationCommonBidRelationMatchBidRelation';
  autoTenderBid?: Maybe<Scalars['Boolean']['output']>;
  bidId: Scalars['Int']['output'];
  credit?: Maybe<Scalars['Boolean']['output']>;
  listingLength: Scalars['Int']['output'];
  maximumAcceptedDeals: Scalars['Int']['output'];
};

export type ConnectBidMatchBidRelationCommonBidRelationProductRelation = {
  __typename?: 'ConnectBidMatchBidRelationCommonBidRelationProductRelation';
  /** JSON */
  attachments?: Maybe<Scalars['String']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  averageWholesalePrice: Scalars['Float']['output'];
  bid?: Maybe<ConnectBidMatchBidRelationCommonBidRelationProductRelationBidRelation>;
  bidId: Scalars['Int']['output'];
  /** JSON */
  image?: Maybe<Scalars['String']['output']>;
  isAnyWholesalerCompatible: Scalars['Boolean']['output'];
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  packagingType: Scalars['String']['output'];
  productCategory?: Maybe<ConnectBidMatchBidRelationCommonBidRelationProductRelationProductCategoryRelation>;
  productCategoryId: Scalars['Int']['output'];
  productTemplateId?: Maybe<Scalars['Int']['output']>;
  unitType: Scalars['String']['output'];
  unitsPerCase: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
  volumePerUnit: Scalars['Float']['output'];
  volumeUnits: Scalars['Float']['output'];
};


export type ConnectBidMatchBidRelationCommonBidRelationProductRelationBidArgs = {
  where?: InputMaybe<CommonBidFilters>;
};


export type ConnectBidMatchBidRelationCommonBidRelationProductRelationProductCategoryArgs = {
  where?: InputMaybe<ProductCategoryFilters>;
};

export type ConnectBidMatchBidRelationCommonBidRelationProductRelationBidRelation = {
  __typename?: 'ConnectBidMatchBidRelationCommonBidRelationProductRelationBidRelation';
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  otherSupportAndTerms?: Maybe<Scalars['String']['output']>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  region: CommonBidRegionEnum;
  status: CommonBidStatusEnum;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  type: CommonBidTypeEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type ConnectBidMatchBidRelationCommonBidRelationProductRelationProductCategoryRelation = {
  __typename?: 'ConnectBidMatchBidRelationCommonBidRelationProductRelationProductCategoryRelation';
  createdAtUtc: Scalars['String']['output'];
  defaultPackagingType?: Maybe<Scalars['String']['output']>;
  defaultVolume?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isPublished: Scalars['Boolean']['output'];
  localizationKey: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  unitType?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type ConnectBidMatchBidRelationCommonBidRelationSupportedWholesalersRelation = {
  __typename?: 'ConnectBidMatchBidRelationCommonBidRelationSupportedWholesalersRelation';
  bid?: Maybe<ConnectBidMatchBidRelationCommonBidRelationSupportedWholesalersRelationBidRelation>;
  bidId: Scalars['Int']['output'];
  wholesaler?: Maybe<ConnectBidMatchBidRelationCommonBidRelationSupportedWholesalersRelationWholesalerRelation>;
  wholesalerId: Scalars['Int']['output'];
};


export type ConnectBidMatchBidRelationCommonBidRelationSupportedWholesalersRelationBidArgs = {
  where?: InputMaybe<CommonBidFilters>;
};


export type ConnectBidMatchBidRelationCommonBidRelationSupportedWholesalersRelationWholesalerArgs = {
  where?: InputMaybe<WholesalerFilters>;
};

export type ConnectBidMatchBidRelationCommonBidRelationSupportedWholesalersRelationBidRelation = {
  __typename?: 'ConnectBidMatchBidRelationCommonBidRelationSupportedWholesalersRelationBidRelation';
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  otherSupportAndTerms?: Maybe<Scalars['String']['output']>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  region: CommonBidRegionEnum;
  status: CommonBidStatusEnum;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  type: CommonBidTypeEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type ConnectBidMatchBidRelationCommonBidRelationSupportedWholesalersRelationWholesalerRelation = {
  __typename?: 'ConnectBidMatchBidRelationCommonBidRelationSupportedWholesalersRelationWholesalerRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  region: Scalars['String']['output'];
};

export type ConnectBidMatchBidRelationCommonBidRelationSupportsRelation = {
  __typename?: 'ConnectBidMatchBidRelationCommonBidRelationSupportsRelation';
  amount: Scalars['Float']['output'];
  /** JSON */
  attachments?: Maybe<Scalars['String']['output']>;
  bid?: Maybe<ConnectBidMatchBidRelationCommonBidRelationSupportsRelationBidRelation>;
  bidId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isProvided: Scalars['Boolean']['output'];
  isReceived: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  supportType: CommonBidSupportSupportTypeEnum;
};


export type ConnectBidMatchBidRelationCommonBidRelationSupportsRelationBidArgs = {
  where?: InputMaybe<CommonBidFilters>;
};

export type ConnectBidMatchBidRelationCommonBidRelationSupportsRelationBidRelation = {
  __typename?: 'ConnectBidMatchBidRelationCommonBidRelationSupportsRelationBidRelation';
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  otherSupportAndTerms?: Maybe<Scalars['String']['output']>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  region: CommonBidRegionEnum;
  status: CommonBidStatusEnum;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  type: CommonBidTypeEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type ConnectBidMatchBidRelationCommonBidRelationUserRelation = {
  __typename?: 'ConnectBidMatchBidRelationCommonBidRelationUserRelation';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type ConnectBidMatchBidRelationProductRelation = {
  __typename?: 'ConnectBidMatchBidRelationProductRelation';
  bid?: Maybe<ConnectBidMatchBidRelationProductRelationBidRelation>;
  bidId: Scalars['Int']['output'];
  commonProduct?: Maybe<ConnectBidMatchBidRelationProductRelationCommonProductRelation>;
  externalProductId?: Maybe<Scalars['String']['output']>;
  externalProvider?: Maybe<MatchBidProductExternalProviderEnum>;
  productId: Scalars['Int']['output'];
};


export type ConnectBidMatchBidRelationProductRelationBidArgs = {
  where?: InputMaybe<MatchBidFilters>;
};


export type ConnectBidMatchBidRelationProductRelationCommonProductArgs = {
  where?: InputMaybe<CommonBidProductFilters>;
};

export type ConnectBidMatchBidRelationProductRelationBidRelation = {
  __typename?: 'ConnectBidMatchBidRelationProductRelationBidRelation';
  autoTenderBid?: Maybe<Scalars['Boolean']['output']>;
  bidId: Scalars['Int']['output'];
  credit?: Maybe<Scalars['Boolean']['output']>;
  listingLength: Scalars['Int']['output'];
  maximumAcceptedDeals: Scalars['Int']['output'];
};

export type ConnectBidMatchBidRelationProductRelationCommonProductRelation = {
  __typename?: 'ConnectBidMatchBidRelationProductRelationCommonProductRelation';
  /** JSON */
  attachments?: Maybe<Scalars['String']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  averageWholesalePrice: Scalars['Float']['output'];
  bid?: Maybe<ConnectBidMatchBidRelationProductRelationCommonProductRelationBidRelation>;
  bidId: Scalars['Int']['output'];
  /** JSON */
  image?: Maybe<Scalars['String']['output']>;
  isAnyWholesalerCompatible: Scalars['Boolean']['output'];
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  packagingType: Scalars['String']['output'];
  productCategory?: Maybe<ConnectBidMatchBidRelationProductRelationCommonProductRelationProductCategoryRelation>;
  productCategoryId: Scalars['Int']['output'];
  productTemplateId?: Maybe<Scalars['Int']['output']>;
  unitType: Scalars['String']['output'];
  unitsPerCase: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
  volumePerUnit: Scalars['Float']['output'];
  volumeUnits: Scalars['Float']['output'];
};


export type ConnectBidMatchBidRelationProductRelationCommonProductRelationBidArgs = {
  where?: InputMaybe<CommonBidFilters>;
};


export type ConnectBidMatchBidRelationProductRelationCommonProductRelationProductCategoryArgs = {
  where?: InputMaybe<ProductCategoryFilters>;
};

export type ConnectBidMatchBidRelationProductRelationCommonProductRelationBidRelation = {
  __typename?: 'ConnectBidMatchBidRelationProductRelationCommonProductRelationBidRelation';
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  otherSupportAndTerms?: Maybe<Scalars['String']['output']>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  region: CommonBidRegionEnum;
  status: CommonBidStatusEnum;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  type: CommonBidTypeEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type ConnectBidMatchBidRelationProductRelationCommonProductRelationProductCategoryRelation = {
  __typename?: 'ConnectBidMatchBidRelationProductRelationCommonProductRelationProductCategoryRelation';
  createdAtUtc: Scalars['String']['output'];
  defaultPackagingType?: Maybe<Scalars['String']['output']>;
  defaultVolume?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isPublished: Scalars['Boolean']['output'];
  localizationKey: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  unitType?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type ConnectBidMatchBidRelationVenueCriteriaRelation = {
  __typename?: 'ConnectBidMatchBidRelationVenueCriteriaRelation';
  bid?: Maybe<ConnectBidMatchBidRelationVenueCriteriaRelationBidRelation>;
  bidId: Scalars['Int']['output'];
  capturedTargetedVenues?: Maybe<Scalars['Int']['output']>;
  /** JSON */
  customerTypes?: Maybe<Scalars['String']['output']>;
  listingType?: Maybe<ConnectBidMatchBidRelationVenueCriteriaRelationListingTypeRelation>;
  listingTypeId: Scalars['Int']['output'];
  /** JSON */
  loyaltyLevels?: Maybe<Scalars['String']['output']>;
  minimumVolume: Scalars['Int']['output'];
  /** JSON */
  regions?: Maybe<Scalars['String']['output']>;
  targetProductCategory?: Maybe<Scalars['Int']['output']>;
  /** JSON */
  venueTypes?: Maybe<Scalars['String']['output']>;
};


export type ConnectBidMatchBidRelationVenueCriteriaRelationBidArgs = {
  where?: InputMaybe<MatchBidFilters>;
};


export type ConnectBidMatchBidRelationVenueCriteriaRelationListingTypeArgs = {
  where?: InputMaybe<ListingTypeFilters>;
};

export type ConnectBidMatchBidRelationVenueCriteriaRelationBidRelation = {
  __typename?: 'ConnectBidMatchBidRelationVenueCriteriaRelationBidRelation';
  autoTenderBid?: Maybe<Scalars['Boolean']['output']>;
  bidId: Scalars['Int']['output'];
  credit?: Maybe<Scalars['Boolean']['output']>;
  listingLength: Scalars['Int']['output'];
  maximumAcceptedDeals: Scalars['Int']['output'];
};

export type ConnectBidMatchBidRelationVenueCriteriaRelationListingTypeRelation = {
  __typename?: 'ConnectBidMatchBidRelationVenueCriteriaRelationListingTypeRelation';
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  localizationKey: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  region?: Maybe<Scalars['String']['output']>;
  regions: Array<ConnectBidMatchBidRelationVenueCriteriaRelationListingTypeRelationRegionsRelation>;
  suggestedListingLengthInMonths: Scalars['Int']['output'];
  suggestedTenderLengthInMonths: Scalars['Int']['output'];
  tenderDrafts: Array<ConnectBidMatchBidRelationVenueCriteriaRelationListingTypeRelationTenderDraftsRelation>;
  tenders: Array<ConnectBidMatchBidRelationVenueCriteriaRelationListingTypeRelationTendersRelation>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};


export type ConnectBidMatchBidRelationVenueCriteriaRelationListingTypeRelationRegionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ListingTypeRegion2OrderBy>;
  where?: InputMaybe<ListingTypeRegion2Filters>;
};


export type ConnectBidMatchBidRelationVenueCriteriaRelationListingTypeRelationTenderDraftsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TenderDraftOrderBy>;
  where?: InputMaybe<TenderDraftFilters>;
};


export type ConnectBidMatchBidRelationVenueCriteriaRelationListingTypeRelationTendersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TenderOrderBy>;
  where?: InputMaybe<TenderFilters>;
};

export type ConnectBidMatchBidRelationVenueCriteriaRelationListingTypeRelationRegionsRelation = {
  __typename?: 'ConnectBidMatchBidRelationVenueCriteriaRelationListingTypeRelationRegionsRelation';
  listingTypeId: Scalars['Int']['output'];
  region: Scalars['String']['output'];
};

export type ConnectBidMatchBidRelationVenueCriteriaRelationListingTypeRelationTenderDraftsRelation = {
  __typename?: 'ConnectBidMatchBidRelationVenueCriteriaRelationListingTypeRelationTenderDraftsRelation';
  createdAtUtc: Scalars['String']['output'];
  estimatedVolume?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isAnyWholesalerCompatible?: Maybe<Scalars['Boolean']['output']>;
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  listingEndsAtUtc?: Maybe<Scalars['String']['output']>;
  listingStartsAtUtc?: Maybe<Scalars['String']['output']>;
  listingTypeId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  packagingType?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  supportDetails?: Maybe<Scalars['String']['output']>;
  supportsDiscount: Scalars['String']['output'];
  supportsFreeStock: Scalars['String']['output'];
  supportsListingFee: Scalars['String']['output'];
  supportsPosBudget: Scalars['String']['output'];
  supportsRetroDiscount: Scalars['String']['output'];
  tenderDetails?: Maybe<Scalars['String']['output']>;
  tenderEndsAtUtc?: Maybe<Scalars['String']['output']>;
  tenderStartsAtUtc?: Maybe<Scalars['String']['output']>;
  unitType?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
  venueId: Scalars['Int']['output'];
  volumeDetails?: Maybe<Scalars['String']['output']>;
  volumeUnits?: Maybe<Scalars['Float']['output']>;
};

export type ConnectBidMatchBidRelationVenueCriteriaRelationListingTypeRelationTendersRelation = {
  __typename?: 'ConnectBidMatchBidRelationVenueCriteriaRelationListingTypeRelationTendersRelation';
  createdAtUtc: Scalars['String']['output'];
  estimatedVolume: Scalars['Int']['output'];
  feedback?: Maybe<Scalars['String']['output']>;
  hostingChargeInvoiceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAnyWholesalerCompatible?: Maybe<Scalars['Boolean']['output']>;
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  listingEndsAtUtc: Scalars['String']['output'];
  listingStartsAtUtc: Scalars['String']['output'];
  listingTypeId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  originalTenderEndsAtUtc?: Maybe<Scalars['String']['output']>;
  packagingType?: Maybe<Scalars['String']['output']>;
  receivedSupportStatus: Scalars['String']['output'];
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  supportDetails?: Maybe<Scalars['String']['output']>;
  supportsDiscount: Scalars['String']['output'];
  supportsFreeStock: Scalars['String']['output'];
  supportsListingFee: Scalars['String']['output'];
  supportsPosBudget: Scalars['String']['output'];
  supportsRetroDiscount: Scalars['String']['output'];
  tenderDetails?: Maybe<Scalars['String']['output']>;
  tenderEndsAtUtc?: Maybe<Scalars['String']['output']>;
  tenderStartsAtUtc?: Maybe<Scalars['String']['output']>;
  unitType: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
  venueId: Scalars['Int']['output'];
  volumeDetails?: Maybe<Scalars['String']['output']>;
  volumeUnits: Scalars['Float']['output'];
};

export type ConnectBidOrderBy = {
  bidId?: InputMaybe<InnerOrder>;
  matchBidId?: InputMaybe<InnerOrder>;
  tenderId?: InputMaybe<InnerOrder>;
};

export type ConnectBidSelectItem = {
  __typename?: 'ConnectBidSelectItem';
  bidId: Scalars['Int']['output'];
  commonBid?: Maybe<ConnectBidCommonBidRelation>;
  matchBid?: Maybe<ConnectBidMatchBidRelation>;
  matchBidId?: Maybe<Scalars['Int']['output']>;
  messageCount: Scalars['Int']['output'];
  tender?: Maybe<ConnectBidTenderRelation>;
  tenderId: Scalars['Int']['output'];
};


export type ConnectBidSelectItemCommonBidArgs = {
  where?: InputMaybe<CommonBidFilters>;
};


export type ConnectBidSelectItemMatchBidArgs = {
  where?: InputMaybe<MatchBidFilters>;
};


export type ConnectBidSelectItemTenderArgs = {
  where?: InputMaybe<TenderFilters>;
};

export type ConnectBidTenderIdFilters = {
  OR?: InputMaybe<Array<ConnectBidTenderIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectBidTenderIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectBidTenderRelation = {
  __typename?: 'ConnectBidTenderRelation';
  connectBids: Array<ConnectBidTenderRelationConnectBidsRelation>;
  createdAtUtc: Scalars['String']['output'];
  estimatedVolume: Scalars['Int']['output'];
  feedback?: Maybe<Scalars['String']['output']>;
  hostingChargeInvoiceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAnyWholesalerCompatible?: Maybe<Scalars['Boolean']['output']>;
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  listingEndsAtUtc: Scalars['String']['output'];
  listingStartsAtUtc: Scalars['String']['output'];
  listingType?: Maybe<ConnectBidTenderRelationListingTypeRelation>;
  listingTypeId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  notifications: Array<ConnectBidTenderRelationNotificationsRelation>;
  originalTenderEndsAtUtc?: Maybe<Scalars['String']['output']>;
  packagingType?: Maybe<Scalars['String']['output']>;
  productCategories: Array<ConnectBidTenderRelationProductCategoriesRelation>;
  productPackaging?: Maybe<ConnectBidTenderRelationProductPackagingRelation>;
  receivedSupportStatus: Scalars['String']['output'];
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  supportDetails?: Maybe<Scalars['String']['output']>;
  supportsDiscount: Scalars['String']['output'];
  supportsFreeStock: Scalars['String']['output'];
  supportsListingFee: Scalars['String']['output'];
  supportsPosBudget: Scalars['String']['output'];
  supportsRetroDiscount: Scalars['String']['output'];
  tenderDetails?: Maybe<Scalars['String']['output']>;
  tenderEndsAtUtc?: Maybe<Scalars['String']['output']>;
  tenderStartsAtUtc?: Maybe<Scalars['String']['output']>;
  tenderWholesalers: Array<ConnectBidTenderRelationTenderWholesalersRelation>;
  unit?: Maybe<ConnectBidTenderRelationUnitRelation>;
  unitType: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<ConnectBidTenderRelationUserRelation>;
  userId: Scalars['Int']['output'];
  venue?: Maybe<ConnectBidTenderRelationVenueRelation>;
  venueId: Scalars['Int']['output'];
  volumeDetails?: Maybe<Scalars['String']['output']>;
  volumeUnits: Scalars['Float']['output'];
};


export type ConnectBidTenderRelationConnectBidsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ConnectBidOrderBy>;
  where?: InputMaybe<ConnectBidFilters>;
};


export type ConnectBidTenderRelationListingTypeArgs = {
  where?: InputMaybe<ListingTypeFilters>;
};


export type ConnectBidTenderRelationNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<NotificationOrderBy>;
  where?: InputMaybe<NotificationFilters>;
};


export type ConnectBidTenderRelationProductCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TenderProductCategoriesOrderBy>;
  where?: InputMaybe<TenderProductCategoriesFilters>;
};


export type ConnectBidTenderRelationProductPackagingArgs = {
  where?: InputMaybe<ProductPackagingFilters>;
};


export type ConnectBidTenderRelationTenderWholesalersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TenderWholesalerOrderBy>;
  where?: InputMaybe<TenderWholesalerFilters>;
};


export type ConnectBidTenderRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type ConnectBidTenderRelationUserArgs = {
  where?: InputMaybe<UserFilters>;
};


export type ConnectBidTenderRelationVenueArgs = {
  where?: InputMaybe<VenueFilters>;
};

export type ConnectBidTenderRelationConnectBidsRelation = {
  __typename?: 'ConnectBidTenderRelationConnectBidsRelation';
  bidId: Scalars['Int']['output'];
  matchBidId?: Maybe<Scalars['Int']['output']>;
  tenderId: Scalars['Int']['output'];
};

export type ConnectBidTenderRelationListingTypeRelation = {
  __typename?: 'ConnectBidTenderRelationListingTypeRelation';
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  localizationKey: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  region?: Maybe<Scalars['String']['output']>;
  regions: Array<ConnectBidTenderRelationListingTypeRelationRegionsRelation>;
  suggestedListingLengthInMonths: Scalars['Int']['output'];
  suggestedTenderLengthInMonths: Scalars['Int']['output'];
  tenderDrafts: Array<ConnectBidTenderRelationListingTypeRelationTenderDraftsRelation>;
  tenders: Array<ConnectBidTenderRelationListingTypeRelationTendersRelation>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};


export type ConnectBidTenderRelationListingTypeRelationRegionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ListingTypeRegion2OrderBy>;
  where?: InputMaybe<ListingTypeRegion2Filters>;
};


export type ConnectBidTenderRelationListingTypeRelationTenderDraftsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TenderDraftOrderBy>;
  where?: InputMaybe<TenderDraftFilters>;
};


export type ConnectBidTenderRelationListingTypeRelationTendersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TenderOrderBy>;
  where?: InputMaybe<TenderFilters>;
};

export type ConnectBidTenderRelationListingTypeRelationRegionsRelation = {
  __typename?: 'ConnectBidTenderRelationListingTypeRelationRegionsRelation';
  listingTypeId: Scalars['Int']['output'];
  region: Scalars['String']['output'];
};

export type ConnectBidTenderRelationListingTypeRelationTenderDraftsRelation = {
  __typename?: 'ConnectBidTenderRelationListingTypeRelationTenderDraftsRelation';
  createdAtUtc: Scalars['String']['output'];
  estimatedVolume?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isAnyWholesalerCompatible?: Maybe<Scalars['Boolean']['output']>;
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  listingEndsAtUtc?: Maybe<Scalars['String']['output']>;
  listingStartsAtUtc?: Maybe<Scalars['String']['output']>;
  listingTypeId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  packagingType?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  supportDetails?: Maybe<Scalars['String']['output']>;
  supportsDiscount: Scalars['String']['output'];
  supportsFreeStock: Scalars['String']['output'];
  supportsListingFee: Scalars['String']['output'];
  supportsPosBudget: Scalars['String']['output'];
  supportsRetroDiscount: Scalars['String']['output'];
  tenderDetails?: Maybe<Scalars['String']['output']>;
  tenderEndsAtUtc?: Maybe<Scalars['String']['output']>;
  tenderStartsAtUtc?: Maybe<Scalars['String']['output']>;
  unitType?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
  venueId: Scalars['Int']['output'];
  volumeDetails?: Maybe<Scalars['String']['output']>;
  volumeUnits?: Maybe<Scalars['Float']['output']>;
};

export type ConnectBidTenderRelationListingTypeRelationTendersRelation = {
  __typename?: 'ConnectBidTenderRelationListingTypeRelationTendersRelation';
  createdAtUtc: Scalars['String']['output'];
  estimatedVolume: Scalars['Int']['output'];
  feedback?: Maybe<Scalars['String']['output']>;
  hostingChargeInvoiceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAnyWholesalerCompatible?: Maybe<Scalars['Boolean']['output']>;
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  listingEndsAtUtc: Scalars['String']['output'];
  listingStartsAtUtc: Scalars['String']['output'];
  listingTypeId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  originalTenderEndsAtUtc?: Maybe<Scalars['String']['output']>;
  packagingType?: Maybe<Scalars['String']['output']>;
  receivedSupportStatus: Scalars['String']['output'];
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  supportDetails?: Maybe<Scalars['String']['output']>;
  supportsDiscount: Scalars['String']['output'];
  supportsFreeStock: Scalars['String']['output'];
  supportsListingFee: Scalars['String']['output'];
  supportsPosBudget: Scalars['String']['output'];
  supportsRetroDiscount: Scalars['String']['output'];
  tenderDetails?: Maybe<Scalars['String']['output']>;
  tenderEndsAtUtc?: Maybe<Scalars['String']['output']>;
  tenderStartsAtUtc?: Maybe<Scalars['String']['output']>;
  unitType: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
  venueId: Scalars['Int']['output'];
  volumeDetails?: Maybe<Scalars['String']['output']>;
  volumeUnits: Scalars['Float']['output'];
};

export type ConnectBidTenderRelationNotificationsRelation = {
  __typename?: 'ConnectBidTenderRelationNotificationsRelation';
  bidId?: Maybe<Scalars['Int']['output']>;
  brandId?: Maybe<Scalars['Int']['output']>;
  category: Scalars['String']['output'];
  createdAtUtc: Scalars['String']['output'];
  fromId?: Maybe<Scalars['Int']['output']>;
  fromType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isRead: Scalars['Boolean']['output'];
  messageId?: Maybe<Scalars['Int']['output']>;
  tenderId?: Maybe<Scalars['Int']['output']>;
  toId: Scalars['Int']['output'];
  toType: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  venueId?: Maybe<Scalars['Int']['output']>;
};

export type ConnectBidTenderRelationProductCategoriesRelation = {
  __typename?: 'ConnectBidTenderRelationProductCategoriesRelation';
  productCategoryId: Scalars['Int']['output'];
  tenderId: Scalars['Int']['output'];
};

export type ConnectBidTenderRelationProductPackagingRelation = {
  __typename?: 'ConnectBidTenderRelationProductPackagingRelation';
  type: Scalars['String']['output'];
};

export type ConnectBidTenderRelationTenderWholesalersRelation = {
  __typename?: 'ConnectBidTenderRelationTenderWholesalersRelation';
  tenderId: Scalars['Int']['output'];
  wholesalerId: Scalars['Int']['output'];
};

export type ConnectBidTenderRelationUnitRelation = {
  __typename?: 'ConnectBidTenderRelationUnitRelation';
  type: Scalars['String']['output'];
};

export type ConnectBidTenderRelationUserRelation = {
  __typename?: 'ConnectBidTenderRelationUserRelation';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type ConnectBidTenderRelationVenueRelation = {
  __typename?: 'ConnectBidTenderRelationVenueRelation';
  address?: Maybe<ConnectBidTenderRelationVenueRelationAddressRelation>;
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<ConnectBidTenderRelationVenueRelationBillingAddressRelation>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompany?: Maybe<ConnectBidTenderRelationVenueRelationRegisteredCompanyRelation>;
  registeredCompanyId: Scalars['Int']['output'];
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  venueCategory?: Maybe<ConnectBidTenderRelationVenueRelationVenueCategoryRelation>;
  venueCategoryId?: Maybe<Scalars['Int']['output']>;
  venueCategoryName?: Maybe<Scalars['String']['output']>;
  venueIntegrations: Array<ConnectBidTenderRelationVenueRelationVenueIntegrationsRelation>;
  venueUsers: Array<ConnectBidTenderRelationVenueRelationVenueUsersRelation>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};


export type ConnectBidTenderRelationVenueRelationAddressArgs = {
  where?: InputMaybe<AddressFilters>;
};


export type ConnectBidTenderRelationVenueRelationBillingAddressArgs = {
  where?: InputMaybe<AddressFilters>;
};


export type ConnectBidTenderRelationVenueRelationRegisteredCompanyArgs = {
  where?: InputMaybe<RegisteredCompanyFilters>;
};


export type ConnectBidTenderRelationVenueRelationVenueCategoryArgs = {
  where?: InputMaybe<VenueCategoryFilters>;
};


export type ConnectBidTenderRelationVenueRelationVenueIntegrationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<VenueIntegrationsOrderBy>;
  where?: InputMaybe<VenueIntegrationsFilters>;
};


export type ConnectBidTenderRelationVenueRelationVenueUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<VenueUserOrderBy>;
  where?: InputMaybe<VenueUserFilters>;
};

export type ConnectBidTenderRelationVenueRelationAddressRelation = {
  __typename?: 'ConnectBidTenderRelationVenueRelationAddressRelation';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type ConnectBidTenderRelationVenueRelationBillingAddressRelation = {
  __typename?: 'ConnectBidTenderRelationVenueRelationBillingAddressRelation';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type ConnectBidTenderRelationVenueRelationRegisteredCompanyRelation = {
  __typename?: 'ConnectBidTenderRelationVenueRelationRegisteredCompanyRelation';
  addressId?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  dateOfCreation?: Maybe<Scalars['String']['output']>;
  firstAddressLine?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  secondAddressLine?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type ConnectBidTenderRelationVenueRelationVenueCategoryRelation = {
  __typename?: 'ConnectBidTenderRelationVenueRelationVenueCategoryRelation';
  id: Scalars['Int']['output'];
  localizationKey: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type ConnectBidTenderRelationVenueRelationVenueIntegrationsRelation = {
  __typename?: 'ConnectBidTenderRelationVenueRelationVenueIntegrationsRelation';
  createdAtUtc: Scalars['String']['output'];
  externalCompanyId: Scalars['String']['output'];
  externalUserId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  integrationType: VenueIntegrationsIntegrationTypeEnum;
  /** JSON */
  metadata?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<ConnectBidTenderRelationVenueRelationVenueIntegrationsRelationUserRelation>;
  userId: Scalars['Int']['output'];
  venue?: Maybe<ConnectBidTenderRelationVenueRelationVenueIntegrationsRelationVenueRelation>;
  venueId: Scalars['Int']['output'];
};


export type ConnectBidTenderRelationVenueRelationVenueIntegrationsRelationUserArgs = {
  where?: InputMaybe<UserFilters>;
};


export type ConnectBidTenderRelationVenueRelationVenueIntegrationsRelationVenueArgs = {
  where?: InputMaybe<VenueFilters>;
};

export type ConnectBidTenderRelationVenueRelationVenueIntegrationsRelationUserRelation = {
  __typename?: 'ConnectBidTenderRelationVenueRelationVenueIntegrationsRelationUserRelation';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type ConnectBidTenderRelationVenueRelationVenueIntegrationsRelationVenueRelation = {
  __typename?: 'ConnectBidTenderRelationVenueRelationVenueIntegrationsRelationVenueRelation';
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompanyId: Scalars['Int']['output'];
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  venueCategoryId?: Maybe<Scalars['Int']['output']>;
  venueCategoryName?: Maybe<Scalars['String']['output']>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};

export type ConnectBidTenderRelationVenueRelationVenueUsersRelation = {
  __typename?: 'ConnectBidTenderRelationVenueRelationVenueUsersRelation';
  createdAtUtc: Scalars['String']['output'];
  role: VenueUserRoleEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<ConnectBidTenderRelationVenueRelationVenueUsersRelationUserRelation>;
  userId: Scalars['Int']['output'];
  venue?: Maybe<ConnectBidTenderRelationVenueRelationVenueUsersRelationVenueRelation>;
  venueId: Scalars['Int']['output'];
};


export type ConnectBidTenderRelationVenueRelationVenueUsersRelationUserArgs = {
  where?: InputMaybe<UserFilters>;
};


export type ConnectBidTenderRelationVenueRelationVenueUsersRelationVenueArgs = {
  where?: InputMaybe<VenueFilters>;
};

export type ConnectBidTenderRelationVenueRelationVenueUsersRelationUserRelation = {
  __typename?: 'ConnectBidTenderRelationVenueRelationVenueUsersRelationUserRelation';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type ConnectBidTenderRelationVenueRelationVenueUsersRelationVenueRelation = {
  __typename?: 'ConnectBidTenderRelationVenueRelationVenueUsersRelationVenueRelation';
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompanyId: Scalars['Int']['output'];
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  venueCategoryId?: Maybe<Scalars['Int']['output']>;
  venueCategoryName?: Maybe<Scalars['String']['output']>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};

export type ConnectBidUpdateInput = {
  matchBidId?: InputMaybe<Scalars['Int']['input']>;
  otherSupportAndTerms?: InputMaybe<Scalars['String']['input']>;
  product: CommonBidProductUpdateInput;
  supportedWholesalersIds?: InputMaybe<Array<Scalars['NonNegativeInt']['input']>>;
  supports: Array<CommonBidSupportInsertInput>;
};

export type Coordinates = {
  __typename?: 'Coordinates';
  lat: Scalars['String']['output'];
  lng: Scalars['String']['output'];
};

export type CoordinatesInput = {
  lat: Scalars['String']['input'];
  lng: Scalars['String']['input'];
  /** Latitude */
  x: Scalars['Float']['input'];
  /** Longitude */
  y: Scalars['Float']['input'];
};

export type CountyRegion = {
  __typename?: 'CountyRegion';
  id: Scalars['NonNegativeInt']['output'];
  name: Scalars['NonEmptyString']['output'];
};

export type CreateBankTransferSubscriptionInput = {
  brandId: Scalars['Int']['input'];
  pricePerMonth: Scalars['Int']['input'];
  successFee: Scalars['Float']['input'];
};

export type CreateBespokePaymentLinkInput = {
  brandId: Scalars['Int']['input'];
  pricePerMonth: Scalars['Int']['input'];
  successFee: Scalars['Float']['input'];
};

export type CreateStripeCheckoutInput = {
  brandId: Scalars['Int']['input'];
  firebaseId: Scalars['String']['input'];
  returnUrl?: InputMaybe<Scalars['String']['input']>;
  subscriptionTier: SubscriptionTier;
  yearlyPeriod?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CursorNotifications = CursorPagination & {
  __typename?: 'CursorNotifications';
  edges: Array<NotificationEdge>;
  pageInfo: CursorPageInfo;
  totalCount: Scalars['Int']['output'];
  unreadTotalCount: Scalars['Int']['output'];
};

export type CursorNotificationsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  category: NotificationCategory;
  first: Scalars['Int']['input'];
  toId: Scalars['Int']['input'];
  toType: NotificationTargetType;
};

export type CursorPageInfo = {
  __typename?: 'CursorPageInfo';
  endCursor: Scalars['String']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor: Scalars['String']['output'];
};

export type CursorPagination = {
  edges: Array<Edge>;
  pageInfo: CursorPageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CursorPaginationInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};

export type CustomerType = {
  __typename?: 'CustomerType';
  id: Scalars['NonNegativeInt']['output'];
  name: Scalars['NonEmptyString']['output'];
};

export enum DashboardMetricType {
  Global = 'GLOBAL',
  Personalised = 'PERSONALISED'
}

export type DeleteBidInput = {
  bidId: Scalars['Int']['input'];
};

export type DeleteProductTemplateInput = {
  brandId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};

export type Edge = {
  cursor: Scalars['String']['output'];
  node: Node;
};

export type EditBidInput = {
  averageWholesalePrice?: InputMaybe<Scalars['Float']['input']>;
  brandId?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  discountAmountPerUnit?: InputMaybe<Scalars['Float']['input']>;
  discountNotes?: InputMaybe<Scalars['String']['input']>;
  files: Array<FileInput>;
  freeStockNotes?: InputMaybe<Scalars['String']['input']>;
  freeStockUnitsAmount?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  id: Scalars['NonNegativeInt']['input'];
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  isAnyWholesalerCompatible: Scalars['Boolean']['input'];
  isDirectSupplyCompatible: Scalars['Boolean']['input'];
  listingFeeNotes?: InputMaybe<Scalars['String']['input']>;
  listingFeeTotalAmount?: InputMaybe<Scalars['Float']['input']>;
  otherSupport?: InputMaybe<Scalars['String']['input']>;
  posBudgetNotes?: InputMaybe<Scalars['String']['input']>;
  posBudgetTotalAmount?: InputMaybe<Scalars['Float']['input']>;
  retroDiscountAmountPerUnit?: InputMaybe<Scalars['Float']['input']>;
  retroDiscountNotes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BidStatus>;
  subscriptionTier?: InputMaybe<SubscriptionTier>;
  successFee?: InputMaybe<Scalars['Float']['input']>;
  supportsDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  supportsFreeStock?: InputMaybe<Scalars['Boolean']['input']>;
  supportsListingFee?: InputMaybe<Scalars['Boolean']['input']>;
  supportsPosBudget?: InputMaybe<Scalars['Boolean']['input']>;
  supportsRetroDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  wholesalersIds: Array<Scalars['NonNegativeInt']['input']>;
};

export type EditBidSupportStatusInput = {
  bidId: Scalars['NonNegativeInt']['input'];
  brandId?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  supportToChange: BidSupportType;
  tenderId: Scalars['NonNegativeInt']['input'];
  venueId?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type EditBrandInput = {
  avatarBucketKey?: InputMaybe<Scalars['String']['input']>;
  awrsCompanyName?: InputMaybe<Scalars['String']['input']>;
  awrsDeregistrationDate?: InputMaybe<Scalars['String']['input']>;
  awrsNumber?: InputMaybe<Scalars['String']['input']>;
  awrsPlaceBusiness?: InputMaybe<Scalars['String']['input']>;
  awrsRegistrationDate?: InputMaybe<Scalars['String']['input']>;
  awrsStatus?: InputMaybe<Scalars['String']['input']>;
  canSeeOtherBids?: InputMaybe<Scalars['Boolean']['input']>;
  complianceCheckDate?: InputMaybe<Scalars['String']['input']>;
  complianceConfirmation?: InputMaybe<Scalars['String']['input']>;
  complianceNextDate?: InputMaybe<Scalars['String']['input']>;
  complianceRiskLevel?: InputMaybe<Scalars['String']['input']>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  instagramUrl?: InputMaybe<Scalars['String']['input']>;
  isAnonymousBidAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  productCategoriesIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  vatCompanyName?: InputMaybe<Scalars['String']['input']>;
  vatConsultationNumber?: InputMaybe<Scalars['String']['input']>;
  vatCountryCode?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  vatProcessingDate?: InputMaybe<Scalars['String']['input']>;
  webPageUrl?: InputMaybe<Scalars['String']['input']>;
};

export type EditBrandSettingsInput = {
  brandId: Scalars['Int']['input'];
  isMatchBidsTenderReportMailNotificationEnabled: Scalars['Boolean']['input'];
  isNewTenderInAppNotificationEnabled: Scalars['Boolean']['input'];
  isNewTenderMailNotificationEnabled: Scalars['Boolean']['input'];
  isRatingProvidedInAppNotificationEnabled: Scalars['Boolean']['input'];
  isRatingProvidedMailNotificationEnabled: Scalars['Boolean']['input'];
  isTenderUpdatedInAppNotificationEnabled: Scalars['Boolean']['input'];
  isTenderUpdatedMailNotificationEnabled: Scalars['Boolean']['input'];
};

export type EditProductTemplateInput = {
  avatarBucketKey?: InputMaybe<Scalars['String']['input']>;
  averageWholesalePrice: Scalars['Float']['input'];
  brandId: Scalars['Int']['input'];
  files: Array<FileInput>;
  id: Scalars['Int']['input'];
  isAnyWholesalerCompatible: Scalars['Boolean']['input'];
  isDirectSupplyCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  packagingType: Scalars['String']['input'];
  productCategoryId: Scalars['Int']['input'];
  productName: Scalars['String']['input'];
  productUrl?: InputMaybe<Scalars['String']['input']>;
  unitType: Scalars['String']['input'];
  unitsPerCase: Scalars['Int']['input'];
  volumePerUnit: Scalars['Float']['input'];
  wholesalersIds: Array<Scalars['Int']['input']>;
};

export type EditSupportStatusInput = {
  bidId: Scalars['NonNegativeInt']['input'];
  brandId?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  supportToChange: BidSupportType;
  tenderId?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  venueId?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type EditTenderDraftInput = {
  estimatedVolume?: InputMaybe<Scalars['Int']['input']>;
  files: Array<FileInput>;
  id: Scalars['NonNegativeInt']['input'];
  isAnyWholesalerCompatible: Scalars['Boolean']['input'];
  isDirectSupplyCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate: Scalars['Boolean']['input'];
  listingEndsAtUtc?: InputMaybe<Scalars['Date']['input']>;
  listingStartsAtUtc?: InputMaybe<Scalars['Date']['input']>;
  listingTypeId: Scalars['NonNegativeInt']['input'];
  name: Scalars['String']['input'];
  packagingType?: InputMaybe<Scalars['String']['input']>;
  productCategoryIds: Array<Scalars['NonNegativeInt']['input']>;
  supportDetails?: InputMaybe<Scalars['String']['input']>;
  supportsDiscount: TenderSupportOption;
  supportsFreeStock: TenderSupportOption;
  supportsListingFee: TenderSupportOption;
  supportsPosBudget: TenderSupportOption;
  supportsRetroDiscount: TenderSupportOption;
  tenderDetails?: InputMaybe<Scalars['String']['input']>;
  tenderEndsAtUtc?: InputMaybe<Scalars['Date']['input']>;
  tenderStartsAtUtc?: InputMaybe<Scalars['Date']['input']>;
  unitType?: InputMaybe<Scalars['String']['input']>;
  volumeDetails?: InputMaybe<Scalars['String']['input']>;
  volumeUnits?: InputMaybe<Scalars['Float']['input']>;
  wholesalersIds: Array<Scalars['NonNegativeInt']['input']>;
};

export type EditTenderInput = {
  estimatedVolume: Scalars['Int']['input'];
  feedback?: InputMaybe<Scalars['String']['input']>;
  files: Array<FileInput>;
  id: Scalars['Int']['input'];
  isAnyWholesalerCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  isDirectSupplyCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate: Scalars['Boolean']['input'];
  listingEndsAtUtc: Scalars['Date']['input'];
  listingStartsAtUtc: Scalars['Date']['input'];
  listingTypeId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  packagingType: Scalars['String']['input'];
  productCategoryIds: Array<Scalars['Int']['input']>;
  sendNotification?: InputMaybe<Scalars['Boolean']['input']>;
  status: TenderStatus;
  supportDetails?: InputMaybe<Scalars['String']['input']>;
  supportsDiscount: TenderSupportOption;
  supportsFreeStock: TenderSupportOption;
  supportsListingFee: TenderSupportOption;
  supportsPosBudget: TenderSupportOption;
  supportsRetroDiscount: TenderSupportOption;
  tenderDetails?: InputMaybe<Scalars['String']['input']>;
  tenderEndsAtUtc: Scalars['Date']['input'];
  tenderStartsAtUtc: Scalars['Date']['input'];
  unitType: Scalars['String']['input'];
  volumeDetails?: InputMaybe<Scalars['String']['input']>;
  volumeUnits: Scalars['Float']['input'];
  wholesalersIds: Array<Scalars['Int']['input']>;
};

export type EditTenderPreferenceInput = {
  id: Scalars['NonNegativeInt']['input'];
  isAnyWholesalerCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  isDirectSupplyCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  supportDetails?: InputMaybe<Scalars['String']['input']>;
  supportsDiscount: TenderSupportOption;
  supportsFreeStock: TenderSupportOption;
  supportsListingFee: TenderSupportOption;
  supportsPosBudget: TenderSupportOption;
  supportsRetroDiscount: TenderSupportOption;
  venueId: Scalars['NonNegativeInt']['input'];
  wholesalersIds: Array<Scalars['NonNegativeInt']['input']>;
};

export type EditUserContactDetailsInput = {
  contactName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type EditVenueInput = {
  address: GoogleAddressInput;
  avatarBucketKey?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  googlePlacesSessionToken: Scalars['String']['input'];
  groupName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  instagramUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  venueCategoryId: Scalars['Int']['input'];
  webPageUrl?: InputMaybe<Scalars['String']['input']>;
};

export type EditVenueSettingsInput = {
  isBidUpdatedInAppNotificationEnabled: Scalars['Boolean']['input'];
  isBidUpdatedMailNotificationEnabled: Scalars['Boolean']['input'];
  isMyTenderEndedInAppNotificationEnabled: Scalars['Boolean']['input'];
  isMyTenderEndedMailNotificationEnabled: Scalars['Boolean']['input'];
  isNewBidsInAppNotificationEnabled: Scalars['Boolean']['input'];
  isNewBidsMailNotificationEnabled: Scalars['Boolean']['input'];
  isNewTenderInAppNotificationEnabled: Scalars['Boolean']['input'];
  isNewTenderMailNotificationEnabled: Scalars['Boolean']['input'];
  isReTenderInAppNotificationEnabled: Scalars['Boolean']['input'];
  isReTenderMailNotificationEnabled: Scalars['Boolean']['input'];
  venueId: Scalars['Int']['input'];
};

export enum EmailType {
  GetInTouch = 'GetInTouch'
}

export type ExternalProductLivePriceType = {
  __typename?: 'ExternalProductLivePriceType';
  baseCasePrice?: Maybe<Scalars['Float']['output']>;
  basePrice?: Maybe<Scalars['Float']['output']>;
  casePrice?: Maybe<Scalars['Float']['output']>;
  externalProductId: Scalars['NonNegativeInt']['output'];
  price: Scalars['Float']['output'];
};

export enum Feature {
  SalesDemo = 'SALES_DEMO'
}

export type File = {
  __typename?: 'File';
  bucketKey: Scalars['String']['output'];
  context: FileContext;
  downloadUrl: Scalars['String']['output'];
  fileSizeInKib: Scalars['Float']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export enum FileContext {
  BidDocument = 'BID_DOCUMENT',
  BidPosDocument = 'BID_POS_DOCUMENT',
  ProductAvatar = 'PRODUCT_AVATAR',
  ProductDocument = 'PRODUCT_DOCUMENT',
  TenderDocument = 'TENDER_DOCUMENT',
  TenderSalesVolumeData = 'TENDER_SALES_VOLUME_DATA',
  UserAvatar = 'USER_AVATAR'
}

export type FileInput = {
  bucketKey: Scalars['NonEmptyString']['input'];
  context: FileContext;
  fileSizeInKib: Scalars['NonNegativeFloat']['input'];
  filename: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type Filter = {
  __typename?: 'Filter';
  label: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  options: Array<FilterOption>;
  type?: Maybe<FilterOptionType>;
};

export type FilterOption = {
  __typename?: 'FilterOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum FilterOptionType {
  MultiSelect = 'MultiSelect',
  Range = 'Range',
  SingleSelect = 'SingleSelect'
}

export type GetCompanyVatDetailsInput = {
  vatNumber: Scalars['String']['input'];
};

export type GetDataFromCompanyNumberInput = {
  companyNumber: Scalars['String']['input'];
};

export type GoogleAddress = {
  __typename?: 'GoogleAddress';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  coordinates: Coordinates;
  country?: Maybe<Scalars['String']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  placeId: Scalars['String']['output'];
  placeName: Scalars['String']['output'];
  postCode?: Maybe<Scalars['String']['output']>;
};

export type GoogleAddressInput = {
  administrativeAreLevel2ShortName?: InputMaybe<Scalars['String']['input']>;
  administrativeAreaLevel1?: InputMaybe<Scalars['String']['input']>;
  administrativeAreaLevel1ShortName?: InputMaybe<Scalars['String']['input']>;
  administrativeAreaLevel2?: InputMaybe<Scalars['String']['input']>;
  coordinates: CoordinatesInput;
  country?: InputMaybe<Scalars['String']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  placeId: Scalars['String']['input'];
  placeName: Scalars['String']['input'];
  postCode: Scalars['String']['input'];
};

export type GoogleLocationByCoordinates = {
  __typename?: 'GoogleLocationByCoordinates';
  country?: Maybe<Scalars['String']['output']>;
};

export type HasActiveSubscriptionData = {
  __typename?: 'HasActiveSubscriptionData';
  brandId: Scalars['Int']['output'];
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type HasBids = {
  __typename?: 'HasBids';
  brandId: Scalars['NonNegativeInt']['output'];
  hasBids: Scalars['Boolean']['output'];
};

export type HelloInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InnerOrder = {
  direction: OrderDirection;
  /** Priority of current field */
  priority: Scalars['Int']['input'];
};

export enum IntegrationType {
  ParamountLiquor = 'PARAMOUNT_LIQUOR',
  VenusAndBooker = 'VENUS_AND_BOOKER'
}

export type InvitationLinkAcceptedByIdFilters = {
  OR?: InputMaybe<Array<InvitationLinkAcceptedByIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type InvitationLinkAcceptedByIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type InvitationLinkBrandIdFilters = {
  OR?: InputMaybe<Array<InvitationLinkBrandIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type InvitationLinkBrandIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type InvitationLinkCreatedAtUtcFilters = {
  OR?: InputMaybe<Array<InvitationLinkCreatedAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type InvitationLinkCreatedAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type InvitationLinkCreatedByIdFilters = {
  OR?: InputMaybe<Array<InvitationLinkCreatedByIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type InvitationLinkCreatedByIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type InvitationLinkEmailFilters = {
  OR?: InputMaybe<Array<InvitationLinkEmailfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type InvitationLinkEmailfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type InvitationLinkExpiresAtFilters = {
  OR?: InputMaybe<Array<InvitationLinkExpiresAtfiltersOr>>;
  /** Date */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type InvitationLinkExpiresAtfiltersOr = {
  /** Date */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Date */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<Date> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type InvitationLinkFilters = {
  OR?: InputMaybe<Array<InvitationLinkFiltersOr>>;
  acceptedById?: InputMaybe<InvitationLinkAcceptedByIdFilters>;
  brandId?: InputMaybe<InvitationLinkBrandIdFilters>;
  createdAtUtc?: InputMaybe<InvitationLinkCreatedAtUtcFilters>;
  createdById?: InputMaybe<InvitationLinkCreatedByIdFilters>;
  email?: InputMaybe<InvitationLinkEmailFilters>;
  expiresAt?: InputMaybe<InvitationLinkExpiresAtFilters>;
  id?: InputMaybe<InvitationLinkIdFilters>;
  role?: InputMaybe<InvitationLinkRoleFilters>;
  updatedAtUtc?: InputMaybe<InvitationLinkUpdatedAtUtcFilters>;
  venueId?: InputMaybe<InvitationLinkVenueIdFilters>;
};

export type InvitationLinkFiltersOr = {
  acceptedById?: InputMaybe<InvitationLinkAcceptedByIdFilters>;
  brandId?: InputMaybe<InvitationLinkBrandIdFilters>;
  createdAtUtc?: InputMaybe<InvitationLinkCreatedAtUtcFilters>;
  createdById?: InputMaybe<InvitationLinkCreatedByIdFilters>;
  email?: InputMaybe<InvitationLinkEmailFilters>;
  expiresAt?: InputMaybe<InvitationLinkExpiresAtFilters>;
  id?: InputMaybe<InvitationLinkIdFilters>;
  role?: InputMaybe<InvitationLinkRoleFilters>;
  updatedAtUtc?: InputMaybe<InvitationLinkUpdatedAtUtcFilters>;
  venueId?: InputMaybe<InvitationLinkVenueIdFilters>;
};

export type InvitationLinkIdFilters = {
  OR?: InputMaybe<Array<InvitationLinkIdfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type InvitationLinkIdfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type InvitationLinkItem = {
  __typename?: 'InvitationLinkItem';
  acceptedById?: Maybe<Scalars['Int']['output']>;
  brandId?: Maybe<Scalars['Int']['output']>;
  createdAtUtc: Scalars['String']['output'];
  createdById: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  /** Date */
  expiresAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  role: InvitationLinkRoleEnum;
  status: InvitationStatus;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  venueId?: Maybe<Scalars['Int']['output']>;
};

export type InvitationLinkOrderBy = {
  acceptedById?: InputMaybe<InnerOrder>;
  brandId?: InputMaybe<InnerOrder>;
  createdAtUtc?: InputMaybe<InnerOrder>;
  createdById?: InputMaybe<InnerOrder>;
  email?: InputMaybe<InnerOrder>;
  expiresAt?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  role?: InputMaybe<InnerOrder>;
  updatedAtUtc?: InputMaybe<InnerOrder>;
  venueId?: InputMaybe<InnerOrder>;
};

export enum InvitationLinkRoleEnum {
  /** Value: ADMIN */
  Admin = 'ADMIN',
  /** Value: OWNER */
  Owner = 'OWNER',
  /** Value: USER */
  User = 'USER'
}

export type InvitationLinkRoleFilters = {
  OR?: InputMaybe<Array<InvitationLinkRolefiltersOr>>;
  eq?: InputMaybe<InvitationLinkRoleEnum>;
  gt?: InputMaybe<InvitationLinkRoleEnum>;
  gte?: InputMaybe<InvitationLinkRoleEnum>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<InvitationLinkRoleEnum>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<InvitationLinkRoleEnum>;
  lte?: InputMaybe<InvitationLinkRoleEnum>;
  ne?: InputMaybe<InvitationLinkRoleEnum>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<InvitationLinkRoleEnum>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type InvitationLinkRolefiltersOr = {
  eq?: InputMaybe<InvitationLinkRoleEnum>;
  gt?: InputMaybe<InvitationLinkRoleEnum>;
  gte?: InputMaybe<InvitationLinkRoleEnum>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<InvitationLinkRoleEnum>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<InvitationLinkRoleEnum>;
  lte?: InputMaybe<InvitationLinkRoleEnum>;
  ne?: InputMaybe<InvitationLinkRoleEnum>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<InvitationLinkRoleEnum>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type InvitationLinkSelectItem = {
  __typename?: 'InvitationLinkSelectItem';
  acceptedById?: Maybe<Scalars['Int']['output']>;
  brandId?: Maybe<Scalars['Int']['output']>;
  createdAtUtc: Scalars['String']['output'];
  createdById: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  /** Date */
  expiresAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  role: InvitationLinkRoleEnum;
  status: InvitationStatus;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  venueId?: Maybe<Scalars['Int']['output']>;
};

export type InvitationLinkUpdatedAtUtcFilters = {
  OR?: InputMaybe<Array<InvitationLinkUpdatedAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type InvitationLinkUpdatedAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type InvitationLinkVenueIdFilters = {
  OR?: InputMaybe<Array<InvitationLinkVenueIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type InvitationLinkVenueIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export enum InvitationStatus {
  Accepted = 'ACCEPTED',
  Active = 'ACTIVE',
  Expired = 'EXPIRED'
}

export type Invoice = {
  __typename?: 'Invoice';
  createdAt: Scalars['Int']['output'];
  customerId?: Maybe<Scalars['String']['output']>;
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  pdfUrl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export type LinkAccountWithExternalProviderInput = {
  companyId: Scalars['NonNegativeInt']['input'];
  integrationType: IntegrationType;
  metadata?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type LinkBrandAccountWithBookerForRetoolInput = {
  brandId: Scalars['NonNegativeInt']['input'];
  externalCompanyId: Scalars['NonEmptyString']['input'];
  externalUserId?: InputMaybe<Scalars['NonEmptyString']['input']>;
  userId?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type ListingTypeCreatedAtUtcFilters = {
  OR?: InputMaybe<Array<ListingTypeCreatedAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ListingTypeCreatedAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ListingTypeFilters = {
  OR?: InputMaybe<Array<ListingTypeFiltersOr>>;
  createdAtUtc?: InputMaybe<ListingTypeCreatedAtUtcFilters>;
  id?: InputMaybe<ListingTypeIdFilters>;
  localizationKey?: InputMaybe<ListingTypeLocalizationKeyFilters>;
  order?: InputMaybe<ListingTypeOrderFilters>;
  region?: InputMaybe<ListingTypeRegionFilters>;
  suggestedListingLengthInMonths?: InputMaybe<ListingTypeSuggestedListingLengthInMonthsFilters>;
  suggestedTenderLengthInMonths?: InputMaybe<ListingTypeSuggestedTenderLengthInMonthsFilters>;
  updatedAtUtc?: InputMaybe<ListingTypeUpdatedAtUtcFilters>;
};

export type ListingTypeFiltersOr = {
  createdAtUtc?: InputMaybe<ListingTypeCreatedAtUtcFilters>;
  id?: InputMaybe<ListingTypeIdFilters>;
  localizationKey?: InputMaybe<ListingTypeLocalizationKeyFilters>;
  order?: InputMaybe<ListingTypeOrderFilters>;
  region?: InputMaybe<ListingTypeRegionFilters>;
  suggestedListingLengthInMonths?: InputMaybe<ListingTypeSuggestedListingLengthInMonthsFilters>;
  suggestedTenderLengthInMonths?: InputMaybe<ListingTypeSuggestedTenderLengthInMonthsFilters>;
  updatedAtUtc?: InputMaybe<ListingTypeUpdatedAtUtcFilters>;
};

export type ListingTypeIdFilters = {
  OR?: InputMaybe<Array<ListingTypeIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ListingTypeIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ListingTypeItem = {
  __typename?: 'ListingTypeItem';
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  localizationKey: Scalars['String']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  region?: Maybe<Scalars['String']['output']>;
  suggestedListingLengthInMonths: Scalars['Int']['output'];
  suggestedTenderLengthInMonths: Scalars['Int']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type ListingTypeLocalizationKeyFilters = {
  OR?: InputMaybe<Array<ListingTypeLocalizationKeyfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ListingTypeLocalizationKeyfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ListingTypeOrderFilters = {
  OR?: InputMaybe<Array<ListingTypeOrderfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ListingTypeOrderfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ListingTypeRegion2Filters = {
  OR?: InputMaybe<Array<ListingTypeRegion2FiltersOr>>;
  listingTypeId?: InputMaybe<ListingTypeRegion2ListingTypeIdFilters>;
  region?: InputMaybe<ListingTypeRegion2RegionFilters>;
};

export type ListingTypeRegion2FiltersOr = {
  listingTypeId?: InputMaybe<ListingTypeRegion2ListingTypeIdFilters>;
  region?: InputMaybe<ListingTypeRegion2RegionFilters>;
};

export type ListingTypeRegion2ListingTypeIdFilters = {
  OR?: InputMaybe<Array<ListingTypeRegion2ListingTypeIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ListingTypeRegion2ListingTypeIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ListingTypeRegion2OrderBy = {
  listingTypeId?: InputMaybe<InnerOrder>;
  region?: InputMaybe<InnerOrder>;
};

export type ListingTypeRegion2RegionFilters = {
  OR?: InputMaybe<Array<ListingTypeRegion2RegionfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ListingTypeRegion2RegionfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ListingTypeRegionFilters = {
  OR?: InputMaybe<Array<ListingTypeRegionfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ListingTypeRegionfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ListingTypeRegionsRelation = {
  __typename?: 'ListingTypeRegionsRelation';
  listingTypeId: Scalars['Int']['output'];
  region: Scalars['String']['output'];
};

export type ListingTypeSelectItem = {
  __typename?: 'ListingTypeSelectItem';
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  localizationKey: Scalars['String']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  region?: Maybe<Scalars['String']['output']>;
  regions: Array<ListingTypeRegionsRelation>;
  suggestedListingLengthInMonths: Scalars['Int']['output'];
  suggestedTenderLengthInMonths: Scalars['Int']['output'];
  tenderDrafts: Array<ListingTypeTenderDraftsRelation>;
  tenders: Array<ListingTypeTendersRelation>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};


export type ListingTypeSelectItemRegionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ListingTypeRegion2OrderBy>;
  where?: InputMaybe<ListingTypeRegion2Filters>;
};


export type ListingTypeSelectItemTenderDraftsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TenderDraftOrderBy>;
  where?: InputMaybe<TenderDraftFilters>;
};


export type ListingTypeSelectItemTendersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TenderOrderBy>;
  where?: InputMaybe<TenderFilters>;
};

export type ListingTypeSuggestedListingLengthInMonthsFilters = {
  OR?: InputMaybe<Array<ListingTypeSuggestedListingLengthInMonthsfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ListingTypeSuggestedListingLengthInMonthsfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ListingTypeSuggestedTenderLengthInMonthsFilters = {
  OR?: InputMaybe<Array<ListingTypeSuggestedTenderLengthInMonthsfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ListingTypeSuggestedTenderLengthInMonthsfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ListingTypeTenderDraftsRelation = {
  __typename?: 'ListingTypeTenderDraftsRelation';
  createdAtUtc: Scalars['String']['output'];
  estimatedVolume?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isAnyWholesalerCompatible?: Maybe<Scalars['Boolean']['output']>;
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  listingEndsAtUtc?: Maybe<Scalars['String']['output']>;
  listingStartsAtUtc?: Maybe<Scalars['String']['output']>;
  listingTypeId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  packagingType?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  supportDetails?: Maybe<Scalars['String']['output']>;
  supportsDiscount: Scalars['String']['output'];
  supportsFreeStock: Scalars['String']['output'];
  supportsListingFee: Scalars['String']['output'];
  supportsPosBudget: Scalars['String']['output'];
  supportsRetroDiscount: Scalars['String']['output'];
  tenderDetails?: Maybe<Scalars['String']['output']>;
  tenderEndsAtUtc?: Maybe<Scalars['String']['output']>;
  tenderStartsAtUtc?: Maybe<Scalars['String']['output']>;
  unitType?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
  venueId: Scalars['Int']['output'];
  volumeDetails?: Maybe<Scalars['String']['output']>;
  volumeUnits?: Maybe<Scalars['Float']['output']>;
};

export type ListingTypeTendersRelation = {
  __typename?: 'ListingTypeTendersRelation';
  connectBids: Array<ListingTypeTendersRelationConnectBidsRelation>;
  createdAtUtc: Scalars['String']['output'];
  estimatedVolume: Scalars['Int']['output'];
  feedback?: Maybe<Scalars['String']['output']>;
  hostingChargeInvoiceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAnyWholesalerCompatible?: Maybe<Scalars['Boolean']['output']>;
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  listingEndsAtUtc: Scalars['String']['output'];
  listingStartsAtUtc: Scalars['String']['output'];
  listingType?: Maybe<ListingTypeTendersRelationListingTypeRelation>;
  listingTypeId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  notifications: Array<ListingTypeTendersRelationNotificationsRelation>;
  originalTenderEndsAtUtc?: Maybe<Scalars['String']['output']>;
  packagingType?: Maybe<Scalars['String']['output']>;
  productCategories: Array<ListingTypeTendersRelationProductCategoriesRelation>;
  productPackaging?: Maybe<ListingTypeTendersRelationProductPackagingRelation>;
  receivedSupportStatus: Scalars['String']['output'];
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  supportDetails?: Maybe<Scalars['String']['output']>;
  supportsDiscount: Scalars['String']['output'];
  supportsFreeStock: Scalars['String']['output'];
  supportsListingFee: Scalars['String']['output'];
  supportsPosBudget: Scalars['String']['output'];
  supportsRetroDiscount: Scalars['String']['output'];
  tenderDetails?: Maybe<Scalars['String']['output']>;
  tenderEndsAtUtc?: Maybe<Scalars['String']['output']>;
  tenderStartsAtUtc?: Maybe<Scalars['String']['output']>;
  tenderWholesalers: Array<ListingTypeTendersRelationTenderWholesalersRelation>;
  unit?: Maybe<ListingTypeTendersRelationUnitRelation>;
  unitType: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<ListingTypeTendersRelationUserRelation>;
  userId: Scalars['Int']['output'];
  venue?: Maybe<ListingTypeTendersRelationVenueRelation>;
  venueId: Scalars['Int']['output'];
  volumeDetails?: Maybe<Scalars['String']['output']>;
  volumeUnits: Scalars['Float']['output'];
};


export type ListingTypeTendersRelationConnectBidsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ConnectBidOrderBy>;
  where?: InputMaybe<ConnectBidFilters>;
};


export type ListingTypeTendersRelationListingTypeArgs = {
  where?: InputMaybe<ListingTypeFilters>;
};


export type ListingTypeTendersRelationNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<NotificationOrderBy>;
  where?: InputMaybe<NotificationFilters>;
};


export type ListingTypeTendersRelationProductCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TenderProductCategoriesOrderBy>;
  where?: InputMaybe<TenderProductCategoriesFilters>;
};


export type ListingTypeTendersRelationProductPackagingArgs = {
  where?: InputMaybe<ProductPackagingFilters>;
};


export type ListingTypeTendersRelationTenderWholesalersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TenderWholesalerOrderBy>;
  where?: InputMaybe<TenderWholesalerFilters>;
};


export type ListingTypeTendersRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type ListingTypeTendersRelationUserArgs = {
  where?: InputMaybe<UserFilters>;
};


export type ListingTypeTendersRelationVenueArgs = {
  where?: InputMaybe<VenueFilters>;
};

export type ListingTypeTendersRelationConnectBidsRelation = {
  __typename?: 'ListingTypeTendersRelationConnectBidsRelation';
  bidId: Scalars['Int']['output'];
  commonBid?: Maybe<ListingTypeTendersRelationConnectBidsRelationCommonBidRelation>;
  matchBid?: Maybe<ListingTypeTendersRelationConnectBidsRelationMatchBidRelation>;
  matchBidId?: Maybe<Scalars['Int']['output']>;
  tender?: Maybe<ListingTypeTendersRelationConnectBidsRelationTenderRelation>;
  tenderId: Scalars['Int']['output'];
};


export type ListingTypeTendersRelationConnectBidsRelationCommonBidArgs = {
  where?: InputMaybe<CommonBidFilters>;
};


export type ListingTypeTendersRelationConnectBidsRelationMatchBidArgs = {
  where?: InputMaybe<MatchBidFilters>;
};


export type ListingTypeTendersRelationConnectBidsRelationTenderArgs = {
  where?: InputMaybe<TenderFilters>;
};

export type ListingTypeTendersRelationConnectBidsRelationCommonBidRelation = {
  __typename?: 'ListingTypeTendersRelationConnectBidsRelationCommonBidRelation';
  brand?: Maybe<ListingTypeTendersRelationConnectBidsRelationCommonBidRelationBrandRelation>;
  brandId: Scalars['Int']['output'];
  connectBid?: Maybe<ListingTypeTendersRelationConnectBidsRelationCommonBidRelationConnectBidRelation>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  matchBid?: Maybe<ListingTypeTendersRelationConnectBidsRelationCommonBidRelationMatchBidRelation>;
  otherSupportAndTerms?: Maybe<Scalars['String']['output']>;
  product?: Maybe<ListingTypeTendersRelationConnectBidsRelationCommonBidRelationProductRelation>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  region: CommonBidRegionEnum;
  status: CommonBidStatusEnum;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  supportedWholesalers: Array<ListingTypeTendersRelationConnectBidsRelationCommonBidRelationSupportedWholesalersRelation>;
  supports: Array<ListingTypeTendersRelationConnectBidsRelationCommonBidRelationSupportsRelation>;
  type: CommonBidTypeEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<ListingTypeTendersRelationConnectBidsRelationCommonBidRelationUserRelation>;
  userId: Scalars['Int']['output'];
};


export type ListingTypeTendersRelationConnectBidsRelationCommonBidRelationBrandArgs = {
  where?: InputMaybe<BrandFilters>;
};


export type ListingTypeTendersRelationConnectBidsRelationCommonBidRelationConnectBidArgs = {
  where?: InputMaybe<ConnectBidFilters>;
};


export type ListingTypeTendersRelationConnectBidsRelationCommonBidRelationMatchBidArgs = {
  where?: InputMaybe<MatchBidFilters>;
};


export type ListingTypeTendersRelationConnectBidsRelationCommonBidRelationProductArgs = {
  where?: InputMaybe<CommonBidProductFilters>;
};


export type ListingTypeTendersRelationConnectBidsRelationCommonBidRelationSupportedWholesalersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CommonBidWholesalerOrderBy>;
  where?: InputMaybe<CommonBidWholesalerFilters>;
};


export type ListingTypeTendersRelationConnectBidsRelationCommonBidRelationSupportsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CommonBidSupportOrderBy>;
  where?: InputMaybe<CommonBidSupportFilters>;
};


export type ListingTypeTendersRelationConnectBidsRelationCommonBidRelationUserArgs = {
  where?: InputMaybe<UserFilters>;
};

export type ListingTypeTendersRelationConnectBidsRelationCommonBidRelationBrandRelation = {
  __typename?: 'ListingTypeTendersRelationConnectBidsRelationCommonBidRelationBrandRelation';
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  awrsCompanyName?: Maybe<Scalars['String']['output']>;
  awrsDeregistrationDate?: Maybe<Scalars['String']['output']>;
  awrsNumber?: Maybe<Scalars['String']['output']>;
  awrsPlaceBusiness?: Maybe<Scalars['String']['output']>;
  awrsRegistrationDate?: Maybe<Scalars['String']['output']>;
  awrsStatus?: Maybe<Scalars['String']['output']>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  canSeeOtherBids?: Maybe<Scalars['Boolean']['output']>;
  complianceCheckDate?: Maybe<Scalars['String']['output']>;
  complianceConfirmation?: Maybe<Scalars['String']['output']>;
  complianceNextDate?: Maybe<Scalars['String']['output']>;
  complianceRiskLevel?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  failedPaymentIntentCounter: Scalars['Int']['output'];
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  isAnonymousBidAllowed?: Maybe<Scalars['Boolean']['output']>;
  isEnterpriseSubscriptionRequestSent?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompanyId: Scalars['Int']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripePaymentLink?: Maybe<Scalars['String']['output']>;
  stripePaymentLinkHash?: Maybe<Scalars['String']['output']>;
  stripePaymentType?: Maybe<Scalars['String']['output']>;
  stripeProductPriceId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  vatCompanyName?: Maybe<Scalars['String']['output']>;
  vatConsultationNumber?: Maybe<Scalars['String']['output']>;
  vatCountryCode?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  vatProcessingDate?: Maybe<Scalars['String']['output']>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};

export type ListingTypeTendersRelationConnectBidsRelationCommonBidRelationConnectBidRelation = {
  __typename?: 'ListingTypeTendersRelationConnectBidsRelationCommonBidRelationConnectBidRelation';
  bidId: Scalars['Int']['output'];
  matchBidId?: Maybe<Scalars['Int']['output']>;
  tenderId: Scalars['Int']['output'];
};

export type ListingTypeTendersRelationConnectBidsRelationCommonBidRelationMatchBidRelation = {
  __typename?: 'ListingTypeTendersRelationConnectBidsRelationCommonBidRelationMatchBidRelation';
  autoTenderBid?: Maybe<Scalars['Boolean']['output']>;
  bidId: Scalars['Int']['output'];
  credit?: Maybe<Scalars['Boolean']['output']>;
  listingLength: Scalars['Int']['output'];
  maximumAcceptedDeals: Scalars['Int']['output'];
};

export type ListingTypeTendersRelationConnectBidsRelationCommonBidRelationProductRelation = {
  __typename?: 'ListingTypeTendersRelationConnectBidsRelationCommonBidRelationProductRelation';
  /** JSON */
  attachments?: Maybe<Scalars['String']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  averageWholesalePrice: Scalars['Float']['output'];
  bidId: Scalars['Int']['output'];
  /** JSON */
  image?: Maybe<Scalars['String']['output']>;
  isAnyWholesalerCompatible: Scalars['Boolean']['output'];
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  packagingType: Scalars['String']['output'];
  productCategoryId: Scalars['Int']['output'];
  productTemplateId?: Maybe<Scalars['Int']['output']>;
  unitType: Scalars['String']['output'];
  unitsPerCase: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
  volumePerUnit: Scalars['Float']['output'];
  volumeUnits: Scalars['Float']['output'];
};

export type ListingTypeTendersRelationConnectBidsRelationCommonBidRelationSupportedWholesalersRelation = {
  __typename?: 'ListingTypeTendersRelationConnectBidsRelationCommonBidRelationSupportedWholesalersRelation';
  bidId: Scalars['Int']['output'];
  wholesalerId: Scalars['Int']['output'];
};

export type ListingTypeTendersRelationConnectBidsRelationCommonBidRelationSupportsRelation = {
  __typename?: 'ListingTypeTendersRelationConnectBidsRelationCommonBidRelationSupportsRelation';
  amount: Scalars['Float']['output'];
  /** JSON */
  attachments?: Maybe<Scalars['String']['output']>;
  bidId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isProvided: Scalars['Boolean']['output'];
  isReceived: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  supportType: CommonBidSupportSupportTypeEnum;
};

export type ListingTypeTendersRelationConnectBidsRelationCommonBidRelationUserRelation = {
  __typename?: 'ListingTypeTendersRelationConnectBidsRelationCommonBidRelationUserRelation';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type ListingTypeTendersRelationConnectBidsRelationMatchBidRelation = {
  __typename?: 'ListingTypeTendersRelationConnectBidsRelationMatchBidRelation';
  autoTenderBid?: Maybe<Scalars['Boolean']['output']>;
  bidId: Scalars['Int']['output'];
  commonBid?: Maybe<ListingTypeTendersRelationConnectBidsRelationMatchBidRelationCommonBidRelation>;
  credit?: Maybe<Scalars['Boolean']['output']>;
  listingLength: Scalars['Int']['output'];
  maximumAcceptedDeals: Scalars['Int']['output'];
  product?: Maybe<ListingTypeTendersRelationConnectBidsRelationMatchBidRelationProductRelation>;
  venueCriteria?: Maybe<ListingTypeTendersRelationConnectBidsRelationMatchBidRelationVenueCriteriaRelation>;
};


export type ListingTypeTendersRelationConnectBidsRelationMatchBidRelationCommonBidArgs = {
  where?: InputMaybe<CommonBidFilters>;
};


export type ListingTypeTendersRelationConnectBidsRelationMatchBidRelationProductArgs = {
  where?: InputMaybe<MatchBidProductFilters>;
};


export type ListingTypeTendersRelationConnectBidsRelationMatchBidRelationVenueCriteriaArgs = {
  where?: InputMaybe<MatchBidVenueCriteriaFilters>;
};

export type ListingTypeTendersRelationConnectBidsRelationMatchBidRelationCommonBidRelation = {
  __typename?: 'ListingTypeTendersRelationConnectBidsRelationMatchBidRelationCommonBidRelation';
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  otherSupportAndTerms?: Maybe<Scalars['String']['output']>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  region: CommonBidRegionEnum;
  status: CommonBidStatusEnum;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  type: CommonBidTypeEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type ListingTypeTendersRelationConnectBidsRelationMatchBidRelationProductRelation = {
  __typename?: 'ListingTypeTendersRelationConnectBidsRelationMatchBidRelationProductRelation';
  bidId: Scalars['Int']['output'];
  externalProductId?: Maybe<Scalars['String']['output']>;
  externalProvider?: Maybe<MatchBidProductExternalProviderEnum>;
  productId: Scalars['Int']['output'];
};

export type ListingTypeTendersRelationConnectBidsRelationMatchBidRelationVenueCriteriaRelation = {
  __typename?: 'ListingTypeTendersRelationConnectBidsRelationMatchBidRelationVenueCriteriaRelation';
  bidId: Scalars['Int']['output'];
  capturedTargetedVenues?: Maybe<Scalars['Int']['output']>;
  /** JSON */
  customerTypes?: Maybe<Scalars['String']['output']>;
  listingTypeId: Scalars['Int']['output'];
  /** JSON */
  loyaltyLevels?: Maybe<Scalars['String']['output']>;
  minimumVolume: Scalars['Int']['output'];
  /** JSON */
  regions?: Maybe<Scalars['String']['output']>;
  targetProductCategory?: Maybe<Scalars['Int']['output']>;
  /** JSON */
  venueTypes?: Maybe<Scalars['String']['output']>;
};

export type ListingTypeTendersRelationConnectBidsRelationTenderRelation = {
  __typename?: 'ListingTypeTendersRelationConnectBidsRelationTenderRelation';
  createdAtUtc: Scalars['String']['output'];
  estimatedVolume: Scalars['Int']['output'];
  feedback?: Maybe<Scalars['String']['output']>;
  hostingChargeInvoiceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAnyWholesalerCompatible?: Maybe<Scalars['Boolean']['output']>;
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  listingEndsAtUtc: Scalars['String']['output'];
  listingStartsAtUtc: Scalars['String']['output'];
  listingTypeId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  originalTenderEndsAtUtc?: Maybe<Scalars['String']['output']>;
  packagingType?: Maybe<Scalars['String']['output']>;
  receivedSupportStatus: Scalars['String']['output'];
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  supportDetails?: Maybe<Scalars['String']['output']>;
  supportsDiscount: Scalars['String']['output'];
  supportsFreeStock: Scalars['String']['output'];
  supportsListingFee: Scalars['String']['output'];
  supportsPosBudget: Scalars['String']['output'];
  supportsRetroDiscount: Scalars['String']['output'];
  tenderDetails?: Maybe<Scalars['String']['output']>;
  tenderEndsAtUtc?: Maybe<Scalars['String']['output']>;
  tenderStartsAtUtc?: Maybe<Scalars['String']['output']>;
  unitType: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
  venueId: Scalars['Int']['output'];
  volumeDetails?: Maybe<Scalars['String']['output']>;
  volumeUnits: Scalars['Float']['output'];
};

export type ListingTypeTendersRelationListingTypeRelation = {
  __typename?: 'ListingTypeTendersRelationListingTypeRelation';
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  localizationKey: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  region?: Maybe<Scalars['String']['output']>;
  suggestedListingLengthInMonths: Scalars['Int']['output'];
  suggestedTenderLengthInMonths: Scalars['Int']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type ListingTypeTendersRelationNotificationsRelation = {
  __typename?: 'ListingTypeTendersRelationNotificationsRelation';
  bidId?: Maybe<Scalars['Int']['output']>;
  brandId?: Maybe<Scalars['Int']['output']>;
  category: Scalars['String']['output'];
  createdAtUtc: Scalars['String']['output'];
  fromId?: Maybe<Scalars['Int']['output']>;
  fromType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isRead: Scalars['Boolean']['output'];
  messageId?: Maybe<Scalars['Int']['output']>;
  tenderId?: Maybe<Scalars['Int']['output']>;
  toId: Scalars['Int']['output'];
  toType: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  venueId?: Maybe<Scalars['Int']['output']>;
};

export type ListingTypeTendersRelationProductCategoriesRelation = {
  __typename?: 'ListingTypeTendersRelationProductCategoriesRelation';
  productCategoryId: Scalars['Int']['output'];
  tenderId: Scalars['Int']['output'];
};

export type ListingTypeTendersRelationProductPackagingRelation = {
  __typename?: 'ListingTypeTendersRelationProductPackagingRelation';
  type: Scalars['String']['output'];
};

export type ListingTypeTendersRelationTenderWholesalersRelation = {
  __typename?: 'ListingTypeTendersRelationTenderWholesalersRelation';
  tenderId: Scalars['Int']['output'];
  wholesalerId: Scalars['Int']['output'];
};

export type ListingTypeTendersRelationUnitRelation = {
  __typename?: 'ListingTypeTendersRelationUnitRelation';
  type: Scalars['String']['output'];
};

export type ListingTypeTendersRelationUserRelation = {
  __typename?: 'ListingTypeTendersRelationUserRelation';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type ListingTypeTendersRelationVenueRelation = {
  __typename?: 'ListingTypeTendersRelationVenueRelation';
  address?: Maybe<ListingTypeTendersRelationVenueRelationAddressRelation>;
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<ListingTypeTendersRelationVenueRelationBillingAddressRelation>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompany?: Maybe<ListingTypeTendersRelationVenueRelationRegisteredCompanyRelation>;
  registeredCompanyId: Scalars['Int']['output'];
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  venueCategory?: Maybe<ListingTypeTendersRelationVenueRelationVenueCategoryRelation>;
  venueCategoryId?: Maybe<Scalars['Int']['output']>;
  venueCategoryName?: Maybe<Scalars['String']['output']>;
  venueIntegrations: Array<ListingTypeTendersRelationVenueRelationVenueIntegrationsRelation>;
  venueUsers: Array<ListingTypeTendersRelationVenueRelationVenueUsersRelation>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};


export type ListingTypeTendersRelationVenueRelationAddressArgs = {
  where?: InputMaybe<AddressFilters>;
};


export type ListingTypeTendersRelationVenueRelationBillingAddressArgs = {
  where?: InputMaybe<AddressFilters>;
};


export type ListingTypeTendersRelationVenueRelationRegisteredCompanyArgs = {
  where?: InputMaybe<RegisteredCompanyFilters>;
};


export type ListingTypeTendersRelationVenueRelationVenueCategoryArgs = {
  where?: InputMaybe<VenueCategoryFilters>;
};


export type ListingTypeTendersRelationVenueRelationVenueIntegrationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<VenueIntegrationsOrderBy>;
  where?: InputMaybe<VenueIntegrationsFilters>;
};


export type ListingTypeTendersRelationVenueRelationVenueUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<VenueUserOrderBy>;
  where?: InputMaybe<VenueUserFilters>;
};

export type ListingTypeTendersRelationVenueRelationAddressRelation = {
  __typename?: 'ListingTypeTendersRelationVenueRelationAddressRelation';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type ListingTypeTendersRelationVenueRelationBillingAddressRelation = {
  __typename?: 'ListingTypeTendersRelationVenueRelationBillingAddressRelation';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type ListingTypeTendersRelationVenueRelationRegisteredCompanyRelation = {
  __typename?: 'ListingTypeTendersRelationVenueRelationRegisteredCompanyRelation';
  addressId?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  dateOfCreation?: Maybe<Scalars['String']['output']>;
  firstAddressLine?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  secondAddressLine?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type ListingTypeTendersRelationVenueRelationVenueCategoryRelation = {
  __typename?: 'ListingTypeTendersRelationVenueRelationVenueCategoryRelation';
  id: Scalars['Int']['output'];
  localizationKey: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type ListingTypeTendersRelationVenueRelationVenueIntegrationsRelation = {
  __typename?: 'ListingTypeTendersRelationVenueRelationVenueIntegrationsRelation';
  createdAtUtc: Scalars['String']['output'];
  externalCompanyId: Scalars['String']['output'];
  externalUserId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  integrationType: VenueIntegrationsIntegrationTypeEnum;
  /** JSON */
  metadata?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<ListingTypeTendersRelationVenueRelationVenueIntegrationsRelationUserRelation>;
  userId: Scalars['Int']['output'];
  venue?: Maybe<ListingTypeTendersRelationVenueRelationVenueIntegrationsRelationVenueRelation>;
  venueId: Scalars['Int']['output'];
};


export type ListingTypeTendersRelationVenueRelationVenueIntegrationsRelationUserArgs = {
  where?: InputMaybe<UserFilters>;
};


export type ListingTypeTendersRelationVenueRelationVenueIntegrationsRelationVenueArgs = {
  where?: InputMaybe<VenueFilters>;
};

export type ListingTypeTendersRelationVenueRelationVenueIntegrationsRelationUserRelation = {
  __typename?: 'ListingTypeTendersRelationVenueRelationVenueIntegrationsRelationUserRelation';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type ListingTypeTendersRelationVenueRelationVenueIntegrationsRelationVenueRelation = {
  __typename?: 'ListingTypeTendersRelationVenueRelationVenueIntegrationsRelationVenueRelation';
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompanyId: Scalars['Int']['output'];
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  venueCategoryId?: Maybe<Scalars['Int']['output']>;
  venueCategoryName?: Maybe<Scalars['String']['output']>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};

export type ListingTypeTendersRelationVenueRelationVenueUsersRelation = {
  __typename?: 'ListingTypeTendersRelationVenueRelationVenueUsersRelation';
  createdAtUtc: Scalars['String']['output'];
  role: VenueUserRoleEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<ListingTypeTendersRelationVenueRelationVenueUsersRelationUserRelation>;
  userId: Scalars['Int']['output'];
  venue?: Maybe<ListingTypeTendersRelationVenueRelationVenueUsersRelationVenueRelation>;
  venueId: Scalars['Int']['output'];
};


export type ListingTypeTendersRelationVenueRelationVenueUsersRelationUserArgs = {
  where?: InputMaybe<UserFilters>;
};


export type ListingTypeTendersRelationVenueRelationVenueUsersRelationVenueArgs = {
  where?: InputMaybe<VenueFilters>;
};

export type ListingTypeTendersRelationVenueRelationVenueUsersRelationUserRelation = {
  __typename?: 'ListingTypeTendersRelationVenueRelationVenueUsersRelationUserRelation';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type ListingTypeTendersRelationVenueRelationVenueUsersRelationVenueRelation = {
  __typename?: 'ListingTypeTendersRelationVenueRelationVenueUsersRelationVenueRelation';
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompanyId: Scalars['Int']['output'];
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  venueCategoryId?: Maybe<Scalars['Int']['output']>;
  venueCategoryName?: Maybe<Scalars['String']['output']>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};

export type ListingTypeUpdatedAtUtcFilters = {
  OR?: InputMaybe<Array<ListingTypeUpdatedAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ListingTypeUpdatedAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type LiveStats = {
  __typename?: 'LiveStats';
  activeBidGrossMerchandiseValue: Scalars['Float']['output'];
  activeTenders: Scalars['Int']['output'];
  matchBids: Scalars['Int']['output'];
};

export type LocationByCoordinatesInput = {
  latitude: Scalars['String']['input'];
  longitude: Scalars['String']['input'];
};

export type MainProductCategory = {
  __typename?: 'MainProductCategory';
  createdAtUtc: Scalars['String']['output'];
  defaultPackagingType?: Maybe<Scalars['String']['output']>;
  defaultVolume?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isPublished: Scalars['Boolean']['output'];
  localizationKey: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentCategory?: Maybe<ProductCategoryParentCategoryRelation>;
  parentId?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  regions: Array<ProductCategoryRegionsRelation>;
  subCategories: Array<ProductCategoryItem>;
  unit?: Maybe<ProductCategoryUnitRelation>;
  unitType?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type MarkAllNotificationsAsReadInput = {
  category: NotificationCategory;
  toId: Scalars['Int']['input'];
  toType: NotificationTargetType;
};

export type MatchBidAcceptedDealsCountItem = {
  __typename?: 'MatchBidAcceptedDealsCountItem';
  bidId: Scalars['NonNegativeInt']['output'];
  count: Scalars['NonNegativeInt']['output'];
};

export type MatchBidAutoTenderBidFilters = {
  OR?: InputMaybe<Array<MatchBidAutoTenderBidfiltersOr>>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MatchBidAutoTenderBidfiltersOr = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MatchBidBidIdFilters = {
  OR?: InputMaybe<Array<MatchBidBidIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MatchBidBidIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MatchBidCommonBidRelation = {
  __typename?: 'MatchBidCommonBidRelation';
  brand?: Maybe<MatchBidCommonBidRelationBrandRelation>;
  brandId: Scalars['Int']['output'];
  connectBid?: Maybe<MatchBidCommonBidRelationConnectBidRelation>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  matchBid?: Maybe<MatchBidCommonBidRelationMatchBidRelation>;
  otherSupportAndTerms?: Maybe<Scalars['String']['output']>;
  product?: Maybe<MatchBidCommonBidRelationProductRelation>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  region: CommonBidRegionEnum;
  status: CommonBidStatusEnum;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  supportedWholesalers: Array<MatchBidCommonBidRelationSupportedWholesalersRelation>;
  supports: Array<MatchBidCommonBidRelationSupportsRelation>;
  type: CommonBidTypeEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<MatchBidCommonBidRelationUserRelation>;
  userId: Scalars['Int']['output'];
};


export type MatchBidCommonBidRelationBrandArgs = {
  where?: InputMaybe<BrandFilters>;
};


export type MatchBidCommonBidRelationConnectBidArgs = {
  where?: InputMaybe<ConnectBidFilters>;
};


export type MatchBidCommonBidRelationMatchBidArgs = {
  where?: InputMaybe<MatchBidFilters>;
};


export type MatchBidCommonBidRelationProductArgs = {
  where?: InputMaybe<CommonBidProductFilters>;
};


export type MatchBidCommonBidRelationSupportedWholesalersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CommonBidWholesalerOrderBy>;
  where?: InputMaybe<CommonBidWholesalerFilters>;
};


export type MatchBidCommonBidRelationSupportsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CommonBidSupportOrderBy>;
  where?: InputMaybe<CommonBidSupportFilters>;
};


export type MatchBidCommonBidRelationUserArgs = {
  where?: InputMaybe<UserFilters>;
};

export type MatchBidCommonBidRelationBrandRelation = {
  __typename?: 'MatchBidCommonBidRelationBrandRelation';
  address?: Maybe<MatchBidCommonBidRelationBrandRelationAddressRelation>;
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  awrsCompanyName?: Maybe<Scalars['String']['output']>;
  awrsDeregistrationDate?: Maybe<Scalars['String']['output']>;
  awrsNumber?: Maybe<Scalars['String']['output']>;
  awrsPlaceBusiness?: Maybe<Scalars['String']['output']>;
  awrsRegistrationDate?: Maybe<Scalars['String']['output']>;
  awrsStatus?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<MatchBidCommonBidRelationBrandRelationBillingAddressRelation>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  brandIntegrations: Array<MatchBidCommonBidRelationBrandRelationBrandIntegrationsRelation>;
  brandUsers: Array<MatchBidCommonBidRelationBrandRelationBrandUsersRelation>;
  canSeeOtherBids?: Maybe<Scalars['Boolean']['output']>;
  complianceCheckDate?: Maybe<Scalars['String']['output']>;
  complianceConfirmation?: Maybe<Scalars['String']['output']>;
  complianceNextDate?: Maybe<Scalars['String']['output']>;
  complianceRiskLevel?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  failedPaymentIntentCounter: Scalars['Int']['output'];
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  isAnonymousBidAllowed?: Maybe<Scalars['Boolean']['output']>;
  isEnterpriseSubscriptionRequestSent?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompany?: Maybe<MatchBidCommonBidRelationBrandRelationRegisteredCompanyRelation>;
  registeredCompanyId: Scalars['Int']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripePaymentLink?: Maybe<Scalars['String']['output']>;
  stripePaymentLinkHash?: Maybe<Scalars['String']['output']>;
  stripePaymentType?: Maybe<Scalars['String']['output']>;
  stripeProductPriceId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  tradingAddress?: Maybe<MatchBidCommonBidRelationBrandRelationTradingAddressRelation>;
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  vatCompanyName?: Maybe<Scalars['String']['output']>;
  vatConsultationNumber?: Maybe<Scalars['String']['output']>;
  vatCountryCode?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  vatProcessingDate?: Maybe<Scalars['String']['output']>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};


export type MatchBidCommonBidRelationBrandRelationAddressArgs = {
  where?: InputMaybe<AddressFilters>;
};


export type MatchBidCommonBidRelationBrandRelationBillingAddressArgs = {
  where?: InputMaybe<AddressFilters>;
};


export type MatchBidCommonBidRelationBrandRelationBrandIntegrationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BrandIntegrationsOrderBy>;
  where?: InputMaybe<BrandIntegrationsFilters>;
};


export type MatchBidCommonBidRelationBrandRelationBrandUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BrandUserOrderBy>;
  where?: InputMaybe<BrandUserFilters>;
};


export type MatchBidCommonBidRelationBrandRelationRegisteredCompanyArgs = {
  where?: InputMaybe<RegisteredCompanyFilters>;
};


export type MatchBidCommonBidRelationBrandRelationTradingAddressArgs = {
  where?: InputMaybe<AddressFilters>;
};

export type MatchBidCommonBidRelationBrandRelationAddressRelation = {
  __typename?: 'MatchBidCommonBidRelationBrandRelationAddressRelation';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type MatchBidCommonBidRelationBrandRelationBillingAddressRelation = {
  __typename?: 'MatchBidCommonBidRelationBrandRelationBillingAddressRelation';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type MatchBidCommonBidRelationBrandRelationBrandIntegrationsRelation = {
  __typename?: 'MatchBidCommonBidRelationBrandRelationBrandIntegrationsRelation';
  brand?: Maybe<MatchBidCommonBidRelationBrandRelationBrandIntegrationsRelationBrandRelation>;
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  externalCompanyId: Scalars['String']['output'];
  externalUserId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  integrationType: BrandIntegrationsIntegrationTypeEnum;
  /** JSON */
  metadata?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<MatchBidCommonBidRelationBrandRelationBrandIntegrationsRelationUserRelation>;
  userId: Scalars['Int']['output'];
};


export type MatchBidCommonBidRelationBrandRelationBrandIntegrationsRelationBrandArgs = {
  where?: InputMaybe<BrandFilters>;
};


export type MatchBidCommonBidRelationBrandRelationBrandIntegrationsRelationUserArgs = {
  where?: InputMaybe<UserFilters>;
};

export type MatchBidCommonBidRelationBrandRelationBrandIntegrationsRelationBrandRelation = {
  __typename?: 'MatchBidCommonBidRelationBrandRelationBrandIntegrationsRelationBrandRelation';
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  awrsCompanyName?: Maybe<Scalars['String']['output']>;
  awrsDeregistrationDate?: Maybe<Scalars['String']['output']>;
  awrsNumber?: Maybe<Scalars['String']['output']>;
  awrsPlaceBusiness?: Maybe<Scalars['String']['output']>;
  awrsRegistrationDate?: Maybe<Scalars['String']['output']>;
  awrsStatus?: Maybe<Scalars['String']['output']>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  canSeeOtherBids?: Maybe<Scalars['Boolean']['output']>;
  complianceCheckDate?: Maybe<Scalars['String']['output']>;
  complianceConfirmation?: Maybe<Scalars['String']['output']>;
  complianceNextDate?: Maybe<Scalars['String']['output']>;
  complianceRiskLevel?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  failedPaymentIntentCounter: Scalars['Int']['output'];
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  isAnonymousBidAllowed?: Maybe<Scalars['Boolean']['output']>;
  isEnterpriseSubscriptionRequestSent?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompanyId: Scalars['Int']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripePaymentLink?: Maybe<Scalars['String']['output']>;
  stripePaymentLinkHash?: Maybe<Scalars['String']['output']>;
  stripePaymentType?: Maybe<Scalars['String']['output']>;
  stripeProductPriceId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  vatCompanyName?: Maybe<Scalars['String']['output']>;
  vatConsultationNumber?: Maybe<Scalars['String']['output']>;
  vatCountryCode?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  vatProcessingDate?: Maybe<Scalars['String']['output']>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};

export type MatchBidCommonBidRelationBrandRelationBrandIntegrationsRelationUserRelation = {
  __typename?: 'MatchBidCommonBidRelationBrandRelationBrandIntegrationsRelationUserRelation';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type MatchBidCommonBidRelationBrandRelationBrandUsersRelation = {
  __typename?: 'MatchBidCommonBidRelationBrandRelationBrandUsersRelation';
  brand?: Maybe<MatchBidCommonBidRelationBrandRelationBrandUsersRelationBrandRelation>;
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  role: BrandUserRoleEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<MatchBidCommonBidRelationBrandRelationBrandUsersRelationUserRelation>;
  userId: Scalars['Int']['output'];
};


export type MatchBidCommonBidRelationBrandRelationBrandUsersRelationBrandArgs = {
  where?: InputMaybe<BrandFilters>;
};


export type MatchBidCommonBidRelationBrandRelationBrandUsersRelationUserArgs = {
  where?: InputMaybe<UserFilters>;
};

export type MatchBidCommonBidRelationBrandRelationBrandUsersRelationBrandRelation = {
  __typename?: 'MatchBidCommonBidRelationBrandRelationBrandUsersRelationBrandRelation';
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  awrsCompanyName?: Maybe<Scalars['String']['output']>;
  awrsDeregistrationDate?: Maybe<Scalars['String']['output']>;
  awrsNumber?: Maybe<Scalars['String']['output']>;
  awrsPlaceBusiness?: Maybe<Scalars['String']['output']>;
  awrsRegistrationDate?: Maybe<Scalars['String']['output']>;
  awrsStatus?: Maybe<Scalars['String']['output']>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  canSeeOtherBids?: Maybe<Scalars['Boolean']['output']>;
  complianceCheckDate?: Maybe<Scalars['String']['output']>;
  complianceConfirmation?: Maybe<Scalars['String']['output']>;
  complianceNextDate?: Maybe<Scalars['String']['output']>;
  complianceRiskLevel?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  failedPaymentIntentCounter: Scalars['Int']['output'];
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  isAnonymousBidAllowed?: Maybe<Scalars['Boolean']['output']>;
  isEnterpriseSubscriptionRequestSent?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompanyId: Scalars['Int']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripePaymentLink?: Maybe<Scalars['String']['output']>;
  stripePaymentLinkHash?: Maybe<Scalars['String']['output']>;
  stripePaymentType?: Maybe<Scalars['String']['output']>;
  stripeProductPriceId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  vatCompanyName?: Maybe<Scalars['String']['output']>;
  vatConsultationNumber?: Maybe<Scalars['String']['output']>;
  vatCountryCode?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  vatProcessingDate?: Maybe<Scalars['String']['output']>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};

export type MatchBidCommonBidRelationBrandRelationBrandUsersRelationUserRelation = {
  __typename?: 'MatchBidCommonBidRelationBrandRelationBrandUsersRelationUserRelation';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type MatchBidCommonBidRelationBrandRelationRegisteredCompanyRelation = {
  __typename?: 'MatchBidCommonBidRelationBrandRelationRegisteredCompanyRelation';
  addressId?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  dateOfCreation?: Maybe<Scalars['String']['output']>;
  firstAddressLine?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  secondAddressLine?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type MatchBidCommonBidRelationBrandRelationTradingAddressRelation = {
  __typename?: 'MatchBidCommonBidRelationBrandRelationTradingAddressRelation';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type MatchBidCommonBidRelationConnectBidRelation = {
  __typename?: 'MatchBidCommonBidRelationConnectBidRelation';
  bidId: Scalars['Int']['output'];
  commonBid?: Maybe<MatchBidCommonBidRelationConnectBidRelationCommonBidRelation>;
  matchBid?: Maybe<MatchBidCommonBidRelationConnectBidRelationMatchBidRelation>;
  matchBidId?: Maybe<Scalars['Int']['output']>;
  tender?: Maybe<MatchBidCommonBidRelationConnectBidRelationTenderRelation>;
  tenderId: Scalars['Int']['output'];
};


export type MatchBidCommonBidRelationConnectBidRelationCommonBidArgs = {
  where?: InputMaybe<CommonBidFilters>;
};


export type MatchBidCommonBidRelationConnectBidRelationMatchBidArgs = {
  where?: InputMaybe<MatchBidFilters>;
};


export type MatchBidCommonBidRelationConnectBidRelationTenderArgs = {
  where?: InputMaybe<TenderFilters>;
};

export type MatchBidCommonBidRelationConnectBidRelationCommonBidRelation = {
  __typename?: 'MatchBidCommonBidRelationConnectBidRelationCommonBidRelation';
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  otherSupportAndTerms?: Maybe<Scalars['String']['output']>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  region: CommonBidRegionEnum;
  status: CommonBidStatusEnum;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  type: CommonBidTypeEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type MatchBidCommonBidRelationConnectBidRelationMatchBidRelation = {
  __typename?: 'MatchBidCommonBidRelationConnectBidRelationMatchBidRelation';
  autoTenderBid?: Maybe<Scalars['Boolean']['output']>;
  bidId: Scalars['Int']['output'];
  credit?: Maybe<Scalars['Boolean']['output']>;
  listingLength: Scalars['Int']['output'];
  maximumAcceptedDeals: Scalars['Int']['output'];
};

export type MatchBidCommonBidRelationConnectBidRelationTenderRelation = {
  __typename?: 'MatchBidCommonBidRelationConnectBidRelationTenderRelation';
  connectBids: Array<MatchBidCommonBidRelationConnectBidRelationTenderRelationConnectBidsRelation>;
  createdAtUtc: Scalars['String']['output'];
  estimatedVolume: Scalars['Int']['output'];
  feedback?: Maybe<Scalars['String']['output']>;
  hostingChargeInvoiceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAnyWholesalerCompatible?: Maybe<Scalars['Boolean']['output']>;
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  listingEndsAtUtc: Scalars['String']['output'];
  listingStartsAtUtc: Scalars['String']['output'];
  listingType?: Maybe<MatchBidCommonBidRelationConnectBidRelationTenderRelationListingTypeRelation>;
  listingTypeId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  notifications: Array<MatchBidCommonBidRelationConnectBidRelationTenderRelationNotificationsRelation>;
  originalTenderEndsAtUtc?: Maybe<Scalars['String']['output']>;
  packagingType?: Maybe<Scalars['String']['output']>;
  productCategories: Array<MatchBidCommonBidRelationConnectBidRelationTenderRelationProductCategoriesRelation>;
  productPackaging?: Maybe<MatchBidCommonBidRelationConnectBidRelationTenderRelationProductPackagingRelation>;
  receivedSupportStatus: Scalars['String']['output'];
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  supportDetails?: Maybe<Scalars['String']['output']>;
  supportsDiscount: Scalars['String']['output'];
  supportsFreeStock: Scalars['String']['output'];
  supportsListingFee: Scalars['String']['output'];
  supportsPosBudget: Scalars['String']['output'];
  supportsRetroDiscount: Scalars['String']['output'];
  tenderDetails?: Maybe<Scalars['String']['output']>;
  tenderEndsAtUtc?: Maybe<Scalars['String']['output']>;
  tenderStartsAtUtc?: Maybe<Scalars['String']['output']>;
  tenderWholesalers: Array<MatchBidCommonBidRelationConnectBidRelationTenderRelationTenderWholesalersRelation>;
  unit?: Maybe<MatchBidCommonBidRelationConnectBidRelationTenderRelationUnitRelation>;
  unitType: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<MatchBidCommonBidRelationConnectBidRelationTenderRelationUserRelation>;
  userId: Scalars['Int']['output'];
  venue?: Maybe<MatchBidCommonBidRelationConnectBidRelationTenderRelationVenueRelation>;
  venueId: Scalars['Int']['output'];
  volumeDetails?: Maybe<Scalars['String']['output']>;
  volumeUnits: Scalars['Float']['output'];
};


export type MatchBidCommonBidRelationConnectBidRelationTenderRelationConnectBidsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ConnectBidOrderBy>;
  where?: InputMaybe<ConnectBidFilters>;
};


export type MatchBidCommonBidRelationConnectBidRelationTenderRelationListingTypeArgs = {
  where?: InputMaybe<ListingTypeFilters>;
};


export type MatchBidCommonBidRelationConnectBidRelationTenderRelationNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<NotificationOrderBy>;
  where?: InputMaybe<NotificationFilters>;
};


export type MatchBidCommonBidRelationConnectBidRelationTenderRelationProductCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TenderProductCategoriesOrderBy>;
  where?: InputMaybe<TenderProductCategoriesFilters>;
};


export type MatchBidCommonBidRelationConnectBidRelationTenderRelationProductPackagingArgs = {
  where?: InputMaybe<ProductPackagingFilters>;
};


export type MatchBidCommonBidRelationConnectBidRelationTenderRelationTenderWholesalersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TenderWholesalerOrderBy>;
  where?: InputMaybe<TenderWholesalerFilters>;
};


export type MatchBidCommonBidRelationConnectBidRelationTenderRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type MatchBidCommonBidRelationConnectBidRelationTenderRelationUserArgs = {
  where?: InputMaybe<UserFilters>;
};


export type MatchBidCommonBidRelationConnectBidRelationTenderRelationVenueArgs = {
  where?: InputMaybe<VenueFilters>;
};

export type MatchBidCommonBidRelationConnectBidRelationTenderRelationConnectBidsRelation = {
  __typename?: 'MatchBidCommonBidRelationConnectBidRelationTenderRelationConnectBidsRelation';
  bidId: Scalars['Int']['output'];
  matchBidId?: Maybe<Scalars['Int']['output']>;
  tenderId: Scalars['Int']['output'];
};

export type MatchBidCommonBidRelationConnectBidRelationTenderRelationListingTypeRelation = {
  __typename?: 'MatchBidCommonBidRelationConnectBidRelationTenderRelationListingTypeRelation';
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  localizationKey: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  region?: Maybe<Scalars['String']['output']>;
  suggestedListingLengthInMonths: Scalars['Int']['output'];
  suggestedTenderLengthInMonths: Scalars['Int']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type MatchBidCommonBidRelationConnectBidRelationTenderRelationNotificationsRelation = {
  __typename?: 'MatchBidCommonBidRelationConnectBidRelationTenderRelationNotificationsRelation';
  bidId?: Maybe<Scalars['Int']['output']>;
  brandId?: Maybe<Scalars['Int']['output']>;
  category: Scalars['String']['output'];
  createdAtUtc: Scalars['String']['output'];
  fromId?: Maybe<Scalars['Int']['output']>;
  fromType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isRead: Scalars['Boolean']['output'];
  messageId?: Maybe<Scalars['Int']['output']>;
  tenderId?: Maybe<Scalars['Int']['output']>;
  toId: Scalars['Int']['output'];
  toType: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  venueId?: Maybe<Scalars['Int']['output']>;
};

export type MatchBidCommonBidRelationConnectBidRelationTenderRelationProductCategoriesRelation = {
  __typename?: 'MatchBidCommonBidRelationConnectBidRelationTenderRelationProductCategoriesRelation';
  productCategoryId: Scalars['Int']['output'];
  tenderId: Scalars['Int']['output'];
};

export type MatchBidCommonBidRelationConnectBidRelationTenderRelationProductPackagingRelation = {
  __typename?: 'MatchBidCommonBidRelationConnectBidRelationTenderRelationProductPackagingRelation';
  type: Scalars['String']['output'];
};

export type MatchBidCommonBidRelationConnectBidRelationTenderRelationTenderWholesalersRelation = {
  __typename?: 'MatchBidCommonBidRelationConnectBidRelationTenderRelationTenderWholesalersRelation';
  tenderId: Scalars['Int']['output'];
  wholesalerId: Scalars['Int']['output'];
};

export type MatchBidCommonBidRelationConnectBidRelationTenderRelationUnitRelation = {
  __typename?: 'MatchBidCommonBidRelationConnectBidRelationTenderRelationUnitRelation';
  type: Scalars['String']['output'];
};

export type MatchBidCommonBidRelationConnectBidRelationTenderRelationUserRelation = {
  __typename?: 'MatchBidCommonBidRelationConnectBidRelationTenderRelationUserRelation';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type MatchBidCommonBidRelationConnectBidRelationTenderRelationVenueRelation = {
  __typename?: 'MatchBidCommonBidRelationConnectBidRelationTenderRelationVenueRelation';
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompanyId: Scalars['Int']['output'];
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  venueCategoryId?: Maybe<Scalars['Int']['output']>;
  venueCategoryName?: Maybe<Scalars['String']['output']>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};

export type MatchBidCommonBidRelationMatchBidRelation = {
  __typename?: 'MatchBidCommonBidRelationMatchBidRelation';
  autoTenderBid?: Maybe<Scalars['Boolean']['output']>;
  bidId: Scalars['Int']['output'];
  credit?: Maybe<Scalars['Boolean']['output']>;
  listingLength: Scalars['Int']['output'];
  maximumAcceptedDeals: Scalars['Int']['output'];
};

export type MatchBidCommonBidRelationProductRelation = {
  __typename?: 'MatchBidCommonBidRelationProductRelation';
  attachments?: Maybe<Array<S3File>>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  averageWholesalePrice: Scalars['Float']['output'];
  bid?: Maybe<MatchBidCommonBidRelationProductRelationBidRelation>;
  bidId: Scalars['Int']['output'];
  image?: Maybe<S3File>;
  isAnyWholesalerCompatible: Scalars['Boolean']['output'];
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  packagingType: Scalars['String']['output'];
  productCategory?: Maybe<MatchBidCommonBidRelationProductRelationProductCategoryRelation>;
  productCategoryId: Scalars['Int']['output'];
  productTemplateId?: Maybe<Scalars['Int']['output']>;
  unitType: Scalars['String']['output'];
  unitsPerCase: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
  volumePerUnit: Scalars['Float']['output'];
  volumeUnits: Scalars['Float']['output'];
};


export type MatchBidCommonBidRelationProductRelationBidArgs = {
  where?: InputMaybe<CommonBidFilters>;
};


export type MatchBidCommonBidRelationProductRelationProductCategoryArgs = {
  where?: InputMaybe<ProductCategoryFilters>;
};

export type MatchBidCommonBidRelationProductRelationBidRelation = {
  __typename?: 'MatchBidCommonBidRelationProductRelationBidRelation';
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  otherSupportAndTerms?: Maybe<Scalars['String']['output']>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  region: CommonBidRegionEnum;
  status: CommonBidStatusEnum;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  type: CommonBidTypeEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type MatchBidCommonBidRelationProductRelationProductCategoryRelation = {
  __typename?: 'MatchBidCommonBidRelationProductRelationProductCategoryRelation';
  createdAtUtc: Scalars['String']['output'];
  defaultPackagingType?: Maybe<Scalars['String']['output']>;
  defaultVolume?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isPublished: Scalars['Boolean']['output'];
  localizationKey: Scalars['String']['output'];
  parentCategory?: Maybe<MatchBidCommonBidRelationProductRelationProductCategoryRelationParentCategoryRelation>;
  parentId?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  regions: Array<MatchBidCommonBidRelationProductRelationProductCategoryRelationRegionsRelation>;
  subCategories: Array<MatchBidCommonBidRelationProductRelationProductCategoryRelationSubCategoriesRelation>;
  unit?: Maybe<MatchBidCommonBidRelationProductRelationProductCategoryRelationUnitRelation>;
  unitType?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};


export type MatchBidCommonBidRelationProductRelationProductCategoryRelationParentCategoryArgs = {
  where?: InputMaybe<ProductCategoryFilters>;
};


export type MatchBidCommonBidRelationProductRelationProductCategoryRelationRegionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProductCategoryRegion2OrderBy>;
  where?: InputMaybe<ProductCategoryRegion2Filters>;
};


export type MatchBidCommonBidRelationProductRelationProductCategoryRelationSubCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProductCategoryOrderBy>;
  where?: InputMaybe<ProductCategoryFilters>;
};


export type MatchBidCommonBidRelationProductRelationProductCategoryRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};

export type MatchBidCommonBidRelationProductRelationProductCategoryRelationParentCategoryRelation = {
  __typename?: 'MatchBidCommonBidRelationProductRelationProductCategoryRelationParentCategoryRelation';
  createdAtUtc: Scalars['String']['output'];
  defaultPackagingType?: Maybe<Scalars['String']['output']>;
  defaultVolume?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isPublished: Scalars['Boolean']['output'];
  localizationKey: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  unitType?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type MatchBidCommonBidRelationProductRelationProductCategoryRelationRegionsRelation = {
  __typename?: 'MatchBidCommonBidRelationProductRelationProductCategoryRelationRegionsRelation';
  productCategoryId: Scalars['Int']['output'];
  region: Scalars['String']['output'];
};

export type MatchBidCommonBidRelationProductRelationProductCategoryRelationSubCategoriesRelation = {
  __typename?: 'MatchBidCommonBidRelationProductRelationProductCategoryRelationSubCategoriesRelation';
  createdAtUtc: Scalars['String']['output'];
  defaultPackagingType?: Maybe<Scalars['String']['output']>;
  defaultVolume?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isPublished: Scalars['Boolean']['output'];
  localizationKey: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  unitType?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type MatchBidCommonBidRelationProductRelationProductCategoryRelationUnitRelation = {
  __typename?: 'MatchBidCommonBidRelationProductRelationProductCategoryRelationUnitRelation';
  type: Scalars['String']['output'];
};

export type MatchBidCommonBidRelationSupportedWholesalersRelation = {
  __typename?: 'MatchBidCommonBidRelationSupportedWholesalersRelation';
  bid?: Maybe<MatchBidCommonBidRelationSupportedWholesalersRelationBidRelation>;
  bidId: Scalars['Int']['output'];
  wholesaler?: Maybe<MatchBidCommonBidRelationSupportedWholesalersRelationWholesalerRelation>;
  wholesalerId: Scalars['Int']['output'];
};


export type MatchBidCommonBidRelationSupportedWholesalersRelationBidArgs = {
  where?: InputMaybe<CommonBidFilters>;
};


export type MatchBidCommonBidRelationSupportedWholesalersRelationWholesalerArgs = {
  where?: InputMaybe<WholesalerFilters>;
};

export type MatchBidCommonBidRelationSupportedWholesalersRelationBidRelation = {
  __typename?: 'MatchBidCommonBidRelationSupportedWholesalersRelationBidRelation';
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  otherSupportAndTerms?: Maybe<Scalars['String']['output']>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  region: CommonBidRegionEnum;
  status: CommonBidStatusEnum;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  type: CommonBidTypeEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type MatchBidCommonBidRelationSupportedWholesalersRelationWholesalerRelation = {
  __typename?: 'MatchBidCommonBidRelationSupportedWholesalersRelationWholesalerRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  region: Scalars['String']['output'];
};

export type MatchBidCommonBidRelationSupportsRelation = {
  __typename?: 'MatchBidCommonBidRelationSupportsRelation';
  amount: Scalars['Float']['output'];
  attachments?: Maybe<Array<S3File>>;
  bid?: Maybe<MatchBidCommonBidRelationSupportsRelationBidRelation>;
  bidId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isProvided: Scalars['Boolean']['output'];
  isReceived: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  supportType: CommonBidSupportSupportTypeEnum;
};


export type MatchBidCommonBidRelationSupportsRelationBidArgs = {
  where?: InputMaybe<CommonBidFilters>;
};

export type MatchBidCommonBidRelationSupportsRelationBidRelation = {
  __typename?: 'MatchBidCommonBidRelationSupportsRelationBidRelation';
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  otherSupportAndTerms?: Maybe<Scalars['String']['output']>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  region: CommonBidRegionEnum;
  status: CommonBidStatusEnum;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  type: CommonBidTypeEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type MatchBidCommonBidRelationUserRelation = {
  __typename?: 'MatchBidCommonBidRelationUserRelation';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type MatchBidCreditFilters = {
  OR?: InputMaybe<Array<MatchBidCreditfiltersOr>>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MatchBidCreditfiltersOr = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export enum MatchBidFilterFieldName {
  CustomerType = 'CustomerType',
  ListingType = 'ListingType',
  ProductName = 'ProductName',
  Region = 'Region',
  Status = 'Status',
  VenueType = 'VenueType'
}

export type MatchBidFilters = {
  OR?: InputMaybe<Array<MatchBidFiltersOr>>;
  autoTenderBid?: InputMaybe<MatchBidAutoTenderBidFilters>;
  bidId?: InputMaybe<MatchBidBidIdFilters>;
  credit?: InputMaybe<MatchBidCreditFilters>;
  listingLength?: InputMaybe<MatchBidListingLengthFilters>;
  maximumAcceptedDeals?: InputMaybe<MatchBidMaximumAcceptedDealsFilters>;
};

export type MatchBidFiltersOr = {
  autoTenderBid?: InputMaybe<MatchBidAutoTenderBidFilters>;
  bidId?: InputMaybe<MatchBidBidIdFilters>;
  credit?: InputMaybe<MatchBidCreditFilters>;
  listingLength?: InputMaybe<MatchBidListingLengthFilters>;
  maximumAcceptedDeals?: InputMaybe<MatchBidMaximumAcceptedDealsFilters>;
};

export type MatchBidInsertInput = {
  autoTenderBid?: InputMaybe<Scalars['Boolean']['input']>;
  brandId: Scalars['Int']['input'];
  credit?: InputMaybe<Scalars['Boolean']['input']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  listingLength?: InputMaybe<Scalars['Int']['input']>;
  maximumAcceptedDeals: Scalars['Int']['input'];
  otherSupportAndTerms?: InputMaybe<Scalars['String']['input']>;
  product: MatchBidProductInsertInput;
  shouldInsertToTenders?: InputMaybe<Scalars['Boolean']['input']>;
  subscriptionTier?: InputMaybe<Scalars['String']['input']>;
  supportedWholesalersIds?: InputMaybe<Array<Scalars['NonNegativeInt']['input']>>;
  supports: Array<CommonBidSupportInsertInput>;
  venueCriteria: MatchBidVenueCriteriaInsertInput;
};

export type MatchBidListingLengthFilters = {
  OR?: InputMaybe<Array<MatchBidListingLengthfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MatchBidListingLengthfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MatchBidMaximumAcceptedDealsFilters = {
  OR?: InputMaybe<Array<MatchBidMaximumAcceptedDealsfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MatchBidMaximumAcceptedDealsfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MatchBidOrderBy = {
  autoTenderBid?: InputMaybe<InnerOrder>;
  bidId?: InputMaybe<InnerOrder>;
  credit?: InputMaybe<InnerOrder>;
  listingLength?: InputMaybe<InnerOrder>;
  maximumAcceptedDeals?: InputMaybe<InnerOrder>;
};

export type MatchBidProductBidIdFilters = {
  OR?: InputMaybe<Array<MatchBidProductBidIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MatchBidProductBidIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MatchBidProductExternalProductIdFilters = {
  OR?: InputMaybe<Array<MatchBidProductExternalProductIdfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MatchBidProductExternalProductIdfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export enum MatchBidProductExternalProviderEnum {
  /** Value: PARAMOUNT_LIQUOR */
  ParamountLiquor = 'PARAMOUNT_LIQUOR',
  /** Value: VENUS_AND_BOOKER */
  VenusAndBooker = 'VENUS_AND_BOOKER'
}

export type MatchBidProductExternalProviderFilters = {
  OR?: InputMaybe<Array<MatchBidProductExternalProviderfiltersOr>>;
  eq?: InputMaybe<MatchBidProductExternalProviderEnum>;
  gt?: InputMaybe<MatchBidProductExternalProviderEnum>;
  gte?: InputMaybe<MatchBidProductExternalProviderEnum>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<MatchBidProductExternalProviderEnum>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<MatchBidProductExternalProviderEnum>;
  lte?: InputMaybe<MatchBidProductExternalProviderEnum>;
  ne?: InputMaybe<MatchBidProductExternalProviderEnum>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<MatchBidProductExternalProviderEnum>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MatchBidProductExternalProviderfiltersOr = {
  eq?: InputMaybe<MatchBidProductExternalProviderEnum>;
  gt?: InputMaybe<MatchBidProductExternalProviderEnum>;
  gte?: InputMaybe<MatchBidProductExternalProviderEnum>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<MatchBidProductExternalProviderEnum>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<MatchBidProductExternalProviderEnum>;
  lte?: InputMaybe<MatchBidProductExternalProviderEnum>;
  ne?: InputMaybe<MatchBidProductExternalProviderEnum>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<MatchBidProductExternalProviderEnum>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MatchBidProductFilters = {
  OR?: InputMaybe<Array<MatchBidProductFiltersOr>>;
  bidId?: InputMaybe<MatchBidProductBidIdFilters>;
  externalProductId?: InputMaybe<MatchBidProductExternalProductIdFilters>;
  externalProvider?: InputMaybe<MatchBidProductExternalProviderFilters>;
  productId?: InputMaybe<MatchBidProductProductIdFilters>;
};

export type MatchBidProductFiltersOr = {
  bidId?: InputMaybe<MatchBidProductBidIdFilters>;
  externalProductId?: InputMaybe<MatchBidProductExternalProductIdFilters>;
  externalProvider?: InputMaybe<MatchBidProductExternalProviderFilters>;
  productId?: InputMaybe<MatchBidProductProductIdFilters>;
};

export type MatchBidProductInsertInput = {
  attachments?: InputMaybe<Array<S3FileInput>>;
  avatarBucketKey?: InputMaybe<Scalars['String']['input']>;
  avatarBucketKeyPreSignedUrl?: InputMaybe<Scalars['String']['input']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: InputMaybe<Scalars['String']['input']>;
  averageWholesalePrice: Scalars['Float']['input'];
  externalProductId?: InputMaybe<Scalars['String']['input']>;
  externalProvider?: InputMaybe<MatchBidProductExternalProviderEnum>;
  image?: InputMaybe<S3FileInput>;
  isAnyWholesalerCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  isDirectSupplyCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  packagingType?: InputMaybe<Scalars['String']['input']>;
  productCategoryId: Scalars['Int']['input'];
  productTemplateId?: InputMaybe<Scalars['Int']['input']>;
  unitType?: InputMaybe<Scalars['String']['input']>;
  unitsPerCase?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  volumePerUnit: Scalars['Float']['input'];
};

export type MatchBidProductProductIdFilters = {
  OR?: InputMaybe<Array<MatchBidProductProductIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MatchBidProductProductIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MatchBidProductRelation = {
  __typename?: 'MatchBidProductRelation';
  bid?: Maybe<MatchBidProductRelationBidRelation>;
  bidId: Scalars['Int']['output'];
  commonProduct?: Maybe<MatchBidProductRelationCommonProductRelation>;
  externalProductId?: Maybe<Scalars['String']['output']>;
  externalProvider?: Maybe<MatchBidProductExternalProviderEnum>;
  productId: Scalars['Int']['output'];
};


export type MatchBidProductRelationBidArgs = {
  where?: InputMaybe<MatchBidFilters>;
};


export type MatchBidProductRelationCommonProductArgs = {
  where?: InputMaybe<CommonBidProductFilters>;
};

export type MatchBidProductRelationBidRelation = {
  __typename?: 'MatchBidProductRelationBidRelation';
  autoTenderBid?: Maybe<Scalars['Boolean']['output']>;
  bidId: Scalars['Int']['output'];
  credit?: Maybe<Scalars['Boolean']['output']>;
  listingLength: Scalars['Int']['output'];
  maximumAcceptedDeals: Scalars['Int']['output'];
};

export type MatchBidProductRelationCommonProductRelation = {
  __typename?: 'MatchBidProductRelationCommonProductRelation';
  /** JSON */
  attachments?: Maybe<Scalars['String']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  averageWholesalePrice: Scalars['Float']['output'];
  bid?: Maybe<MatchBidProductRelationCommonProductRelationBidRelation>;
  bidId: Scalars['Int']['output'];
  /** JSON */
  image?: Maybe<Scalars['String']['output']>;
  isAnyWholesalerCompatible: Scalars['Boolean']['output'];
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  packagingType: Scalars['String']['output'];
  productCategory?: Maybe<MatchBidProductRelationCommonProductRelationProductCategoryRelation>;
  productCategoryId: Scalars['Int']['output'];
  productTemplateId?: Maybe<Scalars['Int']['output']>;
  unitType: Scalars['String']['output'];
  unitsPerCase: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
  volumePerUnit: Scalars['Float']['output'];
  volumeUnits: Scalars['Float']['output'];
};


export type MatchBidProductRelationCommonProductRelationBidArgs = {
  where?: InputMaybe<CommonBidFilters>;
};


export type MatchBidProductRelationCommonProductRelationProductCategoryArgs = {
  where?: InputMaybe<ProductCategoryFilters>;
};

export type MatchBidProductRelationCommonProductRelationBidRelation = {
  __typename?: 'MatchBidProductRelationCommonProductRelationBidRelation';
  brand?: Maybe<MatchBidProductRelationCommonProductRelationBidRelationBrandRelation>;
  brandId: Scalars['Int']['output'];
  connectBid?: Maybe<MatchBidProductRelationCommonProductRelationBidRelationConnectBidRelation>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  matchBid?: Maybe<MatchBidProductRelationCommonProductRelationBidRelationMatchBidRelation>;
  otherSupportAndTerms?: Maybe<Scalars['String']['output']>;
  product?: Maybe<MatchBidProductRelationCommonProductRelationBidRelationProductRelation>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  region: CommonBidRegionEnum;
  status: CommonBidStatusEnum;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  supportedWholesalers: Array<MatchBidProductRelationCommonProductRelationBidRelationSupportedWholesalersRelation>;
  supports: Array<MatchBidProductRelationCommonProductRelationBidRelationSupportsRelation>;
  type: CommonBidTypeEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<MatchBidProductRelationCommonProductRelationBidRelationUserRelation>;
  userId: Scalars['Int']['output'];
};


export type MatchBidProductRelationCommonProductRelationBidRelationBrandArgs = {
  where?: InputMaybe<BrandFilters>;
};


export type MatchBidProductRelationCommonProductRelationBidRelationConnectBidArgs = {
  where?: InputMaybe<ConnectBidFilters>;
};


export type MatchBidProductRelationCommonProductRelationBidRelationMatchBidArgs = {
  where?: InputMaybe<MatchBidFilters>;
};


export type MatchBidProductRelationCommonProductRelationBidRelationProductArgs = {
  where?: InputMaybe<CommonBidProductFilters>;
};


export type MatchBidProductRelationCommonProductRelationBidRelationSupportedWholesalersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CommonBidWholesalerOrderBy>;
  where?: InputMaybe<CommonBidWholesalerFilters>;
};


export type MatchBidProductRelationCommonProductRelationBidRelationSupportsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CommonBidSupportOrderBy>;
  where?: InputMaybe<CommonBidSupportFilters>;
};


export type MatchBidProductRelationCommonProductRelationBidRelationUserArgs = {
  where?: InputMaybe<UserFilters>;
};

export type MatchBidProductRelationCommonProductRelationBidRelationBrandRelation = {
  __typename?: 'MatchBidProductRelationCommonProductRelationBidRelationBrandRelation';
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  awrsCompanyName?: Maybe<Scalars['String']['output']>;
  awrsDeregistrationDate?: Maybe<Scalars['String']['output']>;
  awrsNumber?: Maybe<Scalars['String']['output']>;
  awrsPlaceBusiness?: Maybe<Scalars['String']['output']>;
  awrsRegistrationDate?: Maybe<Scalars['String']['output']>;
  awrsStatus?: Maybe<Scalars['String']['output']>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  canSeeOtherBids?: Maybe<Scalars['Boolean']['output']>;
  complianceCheckDate?: Maybe<Scalars['String']['output']>;
  complianceConfirmation?: Maybe<Scalars['String']['output']>;
  complianceNextDate?: Maybe<Scalars['String']['output']>;
  complianceRiskLevel?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  failedPaymentIntentCounter: Scalars['Int']['output'];
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  isAnonymousBidAllowed?: Maybe<Scalars['Boolean']['output']>;
  isEnterpriseSubscriptionRequestSent?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompanyId: Scalars['Int']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripePaymentLink?: Maybe<Scalars['String']['output']>;
  stripePaymentLinkHash?: Maybe<Scalars['String']['output']>;
  stripePaymentType?: Maybe<Scalars['String']['output']>;
  stripeProductPriceId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  vatCompanyName?: Maybe<Scalars['String']['output']>;
  vatConsultationNumber?: Maybe<Scalars['String']['output']>;
  vatCountryCode?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  vatProcessingDate?: Maybe<Scalars['String']['output']>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};

export type MatchBidProductRelationCommonProductRelationBidRelationConnectBidRelation = {
  __typename?: 'MatchBidProductRelationCommonProductRelationBidRelationConnectBidRelation';
  bidId: Scalars['Int']['output'];
  matchBidId?: Maybe<Scalars['Int']['output']>;
  tenderId: Scalars['Int']['output'];
};

export type MatchBidProductRelationCommonProductRelationBidRelationMatchBidRelation = {
  __typename?: 'MatchBidProductRelationCommonProductRelationBidRelationMatchBidRelation';
  autoTenderBid?: Maybe<Scalars['Boolean']['output']>;
  bidId: Scalars['Int']['output'];
  credit?: Maybe<Scalars['Boolean']['output']>;
  listingLength: Scalars['Int']['output'];
  maximumAcceptedDeals: Scalars['Int']['output'];
};

export type MatchBidProductRelationCommonProductRelationBidRelationProductRelation = {
  __typename?: 'MatchBidProductRelationCommonProductRelationBidRelationProductRelation';
  /** JSON */
  attachments?: Maybe<Scalars['String']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  averageWholesalePrice: Scalars['Float']['output'];
  bidId: Scalars['Int']['output'];
  /** JSON */
  image?: Maybe<Scalars['String']['output']>;
  isAnyWholesalerCompatible: Scalars['Boolean']['output'];
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  packagingType: Scalars['String']['output'];
  productCategoryId: Scalars['Int']['output'];
  productTemplateId?: Maybe<Scalars['Int']['output']>;
  unitType: Scalars['String']['output'];
  unitsPerCase: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
  volumePerUnit: Scalars['Float']['output'];
  volumeUnits: Scalars['Float']['output'];
};

export type MatchBidProductRelationCommonProductRelationBidRelationSupportedWholesalersRelation = {
  __typename?: 'MatchBidProductRelationCommonProductRelationBidRelationSupportedWholesalersRelation';
  bidId: Scalars['Int']['output'];
  wholesalerId: Scalars['Int']['output'];
};

export type MatchBidProductRelationCommonProductRelationBidRelationSupportsRelation = {
  __typename?: 'MatchBidProductRelationCommonProductRelationBidRelationSupportsRelation';
  amount: Scalars['Float']['output'];
  /** JSON */
  attachments?: Maybe<Scalars['String']['output']>;
  bidId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isProvided: Scalars['Boolean']['output'];
  isReceived: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  supportType: CommonBidSupportSupportTypeEnum;
};

export type MatchBidProductRelationCommonProductRelationBidRelationUserRelation = {
  __typename?: 'MatchBidProductRelationCommonProductRelationBidRelationUserRelation';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type MatchBidProductRelationCommonProductRelationProductCategoryRelation = {
  __typename?: 'MatchBidProductRelationCommonProductRelationProductCategoryRelation';
  createdAtUtc: Scalars['String']['output'];
  defaultPackagingType?: Maybe<Scalars['String']['output']>;
  defaultVolume?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isPublished: Scalars['Boolean']['output'];
  localizationKey: Scalars['String']['output'];
  parentCategory?: Maybe<MatchBidProductRelationCommonProductRelationProductCategoryRelationParentCategoryRelation>;
  parentId?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  regions: Array<MatchBidProductRelationCommonProductRelationProductCategoryRelationRegionsRelation>;
  subCategories: Array<MatchBidProductRelationCommonProductRelationProductCategoryRelationSubCategoriesRelation>;
  unit?: Maybe<MatchBidProductRelationCommonProductRelationProductCategoryRelationUnitRelation>;
  unitType?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};


export type MatchBidProductRelationCommonProductRelationProductCategoryRelationParentCategoryArgs = {
  where?: InputMaybe<ProductCategoryFilters>;
};


export type MatchBidProductRelationCommonProductRelationProductCategoryRelationRegionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProductCategoryRegion2OrderBy>;
  where?: InputMaybe<ProductCategoryRegion2Filters>;
};


export type MatchBidProductRelationCommonProductRelationProductCategoryRelationSubCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProductCategoryOrderBy>;
  where?: InputMaybe<ProductCategoryFilters>;
};


export type MatchBidProductRelationCommonProductRelationProductCategoryRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};

export type MatchBidProductRelationCommonProductRelationProductCategoryRelationParentCategoryRelation = {
  __typename?: 'MatchBidProductRelationCommonProductRelationProductCategoryRelationParentCategoryRelation';
  createdAtUtc: Scalars['String']['output'];
  defaultPackagingType?: Maybe<Scalars['String']['output']>;
  defaultVolume?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isPublished: Scalars['Boolean']['output'];
  localizationKey: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  unitType?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type MatchBidProductRelationCommonProductRelationProductCategoryRelationRegionsRelation = {
  __typename?: 'MatchBidProductRelationCommonProductRelationProductCategoryRelationRegionsRelation';
  productCategoryId: Scalars['Int']['output'];
  region: Scalars['String']['output'];
};

export type MatchBidProductRelationCommonProductRelationProductCategoryRelationSubCategoriesRelation = {
  __typename?: 'MatchBidProductRelationCommonProductRelationProductCategoryRelationSubCategoriesRelation';
  createdAtUtc: Scalars['String']['output'];
  defaultPackagingType?: Maybe<Scalars['String']['output']>;
  defaultVolume?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isPublished: Scalars['Boolean']['output'];
  localizationKey: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  unitType?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type MatchBidProductRelationCommonProductRelationProductCategoryRelationUnitRelation = {
  __typename?: 'MatchBidProductRelationCommonProductRelationProductCategoryRelationUnitRelation';
  type: Scalars['String']['output'];
};

export type MatchBidSelectItem = {
  __typename?: 'MatchBidSelectItem';
  autoTenderBid?: Maybe<Scalars['Boolean']['output']>;
  bidId: Scalars['Int']['output'];
  commonBid?: Maybe<MatchBidCommonBidRelation>;
  credit?: Maybe<Scalars['Boolean']['output']>;
  listingLength: Scalars['Int']['output'];
  maximumAcceptedDeals: Scalars['Int']['output'];
  product?: Maybe<MatchBidProductRelation>;
  venueCriteria?: Maybe<MatchBidVenueCriteriaRelation>;
};


export type MatchBidSelectItemCommonBidArgs = {
  where?: InputMaybe<CommonBidFilters>;
};


export type MatchBidSelectItemProductArgs = {
  where?: InputMaybe<MatchBidProductFilters>;
};


export type MatchBidSelectItemVenueCriteriaArgs = {
  where?: InputMaybe<MatchBidVenueCriteriaFilters>;
};

export type MatchBidVenueCriteriaBidIdFilters = {
  OR?: InputMaybe<Array<MatchBidVenueCriteriaBidIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MatchBidVenueCriteriaBidIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MatchBidVenueCriteriaCapturedTargetedVenuesFilters = {
  OR?: InputMaybe<Array<MatchBidVenueCriteriaCapturedTargetedVenuesfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MatchBidVenueCriteriaCapturedTargetedVenuesfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MatchBidVenueCriteriaCustomerTypesFilters = {
  OR?: InputMaybe<Array<MatchBidVenueCriteriaCustomerTypesfiltersOr>>;
  /** JSON */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MatchBidVenueCriteriaCustomerTypesfiltersOr = {
  /** JSON */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MatchBidVenueCriteriaFilters = {
  OR?: InputMaybe<Array<MatchBidVenueCriteriaFiltersOr>>;
  bidId?: InputMaybe<MatchBidVenueCriteriaBidIdFilters>;
  capturedTargetedVenues?: InputMaybe<MatchBidVenueCriteriaCapturedTargetedVenuesFilters>;
  customerTypes?: InputMaybe<MatchBidVenueCriteriaCustomerTypesFilters>;
  listingTypeId?: InputMaybe<MatchBidVenueCriteriaListingTypeIdFilters>;
  loyaltyLevels?: InputMaybe<MatchBidVenueCriteriaLoyaltyLevelsFilters>;
  minimumVolume?: InputMaybe<MatchBidVenueCriteriaMinimumVolumeFilters>;
  regions?: InputMaybe<MatchBidVenueCriteriaRegionsFilters>;
  targetProductCategory?: InputMaybe<MatchBidVenueCriteriaTargetProductCategoryFilters>;
  venueTypes?: InputMaybe<MatchBidVenueCriteriaVenueTypesFilters>;
};

export type MatchBidVenueCriteriaFiltersOr = {
  bidId?: InputMaybe<MatchBidVenueCriteriaBidIdFilters>;
  capturedTargetedVenues?: InputMaybe<MatchBidVenueCriteriaCapturedTargetedVenuesFilters>;
  customerTypes?: InputMaybe<MatchBidVenueCriteriaCustomerTypesFilters>;
  listingTypeId?: InputMaybe<MatchBidVenueCriteriaListingTypeIdFilters>;
  loyaltyLevels?: InputMaybe<MatchBidVenueCriteriaLoyaltyLevelsFilters>;
  minimumVolume?: InputMaybe<MatchBidVenueCriteriaMinimumVolumeFilters>;
  regions?: InputMaybe<MatchBidVenueCriteriaRegionsFilters>;
  targetProductCategory?: InputMaybe<MatchBidVenueCriteriaTargetProductCategoryFilters>;
  venueTypes?: InputMaybe<MatchBidVenueCriteriaVenueTypesFilters>;
};

export type MatchBidVenueCriteriaInsertInput = {
  capturedTargetedVenues?: InputMaybe<Scalars['Int']['input']>;
  customerTypes?: InputMaybe<Array<Scalars['NonEmptyString']['input']>>;
  listingTypeId: Scalars['NonNegativeInt']['input'];
  loyaltyLevels?: InputMaybe<Array<Scalars['NonEmptyString']['input']>>;
  minimumVolume: Scalars['Int']['input'];
  regions?: InputMaybe<Array<Scalars['NonEmptyString']['input']>>;
  targetProductCategory?: InputMaybe<Scalars['Int']['input']>;
  venueTypes?: InputMaybe<Array<Scalars['NonEmptyString']['input']>>;
};

export type MatchBidVenueCriteriaListingTypeIdFilters = {
  OR?: InputMaybe<Array<MatchBidVenueCriteriaListingTypeIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MatchBidVenueCriteriaListingTypeIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MatchBidVenueCriteriaLoyaltyLevelsFilters = {
  OR?: InputMaybe<Array<MatchBidVenueCriteriaLoyaltyLevelsfiltersOr>>;
  /** JSON */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MatchBidVenueCriteriaLoyaltyLevelsfiltersOr = {
  /** JSON */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MatchBidVenueCriteriaMinimumVolumeFilters = {
  OR?: InputMaybe<Array<MatchBidVenueCriteriaMinimumVolumefiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MatchBidVenueCriteriaMinimumVolumefiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MatchBidVenueCriteriaRegionsFilters = {
  OR?: InputMaybe<Array<MatchBidVenueCriteriaRegionsfiltersOr>>;
  /** JSON */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MatchBidVenueCriteriaRegionsfiltersOr = {
  /** JSON */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MatchBidVenueCriteriaRelation = {
  __typename?: 'MatchBidVenueCriteriaRelation';
  bid?: Maybe<MatchBidVenueCriteriaRelationBidRelation>;
  bidId: Scalars['Int']['output'];
  capturedTargetedVenues?: Maybe<Scalars['Int']['output']>;
  customerTypes?: Maybe<Array<Scalars['NonEmptyString']['output']>>;
  listingType?: Maybe<MatchBidVenueCriteriaRelationListingTypeRelation>;
  listingTypeId: Scalars['Int']['output'];
  loyaltyLevels?: Maybe<Array<Scalars['NonEmptyString']['output']>>;
  minimumVolume: Scalars['Int']['output'];
  regions?: Maybe<Array<Scalars['NonEmptyString']['output']>>;
  targetProductCategory?: Maybe<Scalars['Int']['output']>;
  venueTypes?: Maybe<Array<Scalars['NonEmptyString']['output']>>;
};


export type MatchBidVenueCriteriaRelationBidArgs = {
  where?: InputMaybe<MatchBidFilters>;
};


export type MatchBidVenueCriteriaRelationListingTypeArgs = {
  where?: InputMaybe<ListingTypeFilters>;
};

export type MatchBidVenueCriteriaRelationBidRelation = {
  __typename?: 'MatchBidVenueCriteriaRelationBidRelation';
  autoTenderBid?: Maybe<Scalars['Boolean']['output']>;
  bidId: Scalars['Int']['output'];
  credit?: Maybe<Scalars['Boolean']['output']>;
  listingLength: Scalars['Int']['output'];
  maximumAcceptedDeals: Scalars['Int']['output'];
};

export type MatchBidVenueCriteriaRelationListingTypeRelation = {
  __typename?: 'MatchBidVenueCriteriaRelationListingTypeRelation';
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  localizationKey: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  region?: Maybe<Scalars['String']['output']>;
  regions: Array<MatchBidVenueCriteriaRelationListingTypeRelationRegionsRelation>;
  suggestedListingLengthInMonths: Scalars['Int']['output'];
  suggestedTenderLengthInMonths: Scalars['Int']['output'];
  tenderDrafts: Array<MatchBidVenueCriteriaRelationListingTypeRelationTenderDraftsRelation>;
  tenders: Array<MatchBidVenueCriteriaRelationListingTypeRelationTendersRelation>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};


export type MatchBidVenueCriteriaRelationListingTypeRelationRegionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ListingTypeRegion2OrderBy>;
  where?: InputMaybe<ListingTypeRegion2Filters>;
};


export type MatchBidVenueCriteriaRelationListingTypeRelationTenderDraftsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TenderDraftOrderBy>;
  where?: InputMaybe<TenderDraftFilters>;
};


export type MatchBidVenueCriteriaRelationListingTypeRelationTendersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TenderOrderBy>;
  where?: InputMaybe<TenderFilters>;
};

export type MatchBidVenueCriteriaRelationListingTypeRelationRegionsRelation = {
  __typename?: 'MatchBidVenueCriteriaRelationListingTypeRelationRegionsRelation';
  listingTypeId: Scalars['Int']['output'];
  region: Scalars['String']['output'];
};

export type MatchBidVenueCriteriaRelationListingTypeRelationTenderDraftsRelation = {
  __typename?: 'MatchBidVenueCriteriaRelationListingTypeRelationTenderDraftsRelation';
  createdAtUtc: Scalars['String']['output'];
  estimatedVolume?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isAnyWholesalerCompatible?: Maybe<Scalars['Boolean']['output']>;
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  listingEndsAtUtc?: Maybe<Scalars['String']['output']>;
  listingStartsAtUtc?: Maybe<Scalars['String']['output']>;
  listingTypeId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  packagingType?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  supportDetails?: Maybe<Scalars['String']['output']>;
  supportsDiscount: Scalars['String']['output'];
  supportsFreeStock: Scalars['String']['output'];
  supportsListingFee: Scalars['String']['output'];
  supportsPosBudget: Scalars['String']['output'];
  supportsRetroDiscount: Scalars['String']['output'];
  tenderDetails?: Maybe<Scalars['String']['output']>;
  tenderEndsAtUtc?: Maybe<Scalars['String']['output']>;
  tenderStartsAtUtc?: Maybe<Scalars['String']['output']>;
  unitType?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
  venueId: Scalars['Int']['output'];
  volumeDetails?: Maybe<Scalars['String']['output']>;
  volumeUnits?: Maybe<Scalars['Float']['output']>;
};

export type MatchBidVenueCriteriaRelationListingTypeRelationTendersRelation = {
  __typename?: 'MatchBidVenueCriteriaRelationListingTypeRelationTendersRelation';
  connectBids: Array<MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationConnectBidsRelation>;
  createdAtUtc: Scalars['String']['output'];
  estimatedVolume: Scalars['Int']['output'];
  feedback?: Maybe<Scalars['String']['output']>;
  hostingChargeInvoiceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAnyWholesalerCompatible?: Maybe<Scalars['Boolean']['output']>;
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  listingEndsAtUtc: Scalars['String']['output'];
  listingStartsAtUtc: Scalars['String']['output'];
  listingType?: Maybe<MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationListingTypeRelation>;
  listingTypeId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  notifications: Array<MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationNotificationsRelation>;
  originalTenderEndsAtUtc?: Maybe<Scalars['String']['output']>;
  packagingType?: Maybe<Scalars['String']['output']>;
  productCategories: Array<MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationProductCategoriesRelation>;
  productPackaging?: Maybe<MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationProductPackagingRelation>;
  receivedSupportStatus: Scalars['String']['output'];
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  supportDetails?: Maybe<Scalars['String']['output']>;
  supportsDiscount: Scalars['String']['output'];
  supportsFreeStock: Scalars['String']['output'];
  supportsListingFee: Scalars['String']['output'];
  supportsPosBudget: Scalars['String']['output'];
  supportsRetroDiscount: Scalars['String']['output'];
  tenderDetails?: Maybe<Scalars['String']['output']>;
  tenderEndsAtUtc?: Maybe<Scalars['String']['output']>;
  tenderStartsAtUtc?: Maybe<Scalars['String']['output']>;
  tenderWholesalers: Array<MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationTenderWholesalersRelation>;
  unit?: Maybe<MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationUnitRelation>;
  unitType: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationUserRelation>;
  userId: Scalars['Int']['output'];
  venue?: Maybe<MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationVenueRelation>;
  venueId: Scalars['Int']['output'];
  volumeDetails?: Maybe<Scalars['String']['output']>;
  volumeUnits: Scalars['Float']['output'];
};


export type MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationConnectBidsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ConnectBidOrderBy>;
  where?: InputMaybe<ConnectBidFilters>;
};


export type MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationListingTypeArgs = {
  where?: InputMaybe<ListingTypeFilters>;
};


export type MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<NotificationOrderBy>;
  where?: InputMaybe<NotificationFilters>;
};


export type MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationProductCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TenderProductCategoriesOrderBy>;
  where?: InputMaybe<TenderProductCategoriesFilters>;
};


export type MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationProductPackagingArgs = {
  where?: InputMaybe<ProductPackagingFilters>;
};


export type MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationTenderWholesalersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TenderWholesalerOrderBy>;
  where?: InputMaybe<TenderWholesalerFilters>;
};


export type MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationUserArgs = {
  where?: InputMaybe<UserFilters>;
};


export type MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationVenueArgs = {
  where?: InputMaybe<VenueFilters>;
};

export type MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationConnectBidsRelation = {
  __typename?: 'MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationConnectBidsRelation';
  bidId: Scalars['Int']['output'];
  matchBidId?: Maybe<Scalars['Int']['output']>;
  tenderId: Scalars['Int']['output'];
};

export type MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationListingTypeRelation = {
  __typename?: 'MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationListingTypeRelation';
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  localizationKey: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  region?: Maybe<Scalars['String']['output']>;
  suggestedListingLengthInMonths: Scalars['Int']['output'];
  suggestedTenderLengthInMonths: Scalars['Int']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationNotificationsRelation = {
  __typename?: 'MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationNotificationsRelation';
  bidId?: Maybe<Scalars['Int']['output']>;
  brandId?: Maybe<Scalars['Int']['output']>;
  category: Scalars['String']['output'];
  createdAtUtc: Scalars['String']['output'];
  fromId?: Maybe<Scalars['Int']['output']>;
  fromType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isRead: Scalars['Boolean']['output'];
  messageId?: Maybe<Scalars['Int']['output']>;
  tenderId?: Maybe<Scalars['Int']['output']>;
  toId: Scalars['Int']['output'];
  toType: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  venueId?: Maybe<Scalars['Int']['output']>;
};

export type MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationProductCategoriesRelation = {
  __typename?: 'MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationProductCategoriesRelation';
  productCategoryId: Scalars['Int']['output'];
  tenderId: Scalars['Int']['output'];
};

export type MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationProductPackagingRelation = {
  __typename?: 'MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationProductPackagingRelation';
  type: Scalars['String']['output'];
};

export type MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationTenderWholesalersRelation = {
  __typename?: 'MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationTenderWholesalersRelation';
  tenderId: Scalars['Int']['output'];
  wholesalerId: Scalars['Int']['output'];
};

export type MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationUnitRelation = {
  __typename?: 'MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationUnitRelation';
  type: Scalars['String']['output'];
};

export type MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationUserRelation = {
  __typename?: 'MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationUserRelation';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationVenueRelation = {
  __typename?: 'MatchBidVenueCriteriaRelationListingTypeRelationTendersRelationVenueRelation';
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompanyId: Scalars['Int']['output'];
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  venueCategoryId?: Maybe<Scalars['Int']['output']>;
  venueCategoryName?: Maybe<Scalars['String']['output']>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};

export type MatchBidVenueCriteriaTargetProductCategoryFilters = {
  OR?: InputMaybe<Array<MatchBidVenueCriteriaTargetProductCategoryfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MatchBidVenueCriteriaTargetProductCategoryfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MatchBidVenueCriteriaVenueTypesFilters = {
  OR?: InputMaybe<Array<MatchBidVenueCriteriaVenueTypesfiltersOr>>;
  /** JSON */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MatchBidVenueCriteriaVenueTypesfiltersOr = {
  /** JSON */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type MatchBidVenueForBrandConnection = {
  __typename?: 'MatchBidVenueForBrandConnection';
  data: Array<Maybe<MatchBidVenueForBrandItem>>;
  pageInfo: MatchBidVenueForBrandPageInfo;
};

export type MatchBidVenueForBrandItem = {
  __typename?: 'MatchBidVenueForBrandItem';
  bidId: Scalars['NonNegativeInt']['output'];
  id: Scalars['NonNegativeInt']['output'];
  listingTypeLocalizationKey?: Maybe<Scalars['String']['output']>;
  productCategoryLocalizationKey?: Maybe<Scalars['String']['output']>;
  productName: Scalars['String']['output'];
  region: Region;
  status: Scalars['String']['output'];
  supports: Array<CommonBidSupportItem>;
  totalSupport: Scalars['Float']['output'];
  venueId: Scalars['NonNegativeInt']['output'];
  venueName: Scalars['String']['output'];
};

export type MatchBidVenueForBrandPageInfo = {
  __typename?: 'MatchBidVenueForBrandPageInfo';
  hasNextPage: Scalars['Boolean']['output'];
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type MatchBidVenuePdfAttachment = {
  __typename?: 'MatchBidVenuePdfAttachment';
  content: Scalars['String']['output'];
  filename: Scalars['String']['output'];
};

export enum MatchDashboardCacheStatus {
  Failed = 'FAILED',
  Generating = 'GENERATING',
  Ready = 'READY'
}

export type MatchDashboardOverview = {
  __typename?: 'MatchDashboardOverview';
  generatedAtUtc?: Maybe<Scalars['String']['output']>;
  hasMatchBids: Scalars['Boolean']['output'];
  match: MatchDashboardOverviewMatch;
  status: MatchDashboardCacheStatus;
};

export type MatchDashboardOverviewCategory = {
  __typename?: 'MatchDashboardOverviewCategory';
  matchWinsCount: Scalars['NonNegativeInt']['output'];
  portfolioParticipationPercentage: Scalars['Float']['output'];
  productCategoryId: Scalars['NonNegativeInt']['output'];
  productCategoryLocalizationKey: Scalars['String']['output'];
  productsWithBidsCount: Scalars['NonNegativeInt']['output'];
  shareOfTotalWinsPercentage: Scalars['Float']['output'];
  totalProductsCount: Scalars['NonNegativeInt']['output'];
  winningDiscountPercentage?: Maybe<Scalars['Float']['output']>;
};

export type MatchDashboardOverviewConnect = {
  __typename?: 'MatchDashboardOverviewConnect';
  customersCount: Scalars['NonNegativeInt']['output'];
  estimatedSales: Scalars['Float']['output'];
  winsCount: Scalars['NonNegativeInt']['output'];
  winsLastMonthCount: Scalars['NonNegativeInt']['output'];
};

export type MatchDashboardOverviewMatch = {
  __typename?: 'MatchDashboardOverviewMatch';
  bidSetupAllCustomerTypesPercentage: Scalars['Float']['output'];
  bidSetupAllRegionsPercentage: Scalars['Float']['output'];
  bidSetupAllVenueTypesPercentage: Scalars['Float']['output'];
  bidSetupZeroMinVolumePercentage: Scalars['Float']['output'];
  customersCount: Scalars['NonNegativeInt']['output'];
  performanceCommentaryText: Scalars['String']['output'];
  portfolioCoveragePercentage: Scalars['Float']['output'];
  portfolioCoverageUnusedCount: Scalars['NonNegativeInt']['output'];
  portfolioCoverageUsedCount: Scalars['NonNegativeInt']['output'];
  recommendedActionsText: Scalars['String']['output'];
  topCategories: Array<MatchDashboardOverviewCategory>;
  weeklyPerformance: Array<MatchDashboardWeeklyPerformancePoint>;
  winsCount: Scalars['NonNegativeInt']['output'];
  winsLastMonthCount: Scalars['NonNegativeInt']['output'];
};

export type MatchDashboardOverviewPdfResult = {
  __typename?: 'MatchDashboardOverviewPdfResult';
  content: Scalars['String']['output'];
  filename: Scalars['String']['output'];
};

export type MatchDashboardWeeklyPerformancePoint = {
  __typename?: 'MatchDashboardWeeklyPerformancePoint';
  dealsAcceptedCount: Scalars['NonNegativeInt']['output'];
  salesAmount: Scalars['Float']['output'];
  weekLabel: Scalars['String']['output'];
};

export type MatchDealTrackingConnection = {
  __typename?: 'MatchDealTrackingConnection';
  data: Array<MatchDealTrackingItem>;
  highlights: MatchDealTrackingHighlights;
  pageInfo: OffsetPagination;
};

export type MatchDealTrackingHighlights = {
  __typename?: 'MatchDealTrackingHighlights';
  customersPurchasedCount: Scalars['NonNegativeInt']['output'];
  totalSales: Scalars['Float']['output'];
  totalUnitsPurchased: Scalars['NonNegativeInt']['output'];
  winsCount: Scalars['NonNegativeInt']['output'];
};

export type MatchDealTrackingItem = {
  __typename?: 'MatchDealTrackingItem';
  acceptedAtUtc: Scalars['String']['output'];
  bidId: Scalars['NonNegativeInt']['output'];
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerName: Scalars['String']['output'];
  customerPhoneNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['NonNegativeInt']['output'];
  listingEndsAtUtc: Scalars['String']['output'];
  listingTypeLocalizationKey: Scalars['String']['output'];
  productCategoryLocalizationKey?: Maybe<Scalars['String']['output']>;
  productName: Scalars['String']['output'];
  salesAmount: Scalars['Float']['output'];
  supports: Array<CommonBidSupportItem>;
  totalSupport: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  unitsPurchased: Scalars['NonNegativeInt']['output'];
  unitsPurchasedSinceAccepted?: Maybe<Scalars['NonNegativeInt']['output']>;
  venueId: Scalars['NonNegativeInt']['output'];
};

export type MatchTargetCriteria = {
  __typename?: 'MatchTargetCriteria';
  customerTypes: MatchTargetCriteriaMetric;
  listingTypes: Array<MatchTargetCriteriaListingTypeMetric>;
  loyaltyLevels: MatchTargetCriteriaMetric;
  minimumVolume: MatchTargetCriteriaMetric;
  regions: MatchTargetCriteriaMetric;
  venueTypes: MatchTargetCriteriaMetric;
};

export type MatchTargetCriteriaListingTypeMetric = {
  __typename?: 'MatchTargetCriteriaListingTypeMetric';
  listingTypeLocalizationKey: Scalars['String']['output'];
  meetsRecommendedThreshold: Scalars['Boolean']['output'];
  percentageTargetingAll: Scalars['Float']['output'];
};

export type MatchTargetCriteriaMetric = {
  __typename?: 'MatchTargetCriteriaMetric';
  meetsRecommendedThreshold: Scalars['Boolean']['output'];
  percentageTargetingAll: Scalars['Float']['output'];
};

export type Message = {
  __typename?: 'Message';
  bidId: Scalars['Int']['output'];
  brand?: Maybe<Brand>;
  brandId?: Maybe<Scalars['Int']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  venue?: Maybe<Venue>;
  venueId?: Maybe<Scalars['Int']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptInviteToBrand?: Maybe<InvitationLinkItem>;
  acceptInviteToVenue?: Maybe<InvitationLinkItem>;
  acceptMatchBid: Scalars['NonNegativeInt']['output'];
  addMessage: Array<Message>;
  addProductTemplate: ProductTemplate;
  addTender: Tender;
  addTenderDraft: TenderDraft;
  addTenderRetool: Tender;
  addUserActionLog: UserActionLog;
  backgroundJobRunner: Scalars['Boolean']['output'];
  bulkImportMatchDeals: BulkImportMatchDealsResult;
  cancelSubscription: Scalars['Boolean']['output'];
  cancelSubscriptionNewInApp: Scalars['Boolean']['output'];
  cancelSubscriptionNewRetool: Scalars['Boolean']['output'];
  changeEmail: UserSelectItem;
  checkUnverifiedEmails: Scalars['Boolean']['output'];
  chooseMultipleTenderWinners: Array<Tender>;
  chooseWinner: Tender;
  claimVenueAccount?: Maybe<UnclaimedVenueAccount>;
  cleanupSalesDemoData: Scalars['Boolean']['output'];
  clearStellateCache: Scalars['Boolean']['output'];
  confirmChangeEmail: Scalars['Boolean']['output'];
  createBankTransferSubscription: Scalars['Boolean']['output'];
  createBespokePaymentLink: Scalars['String']['output'];
  createDatabaseBackup: Scalars['Boolean']['output'];
  createStripeCheckout: Scalars['String']['output'];
  deleteBidById: Scalars['Boolean']['output'];
  deleteBrandUser?: Maybe<BrandUserItem>;
  deleteCommonBidById: Array<CommonBidItem>;
  deleteMatchBidById: Scalars['Boolean']['output'];
  deleteProductTemplateById: Scalars['Boolean']['output'];
  deleteTenderById: Scalars['Boolean']['output'];
  deleteTenderDraftById: Scalars['Boolean']['output'];
  deleteVenueUser?: Maybe<VenueUserItem>;
  editBid?: Maybe<Bid>;
  editBidSupportStatus: Bid;
  editBrand: Brand;
  editBrandSettings: BrandSettings;
  editCommonBidSupportStatus?: Maybe<ConnectBidSelectItem>;
  editMatchBid?: Maybe<MatchBidSelectItem>;
  editProductTemplate: ProductTemplate;
  editTender: Tender;
  editTenderDraft: TenderDraft;
  editTenderPreference: TenderPreference;
  editTenderRetool: Tender;
  editUserContactDetails: Scalars['Boolean']['output'];
  editVenue: Venue;
  editVenueSettings: VenueSettings;
  endMatchBidById: Scalars['Boolean']['output'];
  generateUploadUrls: Array<UploadUrlItem>;
  insertIntoBrand: BrandItem;
  insertIntoConnectBid: ConnectBidSelectItem;
  insertIntoMatchBid?: Maybe<MatchBidSelectItem>;
  insertIntoVenue: VenueItem;
  inviteToBrand?: Maybe<InvitationLinkItem>;
  inviteToVenue?: Maybe<InvitationLinkItem>;
  isJWTLinkTokenValid: Scalars['Boolean']['output'];
  linkAccountWithExternalProvider: Scalars['String']['output'];
  /** Manually pair a Brand with a Booker company. Retool authentication required. */
  linkBrandAccountWithBookerForRetool: BrandIntegrationsSelectItem;
  markAllNotificationsAsRead: Array<Notification>;
  markNotificationAsRead: Notification;
  rateBid: Bid;
  rateConnectBid?: Maybe<ConnectBidItem>;
  removeBrandBillingAddress?: Maybe<BrandItem>;
  removeBrandCompanyAddress?: Maybe<BrandItem>;
  removeBrandTradingAddress?: Maybe<BrandItem>;
  removeInviteToBrand?: Maybe<InvitationLinkItem>;
  removeInviteToVenue?: Maybe<InvitationLinkItem>;
  removeVenueBillingAddress?: Maybe<VenueItem>;
  removeVenueCompanyAddress?: Maybe<VenueItem>;
  removeVenueTradingAddress?: Maybe<VenueItem>;
  repopulateTendersMatchBid?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  requestChangeEmail: Scalars['Boolean']['output'];
  requestEmail: Scalars['Boolean']['output'];
  retoolChangeBidStatus: Bid;
  retoolChangeTenderAllBidsStatus: Array<Bid>;
  retoolChangeTenderStatus: Tender;
  retoolEditBrand: Brand;
  retoolRecalculateConnectBidExternalLivePrices: Array<RecalculateConnectBidExternalLivePriceResult>;
  sampleRequest: Scalars['Boolean']['output'];
  sendBankTransferInvoiceNotPaidEmail: Scalars['Boolean']['output'];
  sendDailyMatchBidsReport: Scalars['Boolean']['output'];
  sendDailyNewBidsReport: Scalars['Boolean']['output'];
  sendDailyNewTenderBrandReport: Scalars['Boolean']['output'];
  sendDailyRatingReport: Scalars['Boolean']['output'];
  sendReTenderEmail: Scalars['Boolean']['output'];
  sendSelectWinnerEmail: Scalars['Boolean']['output'];
  sendTenderEndsInTwoDaysEmail: Scalars['Boolean']['output'];
  setBrandUserRole?: Maybe<BrandUserItem>;
  setVenueUserRole?: Maybe<VenueUserItem>;
  signInAsUser: Scalars['String']['output'];
  signUp: Scalars['String']['output'];
  syncTenderStatuses: Scalars['Boolean']['output'];
  unlinkAccountWithExternalProvider: Scalars['Boolean']['output'];
  updateBrandBillingAddress?: Maybe<BrandItem>;
  updateCompanyAddressDetails?: Maybe<Scalars['Boolean']['output']>;
  updateConnectBid?: Maybe<ConnectBidSelectItem>;
  updateSubscription: Scalars['Boolean']['output'];
  updateVenueBillingAddress?: Maybe<VenueItem>;
  upgradeToBespoke: UpgradeToBespokeData;
  verifyAllUserEmails: Scalars['Boolean']['output'];
  verifyEmailRequest: Scalars['Boolean']['output'];
  verifyUserEmailManually: Scalars['Boolean']['output'];
};


export type MutationAcceptInviteToBrandArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationAcceptInviteToVenueArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationAcceptMatchBidArgs = {
  bidId: Scalars['NonNegativeInt']['input'];
  price: Scalars['Float']['input'];
  venueId: Scalars['NonNegativeInt']['input'];
};


export type MutationAddMessageArgs = {
  input: AddMessageInput;
};


export type MutationAddProductTemplateArgs = {
  input: AddProductTemplateInput;
};


export type MutationAddTenderArgs = {
  input: AddTenderInput;
};


export type MutationAddTenderDraftArgs = {
  input: AddTenderDraftInput;
};


export type MutationAddTenderRetoolArgs = {
  input: AddTenderRetoolInput;
};


export type MutationAddUserActionLogArgs = {
  input: UserActionLogInput;
};


export type MutationBackgroundJobRunnerArgs = {
  token: Scalars['String']['input'];
};


export type MutationBulkImportMatchDealsArgs = {
  brandId: Scalars['Int']['input'];
  mode: BulkImportMatchDealsMode;
  validationToken?: InputMaybe<Scalars['String']['input']>;
  workbookBase64: Scalars['String']['input'];
};


export type MutationCancelSubscriptionArgs = {
  input: CancelSubscriptionInput;
};


export type MutationCancelSubscriptionNewInAppArgs = {
  input: CancelSubscriptionNewInAppInput;
};


export type MutationCancelSubscriptionNewRetoolArgs = {
  input: CancelSubscriptionNewRetoolInput;
};


export type MutationChangeEmailArgs = {
  input: ChangeEmailInput;
};


export type MutationCheckUnverifiedEmailsArgs = {
  token: Scalars['String']['input'];
};


export type MutationChooseMultipleTenderWinnersArgs = {
  input: ChooseMultipleTenderWinnersInput;
};


export type MutationChooseWinnerArgs = {
  input: ChooseWinnerInput;
};


export type MutationClaimVenueAccountArgs = {
  input: ClaimVenueAccountInput;
};


export type MutationCleanupSalesDemoDataArgs = {
  token: Scalars['String']['input'];
};


export type MutationClearStellateCacheArgs = {
  brandId?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  commonBidId?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  tenderId?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  userId?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


export type MutationConfirmChangeEmailArgs = {
  changeEmailToken: Scalars['String']['input'];
};


export type MutationCreateBankTransferSubscriptionArgs = {
  input: CreateBankTransferSubscriptionInput;
};


export type MutationCreateBespokePaymentLinkArgs = {
  input: CreateBespokePaymentLinkInput;
};


export type MutationCreateDatabaseBackupArgs = {
  token: Scalars['String']['input'];
};


export type MutationCreateStripeCheckoutArgs = {
  input: CreateStripeCheckoutInput;
};


export type MutationDeleteBidByIdArgs = {
  bidId: Scalars['NonNegativeInt']['input'];
};


export type MutationDeleteBrandUserArgs = {
  brandId: Scalars['NonNegativeInt']['input'];
  userId: Scalars['NonNegativeInt']['input'];
};


export type MutationDeleteCommonBidByIdArgs = {
  id: Scalars['NonNegativeInt']['input'];
};


export type MutationDeleteMatchBidByIdArgs = {
  bidId: Scalars['NonNegativeInt']['input'];
};


export type MutationDeleteProductTemplateByIdArgs = {
  input: DeleteProductTemplateInput;
};


export type MutationDeleteTenderByIdArgs = {
  tenderId: Scalars['NonNegativeInt']['input'];
};


export type MutationDeleteTenderDraftByIdArgs = {
  tenderDraftId: Scalars['NonNegativeInt']['input'];
};


export type MutationDeleteVenueUserArgs = {
  userId: Scalars['NonNegativeInt']['input'];
  venueId: Scalars['NonNegativeInt']['input'];
};


export type MutationEditBidArgs = {
  input: EditBidInput;
};


export type MutationEditBidSupportStatusArgs = {
  input: EditBidSupportStatusInput;
};


export type MutationEditBrandArgs = {
  input: EditBrandInput;
};


export type MutationEditBrandSettingsArgs = {
  input: EditBrandSettingsInput;
};


export type MutationEditCommonBidSupportStatusArgs = {
  input: EditSupportStatusInput;
};


export type MutationEditMatchBidArgs = {
  id: Scalars['NonNegativeInt']['input'];
  set: MatchBidInsertInput;
};


export type MutationEditProductTemplateArgs = {
  input: EditProductTemplateInput;
};


export type MutationEditTenderArgs = {
  input: EditTenderInput;
};


export type MutationEditTenderDraftArgs = {
  input: EditTenderDraftInput;
};


export type MutationEditTenderPreferenceArgs = {
  input: EditTenderPreferenceInput;
};


export type MutationEditTenderRetoolArgs = {
  input: EditTenderInput;
};


export type MutationEditUserContactDetailsArgs = {
  input: EditUserContactDetailsInput;
};


export type MutationEditVenueArgs = {
  input: EditVenueInput;
};


export type MutationEditVenueSettingsArgs = {
  input: EditVenueSettingsInput;
};


export type MutationEndMatchBidByIdArgs = {
  bidId: Scalars['NonNegativeInt']['input'];
  brandId: Scalars['NonNegativeInt']['input'];
};


export type MutationGenerateUploadUrlsArgs = {
  fileNames: Array<Scalars['String']['input']>;
};


export type MutationInsertIntoBrandArgs = {
  input: BrandInsertInput;
};


export type MutationInsertIntoConnectBidArgs = {
  input: ConnectBidInsertInput;
};


export type MutationInsertIntoMatchBidArgs = {
  input: MatchBidInsertInput;
};


export type MutationInsertIntoVenueArgs = {
  input: VenueInsertInput;
};


export type MutationInviteToBrandArgs = {
  email: Scalars['EmailAddress']['input'];
  id: Scalars['NonNegativeInt']['input'];
  userRole: UserRole;
};


export type MutationInviteToVenueArgs = {
  email: Scalars['EmailAddress']['input'];
  id: Scalars['NonNegativeInt']['input'];
  userRole: UserRole;
};


export type MutationIsJwtLinkTokenValidArgs = {
  integrationType: IntegrationType;
  token: Scalars['String']['input'];
};


export type MutationLinkAccountWithExternalProviderArgs = {
  input: LinkAccountWithExternalProviderInput;
};


export type MutationLinkBrandAccountWithBookerForRetoolArgs = {
  input: LinkBrandAccountWithBookerForRetoolInput;
};


export type MutationMarkAllNotificationsAsReadArgs = {
  input: MarkAllNotificationsAsReadInput;
};


export type MutationMarkNotificationAsReadArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRateBidArgs = {
  input: CommonBidRateInput;
};


export type MutationRateConnectBidArgs = {
  input: CommonBidRateInput;
};


export type MutationRemoveBrandBillingAddressArgs = {
  id: Scalars['NonNegativeInt']['input'];
};


export type MutationRemoveBrandCompanyAddressArgs = {
  id: Scalars['NonNegativeInt']['input'];
};


export type MutationRemoveBrandTradingAddressArgs = {
  id: Scalars['NonNegativeInt']['input'];
};


export type MutationRemoveInviteToBrandArgs = {
  id: Scalars['NonNegativeInt']['input'];
  invitationId: Scalars['UUID']['input'];
};


export type MutationRemoveInviteToVenueArgs = {
  id: Scalars['NonNegativeInt']['input'];
  invitationId: Scalars['UUID']['input'];
};


export type MutationRemoveVenueBillingAddressArgs = {
  id: Scalars['NonNegativeInt']['input'];
};


export type MutationRemoveVenueCompanyAddressArgs = {
  id: Scalars['NonNegativeInt']['input'];
};


export type MutationRemoveVenueTradingAddressArgs = {
  id: Scalars['NonNegativeInt']['input'];
};


export type MutationRepopulateTendersMatchBidArgs = {
  matchBidIds: Array<Scalars['Int']['input']>;
};


export type MutationRequestChangeEmailArgs = {
  emailToChange: Scalars['String']['input'];
};


export type MutationRequestEmailArgs = {
  input: RequestEmailInput;
};


export type MutationRetoolChangeBidStatusArgs = {
  input: RetoolChangeBidStatusInput;
};


export type MutationRetoolChangeTenderAllBidsStatusArgs = {
  input: RetoolChangeTenderAllBidsStatusInput;
};


export type MutationRetoolChangeTenderStatusArgs = {
  input: RetoolChangeTenderStatusInput;
};


export type MutationRetoolEditBrandArgs = {
  input: EditBrandInput;
};


export type MutationRetoolRecalculateConnectBidExternalLivePricesArgs = {
  tenderId: Scalars['NonNegativeInt']['input'];
};


export type MutationSampleRequestArgs = {
  input: CommonBidSampleRequestInput;
};


export type MutationSendBankTransferInvoiceNotPaidEmailArgs = {
  token: Scalars['String']['input'];
};


export type MutationSendDailyMatchBidsReportArgs = {
  token: Scalars['String']['input'];
};


export type MutationSendDailyNewBidsReportArgs = {
  token: Scalars['String']['input'];
};


export type MutationSendDailyNewTenderBrandReportArgs = {
  token: Scalars['String']['input'];
};


export type MutationSendDailyRatingReportArgs = {
  token: Scalars['String']['input'];
};


export type MutationSendReTenderEmailArgs = {
  token: Scalars['String']['input'];
};


export type MutationSendSelectWinnerEmailArgs = {
  token: Scalars['String']['input'];
};


export type MutationSendTenderEndsInTwoDaysEmailArgs = {
  token: Scalars['String']['input'];
};


export type MutationSetBrandUserRoleArgs = {
  brandId: Scalars['NonNegativeInt']['input'];
  role: SetUserRole;
  userId: Scalars['NonNegativeInt']['input'];
};


export type MutationSetVenueUserRoleArgs = {
  role: SetUserRole;
  userId: Scalars['NonNegativeInt']['input'];
  venueId: Scalars['NonNegativeInt']['input'];
};


export type MutationSignInAsUserArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationSignUpArgs = {
  input: SignUpInput;
};


export type MutationSyncTenderStatusesArgs = {
  token: Scalars['String']['input'];
};


export type MutationUnlinkAccountWithExternalProviderArgs = {
  input: UnlinkAccountWithExternalProviderInput;
};


export type MutationUpdateBrandBillingAddressArgs = {
  id: Scalars['NonNegativeInt']['input'];
  input: AddressInsertInput;
};


export type MutationUpdateCompanyAddressDetailsArgs = {
  input: UpdateCompanyAddressDetailsInput;
};


export type MutationUpdateConnectBidArgs = {
  id: Scalars['NonNegativeInt']['input'];
  set: ConnectBidUpdateInput;
};


export type MutationUpdateSubscriptionArgs = {
  input: UpdateSubscriptionInput;
};


export type MutationUpdateVenueBillingAddressArgs = {
  id: Scalars['NonNegativeInt']['input'];
  input: AddressInsertInput;
};


export type MutationUpgradeToBespokeArgs = {
  token: Scalars['String']['input'];
};


export type MutationVerifyUserEmailManuallyArgs = {
  email: Scalars['NonEmptyString']['input'];
};

export enum MyBidsFilterValues {
  OnlyTendersWithoutMyBids = 'ONLY_TENDERS_WITHOUT_MY_BIDS',
  OnlyTendersWithMyBids = 'ONLY_TENDERS_WITH_MY_BIDS'
}

export type MyBidsOption = {
  brandId: Scalars['Int']['input'];
  value: MyBidsFilterValues;
};

export enum MyTendersFilterValues {
  OnlyMyTenders = 'ONLY_MY_TENDERS',
  OnlyWithoutMyTenders = 'ONLY_WITHOUT_MY_TENDERS'
}

export type MyTendersOption = {
  value: MyTendersFilterValues;
  venueId: Scalars['Int']['input'];
};

export type Node = {
  id: Scalars['Int']['output'];
};

export type Notification = Node & {
  __typename?: 'Notification';
  bid?: Maybe<Bid>;
  bidId?: Maybe<Scalars['Int']['output']>;
  brand?: Maybe<Brand>;
  brandId?: Maybe<Scalars['Int']['output']>;
  category: NotificationCategory;
  createdAtUtc: Scalars['Date']['output'];
  fromId?: Maybe<Scalars['Int']['output']>;
  fromType?: Maybe<NotificationTargetType>;
  id: Scalars['Int']['output'];
  isRead: Scalars['Boolean']['output'];
  message?: Maybe<Message>;
  messageId?: Maybe<Scalars['Int']['output']>;
  tender?: Maybe<Tender>;
  tenderId?: Maybe<Scalars['Int']['output']>;
  toId: Scalars['Int']['output'];
  toType: NotificationTargetType;
  type: NotificationType;
  updatedAtUtc?: Maybe<Scalars['Date']['output']>;
  venue?: Maybe<Venue>;
  venueId?: Maybe<Scalars['Int']['output']>;
};

export type NotificationBidIdFilters = {
  OR?: InputMaybe<Array<NotificationBidIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationBidIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationBrandIdFilters = {
  OR?: InputMaybe<Array<NotificationBrandIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationBrandIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export enum NotificationCategory {
  Message = 'MESSAGE',
  System = 'SYSTEM'
}

export type NotificationCategoryFilters = {
  OR?: InputMaybe<Array<NotificationCategoryfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationCategoryfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationCreatedAtUtcFilters = {
  OR?: InputMaybe<Array<NotificationCreatedAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationCreatedAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationEdge = Edge & {
  __typename?: 'NotificationEdge';
  cursor: Scalars['String']['output'];
  node: Notification;
};

export type NotificationFilters = {
  OR?: InputMaybe<Array<NotificationFiltersOr>>;
  bidId?: InputMaybe<NotificationBidIdFilters>;
  brandId?: InputMaybe<NotificationBrandIdFilters>;
  category?: InputMaybe<NotificationCategoryFilters>;
  createdAtUtc?: InputMaybe<NotificationCreatedAtUtcFilters>;
  fromId?: InputMaybe<NotificationFromIdFilters>;
  fromType?: InputMaybe<NotificationFromTypeFilters>;
  id?: InputMaybe<NotificationIdFilters>;
  isRead?: InputMaybe<NotificationIsReadFilters>;
  messageId?: InputMaybe<NotificationMessageIdFilters>;
  tenderId?: InputMaybe<NotificationTenderIdFilters>;
  toId?: InputMaybe<NotificationToIdFilters>;
  toType?: InputMaybe<NotificationToTypeFilters>;
  type?: InputMaybe<NotificationTypeFilters>;
  updatedAtUtc?: InputMaybe<NotificationUpdatedAtUtcFilters>;
  venueId?: InputMaybe<NotificationVenueIdFilters>;
};

export type NotificationFiltersOr = {
  bidId?: InputMaybe<NotificationBidIdFilters>;
  brandId?: InputMaybe<NotificationBrandIdFilters>;
  category?: InputMaybe<NotificationCategoryFilters>;
  createdAtUtc?: InputMaybe<NotificationCreatedAtUtcFilters>;
  fromId?: InputMaybe<NotificationFromIdFilters>;
  fromType?: InputMaybe<NotificationFromTypeFilters>;
  id?: InputMaybe<NotificationIdFilters>;
  isRead?: InputMaybe<NotificationIsReadFilters>;
  messageId?: InputMaybe<NotificationMessageIdFilters>;
  tenderId?: InputMaybe<NotificationTenderIdFilters>;
  toId?: InputMaybe<NotificationToIdFilters>;
  toType?: InputMaybe<NotificationToTypeFilters>;
  type?: InputMaybe<NotificationTypeFilters>;
  updatedAtUtc?: InputMaybe<NotificationUpdatedAtUtcFilters>;
  venueId?: InputMaybe<NotificationVenueIdFilters>;
};

export type NotificationFromIdFilters = {
  OR?: InputMaybe<Array<NotificationFromIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationFromIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationFromTypeFilters = {
  OR?: InputMaybe<Array<NotificationFromTypefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationFromTypefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationIdFilters = {
  OR?: InputMaybe<Array<NotificationIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationIsReadFilters = {
  OR?: InputMaybe<Array<NotificationIsReadfiltersOr>>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationIsReadfiltersOr = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationMessageIdFilters = {
  OR?: InputMaybe<Array<NotificationMessageIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationMessageIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationOrderBy = {
  bidId?: InputMaybe<InnerOrder>;
  brandId?: InputMaybe<InnerOrder>;
  category?: InputMaybe<InnerOrder>;
  createdAtUtc?: InputMaybe<InnerOrder>;
  fromId?: InputMaybe<InnerOrder>;
  fromType?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  isRead?: InputMaybe<InnerOrder>;
  messageId?: InputMaybe<InnerOrder>;
  tenderId?: InputMaybe<InnerOrder>;
  toId?: InputMaybe<InnerOrder>;
  toType?: InputMaybe<InnerOrder>;
  type?: InputMaybe<InnerOrder>;
  updatedAtUtc?: InputMaybe<InnerOrder>;
  venueId?: InputMaybe<InnerOrder>;
};

export enum NotificationTargetType {
  Brand = 'BRAND',
  Venue = 'VENUE'
}

export type NotificationTenderIdFilters = {
  OR?: InputMaybe<Array<NotificationTenderIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationTenderIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationToIdFilters = {
  OR?: InputMaybe<Array<NotificationToIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationToIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationToTypeFilters = {
  OR?: InputMaybe<Array<NotificationToTypefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationToTypefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export enum NotificationType {
  BidRated = 'BID_RATED',
  BidUpdated = 'BID_UPDATED',
  GeneralMessage = 'GENERAL_MESSAGE',
  NewBid = 'NEW_BID',
  NewTender = 'NEW_TENDER',
  PaymentIntentFailed = 'PAYMENT_INTENT_FAILED',
  PaymentIntentFailedStandardTier = 'PAYMENT_INTENT_FAILED_STANDARD_TIER',
  ReTenderReminder = 'RE_TENDER_REMINDER',
  SubscriptionDeleted = 'SUBSCRIPTION_DELETED',
  SubscriptionDeletedStandardTier = 'SUBSCRIPTION_DELETED_STANDARD_TIER',
  TenderCloseWithoutWinner = 'TENDER_CLOSE_WITHOUT_WINNER',
  TenderClosing = 'TENDER_CLOSING',
  TenderEnded = 'TENDER_ENDED',
  TenderEndedReminder = 'TENDER_ENDED_REMINDER',
  TenderUpdated = 'TENDER_UPDATED',
  WinnerAnnouncement = 'WINNER_ANNOUNCEMENT'
}

export type NotificationTypeFilters = {
  OR?: InputMaybe<Array<NotificationTypefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationTypefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationUpdatedAtUtcFilters = {
  OR?: InputMaybe<Array<NotificationUpdatedAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationUpdatedAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationVenueIdFilters = {
  OR?: InputMaybe<Array<NotificationVenueIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationVenueIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type OffsetNotifications = {
  __typename?: 'OffsetNotifications';
  data: Array<Notification>;
  pageInfo: OffsetPageInfo;
  totalCount: Scalars['Int']['output'];
  unreadTotalCount: Scalars['Int']['output'];
};

export type OffsetNotificationsInput = {
  category: NotificationCategory;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  toId: Scalars['Int']['input'];
  toType: NotificationTargetType;
};

export type OffsetPageInfo = {
  __typename?: 'OffsetPageInfo';
  currentPage: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPrevPage: Scalars['Boolean']['output'];
  totalPages: Scalars['Int']['output'];
};

export type OffsetPagination = {
  __typename?: 'OffsetPagination';
  currentPage: Scalars['NonNegativeInt']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPrevPage: Scalars['Boolean']['output'];
  totalCount: Scalars['NonNegativeInt']['output'];
  totalPages: Scalars['NonNegativeInt']['output'];
};

export type OffsetPaginationInput = {
  limit: Scalars['NonNegativeInt']['input'];
  offset: Scalars['NonNegativeInt']['input'];
};

/** Order by direction */
export enum OrderDirection {
  /** Ascending order */
  Asc = 'asc',
  /** Descending order */
  Desc = 'desc'
}

export type PlaceAutocomplete = {
  __typename?: 'PlaceAutocomplete';
  placeId: Scalars['String']['output'];
  placeName: Scalars['String']['output'];
};

export type PlacesInput = {
  region: Region;
  searchQuery: Scalars['String']['input'];
  sessionToken: Scalars['String']['input'];
};

export type Point = {
  __typename?: 'Point';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type PointInput = {
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type PriceRangeOption = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type ProductCategoriesForRetoolInput = {
  region: Region;
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  createdAtUtc: Scalars['String']['output'];
  defaultPackagingType?: Maybe<Scalars['String']['output']>;
  defaultVolume?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isPublished: Scalars['Boolean']['output'];
  localizationKey: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  regions: Array<Region>;
  unitType?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type ProductCategoryCreatedAtUtcFilters = {
  OR?: InputMaybe<Array<ProductCategoryCreatedAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCategoryCreatedAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCategoryDefaultPackagingTypeFilters = {
  OR?: InputMaybe<Array<ProductCategoryDefaultPackagingTypefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCategoryDefaultPackagingTypefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCategoryDefaultVolumeFilters = {
  OR?: InputMaybe<Array<ProductCategoryDefaultVolumefiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCategoryDefaultVolumefiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCategoryFilters = {
  OR?: InputMaybe<Array<ProductCategoryFiltersOr>>;
  createdAtUtc?: InputMaybe<ProductCategoryCreatedAtUtcFilters>;
  defaultPackagingType?: InputMaybe<ProductCategoryDefaultPackagingTypeFilters>;
  defaultVolume?: InputMaybe<ProductCategoryDefaultVolumeFilters>;
  id?: InputMaybe<ProductCategoryIdFilters>;
  isPublished?: InputMaybe<ProductCategoryIsPublishedFilters>;
  localizationKey?: InputMaybe<ProductCategoryLocalizationKeyFilters>;
  parentId?: InputMaybe<ProductCategoryParentIdFilters>;
  region?: InputMaybe<ProductCategoryRegionFilters>;
  unitType?: InputMaybe<ProductCategoryUnitTypeFilters>;
  updatedAtUtc?: InputMaybe<ProductCategoryUpdatedAtUtcFilters>;
};

export type ProductCategoryFiltersOr = {
  createdAtUtc?: InputMaybe<ProductCategoryCreatedAtUtcFilters>;
  defaultPackagingType?: InputMaybe<ProductCategoryDefaultPackagingTypeFilters>;
  defaultVolume?: InputMaybe<ProductCategoryDefaultVolumeFilters>;
  id?: InputMaybe<ProductCategoryIdFilters>;
  isPublished?: InputMaybe<ProductCategoryIsPublishedFilters>;
  localizationKey?: InputMaybe<ProductCategoryLocalizationKeyFilters>;
  parentId?: InputMaybe<ProductCategoryParentIdFilters>;
  region?: InputMaybe<ProductCategoryRegionFilters>;
  unitType?: InputMaybe<ProductCategoryUnitTypeFilters>;
  updatedAtUtc?: InputMaybe<ProductCategoryUpdatedAtUtcFilters>;
};

export type ProductCategoryIdFilters = {
  OR?: InputMaybe<Array<ProductCategoryIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCategoryIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCategoryIsPublishedFilters = {
  OR?: InputMaybe<Array<ProductCategoryIsPublishedfiltersOr>>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCategoryIsPublishedfiltersOr = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCategoryItem = {
  __typename?: 'ProductCategoryItem';
  createdAtUtc: Scalars['String']['output'];
  defaultPackagingType?: Maybe<Scalars['String']['output']>;
  defaultVolume?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isPublished: Scalars['Boolean']['output'];
  localizationKey: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  unitType?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export enum ProductCategoryLevel {
  Detail = 'DETAIL',
  Main = 'MAIN',
  Top = 'TOP'
}

export type ProductCategoryLocalizationKeyFilters = {
  OR?: InputMaybe<Array<ProductCategoryLocalizationKeyfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCategoryLocalizationKeyfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCategoryOrderBy = {
  createdAtUtc?: InputMaybe<InnerOrder>;
  defaultPackagingType?: InputMaybe<InnerOrder>;
  defaultVolume?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  isPublished?: InputMaybe<InnerOrder>;
  localizationKey?: InputMaybe<InnerOrder>;
  parentId?: InputMaybe<InnerOrder>;
  region?: InputMaybe<InnerOrder>;
  unitType?: InputMaybe<InnerOrder>;
  updatedAtUtc?: InputMaybe<InnerOrder>;
};

export type ProductCategoryParentCategoryRelation = {
  __typename?: 'ProductCategoryParentCategoryRelation';
  createdAtUtc: Scalars['String']['output'];
  defaultPackagingType?: Maybe<Scalars['String']['output']>;
  defaultVolume?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isPublished: Scalars['Boolean']['output'];
  localizationKey: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  unitType?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type ProductCategoryParentIdFilters = {
  OR?: InputMaybe<Array<ProductCategoryParentIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCategoryParentIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCategoryRegion2Filters = {
  OR?: InputMaybe<Array<ProductCategoryRegion2FiltersOr>>;
  productCategoryId?: InputMaybe<ProductCategoryRegion2ProductCategoryIdFilters>;
  region?: InputMaybe<ProductCategoryRegion2RegionFilters>;
};

export type ProductCategoryRegion2FiltersOr = {
  productCategoryId?: InputMaybe<ProductCategoryRegion2ProductCategoryIdFilters>;
  region?: InputMaybe<ProductCategoryRegion2RegionFilters>;
};

export type ProductCategoryRegion2OrderBy = {
  productCategoryId?: InputMaybe<InnerOrder>;
  region?: InputMaybe<InnerOrder>;
};

export type ProductCategoryRegion2ProductCategoryIdFilters = {
  OR?: InputMaybe<Array<ProductCategoryRegion2ProductCategoryIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCategoryRegion2ProductCategoryIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCategoryRegion2RegionFilters = {
  OR?: InputMaybe<Array<ProductCategoryRegion2RegionfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCategoryRegion2RegionfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCategoryRegionFilters = {
  OR?: InputMaybe<Array<ProductCategoryRegionfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCategoryRegionfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCategoryRegionsRelation = {
  __typename?: 'ProductCategoryRegionsRelation';
  productCategoryId: Scalars['Int']['output'];
  region: Scalars['String']['output'];
};

export type ProductCategorySelectItem = {
  __typename?: 'ProductCategorySelectItem';
  name: Scalars['String']['output'];
};

export type ProductCategoryUnitRelation = {
  __typename?: 'ProductCategoryUnitRelation';
  type: Scalars['String']['output'];
};

export type ProductCategoryUnitTypeFilters = {
  OR?: InputMaybe<Array<ProductCategoryUnitTypefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCategoryUnitTypefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCategoryUpdatedAtUtcFilters = {
  OR?: InputMaybe<Array<ProductCategoryUpdatedAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCategoryUpdatedAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ProductPackagingFilters = {
  OR?: InputMaybe<Array<ProductPackagingFiltersOr>>;
  type?: InputMaybe<ProductPackagingTypeFilters>;
};

export type ProductPackagingFiltersOr = {
  type?: InputMaybe<ProductPackagingTypeFilters>;
};

export type ProductPackagingTypeFilters = {
  OR?: InputMaybe<Array<ProductPackagingTypefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ProductPackagingTypefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ProductTemplate = {
  __typename?: 'ProductTemplate';
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  averageWholesalePrice: Scalars['Float']['output'];
  brand: Brand;
  brandId: Scalars['Int']['output'];
  externalProductId?: Maybe<Scalars['String']['output']>;
  externalProvider?: Maybe<IntegrationType>;
  files?: Maybe<Array<File>>;
  hasEditablePrice: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isAnyWholesalerCompatible: Scalars['Boolean']['output'];
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  packagingType: Scalars['String']['output'];
  productCategory: ProductCategory;
  productCategoryId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  productUrl?: Maybe<Scalars['String']['output']>;
  status: ProductTemplateStatusEnum;
  unitType: Scalars['String']['output'];
  unitsPerCase: Scalars['Int']['output'];
  volumePerUnit: Scalars['Float']['output'];
  volumeUnits: Scalars['Float']['output'];
  wholesalers: Array<Wholesaler>;
};

export enum ProductTemplateStatusEnum {
  Approved = 'APPROVED',
  RequiresReview = 'REQUIRES_REVIEW'
}

export type ProductTemplatesByBrandIdInput = {
  brandId: Scalars['Int']['input'];
  productCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  status?: InputMaybe<ProductTemplateStatusEnum>;
};

export type Query = {
  __typename?: 'Query';
  addressByPlaceId: GoogleAddress;
  areWholesalersCompatible: Scalars['Boolean']['output'];
  bespokeTokenCheck: BespokeCheckData;
  bidById: Bid;
  bidIdsForSelection: Array<Scalars['Int']['output']>;
  bidRatingFeedbackValue: Array<BidRatingFeedbackValueSelectItem>;
  bids: Bids;
  bidsViewFilterOptions: Array<Filter>;
  brandById: Brand;
  brandIntegrations: Array<BrandIntegrationsSelectItem>;
  /** List all brand integrations, optionally filtered by brand id, external company id and integration type. Retool authentication required. */
  brandIntegrationsForRetool: Array<BrandIntegrationForRetool>;
  brandSettingsByBrandId: BrandSettings;
  brandUser?: Maybe<BrandUserSelectItem>;
  brandUsers: Array<BrandUserSelectItem>;
  canCreateBid: Scalars['Boolean']['output'];
  commonBid?: Maybe<CommonBidSelectItem>;
  commonBids: Array<CommonBidSelectItem>;
  commonBidsWithPagination?: Maybe<CommonBidsWithPagination>;
  compatibleTenders: Array<Maybe<TenderSelectItem>>;
  connectBid?: Maybe<ConnectBidSelectItem>;
  connectBids: Array<ConnectBidSelectItem>;
  countryRegions: Array<CountyRegion>;
  cursorNotifications: CursorNotifications;
  customerTypes: Array<CustomerType>;
  echo?: Maybe<Scalars['String']['output']>;
  externalProductLivePrice?: Maybe<ExternalProductLivePriceType>;
  getCompanyVatDetails: CompanyVatDetails;
  getDataFromCompanyNumber: RegisteredCompanyWithoutId;
  getLiveStats: LiveStats;
  hasActiveSubscription: HasActiveSubscriptionData;
  hasBids: HasBids;
  hello: Scalars['String']['output'];
  invitationLink?: Maybe<InvitationLinkSelectItem>;
  invitationLinkRegion: Region;
  invitationsToBrand: Array<InvitationLinkItem>;
  invitationsToVenue: Array<InvitationLinkItem>;
  invoices: Array<Invoice>;
  isUserEmailConfirmed: Scalars['Boolean']['output'];
  listingTypes: Array<ListingTypeSelectItem>;
  listingTypesForRetool: Array<ListingTypeSelectItem>;
  locationByCoordinates: GoogleLocationByCoordinates;
  matchBid?: Maybe<MatchBidSelectItem>;
  matchBidAcceptedDealsCount: Array<MatchBidAcceptedDealsCountItem>;
  matchBidFilterOptions: Array<Filter>;
  matchBidVenuePdf: MatchBidVenuePdfAttachment;
  matchBidVenuesByBrand: MatchBidVenueForBrandConnection;
  matchBids: Array<MatchBidSelectItem>;
  matchDashboardConnectStatsByBrandId: MatchDashboardOverviewConnect;
  matchDashboardOverviewByBrandId: MatchDashboardOverview;
  matchDashboardOverviewPdf: MatchDashboardOverviewPdfResult;
  matchDealTrackingByBrand: MatchDealTrackingConnection;
  matchDealTrackingFilterOptions: Array<Filter>;
  matchTargetCriteriaByBrandId: MatchTargetCriteria;
  messagesByBidId: Array<Message>;
  myInvitations: Array<InvitationLinkItem>;
  offsetNotifications: OffsetNotifications;
  /** Fetch live Paramount data using the original request parameters. Retool authentication required. */
  paramountCustomerPrices: Scalars['JSONObject']['output'];
  /** Fetch live Paramount data using the original request parameters. Retool authentication required. */
  paramountCustomerPurchases: Scalars['JSONObject']['output'];
  /** Fetch live Paramount data using the original request parameters. Retool authentication required. */
  paramountCustomers: Scalars['JSONObject']['output'];
  /** Fetch live Paramount data using the original request parameters. Retool authentication required. */
  paramountProducts: Scalars['JSONObject']['output'];
  places: Array<PlaceAutocomplete>;
  previousBid?: Maybe<Bid>;
  productCategories: Array<ProductCategory>;
  productCategoriesByIds: Array<ProductCategory>;
  productCategoriesForRetool: Array<ProductCategory>;
  productCategoriesTree: Array<TopProductCategory>;
  productMainCategoriesTree: Array<MainProductCategory>;
  productPackaging: Array<Scalars['String']['output']>;
  productTemplatesByBrandId: Array<ProductTemplate>;
  productUnits: Array<Scalars['String']['output']>;
  productsInMainCategory: Array<CommonBidProductItem>;
  productsInTopCategory: Array<CommonBidProductItem>;
  ratingFeedbackValues: Array<RatingFeedbackValue>;
  ratingOptions: Array<RatingOption>;
  retoolBidsForTenderAndBidStatusChange: Array<Maybe<RetoolBidsForStatusChangeItem>>;
  retoolBrandById: Brand;
  retoolBrandInList: Brands;
  retoolUsersInList: Users;
  retoolVenuesForTenderAndBidStatusChange: Array<RetoolVenuesForStatusChange>;
  searchVenues: Array<Venue>;
  searchWholesalers: Wholesalers;
  subscription: Subscription;
  subscriptionFeatures: Array<SubscriptionFeaturesItem>;
  successFeeInvoiceById: SuccessFeeInvoice;
  successFeeInvoiceList: Array<SuccessFeeInvoiceListItem>;
  targetedVenuesByVenueCriteria?: Maybe<TargetedVenuesByVenueCriteria>;
  tender?: Maybe<TenderSelectItem>;
  tenderById: Tender;
  tenderDraftById: TenderDraft;
  tenderList: Tenders;
  tenderListFilterOptions: Array<Filter>;
  tenderListRetool: Tenders;
  tenderPreferenceByVenueId: TenderPreference;
  tenderProductOptionsForRetool: TenderProductOptionsForRetool;
  tenders: Array<TenderSelectItem>;
  topLevelProductCategoryById?: Maybe<TopLevelProductCategoryById>;
  topTendersBidsCountMinBoundary: Scalars['Int']['output'];
  /** List all UK brand IDs and names for the Retool brand selector, ordered by brand ID. Retool authentication required. */
  ukBrandsForRetool: Array<BrandOptionForRetool>;
  userBrands: BrandsCursor;
  userExists: Scalars['Boolean']['output'];
  userMe: UserSelectItem;
  userVenues: Venues;
  userVenuesByName: Array<Venue>;
  usersByIds: Array<UserSelectItem>;
  venueById: Venue;
  venueCategories: Array<VenueCategory>;
  venueDashboardMetricsByVenueId: Array<VenueDashboardMetric>;
  venueDashboardTenders: UnionTenders;
  venueIntegrations: Array<VenueIntegrationsSelectItem>;
  venueList: VenuesWithPagination;
  venueLoyaltyLevels: Array<VenueLoyaltyLevel>;
  venueSettingsByVenueId: VenueSettings;
  venueUser?: Maybe<VenueUserSelectItem>;
  venueUsers: Array<VenueUserSelectItem>;
  winningBidsByTenderId: Array<Bid>;
  wonConnectDealsFilterOptions: Array<Filter>;
};


export type QueryAddressByPlaceIdArgs = {
  input: AddressByPlaceIdInput;
};


export type QueryAreWholesalersCompatibleArgs = {
  bidId: Scalars['NonNegativeInt']['input'];
};


export type QueryBespokeTokenCheckArgs = {
  token: Scalars['String']['input'];
};


export type QueryBidByIdArgs = {
  bidId: Scalars['Int']['input'];
};


export type QueryBidIdsForSelectionArgs = {
  filter?: InputMaybe<BidsViewFiltersInput>;
};


export type QueryBidRatingFeedbackValueArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BidRatingFeedbackValueOrderBy>;
  where?: InputMaybe<BidRatingFeedbackValueFilters>;
};


export type QueryBidsArgs = {
  input: BidsInput;
};


export type QueryBidsViewFilterOptionsArgs = {
  input: BidsFilterOptionsInput;
};


export type QueryBrandByIdArgs = {
  brandId: Scalars['Int']['input'];
};


export type QueryBrandIntegrationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BrandIntegrationsOrderBy>;
  where?: InputMaybe<BrandIntegrationsFilters>;
};


export type QueryBrandIntegrationsForRetoolArgs = {
  input?: InputMaybe<BrandIntegrationsForRetoolInput>;
};


export type QueryBrandSettingsByBrandIdArgs = {
  brandId: Scalars['Int']['input'];
};


export type QueryBrandUserArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BrandUserOrderBy>;
  where?: InputMaybe<BrandUserFilters>;
};


export type QueryBrandUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BrandUserOrderBy>;
  where?: InputMaybe<BrandUserFilters>;
};


export type QueryCanCreateBidArgs = {
  brandId: Scalars['NonNegativeInt']['input'];
};


export type QueryCommonBidArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CommonBidOrderBy>;
  where?: InputMaybe<CommonBidFilters>;
};


export type QueryCommonBidsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CommonBidOrderBy>;
  where?: InputMaybe<CommonBidFilters>;
};


export type QueryCommonBidsWithPaginationArgs = {
  orderBy?: InputMaybe<CommonBidSortingOptions>;
  orderDirection?: InputMaybe<SortDirectionEnum>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  where?: InputMaybe<CommonBidsWithPaginationWhereInput>;
};


export type QueryCompatibleTendersArgs = {
  brandId: Scalars['NonNegativeInt']['input'];
  productCategoryId?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


export type QueryConnectBidArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ConnectBidOrderBy>;
  where?: InputMaybe<ConnectBidFilters>;
};


export type QueryConnectBidsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ConnectBidOrderBy>;
  where?: InputMaybe<ConnectBidFilters>;
};


export type QueryCountryRegionsArgs = {
  region: Region;
};


export type QueryCursorNotificationsArgs = {
  input: CursorNotificationsInput;
};


export type QueryEchoArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryExternalProductLivePriceArgs = {
  brandId: Scalars['NonNegativeInt']['input'];
  productTemplateId: Scalars['NonNegativeInt']['input'];
  venueId: Scalars['NonNegativeInt']['input'];
};


export type QueryGetCompanyVatDetailsArgs = {
  input: GetCompanyVatDetailsInput;
};


export type QueryGetDataFromCompanyNumberArgs = {
  input: GetDataFromCompanyNumberInput;
};


export type QueryHasActiveSubscriptionArgs = {
  brandId: Scalars['NonNegativeInt']['input'];
};


export type QueryHasBidsArgs = {
  brandId: Scalars['NonNegativeInt']['input'];
};


export type QueryHelloArgs = {
  input: HelloInput;
};


export type QueryInvitationLinkArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<InvitationLinkOrderBy>;
  where?: InputMaybe<InvitationLinkFilters>;
};


export type QueryInvitationLinkRegionArgs = {
  invitationLinkId: Scalars['UUID']['input'];
};


export type QueryInvitationsToBrandArgs = {
  id: Scalars['NonNegativeInt']['input'];
  status?: InputMaybe<InvitationStatus>;
};


export type QueryInvitationsToVenueArgs = {
  id: Scalars['NonNegativeInt']['input'];
  status?: InputMaybe<InvitationStatus>;
};


export type QueryInvoicesArgs = {
  stripeCustomerId: Scalars['String']['input'];
};


export type QueryListingTypesArgs = {
  region: Region;
};


export type QueryListingTypesForRetoolArgs = {
  region: Region;
};


export type QueryLocationByCoordinatesArgs = {
  input: LocationByCoordinatesInput;
};


export type QueryMatchBidArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MatchBidOrderBy>;
  where?: InputMaybe<MatchBidFilters>;
};


export type QueryMatchBidAcceptedDealsCountArgs = {
  bidIds?: InputMaybe<Array<Scalars['NonNegativeInt']['input']>>;
};


export type QueryMatchBidFilterOptionsArgs = {
  where?: InputMaybe<CommonBidsWithPaginationWhereInput>;
};


export type QueryMatchBidVenuePdfArgs = {
  bidId: Scalars['NonNegativeInt']['input'];
  venueId: Scalars['NonNegativeInt']['input'];
};


export type QueryMatchBidVenuesByBrandArgs = {
  brandId?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  limit: Scalars['NonNegativeInt']['input'];
  offset: Scalars['NonNegativeInt']['input'];
  venueId?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


export type QueryMatchBidsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MatchBidOrderBy>;
  where?: InputMaybe<MatchBidFilters>;
};


export type QueryMatchDashboardConnectStatsByBrandIdArgs = {
  brandId: Scalars['NonNegativeInt']['input'];
};


export type QueryMatchDashboardOverviewByBrandIdArgs = {
  brandId: Scalars['NonNegativeInt']['input'];
};


export type QueryMatchDashboardOverviewPdfArgs = {
  brandId: Scalars['NonNegativeInt']['input'];
};


export type QueryMatchDealTrackingByBrandArgs = {
  bidIds?: InputMaybe<Array<Scalars['NonNegativeInt']['input']>>;
  brandId: Scalars['NonNegativeInt']['input'];
  limit: Scalars['NonNegativeInt']['input'];
  listingTypeLocalizationKeys?: InputMaybe<Array<Scalars['NonEmptyString']['input']>>;
  offset: Scalars['NonNegativeInt']['input'];
  productCategoryLocalizationKeys?: InputMaybe<Array<Scalars['NonEmptyString']['input']>>;
  productTemplateIds?: InputMaybe<Array<Scalars['NonNegativeInt']['input']>>;
  venueIds?: InputMaybe<Array<Scalars['NonNegativeInt']['input']>>;
};


export type QueryMatchDealTrackingFilterOptionsArgs = {
  brandId: Scalars['NonNegativeInt']['input'];
};


export type QueryMatchTargetCriteriaByBrandIdArgs = {
  brandId: Scalars['NonNegativeInt']['input'];
};


export type QueryMessagesByBidIdArgs = {
  bidId: Scalars['Int']['input'];
};


export type QueryOffsetNotificationsArgs = {
  input: OffsetNotificationsInput;
};


export type QueryParamountCustomerPricesArgs = {
  input?: InputMaybe<Scalars['JSONObject']['input']>;
};


export type QueryParamountCustomerPurchasesArgs = {
  input?: InputMaybe<Scalars['JSONObject']['input']>;
};


export type QueryParamountCustomersArgs = {
  input?: InputMaybe<Scalars['JSONObject']['input']>;
};


export type QueryParamountProductsArgs = {
  input?: InputMaybe<Scalars['JSONObject']['input']>;
};


export type QueryPlacesArgs = {
  input: PlacesInput;
};


export type QueryPreviousBidArgs = {
  brandId: Scalars['Int']['input'];
};


export type QueryProductCategoriesArgs = {
  level?: InputMaybe<ProductCategoryLevel>;
};


export type QueryProductCategoriesByIdsArgs = {
  productCategoryIds: Array<Scalars['NonNegativeInt']['input']>;
};


export type QueryProductCategoriesForRetoolArgs = {
  input: ProductCategoriesForRetoolInput;
};


export type QueryProductTemplatesByBrandIdArgs = {
  input: ProductTemplatesByBrandIdInput;
};


export type QueryProductsInMainCategoryArgs = {
  categoryId: Scalars['NonNegativeInt']['input'];
};


export type QueryProductsInTopCategoryArgs = {
  categoryId: Scalars['NonNegativeInt']['input'];
};


export type QueryRetoolBidsForTenderAndBidStatusChangeArgs = {
  region?: InputMaybe<Region>;
  tenderId: Scalars['NonNegativeInt']['input'];
};


export type QueryRetoolBrandByIdArgs = {
  brandId: Scalars['Int']['input'];
};


export type QueryRetoolBrandInListArgs = {
  input: RetoolBrandListInput;
};


export type QueryRetoolUsersInListArgs = {
  input: RetoolUsersInListInput;
};


export type QueryRetoolVenuesForTenderAndBidStatusChangeArgs = {
  region?: InputMaybe<Region>;
};


export type QuerySearchVenuesArgs = {
  input: SearchVenuesInput;
};


export type QuerySearchWholesalersArgs = {
  input: WholesalerSearchInput;
};


export type QuerySubscriptionArgs = {
  brandId: Scalars['NonNegativeInt']['input'];
  stripeSubscriptionId: Scalars['String']['input'];
};


export type QuerySubscriptionFeaturesArgs = {
  brandId: Scalars['NonNegativeInt']['input'];
};


export type QuerySuccessFeeInvoiceByIdArgs = {
  invoiceId: Scalars['String']['input'];
};


export type QuerySuccessFeeInvoiceListArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryTargetedVenuesByVenueCriteriaArgs = {
  input: TargetedVenuesByVenueCriteriaInput;
};


export type QueryTenderArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TenderOrderBy>;
  where?: InputMaybe<TenderFilters>;
};


export type QueryTenderByIdArgs = {
  tenderId: Scalars['NonNegativeInt']['input'];
};


export type QueryTenderDraftByIdArgs = {
  tenderDraftId: Scalars['NonNegativeInt']['input'];
};


export type QueryTenderListArgs = {
  input: TendersInput;
};


export type QueryTenderListRetoolArgs = {
  input: TendersForRetoolInput;
};


export type QueryTenderPreferenceByVenueIdArgs = {
  venueId: Scalars['NonNegativeInt']['input'];
};


export type QueryTenderProductOptionsForRetoolArgs = {
  region: Region;
};


export type QueryTendersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TenderOrderBy>;
  where?: InputMaybe<TenderFilters>;
};


export type QueryTopLevelProductCategoryByIdArgs = {
  productCategoryId: Scalars['NonNegativeInt']['input'];
};


export type QueryUserBrandsArgs = {
  input: UserBrandsInput;
};


export type QueryUserExistsArgs = {
  input: UserExistsInput;
};


export type QueryUserMeArgs = {
  input?: InputMaybe<UserMeInput>;
};


export type QueryUserVenuesArgs = {
  input: UserVenuesInput;
};


export type QueryUserVenuesByNameArgs = {
  venueName: Scalars['String']['input'];
};


export type QueryUsersByIdsArgs = {
  userIds: Array<Scalars['Int']['input']>;
};


export type QueryVenueByIdArgs = {
  venueId: Scalars['Int']['input'];
};


export type QueryVenueCategoriesArgs = {
  region: Region;
};


export type QueryVenueDashboardMetricsByVenueIdArgs = {
  venueId: Scalars['Int']['input'];
};


export type QueryVenueDashboardTendersArgs = {
  input: VenueDashboardTendersInput;
};


export type QueryVenueIntegrationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<VenueIntegrationsOrderBy>;
  where?: InputMaybe<VenueIntegrationsFilters>;
};


export type QueryVenueListArgs = {
  input: VenueListInput;
};


export type QueryVenueSettingsByVenueIdArgs = {
  venueId: Scalars['Int']['input'];
};


export type QueryVenueUserArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<VenueUserOrderBy>;
  where?: InputMaybe<VenueUserFilters>;
};


export type QueryVenueUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<VenueUserOrderBy>;
  where?: InputMaybe<VenueUserFilters>;
};


export type QueryWinningBidsByTenderIdArgs = {
  tenderId: Scalars['Int']['input'];
};


export type QueryWonConnectDealsFilterOptionsArgs = {
  brandId: Scalars['NonNegativeInt']['input'];
};

export type RatingFeedbackValue = {
  __typename?: 'RatingFeedbackValue';
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type RatingOption = {
  __typename?: 'RatingOption';
  name: Scalars['String']['output'];
  type: RatingOptionType;
};

export enum RatingOptionType {
  All = 'ALL',
  Or = 'OR'
}

export type RecalculateConnectBidExternalLivePriceResult = {
  __typename?: 'RecalculateConnectBidExternalLivePriceResult';
  bidId: Scalars['NonNegativeInt']['output'];
  newPrice: Scalars['Float']['output'];
  previousPrice: Scalars['Float']['output'];
  productTemplateId: Scalars['NonNegativeInt']['output'];
  tenderId: Scalars['NonNegativeInt']['output'];
};

export enum Region {
  Australia = 'Australia',
  Spain = 'Spain',
  UnitedKingdom = 'UnitedKingdom'
}

export type RegisteredCompany = {
  __typename?: 'RegisteredCompany';
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  dateOfCreation?: Maybe<Scalars['String']['output']>;
  firstAddressLine?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  secondAddressLine?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type RegisteredCompanyAddressIdFilters = {
  OR?: InputMaybe<Array<RegisteredCompanyAddressIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredCompanyAddressIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredCompanyCountryFilters = {
  OR?: InputMaybe<Array<RegisteredCompanyCountryfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredCompanyCountryfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredCompanyCreatedAtUtcFilters = {
  OR?: InputMaybe<Array<RegisteredCompanyCreatedAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredCompanyCreatedAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredCompanyDateOfCreationFilters = {
  OR?: InputMaybe<Array<RegisteredCompanyDateOfCreationfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredCompanyDateOfCreationfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredCompanyFilters = {
  OR?: InputMaybe<Array<RegisteredCompanyFiltersOr>>;
  addressId?: InputMaybe<RegisteredCompanyAddressIdFilters>;
  country?: InputMaybe<RegisteredCompanyCountryFilters>;
  createdAtUtc?: InputMaybe<RegisteredCompanyCreatedAtUtcFilters>;
  dateOfCreation?: InputMaybe<RegisteredCompanyDateOfCreationFilters>;
  firstAddressLine?: InputMaybe<RegisteredCompanyFirstAddressLineFilters>;
  formattedAddress?: InputMaybe<RegisteredCompanyFormattedAddressFilters>;
  id?: InputMaybe<RegisteredCompanyIdFilters>;
  locality?: InputMaybe<RegisteredCompanyLocalityFilters>;
  name?: InputMaybe<RegisteredCompanyNameFilters>;
  number?: InputMaybe<RegisteredCompanyNumberFilters>;
  postalCode?: InputMaybe<RegisteredCompanyPostalCodeFilters>;
  region?: InputMaybe<RegisteredCompanyRegionFilters>;
  secondAddressLine?: InputMaybe<RegisteredCompanySecondAddressLineFilters>;
  status?: InputMaybe<RegisteredCompanyStatusFilters>;
  updatedAtUtc?: InputMaybe<RegisteredCompanyUpdatedAtUtcFilters>;
};

export type RegisteredCompanyFiltersOr = {
  addressId?: InputMaybe<RegisteredCompanyAddressIdFilters>;
  country?: InputMaybe<RegisteredCompanyCountryFilters>;
  createdAtUtc?: InputMaybe<RegisteredCompanyCreatedAtUtcFilters>;
  dateOfCreation?: InputMaybe<RegisteredCompanyDateOfCreationFilters>;
  firstAddressLine?: InputMaybe<RegisteredCompanyFirstAddressLineFilters>;
  formattedAddress?: InputMaybe<RegisteredCompanyFormattedAddressFilters>;
  id?: InputMaybe<RegisteredCompanyIdFilters>;
  locality?: InputMaybe<RegisteredCompanyLocalityFilters>;
  name?: InputMaybe<RegisteredCompanyNameFilters>;
  number?: InputMaybe<RegisteredCompanyNumberFilters>;
  postalCode?: InputMaybe<RegisteredCompanyPostalCodeFilters>;
  region?: InputMaybe<RegisteredCompanyRegionFilters>;
  secondAddressLine?: InputMaybe<RegisteredCompanySecondAddressLineFilters>;
  status?: InputMaybe<RegisteredCompanyStatusFilters>;
  updatedAtUtc?: InputMaybe<RegisteredCompanyUpdatedAtUtcFilters>;
};

export type RegisteredCompanyFirstAddressLineFilters = {
  OR?: InputMaybe<Array<RegisteredCompanyFirstAddressLinefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredCompanyFirstAddressLinefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredCompanyFormattedAddressFilters = {
  OR?: InputMaybe<Array<RegisteredCompanyFormattedAddressfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredCompanyFormattedAddressfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredCompanyIdFilters = {
  OR?: InputMaybe<Array<RegisteredCompanyIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredCompanyIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredCompanyInput = {
  address?: InputMaybe<GoogleAddressInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  dateOfCreation?: InputMaybe<Scalars['String']['input']>;
  firstAddressLine?: InputMaybe<Scalars['String']['input']>;
  formattedAddress?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  number: Scalars['String']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  secondAddressLine?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredCompanyInsertInput = {
  address?: InputMaybe<AddressInsertInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  dateOfCreation?: InputMaybe<Scalars['String']['input']>;
  firstAddressLine?: InputMaybe<Scalars['String']['input']>;
  formattedAddress?: InputMaybe<Scalars['String']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  number: Scalars['String']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  secondAddressLine?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredCompanyLocalityFilters = {
  OR?: InputMaybe<Array<RegisteredCompanyLocalityfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredCompanyLocalityfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredCompanyNameFilters = {
  OR?: InputMaybe<Array<RegisteredCompanyNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredCompanyNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredCompanyNumberFilters = {
  OR?: InputMaybe<Array<RegisteredCompanyNumberfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredCompanyNumberfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredCompanyPostalCodeFilters = {
  OR?: InputMaybe<Array<RegisteredCompanyPostalCodefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredCompanyPostalCodefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredCompanyRegionFilters = {
  OR?: InputMaybe<Array<RegisteredCompanyRegionfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredCompanyRegionfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredCompanySecondAddressLineFilters = {
  OR?: InputMaybe<Array<RegisteredCompanySecondAddressLinefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredCompanySecondAddressLinefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredCompanyStatusFilters = {
  OR?: InputMaybe<Array<RegisteredCompanyStatusfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredCompanyStatusfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredCompanyUpdatedAtUtcFilters = {
  OR?: InputMaybe<Array<RegisteredCompanyUpdatedAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredCompanyUpdatedAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredCompanyWithoutId = {
  __typename?: 'RegisteredCompanyWithoutId';
  country?: Maybe<Scalars['String']['output']>;
  dateOfCreation: Scalars['String']['output'];
  firstAddressLine?: Maybe<Scalars['String']['output']>;
  formattedAddress: Scalars['String']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  secondAddressLine?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type RequestEmailArgument = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type RequestEmailInput = {
  brandId?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  emailType: EmailType;
  region: Region;
  requestEmailArguments: Array<RequestEmailArgument>;
  requesterEmail: Scalars['String']['input'];
};

export type RetoolBidsForStatusChangeItem = {
  __typename?: 'RetoolBidsForStatusChangeItem';
  bidId: Scalars['NonNegativeInt']['output'];
  bidStatus: BidStatus;
  brandName: Scalars['String']['output'];
  brandUserId: Scalars['NonNegativeInt']['output'];
  email: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  tenderId: Scalars['NonNegativeInt']['output'];
  tenderName: Scalars['String']['output'];
  tenderStatus: TenderStatus;
  venueName: Scalars['String']['output'];
};

export type RetoolBrandListFilter = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Region>;
};

export type RetoolBrandListInput = {
  filter?: InputMaybe<RetoolBrandListFilter>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderDirection?: InputMaybe<SortDirectionEnum>;
};

export type RetoolChangeBidStatusInput = {
  bidId: Scalars['NonNegativeInt']['input'];
  bidStatus: BidStatus;
};

export type RetoolChangeTenderAllBidsStatusInput = {
  bidStatus: BidStatus;
  tenderId: Scalars['NonNegativeInt']['input'];
};

export type RetoolChangeTenderStatusInput = {
  tenderId: Scalars['Int']['input'];
  tenderStatus: TenderStatus;
};

export type RetoolUsersFilterInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Region>;
  status?: InputMaybe<UserStatus>;
};

export type RetoolUsersInListInput = {
  filter?: InputMaybe<RetoolUsersFilterInput>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderDirection?: InputMaybe<SortDirectionEnum>;
};

export type S3File = {
  __typename?: 'S3File';
  bucketKey: Scalars['NonEmptyString']['output'];
  downloadUrl: Scalars['URL']['output'];
  fileSizeInKib: Scalars['NonNegativeFloat']['output'];
  filename: Scalars['NonEmptyString']['output'];
};

export type S3FileInput = {
  bucketKey: Scalars['NonEmptyString']['input'];
  fileSizeInKib: Scalars['NonNegativeFloat']['input'];
  filename: Scalars['NonEmptyString']['input'];
};

export type SearchVenuesInput = {
  venueName: Scalars['String']['input'];
  withPublicTendersOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SetUserRole {
  Admin = 'ADMIN',
  User = 'USER'
}

export type SignUpInput = {
  contactName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  invitationId?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  region: Region;
  registeredCompany?: InputMaybe<RegisteredCompanyInput>;
  userType: UserType;
};

export enum SortDirectionEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Subscription = {
  __typename?: 'Subscription';
  amount?: Maybe<Scalars['Int']['output']>;
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['Int']['output'];
  currentPeriodEnd: Scalars['Int']['output'];
  currentPeriodStart: Scalars['Int']['output'];
  customerId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  interval?: Maybe<SubscriptionInterval>;
  isCanceled: Scalars['Boolean']['output'];
  isExpired: Scalars['Boolean']['output'];
  subscriptionTier?: Maybe<SubscriptionTier>;
  successFee?: Maybe<Scalars['Float']['output']>;
};

export enum SubscriptionFeatures {
  MaximumProducts = 'maximumProducts',
  MaximumUsersInBrand = 'maximumUsersInBrand'
}

export type SubscriptionFeaturesItem = {
  __typename?: 'SubscriptionFeaturesItem';
  brandId: Scalars['NonNegativeInt']['output'];
  type: SubscriptionFeatures;
  value: Scalars['NonNegativeInt']['output'];
};

export enum SubscriptionInterval {
  Month = 'month',
  Year = 'year'
}

export enum SubscriptionTier {
  Enterprise = 'ENTERPRISE',
  EnterpriseNew = 'ENTERPRISE_NEW',
  FreeTrial = 'FREE_TRIAL',
  Growth = 'GROWTH',
  Premium = 'PREMIUM',
  Pro = 'PRO',
  Standard = 'STANDARD'
}

export type SuccessFeeInvoice = {
  __typename?: 'SuccessFeeInvoice';
  createdAt: Scalars['Int']['output'];
  customerId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  paymentUrl: Scalars['String']['output'];
  pdfUrl: Scalars['String']['output'];
  status: Scalars['String']['output'];
  total: Scalars['Float']['output'];
};

export type SuccessFeeInvoiceListItem = {
  __typename?: 'SuccessFeeInvoiceListItem';
  averageWholesaleBidPrice: Scalars['Float']['output'];
  bidUnitType: Scalars['String']['output'];
  bidVolumeUnits: Scalars['Float']['output'];
  createdAt: Scalars['Int']['output'];
  customerId: Scalars['String']['output'];
  estimatedVolume: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  packagingType: Scalars['String']['output'];
  paymentUrl: Scalars['String']['output'];
  pdfUrl: Scalars['String']['output'];
  status: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  tenderName: Scalars['String']['output'];
  tenderUnitType: Scalars['String']['output'];
  tenderVolumeUnits: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  venueName: Scalars['String']['output'];
};

export type TargetedVenuesByVenueCriteria = {
  __typename?: 'TargetedVenuesByVenueCriteria';
  averageVolumePerListing?: Maybe<Scalars['Float']['output']>;
  detailedCategoryVolume?: Maybe<Scalars['Float']['output']>;
  mainCategoryVolume?: Maybe<Scalars['Float']['output']>;
  targetCustomers?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type TargetedVenuesByVenueCriteriaInput = {
  customerTypes?: InputMaybe<Array<Scalars['NonNegativeInt']['input']>>;
  listingTypeId?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  loyaltyLevels?: InputMaybe<Array<Scalars['NonNegativeInt']['input']>>;
  minimumVolume?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  productId: Scalars['NonNegativeInt']['input'];
  regions?: InputMaybe<Array<Scalars['NonNegativeInt']['input']>>;
  targetProductCategoryId?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  venueTypes?: InputMaybe<Array<Scalars['NonNegativeInt']['input']>>;
};

export type Tender = {
  __typename?: 'Tender';
  createdAtUtc?: Maybe<Scalars['String']['output']>;
  estimatedVolume?: Maybe<Scalars['Int']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<File>>;
  hasBrandsBid?: Maybe<Scalars['Boolean']['output']>;
  hostingChargeInvoiceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAnyWholesalerCompatible?: Maybe<Scalars['Boolean']['output']>;
  isDirectSupplyCompatible?: Maybe<Scalars['Boolean']['output']>;
  isPrivate: Scalars['Boolean']['output'];
  listingEndsAtUtc?: Maybe<Scalars['Date']['output']>;
  listingStartsAtUtc?: Maybe<Scalars['Date']['output']>;
  listingType: ListingTypeSelectItem;
  listingTypeId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  packagingType?: Maybe<Scalars['String']['output']>;
  productCategories: Array<ProductCategory>;
  productCategoryIds: Array<Scalars['Int']['output']>;
  receivedSupportStatus?: Maybe<TenderSupportStatus>;
  region: Region;
  status: TenderStatus;
  supportDetails?: Maybe<Scalars['String']['output']>;
  supportsDiscount?: Maybe<TenderSupportOption>;
  supportsFreeStock?: Maybe<TenderSupportOption>;
  supportsListingFee?: Maybe<TenderSupportOption>;
  supportsPosBudget?: Maybe<TenderSupportOption>;
  supportsRetroDiscount?: Maybe<TenderSupportOption>;
  tenderDetails?: Maybe<Scalars['String']['output']>;
  tenderEndsAtUtc?: Maybe<Scalars['Date']['output']>;
  tenderStartsAtUtc?: Maybe<Scalars['Date']['output']>;
  totalReceivedBids: Scalars['Int']['output'];
  unitType?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
  venue: Venue;
  venueId: Scalars['Int']['output'];
  volumeDetails?: Maybe<Scalars['String']['output']>;
  volumeUnits?: Maybe<Scalars['Float']['output']>;
  wholesalers?: Maybe<Array<Wholesaler>>;
};

export type TenderConnectBidsRelation = {
  __typename?: 'TenderConnectBidsRelation';
  bidId: Scalars['Int']['output'];
  commonBid?: Maybe<TenderConnectBidsRelationCommonBidRelation>;
  matchBid?: Maybe<TenderConnectBidsRelationMatchBidRelation>;
  matchBidId?: Maybe<Scalars['Int']['output']>;
  tender?: Maybe<TenderConnectBidsRelationTenderRelation>;
  tenderId: Scalars['Int']['output'];
};


export type TenderConnectBidsRelationCommonBidArgs = {
  where?: InputMaybe<CommonBidFilters>;
};


export type TenderConnectBidsRelationMatchBidArgs = {
  where?: InputMaybe<MatchBidFilters>;
};


export type TenderConnectBidsRelationTenderArgs = {
  where?: InputMaybe<TenderFilters>;
};

export type TenderConnectBidsRelationCommonBidRelation = {
  __typename?: 'TenderConnectBidsRelationCommonBidRelation';
  brand?: Maybe<TenderConnectBidsRelationCommonBidRelationBrandRelation>;
  brandId: Scalars['Int']['output'];
  connectBid?: Maybe<TenderConnectBidsRelationCommonBidRelationConnectBidRelation>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  matchBid?: Maybe<TenderConnectBidsRelationCommonBidRelationMatchBidRelation>;
  otherSupportAndTerms?: Maybe<Scalars['String']['output']>;
  product?: Maybe<TenderConnectBidsRelationCommonBidRelationProductRelation>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  region: CommonBidRegionEnum;
  status: CommonBidStatusEnum;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  supportedWholesalers: Array<TenderConnectBidsRelationCommonBidRelationSupportedWholesalersRelation>;
  supports: Array<TenderConnectBidsRelationCommonBidRelationSupportsRelation>;
  type: CommonBidTypeEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<TenderConnectBidsRelationCommonBidRelationUserRelation>;
  userId: Scalars['Int']['output'];
};


export type TenderConnectBidsRelationCommonBidRelationBrandArgs = {
  where?: InputMaybe<BrandFilters>;
};


export type TenderConnectBidsRelationCommonBidRelationConnectBidArgs = {
  where?: InputMaybe<ConnectBidFilters>;
};


export type TenderConnectBidsRelationCommonBidRelationMatchBidArgs = {
  where?: InputMaybe<MatchBidFilters>;
};


export type TenderConnectBidsRelationCommonBidRelationProductArgs = {
  where?: InputMaybe<CommonBidProductFilters>;
};


export type TenderConnectBidsRelationCommonBidRelationSupportedWholesalersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CommonBidWholesalerOrderBy>;
  where?: InputMaybe<CommonBidWholesalerFilters>;
};


export type TenderConnectBidsRelationCommonBidRelationSupportsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CommonBidSupportOrderBy>;
  where?: InputMaybe<CommonBidSupportFilters>;
};


export type TenderConnectBidsRelationCommonBidRelationUserArgs = {
  where?: InputMaybe<UserFilters>;
};

export type TenderConnectBidsRelationCommonBidRelationBrandRelation = {
  __typename?: 'TenderConnectBidsRelationCommonBidRelationBrandRelation';
  address?: Maybe<TenderConnectBidsRelationCommonBidRelationBrandRelationAddressRelation>;
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  awrsCompanyName?: Maybe<Scalars['String']['output']>;
  awrsDeregistrationDate?: Maybe<Scalars['String']['output']>;
  awrsNumber?: Maybe<Scalars['String']['output']>;
  awrsPlaceBusiness?: Maybe<Scalars['String']['output']>;
  awrsRegistrationDate?: Maybe<Scalars['String']['output']>;
  awrsStatus?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<TenderConnectBidsRelationCommonBidRelationBrandRelationBillingAddressRelation>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  brandIntegrations: Array<TenderConnectBidsRelationCommonBidRelationBrandRelationBrandIntegrationsRelation>;
  brandUsers: Array<TenderConnectBidsRelationCommonBidRelationBrandRelationBrandUsersRelation>;
  canSeeOtherBids?: Maybe<Scalars['Boolean']['output']>;
  complianceCheckDate?: Maybe<Scalars['String']['output']>;
  complianceConfirmation?: Maybe<Scalars['String']['output']>;
  complianceNextDate?: Maybe<Scalars['String']['output']>;
  complianceRiskLevel?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  failedPaymentIntentCounter: Scalars['Int']['output'];
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  isAnonymousBidAllowed?: Maybe<Scalars['Boolean']['output']>;
  isEnterpriseSubscriptionRequestSent?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompany?: Maybe<TenderConnectBidsRelationCommonBidRelationBrandRelationRegisteredCompanyRelation>;
  registeredCompanyId: Scalars['Int']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripePaymentLink?: Maybe<Scalars['String']['output']>;
  stripePaymentLinkHash?: Maybe<Scalars['String']['output']>;
  stripePaymentType?: Maybe<Scalars['String']['output']>;
  stripeProductPriceId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  tradingAddress?: Maybe<TenderConnectBidsRelationCommonBidRelationBrandRelationTradingAddressRelation>;
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  vatCompanyName?: Maybe<Scalars['String']['output']>;
  vatConsultationNumber?: Maybe<Scalars['String']['output']>;
  vatCountryCode?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  vatProcessingDate?: Maybe<Scalars['String']['output']>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};


export type TenderConnectBidsRelationCommonBidRelationBrandRelationAddressArgs = {
  where?: InputMaybe<AddressFilters>;
};


export type TenderConnectBidsRelationCommonBidRelationBrandRelationBillingAddressArgs = {
  where?: InputMaybe<AddressFilters>;
};


export type TenderConnectBidsRelationCommonBidRelationBrandRelationBrandIntegrationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BrandIntegrationsOrderBy>;
  where?: InputMaybe<BrandIntegrationsFilters>;
};


export type TenderConnectBidsRelationCommonBidRelationBrandRelationBrandUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BrandUserOrderBy>;
  where?: InputMaybe<BrandUserFilters>;
};


export type TenderConnectBidsRelationCommonBidRelationBrandRelationRegisteredCompanyArgs = {
  where?: InputMaybe<RegisteredCompanyFilters>;
};


export type TenderConnectBidsRelationCommonBidRelationBrandRelationTradingAddressArgs = {
  where?: InputMaybe<AddressFilters>;
};

export type TenderConnectBidsRelationCommonBidRelationBrandRelationAddressRelation = {
  __typename?: 'TenderConnectBidsRelationCommonBidRelationBrandRelationAddressRelation';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type TenderConnectBidsRelationCommonBidRelationBrandRelationBillingAddressRelation = {
  __typename?: 'TenderConnectBidsRelationCommonBidRelationBrandRelationBillingAddressRelation';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type TenderConnectBidsRelationCommonBidRelationBrandRelationBrandIntegrationsRelation = {
  __typename?: 'TenderConnectBidsRelationCommonBidRelationBrandRelationBrandIntegrationsRelation';
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  externalCompanyId: Scalars['String']['output'];
  externalUserId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  integrationType: BrandIntegrationsIntegrationTypeEnum;
  /** JSON */
  metadata?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type TenderConnectBidsRelationCommonBidRelationBrandRelationBrandUsersRelation = {
  __typename?: 'TenderConnectBidsRelationCommonBidRelationBrandRelationBrandUsersRelation';
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  role: BrandUserRoleEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type TenderConnectBidsRelationCommonBidRelationBrandRelationRegisteredCompanyRelation = {
  __typename?: 'TenderConnectBidsRelationCommonBidRelationBrandRelationRegisteredCompanyRelation';
  addressId?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  dateOfCreation?: Maybe<Scalars['String']['output']>;
  firstAddressLine?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  secondAddressLine?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type TenderConnectBidsRelationCommonBidRelationBrandRelationTradingAddressRelation = {
  __typename?: 'TenderConnectBidsRelationCommonBidRelationBrandRelationTradingAddressRelation';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type TenderConnectBidsRelationCommonBidRelationConnectBidRelation = {
  __typename?: 'TenderConnectBidsRelationCommonBidRelationConnectBidRelation';
  bidId: Scalars['Int']['output'];
  matchBidId?: Maybe<Scalars['Int']['output']>;
  tenderId: Scalars['Int']['output'];
};

export type TenderConnectBidsRelationCommonBidRelationMatchBidRelation = {
  __typename?: 'TenderConnectBidsRelationCommonBidRelationMatchBidRelation';
  autoTenderBid?: Maybe<Scalars['Boolean']['output']>;
  bidId: Scalars['Int']['output'];
  commonBid?: Maybe<TenderConnectBidsRelationCommonBidRelationMatchBidRelationCommonBidRelation>;
  credit?: Maybe<Scalars['Boolean']['output']>;
  listingLength: Scalars['Int']['output'];
  maximumAcceptedDeals: Scalars['Int']['output'];
  product?: Maybe<TenderConnectBidsRelationCommonBidRelationMatchBidRelationProductRelation>;
  venueCriteria?: Maybe<TenderConnectBidsRelationCommonBidRelationMatchBidRelationVenueCriteriaRelation>;
};


export type TenderConnectBidsRelationCommonBidRelationMatchBidRelationCommonBidArgs = {
  where?: InputMaybe<CommonBidFilters>;
};


export type TenderConnectBidsRelationCommonBidRelationMatchBidRelationProductArgs = {
  where?: InputMaybe<MatchBidProductFilters>;
};


export type TenderConnectBidsRelationCommonBidRelationMatchBidRelationVenueCriteriaArgs = {
  where?: InputMaybe<MatchBidVenueCriteriaFilters>;
};

export type TenderConnectBidsRelationCommonBidRelationMatchBidRelationCommonBidRelation = {
  __typename?: 'TenderConnectBidsRelationCommonBidRelationMatchBidRelationCommonBidRelation';
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  otherSupportAndTerms?: Maybe<Scalars['String']['output']>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  region: CommonBidRegionEnum;
  status: CommonBidStatusEnum;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  type: CommonBidTypeEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type TenderConnectBidsRelationCommonBidRelationMatchBidRelationProductRelation = {
  __typename?: 'TenderConnectBidsRelationCommonBidRelationMatchBidRelationProductRelation';
  bidId: Scalars['Int']['output'];
  externalProductId?: Maybe<Scalars['String']['output']>;
  externalProvider?: Maybe<MatchBidProductExternalProviderEnum>;
  productId: Scalars['Int']['output'];
};

export type TenderConnectBidsRelationCommonBidRelationMatchBidRelationVenueCriteriaRelation = {
  __typename?: 'TenderConnectBidsRelationCommonBidRelationMatchBidRelationVenueCriteriaRelation';
  bidId: Scalars['Int']['output'];
  capturedTargetedVenues?: Maybe<Scalars['Int']['output']>;
  /** JSON */
  customerTypes?: Maybe<Scalars['String']['output']>;
  listingTypeId: Scalars['Int']['output'];
  /** JSON */
  loyaltyLevels?: Maybe<Scalars['String']['output']>;
  minimumVolume: Scalars['Int']['output'];
  /** JSON */
  regions?: Maybe<Scalars['String']['output']>;
  targetProductCategory?: Maybe<Scalars['Int']['output']>;
  /** JSON */
  venueTypes?: Maybe<Scalars['String']['output']>;
};

export type TenderConnectBidsRelationCommonBidRelationProductRelation = {
  __typename?: 'TenderConnectBidsRelationCommonBidRelationProductRelation';
  /** JSON */
  attachments?: Maybe<Scalars['String']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  averageWholesalePrice: Scalars['Float']['output'];
  bid?: Maybe<TenderConnectBidsRelationCommonBidRelationProductRelationBidRelation>;
  bidId: Scalars['Int']['output'];
  /** JSON */
  image?: Maybe<Scalars['String']['output']>;
  isAnyWholesalerCompatible: Scalars['Boolean']['output'];
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  packagingType: Scalars['String']['output'];
  productCategory?: Maybe<TenderConnectBidsRelationCommonBidRelationProductRelationProductCategoryRelation>;
  productCategoryId: Scalars['Int']['output'];
  productTemplateId?: Maybe<Scalars['Int']['output']>;
  unitType: Scalars['String']['output'];
  unitsPerCase: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
  volumePerUnit: Scalars['Float']['output'];
  volumeUnits: Scalars['Float']['output'];
};


export type TenderConnectBidsRelationCommonBidRelationProductRelationBidArgs = {
  where?: InputMaybe<CommonBidFilters>;
};


export type TenderConnectBidsRelationCommonBidRelationProductRelationProductCategoryArgs = {
  where?: InputMaybe<ProductCategoryFilters>;
};

export type TenderConnectBidsRelationCommonBidRelationProductRelationBidRelation = {
  __typename?: 'TenderConnectBidsRelationCommonBidRelationProductRelationBidRelation';
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  otherSupportAndTerms?: Maybe<Scalars['String']['output']>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  region: CommonBidRegionEnum;
  status: CommonBidStatusEnum;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  type: CommonBidTypeEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type TenderConnectBidsRelationCommonBidRelationProductRelationProductCategoryRelation = {
  __typename?: 'TenderConnectBidsRelationCommonBidRelationProductRelationProductCategoryRelation';
  createdAtUtc: Scalars['String']['output'];
  defaultPackagingType?: Maybe<Scalars['String']['output']>;
  defaultVolume?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isPublished: Scalars['Boolean']['output'];
  localizationKey: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  unitType?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type TenderConnectBidsRelationCommonBidRelationSupportedWholesalersRelation = {
  __typename?: 'TenderConnectBidsRelationCommonBidRelationSupportedWholesalersRelation';
  bid?: Maybe<TenderConnectBidsRelationCommonBidRelationSupportedWholesalersRelationBidRelation>;
  bidId: Scalars['Int']['output'];
  wholesaler?: Maybe<TenderConnectBidsRelationCommonBidRelationSupportedWholesalersRelationWholesalerRelation>;
  wholesalerId: Scalars['Int']['output'];
};


export type TenderConnectBidsRelationCommonBidRelationSupportedWholesalersRelationBidArgs = {
  where?: InputMaybe<CommonBidFilters>;
};


export type TenderConnectBidsRelationCommonBidRelationSupportedWholesalersRelationWholesalerArgs = {
  where?: InputMaybe<WholesalerFilters>;
};

export type TenderConnectBidsRelationCommonBidRelationSupportedWholesalersRelationBidRelation = {
  __typename?: 'TenderConnectBidsRelationCommonBidRelationSupportedWholesalersRelationBidRelation';
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  otherSupportAndTerms?: Maybe<Scalars['String']['output']>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  region: CommonBidRegionEnum;
  status: CommonBidStatusEnum;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  type: CommonBidTypeEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type TenderConnectBidsRelationCommonBidRelationSupportedWholesalersRelationWholesalerRelation = {
  __typename?: 'TenderConnectBidsRelationCommonBidRelationSupportedWholesalersRelationWholesalerRelation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  region: Scalars['String']['output'];
};

export type TenderConnectBidsRelationCommonBidRelationSupportsRelation = {
  __typename?: 'TenderConnectBidsRelationCommonBidRelationSupportsRelation';
  amount: Scalars['Float']['output'];
  /** JSON */
  attachments?: Maybe<Scalars['String']['output']>;
  bid?: Maybe<TenderConnectBidsRelationCommonBidRelationSupportsRelationBidRelation>;
  bidId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isProvided: Scalars['Boolean']['output'];
  isReceived: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  supportType: CommonBidSupportSupportTypeEnum;
};


export type TenderConnectBidsRelationCommonBidRelationSupportsRelationBidArgs = {
  where?: InputMaybe<CommonBidFilters>;
};

export type TenderConnectBidsRelationCommonBidRelationSupportsRelationBidRelation = {
  __typename?: 'TenderConnectBidsRelationCommonBidRelationSupportsRelationBidRelation';
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  otherSupportAndTerms?: Maybe<Scalars['String']['output']>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  region: CommonBidRegionEnum;
  status: CommonBidStatusEnum;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  type: CommonBidTypeEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type TenderConnectBidsRelationCommonBidRelationUserRelation = {
  __typename?: 'TenderConnectBidsRelationCommonBidRelationUserRelation';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type TenderConnectBidsRelationMatchBidRelation = {
  __typename?: 'TenderConnectBidsRelationMatchBidRelation';
  autoTenderBid?: Maybe<Scalars['Boolean']['output']>;
  bidId: Scalars['Int']['output'];
  commonBid?: Maybe<TenderConnectBidsRelationMatchBidRelationCommonBidRelation>;
  credit?: Maybe<Scalars['Boolean']['output']>;
  listingLength: Scalars['Int']['output'];
  maximumAcceptedDeals: Scalars['Int']['output'];
  product?: Maybe<TenderConnectBidsRelationMatchBidRelationProductRelation>;
  venueCriteria?: Maybe<TenderConnectBidsRelationMatchBidRelationVenueCriteriaRelation>;
};


export type TenderConnectBidsRelationMatchBidRelationCommonBidArgs = {
  where?: InputMaybe<CommonBidFilters>;
};


export type TenderConnectBidsRelationMatchBidRelationProductArgs = {
  where?: InputMaybe<MatchBidProductFilters>;
};


export type TenderConnectBidsRelationMatchBidRelationVenueCriteriaArgs = {
  where?: InputMaybe<MatchBidVenueCriteriaFilters>;
};

export type TenderConnectBidsRelationMatchBidRelationCommonBidRelation = {
  __typename?: 'TenderConnectBidsRelationMatchBidRelationCommonBidRelation';
  brand?: Maybe<TenderConnectBidsRelationMatchBidRelationCommonBidRelationBrandRelation>;
  brandId: Scalars['Int']['output'];
  connectBid?: Maybe<TenderConnectBidsRelationMatchBidRelationCommonBidRelationConnectBidRelation>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  matchBid?: Maybe<TenderConnectBidsRelationMatchBidRelationCommonBidRelationMatchBidRelation>;
  otherSupportAndTerms?: Maybe<Scalars['String']['output']>;
  product?: Maybe<TenderConnectBidsRelationMatchBidRelationCommonBidRelationProductRelation>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  region: CommonBidRegionEnum;
  status: CommonBidStatusEnum;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  supportedWholesalers: Array<TenderConnectBidsRelationMatchBidRelationCommonBidRelationSupportedWholesalersRelation>;
  supports: Array<TenderConnectBidsRelationMatchBidRelationCommonBidRelationSupportsRelation>;
  type: CommonBidTypeEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<TenderConnectBidsRelationMatchBidRelationCommonBidRelationUserRelation>;
  userId: Scalars['Int']['output'];
};


export type TenderConnectBidsRelationMatchBidRelationCommonBidRelationBrandArgs = {
  where?: InputMaybe<BrandFilters>;
};


export type TenderConnectBidsRelationMatchBidRelationCommonBidRelationConnectBidArgs = {
  where?: InputMaybe<ConnectBidFilters>;
};


export type TenderConnectBidsRelationMatchBidRelationCommonBidRelationMatchBidArgs = {
  where?: InputMaybe<MatchBidFilters>;
};


export type TenderConnectBidsRelationMatchBidRelationCommonBidRelationProductArgs = {
  where?: InputMaybe<CommonBidProductFilters>;
};


export type TenderConnectBidsRelationMatchBidRelationCommonBidRelationSupportedWholesalersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CommonBidWholesalerOrderBy>;
  where?: InputMaybe<CommonBidWholesalerFilters>;
};


export type TenderConnectBidsRelationMatchBidRelationCommonBidRelationSupportsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CommonBidSupportOrderBy>;
  where?: InputMaybe<CommonBidSupportFilters>;
};


export type TenderConnectBidsRelationMatchBidRelationCommonBidRelationUserArgs = {
  where?: InputMaybe<UserFilters>;
};

export type TenderConnectBidsRelationMatchBidRelationCommonBidRelationBrandRelation = {
  __typename?: 'TenderConnectBidsRelationMatchBidRelationCommonBidRelationBrandRelation';
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  awrsCompanyName?: Maybe<Scalars['String']['output']>;
  awrsDeregistrationDate?: Maybe<Scalars['String']['output']>;
  awrsNumber?: Maybe<Scalars['String']['output']>;
  awrsPlaceBusiness?: Maybe<Scalars['String']['output']>;
  awrsRegistrationDate?: Maybe<Scalars['String']['output']>;
  awrsStatus?: Maybe<Scalars['String']['output']>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  canSeeOtherBids?: Maybe<Scalars['Boolean']['output']>;
  complianceCheckDate?: Maybe<Scalars['String']['output']>;
  complianceConfirmation?: Maybe<Scalars['String']['output']>;
  complianceNextDate?: Maybe<Scalars['String']['output']>;
  complianceRiskLevel?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  failedPaymentIntentCounter: Scalars['Int']['output'];
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  isAnonymousBidAllowed?: Maybe<Scalars['Boolean']['output']>;
  isEnterpriseSubscriptionRequestSent?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompanyId: Scalars['Int']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripePaymentLink?: Maybe<Scalars['String']['output']>;
  stripePaymentLinkHash?: Maybe<Scalars['String']['output']>;
  stripePaymentType?: Maybe<Scalars['String']['output']>;
  stripeProductPriceId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionTier: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  vatCompanyName?: Maybe<Scalars['String']['output']>;
  vatConsultationNumber?: Maybe<Scalars['String']['output']>;
  vatCountryCode?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  vatProcessingDate?: Maybe<Scalars['String']['output']>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};

export type TenderConnectBidsRelationMatchBidRelationCommonBidRelationConnectBidRelation = {
  __typename?: 'TenderConnectBidsRelationMatchBidRelationCommonBidRelationConnectBidRelation';
  bidId: Scalars['Int']['output'];
  matchBidId?: Maybe<Scalars['Int']['output']>;
  tenderId: Scalars['Int']['output'];
};

export type TenderConnectBidsRelationMatchBidRelationCommonBidRelationMatchBidRelation = {
  __typename?: 'TenderConnectBidsRelationMatchBidRelationCommonBidRelationMatchBidRelation';
  autoTenderBid?: Maybe<Scalars['Boolean']['output']>;
  bidId: Scalars['Int']['output'];
  credit?: Maybe<Scalars['Boolean']['output']>;
  listingLength: Scalars['Int']['output'];
  maximumAcceptedDeals: Scalars['Int']['output'];
};

export type TenderConnectBidsRelationMatchBidRelationCommonBidRelationProductRelation = {
  __typename?: 'TenderConnectBidsRelationMatchBidRelationCommonBidRelationProductRelation';
  /** JSON */
  attachments?: Maybe<Scalars['String']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  averageWholesalePrice: Scalars['Float']['output'];
  bidId: Scalars['Int']['output'];
  /** JSON */
  image?: Maybe<Scalars['String']['output']>;
  isAnyWholesalerCompatible: Scalars['Boolean']['output'];
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  packagingType: Scalars['String']['output'];
  productCategoryId: Scalars['Int']['output'];
  productTemplateId?: Maybe<Scalars['Int']['output']>;
  unitType: Scalars['String']['output'];
  unitsPerCase: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
  volumePerUnit: Scalars['Float']['output'];
  volumeUnits: Scalars['Float']['output'];
};

export type TenderConnectBidsRelationMatchBidRelationCommonBidRelationSupportedWholesalersRelation = {
  __typename?: 'TenderConnectBidsRelationMatchBidRelationCommonBidRelationSupportedWholesalersRelation';
  bidId: Scalars['Int']['output'];
  wholesalerId: Scalars['Int']['output'];
};

export type TenderConnectBidsRelationMatchBidRelationCommonBidRelationSupportsRelation = {
  __typename?: 'TenderConnectBidsRelationMatchBidRelationCommonBidRelationSupportsRelation';
  amount: Scalars['Float']['output'];
  /** JSON */
  attachments?: Maybe<Scalars['String']['output']>;
  bidId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isProvided: Scalars['Boolean']['output'];
  isReceived: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  supportType: CommonBidSupportSupportTypeEnum;
};

export type TenderConnectBidsRelationMatchBidRelationCommonBidRelationUserRelation = {
  __typename?: 'TenderConnectBidsRelationMatchBidRelationCommonBidRelationUserRelation';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type TenderConnectBidsRelationMatchBidRelationProductRelation = {
  __typename?: 'TenderConnectBidsRelationMatchBidRelationProductRelation';
  bid?: Maybe<TenderConnectBidsRelationMatchBidRelationProductRelationBidRelation>;
  bidId: Scalars['Int']['output'];
  commonProduct?: Maybe<TenderConnectBidsRelationMatchBidRelationProductRelationCommonProductRelation>;
  externalProductId?: Maybe<Scalars['String']['output']>;
  externalProvider?: Maybe<MatchBidProductExternalProviderEnum>;
  productId: Scalars['Int']['output'];
};


export type TenderConnectBidsRelationMatchBidRelationProductRelationBidArgs = {
  where?: InputMaybe<MatchBidFilters>;
};


export type TenderConnectBidsRelationMatchBidRelationProductRelationCommonProductArgs = {
  where?: InputMaybe<CommonBidProductFilters>;
};

export type TenderConnectBidsRelationMatchBidRelationProductRelationBidRelation = {
  __typename?: 'TenderConnectBidsRelationMatchBidRelationProductRelationBidRelation';
  autoTenderBid?: Maybe<Scalars['Boolean']['output']>;
  bidId: Scalars['Int']['output'];
  credit?: Maybe<Scalars['Boolean']['output']>;
  listingLength: Scalars['Int']['output'];
  maximumAcceptedDeals: Scalars['Int']['output'];
};

export type TenderConnectBidsRelationMatchBidRelationProductRelationCommonProductRelation = {
  __typename?: 'TenderConnectBidsRelationMatchBidRelationProductRelationCommonProductRelation';
  /** JSON */
  attachments?: Maybe<Scalars['String']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  averageWholesalePrice: Scalars['Float']['output'];
  bidId: Scalars['Int']['output'];
  /** JSON */
  image?: Maybe<Scalars['String']['output']>;
  isAnyWholesalerCompatible: Scalars['Boolean']['output'];
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  packagingType: Scalars['String']['output'];
  productCategoryId: Scalars['Int']['output'];
  productTemplateId?: Maybe<Scalars['Int']['output']>;
  unitType: Scalars['String']['output'];
  unitsPerCase: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
  volumePerUnit: Scalars['Float']['output'];
  volumeUnits: Scalars['Float']['output'];
};

export type TenderConnectBidsRelationMatchBidRelationVenueCriteriaRelation = {
  __typename?: 'TenderConnectBidsRelationMatchBidRelationVenueCriteriaRelation';
  bid?: Maybe<TenderConnectBidsRelationMatchBidRelationVenueCriteriaRelationBidRelation>;
  bidId: Scalars['Int']['output'];
  capturedTargetedVenues?: Maybe<Scalars['Int']['output']>;
  /** JSON */
  customerTypes?: Maybe<Scalars['String']['output']>;
  listingType?: Maybe<TenderConnectBidsRelationMatchBidRelationVenueCriteriaRelationListingTypeRelation>;
  listingTypeId: Scalars['Int']['output'];
  /** JSON */
  loyaltyLevels?: Maybe<Scalars['String']['output']>;
  minimumVolume: Scalars['Int']['output'];
  /** JSON */
  regions?: Maybe<Scalars['String']['output']>;
  targetProductCategory?: Maybe<Scalars['Int']['output']>;
  /** JSON */
  venueTypes?: Maybe<Scalars['String']['output']>;
};


export type TenderConnectBidsRelationMatchBidRelationVenueCriteriaRelationBidArgs = {
  where?: InputMaybe<MatchBidFilters>;
};


export type TenderConnectBidsRelationMatchBidRelationVenueCriteriaRelationListingTypeArgs = {
  where?: InputMaybe<ListingTypeFilters>;
};

export type TenderConnectBidsRelationMatchBidRelationVenueCriteriaRelationBidRelation = {
  __typename?: 'TenderConnectBidsRelationMatchBidRelationVenueCriteriaRelationBidRelation';
  autoTenderBid?: Maybe<Scalars['Boolean']['output']>;
  bidId: Scalars['Int']['output'];
  credit?: Maybe<Scalars['Boolean']['output']>;
  listingLength: Scalars['Int']['output'];
  maximumAcceptedDeals: Scalars['Int']['output'];
};

export type TenderConnectBidsRelationMatchBidRelationVenueCriteriaRelationListingTypeRelation = {
  __typename?: 'TenderConnectBidsRelationMatchBidRelationVenueCriteriaRelationListingTypeRelation';
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  localizationKey: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  region?: Maybe<Scalars['String']['output']>;
  suggestedListingLengthInMonths: Scalars['Int']['output'];
  suggestedTenderLengthInMonths: Scalars['Int']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type TenderConnectBidsRelationTenderRelation = {
  __typename?: 'TenderConnectBidsRelationTenderRelation';
  createdAtUtc: Scalars['String']['output'];
  estimatedVolume: Scalars['Int']['output'];
  feedback?: Maybe<Scalars['String']['output']>;
  hostingChargeInvoiceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAnyWholesalerCompatible?: Maybe<Scalars['Boolean']['output']>;
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  listingEndsAtUtc: Scalars['String']['output'];
  listingStartsAtUtc: Scalars['String']['output'];
  listingTypeId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  originalTenderEndsAtUtc?: Maybe<Scalars['String']['output']>;
  packagingType?: Maybe<Scalars['String']['output']>;
  receivedSupportStatus: Scalars['String']['output'];
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  supportDetails?: Maybe<Scalars['String']['output']>;
  supportsDiscount: Scalars['String']['output'];
  supportsFreeStock: Scalars['String']['output'];
  supportsListingFee: Scalars['String']['output'];
  supportsPosBudget: Scalars['String']['output'];
  supportsRetroDiscount: Scalars['String']['output'];
  tenderDetails?: Maybe<Scalars['String']['output']>;
  tenderEndsAtUtc?: Maybe<Scalars['String']['output']>;
  tenderStartsAtUtc?: Maybe<Scalars['String']['output']>;
  unitType: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
  venueId: Scalars['Int']['output'];
  volumeDetails?: Maybe<Scalars['String']['output']>;
  volumeUnits: Scalars['Float']['output'];
};

export type TenderCreatedAtUtcFilters = {
  OR?: InputMaybe<Array<TenderCreatedAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderCreatedAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraft = {
  __typename?: 'TenderDraft';
  createdAtUtc: Scalars['String']['output'];
  estimatedVolume?: Maybe<Scalars['Int']['output']>;
  files: Array<File>;
  id: Scalars['Int']['output'];
  isAnyWholesalerCompatible: Scalars['Boolean']['output'];
  isDirectSupplyCompatible?: Maybe<Scalars['Boolean']['output']>;
  isPrivate: Scalars['Boolean']['output'];
  listingEndsAtUtc?: Maybe<Scalars['Date']['output']>;
  listingStartsAtUtc?: Maybe<Scalars['Date']['output']>;
  listingType: ListingTypeSelectItem;
  listingTypeId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  packagingType?: Maybe<Scalars['String']['output']>;
  productCategories: Array<ProductCategory>;
  productCategoryIds: Array<Scalars['Int']['output']>;
  region: Region;
  supportDetails?: Maybe<Scalars['String']['output']>;
  supportsDiscount: TenderSupportOption;
  supportsFreeStock: TenderSupportOption;
  supportsListingFee: TenderSupportOption;
  supportsPosBudget: TenderSupportOption;
  supportsRetroDiscount: TenderSupportOption;
  tenderDetails?: Maybe<Scalars['String']['output']>;
  tenderEndsAtUtc?: Maybe<Scalars['Date']['output']>;
  tenderStartsAtUtc?: Maybe<Scalars['Date']['output']>;
  unitType?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user: User;
  userId: Scalars['Int']['output'];
  venue: Venue;
  venueId: Scalars['Int']['output'];
  volumeDetails?: Maybe<Scalars['String']['output']>;
  volumeUnits?: Maybe<Scalars['Float']['output']>;
  wholesalers: Array<Wholesaler>;
};

export type TenderDraftCreatedAtUtcFilters = {
  OR?: InputMaybe<Array<TenderDraftCreatedAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftCreatedAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftEstimatedVolumeFilters = {
  OR?: InputMaybe<Array<TenderDraftEstimatedVolumefiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftEstimatedVolumefiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftFilters = {
  OR?: InputMaybe<Array<TenderDraftFiltersOr>>;
  createdAtUtc?: InputMaybe<TenderDraftCreatedAtUtcFilters>;
  estimatedVolume?: InputMaybe<TenderDraftEstimatedVolumeFilters>;
  id?: InputMaybe<TenderDraftIdFilters>;
  isAnyWholesalerCompatible?: InputMaybe<TenderDraftIsAnyWholesalerCompatibleFilters>;
  isDirectSupplyCompatible?: InputMaybe<TenderDraftIsDirectSupplyCompatibleFilters>;
  isPrivate?: InputMaybe<TenderDraftIsPrivateFilters>;
  listingEndsAtUtc?: InputMaybe<TenderDraftListingEndsAtUtcFilters>;
  listingStartsAtUtc?: InputMaybe<TenderDraftListingStartsAtUtcFilters>;
  listingTypeId?: InputMaybe<TenderDraftListingTypeIdFilters>;
  name?: InputMaybe<TenderDraftNameFilters>;
  packagingType?: InputMaybe<TenderDraftPackagingTypeFilters>;
  region?: InputMaybe<TenderDraftRegionFilters>;
  supportDetails?: InputMaybe<TenderDraftSupportDetailsFilters>;
  supportsDiscount?: InputMaybe<TenderDraftSupportsDiscountFilters>;
  supportsFreeStock?: InputMaybe<TenderDraftSupportsFreeStockFilters>;
  supportsListingFee?: InputMaybe<TenderDraftSupportsListingFeeFilters>;
  supportsPosBudget?: InputMaybe<TenderDraftSupportsPosBudgetFilters>;
  supportsRetroDiscount?: InputMaybe<TenderDraftSupportsRetroDiscountFilters>;
  tenderDetails?: InputMaybe<TenderDraftTenderDetailsFilters>;
  tenderEndsAtUtc?: InputMaybe<TenderDraftTenderEndsAtUtcFilters>;
  tenderStartsAtUtc?: InputMaybe<TenderDraftTenderStartsAtUtcFilters>;
  unitType?: InputMaybe<TenderDraftUnitTypeFilters>;
  updatedAtUtc?: InputMaybe<TenderDraftUpdatedAtUtcFilters>;
  userId?: InputMaybe<TenderDraftUserIdFilters>;
  venueId?: InputMaybe<TenderDraftVenueIdFilters>;
  volumeDetails?: InputMaybe<TenderDraftVolumeDetailsFilters>;
  volumeUnits?: InputMaybe<TenderDraftVolumeUnitsFilters>;
};

export type TenderDraftFiltersOr = {
  createdAtUtc?: InputMaybe<TenderDraftCreatedAtUtcFilters>;
  estimatedVolume?: InputMaybe<TenderDraftEstimatedVolumeFilters>;
  id?: InputMaybe<TenderDraftIdFilters>;
  isAnyWholesalerCompatible?: InputMaybe<TenderDraftIsAnyWholesalerCompatibleFilters>;
  isDirectSupplyCompatible?: InputMaybe<TenderDraftIsDirectSupplyCompatibleFilters>;
  isPrivate?: InputMaybe<TenderDraftIsPrivateFilters>;
  listingEndsAtUtc?: InputMaybe<TenderDraftListingEndsAtUtcFilters>;
  listingStartsAtUtc?: InputMaybe<TenderDraftListingStartsAtUtcFilters>;
  listingTypeId?: InputMaybe<TenderDraftListingTypeIdFilters>;
  name?: InputMaybe<TenderDraftNameFilters>;
  packagingType?: InputMaybe<TenderDraftPackagingTypeFilters>;
  region?: InputMaybe<TenderDraftRegionFilters>;
  supportDetails?: InputMaybe<TenderDraftSupportDetailsFilters>;
  supportsDiscount?: InputMaybe<TenderDraftSupportsDiscountFilters>;
  supportsFreeStock?: InputMaybe<TenderDraftSupportsFreeStockFilters>;
  supportsListingFee?: InputMaybe<TenderDraftSupportsListingFeeFilters>;
  supportsPosBudget?: InputMaybe<TenderDraftSupportsPosBudgetFilters>;
  supportsRetroDiscount?: InputMaybe<TenderDraftSupportsRetroDiscountFilters>;
  tenderDetails?: InputMaybe<TenderDraftTenderDetailsFilters>;
  tenderEndsAtUtc?: InputMaybe<TenderDraftTenderEndsAtUtcFilters>;
  tenderStartsAtUtc?: InputMaybe<TenderDraftTenderStartsAtUtcFilters>;
  unitType?: InputMaybe<TenderDraftUnitTypeFilters>;
  updatedAtUtc?: InputMaybe<TenderDraftUpdatedAtUtcFilters>;
  userId?: InputMaybe<TenderDraftUserIdFilters>;
  venueId?: InputMaybe<TenderDraftVenueIdFilters>;
  volumeDetails?: InputMaybe<TenderDraftVolumeDetailsFilters>;
  volumeUnits?: InputMaybe<TenderDraftVolumeUnitsFilters>;
};

export type TenderDraftIdFilters = {
  OR?: InputMaybe<Array<TenderDraftIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftIsAnyWholesalerCompatibleFilters = {
  OR?: InputMaybe<Array<TenderDraftIsAnyWholesalerCompatiblefiltersOr>>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftIsAnyWholesalerCompatiblefiltersOr = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftIsDirectSupplyCompatibleFilters = {
  OR?: InputMaybe<Array<TenderDraftIsDirectSupplyCompatiblefiltersOr>>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftIsDirectSupplyCompatiblefiltersOr = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftIsPrivateFilters = {
  OR?: InputMaybe<Array<TenderDraftIsPrivatefiltersOr>>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftIsPrivatefiltersOr = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftListingEndsAtUtcFilters = {
  OR?: InputMaybe<Array<TenderDraftListingEndsAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftListingEndsAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftListingStartsAtUtcFilters = {
  OR?: InputMaybe<Array<TenderDraftListingStartsAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftListingStartsAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftListingTypeIdFilters = {
  OR?: InputMaybe<Array<TenderDraftListingTypeIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftListingTypeIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftNameFilters = {
  OR?: InputMaybe<Array<TenderDraftNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftOrderBy = {
  createdAtUtc?: InputMaybe<InnerOrder>;
  estimatedVolume?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  isAnyWholesalerCompatible?: InputMaybe<InnerOrder>;
  isDirectSupplyCompatible?: InputMaybe<InnerOrder>;
  isPrivate?: InputMaybe<InnerOrder>;
  listingEndsAtUtc?: InputMaybe<InnerOrder>;
  listingStartsAtUtc?: InputMaybe<InnerOrder>;
  listingTypeId?: InputMaybe<InnerOrder>;
  name?: InputMaybe<InnerOrder>;
  packagingType?: InputMaybe<InnerOrder>;
  region?: InputMaybe<InnerOrder>;
  supportDetails?: InputMaybe<InnerOrder>;
  supportsDiscount?: InputMaybe<InnerOrder>;
  supportsFreeStock?: InputMaybe<InnerOrder>;
  supportsListingFee?: InputMaybe<InnerOrder>;
  supportsPosBudget?: InputMaybe<InnerOrder>;
  supportsRetroDiscount?: InputMaybe<InnerOrder>;
  tenderDetails?: InputMaybe<InnerOrder>;
  tenderEndsAtUtc?: InputMaybe<InnerOrder>;
  tenderStartsAtUtc?: InputMaybe<InnerOrder>;
  unitType?: InputMaybe<InnerOrder>;
  updatedAtUtc?: InputMaybe<InnerOrder>;
  userId?: InputMaybe<InnerOrder>;
  venueId?: InputMaybe<InnerOrder>;
  volumeDetails?: InputMaybe<InnerOrder>;
  volumeUnits?: InputMaybe<InnerOrder>;
};

export type TenderDraftPackagingTypeFilters = {
  OR?: InputMaybe<Array<TenderDraftPackagingTypefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftPackagingTypefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftRegionFilters = {
  OR?: InputMaybe<Array<TenderDraftRegionfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftRegionfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftSupportDetailsFilters = {
  OR?: InputMaybe<Array<TenderDraftSupportDetailsfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftSupportDetailsfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftSupportsDiscountFilters = {
  OR?: InputMaybe<Array<TenderDraftSupportsDiscountfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftSupportsDiscountfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftSupportsFreeStockFilters = {
  OR?: InputMaybe<Array<TenderDraftSupportsFreeStockfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftSupportsFreeStockfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftSupportsListingFeeFilters = {
  OR?: InputMaybe<Array<TenderDraftSupportsListingFeefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftSupportsListingFeefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftSupportsPosBudgetFilters = {
  OR?: InputMaybe<Array<TenderDraftSupportsPosBudgetfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftSupportsPosBudgetfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftSupportsRetroDiscountFilters = {
  OR?: InputMaybe<Array<TenderDraftSupportsRetroDiscountfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftSupportsRetroDiscountfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftTenderDetailsFilters = {
  OR?: InputMaybe<Array<TenderDraftTenderDetailsfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftTenderDetailsfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftTenderEndsAtUtcFilters = {
  OR?: InputMaybe<Array<TenderDraftTenderEndsAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftTenderEndsAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftTenderStartsAtUtcFilters = {
  OR?: InputMaybe<Array<TenderDraftTenderStartsAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftTenderStartsAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftUnitTypeFilters = {
  OR?: InputMaybe<Array<TenderDraftUnitTypefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftUnitTypefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftUpdatedAtUtcFilters = {
  OR?: InputMaybe<Array<TenderDraftUpdatedAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftUpdatedAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftUserIdFilters = {
  OR?: InputMaybe<Array<TenderDraftUserIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftUserIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftVenueIdFilters = {
  OR?: InputMaybe<Array<TenderDraftVenueIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftVenueIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftVolumeDetailsFilters = {
  OR?: InputMaybe<Array<TenderDraftVolumeDetailsfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftVolumeDetailsfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftVolumeUnitsFilters = {
  OR?: InputMaybe<Array<TenderDraftVolumeUnitsfiltersOr>>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Float']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Float']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderDraftVolumeUnitsfiltersOr = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Float']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Float']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderEstimatedVolumeFilters = {
  OR?: InputMaybe<Array<TenderEstimatedVolumefiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderEstimatedVolumefiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderFeedbackFilters = {
  OR?: InputMaybe<Array<TenderFeedbackfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderFeedbackfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderFilterOptionsInput = {
  administrativeAreaLevel2?: InputMaybe<Array<Scalars['String']['input']>>;
  listingTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  myBids?: InputMaybe<MyBidsOption>;
  myTenders?: InputMaybe<MyTendersOption>;
  postCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  productCategoryId?: InputMaybe<Scalars['Int']['input']>;
  venueGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  venueIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  venueTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  volume?: InputMaybe<VolumeRangeOption>;
  wholesalerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type TenderFilters = {
  OR?: InputMaybe<Array<TenderFiltersOr>>;
  createdAtUtc?: InputMaybe<TenderCreatedAtUtcFilters>;
  estimatedVolume?: InputMaybe<TenderEstimatedVolumeFilters>;
  feedback?: InputMaybe<TenderFeedbackFilters>;
  hostingChargeInvoiceId?: InputMaybe<TenderHostingChargeInvoiceIdFilters>;
  id?: InputMaybe<TenderIdFilters>;
  isAnyWholesalerCompatible?: InputMaybe<TenderIsAnyWholesalerCompatibleFilters>;
  isDirectSupplyCompatible?: InputMaybe<TenderIsDirectSupplyCompatibleFilters>;
  isPrivate?: InputMaybe<TenderIsPrivateFilters>;
  listingEndsAtUtc?: InputMaybe<TenderListingEndsAtUtcFilters>;
  listingStartsAtUtc?: InputMaybe<TenderListingStartsAtUtcFilters>;
  listingTypeId?: InputMaybe<TenderListingTypeIdFilters>;
  name?: InputMaybe<TenderNameFilters>;
  originalTenderEndsAtUtc?: InputMaybe<TenderOriginalTenderEndsAtUtcFilters>;
  packagingType?: InputMaybe<TenderPackagingTypeFilters>;
  receivedSupportStatus?: InputMaybe<TenderReceivedSupportStatusFilters>;
  region?: InputMaybe<TenderRegionFilters>;
  status?: InputMaybe<TenderStatusFilters>;
  supportDetails?: InputMaybe<TenderSupportDetailsFilters>;
  supportsDiscount?: InputMaybe<TenderSupportsDiscountFilters>;
  supportsFreeStock?: InputMaybe<TenderSupportsFreeStockFilters>;
  supportsListingFee?: InputMaybe<TenderSupportsListingFeeFilters>;
  supportsPosBudget?: InputMaybe<TenderSupportsPosBudgetFilters>;
  supportsRetroDiscount?: InputMaybe<TenderSupportsRetroDiscountFilters>;
  tenderDetails?: InputMaybe<TenderTenderDetailsFilters>;
  tenderEndsAtUtc?: InputMaybe<TenderTenderEndsAtUtcFilters>;
  tenderStartsAtUtc?: InputMaybe<TenderTenderStartsAtUtcFilters>;
  unitType?: InputMaybe<TenderUnitTypeFilters>;
  updatedAtUtc?: InputMaybe<TenderUpdatedAtUtcFilters>;
  userId?: InputMaybe<TenderUserIdFilters>;
  venueId?: InputMaybe<TenderVenueIdFilters>;
  volumeDetails?: InputMaybe<TenderVolumeDetailsFilters>;
  volumeUnits?: InputMaybe<TenderVolumeUnitsFilters>;
};

export type TenderFiltersOr = {
  createdAtUtc?: InputMaybe<TenderCreatedAtUtcFilters>;
  estimatedVolume?: InputMaybe<TenderEstimatedVolumeFilters>;
  feedback?: InputMaybe<TenderFeedbackFilters>;
  hostingChargeInvoiceId?: InputMaybe<TenderHostingChargeInvoiceIdFilters>;
  id?: InputMaybe<TenderIdFilters>;
  isAnyWholesalerCompatible?: InputMaybe<TenderIsAnyWholesalerCompatibleFilters>;
  isDirectSupplyCompatible?: InputMaybe<TenderIsDirectSupplyCompatibleFilters>;
  isPrivate?: InputMaybe<TenderIsPrivateFilters>;
  listingEndsAtUtc?: InputMaybe<TenderListingEndsAtUtcFilters>;
  listingStartsAtUtc?: InputMaybe<TenderListingStartsAtUtcFilters>;
  listingTypeId?: InputMaybe<TenderListingTypeIdFilters>;
  name?: InputMaybe<TenderNameFilters>;
  originalTenderEndsAtUtc?: InputMaybe<TenderOriginalTenderEndsAtUtcFilters>;
  packagingType?: InputMaybe<TenderPackagingTypeFilters>;
  receivedSupportStatus?: InputMaybe<TenderReceivedSupportStatusFilters>;
  region?: InputMaybe<TenderRegionFilters>;
  status?: InputMaybe<TenderStatusFilters>;
  supportDetails?: InputMaybe<TenderSupportDetailsFilters>;
  supportsDiscount?: InputMaybe<TenderSupportsDiscountFilters>;
  supportsFreeStock?: InputMaybe<TenderSupportsFreeStockFilters>;
  supportsListingFee?: InputMaybe<TenderSupportsListingFeeFilters>;
  supportsPosBudget?: InputMaybe<TenderSupportsPosBudgetFilters>;
  supportsRetroDiscount?: InputMaybe<TenderSupportsRetroDiscountFilters>;
  tenderDetails?: InputMaybe<TenderTenderDetailsFilters>;
  tenderEndsAtUtc?: InputMaybe<TenderTenderEndsAtUtcFilters>;
  tenderStartsAtUtc?: InputMaybe<TenderTenderStartsAtUtcFilters>;
  unitType?: InputMaybe<TenderUnitTypeFilters>;
  updatedAtUtc?: InputMaybe<TenderUpdatedAtUtcFilters>;
  userId?: InputMaybe<TenderUserIdFilters>;
  venueId?: InputMaybe<TenderVenueIdFilters>;
  volumeDetails?: InputMaybe<TenderVolumeDetailsFilters>;
  volumeUnits?: InputMaybe<TenderVolumeUnitsFilters>;
};

export type TenderHostingChargeInvoiceIdFilters = {
  OR?: InputMaybe<Array<TenderHostingChargeInvoiceIdfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderHostingChargeInvoiceIdfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderIdFilters = {
  OR?: InputMaybe<Array<TenderIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderIsAnyWholesalerCompatibleFilters = {
  OR?: InputMaybe<Array<TenderIsAnyWholesalerCompatiblefiltersOr>>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderIsAnyWholesalerCompatiblefiltersOr = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderIsDirectSupplyCompatibleFilters = {
  OR?: InputMaybe<Array<TenderIsDirectSupplyCompatiblefiltersOr>>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderIsDirectSupplyCompatiblefiltersOr = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderIsPrivateFilters = {
  OR?: InputMaybe<Array<TenderIsPrivatefiltersOr>>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderIsPrivatefiltersOr = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderItem = {
  __typename?: 'TenderItem';
  hasBrandBidsInTender: Scalars['Boolean']['output'];
};


export type TenderItemHasBrandBidsInTenderArgs = {
  brandId: Scalars['NonNegativeInt']['input'];
};

export enum TenderListOrderByEnum {
  Duration = 'DURATION',
  RecentlyAdded = 'RECENTLY_ADDED',
  TimeLeft = 'TIME_LEFT',
  Volume = 'VOLUME'
}

export type TenderListPaginationInput = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<TenderListOrderByEnum>;
  orderDirection?: InputMaybe<SortDirectionEnum>;
};

export type TenderListingEndsAtUtcFilters = {
  OR?: InputMaybe<Array<TenderListingEndsAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderListingEndsAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderListingStartsAtUtcFilters = {
  OR?: InputMaybe<Array<TenderListingStartsAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderListingStartsAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderListingTypeIdFilters = {
  OR?: InputMaybe<Array<TenderListingTypeIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderListingTypeIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderListingTypeRelation = {
  __typename?: 'TenderListingTypeRelation';
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  localizationKey: Scalars['String']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  region?: Maybe<Scalars['String']['output']>;
  regions: Array<TenderListingTypeRelationRegionsRelation>;
  suggestedListingLengthInMonths: Scalars['Int']['output'];
  suggestedTenderLengthInMonths: Scalars['Int']['output'];
  tenderDrafts: Array<TenderListingTypeRelationTenderDraftsRelation>;
  tenders: Array<TenderListingTypeRelationTendersRelation>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};


export type TenderListingTypeRelationRegionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ListingTypeRegion2OrderBy>;
  where?: InputMaybe<ListingTypeRegion2Filters>;
};


export type TenderListingTypeRelationTenderDraftsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TenderDraftOrderBy>;
  where?: InputMaybe<TenderDraftFilters>;
};


export type TenderListingTypeRelationTendersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TenderOrderBy>;
  where?: InputMaybe<TenderFilters>;
};

export type TenderListingTypeRelationRegionsRelation = {
  __typename?: 'TenderListingTypeRelationRegionsRelation';
  listingTypeId: Scalars['Int']['output'];
  region: Scalars['String']['output'];
};

export type TenderListingTypeRelationTenderDraftsRelation = {
  __typename?: 'TenderListingTypeRelationTenderDraftsRelation';
  createdAtUtc: Scalars['String']['output'];
  estimatedVolume?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isAnyWholesalerCompatible?: Maybe<Scalars['Boolean']['output']>;
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  listingEndsAtUtc?: Maybe<Scalars['String']['output']>;
  listingStartsAtUtc?: Maybe<Scalars['String']['output']>;
  listingTypeId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  packagingType?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  supportDetails?: Maybe<Scalars['String']['output']>;
  supportsDiscount: Scalars['String']['output'];
  supportsFreeStock: Scalars['String']['output'];
  supportsListingFee: Scalars['String']['output'];
  supportsPosBudget: Scalars['String']['output'];
  supportsRetroDiscount: Scalars['String']['output'];
  tenderDetails?: Maybe<Scalars['String']['output']>;
  tenderEndsAtUtc?: Maybe<Scalars['String']['output']>;
  tenderStartsAtUtc?: Maybe<Scalars['String']['output']>;
  unitType?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
  venueId: Scalars['Int']['output'];
  volumeDetails?: Maybe<Scalars['String']['output']>;
  volumeUnits?: Maybe<Scalars['Float']['output']>;
};

export type TenderListingTypeRelationTendersRelation = {
  __typename?: 'TenderListingTypeRelationTendersRelation';
  createdAtUtc: Scalars['String']['output'];
  estimatedVolume: Scalars['Int']['output'];
  feedback?: Maybe<Scalars['String']['output']>;
  hostingChargeInvoiceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAnyWholesalerCompatible?: Maybe<Scalars['Boolean']['output']>;
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  listingEndsAtUtc: Scalars['String']['output'];
  listingStartsAtUtc: Scalars['String']['output'];
  listingTypeId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  originalTenderEndsAtUtc?: Maybe<Scalars['String']['output']>;
  packagingType?: Maybe<Scalars['String']['output']>;
  receivedSupportStatus: Scalars['String']['output'];
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  supportDetails?: Maybe<Scalars['String']['output']>;
  supportsDiscount: Scalars['String']['output'];
  supportsFreeStock: Scalars['String']['output'];
  supportsListingFee: Scalars['String']['output'];
  supportsPosBudget: Scalars['String']['output'];
  supportsRetroDiscount: Scalars['String']['output'];
  tenderDetails?: Maybe<Scalars['String']['output']>;
  tenderEndsAtUtc?: Maybe<Scalars['String']['output']>;
  tenderStartsAtUtc?: Maybe<Scalars['String']['output']>;
  unitType: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
  venueId: Scalars['Int']['output'];
  volumeDetails?: Maybe<Scalars['String']['output']>;
  volumeUnits: Scalars['Float']['output'];
};

export type TenderNameFilters = {
  OR?: InputMaybe<Array<TenderNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderNotificationsRelation = {
  __typename?: 'TenderNotificationsRelation';
  bidId?: Maybe<Scalars['Int']['output']>;
  brandId?: Maybe<Scalars['Int']['output']>;
  category: Scalars['String']['output'];
  createdAtUtc: Scalars['String']['output'];
  fromId?: Maybe<Scalars['Int']['output']>;
  fromType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isRead: Scalars['Boolean']['output'];
  messageId?: Maybe<Scalars['Int']['output']>;
  tenderId?: Maybe<Scalars['Int']['output']>;
  toId: Scalars['Int']['output'];
  toType: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  venueId?: Maybe<Scalars['Int']['output']>;
};

export type TenderOrderBy = {
  createdAtUtc?: InputMaybe<InnerOrder>;
  estimatedVolume?: InputMaybe<InnerOrder>;
  feedback?: InputMaybe<InnerOrder>;
  hostingChargeInvoiceId?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  isAnyWholesalerCompatible?: InputMaybe<InnerOrder>;
  isDirectSupplyCompatible?: InputMaybe<InnerOrder>;
  isPrivate?: InputMaybe<InnerOrder>;
  listingEndsAtUtc?: InputMaybe<InnerOrder>;
  listingStartsAtUtc?: InputMaybe<InnerOrder>;
  listingTypeId?: InputMaybe<InnerOrder>;
  name?: InputMaybe<InnerOrder>;
  originalTenderEndsAtUtc?: InputMaybe<InnerOrder>;
  packagingType?: InputMaybe<InnerOrder>;
  receivedSupportStatus?: InputMaybe<InnerOrder>;
  region?: InputMaybe<InnerOrder>;
  status?: InputMaybe<InnerOrder>;
  supportDetails?: InputMaybe<InnerOrder>;
  supportsDiscount?: InputMaybe<InnerOrder>;
  supportsFreeStock?: InputMaybe<InnerOrder>;
  supportsListingFee?: InputMaybe<InnerOrder>;
  supportsPosBudget?: InputMaybe<InnerOrder>;
  supportsRetroDiscount?: InputMaybe<InnerOrder>;
  tenderDetails?: InputMaybe<InnerOrder>;
  tenderEndsAtUtc?: InputMaybe<InnerOrder>;
  tenderStartsAtUtc?: InputMaybe<InnerOrder>;
  unitType?: InputMaybe<InnerOrder>;
  updatedAtUtc?: InputMaybe<InnerOrder>;
  userId?: InputMaybe<InnerOrder>;
  venueId?: InputMaybe<InnerOrder>;
  volumeDetails?: InputMaybe<InnerOrder>;
  volumeUnits?: InputMaybe<InnerOrder>;
};

export type TenderOriginalTenderEndsAtUtcFilters = {
  OR?: InputMaybe<Array<TenderOriginalTenderEndsAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderOriginalTenderEndsAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderPackagingTypeFilters = {
  OR?: InputMaybe<Array<TenderPackagingTypefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderPackagingTypefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderPreference = {
  __typename?: 'TenderPreference';
  id: Scalars['Int']['output'];
  isAnyWholesalerCompatible?: Maybe<Scalars['Boolean']['output']>;
  isDirectSupplyCompatible?: Maybe<Scalars['Boolean']['output']>;
  supportDetails?: Maybe<Scalars['String']['output']>;
  supportsDiscount: TenderSupportOption;
  supportsFreeStock: TenderSupportOption;
  supportsListingFee: TenderSupportOption;
  supportsPosBudget: TenderSupportOption;
  supportsRetroDiscount: TenderSupportOption;
  venueId: Scalars['Int']['output'];
  wholesalers: Array<Wholesaler>;
};

export type TenderProductCategoriesFilters = {
  OR?: InputMaybe<Array<TenderProductCategoriesFiltersOr>>;
  productCategoryId?: InputMaybe<TenderProductCategoriesProductCategoryIdFilters>;
  tenderId?: InputMaybe<TenderProductCategoriesTenderIdFilters>;
};

export type TenderProductCategoriesFiltersOr = {
  productCategoryId?: InputMaybe<TenderProductCategoriesProductCategoryIdFilters>;
  tenderId?: InputMaybe<TenderProductCategoriesTenderIdFilters>;
};

export type TenderProductCategoriesOrderBy = {
  productCategoryId?: InputMaybe<InnerOrder>;
  tenderId?: InputMaybe<InnerOrder>;
};

export type TenderProductCategoriesProductCategoryIdFilters = {
  OR?: InputMaybe<Array<TenderProductCategoriesProductCategoryIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderProductCategoriesProductCategoryIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderProductCategoriesRelation = {
  __typename?: 'TenderProductCategoriesRelation';
  productCategoryId: Scalars['Int']['output'];
  tenderId: Scalars['Int']['output'];
};

export type TenderProductCategoriesTenderIdFilters = {
  OR?: InputMaybe<Array<TenderProductCategoriesTenderIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderProductCategoriesTenderIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderProductOptionsForRetool = {
  __typename?: 'TenderProductOptionsForRetool';
  listingTypes: Array<ListingTypeSelectItem>;
  productCategories: Array<ProductCategory>;
  productPackaging: Array<Scalars['String']['output']>;
  productUnits: Array<Scalars['String']['output']>;
  wholesalers: Array<Wholesaler>;
};

export type TenderProductPackagingRelation = {
  __typename?: 'TenderProductPackagingRelation';
  type: Scalars['String']['output'];
};

export type TenderReceivedSupportStatusFilters = {
  OR?: InputMaybe<Array<TenderReceivedSupportStatusfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderReceivedSupportStatusfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderRegionFilters = {
  OR?: InputMaybe<Array<TenderRegionfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderRegionfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderSelectItem = {
  __typename?: 'TenderSelectItem';
  connectBids: Array<TenderConnectBidsRelation>;
  createdAtUtc: Scalars['String']['output'];
  estimatedVolume: Scalars['Int']['output'];
  feedback?: Maybe<Scalars['String']['output']>;
  hasBrandBidsInTender: Scalars['Boolean']['output'];
  hostingChargeInvoiceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAnyWholesalerCompatible?: Maybe<Scalars['Boolean']['output']>;
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  listingEndsAtUtc: Scalars['String']['output'];
  listingStartsAtUtc: Scalars['String']['output'];
  listingType?: Maybe<TenderListingTypeRelation>;
  listingTypeId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  notifications: Array<TenderNotificationsRelation>;
  originalTenderEndsAtUtc?: Maybe<Scalars['String']['output']>;
  packagingType?: Maybe<Scalars['String']['output']>;
  productCategories: Array<TenderProductCategoriesRelation>;
  productPackaging?: Maybe<TenderProductPackagingRelation>;
  receivedSupportStatus: Scalars['String']['output'];
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  supportDetails?: Maybe<Scalars['String']['output']>;
  supportsDiscount: Scalars['String']['output'];
  supportsFreeStock: Scalars['String']['output'];
  supportsListingFee: Scalars['String']['output'];
  supportsPosBudget: Scalars['String']['output'];
  supportsRetroDiscount: Scalars['String']['output'];
  tenderDetails?: Maybe<Scalars['String']['output']>;
  tenderEndsAtUtc?: Maybe<Scalars['String']['output']>;
  tenderStartsAtUtc?: Maybe<Scalars['String']['output']>;
  tenderWholesalers: Array<TenderTenderWholesalersRelation>;
  unit?: Maybe<TenderUnitRelation>;
  unitType: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<TenderUserRelation>;
  userId: Scalars['Int']['output'];
  venue?: Maybe<TenderVenueRelation>;
  venueId: Scalars['Int']['output'];
  volumeDetails?: Maybe<Scalars['String']['output']>;
  volumeUnits: Scalars['Float']['output'];
};


export type TenderSelectItemConnectBidsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ConnectBidOrderBy>;
  where?: InputMaybe<ConnectBidFilters>;
};


export type TenderSelectItemHasBrandBidsInTenderArgs = {
  brandId: Scalars['NonNegativeInt']['input'];
};


export type TenderSelectItemListingTypeArgs = {
  where?: InputMaybe<ListingTypeFilters>;
};


export type TenderSelectItemNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<NotificationOrderBy>;
  where?: InputMaybe<NotificationFilters>;
};


export type TenderSelectItemProductCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TenderProductCategoriesOrderBy>;
  where?: InputMaybe<TenderProductCategoriesFilters>;
};


export type TenderSelectItemProductPackagingArgs = {
  where?: InputMaybe<ProductPackagingFilters>;
};


export type TenderSelectItemTenderWholesalersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TenderWholesalerOrderBy>;
  where?: InputMaybe<TenderWholesalerFilters>;
};


export type TenderSelectItemUnitArgs = {
  where?: InputMaybe<UnitFilters>;
};


export type TenderSelectItemUserArgs = {
  where?: InputMaybe<UserFilters>;
};


export type TenderSelectItemVenueArgs = {
  where?: InputMaybe<VenueFilters>;
};

export type TenderSortInput = {
  orderBy?: InputMaybe<VenueDashboardOrderByEnum>;
  orderDirection?: InputMaybe<SortDirectionEnum>;
};

export enum TenderStatus {
  Awarded = 'AWARDED',
  Closed = 'CLOSED',
  ClosedWithoutWinner = 'CLOSED_WITHOUT_WINNER',
  Deleted = 'DELETED',
  Published = 'PUBLISHED'
}

export type TenderStatusFilters = {
  OR?: InputMaybe<Array<TenderStatusfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderStatusfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderSupportDetailsFilters = {
  OR?: InputMaybe<Array<TenderSupportDetailsfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderSupportDetailsfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export enum TenderSupportOption {
  NotInterested = 'NOT_INTERESTED',
  Optional = 'OPTIONAL',
  Preferred = 'PREFERRED'
}

export enum TenderSupportStatus {
  InProgress = 'IN_PROGRESS',
  NotProvided = 'NOT_PROVIDED',
  Received = 'RECEIVED'
}

export type TenderSupportsDiscountFilters = {
  OR?: InputMaybe<Array<TenderSupportsDiscountfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderSupportsDiscountfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderSupportsFreeStockFilters = {
  OR?: InputMaybe<Array<TenderSupportsFreeStockfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderSupportsFreeStockfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderSupportsListingFeeFilters = {
  OR?: InputMaybe<Array<TenderSupportsListingFeefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderSupportsListingFeefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderSupportsPosBudgetFilters = {
  OR?: InputMaybe<Array<TenderSupportsPosBudgetfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderSupportsPosBudgetfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderSupportsRetroDiscountFilters = {
  OR?: InputMaybe<Array<TenderSupportsRetroDiscountfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderSupportsRetroDiscountfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderTenderDetailsFilters = {
  OR?: InputMaybe<Array<TenderTenderDetailsfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderTenderDetailsfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderTenderEndsAtUtcFilters = {
  OR?: InputMaybe<Array<TenderTenderEndsAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderTenderEndsAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderTenderStartsAtUtcFilters = {
  OR?: InputMaybe<Array<TenderTenderStartsAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderTenderStartsAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderTenderWholesalersRelation = {
  __typename?: 'TenderTenderWholesalersRelation';
  tenderId: Scalars['Int']['output'];
  wholesalerId: Scalars['Int']['output'];
};

export type TenderUnitRelation = {
  __typename?: 'TenderUnitRelation';
  type: Scalars['String']['output'];
};

export type TenderUnitTypeFilters = {
  OR?: InputMaybe<Array<TenderUnitTypefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderUnitTypefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderUpdatedAtUtcFilters = {
  OR?: InputMaybe<Array<TenderUpdatedAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderUpdatedAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderUserIdFilters = {
  OR?: InputMaybe<Array<TenderUserIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderUserIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderUserRelation = {
  __typename?: 'TenderUserRelation';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type TenderVenueIdFilters = {
  OR?: InputMaybe<Array<TenderVenueIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderVenueIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderVenueRelation = {
  __typename?: 'TenderVenueRelation';
  address?: Maybe<TenderVenueRelationAddressRelation>;
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<TenderVenueRelationBillingAddressRelation>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompany?: Maybe<TenderVenueRelationRegisteredCompanyRelation>;
  registeredCompanyId: Scalars['Int']['output'];
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  venueCategory?: Maybe<TenderVenueRelationVenueCategoryRelation>;
  venueCategoryId?: Maybe<Scalars['Int']['output']>;
  venueCategoryName?: Maybe<Scalars['String']['output']>;
  venueIntegrations: Array<TenderVenueRelationVenueIntegrationsRelation>;
  venueUsers: Array<TenderVenueRelationVenueUsersRelation>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};


export type TenderVenueRelationAddressArgs = {
  where?: InputMaybe<AddressFilters>;
};


export type TenderVenueRelationBillingAddressArgs = {
  where?: InputMaybe<AddressFilters>;
};


export type TenderVenueRelationRegisteredCompanyArgs = {
  where?: InputMaybe<RegisteredCompanyFilters>;
};


export type TenderVenueRelationVenueCategoryArgs = {
  where?: InputMaybe<VenueCategoryFilters>;
};


export type TenderVenueRelationVenueIntegrationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<VenueIntegrationsOrderBy>;
  where?: InputMaybe<VenueIntegrationsFilters>;
};


export type TenderVenueRelationVenueUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<VenueUserOrderBy>;
  where?: InputMaybe<VenueUserFilters>;
};

export type TenderVenueRelationAddressRelation = {
  __typename?: 'TenderVenueRelationAddressRelation';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type TenderVenueRelationBillingAddressRelation = {
  __typename?: 'TenderVenueRelationBillingAddressRelation';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type TenderVenueRelationRegisteredCompanyRelation = {
  __typename?: 'TenderVenueRelationRegisteredCompanyRelation';
  addressId?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  dateOfCreation?: Maybe<Scalars['String']['output']>;
  firstAddressLine?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  secondAddressLine?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type TenderVenueRelationVenueCategoryRelation = {
  __typename?: 'TenderVenueRelationVenueCategoryRelation';
  id: Scalars['Int']['output'];
  localizationKey: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type TenderVenueRelationVenueIntegrationsRelation = {
  __typename?: 'TenderVenueRelationVenueIntegrationsRelation';
  createdAtUtc: Scalars['String']['output'];
  externalCompanyId: Scalars['String']['output'];
  externalUserId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  integrationType: VenueIntegrationsIntegrationTypeEnum;
  /** JSON */
  metadata?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<TenderVenueRelationVenueIntegrationsRelationUserRelation>;
  userId: Scalars['Int']['output'];
  venue?: Maybe<TenderVenueRelationVenueIntegrationsRelationVenueRelation>;
  venueId: Scalars['Int']['output'];
};


export type TenderVenueRelationVenueIntegrationsRelationUserArgs = {
  where?: InputMaybe<UserFilters>;
};


export type TenderVenueRelationVenueIntegrationsRelationVenueArgs = {
  where?: InputMaybe<VenueFilters>;
};

export type TenderVenueRelationVenueIntegrationsRelationUserRelation = {
  __typename?: 'TenderVenueRelationVenueIntegrationsRelationUserRelation';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type TenderVenueRelationVenueIntegrationsRelationVenueRelation = {
  __typename?: 'TenderVenueRelationVenueIntegrationsRelationVenueRelation';
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompanyId: Scalars['Int']['output'];
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  venueCategoryId?: Maybe<Scalars['Int']['output']>;
  venueCategoryName?: Maybe<Scalars['String']['output']>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};

export type TenderVenueRelationVenueUsersRelation = {
  __typename?: 'TenderVenueRelationVenueUsersRelation';
  createdAtUtc: Scalars['String']['output'];
  role: VenueUserRoleEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<TenderVenueRelationVenueUsersRelationUserRelation>;
  userId: Scalars['Int']['output'];
  venue?: Maybe<TenderVenueRelationVenueUsersRelationVenueRelation>;
  venueId: Scalars['Int']['output'];
};


export type TenderVenueRelationVenueUsersRelationUserArgs = {
  where?: InputMaybe<UserFilters>;
};


export type TenderVenueRelationVenueUsersRelationVenueArgs = {
  where?: InputMaybe<VenueFilters>;
};

export type TenderVenueRelationVenueUsersRelationUserRelation = {
  __typename?: 'TenderVenueRelationVenueUsersRelationUserRelation';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type TenderVenueRelationVenueUsersRelationVenueRelation = {
  __typename?: 'TenderVenueRelationVenueUsersRelationVenueRelation';
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompanyId: Scalars['Int']['output'];
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  venueCategoryId?: Maybe<Scalars['Int']['output']>;
  venueCategoryName?: Maybe<Scalars['String']['output']>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};

export type TenderVolumeDetailsFilters = {
  OR?: InputMaybe<Array<TenderVolumeDetailsfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderVolumeDetailsfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderVolumeUnitsFilters = {
  OR?: InputMaybe<Array<TenderVolumeUnitsfiltersOr>>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Float']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Float']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderVolumeUnitsfiltersOr = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Float']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Float']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderWholesalerFilters = {
  OR?: InputMaybe<Array<TenderWholesalerFiltersOr>>;
  tenderId?: InputMaybe<TenderWholesalerTenderIdFilters>;
  wholesalerId?: InputMaybe<TenderWholesalerWholesalerIdFilters>;
};

export type TenderWholesalerFiltersOr = {
  tenderId?: InputMaybe<TenderWholesalerTenderIdFilters>;
  wholesalerId?: InputMaybe<TenderWholesalerWholesalerIdFilters>;
};

export type TenderWholesalerOrderBy = {
  tenderId?: InputMaybe<InnerOrder>;
  wholesalerId?: InputMaybe<InnerOrder>;
};

export type TenderWholesalerTenderIdFilters = {
  OR?: InputMaybe<Array<TenderWholesalerTenderIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderWholesalerTenderIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderWholesalerWholesalerIdFilters = {
  OR?: InputMaybe<Array<TenderWholesalerWholesalerIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type TenderWholesalerWholesalerIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type Tenders = {
  __typename?: 'Tenders';
  data: Array<Tender>;
  pageInfo: OffsetPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TendersForRetoolInput = {
  pagination: TenderListPaginationInput;
  region: Region;
};

export type TendersInput = {
  excludedTenderIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  filter?: InputMaybe<TenderFilterOptionsInput>;
  pagination?: InputMaybe<TenderListPaginationInput>;
};

export type TopLevelProductCategoryById = {
  __typename?: 'TopLevelProductCategoryById';
  id: Scalars['NonNegativeInt']['output'];
  localizationKey: Scalars['String']['output'];
};

export type TopProductCategory = {
  __typename?: 'TopProductCategory';
  createdAtUtc: Scalars['String']['output'];
  defaultPackagingType?: Maybe<Scalars['String']['output']>;
  defaultVolume?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isPublished: Scalars['Boolean']['output'];
  localizationKey: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentCategory?: Maybe<ProductCategoryParentCategoryRelation>;
  parentId?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  regions: Array<ProductCategoryRegionsRelation>;
  subCategories: Array<MainProductCategory>;
  unit?: Maybe<ProductCategoryUnitRelation>;
  unitType?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type UnclaimedVenueAccount = {
  __typename?: 'UnclaimedVenueAccount';
  email: Scalars['String']['output'];
  integrationType: IntegrationType;
  region: Region;
  resendAvailableInSeconds?: Maybe<Scalars['Int']['output']>;
};

export type UnionTenderInList = Tender | TenderDraft;

export type UnionTenders = {
  __typename?: 'UnionTenders';
  data: Array<UnionTenderInList>;
  pageInfo: OffsetPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UnitFilters = {
  OR?: InputMaybe<Array<UnitFiltersOr>>;
  type?: InputMaybe<UnitTypeFilters>;
};

export type UnitFiltersOr = {
  type?: InputMaybe<UnitTypeFilters>;
};

export type UnitTypeFilters = {
  OR?: InputMaybe<Array<UnitTypefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UnitTypefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UnlinkAccountWithExternalProviderInput = {
  companyId: Scalars['NonNegativeInt']['input'];
  companyType: CompanyType;
  externalCompanyId: Scalars['String']['input'];
  integrationType: IntegrationType;
};

export type UpdateCompanyAddressDetailsInput = {
  activeBrandId?: InputMaybe<Scalars['Int']['input']>;
  activeVenueId?: InputMaybe<Scalars['Int']['input']>;
  billingAddress?: InputMaybe<GoogleAddressInput>;
  billingName?: InputMaybe<Scalars['String']['input']>;
  googlePlacesSessionToken: Scalars['String']['input'];
  registeredCompany?: InputMaybe<RegisteredCompanyInput>;
  tradingAddress?: InputMaybe<GoogleAddressInput>;
  tradingName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSubscriptionInput = {
  stripeCustomerId: Scalars['String']['input'];
  stripeSubscriptionId: Scalars['String']['input'];
  subscriptionTier: SubscriptionTier;
  successFee: Scalars['Float']['input'];
  yearlyPeriod?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpgradeToBespokeData = {
  __typename?: 'UpgradeToBespokeData';
  needsRedirect: Scalars['Boolean']['output'];
  redirectUrl?: Maybe<Scalars['String']['output']>;
  wasSuccessfullyUpdated: Scalars['Boolean']['output'];
};

export type UploadUrlItem = {
  __typename?: 'UploadUrlItem';
  bucketKey: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  contactName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Region;
  status: UserStatus;
  userType: UserType;
};

export type UserAccountClaimEmailSentAtUtcFilters = {
  OR?: InputMaybe<Array<UserAccountClaimEmailSentAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UserAccountClaimEmailSentAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UserActionLog = {
  __typename?: 'UserActionLog';
  additionalData?: Maybe<Scalars['Object']['output']>;
  eventName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type UserActionLogInput = {
  additionalData?: InputMaybe<Scalars['Object']['input']>;
  eventName: Scalars['String']['input'];
};

export type UserBrandsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UserBrandsInputFilter>;
  first: Scalars['Int']['input'];
  sortColumn?: InputMaybe<UserBrandsSortColumnEnum>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
};

export type UserBrandsInputFilter = {
  brandName?: InputMaybe<Scalars['String']['input']>;
};

export enum UserBrandsSortColumnEnum {
  Name = 'name'
}

export type UserContactNameFilters = {
  OR?: InputMaybe<Array<UserContactNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UserContactNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreatedAtUtcFilters = {
  OR?: InputMaybe<Array<UserCreatedAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreatedAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UserEmailFilters = {
  OR?: InputMaybe<Array<UserEmailfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UserEmailToChangeFilters = {
  OR?: InputMaybe<Array<UserEmailToChangefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UserEmailToChangeTokenFilters = {
  OR?: InputMaybe<Array<UserEmailToChangeTokenfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UserEmailToChangeTokenfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UserEmailToChangefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UserEmailfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UserExistsInput = {
  email: Scalars['String']['input'];
};

export type UserFilters = {
  OR?: InputMaybe<Array<UserFiltersOr>>;
  accountClaimEmailSentAtUtc?: InputMaybe<UserAccountClaimEmailSentAtUtcFilters>;
  contactName?: InputMaybe<UserContactNameFilters>;
  createdAtUtc?: InputMaybe<UserCreatedAtUtcFilters>;
  email?: InputMaybe<UserEmailFilters>;
  emailToChange?: InputMaybe<UserEmailToChangeFilters>;
  emailToChangeToken?: InputMaybe<UserEmailToChangeTokenFilters>;
  firebaseId?: InputMaybe<UserFirebaseIdFilters>;
  id?: InputMaybe<UserIdFilters>;
  isAccountClaimed?: InputMaybe<UserIsAccountClaimedFilters>;
  isSalesDemo?: InputMaybe<UserIsSalesDemoFilters>;
  phoneNumber?: InputMaybe<UserPhoneNumberFilters>;
  region?: InputMaybe<UserRegionFilters>;
  status?: InputMaybe<UserStatusFilters>;
  updatedAtUtc?: InputMaybe<UserUpdatedAtUtcFilters>;
  userType?: InputMaybe<UserUserTypeFilters>;
};

export type UserFiltersOr = {
  accountClaimEmailSentAtUtc?: InputMaybe<UserAccountClaimEmailSentAtUtcFilters>;
  contactName?: InputMaybe<UserContactNameFilters>;
  createdAtUtc?: InputMaybe<UserCreatedAtUtcFilters>;
  email?: InputMaybe<UserEmailFilters>;
  emailToChange?: InputMaybe<UserEmailToChangeFilters>;
  emailToChangeToken?: InputMaybe<UserEmailToChangeTokenFilters>;
  firebaseId?: InputMaybe<UserFirebaseIdFilters>;
  id?: InputMaybe<UserIdFilters>;
  isAccountClaimed?: InputMaybe<UserIsAccountClaimedFilters>;
  isSalesDemo?: InputMaybe<UserIsSalesDemoFilters>;
  phoneNumber?: InputMaybe<UserPhoneNumberFilters>;
  region?: InputMaybe<UserRegionFilters>;
  status?: InputMaybe<UserStatusFilters>;
  updatedAtUtc?: InputMaybe<UserUpdatedAtUtcFilters>;
  userType?: InputMaybe<UserUserTypeFilters>;
};

export type UserFirebaseIdFilters = {
  OR?: InputMaybe<Array<UserFirebaseIdfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UserFirebaseIdfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UserIdFilters = {
  OR?: InputMaybe<Array<UserIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UserIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UserIsAccountClaimedFilters = {
  OR?: InputMaybe<Array<UserIsAccountClaimedfiltersOr>>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UserIsAccountClaimedfiltersOr = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UserIsSalesDemoFilters = {
  OR?: InputMaybe<Array<UserIsSalesDemofiltersOr>>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UserIsSalesDemofiltersOr = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UserMeInput = {
  activeBrandId?: InputMaybe<Scalars['Int']['input']>;
  activeVenueId?: InputMaybe<Scalars['Int']['input']>;
};

export type UserPhoneNumberFilters = {
  OR?: InputMaybe<Array<UserPhoneNumberfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UserPhoneNumberfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UserRegionFilters = {
  OR?: InputMaybe<Array<UserRegionfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UserRegionfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export enum UserRole {
  Admin = 'ADMIN',
  Owner = 'OWNER',
  User = 'USER'
}

export type UserSelectItem = {
  __typename?: 'UserSelectItem';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  activeBrand?: Maybe<Brand>;
  activeVenue?: Maybe<Venue>;
  companyCount: Scalars['Int']['output'];
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Region;
  status: UserStatus;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: UserType;
};

export enum UserStatus {
  Blocked = 'BLOCKED',
  Unverified = 'UNVERIFIED',
  Verified = 'VERIFIED'
}

export type UserStatusFilters = {
  OR?: InputMaybe<Array<UserStatusfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UserStatusfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export enum UserType {
  Brand = 'BRAND',
  Venue = 'VENUE'
}

export type UserUpdatedAtUtcFilters = {
  OR?: InputMaybe<Array<UserUpdatedAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UserUpdatedAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UserUserTypeFilters = {
  OR?: InputMaybe<Array<UserUserTypefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UserUserTypefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type UserVenuesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UserVenuesInputFilter>;
  first: Scalars['Int']['input'];
  sortColumn?: InputMaybe<UserVenuesSortColumnEnum>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
};

export type UserVenuesInputFilter = {
  venueName?: InputMaybe<Scalars['String']['input']>;
};

export enum UserVenuesSortColumnEnum {
  Name = 'name'
}

export type Users = {
  __typename?: 'Users';
  data: Array<UserSelectItem>;
  pageInfo: OffsetPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Venue = Node & {
  __typename?: 'Venue';
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<Address>;
  billingName?: Maybe<Scalars['String']['output']>;
  canCreateTender: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  hasTenders: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Region;
  registeredCompany?: Maybe<RegisteredCompany>;
  requiresParamountLiquorIntegration: Scalars['Boolean']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  tenderPreference: TenderPreference;
  tradingAddress?: Maybe<Address>;
  tradingName?: Maybe<Scalars['String']['output']>;
  users: Array<CompanyUser>;
  venueCategory?: Maybe<VenueCategory>;
  venueCategoryId?: Maybe<Scalars['Int']['output']>;
  venueCategoryName?: Maybe<Scalars['String']['output']>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};

export type VenueAddressIdFilters = {
  OR?: InputMaybe<Array<VenueAddressIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueAddressIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueAvatarBucketKeyFilters = {
  OR?: InputMaybe<Array<VenueAvatarBucketKeyfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueAvatarBucketKeyPreSignedUrlExpirationDateAtUtcFilters = {
  OR?: InputMaybe<Array<VenueAvatarBucketKeyPreSignedUrlExpirationDateAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueAvatarBucketKeyPreSignedUrlExpirationDateAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueAvatarBucketKeyPreSignedUrlFilters = {
  OR?: InputMaybe<Array<VenueAvatarBucketKeyPreSignedUrlfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueAvatarBucketKeyPreSignedUrlfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueAvatarBucketKeyfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueBillingAddressIdFilters = {
  OR?: InputMaybe<Array<VenueBillingAddressIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueBillingAddressIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueBillingNameFilters = {
  OR?: InputMaybe<Array<VenueBillingNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueBillingNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueCategory = {
  __typename?: 'VenueCategory';
  id: Scalars['NonNegativeInt']['output'];
  localizationKey: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
};

export type VenueCategoryFilters = {
  OR?: InputMaybe<Array<VenueCategoryFiltersOr>>;
  id?: InputMaybe<VenueCategoryIdFilters>;
  localizationKey?: InputMaybe<VenueCategoryLocalizationKeyFilters>;
  parentId?: InputMaybe<VenueCategoryParentIdFilters>;
  region?: InputMaybe<VenueCategoryRegionFilters>;
};

export type VenueCategoryFiltersOr = {
  id?: InputMaybe<VenueCategoryIdFilters>;
  localizationKey?: InputMaybe<VenueCategoryLocalizationKeyFilters>;
  parentId?: InputMaybe<VenueCategoryParentIdFilters>;
  region?: InputMaybe<VenueCategoryRegionFilters>;
};

export type VenueCategoryIdFilters = {
  OR?: InputMaybe<Array<VenueCategoryIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueCategoryIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueCategoryLocalizationKeyFilters = {
  OR?: InputMaybe<Array<VenueCategoryLocalizationKeyfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueCategoryLocalizationKeyfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueCategoryParentIdFilters = {
  OR?: InputMaybe<Array<VenueCategoryParentIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueCategoryParentIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueCategoryRegionFilters = {
  OR?: InputMaybe<Array<VenueCategoryRegionfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueCategoryRegionfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueCreatedAtUtcFilters = {
  OR?: InputMaybe<Array<VenueCreatedAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueCreatedAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueDashboardFilterOptionsInput = {
  status?: InputMaybe<VenueDashboardTenderStatus>;
};

export type VenueDashboardMetric = {
  __typename?: 'VenueDashboardMetric';
  label: VenueDashboardMetricLabel;
  type: DashboardMetricType;
  value: Scalars['String']['output'];
};

export enum VenueDashboardMetricLabel {
  ActualTenderVolume = 'ACTUAL_TENDER_VOLUME',
  AverageBidsCount = 'AVERAGE_BIDS_COUNT',
  SupportPerBottle = 'SUPPORT_PER_BOTTLE',
  TotalSupportValue = 'TOTAL_SUPPORT_VALUE'
}

export enum VenueDashboardOrderByEnum {
  RecentlyAdded = 'RECENTLY_ADDED',
  Status = 'STATUS',
  SupportReceived = 'SUPPORT_RECEIVED',
  TimeLeft = 'TIME_LEFT',
  Volume = 'VOLUME'
}

export enum VenueDashboardTenderStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Past = 'PAST'
}

export type VenueDashboardTendersInput = {
  filter: VenueDashboardFilterOptionsInput;
  pagination: OffsetPaginationInput;
  sort?: InputMaybe<TenderSortInput>;
  venueId: Scalars['Int']['input'];
};

export enum VenueDashboardViews {
  BidView = 'BID_VIEW',
  TenderView = 'TENDER_VIEW'
}

export type VenueDescriptionFilters = {
  OR?: InputMaybe<Array<VenueDescriptionfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueDescriptionfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueEdge = Edge & {
  __typename?: 'VenueEdge';
  cursor: Scalars['String']['output'];
  node: Venue;
};

export type VenueFilters = {
  OR?: InputMaybe<Array<VenueFiltersOr>>;
  addressId?: InputMaybe<VenueAddressIdFilters>;
  avatarBucketKey?: InputMaybe<VenueAvatarBucketKeyFilters>;
  avatarBucketKeyPreSignedUrl?: InputMaybe<VenueAvatarBucketKeyPreSignedUrlFilters>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: InputMaybe<VenueAvatarBucketKeyPreSignedUrlExpirationDateAtUtcFilters>;
  billingAddressId?: InputMaybe<VenueBillingAddressIdFilters>;
  billingName?: InputMaybe<VenueBillingNameFilters>;
  createdAtUtc?: InputMaybe<VenueCreatedAtUtcFilters>;
  description?: InputMaybe<VenueDescriptionFilters>;
  groupName?: InputMaybe<VenueGroupNameFilters>;
  id?: InputMaybe<VenueIdFilters>;
  instagramUrl?: InputMaybe<VenueInstagramUrlFilters>;
  name?: InputMaybe<VenueNameFilters>;
  phoneNumber?: InputMaybe<VenuePhoneNumberFilters>;
  region?: InputMaybe<VenueRegionFilters>;
  registeredCompanyId?: InputMaybe<VenueRegisteredCompanyIdFilters>;
  tradingAddressId?: InputMaybe<VenueTradingAddressIdFilters>;
  tradingName?: InputMaybe<VenueTradingNameFilters>;
  updatedAtUtc?: InputMaybe<VenueUpdatedAtUtcFilters>;
  venueCategoryId?: InputMaybe<VenueVenueCategoryIdFilters>;
  venueCategoryName?: InputMaybe<VenueVenueCategoryNameFilters>;
  webPageUrl?: InputMaybe<VenueWebPageUrlFilters>;
};

export type VenueFiltersOr = {
  addressId?: InputMaybe<VenueAddressIdFilters>;
  avatarBucketKey?: InputMaybe<VenueAvatarBucketKeyFilters>;
  avatarBucketKeyPreSignedUrl?: InputMaybe<VenueAvatarBucketKeyPreSignedUrlFilters>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: InputMaybe<VenueAvatarBucketKeyPreSignedUrlExpirationDateAtUtcFilters>;
  billingAddressId?: InputMaybe<VenueBillingAddressIdFilters>;
  billingName?: InputMaybe<VenueBillingNameFilters>;
  createdAtUtc?: InputMaybe<VenueCreatedAtUtcFilters>;
  description?: InputMaybe<VenueDescriptionFilters>;
  groupName?: InputMaybe<VenueGroupNameFilters>;
  id?: InputMaybe<VenueIdFilters>;
  instagramUrl?: InputMaybe<VenueInstagramUrlFilters>;
  name?: InputMaybe<VenueNameFilters>;
  phoneNumber?: InputMaybe<VenuePhoneNumberFilters>;
  region?: InputMaybe<VenueRegionFilters>;
  registeredCompanyId?: InputMaybe<VenueRegisteredCompanyIdFilters>;
  tradingAddressId?: InputMaybe<VenueTradingAddressIdFilters>;
  tradingName?: InputMaybe<VenueTradingNameFilters>;
  updatedAtUtc?: InputMaybe<VenueUpdatedAtUtcFilters>;
  venueCategoryId?: InputMaybe<VenueVenueCategoryIdFilters>;
  venueCategoryName?: InputMaybe<VenueVenueCategoryNameFilters>;
  webPageUrl?: InputMaybe<VenueWebPageUrlFilters>;
};

export type VenueGroupNameFilters = {
  OR?: InputMaybe<Array<VenueGroupNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueGroupNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueIdFilters = {
  OR?: InputMaybe<Array<VenueIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueInsertInput = {
  address?: InputMaybe<AddressInsertInput>;
  avatarBucketKey?: InputMaybe<Scalars['String']['input']>;
  billingAddressId?: InputMaybe<Scalars['Int']['input']>;
  billingName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  instagramUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  registeredCompany: RegisteredCompanyInsertInput;
  tradingAddress?: InputMaybe<AddressInsertInput>;
  tradingName?: InputMaybe<Scalars['String']['input']>;
  venueCategoryId?: InputMaybe<Scalars['Int']['input']>;
  venueCategoryName?: InputMaybe<Scalars['String']['input']>;
  webPageUrl?: InputMaybe<Scalars['String']['input']>;
};

export type VenueInstagramUrlFilters = {
  OR?: InputMaybe<Array<VenueInstagramUrlfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueInstagramUrlfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueIntegrationsCreatedAtUtcFilters = {
  OR?: InputMaybe<Array<VenueIntegrationsCreatedAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueIntegrationsCreatedAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueIntegrationsExternalCompanyIdFilters = {
  OR?: InputMaybe<Array<VenueIntegrationsExternalCompanyIdfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueIntegrationsExternalCompanyIdfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueIntegrationsExternalUserIdFilters = {
  OR?: InputMaybe<Array<VenueIntegrationsExternalUserIdfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueIntegrationsExternalUserIdfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueIntegrationsFilters = {
  OR?: InputMaybe<Array<VenueIntegrationsFiltersOr>>;
  createdAtUtc?: InputMaybe<VenueIntegrationsCreatedAtUtcFilters>;
  externalCompanyId?: InputMaybe<VenueIntegrationsExternalCompanyIdFilters>;
  externalUserId?: InputMaybe<VenueIntegrationsExternalUserIdFilters>;
  id?: InputMaybe<VenueIntegrationsIdFilters>;
  integrationType?: InputMaybe<VenueIntegrationsIntegrationTypeFilters>;
  metadata?: InputMaybe<VenueIntegrationsMetadataFilters>;
  updatedAtUtc?: InputMaybe<VenueIntegrationsUpdatedAtUtcFilters>;
  userId?: InputMaybe<VenueIntegrationsUserIdFilters>;
  venueId?: InputMaybe<VenueIntegrationsVenueIdFilters>;
};

export type VenueIntegrationsFiltersOr = {
  createdAtUtc?: InputMaybe<VenueIntegrationsCreatedAtUtcFilters>;
  externalCompanyId?: InputMaybe<VenueIntegrationsExternalCompanyIdFilters>;
  externalUserId?: InputMaybe<VenueIntegrationsExternalUserIdFilters>;
  id?: InputMaybe<VenueIntegrationsIdFilters>;
  integrationType?: InputMaybe<VenueIntegrationsIntegrationTypeFilters>;
  metadata?: InputMaybe<VenueIntegrationsMetadataFilters>;
  updatedAtUtc?: InputMaybe<VenueIntegrationsUpdatedAtUtcFilters>;
  userId?: InputMaybe<VenueIntegrationsUserIdFilters>;
  venueId?: InputMaybe<VenueIntegrationsVenueIdFilters>;
};

export type VenueIntegrationsIdFilters = {
  OR?: InputMaybe<Array<VenueIntegrationsIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueIntegrationsIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export enum VenueIntegrationsIntegrationTypeEnum {
  /** Value: PARAMOUNT_LIQUOR */
  ParamountLiquor = 'PARAMOUNT_LIQUOR',
  /** Value: VENUS_AND_BOOKER */
  VenusAndBooker = 'VENUS_AND_BOOKER'
}

export type VenueIntegrationsIntegrationTypeFilters = {
  OR?: InputMaybe<Array<VenueIntegrationsIntegrationTypefiltersOr>>;
  eq?: InputMaybe<VenueIntegrationsIntegrationTypeEnum>;
  gt?: InputMaybe<VenueIntegrationsIntegrationTypeEnum>;
  gte?: InputMaybe<VenueIntegrationsIntegrationTypeEnum>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<VenueIntegrationsIntegrationTypeEnum>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<VenueIntegrationsIntegrationTypeEnum>;
  lte?: InputMaybe<VenueIntegrationsIntegrationTypeEnum>;
  ne?: InputMaybe<VenueIntegrationsIntegrationTypeEnum>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<VenueIntegrationsIntegrationTypeEnum>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueIntegrationsIntegrationTypefiltersOr = {
  eq?: InputMaybe<VenueIntegrationsIntegrationTypeEnum>;
  gt?: InputMaybe<VenueIntegrationsIntegrationTypeEnum>;
  gte?: InputMaybe<VenueIntegrationsIntegrationTypeEnum>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<VenueIntegrationsIntegrationTypeEnum>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<VenueIntegrationsIntegrationTypeEnum>;
  lte?: InputMaybe<VenueIntegrationsIntegrationTypeEnum>;
  ne?: InputMaybe<VenueIntegrationsIntegrationTypeEnum>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<VenueIntegrationsIntegrationTypeEnum>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueIntegrationsMetadataFilters = {
  OR?: InputMaybe<Array<VenueIntegrationsMetadatafiltersOr>>;
  /** JSON */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueIntegrationsMetadatafiltersOr = {
  /** JSON */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  lte?: InputMaybe<Scalars['String']['input']>;
  /** JSON */
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<JSON> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueIntegrationsOrderBy = {
  createdAtUtc?: InputMaybe<InnerOrder>;
  externalCompanyId?: InputMaybe<InnerOrder>;
  externalUserId?: InputMaybe<InnerOrder>;
  id?: InputMaybe<InnerOrder>;
  integrationType?: InputMaybe<InnerOrder>;
  metadata?: InputMaybe<InnerOrder>;
  updatedAtUtc?: InputMaybe<InnerOrder>;
  userId?: InputMaybe<InnerOrder>;
  venueId?: InputMaybe<InnerOrder>;
};

export type VenueIntegrationsSelectItem = {
  __typename?: 'VenueIntegrationsSelectItem';
  createdAtUtc: Scalars['String']['output'];
  externalCompanyId: Scalars['String']['output'];
  externalUserId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  integrationType: VenueIntegrationsIntegrationTypeEnum;
  /** JSON */
  metadata?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<VenueIntegrationsUserRelation>;
  userId: Scalars['Int']['output'];
  venue?: Maybe<VenueIntegrationsVenueRelation>;
  venueId: Scalars['Int']['output'];
};


export type VenueIntegrationsSelectItemUserArgs = {
  where?: InputMaybe<UserFilters>;
};


export type VenueIntegrationsSelectItemVenueArgs = {
  where?: InputMaybe<VenueFilters>;
};

export type VenueIntegrationsUpdatedAtUtcFilters = {
  OR?: InputMaybe<Array<VenueIntegrationsUpdatedAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueIntegrationsUpdatedAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueIntegrationsUserIdFilters = {
  OR?: InputMaybe<Array<VenueIntegrationsUserIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueIntegrationsUserIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueIntegrationsUserRelation = {
  __typename?: 'VenueIntegrationsUserRelation';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type VenueIntegrationsVenueIdFilters = {
  OR?: InputMaybe<Array<VenueIntegrationsVenueIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueIntegrationsVenueIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueIntegrationsVenueRelation = {
  __typename?: 'VenueIntegrationsVenueRelation';
  address?: Maybe<VenueIntegrationsVenueRelationAddressRelation>;
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<VenueIntegrationsVenueRelationBillingAddressRelation>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompany?: Maybe<VenueIntegrationsVenueRelationRegisteredCompanyRelation>;
  registeredCompanyId: Scalars['Int']['output'];
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  venueCategory?: Maybe<VenueIntegrationsVenueRelationVenueCategoryRelation>;
  venueCategoryId?: Maybe<Scalars['Int']['output']>;
  venueCategoryName?: Maybe<Scalars['String']['output']>;
  venueIntegrations: Array<VenueIntegrationsVenueRelationVenueIntegrationsRelation>;
  venueUsers: Array<VenueIntegrationsVenueRelationVenueUsersRelation>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};


export type VenueIntegrationsVenueRelationAddressArgs = {
  where?: InputMaybe<AddressFilters>;
};


export type VenueIntegrationsVenueRelationBillingAddressArgs = {
  where?: InputMaybe<AddressFilters>;
};


export type VenueIntegrationsVenueRelationRegisteredCompanyArgs = {
  where?: InputMaybe<RegisteredCompanyFilters>;
};


export type VenueIntegrationsVenueRelationVenueCategoryArgs = {
  where?: InputMaybe<VenueCategoryFilters>;
};


export type VenueIntegrationsVenueRelationVenueIntegrationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<VenueIntegrationsOrderBy>;
  where?: InputMaybe<VenueIntegrationsFilters>;
};


export type VenueIntegrationsVenueRelationVenueUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<VenueUserOrderBy>;
  where?: InputMaybe<VenueUserFilters>;
};

export type VenueIntegrationsVenueRelationAddressRelation = {
  __typename?: 'VenueIntegrationsVenueRelationAddressRelation';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type VenueIntegrationsVenueRelationBillingAddressRelation = {
  __typename?: 'VenueIntegrationsVenueRelationBillingAddressRelation';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type VenueIntegrationsVenueRelationRegisteredCompanyRelation = {
  __typename?: 'VenueIntegrationsVenueRelationRegisteredCompanyRelation';
  addressId?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  dateOfCreation?: Maybe<Scalars['String']['output']>;
  firstAddressLine?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  secondAddressLine?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type VenueIntegrationsVenueRelationVenueCategoryRelation = {
  __typename?: 'VenueIntegrationsVenueRelationVenueCategoryRelation';
  id: Scalars['Int']['output'];
  localizationKey: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type VenueIntegrationsVenueRelationVenueIntegrationsRelation = {
  __typename?: 'VenueIntegrationsVenueRelationVenueIntegrationsRelation';
  createdAtUtc: Scalars['String']['output'];
  externalCompanyId: Scalars['String']['output'];
  externalUserId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  integrationType: VenueIntegrationsIntegrationTypeEnum;
  /** JSON */
  metadata?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
  venueId: Scalars['Int']['output'];
};

export type VenueIntegrationsVenueRelationVenueUsersRelation = {
  __typename?: 'VenueIntegrationsVenueRelationVenueUsersRelation';
  createdAtUtc: Scalars['String']['output'];
  role: VenueUserRoleEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<VenueIntegrationsVenueRelationVenueUsersRelationUserRelation>;
  userId: Scalars['Int']['output'];
  venue?: Maybe<VenueIntegrationsVenueRelationVenueUsersRelationVenueRelation>;
  venueId: Scalars['Int']['output'];
};


export type VenueIntegrationsVenueRelationVenueUsersRelationUserArgs = {
  where?: InputMaybe<UserFilters>;
};


export type VenueIntegrationsVenueRelationVenueUsersRelationVenueArgs = {
  where?: InputMaybe<VenueFilters>;
};

export type VenueIntegrationsVenueRelationVenueUsersRelationUserRelation = {
  __typename?: 'VenueIntegrationsVenueRelationVenueUsersRelationUserRelation';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type VenueIntegrationsVenueRelationVenueUsersRelationVenueRelation = {
  __typename?: 'VenueIntegrationsVenueRelationVenueUsersRelationVenueRelation';
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompanyId: Scalars['Int']['output'];
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  venueCategoryId?: Maybe<Scalars['Int']['output']>;
  venueCategoryName?: Maybe<Scalars['String']['output']>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};

export type VenueItem = {
  __typename?: 'VenueItem';
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompanyId: Scalars['Int']['output'];
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  venueCategoryId?: Maybe<Scalars['Int']['output']>;
  venueCategoryName?: Maybe<Scalars['String']['output']>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};

export type VenueListFilterInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Region>;
};

export type VenueListInput = {
  filter?: InputMaybe<VenueListFilterInput>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderDirection?: InputMaybe<SortDirectionEnum>;
};

export type VenueLoyaltyLevel = {
  __typename?: 'VenueLoyaltyLevel';
  id: Scalars['NonNegativeInt']['output'];
  name: Scalars['NonEmptyString']['output'];
};

export type VenueNameFilters = {
  OR?: InputMaybe<Array<VenueNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenuePhoneNumberFilters = {
  OR?: InputMaybe<Array<VenuePhoneNumberfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenuePhoneNumberfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueRegionFilters = {
  OR?: InputMaybe<Array<VenueRegionfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueRegionfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueRegisteredCompanyIdFilters = {
  OR?: InputMaybe<Array<VenueRegisteredCompanyIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueRegisteredCompanyIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueSettings = {
  __typename?: 'VenueSettings';
  id: Scalars['Int']['output'];
  isBidUpdatedInAppNotificationEnabled: Scalars['Boolean']['output'];
  isBidUpdatedMailNotificationEnabled: Scalars['Boolean']['output'];
  isMyTenderEndedInAppNotificationEnabled: Scalars['Boolean']['output'];
  isMyTenderEndedMailNotificationEnabled: Scalars['Boolean']['output'];
  isNewBidsInAppNotificationEnabled: Scalars['Boolean']['output'];
  isNewBidsMailNotificationEnabled: Scalars['Boolean']['output'];
  isNewTenderInAppNotificationEnabled: Scalars['Boolean']['output'];
  isNewTenderMailNotificationEnabled: Scalars['Boolean']['output'];
  isReTenderInAppNotificationEnabled: Scalars['Boolean']['output'];
  isReTenderMailNotificationEnabled: Scalars['Boolean']['output'];
  venueId: Scalars['Int']['output'];
};

export type VenueTradingAddressIdFilters = {
  OR?: InputMaybe<Array<VenueTradingAddressIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueTradingAddressIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueTradingNameFilters = {
  OR?: InputMaybe<Array<VenueTradingNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueTradingNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueUpdatedAtUtcFilters = {
  OR?: InputMaybe<Array<VenueUpdatedAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueUpdatedAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueUserCreatedAtUtcFilters = {
  OR?: InputMaybe<Array<VenueUserCreatedAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueUserCreatedAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueUserFilters = {
  OR?: InputMaybe<Array<VenueUserFiltersOr>>;
  createdAtUtc?: InputMaybe<VenueUserCreatedAtUtcFilters>;
  role?: InputMaybe<VenueUserRoleFilters>;
  updatedAtUtc?: InputMaybe<VenueUserUpdatedAtUtcFilters>;
  userId?: InputMaybe<VenueUserUserIdFilters>;
  venueId?: InputMaybe<VenueUserVenueIdFilters>;
};

export type VenueUserFiltersOr = {
  createdAtUtc?: InputMaybe<VenueUserCreatedAtUtcFilters>;
  role?: InputMaybe<VenueUserRoleFilters>;
  updatedAtUtc?: InputMaybe<VenueUserUpdatedAtUtcFilters>;
  userId?: InputMaybe<VenueUserUserIdFilters>;
  venueId?: InputMaybe<VenueUserVenueIdFilters>;
};

export type VenueUserItem = {
  __typename?: 'VenueUserItem';
  createdAtUtc: Scalars['String']['output'];
  role?: Maybe<UserRole>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
  venueId: Scalars['Int']['output'];
};

export type VenueUserOrderBy = {
  createdAtUtc?: InputMaybe<InnerOrder>;
  role?: InputMaybe<InnerOrder>;
  updatedAtUtc?: InputMaybe<InnerOrder>;
  userId?: InputMaybe<InnerOrder>;
  venueId?: InputMaybe<InnerOrder>;
};

export enum VenueUserRoleEnum {
  /** Value: ADMIN */
  Admin = 'ADMIN',
  /** Value: OWNER */
  Owner = 'OWNER',
  /** Value: USER */
  User = 'USER'
}

export type VenueUserRoleFilters = {
  OR?: InputMaybe<Array<VenueUserRolefiltersOr>>;
  eq?: InputMaybe<VenueUserRoleEnum>;
  gt?: InputMaybe<VenueUserRoleEnum>;
  gte?: InputMaybe<VenueUserRoleEnum>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<VenueUserRoleEnum>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<VenueUserRoleEnum>;
  lte?: InputMaybe<VenueUserRoleEnum>;
  ne?: InputMaybe<VenueUserRoleEnum>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<VenueUserRoleEnum>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueUserRolefiltersOr = {
  eq?: InputMaybe<VenueUserRoleEnum>;
  gt?: InputMaybe<VenueUserRoleEnum>;
  gte?: InputMaybe<VenueUserRoleEnum>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<VenueUserRoleEnum>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<VenueUserRoleEnum>;
  lte?: InputMaybe<VenueUserRoleEnum>;
  ne?: InputMaybe<VenueUserRoleEnum>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<VenueUserRoleEnum>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueUserSelectItem = {
  __typename?: 'VenueUserSelectItem';
  createdAtUtc: Scalars['String']['output'];
  role: VenueUserRoleEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<VenueUserUserRelation>;
  userId: Scalars['Int']['output'];
  venue?: Maybe<VenueUserVenueRelation>;
  venueId: Scalars['Int']['output'];
};


export type VenueUserSelectItemUserArgs = {
  where?: InputMaybe<UserFilters>;
};


export type VenueUserSelectItemVenueArgs = {
  where?: InputMaybe<VenueFilters>;
};

export type VenueUserUpdatedAtUtcFilters = {
  OR?: InputMaybe<Array<VenueUserUpdatedAtUtcfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueUserUpdatedAtUtcfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueUserUserIdFilters = {
  OR?: InputMaybe<Array<VenueUserUserIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueUserUserIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueUserUserRelation = {
  __typename?: 'VenueUserUserRelation';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type VenueUserVenueIdFilters = {
  OR?: InputMaybe<Array<VenueUserVenueIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueUserVenueIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueUserVenueRelation = {
  __typename?: 'VenueUserVenueRelation';
  address?: Maybe<VenueUserVenueRelationAddressRelation>;
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<VenueUserVenueRelationBillingAddressRelation>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompany?: Maybe<VenueUserVenueRelationRegisteredCompanyRelation>;
  registeredCompanyId: Scalars['Int']['output'];
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  venueCategory?: Maybe<VenueUserVenueRelationVenueCategoryRelation>;
  venueCategoryId?: Maybe<Scalars['Int']['output']>;
  venueCategoryName?: Maybe<Scalars['String']['output']>;
  venueIntegrations: Array<VenueUserVenueRelationVenueIntegrationsRelation>;
  venueUsers: Array<VenueUserVenueRelationVenueUsersRelation>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};


export type VenueUserVenueRelationAddressArgs = {
  where?: InputMaybe<AddressFilters>;
};


export type VenueUserVenueRelationBillingAddressArgs = {
  where?: InputMaybe<AddressFilters>;
};


export type VenueUserVenueRelationRegisteredCompanyArgs = {
  where?: InputMaybe<RegisteredCompanyFilters>;
};


export type VenueUserVenueRelationVenueCategoryArgs = {
  where?: InputMaybe<VenueCategoryFilters>;
};


export type VenueUserVenueRelationVenueIntegrationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<VenueIntegrationsOrderBy>;
  where?: InputMaybe<VenueIntegrationsFilters>;
};


export type VenueUserVenueRelationVenueUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<VenueUserOrderBy>;
  where?: InputMaybe<VenueUserFilters>;
};

export type VenueUserVenueRelationAddressRelation = {
  __typename?: 'VenueUserVenueRelationAddressRelation';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type VenueUserVenueRelationBillingAddressRelation = {
  __typename?: 'VenueUserVenueRelationBillingAddressRelation';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type VenueUserVenueRelationRegisteredCompanyRelation = {
  __typename?: 'VenueUserVenueRelationRegisteredCompanyRelation';
  addressId?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  dateOfCreation?: Maybe<Scalars['String']['output']>;
  firstAddressLine?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  secondAddressLine?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
};

export type VenueUserVenueRelationVenueCategoryRelation = {
  __typename?: 'VenueUserVenueRelationVenueCategoryRelation';
  id: Scalars['Int']['output'];
  localizationKey: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type VenueUserVenueRelationVenueIntegrationsRelation = {
  __typename?: 'VenueUserVenueRelationVenueIntegrationsRelation';
  createdAtUtc: Scalars['String']['output'];
  externalCompanyId: Scalars['String']['output'];
  externalUserId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  integrationType: VenueIntegrationsIntegrationTypeEnum;
  /** JSON */
  metadata?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<VenueUserVenueRelationVenueIntegrationsRelationUserRelation>;
  userId: Scalars['Int']['output'];
  venue?: Maybe<VenueUserVenueRelationVenueIntegrationsRelationVenueRelation>;
  venueId: Scalars['Int']['output'];
};


export type VenueUserVenueRelationVenueIntegrationsRelationUserArgs = {
  where?: InputMaybe<UserFilters>;
};


export type VenueUserVenueRelationVenueIntegrationsRelationVenueArgs = {
  where?: InputMaybe<VenueFilters>;
};

export type VenueUserVenueRelationVenueIntegrationsRelationUserRelation = {
  __typename?: 'VenueUserVenueRelationVenueIntegrationsRelationUserRelation';
  accountClaimEmailSentAtUtc?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailToChange?: Maybe<Scalars['String']['output']>;
  emailToChangeToken?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAccountClaimed: Scalars['Boolean']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type VenueUserVenueRelationVenueIntegrationsRelationVenueRelation = {
  __typename?: 'VenueUserVenueRelationVenueIntegrationsRelationVenueRelation';
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrl?: Maybe<Scalars['String']['output']>;
  avatarBucketKeyPreSignedUrlExpirationDateAtUtc?: Maybe<Scalars['String']['output']>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  registeredCompanyId: Scalars['Int']['output'];
  tradingAddressId?: Maybe<Scalars['Int']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  venueCategoryId?: Maybe<Scalars['Int']['output']>;
  venueCategoryName?: Maybe<Scalars['String']['output']>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};

export type VenueUserVenueRelationVenueUsersRelation = {
  __typename?: 'VenueUserVenueRelationVenueUsersRelation';
  createdAtUtc: Scalars['String']['output'];
  role: VenueUserRoleEnum;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
  venueId: Scalars['Int']['output'];
};

export type VenueVenueCategoryIdFilters = {
  OR?: InputMaybe<Array<VenueVenueCategoryIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueVenueCategoryIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueVenueCategoryNameFilters = {
  OR?: InputMaybe<Array<VenueVenueCategoryNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueVenueCategoryNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueWebPageUrlFilters = {
  OR?: InputMaybe<Array<VenueWebPageUrlfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type VenueWebPageUrlfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type Venues = CursorPagination & {
  __typename?: 'Venues';
  edges: Array<VenueEdge>;
  pageInfo: CursorPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type VenuesWithPagination = {
  __typename?: 'VenuesWithPagination';
  data: Array<Venue>;
  pageInfo: OffsetPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type VolumeRangeOption = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type Wholesaler = Node & {
  __typename?: 'Wholesaler';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  region: Region;
};

export type WholesalerEdge = Edge & {
  __typename?: 'WholesalerEdge';
  cursor: Scalars['String']['output'];
  node: Wholesaler;
};

export type WholesalerFilters = {
  OR?: InputMaybe<Array<WholesalerFiltersOr>>;
  id?: InputMaybe<WholesalerIdFilters>;
  name?: InputMaybe<WholesalerNameFilters>;
  region?: InputMaybe<WholesalerRegionFilters>;
};

export type WholesalerFiltersOr = {
  id?: InputMaybe<WholesalerIdFilters>;
  name?: InputMaybe<WholesalerNameFilters>;
  region?: InputMaybe<WholesalerRegionFilters>;
};

export type WholesalerIdFilters = {
  OR?: InputMaybe<Array<WholesalerIdfiltersOr>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WholesalerIdfiltersOr = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WholesalerNameFilters = {
  OR?: InputMaybe<Array<WholesalerNamefiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WholesalerNamefiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WholesalerRegionFilters = {
  OR?: InputMaybe<Array<WholesalerRegionfiltersOr>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WholesalerRegionfiltersOr = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  inArray?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notIlike?: InputMaybe<Scalars['String']['input']>;
  /** Array<undefined> */
  notInArray?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type WholesalerSearchInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  searchQuery: Scalars['String']['input'];
  sortDirection?: InputMaybe<SortDirectionEnum>;
};

export type Wholesalers = CursorPagination & {
  __typename?: 'Wholesalers';
  edges: Array<WholesalerEdge>;
  pageInfo: CursorPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RetoolVenuesForStatusChange = {
  __typename?: 'retoolVenuesForStatusChange';
  tenderId: Scalars['Int']['output'];
  tenderName: Scalars['String']['output'];
  tenderStatus: TenderStatus;
  venueName: Scalars['String']['output'];
  venueUserId: Scalars['Int']['output'];
};

export type CursorPageInfoFragment = { __typename?: 'CursorPageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean };

export type OffsetPageInfoFragment = { __typename?: 'OffsetPageInfo', currentPage: number, totalPages: number, hasNextPage: boolean, hasPrevPage: boolean };

export type OffsetPaginationFragment = { __typename?: 'OffsetPagination', currentPage: number, totalPages: number, hasNextPage: boolean, hasPrevPage: boolean, totalCount: number };

export type AddressInfoFragment = { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } };

export type PlacesQueryVariables = Exact<{
  input: PlacesInput;
}>;


export type PlacesQuery = { __typename?: 'Query', places: Array<{ __typename?: 'PlaceAutocomplete', placeName: string, placeId: string }> };

export type AddressWithPostcodeByPlaceIdQueryVariables = Exact<{
  input: AddressByPlaceIdInput;
}>;


export type AddressWithPostcodeByPlaceIdQuery = { __typename?: 'Query', addressByPlaceId: { __typename?: 'GoogleAddress', placeId: string, placeName: string, postCode?: string | null, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Coordinates', lat: string, lng: string } } };

export type LocationByCoordinatesQueryVariables = Exact<{
  input: LocationByCoordinatesInput;
}>;


export type LocationByCoordinatesQuery = { __typename?: 'Query', locationByCoordinates: { __typename?: 'GoogleLocationByCoordinates', country?: string | null } };

export type UpdateCompanyAddressDetailsMutationVariables = Exact<{
  input: UpdateCompanyAddressDetailsInput;
}>;


export type UpdateCompanyAddressDetailsMutation = { __typename?: 'Mutation', updateCompanyAddressDetails?: boolean | null };

export type BidInfoFragment = { __typename?: 'Bid', id: number, tenderId: number, brandId: number, userId: number, isAnonymous: boolean, productName?: string | null, volumeUnits?: number | null, productCategoryId?: number | null, averageWholesalePrice?: number | null, productUrl?: string | null, supportsListingFee?: boolean | null, listingFeeTotalAmount?: number | null, listingFeeNotes?: string | null, supportsFreeStock?: boolean | null, freeStockUnitsAmount?: number | null, freeStockNotes?: string | null, supportsRetroDiscount?: boolean | null, supportsDiscount?: boolean | null, discountAmountPerUnit?: number | null, discountNotes?: string | null, retroDiscountAmountPerUnit?: number | null, retroDiscountNotes?: string | null, supportsPosBudget?: boolean | null, posBudgetTotalAmount?: number | null, posBudgetNotes?: string | null, otherSupport?: string | null, rating?: number | null, ratingComment?: string | null, isRatingOutdated?: boolean | null, ratedAtUtc?: string | null, updatedAtUtc?: string | null, createdAtUtc?: string | null, status: BidStatus, avatarUrl?: string | null, avatarBucketKey?: string | null, isListingFeeProvided?: boolean | null, isFreeStockProvided?: boolean | null, isRetroDiscountProvided?: boolean | null, isPosBudgetProvided?: boolean | null, isDiscountProvided?: boolean | null, areWholesalersCompatible?: boolean | null, messagesCount?: number | null, isListingFeeReceived?: boolean | null, isFreeStockReceived?: boolean | null, isRetroDiscountReceived?: boolean | null, isPosBudgetReceived?: boolean | null, isDiscountReceived?: boolean | null, netPrice?: number | null, netPricePerLitre?: number | null, netPricePerEquivalentUnit?: number | null, packagingType?: string | null, unitType?: string | null, unitsPerCase?: number | null, volumePerUnit?: number | null, isDirectSupplyCompatible: boolean, isAnyWholesalerCompatible: boolean, subscriptionTier: SubscriptionTier, successFee?: number | null, region: Region, commonBidId?: number | null, productCategory?: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null } | null, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null, support?: { __typename?: 'ComputedSupport', listingFee: number, freeStock: number, retro: number, marketing: number, discount: number, total: number } | null };

export type BidByIdQueryVariables = Exact<{
  bidId: Scalars['Int']['input'];
}>;


export type BidByIdQuery = { __typename?: 'Query', bidById: { __typename?: 'Bid', id: number, tenderId: number, brandId: number, userId: number, isAnonymous: boolean, productName?: string | null, volumeUnits?: number | null, productCategoryId?: number | null, averageWholesalePrice?: number | null, productUrl?: string | null, supportsListingFee?: boolean | null, listingFeeTotalAmount?: number | null, listingFeeNotes?: string | null, supportsFreeStock?: boolean | null, freeStockUnitsAmount?: number | null, freeStockNotes?: string | null, supportsRetroDiscount?: boolean | null, supportsDiscount?: boolean | null, discountAmountPerUnit?: number | null, discountNotes?: string | null, retroDiscountAmountPerUnit?: number | null, retroDiscountNotes?: string | null, supportsPosBudget?: boolean | null, posBudgetTotalAmount?: number | null, posBudgetNotes?: string | null, otherSupport?: string | null, rating?: number | null, ratingComment?: string | null, isRatingOutdated?: boolean | null, ratedAtUtc?: string | null, updatedAtUtc?: string | null, createdAtUtc?: string | null, status: BidStatus, avatarUrl?: string | null, avatarBucketKey?: string | null, isListingFeeProvided?: boolean | null, isFreeStockProvided?: boolean | null, isRetroDiscountProvided?: boolean | null, isPosBudgetProvided?: boolean | null, isDiscountProvided?: boolean | null, areWholesalersCompatible?: boolean | null, messagesCount?: number | null, isListingFeeReceived?: boolean | null, isFreeStockReceived?: boolean | null, isRetroDiscountReceived?: boolean | null, isPosBudgetReceived?: boolean | null, isDiscountReceived?: boolean | null, netPrice?: number | null, netPricePerLitre?: number | null, netPricePerEquivalentUnit?: number | null, packagingType?: string | null, unitType?: string | null, unitsPerCase?: number | null, volumePerUnit?: number | null, isDirectSupplyCompatible: boolean, isAnyWholesalerCompatible: boolean, subscriptionTier: SubscriptionTier, successFee?: number | null, region: Region, commonBidId?: number | null, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null, brand?: { __typename?: 'Brand', id: number, name?: string | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, isAnonymousBidAllowed?: boolean | null, vatNumber?: string | null, vatCompanyName?: string | null, vatCountryCode?: string | null, vatConsultationNumber?: string | null, vatProcessingDate?: string | null, complianceCheckDate?: string | null, complianceNextDate?: string | null, complianceRiskLevel?: string | null, complianceConfirmation?: string | null, billingName?: string | null, isEnterpriseSubscriptionRequestSent: boolean, subscriptionTier: SubscriptionTier, successFee: number, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, failedPaymentIntentCounter: number, region: Region, canSeeOtherBids: boolean, tradingName?: string | null, addressId?: number | null, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null }>, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, tradingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, users: Array<{ __typename?: 'CompanyUser', userId: number, role: string }>, billingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, user?: { __typename?: 'User', id: number, firebaseId: string, userType: UserType, email: string, isSalesDemo?: boolean | null, region: Region, status: UserStatus, contactName?: string | null, phoneNumber?: string | null } | null, bidRatingFeedbackValues?: Array<{ __typename?: 'BidRatingFeedbackValue', ratingFeedbackValueId: number }> | null, tender: { __typename?: 'Tender', id: number, userId: number, venueId: number, name: string, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, listingTypeId: number, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, tenderDetails?: string | null, status: TenderStatus, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock?: TenderSupportOption | null, supportsDiscount?: TenderSupportOption | null, supportsListingFee?: TenderSupportOption | null, supportsPosBudget?: TenderSupportOption | null, supportsRetroDiscount?: TenderSupportOption | null, supportDetails?: string | null, totalReceivedBids: number, createdAtUtc?: string | null, updatedAtUtc?: string | null, receivedSupportStatus?: TenderSupportStatus | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, feedback?: string | null, region: Region, isPrivate: boolean, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null, user?: { __typename?: 'User', id: number, firebaseId: string, userType: UserType, email: string, isSalesDemo?: boolean | null, region: Region, status: UserStatus, contactName?: string | null, phoneNumber?: string | null } | null, venue: { __typename?: 'Venue', id: number, name?: string | null, venueCategoryName?: string | null, venueCategoryId?: number | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, requiresParamountLiquorIntegration: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, billingName?: string | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsDiscount: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> }, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, users: Array<{ __typename?: 'CompanyUser', userId: number, role: string }>, billingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null }, listingType: { __typename?: 'ListingTypeSelectItem', id: number, name: string, suggestedTenderLengthInMonths: number, suggestedListingLengthInMonths: number, order: number }, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null }> }, productCategory?: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null } | null, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null, support?: { __typename?: 'ComputedSupport', listingFee: number, freeStock: number, retro: number, marketing: number, discount: number, total: number } | null } };

export type PreviousBidQueryVariables = Exact<{
  brandId: Scalars['Int']['input'];
}>;


export type PreviousBidQuery = { __typename?: 'Query', previousBid?: { __typename?: 'Bid', id: number, tenderId: number, brandId: number, userId: number, isAnonymous: boolean, productName?: string | null, volumeUnits?: number | null, productCategoryId?: number | null, averageWholesalePrice?: number | null, productUrl?: string | null, supportsListingFee?: boolean | null, listingFeeTotalAmount?: number | null, listingFeeNotes?: string | null, supportsFreeStock?: boolean | null, freeStockUnitsAmount?: number | null, freeStockNotes?: string | null, supportsRetroDiscount?: boolean | null, supportsDiscount?: boolean | null, discountAmountPerUnit?: number | null, discountNotes?: string | null, retroDiscountAmountPerUnit?: number | null, retroDiscountNotes?: string | null, supportsPosBudget?: boolean | null, posBudgetTotalAmount?: number | null, posBudgetNotes?: string | null, otherSupport?: string | null, rating?: number | null, ratingComment?: string | null, isRatingOutdated?: boolean | null, ratedAtUtc?: string | null, updatedAtUtc?: string | null, createdAtUtc?: string | null, status: BidStatus, avatarUrl?: string | null, avatarBucketKey?: string | null, isListingFeeProvided?: boolean | null, isFreeStockProvided?: boolean | null, isRetroDiscountProvided?: boolean | null, isPosBudgetProvided?: boolean | null, isDiscountProvided?: boolean | null, areWholesalersCompatible?: boolean | null, messagesCount?: number | null, isListingFeeReceived?: boolean | null, isFreeStockReceived?: boolean | null, isRetroDiscountReceived?: boolean | null, isPosBudgetReceived?: boolean | null, isDiscountReceived?: boolean | null, netPrice?: number | null, netPricePerLitre?: number | null, netPricePerEquivalentUnit?: number | null, packagingType?: string | null, unitType?: string | null, unitsPerCase?: number | null, volumePerUnit?: number | null, isDirectSupplyCompatible: boolean, isAnyWholesalerCompatible: boolean, subscriptionTier: SubscriptionTier, successFee?: number | null, region: Region, commonBidId?: number | null, productCategory?: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null } | null, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null, support?: { __typename?: 'ComputedSupport', listingFee: number, freeStock: number, retro: number, marketing: number, discount: number, total: number } | null } | null };

export type BidsForMultiSelectQueryVariables = Exact<{
  input: BidsInput;
}>;


export type BidsForMultiSelectQuery = { __typename?: 'Query', bids: { __typename?: 'Bids', data: Array<{ __typename?: 'Bid', id: number, support?: { __typename?: 'ComputedSupport', listingFee: number, freeStock: number, retro: number, marketing: number, discount: number, total: number } | null }> } };

export type BidsForMultiSelectTableQueryVariables = Exact<{
  input: BidsInput;
}>;


export type BidsForMultiSelectTableQuery = { __typename?: 'Query', bids: { __typename?: 'Bids', data: Array<{ __typename?: 'Bid', id: number, tenderId: number, productUrl?: string | null, productName?: string | null, isDirectSupplyCompatible: boolean, areWholesalersCompatible?: boolean | null, isAnyWholesalerCompatible: boolean, averageWholesalePrice?: number | null, netPrice?: number | null, unitType?: string | null, volumePerUnit?: number | null, unitsPerCase?: number | null, volumeUnits?: number | null, packagingType?: string | null, region: Region, retroDiscountAmountPerUnit?: number | null, rating?: number | null, support?: { __typename?: 'ComputedSupport', listingFee: number, freeStock: number, retro: number, marketing: number, discount: number, total: number } | null, brand?: { __typename?: 'Brand', name?: string | null } | null, tender: { __typename?: 'Tender', id: number, name: string } }> } };

export type BidsQueryVariables = Exact<{
  input: BidsInput;
}>;


export type BidsQuery = { __typename?: 'Query', bids: { __typename?: 'Bids', totalCount: number, data: Array<{ __typename?: 'Bid', id: number, tenderId: number, brandId: number, userId: number, isAnonymous: boolean, productName?: string | null, volumeUnits?: number | null, productCategoryId?: number | null, averageWholesalePrice?: number | null, productUrl?: string | null, supportsListingFee?: boolean | null, listingFeeTotalAmount?: number | null, listingFeeNotes?: string | null, supportsFreeStock?: boolean | null, freeStockUnitsAmount?: number | null, freeStockNotes?: string | null, supportsRetroDiscount?: boolean | null, supportsDiscount?: boolean | null, discountAmountPerUnit?: number | null, discountNotes?: string | null, retroDiscountAmountPerUnit?: number | null, retroDiscountNotes?: string | null, supportsPosBudget?: boolean | null, posBudgetTotalAmount?: number | null, posBudgetNotes?: string | null, otherSupport?: string | null, rating?: number | null, ratingComment?: string | null, isRatingOutdated?: boolean | null, ratedAtUtc?: string | null, updatedAtUtc?: string | null, createdAtUtc?: string | null, status: BidStatus, avatarUrl?: string | null, avatarBucketKey?: string | null, isListingFeeProvided?: boolean | null, isFreeStockProvided?: boolean | null, isRetroDiscountProvided?: boolean | null, isPosBudgetProvided?: boolean | null, isDiscountProvided?: boolean | null, areWholesalersCompatible?: boolean | null, messagesCount?: number | null, isListingFeeReceived?: boolean | null, isFreeStockReceived?: boolean | null, isRetroDiscountReceived?: boolean | null, isPosBudgetReceived?: boolean | null, isDiscountReceived?: boolean | null, netPrice?: number | null, netPricePerLitre?: number | null, netPricePerEquivalentUnit?: number | null, packagingType?: string | null, unitType?: string | null, unitsPerCase?: number | null, volumePerUnit?: number | null, isDirectSupplyCompatible: boolean, isAnyWholesalerCompatible: boolean, subscriptionTier: SubscriptionTier, successFee?: number | null, region: Region, commonBidId?: number | null, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null, brand?: { __typename?: 'Brand', id: number, name?: string | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, isAnonymousBidAllowed?: boolean | null, vatNumber?: string | null, vatCompanyName?: string | null, vatCountryCode?: string | null, vatConsultationNumber?: string | null, vatProcessingDate?: string | null, complianceCheckDate?: string | null, complianceNextDate?: string | null, complianceRiskLevel?: string | null, complianceConfirmation?: string | null, billingName?: string | null, isEnterpriseSubscriptionRequestSent: boolean, subscriptionTier: SubscriptionTier, successFee: number, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, failedPaymentIntentCounter: number, region: Region, canSeeOtherBids: boolean, tradingName?: string | null, addressId?: number | null, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null }>, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, tradingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, users: Array<{ __typename?: 'CompanyUser', userId: number, role: string }>, billingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, user?: { __typename?: 'User', email: string, phoneNumber?: string | null, contactName?: string | null } | null, bidRatingFeedbackValues?: Array<{ __typename?: 'BidRatingFeedbackValue', ratingFeedbackValueId: number }> | null, tender: { __typename?: 'Tender', id: number, userId: number, venueId: number, name: string, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, listingTypeId: number, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, tenderDetails?: string | null, status: TenderStatus, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock?: TenderSupportOption | null, supportsDiscount?: TenderSupportOption | null, supportsListingFee?: TenderSupportOption | null, supportsPosBudget?: TenderSupportOption | null, supportsRetroDiscount?: TenderSupportOption | null, supportDetails?: string | null, totalReceivedBids: number, createdAtUtc?: string | null, updatedAtUtc?: string | null, receivedSupportStatus?: TenderSupportStatus | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, feedback?: string | null, region: Region, isPrivate: boolean, listingType: { __typename?: 'ListingTypeSelectItem', id: number, name: string, suggestedTenderLengthInMonths: number, suggestedListingLengthInMonths: number, order: number } }, productCategory?: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null } | null, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null, support?: { __typename?: 'ComputedSupport', listingFee: number, freeStock: number, retro: number, marketing: number, discount: number, total: number } | null }>, pageInfo: { __typename?: 'OffsetPageInfo', currentPage: number, totalPages: number, hasNextPage: boolean, hasPrevPage: boolean } } };

export type BidIdsForSelectionQueryVariables = Exact<{
  filter: BidsViewFiltersInput;
}>;


export type BidIdsForSelectionQuery = { __typename?: 'Query', bidIdsForSelection: Array<number> };

export type BrandDashboardBidDataFragment = { __typename?: 'Bid', averageWholesalePrice?: number | null, id: number, isFreeStockProvided?: boolean | null, isListingFeeProvided?: boolean | null, isPosBudgetProvided?: boolean | null, isRetroDiscountProvided?: boolean | null, isDiscountProvided?: boolean | null, isFreeStockReceived?: boolean | null, isListingFeeReceived?: boolean | null, isPosBudgetReceived?: boolean | null, isRetroDiscountReceived?: boolean | null, freeStockUnitsAmount?: number | null, retroDiscountAmountPerUnit?: number | null, discountAmountPerUnit?: number | null, supportsFreeStock?: boolean | null, supportsPosBudget?: boolean | null, supportsRetroDiscount?: boolean | null, supportsListingFee?: boolean | null, tenderId: number, rating?: number | null, volumeUnits?: number | null, volumePerUnit?: number | null, unitsPerCase?: number | null, unitType?: string | null, packagingType?: string | null, region: Region, productName?: string | null, ratingComment?: string | null, commonBidId?: number | null, status: BidStatus, support?: { __typename?: 'ComputedSupport', listingFee: number, freeStock: number, retro: number, marketing: number, discount: number, total: number } | null };

export type BrandDashboardBidsQueryVariables = Exact<{
  input: BidsInput;
}>;


export type BrandDashboardBidsQuery = { __typename?: 'Query', bids: { __typename?: 'Bids', totalCount: number, data: Array<{ __typename?: 'Bid', averageWholesalePrice?: number | null, id: number, isFreeStockProvided?: boolean | null, isListingFeeProvided?: boolean | null, isPosBudgetProvided?: boolean | null, isRetroDiscountProvided?: boolean | null, isDiscountProvided?: boolean | null, isFreeStockReceived?: boolean | null, isListingFeeReceived?: boolean | null, isPosBudgetReceived?: boolean | null, isRetroDiscountReceived?: boolean | null, freeStockUnitsAmount?: number | null, retroDiscountAmountPerUnit?: number | null, discountAmountPerUnit?: number | null, supportsFreeStock?: boolean | null, supportsPosBudget?: boolean | null, supportsRetroDiscount?: boolean | null, supportsListingFee?: boolean | null, tenderId: number, rating?: number | null, volumeUnits?: number | null, volumePerUnit?: number | null, unitsPerCase?: number | null, unitType?: string | null, packagingType?: string | null, region: Region, productName?: string | null, ratingComment?: string | null, commonBidId?: number | null, status: BidStatus, tender: { __typename?: 'Tender', id: number, userId: number, venueId: number, name: string, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, listingTypeId: number, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, tenderDetails?: string | null, status: TenderStatus, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock?: TenderSupportOption | null, supportsDiscount?: TenderSupportOption | null, supportsListingFee?: TenderSupportOption | null, supportsPosBudget?: TenderSupportOption | null, supportsRetroDiscount?: TenderSupportOption | null, supportDetails?: string | null, totalReceivedBids: number, createdAtUtc?: string | null, updatedAtUtc?: string | null, receivedSupportStatus?: TenderSupportStatus | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, feedback?: string | null, region: Region, isPrivate: boolean, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null, venue: { __typename?: 'Venue', id: number, name?: string | null, venueCategoryName?: string | null, venueCategoryId?: number | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, requiresParamountLiquorIntegration: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, billingName?: string | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsDiscount: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> }, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, users: Array<{ __typename?: 'CompanyUser', userId: number, role: string }>, billingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null }, listingType: { __typename?: 'ListingTypeSelectItem', id: number, name: string, suggestedTenderLengthInMonths: number, suggestedListingLengthInMonths: number, order: number }, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null }> }, support?: { __typename?: 'ComputedSupport', listingFee: number, freeStock: number, retro: number, marketing: number, discount: number, total: number } | null }>, pageInfo: { __typename?: 'OffsetPageInfo', currentPage: number, totalPages: number, hasNextPage: boolean, hasPrevPage: boolean } } };

export type BrandDashboardPdfDataQueryVariables = Exact<{
  bidId: Scalars['Int']['input'];
}>;


export type BrandDashboardPdfDataQuery = { __typename?: 'Query', bidById: { __typename?: 'Bid', id: number, tenderId: number, brandId: number, userId: number, isAnonymous: boolean, productName?: string | null, volumeUnits?: number | null, productCategoryId?: number | null, averageWholesalePrice?: number | null, productUrl?: string | null, supportsListingFee?: boolean | null, listingFeeTotalAmount?: number | null, listingFeeNotes?: string | null, supportsFreeStock?: boolean | null, freeStockUnitsAmount?: number | null, freeStockNotes?: string | null, supportsRetroDiscount?: boolean | null, supportsDiscount?: boolean | null, discountAmountPerUnit?: number | null, discountNotes?: string | null, retroDiscountAmountPerUnit?: number | null, retroDiscountNotes?: string | null, supportsPosBudget?: boolean | null, posBudgetTotalAmount?: number | null, posBudgetNotes?: string | null, otherSupport?: string | null, rating?: number | null, ratingComment?: string | null, isRatingOutdated?: boolean | null, ratedAtUtc?: string | null, updatedAtUtc?: string | null, createdAtUtc?: string | null, status: BidStatus, avatarUrl?: string | null, avatarBucketKey?: string | null, isListingFeeProvided?: boolean | null, isFreeStockProvided?: boolean | null, isRetroDiscountProvided?: boolean | null, isPosBudgetProvided?: boolean | null, isDiscountProvided?: boolean | null, areWholesalersCompatible?: boolean | null, messagesCount?: number | null, isListingFeeReceived?: boolean | null, isFreeStockReceived?: boolean | null, isRetroDiscountReceived?: boolean | null, isPosBudgetReceived?: boolean | null, isDiscountReceived?: boolean | null, netPrice?: number | null, netPricePerLitre?: number | null, netPricePerEquivalentUnit?: number | null, packagingType?: string | null, unitType?: string | null, unitsPerCase?: number | null, volumePerUnit?: number | null, isDirectSupplyCompatible: boolean, isAnyWholesalerCompatible: boolean, subscriptionTier: SubscriptionTier, successFee?: number | null, region: Region, commonBidId?: number | null, brand?: { __typename?: 'Brand', id: number, name?: string | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, isAnonymousBidAllowed?: boolean | null, vatNumber?: string | null, vatCompanyName?: string | null, vatCountryCode?: string | null, vatConsultationNumber?: string | null, vatProcessingDate?: string | null, complianceCheckDate?: string | null, complianceNextDate?: string | null, complianceRiskLevel?: string | null, complianceConfirmation?: string | null, billingName?: string | null, isEnterpriseSubscriptionRequestSent: boolean, subscriptionTier: SubscriptionTier, successFee: number, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, failedPaymentIntentCounter: number, region: Region, canSeeOtherBids: boolean, tradingName?: string | null, addressId?: number | null, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null }>, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, tradingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, users: Array<{ __typename?: 'CompanyUser', userId: number, role: string }>, billingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, user?: { __typename?: 'User', id: number, firebaseId: string, userType: UserType, email: string, isSalesDemo?: boolean | null, region: Region, status: UserStatus, contactName?: string | null, phoneNumber?: string | null } | null, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null, tender: { __typename?: 'Tender', id: number, userId: number, venueId: number, name: string, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, listingTypeId: number, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, tenderDetails?: string | null, status: TenderStatus, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock?: TenderSupportOption | null, supportsDiscount?: TenderSupportOption | null, supportsListingFee?: TenderSupportOption | null, supportsPosBudget?: TenderSupportOption | null, supportsRetroDiscount?: TenderSupportOption | null, supportDetails?: string | null, totalReceivedBids: number, createdAtUtc?: string | null, updatedAtUtc?: string | null, receivedSupportStatus?: TenderSupportStatus | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, feedback?: string | null, region: Region, isPrivate: boolean, user?: { __typename?: 'User', id: number, firebaseId: string, userType: UserType, email: string, isSalesDemo?: boolean | null, region: Region, status: UserStatus, contactName?: string | null, phoneNumber?: string | null } | null, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null, venue: { __typename?: 'Venue', id: number, name?: string | null, venueCategoryName?: string | null, venueCategoryId?: number | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, requiresParamountLiquorIntegration: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, billingName?: string | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsDiscount: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> }, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, users: Array<{ __typename?: 'CompanyUser', userId: number, role: string }>, billingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null }, listingType: { __typename?: 'ListingTypeSelectItem', id: number, name: string, suggestedTenderLengthInMonths: number, suggestedListingLengthInMonths: number, order: number }, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null }> }, productCategory?: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null } | null, support?: { __typename?: 'ComputedSupport', listingFee: number, freeStock: number, retro: number, marketing: number, discount: number, total: number } | null } };

export type WinningBidsByTenderIdQueryVariables = Exact<{
  tenderId: Scalars['Int']['input'];
}>;


export type WinningBidsByTenderIdQuery = { __typename?: 'Query', winningBidsByTenderId: Array<{ __typename?: 'Bid', id: number, tenderId: number, brandId: number, userId: number, isAnonymous: boolean, productName?: string | null, volumeUnits?: number | null, productCategoryId?: number | null, averageWholesalePrice?: number | null, productUrl?: string | null, supportsListingFee?: boolean | null, listingFeeTotalAmount?: number | null, listingFeeNotes?: string | null, supportsFreeStock?: boolean | null, freeStockUnitsAmount?: number | null, freeStockNotes?: string | null, supportsRetroDiscount?: boolean | null, supportsDiscount?: boolean | null, discountAmountPerUnit?: number | null, discountNotes?: string | null, retroDiscountAmountPerUnit?: number | null, retroDiscountNotes?: string | null, supportsPosBudget?: boolean | null, posBudgetTotalAmount?: number | null, posBudgetNotes?: string | null, otherSupport?: string | null, rating?: number | null, ratingComment?: string | null, isRatingOutdated?: boolean | null, ratedAtUtc?: string | null, updatedAtUtc?: string | null, createdAtUtc?: string | null, status: BidStatus, avatarUrl?: string | null, avatarBucketKey?: string | null, isListingFeeProvided?: boolean | null, isFreeStockProvided?: boolean | null, isRetroDiscountProvided?: boolean | null, isPosBudgetProvided?: boolean | null, isDiscountProvided?: boolean | null, areWholesalersCompatible?: boolean | null, messagesCount?: number | null, isListingFeeReceived?: boolean | null, isFreeStockReceived?: boolean | null, isRetroDiscountReceived?: boolean | null, isPosBudgetReceived?: boolean | null, isDiscountReceived?: boolean | null, netPrice?: number | null, netPricePerLitre?: number | null, netPricePerEquivalentUnit?: number | null, packagingType?: string | null, unitType?: string | null, unitsPerCase?: number | null, volumePerUnit?: number | null, isDirectSupplyCompatible: boolean, isAnyWholesalerCompatible: boolean, subscriptionTier: SubscriptionTier, successFee?: number | null, region: Region, commonBidId?: number | null, brand?: { __typename?: 'Brand', id: number, name?: string | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, isAnonymousBidAllowed?: boolean | null, vatNumber?: string | null, vatCompanyName?: string | null, vatCountryCode?: string | null, vatConsultationNumber?: string | null, vatProcessingDate?: string | null, complianceCheckDate?: string | null, complianceNextDate?: string | null, complianceRiskLevel?: string | null, complianceConfirmation?: string | null, billingName?: string | null, isEnterpriseSubscriptionRequestSent: boolean, subscriptionTier: SubscriptionTier, successFee: number, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, failedPaymentIntentCounter: number, region: Region, canSeeOtherBids: boolean, tradingName?: string | null, addressId?: number | null, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null }>, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, tradingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, users: Array<{ __typename?: 'CompanyUser', userId: number, role: string }>, billingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, user?: { __typename?: 'User', id: number, firebaseId: string, userType: UserType, email: string, isSalesDemo?: boolean | null, region: Region, status: UserStatus, contactName?: string | null, phoneNumber?: string | null } | null, bidRatingFeedbackValues?: Array<{ __typename?: 'BidRatingFeedbackValue', ratingFeedbackValueId: number }> | null, tender: { __typename?: 'Tender', id: number, userId: number, venueId: number, name: string, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, listingTypeId: number, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, tenderDetails?: string | null, status: TenderStatus, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock?: TenderSupportOption | null, supportsDiscount?: TenderSupportOption | null, supportsListingFee?: TenderSupportOption | null, supportsPosBudget?: TenderSupportOption | null, supportsRetroDiscount?: TenderSupportOption | null, supportDetails?: string | null, totalReceivedBids: number, createdAtUtc?: string | null, updatedAtUtc?: string | null, receivedSupportStatus?: TenderSupportStatus | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, feedback?: string | null, region: Region, isPrivate: boolean, user?: { __typename?: 'User', id: number, firebaseId: string, userType: UserType, email: string, isSalesDemo?: boolean | null, region: Region, status: UserStatus, contactName?: string | null, phoneNumber?: string | null } | null, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null, venue: { __typename?: 'Venue', id: number, name?: string | null, venueCategoryName?: string | null, venueCategoryId?: number | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, requiresParamountLiquorIntegration: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, billingName?: string | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsDiscount: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> }, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, users: Array<{ __typename?: 'CompanyUser', userId: number, role: string }>, billingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null }, listingType: { __typename?: 'ListingTypeSelectItem', id: number, name: string, suggestedTenderLengthInMonths: number, suggestedListingLengthInMonths: number, order: number }, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null }> }, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null, productCategory?: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null } | null, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null, support?: { __typename?: 'ComputedSupport', listingFee: number, freeStock: number, retro: number, marketing: number, discount: number, total: number } | null }> };

export type BidsViewFilterOptionsQueryVariables = Exact<{
  input: BidsFilterOptionsInput;
}>;


export type BidsViewFilterOptionsQuery = { __typename?: 'Query', bidsViewFilterOptions: Array<{ __typename?: 'Filter', label: string, options: Array<{ __typename?: 'FilterOption', label: string, value: string }> }> };

export type RateBidMutationVariables = Exact<{
  input: CommonBidRateInput;
}>;


export type RateBidMutation = { __typename?: 'Mutation', rateBid: { __typename?: 'Bid', id: number, tenderId: number, userId: number, rating?: number | null, ratingComment?: string | null, isRatingOutdated?: boolean | null, bidRatingFeedbackValues?: Array<{ __typename?: 'BidRatingFeedbackValue', ratingFeedbackValueId: number }> | null } };

export type DeleteBidByIdMutationVariables = Exact<{
  bidId: Scalars['NonNegativeInt']['input'];
}>;


export type DeleteBidByIdMutation = { __typename?: 'Mutation', deleteBidById: boolean };

export type InsertIntoConnectBidMutationVariables = Exact<{
  input: ConnectBidInsertInput;
}>;


export type InsertIntoConnectBidMutation = { __typename?: 'Mutation', insertIntoConnectBid: { __typename?: 'ConnectBidSelectItem', bidId: number, tenderId: number, commonBid?: { __typename?: 'ConnectBidCommonBidRelation', id: number, successFee: number, product?: { __typename?: 'ConnectBidCommonBidRelationProductRelation', volumePerUnit: number, unitType: string, averageWholesalePrice: number } | null, supports: Array<{ __typename?: 'ConnectBidCommonBidRelationSupportsRelation', amount: number, notes?: string | null, supportType: CommonBidSupportSupportTypeEnum }> } | null } };

export type EditBidMutationVariables = Exact<{
  input: EditBidInput;
}>;


export type EditBidMutation = { __typename?: 'Mutation', editBid?: { __typename?: 'Bid', id: number } | null };

export type SampleRequestMutationVariables = Exact<{
  input: CommonBidSampleRequestInput;
}>;


export type SampleRequestMutation = { __typename?: 'Mutation', sampleRequest: boolean };

export type EditBidSupportStatusMutationVariables = Exact<{
  input: EditBidSupportStatusInput;
}>;


export type EditBidSupportStatusMutation = { __typename?: 'Mutation', editBidSupportStatus: { __typename?: 'Bid', id: number, tenderId: number, brandId: number, userId: number, isAnonymous: boolean, productName?: string | null, volumeUnits?: number | null, productCategoryId?: number | null, averageWholesalePrice?: number | null, productUrl?: string | null, supportsListingFee?: boolean | null, listingFeeTotalAmount?: number | null, listingFeeNotes?: string | null, supportsFreeStock?: boolean | null, freeStockUnitsAmount?: number | null, freeStockNotes?: string | null, supportsRetroDiscount?: boolean | null, supportsDiscount?: boolean | null, discountAmountPerUnit?: number | null, discountNotes?: string | null, retroDiscountAmountPerUnit?: number | null, retroDiscountNotes?: string | null, supportsPosBudget?: boolean | null, posBudgetTotalAmount?: number | null, posBudgetNotes?: string | null, otherSupport?: string | null, rating?: number | null, ratingComment?: string | null, isRatingOutdated?: boolean | null, ratedAtUtc?: string | null, updatedAtUtc?: string | null, createdAtUtc?: string | null, status: BidStatus, avatarUrl?: string | null, avatarBucketKey?: string | null, isListingFeeProvided?: boolean | null, isFreeStockProvided?: boolean | null, isRetroDiscountProvided?: boolean | null, isPosBudgetProvided?: boolean | null, isDiscountProvided?: boolean | null, areWholesalersCompatible?: boolean | null, messagesCount?: number | null, isListingFeeReceived?: boolean | null, isFreeStockReceived?: boolean | null, isRetroDiscountReceived?: boolean | null, isPosBudgetReceived?: boolean | null, isDiscountReceived?: boolean | null, netPrice?: number | null, netPricePerLitre?: number | null, netPricePerEquivalentUnit?: number | null, packagingType?: string | null, unitType?: string | null, unitsPerCase?: number | null, volumePerUnit?: number | null, isDirectSupplyCompatible: boolean, isAnyWholesalerCompatible: boolean, subscriptionTier: SubscriptionTier, successFee?: number | null, region: Region, commonBidId?: number | null, productCategory?: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null } | null, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null, support?: { __typename?: 'ComputedSupport', listingFee: number, freeStock: number, retro: number, marketing: number, discount: number, total: number } | null } };

export type AreWholesalersCompatibleQueryVariables = Exact<{
  bidId: Scalars['NonNegativeInt']['input'];
}>;


export type AreWholesalersCompatibleQuery = { __typename?: 'Query', areWholesalersCompatible: boolean };

export type BrandInfoFragment = { __typename?: 'Brand', id: number, name?: string | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, isAnonymousBidAllowed?: boolean | null, vatNumber?: string | null, vatCompanyName?: string | null, vatCountryCode?: string | null, vatConsultationNumber?: string | null, vatProcessingDate?: string | null, complianceCheckDate?: string | null, complianceNextDate?: string | null, complianceRiskLevel?: string | null, complianceConfirmation?: string | null, billingName?: string | null, isEnterpriseSubscriptionRequestSent: boolean, subscriptionTier: SubscriptionTier, successFee: number, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, failedPaymentIntentCounter: number, region: Region, canSeeOtherBids: boolean, tradingName?: string | null, addressId?: number | null, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null }>, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, tradingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, users: Array<{ __typename?: 'CompanyUser', userId: number, role: string }>, billingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null };

export type BrandUserInfoFragment = { __typename?: 'BrandUserItem', userId: number, brandId: number, role?: UserRole | null };

export type EditBrandMutationVariables = Exact<{
  input: EditBrandInput;
}>;


export type EditBrandMutation = { __typename?: 'Mutation', editBrand: { __typename?: 'Brand', id: number, name?: string | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, isAnonymousBidAllowed?: boolean | null, vatNumber?: string | null, vatCompanyName?: string | null, vatCountryCode?: string | null, vatConsultationNumber?: string | null, vatProcessingDate?: string | null, complianceCheckDate?: string | null, complianceNextDate?: string | null, complianceRiskLevel?: string | null, complianceConfirmation?: string | null, billingName?: string | null, isEnterpriseSubscriptionRequestSent: boolean, subscriptionTier: SubscriptionTier, successFee: number, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, failedPaymentIntentCounter: number, region: Region, canSeeOtherBids: boolean, tradingName?: string | null, addressId?: number | null, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null }>, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, tradingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, users: Array<{ __typename?: 'CompanyUser', userId: number, role: string }>, billingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } };

export type GetDataFromCompanyVatQueryVariables = Exact<{
  input: GetCompanyVatDetailsInput;
}>;


export type GetDataFromCompanyVatQuery = { __typename?: 'Query', getCompanyVatDetails: { __typename?: 'CompanyVatDetails', vatNumber: string, vatCompanyName: string, vatCountryCode: string, vatConsultationNumber: string, vatProcessingDate: string } };

export type UserBrandsQueryVariables = Exact<{
  input: UserBrandsInput;
}>;


export type UserBrandsQuery = { __typename?: 'Query', userBrands: { __typename?: 'BrandsCursor', totalCount: number, edges: Array<{ __typename?: 'BrandEdge', cursor: string, node: { __typename?: 'Brand', id: number, name?: string | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, isAnonymousBidAllowed?: boolean | null, vatNumber?: string | null, vatCompanyName?: string | null, vatCountryCode?: string | null, vatConsultationNumber?: string | null, vatProcessingDate?: string | null, complianceCheckDate?: string | null, complianceNextDate?: string | null, complianceRiskLevel?: string | null, complianceConfirmation?: string | null, billingName?: string | null, isEnterpriseSubscriptionRequestSent: boolean, subscriptionTier: SubscriptionTier, successFee: number, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, failedPaymentIntentCounter: number, region: Region, canSeeOtherBids: boolean, tradingName?: string | null, addressId?: number | null, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null }>, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, tradingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, users: Array<{ __typename?: 'CompanyUser', userId: number, role: string }>, billingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } }>, pageInfo: { __typename?: 'CursorPageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type BrandByIdQueryVariables = Exact<{
  brandId: Scalars['Int']['input'];
}>;


export type BrandByIdQuery = { __typename?: 'Query', brandById: { __typename?: 'Brand', id: number, name?: string | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, isAnonymousBidAllowed?: boolean | null, vatNumber?: string | null, vatCompanyName?: string | null, vatCountryCode?: string | null, vatConsultationNumber?: string | null, vatProcessingDate?: string | null, complianceCheckDate?: string | null, complianceNextDate?: string | null, complianceRiskLevel?: string | null, complianceConfirmation?: string | null, billingName?: string | null, isEnterpriseSubscriptionRequestSent: boolean, subscriptionTier: SubscriptionTier, successFee: number, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, failedPaymentIntentCounter: number, region: Region, canSeeOtherBids: boolean, tradingName?: string | null, addressId?: number | null, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null }>, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, tradingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, users: Array<{ __typename?: 'CompanyUser', userId: number, role: string }>, billingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } };

export type BrandUsersQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BrandUserOrderBy>;
  where?: InputMaybe<BrandUserFilters>;
}>;


export type BrandUsersQuery = { __typename?: 'Query', brandUsers: Array<{ __typename?: 'BrandUserSelectItem', userId: number, role: BrandUserRoleEnum, user?: { __typename?: 'BrandUserUserRelation', id: number, email: string } | null }> };

export type DeleteBrandUserMutationVariables = Exact<{
  brandId: Scalars['NonNegativeInt']['input'];
  userId: Scalars['NonNegativeInt']['input'];
}>;


export type DeleteBrandUserMutation = { __typename?: 'Mutation', deleteBrandUser?: { __typename?: 'BrandUserItem', userId: number, brandId: number, role?: UserRole | null } | null };

export type SetBrandUserRoleMutationVariables = Exact<{
  brandId: Scalars['NonNegativeInt']['input'];
  userId: Scalars['NonNegativeInt']['input'];
  role: SetUserRole;
}>;


export type SetBrandUserRoleMutation = { __typename?: 'Mutation', setBrandUserRole?: { __typename?: 'BrandUserItem', userId: number, brandId: number, role?: UserRole | null } | null };

export type InsertIntoBrandMutationVariables = Exact<{
  input: BrandInsertInput;
}>;


export type InsertIntoBrandMutation = { __typename?: 'Mutation', insertIntoBrand: { __typename?: 'BrandItem', id: number } };

export type UpdateBrandBillingAddressMutationVariables = Exact<{
  id: Scalars['NonNegativeInt']['input'];
  input: AddressInsertInput;
}>;


export type UpdateBrandBillingAddressMutation = { __typename?: 'Mutation', updateBrandBillingAddress?: { __typename?: 'BrandItem', id: number } | null };

export type BrandSubscriptionFeaturesQueryVariables = Exact<{
  brandId: Scalars['NonNegativeInt']['input'];
}>;


export type BrandSubscriptionFeaturesQuery = { __typename?: 'Query', subscriptionFeatures: Array<{ __typename?: 'SubscriptionFeaturesItem', type: SubscriptionFeatures, value: number, brandId: number }> };

export type HasBidsQueryVariables = Exact<{
  brandId: Scalars['NonNegativeInt']['input'];
}>;


export type HasBidsQuery = { __typename?: 'Query', hasBids: { __typename?: 'HasBids', brandId: number, hasBids: boolean } };

export type BrandIntegrationItemFragment = { __typename?: 'BrandIntegrationsSelectItem', id: number, createdAtUtc: string, updatedAtUtc?: string | null, brandId: number, userId: number, externalUserId: string, externalCompanyId: string, integrationType: BrandIntegrationsIntegrationTypeEnum, metadata?: string | null };

export type BrandIntegrationsQueryVariables = Exact<{
  brandId: Scalars['Int']['input'];
}>;


export type BrandIntegrationsQuery = { __typename?: 'Query', brandIntegrations: Array<{ __typename?: 'BrandIntegrationsSelectItem', id: number, createdAtUtc: string, updatedAtUtc?: string | null, brandId: number, userId: number, externalUserId: string, externalCompanyId: string, integrationType: BrandIntegrationsIntegrationTypeEnum, metadata?: string | null }> };

export type BrandSettingsInfoFragment = { __typename?: 'BrandSettings', id: number, brandId: number, isRatingProvidedMailNotificationEnabled: boolean, isTenderUpdatedMailNotificationEnabled: boolean, isNewTenderMailNotificationEnabled: boolean, isRatingProvidedInAppNotificationEnabled: boolean, isTenderUpdatedInAppNotificationEnabled: boolean, isNewTenderInAppNotificationEnabled: boolean, isMatchBidsTenderReportMailNotificationEnabled: boolean };

export type BrandSettingsByBrandIdQueryVariables = Exact<{
  brandId: Scalars['Int']['input'];
}>;


export type BrandSettingsByBrandIdQuery = { __typename?: 'Query', brandSettingsByBrandId: { __typename?: 'BrandSettings', id: number, brandId: number, isRatingProvidedMailNotificationEnabled: boolean, isTenderUpdatedMailNotificationEnabled: boolean, isNewTenderMailNotificationEnabled: boolean, isRatingProvidedInAppNotificationEnabled: boolean, isTenderUpdatedInAppNotificationEnabled: boolean, isNewTenderInAppNotificationEnabled: boolean, isMatchBidsTenderReportMailNotificationEnabled: boolean } };

export type EditBrandSettingsMutationVariables = Exact<{
  input: EditBrandSettingsInput;
}>;


export type EditBrandSettingsMutation = { __typename?: 'Mutation', editBrandSettings: { __typename?: 'BrandSettings', id: number, brandId: number, isRatingProvidedMailNotificationEnabled: boolean, isTenderUpdatedMailNotificationEnabled: boolean, isNewTenderMailNotificationEnabled: boolean, isRatingProvidedInAppNotificationEnabled: boolean, isTenderUpdatedInAppNotificationEnabled: boolean, isNewTenderInAppNotificationEnabled: boolean, isMatchBidsTenderReportMailNotificationEnabled: boolean } };

export type CommonBidMatchBidFragment = { __typename?: 'CommonBidMatchBidRelation', bidId: number, credit?: boolean | null, maximumAcceptedDeals: number, product?: { __typename?: 'CommonBidMatchBidRelationProductRelation', bidId: number, productId: number, externalProductId?: string | null } | null, venueCriteria?: { __typename?: 'CommonBidMatchBidRelationVenueCriteriaRelation', bidId: number, regions?: Array<string> | null, customerTypes?: Array<string> | null, listingTypeId: number, loyaltyLevels?: Array<string> | null, minimumVolume: number, venueTypes?: Array<string> | null, targetProductCategory?: number | null } | null };

export type CommonBidInfoFragment = { __typename?: 'CommonBidSelectItem', id: number, status: CommonBidStatusEnum, otherSupportAndTerms?: string | null, brandId: number, region: CommonBidRegionEnum, isAnonymous: boolean, ratedAtUtc?: string | null, updatedAtUtc?: string | null, rating?: number | null, ratingComment?: string | null, userId: number, supportedWholesalers: Array<{ __typename?: 'CommonBidSupportedWholesalersRelation', bidId: number, wholesalerId: number, wholesaler?: { __typename?: 'CommonBidSupportedWholesalersRelationWholesalerRelation', id: number, name: string } | null }>, supports: Array<{ __typename?: 'CommonBidSupportsRelation', amount: number, notes?: string | null, supportType: CommonBidSupportSupportTypeEnum, isProvided: boolean, isReceived: boolean }>, user?: { __typename?: 'CommonBidUserRelation', id: number, email: string, phoneNumber?: string | null, contactName?: string | null } | null, brand?: { __typename?: 'CommonBidBrandRelation', id: number, name?: string | null, billingName?: string | null, avatarBucketKey?: string | null, addressId?: number | null, phoneNumber?: string | null, tradingName?: string | null, webPageUrl?: string | null, subscriptionTier: string, avatarUrl?: string | null, address?: { __typename?: 'CommonBidBrandRelationAddressRelation', id: number, name: string } | null, registeredCompany?: { __typename?: 'CommonBidBrandRelationRegisteredCompanyRelation', id: number, name: string, formattedAddress?: string | null } | null } | null, product?: { __typename?: 'CommonBidProductRelation', bidId: number, name: string, productCategoryId: number, url?: string | null, packagingType: string, volumeUnits: number, averageWholesalePrice: number, isAnyWholesalerCompatible: boolean, isDirectSupplyCompatible: boolean, unitType: string, avatarUrl?: string | null, avatarBucketKey?: string | null, productTemplateId?: number | null, unitsPerCase: number, volumePerUnit: number, attachments?: Array<{ __typename?: 'S3File', filename: string, bucketKey: string, downloadUrl: URL | string, fileSizeInKib: number }> | null, productCategory?: { __typename?: 'CommonBidProductRelationProductCategoryRelation', id: number, localizationKey: string, parentCategory?: { __typename?: 'CommonBidProductRelationProductCategoryRelationParentCategoryRelation', id: number, localizationKey: string } | null } | null } | null, matchBid?: { __typename?: 'CommonBidMatchBidRelation', bidId: number, credit?: boolean | null, maximumAcceptedDeals: number, product?: { __typename?: 'CommonBidMatchBidRelationProductRelation', bidId: number, productId: number, externalProductId?: string | null } | null, venueCriteria?: { __typename?: 'CommonBidMatchBidRelationVenueCriteriaRelation', bidId: number, regions?: Array<string> | null, customerTypes?: Array<string> | null, listingTypeId: number, loyaltyLevels?: Array<string> | null, minimumVolume: number, venueTypes?: Array<string> | null, targetProductCategory?: number | null } | null } | null, connectBid?: { __typename?: 'CommonBidConnectBidRelation', bidId: number, tenderId: number, matchBidId?: number | null, messageCount: number, tender?: { __typename?: 'CommonBidConnectBidRelationTenderRelation', id: number, userId: number, estimatedVolume: number, volumeUnits: number, unitType: string, venueId: number, isAnyWholesalerCompatible?: boolean | null, venue?: { __typename?: 'CommonBidConnectBidRelationTenderRelationVenueRelation', name?: string | null } | null } | null, matchBid?: { __typename?: 'CommonBidConnectBidRelationMatchBidRelation', bidId: number, venueCriteria?: { __typename?: 'CommonBidConnectBidRelationMatchBidRelationVenueCriteriaRelation', bidId: number, regions?: Array<string> | null, customerTypes?: Array<string> | null, listingTypeId: number, loyaltyLevels?: Array<string> | null, minimumVolume: number, venueTypes?: Array<string> | null, targetProductCategory?: number | null } | null } | null } | null };

export type CommonBidQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CommonBidOrderBy>;
  where?: InputMaybe<CommonBidFilters>;
}>;


export type CommonBidQuery = { __typename?: 'Query', commonBid?: { __typename?: 'CommonBidSelectItem', id: number, status: CommonBidStatusEnum, otherSupportAndTerms?: string | null, brandId: number, region: CommonBidRegionEnum, isAnonymous: boolean, ratedAtUtc?: string | null, updatedAtUtc?: string | null, rating?: number | null, ratingComment?: string | null, userId: number, supportedWholesalers: Array<{ __typename?: 'CommonBidSupportedWholesalersRelation', bidId: number, wholesalerId: number, wholesaler?: { __typename?: 'CommonBidSupportedWholesalersRelationWholesalerRelation', id: number, name: string } | null }>, supports: Array<{ __typename?: 'CommonBidSupportsRelation', amount: number, notes?: string | null, supportType: CommonBidSupportSupportTypeEnum, isProvided: boolean, isReceived: boolean }>, user?: { __typename?: 'CommonBidUserRelation', id: number, email: string, phoneNumber?: string | null, contactName?: string | null } | null, brand?: { __typename?: 'CommonBidBrandRelation', id: number, name?: string | null, billingName?: string | null, avatarBucketKey?: string | null, addressId?: number | null, phoneNumber?: string | null, tradingName?: string | null, webPageUrl?: string | null, subscriptionTier: string, avatarUrl?: string | null, address?: { __typename?: 'CommonBidBrandRelationAddressRelation', id: number, name: string } | null, registeredCompany?: { __typename?: 'CommonBidBrandRelationRegisteredCompanyRelation', id: number, name: string, formattedAddress?: string | null } | null } | null, product?: { __typename?: 'CommonBidProductRelation', bidId: number, name: string, productCategoryId: number, url?: string | null, packagingType: string, volumeUnits: number, averageWholesalePrice: number, isAnyWholesalerCompatible: boolean, isDirectSupplyCompatible: boolean, unitType: string, avatarUrl?: string | null, avatarBucketKey?: string | null, productTemplateId?: number | null, unitsPerCase: number, volumePerUnit: number, attachments?: Array<{ __typename?: 'S3File', filename: string, bucketKey: string, downloadUrl: URL | string, fileSizeInKib: number }> | null, productCategory?: { __typename?: 'CommonBidProductRelationProductCategoryRelation', id: number, localizationKey: string, parentCategory?: { __typename?: 'CommonBidProductRelationProductCategoryRelationParentCategoryRelation', id: number, localizationKey: string } | null } | null } | null, matchBid?: { __typename?: 'CommonBidMatchBidRelation', bidId: number, credit?: boolean | null, maximumAcceptedDeals: number, product?: { __typename?: 'CommonBidMatchBidRelationProductRelation', bidId: number, productId: number, externalProductId?: string | null } | null, venueCriteria?: { __typename?: 'CommonBidMatchBidRelationVenueCriteriaRelation', bidId: number, regions?: Array<string> | null, customerTypes?: Array<string> | null, listingTypeId: number, loyaltyLevels?: Array<string> | null, minimumVolume: number, venueTypes?: Array<string> | null, targetProductCategory?: number | null } | null } | null, connectBid?: { __typename?: 'CommonBidConnectBidRelation', bidId: number, tenderId: number, matchBidId?: number | null, messageCount: number, tender?: { __typename?: 'CommonBidConnectBidRelationTenderRelation', id: number, userId: number, estimatedVolume: number, volumeUnits: number, unitType: string, venueId: number, isAnyWholesalerCompatible?: boolean | null, venue?: { __typename?: 'CommonBidConnectBidRelationTenderRelationVenueRelation', name?: string | null } | null } | null, matchBid?: { __typename?: 'CommonBidConnectBidRelationMatchBidRelation', bidId: number, venueCriteria?: { __typename?: 'CommonBidConnectBidRelationMatchBidRelationVenueCriteriaRelation', bidId: number, regions?: Array<string> | null, customerTypes?: Array<string> | null, listingTypeId: number, loyaltyLevels?: Array<string> | null, minimumVolume: number, venueTypes?: Array<string> | null, targetProductCategory?: number | null } | null } | null } | null } | null };

export type BidRatingFeedbackValueQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BidRatingFeedbackValueOrderBy>;
  where?: InputMaybe<BidRatingFeedbackValueFilters>;
}>;


export type BidRatingFeedbackValueQuery = { __typename?: 'Query', bidRatingFeedbackValue: Array<{ __typename?: 'BidRatingFeedbackValueSelectItem', id: number, bidId: number, ratingFeedbackValueId: number }> };

export type BrandDashboardCommonBidsQueryVariables = Exact<{
  pagination?: InputMaybe<OffsetPaginationInput>;
  orderBy?: InputMaybe<CommonBidSortingOptions>;
  orderDirection?: InputMaybe<SortDirectionEnum>;
  where?: InputMaybe<CommonBidsWithPaginationWhereInput>;
}>;


export type BrandDashboardCommonBidsQuery = { __typename?: 'Query', commonBidsWithPagination?: { __typename?: 'CommonBidsWithPagination', data: Array<{ __typename?: 'CommonBidSelectItem', id: number, status: CommonBidStatusEnum, type: CommonBidTypeEnum, region: CommonBidRegionEnum, connectBid?: { __typename?: 'CommonBidConnectBidRelation', bidId: number, tender?: { __typename?: 'CommonBidConnectBidRelationTenderRelation', id: number, name: string, unitType: string, volumeUnits: number, estimatedVolume: number, venue?: { __typename?: 'CommonBidConnectBidRelationTenderRelationVenueRelation', name?: string | null } | null } | null } | null, matchBid?: { __typename?: 'CommonBidMatchBidRelation', bidId: number } | null, product?: { __typename?: 'CommonBidProductRelation', bidId: number, volumeUnits: number, packagingType: string, productCategoryId: number, unitType: string, name: string, averageWholesalePrice: number, avatarBucketKey?: string | null, avatarUrl?: string | null, unitsPerCase: number, volumePerUnit: number } | null, supports: Array<{ __typename?: 'CommonBidSupportsRelation', amount: number, supportType: CommonBidSupportSupportTypeEnum, isProvided: boolean, isReceived: boolean }> }>, pageInfo: { __typename?: 'OffsetPagination', currentPage: number, totalPages: number, hasNextPage: boolean, hasPrevPage: boolean, totalCount: number } } | null };

export type WonConnectDealsFilterOptionsQueryVariables = Exact<{
  brandId: Scalars['NonNegativeInt']['input'];
}>;


export type WonConnectDealsFilterOptionsQuery = { __typename?: 'Query', wonConnectDealsFilterOptions: Array<{ __typename?: 'Filter', label: string, options: Array<{ __typename?: 'FilterOption', label: string, value: string }> }> };

export type ComputedSupportInfoFragment = { __typename?: 'ComputedSupport', listingFee: number, freeStock: number, retro: number, marketing: number, discount: number, total: number };

export type RequestEmailMutationVariables = Exact<{
  input: RequestEmailInput;
}>;


export type RequestEmailMutation = { __typename?: 'Mutation', requestEmail: boolean };

export type FileInfoFragment = { __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number };

export type S3FileInfoFragment = { __typename?: 'S3File', filename: string, bucketKey: string, downloadUrl: URL | string, fileSizeInKib: number };

export type GenerateUploadUrlsMutationVariables = Exact<{
  input: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GenerateUploadUrlsMutation = { __typename?: 'Mutation', generateUploadUrls: Array<{ __typename?: 'UploadUrlItem', filename: string, bucketKey: string, uploadUrl: string }> };

export type FilterOptionsFragment = { __typename?: 'Filter', label: string, type?: FilterOptionType | null, options: Array<{ __typename?: 'FilterOption', label: string, value: string }> };

export type LinkAccountWithExternalProviderMutationVariables = Exact<{
  input: LinkAccountWithExternalProviderInput;
}>;


export type LinkAccountWithExternalProviderMutation = { __typename?: 'Mutation', linkAccountWithExternalProvider: string };

export type UnlinkAccountWithExternalProviderMutationVariables = Exact<{
  input: UnlinkAccountWithExternalProviderInput;
}>;


export type UnlinkAccountWithExternalProviderMutation = { __typename?: 'Mutation', unlinkAccountWithExternalProvider: boolean };

export type IsJwtLinkTokenValidMutationVariables = Exact<{
  token: Scalars['String']['input'];
  integrationType: IntegrationType;
}>;


export type IsJwtLinkTokenValidMutation = { __typename?: 'Mutation', isJWTLinkTokenValid: boolean };

export type InvitationLinkItemFragment = { __typename?: 'InvitationLinkItem', id: string, email: string, createdById: number, expiresAt: string, acceptedById?: number | null, status: InvitationStatus };

export type VenueInvitationsQueryVariables = Exact<{
  venueId: Scalars['NonNegativeInt']['input'];
  status?: InputMaybe<InvitationStatus>;
}>;


export type VenueInvitationsQuery = { __typename?: 'Query', invitationsToVenue: Array<{ __typename?: 'InvitationLinkItem', id: string, email: string, createdById: number, expiresAt: string, acceptedById?: number | null, status: InvitationStatus }> };

export type BrandInvitationsQueryVariables = Exact<{
  brandId: Scalars['NonNegativeInt']['input'];
  status?: InputMaybe<InvitationStatus>;
}>;


export type BrandInvitationsQuery = { __typename?: 'Query', invitationsToBrand: Array<{ __typename?: 'InvitationLinkItem', id: string, email: string, createdById: number, expiresAt: string, acceptedById?: number | null, status: InvitationStatus }> };

export type InvitationLinkQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<InvitationLinkOrderBy>;
  where?: InputMaybe<InvitationLinkFilters>;
}>;


export type InvitationLinkQuery = { __typename?: 'Query', invitationLink?: { __typename?: 'InvitationLinkSelectItem', id: string, email: string, expiresAt: string, acceptedById?: number | null, status: InvitationStatus, venueId?: number | null, brandId?: number | null } | null };

export type InviteToBrandMutationVariables = Exact<{
  brandId: Scalars['NonNegativeInt']['input'];
  email: Scalars['EmailAddress']['input'];
  role: UserRole;
}>;


export type InviteToBrandMutation = { __typename?: 'Mutation', inviteToBrand?: { __typename?: 'InvitationLinkItem', id: string, email: string, createdById: number, expiresAt: string, acceptedById?: number | null, status: InvitationStatus } | null };

export type InviteToVenueMutationVariables = Exact<{
  venueId: Scalars['NonNegativeInt']['input'];
  email: Scalars['EmailAddress']['input'];
  role: UserRole;
}>;


export type InviteToVenueMutation = { __typename?: 'Mutation', inviteToVenue?: { __typename?: 'InvitationLinkItem', id: string, email: string, createdById: number, expiresAt: string, acceptedById?: number | null, status: InvitationStatus } | null };

export type RemoveInviteToBrandMutationVariables = Exact<{
  brandId: Scalars['NonNegativeInt']['input'];
  invitationId: Scalars['UUID']['input'];
}>;


export type RemoveInviteToBrandMutation = { __typename?: 'Mutation', removeInviteToBrand?: { __typename?: 'InvitationLinkItem', id: string, email: string, createdById: number, expiresAt: string, acceptedById?: number | null, status: InvitationStatus } | null };

export type RemoveInviteToVenueMutationVariables = Exact<{
  venueId: Scalars['NonNegativeInt']['input'];
  invitationId: Scalars['UUID']['input'];
}>;


export type RemoveInviteToVenueMutation = { __typename?: 'Mutation', removeInviteToVenue?: { __typename?: 'InvitationLinkItem', id: string, email: string, createdById: number, expiresAt: string, acceptedById?: number | null, status: InvitationStatus } | null };

export type AcceptInviteToBrandMutationVariables = Exact<{
  invitationId: Scalars['UUID']['input'];
}>;


export type AcceptInviteToBrandMutation = { __typename?: 'Mutation', acceptInviteToBrand?: { __typename?: 'InvitationLinkItem', id: string, email: string, createdById: number, expiresAt: string, acceptedById?: number | null, status: InvitationStatus } | null };

export type AcceptInviteToVenueMutationVariables = Exact<{
  invitationId: Scalars['UUID']['input'];
}>;


export type AcceptInviteToVenueMutation = { __typename?: 'Mutation', acceptInviteToVenue?: { __typename?: 'InvitationLinkItem', id: string, email: string, createdById: number, expiresAt: string, acceptedById?: number | null, status: InvitationStatus } | null };

export type InvitationLinkRegionQueryVariables = Exact<{
  invitationLinkId: Scalars['UUID']['input'];
}>;


export type InvitationLinkRegionQuery = { __typename?: 'Query', invitationLinkRegion: Region };

export type ListingTypeInfoFragment = { __typename?: 'ListingTypeSelectItem', id: number, name: string, suggestedTenderLengthInMonths: number, suggestedListingLengthInMonths: number, order: number };

export type ListingTypesQueryVariables = Exact<{
  region: Region;
}>;


export type ListingTypesQuery = { __typename?: 'Query', listingTypes: Array<{ __typename?: 'ListingTypeSelectItem', id: number, name: string, suggestedTenderLengthInMonths: number, suggestedListingLengthInMonths: number, order: number }> };

export type GetLiveStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLiveStatsQuery = { __typename?: 'Query', getLiveStats: { __typename?: 'LiveStats', activeTenders: number, activeBidGrossMerchandiseValue: number, matchBids: number } };

export type MatchBidInfoFragment = { __typename?: 'MatchBidSelectItem', bidId: number, credit?: boolean | null, maximumAcceptedDeals: number, product?: { __typename?: 'MatchBidProductRelation', bidId: number, productId: number, externalProductId?: string | null, externalProvider?: MatchBidProductExternalProviderEnum | null } | null, venueCriteria?: { __typename?: 'MatchBidVenueCriteriaRelation', bidId: number, regions?: Array<string> | null, customerTypes?: Array<string> | null, listingTypeId: number, loyaltyLevels?: Array<string> | null, minimumVolume: number, venueTypes?: Array<string> | null, targetProductCategory?: number | null } | null, commonBid?: { __typename?: 'MatchBidCommonBidRelation', id: number, status: CommonBidStatusEnum, otherSupportAndTerms?: string | null, brandId: number, region: CommonBidRegionEnum, supports: Array<{ __typename?: 'MatchBidCommonBidRelationSupportsRelation', amount: number, notes?: string | null, supportType: CommonBidSupportSupportTypeEnum }>, brand?: { __typename?: 'MatchBidCommonBidRelationBrandRelation', id: number, name?: string | null } | null, supportedWholesalers: Array<{ __typename?: 'MatchBidCommonBidRelationSupportedWholesalersRelation', wholesaler?: { __typename?: 'MatchBidCommonBidRelationSupportedWholesalersRelationWholesalerRelation', id: number, name: string } | null }>, product?: { __typename?: 'MatchBidCommonBidRelationProductRelation', bidId: number, name: string, productCategoryId: number, url?: string | null, packagingType: string, volumeUnits: number, averageWholesalePrice: number, unitType: string, unitsPerCase: number, volumePerUnit: number, avatarBucketKey?: string | null, avatarUrl?: string | null, isAnyWholesalerCompatible: boolean, isDirectSupplyCompatible: boolean, productTemplateId?: number | null, attachments?: Array<{ __typename?: 'S3File', filename: string, bucketKey: string, downloadUrl: URL | string, fileSizeInKib: number }> | null, productCategory?: { __typename?: 'MatchBidCommonBidRelationProductRelationProductCategoryRelation', id: number, localizationKey: string, parentCategory?: { __typename?: 'MatchBidCommonBidRelationProductRelationProductCategoryRelationParentCategoryRelation', id: number, localizationKey: string } | null } | null } | null } | null };

export type MatchBidFieldDataQueryVariables = Exact<{
  region: Region;
}>;


export type MatchBidFieldDataQuery = { __typename?: 'Query', listingTypes: Array<{ __typename?: 'ListingTypeSelectItem', id: number, name: string, suggestedListingLengthInMonths: number, order: number }>, venueCategories: Array<{ __typename?: 'VenueCategory', id: number, name: string, parentId?: number | null, localizationKey: string }>, venueLoyaltyLevels: Array<{ __typename?: 'VenueLoyaltyLevel', id: number, name: string }>, countryRegions: Array<{ __typename?: 'CountyRegion', id: number, name: string }>, customerTypes: Array<{ __typename?: 'CustomerType', id: number, name: string }> };

export type AddMatchBidMutationVariables = Exact<{
  input: MatchBidInsertInput;
}>;


export type AddMatchBidMutation = { __typename?: 'Mutation', insertIntoMatchBid?: { __typename?: 'MatchBidSelectItem', bidId: number, maximumAcceptedDeals: number, commonBid?: { __typename?: 'MatchBidCommonBidRelation', product?: { __typename?: 'MatchBidCommonBidRelationProductRelation', name: string, productCategoryId: number, attachments?: Array<{ __typename?: 'S3File', filename: string, bucketKey: string, downloadUrl: URL | string, fileSizeInKib: number }> | null } | null } | null } | null };

export type EditMatchBidMutationVariables = Exact<{
  id: Scalars['NonNegativeInt']['input'];
  set: MatchBidInsertInput;
}>;


export type EditMatchBidMutation = { __typename?: 'Mutation', editMatchBid?: { __typename?: 'MatchBidSelectItem', bidId: number, maximumAcceptedDeals: number, commonBid?: { __typename?: 'MatchBidCommonBidRelation', product?: { __typename?: 'MatchBidCommonBidRelationProductRelation', name: string, productCategoryId: number, attachments?: Array<{ __typename?: 'S3File', filename: string, bucketKey: string, downloadUrl: URL | string, fileSizeInKib: number }> | null } | null } | null } | null };

export type EndMatchBidMutationVariables = Exact<{
  id: Scalars['NonNegativeInt']['input'];
  brandId: Scalars['NonNegativeInt']['input'];
}>;


export type EndMatchBidMutation = { __typename?: 'Mutation', endMatchBidById: boolean };

export type AcceptMatchBidMutationVariables = Exact<{
  bidId: Scalars['NonNegativeInt']['input'];
  venueId: Scalars['NonNegativeInt']['input'];
  price: Scalars['Float']['input'];
}>;


export type AcceptMatchBidMutation = { __typename?: 'Mutation', acceptMatchBid: number };

export type MatchBidAcceptedDealsCountQueryVariables = Exact<{
  bidIds: Array<Scalars['NonNegativeInt']['input']> | Scalars['NonNegativeInt']['input'];
}>;


export type MatchBidAcceptedDealsCountQuery = { __typename?: 'Query', matchBidAcceptedDealsCount: Array<{ __typename?: 'MatchBidAcceptedDealsCountItem', count: number, bidId: number }> };

export type MatchBidQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MatchBidOrderBy>;
  where?: InputMaybe<MatchBidFilters>;
}>;


export type MatchBidQuery = { __typename?: 'Query', matchBid?: { __typename?: 'MatchBidSelectItem', bidId: number, credit?: boolean | null, maximumAcceptedDeals: number, product?: { __typename?: 'MatchBidProductRelation', bidId: number, productId: number, externalProductId?: string | null, externalProvider?: MatchBidProductExternalProviderEnum | null } | null, venueCriteria?: { __typename?: 'MatchBidVenueCriteriaRelation', bidId: number, regions?: Array<string> | null, customerTypes?: Array<string> | null, listingTypeId: number, loyaltyLevels?: Array<string> | null, minimumVolume: number, venueTypes?: Array<string> | null, targetProductCategory?: number | null } | null, commonBid?: { __typename?: 'MatchBidCommonBidRelation', id: number, status: CommonBidStatusEnum, otherSupportAndTerms?: string | null, brandId: number, region: CommonBidRegionEnum, supports: Array<{ __typename?: 'MatchBidCommonBidRelationSupportsRelation', amount: number, notes?: string | null, supportType: CommonBidSupportSupportTypeEnum }>, brand?: { __typename?: 'MatchBidCommonBidRelationBrandRelation', id: number, name?: string | null } | null, supportedWholesalers: Array<{ __typename?: 'MatchBidCommonBidRelationSupportedWholesalersRelation', wholesaler?: { __typename?: 'MatchBidCommonBidRelationSupportedWholesalersRelationWholesalerRelation', id: number, name: string } | null }>, product?: { __typename?: 'MatchBidCommonBidRelationProductRelation', bidId: number, name: string, productCategoryId: number, url?: string | null, packagingType: string, volumeUnits: number, averageWholesalePrice: number, unitType: string, unitsPerCase: number, volumePerUnit: number, avatarBucketKey?: string | null, avatarUrl?: string | null, isAnyWholesalerCompatible: boolean, isDirectSupplyCompatible: boolean, productTemplateId?: number | null, attachments?: Array<{ __typename?: 'S3File', filename: string, bucketKey: string, downloadUrl: URL | string, fileSizeInKib: number }> | null, productCategory?: { __typename?: 'MatchBidCommonBidRelationProductRelationProductCategoryRelation', id: number, localizationKey: string, parentCategory?: { __typename?: 'MatchBidCommonBidRelationProductRelationProductCategoryRelationParentCategoryRelation', id: number, localizationKey: string } | null } | null } | null } | null } | null };

export type MatchBidsWithPaginationQueryVariables = Exact<{
  pagination?: InputMaybe<OffsetPaginationInput>;
  orderBy?: InputMaybe<CommonBidSortingOptions>;
  orderDirection?: InputMaybe<SortDirectionEnum>;
  where?: InputMaybe<CommonBidsWithPaginationWhereInput>;
  region: Region;
}>;


export type MatchBidsWithPaginationQuery = { __typename?: 'Query', commonBidsWithPagination?: { __typename?: 'CommonBidsWithPagination', data: Array<{ __typename?: 'CommonBidSelectItem', id: number, status: CommonBidStatusEnum, matchBid?: { __typename?: 'CommonBidMatchBidRelation', bidId: number, maximumAcceptedDeals: number, venueCriteria?: { __typename?: 'CommonBidMatchBidRelationVenueCriteriaRelation', bidId: number, regions?: Array<string> | null, customerTypes?: Array<string> | null, listingTypeId: number, loyaltyLevels?: Array<string> | null, minimumVolume: number, venueTypes?: Array<string> | null, targetProductCategory?: number | null } | null } | null, product?: { __typename?: 'CommonBidProductRelation', bidId: number, name: string, avatarBucketKey?: string | null, avatarUrl?: string | null } | null }>, pageInfo: { __typename?: 'OffsetPagination', currentPage: number, totalPages: number, hasNextPage: boolean, hasPrevPage: boolean, totalCount: number } } | null, matchBidFilterOptions: Array<{ __typename?: 'Filter', label: string, type?: FilterOptionType | null, options: Array<{ __typename?: 'FilterOption', label: string, value: string }> }>, listingTypes: Array<{ __typename?: 'ListingTypeSelectItem', id: number, name: string }>, venueCategories: Array<{ __typename?: 'VenueCategory', id: number, name: string, parentId?: number | null, localizationKey: string }>, venueLoyaltyLevels: Array<{ __typename?: 'VenueLoyaltyLevel', id: number, name: string }>, countryRegions: Array<{ __typename?: 'CountyRegion', id: number, name: string }>, customerTypes: Array<{ __typename?: 'CustomerType', id: number, name: string }> };

export type MatchBidTargetedVenuesByVenueCriteriaQueryVariables = Exact<{
  input: TargetedVenuesByVenueCriteriaInput;
}>;


export type MatchBidTargetedVenuesByVenueCriteriaQuery = { __typename?: 'Query', targetedVenuesByVenueCriteria?: { __typename?: 'TargetedVenuesByVenueCriteria', mainCategoryVolume?: number | null, detailedCategoryVolume?: number | null, targetCustomers?: number | null, averageVolumePerListing?: number | null } | null };

export type MatchDashboardOverviewByBrandIdQueryVariables = Exact<{
  brandId: Scalars['NonNegativeInt']['input'];
}>;


export type MatchDashboardOverviewByBrandIdQuery = { __typename?: 'Query', matchDashboardOverviewByBrandId: { __typename?: 'MatchDashboardOverview', status: MatchDashboardCacheStatus, generatedAtUtc?: string | null, hasMatchBids: boolean, match: { __typename?: 'MatchDashboardOverviewMatch', winsCount: number, customersCount: number, winsLastMonthCount: number, portfolioCoveragePercentage: number, portfolioCoverageUsedCount: number, portfolioCoverageUnusedCount: number, bidSetupAllRegionsPercentage: number, bidSetupAllVenueTypesPercentage: number, bidSetupAllCustomerTypesPercentage: number, bidSetupZeroMinVolumePercentage: number, recommendedActionsText: string, performanceCommentaryText: string, topCategories: Array<{ __typename?: 'MatchDashboardOverviewCategory', productCategoryId: number, productCategoryLocalizationKey: string, totalProductsCount: number, productsWithBidsCount: number, portfolioParticipationPercentage: number, matchWinsCount: number, shareOfTotalWinsPercentage: number, winningDiscountPercentage?: number | null }>, weeklyPerformance: Array<{ __typename?: 'MatchDashboardWeeklyPerformancePoint', weekLabel: string, dealsAcceptedCount: number, salesAmount: number }> } } };

export type MatchDashboardConnectStatsByBrandIdQueryVariables = Exact<{
  brandId: Scalars['NonNegativeInt']['input'];
}>;


export type MatchDashboardConnectStatsByBrandIdQuery = { __typename?: 'Query', matchDashboardConnectStatsByBrandId: { __typename?: 'MatchDashboardOverviewConnect', winsCount: number, customersCount: number, winsLastMonthCount: number, estimatedSales: number } };

export type MatchTargetCriteriaByBrandIdQueryVariables = Exact<{
  brandId: Scalars['NonNegativeInt']['input'];
}>;


export type MatchTargetCriteriaByBrandIdQuery = { __typename?: 'Query', matchTargetCriteriaByBrandId: { __typename?: 'MatchTargetCriteria', regions: { __typename?: 'MatchTargetCriteriaMetric', percentageTargetingAll: number, meetsRecommendedThreshold: boolean }, customerTypes: { __typename?: 'MatchTargetCriteriaMetric', percentageTargetingAll: number, meetsRecommendedThreshold: boolean }, venueTypes: { __typename?: 'MatchTargetCriteriaMetric', percentageTargetingAll: number, meetsRecommendedThreshold: boolean }, loyaltyLevels: { __typename?: 'MatchTargetCriteriaMetric', percentageTargetingAll: number, meetsRecommendedThreshold: boolean }, minimumVolume: { __typename?: 'MatchTargetCriteriaMetric', percentageTargetingAll: number, meetsRecommendedThreshold: boolean }, listingTypes: Array<{ __typename?: 'MatchTargetCriteriaListingTypeMetric', listingTypeLocalizationKey: string, percentageTargetingAll: number, meetsRecommendedThreshold: boolean }> } };

export type MatchDealTrackingByBrandQueryVariables = Exact<{
  brandId: Scalars['NonNegativeInt']['input'];
  limit: Scalars['NonNegativeInt']['input'];
  offset: Scalars['NonNegativeInt']['input'];
  bidIds?: InputMaybe<Array<Scalars['NonNegativeInt']['input']> | Scalars['NonNegativeInt']['input']>;
  venueIds?: InputMaybe<Array<Scalars['NonNegativeInt']['input']> | Scalars['NonNegativeInt']['input']>;
  productTemplateIds?: InputMaybe<Array<Scalars['NonNegativeInt']['input']> | Scalars['NonNegativeInt']['input']>;
  listingTypeLocalizationKeys?: InputMaybe<Array<Scalars['NonEmptyString']['input']> | Scalars['NonEmptyString']['input']>;
  productCategoryLocalizationKeys?: InputMaybe<Array<Scalars['NonEmptyString']['input']> | Scalars['NonEmptyString']['input']>;
}>;


export type MatchDealTrackingByBrandQuery = { __typename?: 'Query', matchDealTrackingByBrand: { __typename?: 'MatchDealTrackingConnection', highlights: { __typename?: 'MatchDealTrackingHighlights', winsCount: number, customersPurchasedCount: number, totalSales: number, totalUnitsPurchased: number }, data: Array<{ __typename?: 'MatchDealTrackingItem', id: number, bidId: number, venueId: number, acceptedAtUtc: string, listingEndsAtUtc: string, customerName: string, customerEmail?: string | null, customerPhoneNumber?: string | null, productName: string, productCategoryLocalizationKey?: string | null, listingTypeLocalizationKey: string, unitsPurchased: number, salesAmount: number, unitPrice: number, unitsPurchasedSinceAccepted?: number | null, totalSupport: number, supports: Array<{ __typename?: 'CommonBidSupportItem', supportType: CommonBidSupportSupportTypeEnum, amount: number }> }>, pageInfo: { __typename?: 'OffsetPagination', currentPage: number, totalPages: number, hasNextPage: boolean, hasPrevPage: boolean, totalCount: number } } };

export type MatchDealTrackingFilterOptionsQueryVariables = Exact<{
  brandId: Scalars['NonNegativeInt']['input'];
}>;


export type MatchDealTrackingFilterOptionsQuery = { __typename?: 'Query', matchDealTrackingFilterOptions: Array<{ __typename?: 'Filter', label: string, options: Array<{ __typename?: 'FilterOption', label: string, value: string }> }> };

export type MatchDealTrackingBidPdfQueryVariables = Exact<{
  bidId: Scalars['NonNegativeInt']['input'];
  venueId: Scalars['NonNegativeInt']['input'];
}>;


export type MatchDealTrackingBidPdfQuery = { __typename?: 'Query', matchBidVenuePdf: { __typename?: 'MatchBidVenuePdfAttachment', filename: string, content: string } };

export type MatchDashboardOverviewPdfQueryVariables = Exact<{
  brandId: Scalars['NonNegativeInt']['input'];
}>;


export type MatchDashboardOverviewPdfQuery = { __typename?: 'Query', matchDashboardOverviewPdf: { __typename?: 'MatchDashboardOverviewPdfResult', filename: string, content: string } };

export type MessageInfoFragment = { __typename?: 'Message', id: number, bidId: number, venueId?: number | null, brandId?: number | null, text: string, createdAtUtc: string, updatedAtUtc?: string | null };

export type MessagesByBidIdQueryVariables = Exact<{
  bidId: Scalars['Int']['input'];
}>;


export type MessagesByBidIdQuery = { __typename?: 'Query', messagesByBidId: Array<{ __typename?: 'Message', id: number, bidId: number, venueId?: number | null, brandId?: number | null, text: string, createdAtUtc: string, updatedAtUtc?: string | null, venue?: { __typename?: 'Venue', id: number, name?: string | null } | null, brand?: { __typename?: 'Brand', id: number, name?: string | null } | null }> };

export type AddMessageMutationVariables = Exact<{
  input: AddMessageInput;
}>;


export type AddMessageMutation = { __typename?: 'Mutation', addMessage: Array<{ __typename?: 'Message', id: number, bidId: number, venueId?: number | null, brandId?: number | null, text: string, createdAtUtc: string, updatedAtUtc?: string | null }> };

export type NotificationInfoFragment = { __typename?: 'Notification', id: number, category: NotificationCategory, createdAtUtc: string, isRead: boolean, type: NotificationType, toId: number, toType: NotificationTargetType, bidId?: number | null, tenderId?: number | null, bid?: { __typename?: 'Bid', id: number, commonBidId?: number | null, brandId: number, messagesCount?: number | null, avatarUrl?: string | null, productName?: string | null } | null, message?: { __typename?: 'Message', text: string } | null, brand?: { __typename?: 'Brand', name?: string | null, avatarUrl?: string | null, region: Region, subscriptionTier: SubscriptionTier } | null, venue?: { __typename?: 'Venue', name?: string | null, avatarUrl?: string | null } | null, tender?: { __typename?: 'Tender', name: string, listingEndsAtUtc?: string | null } | null };

export type MarkNotificationAsReadMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type MarkNotificationAsReadMutation = { __typename?: 'Mutation', markNotificationAsRead: { __typename?: 'Notification', id: number, category: NotificationCategory, createdAtUtc: string, isRead: boolean, type: NotificationType, toId: number, toType: NotificationTargetType, bidId?: number | null, tenderId?: number | null, bid?: { __typename?: 'Bid', id: number, commonBidId?: number | null, brandId: number, messagesCount?: number | null, avatarUrl?: string | null, productName?: string | null } | null, message?: { __typename?: 'Message', text: string } | null, brand?: { __typename?: 'Brand', name?: string | null, avatarUrl?: string | null, region: Region, subscriptionTier: SubscriptionTier } | null, venue?: { __typename?: 'Venue', name?: string | null, avatarUrl?: string | null } | null, tender?: { __typename?: 'Tender', name: string, listingEndsAtUtc?: string | null } | null } };

export type MarkAllNotificationsAsReadMutationVariables = Exact<{
  input: MarkAllNotificationsAsReadInput;
}>;


export type MarkAllNotificationsAsReadMutation = { __typename?: 'Mutation', markAllNotificationsAsRead: Array<{ __typename?: 'Notification', id: number, category: NotificationCategory, createdAtUtc: string, isRead: boolean, type: NotificationType, toId: number, toType: NotificationTargetType, bidId?: number | null, tenderId?: number | null, bid?: { __typename?: 'Bid', id: number, commonBidId?: number | null, brandId: number, messagesCount?: number | null, avatarUrl?: string | null, productName?: string | null } | null, message?: { __typename?: 'Message', text: string } | null, brand?: { __typename?: 'Brand', name?: string | null, avatarUrl?: string | null, region: Region, subscriptionTier: SubscriptionTier } | null, venue?: { __typename?: 'Venue', name?: string | null, avatarUrl?: string | null } | null, tender?: { __typename?: 'Tender', name: string, listingEndsAtUtc?: string | null } | null }> };

export type CursorNotificationsQueryVariables = Exact<{
  input: CursorNotificationsInput;
}>;


export type CursorNotificationsQuery = { __typename?: 'Query', cursorNotifications: { __typename?: 'CursorNotifications', totalCount: number, unreadTotalCount: number, edges: Array<{ __typename?: 'NotificationEdge', cursor: string, node: { __typename?: 'Notification', id: number, category: NotificationCategory, createdAtUtc: string, isRead: boolean, type: NotificationType, toId: number, toType: NotificationTargetType, bidId?: number | null, tenderId?: number | null, bid?: { __typename?: 'Bid', id: number, commonBidId?: number | null, brandId: number, messagesCount?: number | null, avatarUrl?: string | null, productName?: string | null } | null, message?: { __typename?: 'Message', text: string } | null, brand?: { __typename?: 'Brand', name?: string | null, avatarUrl?: string | null, region: Region, subscriptionTier: SubscriptionTier } | null, venue?: { __typename?: 'Venue', name?: string | null, avatarUrl?: string | null } | null, tender?: { __typename?: 'Tender', name: string, listingEndsAtUtc?: string | null } | null } }>, pageInfo: { __typename?: 'CursorPageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type OffsetNotificationsQueryVariables = Exact<{
  input: OffsetNotificationsInput;
}>;


export type OffsetNotificationsQuery = { __typename?: 'Query', offsetNotifications: { __typename?: 'OffsetNotifications', totalCount: number, unreadTotalCount: number, data: Array<{ __typename?: 'Notification', id: number, category: NotificationCategory, createdAtUtc: string, isRead: boolean, type: NotificationType, toId: number, toType: NotificationTargetType, bidId?: number | null, tenderId?: number | null, bid?: { __typename?: 'Bid', id: number, commonBidId?: number | null, brandId: number, messagesCount?: number | null, avatarUrl?: string | null, productName?: string | null } | null, message?: { __typename?: 'Message', text: string } | null, brand?: { __typename?: 'Brand', name?: string | null, avatarUrl?: string | null, region: Region, subscriptionTier: SubscriptionTier } | null, venue?: { __typename?: 'Venue', name?: string | null, avatarUrl?: string | null } | null, tender?: { __typename?: 'Tender', name: string, listingEndsAtUtc?: string | null } | null }>, pageInfo: { __typename?: 'OffsetPageInfo', currentPage: number, totalPages: number, hasNextPage: boolean, hasPrevPage: boolean } } };

export type ProductCategoryInfoFragment = { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null };

export type MainProductCategoryInfoFragment = { __typename?: 'MainProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null, subCategories: Array<{ __typename?: 'ProductCategoryItem', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null }> };

export type ProductCategoryTreeInfoFragment = { __typename?: 'TopProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, defaultVolume?: number | null, defaultPackagingType?: string | null, isPublished: boolean, subCategories: Array<{ __typename?: 'MainProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null, subCategories: Array<{ __typename?: 'ProductCategoryItem', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null }> }> };

export type ProductCategoryTreeQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductCategoryTreeQuery = { __typename?: 'Query', productCategoriesTree: Array<{ __typename?: 'TopProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, defaultVolume?: number | null, defaultPackagingType?: string | null, isPublished: boolean, subCategories: Array<{ __typename?: 'MainProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null, subCategories: Array<{ __typename?: 'ProductCategoryItem', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null }> }> }> };

export type TopLevelProductCategoryByIdQueryVariables = Exact<{
  productCategoryId: Scalars['NonNegativeInt']['input'];
}>;


export type TopLevelProductCategoryByIdQuery = { __typename?: 'Query', topLevelProductCategoryById?: { __typename?: 'TopLevelProductCategoryById', id: number, localizationKey: string } | null };

export type ProductCategoriesByIdsQueryVariables = Exact<{
  productCategoryIds: Array<Scalars['NonNegativeInt']['input']> | Scalars['NonNegativeInt']['input'];
}>;


export type ProductCategoriesByIdsQuery = { __typename?: 'Query', productCategoriesByIds: Array<{ __typename?: 'ProductCategory', id: number, localizationKey: string }> };

export type ProductTemplateInfoFragment = { __typename?: 'ProductTemplate', id: number, brandId: number, productCategoryId: number, productName: string, volumeUnits: number, volumePerUnit: number, unitsPerCase: number, averageWholesalePrice: number, status: ProductTemplateStatusEnum, productUrl?: string | null, externalProductId?: string | null, avatarUrl?: string | null, avatarBucketKey?: string | null, packagingType: string, unitType: string, isDirectSupplyCompatible: boolean, isAnyWholesalerCompatible: boolean, externalProvider?: IntegrationType | null, hasEditablePrice: boolean, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }>, brand: { __typename?: 'Brand', id: number, name?: string | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, isAnonymousBidAllowed?: boolean | null, vatNumber?: string | null, vatCompanyName?: string | null, vatCountryCode?: string | null, vatConsultationNumber?: string | null, vatProcessingDate?: string | null, complianceCheckDate?: string | null, complianceNextDate?: string | null, complianceRiskLevel?: string | null, complianceConfirmation?: string | null, billingName?: string | null, isEnterpriseSubscriptionRequestSent: boolean, subscriptionTier: SubscriptionTier, successFee: number, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, failedPaymentIntentCounter: number, region: Region, canSeeOtherBids: boolean, tradingName?: string | null, addressId?: number | null, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null }>, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, tradingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, users: Array<{ __typename?: 'CompanyUser', userId: number, role: string }>, billingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null }, productCategory: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null } };

export type ProductTemplatesByBrandIdQueryVariables = Exact<{
  input: ProductTemplatesByBrandIdInput;
}>;


export type ProductTemplatesByBrandIdQuery = { __typename?: 'Query', productTemplatesByBrandId: Array<{ __typename?: 'ProductTemplate', id: number, brandId: number, productCategoryId: number, productName: string, volumeUnits: number, volumePerUnit: number, unitsPerCase: number, averageWholesalePrice: number, status: ProductTemplateStatusEnum, productUrl?: string | null, externalProductId?: string | null, avatarUrl?: string | null, avatarBucketKey?: string | null, packagingType: string, unitType: string, isDirectSupplyCompatible: boolean, isAnyWholesalerCompatible: boolean, externalProvider?: IntegrationType | null, hasEditablePrice: boolean, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }>, brand: { __typename?: 'Brand', id: number, name?: string | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, isAnonymousBidAllowed?: boolean | null, vatNumber?: string | null, vatCompanyName?: string | null, vatCountryCode?: string | null, vatConsultationNumber?: string | null, vatProcessingDate?: string | null, complianceCheckDate?: string | null, complianceNextDate?: string | null, complianceRiskLevel?: string | null, complianceConfirmation?: string | null, billingName?: string | null, isEnterpriseSubscriptionRequestSent: boolean, subscriptionTier: SubscriptionTier, successFee: number, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, failedPaymentIntentCounter: number, region: Region, canSeeOtherBids: boolean, tradingName?: string | null, addressId?: number | null, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null }>, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, tradingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, users: Array<{ __typename?: 'CompanyUser', userId: number, role: string }>, billingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null }, productCategory: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null } }> };

export type DeleteProductTemplateByIdMutationVariables = Exact<{
  input: DeleteProductTemplateInput;
}>;


export type DeleteProductTemplateByIdMutation = { __typename?: 'Mutation', deleteProductTemplateById: boolean };

export type AddProductTemplateMutationVariables = Exact<{
  input: AddProductTemplateInput;
}>;


export type AddProductTemplateMutation = { __typename?: 'Mutation', addProductTemplate: { __typename?: 'ProductTemplate', id: number, brandId: number, productCategoryId: number, productName: string, volumeUnits: number, volumePerUnit: number, unitsPerCase: number, averageWholesalePrice: number, status: ProductTemplateStatusEnum, productUrl?: string | null, externalProductId?: string | null, avatarUrl?: string | null, avatarBucketKey?: string | null, packagingType: string, unitType: string, isDirectSupplyCompatible: boolean, isAnyWholesalerCompatible: boolean, externalProvider?: IntegrationType | null, hasEditablePrice: boolean, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }>, brand: { __typename?: 'Brand', id: number, name?: string | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, isAnonymousBidAllowed?: boolean | null, vatNumber?: string | null, vatCompanyName?: string | null, vatCountryCode?: string | null, vatConsultationNumber?: string | null, vatProcessingDate?: string | null, complianceCheckDate?: string | null, complianceNextDate?: string | null, complianceRiskLevel?: string | null, complianceConfirmation?: string | null, billingName?: string | null, isEnterpriseSubscriptionRequestSent: boolean, subscriptionTier: SubscriptionTier, successFee: number, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, failedPaymentIntentCounter: number, region: Region, canSeeOtherBids: boolean, tradingName?: string | null, addressId?: number | null, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null }>, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, tradingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, users: Array<{ __typename?: 'CompanyUser', userId: number, role: string }>, billingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null }, productCategory: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null } } };

export type EditProductTemplateMutationVariables = Exact<{
  input: EditProductTemplateInput;
}>;


export type EditProductTemplateMutation = { __typename?: 'Mutation', editProductTemplate: { __typename?: 'ProductTemplate', id: number, brandId: number, productCategoryId: number, productName: string, volumeUnits: number, volumePerUnit: number, unitsPerCase: number, averageWholesalePrice: number, status: ProductTemplateStatusEnum, productUrl?: string | null, externalProductId?: string | null, avatarUrl?: string | null, avatarBucketKey?: string | null, packagingType: string, unitType: string, isDirectSupplyCompatible: boolean, isAnyWholesalerCompatible: boolean, externalProvider?: IntegrationType | null, hasEditablePrice: boolean, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }>, brand: { __typename?: 'Brand', id: number, name?: string | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, isAnonymousBidAllowed?: boolean | null, vatNumber?: string | null, vatCompanyName?: string | null, vatCountryCode?: string | null, vatConsultationNumber?: string | null, vatProcessingDate?: string | null, complianceCheckDate?: string | null, complianceNextDate?: string | null, complianceRiskLevel?: string | null, complianceConfirmation?: string | null, billingName?: string | null, isEnterpriseSubscriptionRequestSent: boolean, subscriptionTier: SubscriptionTier, successFee: number, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, failedPaymentIntentCounter: number, region: Region, canSeeOtherBids: boolean, tradingName?: string | null, addressId?: number | null, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null }>, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, tradingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, users: Array<{ __typename?: 'CompanyUser', userId: number, role: string }>, billingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null }, productCategory: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null } } };

export type ProductUnitQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductUnitQuery = { __typename?: 'Query', productUnits: Array<string> };

export type ProductPackagingQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductPackagingQuery = { __typename?: 'Query', productPackaging: Array<string> };

export type ExternalProductLivePriceQueryVariables = Exact<{
  brandId: Scalars['NonNegativeInt']['input'];
  venueId: Scalars['NonNegativeInt']['input'];
  productTemplateId: Scalars['NonNegativeInt']['input'];
}>;


export type ExternalProductLivePriceQuery = { __typename?: 'Query', externalProductLivePrice?: { __typename?: 'ExternalProductLivePriceType', externalProductId: number, price: number, casePrice?: number | null, basePrice?: number | null, baseCasePrice?: number | null } | null };

export type RegisteredCompanyWithoutIdInfoFragment = { __typename?: 'RegisteredCompanyWithoutId', name: string, number: string, status: string, dateOfCreation: string, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress: string };

export type RegisteredCompanyInfoFragment = { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null };

export type GetDataFromCompanyNumberQueryVariables = Exact<{
  input: GetDataFromCompanyNumberInput;
}>;


export type GetDataFromCompanyNumberQuery = { __typename?: 'Query', getDataFromCompanyNumber: { __typename?: 'RegisteredCompanyWithoutId', name: string, number: string, status: string, dateOfCreation: string, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress: string } };

export type SubscriptionInfoFragment = { __typename?: 'Subscription', id: string, brandId: number, customerId: string, createdAtUtc: number, currentPeriodEnd: number, currentPeriodStart: number, isCanceled: boolean, isExpired: boolean, amount?: number | null, subscriptionTier?: SubscriptionTier | null, successFee?: number | null, interval?: SubscriptionInterval | null };

export type UpgradeToBespokeDataInfoFragment = { __typename?: 'UpgradeToBespokeData', wasSuccessfullyUpdated: boolean, needsRedirect: boolean, redirectUrl?: string | null };

export type InvoiceInfoFragment = { __typename?: 'Invoice', id: string, total: number, createdAt: number, customerId?: string | null, pdfUrl?: string | null, status?: string | null, hostedInvoiceUrl?: string | null };

export type SuccessFeeInvoiceInfoFragment = { __typename?: 'SuccessFeeInvoice', id: string, total: number, createdAt: number, customerId: string, paymentUrl: string, status: string, pdfUrl: string };

export type SuccessFeeInvoiceListItemInfoFragment = { __typename?: 'SuccessFeeInvoiceListItem', id: string, tenderName: string, venueName: string, total: number, createdAt: number, customerId: string, paymentUrl: string, status: string, pdfUrl: string, bidUnitType: string, packagingType: string, tenderUnitType: string, successFee: number, bidVolumeUnits: number, estimatedVolume: number, tenderVolumeUnits: number, averageWholesaleBidPrice: number };

export type BespokeCheckDataInfoFragment = { __typename?: 'BespokeCheckData', successFee: number, pricePerMonth: number };

export type CreateStripeCheckoutMutationVariables = Exact<{
  input: CreateStripeCheckoutInput;
}>;


export type CreateStripeCheckoutMutation = { __typename?: 'Mutation', createStripeCheckout: string };

export type UpdateSubscriptionMutationVariables = Exact<{
  input: UpdateSubscriptionInput;
}>;


export type UpdateSubscriptionMutation = { __typename?: 'Mutation', updateSubscription: boolean };

export type SubscriptionQueryVariables = Exact<{
  stripeSubscriptionId: Scalars['String']['input'];
  brandId: Scalars['NonNegativeInt']['input'];
}>;


export type SubscriptionQuery = { __typename?: 'Query', subscription: { __typename?: 'Subscription', id: string, brandId: number, customerId: string, createdAtUtc: number, currentPeriodEnd: number, currentPeriodStart: number, isCanceled: boolean, isExpired: boolean, amount?: number | null, subscriptionTier?: SubscriptionTier | null, successFee?: number | null, interval?: SubscriptionInterval | null } };

export type InvoicesQueryVariables = Exact<{
  stripeCustomerId: Scalars['String']['input'];
}>;


export type InvoicesQuery = { __typename?: 'Query', invoices: Array<{ __typename?: 'Invoice', id: string, total: number, createdAt: number, customerId?: string | null, pdfUrl?: string | null, status?: string | null, hostedInvoiceUrl?: string | null }> };

export type SuccessFeeInvoiceListQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type SuccessFeeInvoiceListQuery = { __typename?: 'Query', successFeeInvoiceList: Array<{ __typename?: 'SuccessFeeInvoiceListItem', id: string, tenderName: string, venueName: string, total: number, createdAt: number, customerId: string, paymentUrl: string, status: string, pdfUrl: string, bidUnitType: string, packagingType: string, tenderUnitType: string, successFee: number, bidVolumeUnits: number, estimatedVolume: number, tenderVolumeUnits: number, averageWholesaleBidPrice: number }> };

export type SuccessFeeInvoiceByIdQueryVariables = Exact<{
  invoiceId: Scalars['String']['input'];
}>;


export type SuccessFeeInvoiceByIdQuery = { __typename?: 'Query', successFeeInvoiceById: { __typename?: 'SuccessFeeInvoice', id: string, total: number, createdAt: number, customerId: string, paymentUrl: string, status: string, pdfUrl: string } };

export type BespokeTokenCheckQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type BespokeTokenCheckQuery = { __typename?: 'Query', bespokeTokenCheck: { __typename?: 'BespokeCheckData', successFee: number, pricePerMonth: number } };

export type CanCreateBidQueryVariables = Exact<{
  brandId: Scalars['NonNegativeInt']['input'];
}>;


export type CanCreateBidQuery = { __typename?: 'Query', canCreateBid: boolean };

export type HasActiveSubscriptionQueryVariables = Exact<{
  brandId: Scalars['NonNegativeInt']['input'];
}>;


export type HasActiveSubscriptionQuery = { __typename?: 'Query', hasActiveSubscription: { __typename?: 'HasActiveSubscriptionData', value?: boolean | null, brandId: number } };

export type UpgradeToBespokeMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type UpgradeToBespokeMutation = { __typename?: 'Mutation', upgradeToBespoke: { __typename?: 'UpgradeToBespokeData', wasSuccessfullyUpdated: boolean, needsRedirect: boolean, redirectUrl?: string | null } };

export type TenderInfoFragment = { __typename?: 'Tender', id: number, userId: number, venueId: number, name: string, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, listingTypeId: number, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, tenderDetails?: string | null, status: TenderStatus, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock?: TenderSupportOption | null, supportsDiscount?: TenderSupportOption | null, supportsListingFee?: TenderSupportOption | null, supportsPosBudget?: TenderSupportOption | null, supportsRetroDiscount?: TenderSupportOption | null, supportDetails?: string | null, totalReceivedBids: number, createdAtUtc?: string | null, updatedAtUtc?: string | null, receivedSupportStatus?: TenderSupportStatus | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, feedback?: string | null, region: Region, isPrivate: boolean };

export type TenderByIdQueryVariables = Exact<{
  tenderId: Scalars['NonNegativeInt']['input'];
}>;


export type TenderByIdQuery = { __typename?: 'Query', tenderById: { __typename?: 'Tender', listingTypeId: number, totalReceivedBids: number, id: number, userId: number, venueId: number, name: string, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, tenderDetails?: string | null, status: TenderStatus, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock?: TenderSupportOption | null, supportsDiscount?: TenderSupportOption | null, supportsListingFee?: TenderSupportOption | null, supportsPosBudget?: TenderSupportOption | null, supportsRetroDiscount?: TenderSupportOption | null, supportDetails?: string | null, createdAtUtc?: string | null, updatedAtUtc?: string | null, receivedSupportStatus?: TenderSupportStatus | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, feedback?: string | null, region: Region, isPrivate: boolean, venue: { __typename?: 'Venue', id: number, name?: string | null, venueCategoryName?: string | null, venueCategoryId?: number | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, requiresParamountLiquorIntegration: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, billingName?: string | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsDiscount: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> }, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, users: Array<{ __typename?: 'CompanyUser', userId: number, role: string }>, billingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null }, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null }>, listingType: { __typename?: 'ListingTypeSelectItem', id: number, name: string, suggestedTenderLengthInMonths: number, suggestedListingLengthInMonths: number, order: number }, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null, user?: { __typename?: 'User', id: number, firebaseId: string, userType: UserType, email: string, isSalesDemo?: boolean | null, region: Region, status: UserStatus, contactName?: string | null, phoneNumber?: string | null } | null } };

export type TenderTemplateByTenderIdQueryVariables = Exact<{
  tenderId: Scalars['NonNegativeInt']['input'];
}>;


export type TenderTemplateByTenderIdQuery = { __typename?: 'Query', tenderById: { __typename?: 'Tender', venueId: number, listingTypeId: number, tenderDetails?: string | null, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock?: TenderSupportOption | null, supportsListingFee?: TenderSupportOption | null, supportsPosBudget?: TenderSupportOption | null, supportsRetroDiscount?: TenderSupportOption | null, supportDetails?: string | null, userId: number, packagingType?: string | null, unitType?: string | null, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, isPrivate: boolean, region: Region, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null }>, listingType: { __typename?: 'ListingTypeSelectItem', id: number, name: string, suggestedTenderLengthInMonths: number, suggestedListingLengthInMonths: number, order: number }, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null } };

export type VenueDashboardTendersQueryVariables = Exact<{
  input: VenueDashboardTendersInput;
}>;


export type VenueDashboardTendersQuery = { __typename?: 'Query', venueDashboardTenders: { __typename?: 'UnionTenders', totalCount: number, data: Array<{ __typename: 'Tender', id: number, status: TenderStatus, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, name: string, estimatedVolume?: number | null, volumeUnits?: number | null, totalReceivedBids: number, receivedSupportStatus?: TenderSupportStatus | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, region: Region, venue: { __typename?: 'Venue', id: number, name?: string | null, venueCategoryName?: string | null, venueCategoryId?: number | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, requiresParamountLiquorIntegration: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, billingName?: string | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsDiscount: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> }, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, users: Array<{ __typename?: 'CompanyUser', userId: number, role: string }>, billingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null }, listingType: { __typename?: 'ListingTypeSelectItem', id: number, name: string, suggestedTenderLengthInMonths: number, suggestedListingLengthInMonths: number, order: number }, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null }> } | { __typename: 'TenderDraft', id: number, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, name: string, estimatedVolume?: number | null, volumeUnits?: number | null, createdAtUtc: string, draftPackagingType?: string | null, draftUnitType?: string | null, listingType: { __typename?: 'ListingTypeSelectItem', id: number, name: string, suggestedTenderLengthInMonths: number, suggestedListingLengthInMonths: number, order: number }, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null }> }>, pageInfo: { __typename?: 'OffsetPageInfo', currentPage: number, totalPages: number, hasNextPage: boolean, hasPrevPage: boolean } } };

export type AddTenderMutationVariables = Exact<{
  input: AddTenderInput;
}>;


export type AddTenderMutation = { __typename?: 'Mutation', addTender: { __typename?: 'Tender', id: number, userId: number, venueId: number, name: string, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, listingTypeId: number, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, tenderDetails?: string | null, status: TenderStatus, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock?: TenderSupportOption | null, supportsDiscount?: TenderSupportOption | null, supportsListingFee?: TenderSupportOption | null, supportsPosBudget?: TenderSupportOption | null, supportsRetroDiscount?: TenderSupportOption | null, supportDetails?: string | null, totalReceivedBids: number, createdAtUtc?: string | null, updatedAtUtc?: string | null, receivedSupportStatus?: TenderSupportStatus | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, feedback?: string | null, region: Region, isPrivate: boolean, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null } };

export type ChooseMultipleTenderWinnersMutationVariables = Exact<{
  input: ChooseMultipleTenderWinnersInput;
}>;


export type ChooseMultipleTenderWinnersMutation = { __typename?: 'Mutation', chooseMultipleTenderWinners: Array<{ __typename?: 'Tender', id: number, userId: number, venueId: number, name: string, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, listingTypeId: number, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, tenderDetails?: string | null, status: TenderStatus, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock?: TenderSupportOption | null, supportsDiscount?: TenderSupportOption | null, supportsListingFee?: TenderSupportOption | null, supportsPosBudget?: TenderSupportOption | null, supportsRetroDiscount?: TenderSupportOption | null, supportDetails?: string | null, totalReceivedBids: number, createdAtUtc?: string | null, updatedAtUtc?: string | null, receivedSupportStatus?: TenderSupportStatus | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, feedback?: string | null, region: Region, isPrivate: boolean }> };

export type EditTenderMutationVariables = Exact<{
  input: EditTenderInput;
}>;


export type EditTenderMutation = { __typename?: 'Mutation', editTender: { __typename?: 'Tender', id: number, userId: number, venueId: number, name: string, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, listingTypeId: number, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, tenderDetails?: string | null, status: TenderStatus, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock?: TenderSupportOption | null, supportsDiscount?: TenderSupportOption | null, supportsListingFee?: TenderSupportOption | null, supportsPosBudget?: TenderSupportOption | null, supportsRetroDiscount?: TenderSupportOption | null, supportDetails?: string | null, totalReceivedBids: number, createdAtUtc?: string | null, updatedAtUtc?: string | null, receivedSupportStatus?: TenderSupportStatus | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, feedback?: string | null, region: Region, isPrivate: boolean, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null } };

export type TenderListQueryVariables = Exact<{
  input: TendersInput;
}>;


export type TenderListQuery = { __typename?: 'Query', tenderList: { __typename?: 'Tenders', totalCount: number, data: Array<{ __typename?: 'Tender', id: number, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, name: string, estimatedVolume?: number | null, volumeUnits?: number | null, totalReceivedBids: number, status: TenderStatus, userId: number, venueId: number, listingTypeId: number, receivedSupportStatus?: TenderSupportStatus | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, region: Region, isPrivate: boolean, venue: { __typename?: 'Venue', id: number, name?: string | null, venueCategoryName?: string | null, venueCategoryId?: number | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, requiresParamountLiquorIntegration: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, billingName?: string | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsDiscount: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> }, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, users: Array<{ __typename?: 'CompanyUser', userId: number, role: string }>, billingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null }, listingType: { __typename?: 'ListingTypeSelectItem', id: number, name: string, suggestedTenderLengthInMonths: number, suggestedListingLengthInMonths: number, order: number }, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null }>, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null }>, pageInfo: { __typename?: 'OffsetPageInfo', currentPage: number, totalPages: number, hasNextPage: boolean, hasPrevPage: boolean } } };

export type TenderListFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type TenderListFilterOptionsQuery = { __typename?: 'Query', tenderListFilterOptions: Array<{ __typename?: 'Filter', label: string, type?: FilterOptionType | null, options: Array<{ __typename?: 'FilterOption', label: string, value: string }> }> };

export type DeleteTenderByIdMutationVariables = Exact<{
  tenderId: Scalars['NonNegativeInt']['input'];
}>;


export type DeleteTenderByIdMutation = { __typename?: 'Mutation', deleteTenderById: boolean };

export type ChooseWinnerMutationVariables = Exact<{
  input: ChooseWinnerInput;
}>;


export type ChooseWinnerMutation = { __typename?: 'Mutation', chooseWinner: { __typename?: 'Tender', id: number, userId: number, venueId: number, name: string, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, listingTypeId: number, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, tenderDetails?: string | null, status: TenderStatus, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock?: TenderSupportOption | null, supportsDiscount?: TenderSupportOption | null, supportsListingFee?: TenderSupportOption | null, supportsPosBudget?: TenderSupportOption | null, supportsRetroDiscount?: TenderSupportOption | null, supportDetails?: string | null, totalReceivedBids: number, createdAtUtc?: string | null, updatedAtUtc?: string | null, receivedSupportStatus?: TenderSupportStatus | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, feedback?: string | null, region: Region, isPrivate: boolean } };

export type MultipleBidsTendersQueryVariables = Exact<{
  input: TendersInput;
}>;


export type MultipleBidsTendersQuery = { __typename?: 'Query', tenderList: { __typename?: 'Tenders', totalCount: number, data: Array<{ __typename?: 'Tender', id: number, name: string, listingTypeId: number, supportsFreeStock?: TenderSupportOption | null, supportsListingFee?: TenderSupportOption | null, supportsPosBudget?: TenderSupportOption | null, supportsRetroDiscount?: TenderSupportOption | null, supportDetails?: string | null, tenderDetails?: string | null, volumeDetails?: string | null, estimatedVolume?: number | null, volumeUnits?: number | null, listingEndsAtUtc?: string | null, listingStartsAtUtc?: string | null, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, hasBrandsBid?: boolean | null, status: TenderStatus, venueId: number, totalReceivedBids: number, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, region: Region, isPrivate: boolean, venue: { __typename?: 'Venue', id: number, name?: string | null, venueCategoryName?: string | null, venueCategoryId?: number | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, requiresParamountLiquorIntegration: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, billingName?: string | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsDiscount: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> }, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, users: Array<{ __typename?: 'CompanyUser', userId: number, role: string }>, billingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null }, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null, listingType: { __typename?: 'ListingTypeSelectItem', id: number, name: string, suggestedTenderLengthInMonths: number, suggestedListingLengthInMonths: number, order: number }, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null }>, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null }>, pageInfo: { __typename?: 'OffsetPageInfo', currentPage: number, totalPages: number, hasNextPage: boolean, hasPrevPage: boolean } } };

export type CompatibleTendersQueryVariables = Exact<{
  brandId: Scalars['NonNegativeInt']['input'];
  productCategoryId?: InputMaybe<Scalars['NonNegativeInt']['input']>;
}>;


export type CompatibleTendersQuery = { __typename?: 'Query', compatibleTenders: Array<{ __typename?: 'TenderSelectItem', id: number, hasBrandBidsInTender: boolean, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, listingStartsAtUtc: string, listingEndsAtUtc: string, name: string, estimatedVolume: number, volumeUnits: number, userId: number, venueId: number, packagingType?: string | null, unitType: string, region: string, venue?: { __typename?: 'TenderVenueRelation', id: number, name?: string | null, venueCategoryName?: string | null } | null, listingType?: { __typename?: 'TenderListingTypeRelation', id: number, name: string } | null, productCategories: Array<{ __typename?: 'TenderProductCategoriesRelation', tenderId: number, productCategoryId: number }> } | null> };

export type TopTendersBidsCountMinBoundaryQueryVariables = Exact<{ [key: string]: never; }>;


export type TopTendersBidsCountMinBoundaryQuery = { __typename?: 'Query', topTendersBidsCountMinBoundary: number };

export type TenderDraftInfoFragment = { __typename?: 'TenderDraft', id: number, userId: number, venueId: number, name: string, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, listingTypeId: number, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, tenderDetails?: string | null, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock: TenderSupportOption, supportsListingFee: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsDiscount: TenderSupportOption, supportDetails?: string | null, createdAtUtc: string, updatedAtUtc?: string | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible: boolean, region: Region, isPrivate: boolean };

export type TenderDraftByIdQueryVariables = Exact<{
  tenderDraftId: Scalars['NonNegativeInt']['input'];
}>;


export type TenderDraftByIdQuery = { __typename?: 'Query', tenderDraftById: { __typename?: 'TenderDraft', listingTypeId: number, id: number, userId: number, venueId: number, name: string, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, tenderDetails?: string | null, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock: TenderSupportOption, supportsListingFee: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsDiscount: TenderSupportOption, supportDetails?: string | null, createdAtUtc: string, updatedAtUtc?: string | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible: boolean, region: Region, isPrivate: boolean, venue: { __typename?: 'Venue', id: number, name?: string | null, venueCategoryName?: string | null, venueCategoryId?: number | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, requiresParamountLiquorIntegration: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, billingName?: string | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsDiscount: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> }, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, users: Array<{ __typename?: 'CompanyUser', userId: number, role: string }>, billingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null }, user: { __typename?: 'User', id: number, firebaseId: string, userType: UserType, email: string, isSalesDemo?: boolean | null, region: Region, status: UserStatus, contactName?: string | null, phoneNumber?: string | null }, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null }>, listingType: { __typename?: 'ListingTypeSelectItem', id: number, name: string, suggestedTenderLengthInMonths: number, suggestedListingLengthInMonths: number, order: number }, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }>, files: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> } };

export type EditTenderDraftMutationVariables = Exact<{
  input: EditTenderDraftInput;
}>;


export type EditTenderDraftMutation = { __typename?: 'Mutation', editTenderDraft: { __typename?: 'TenderDraft', id: number, userId: number, venueId: number, name: string, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, listingTypeId: number, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, tenderDetails?: string | null, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock: TenderSupportOption, supportsListingFee: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsDiscount: TenderSupportOption, supportDetails?: string | null, createdAtUtc: string, updatedAtUtc?: string | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible: boolean, region: Region, isPrivate: boolean, files: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> } };

export type AddTenderDraftMutationVariables = Exact<{
  input: AddTenderDraftInput;
}>;


export type AddTenderDraftMutation = { __typename?: 'Mutation', addTenderDraft: { __typename?: 'TenderDraft', id: number, userId: number, venueId: number, name: string, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, listingTypeId: number, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, tenderDetails?: string | null, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock: TenderSupportOption, supportsListingFee: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsDiscount: TenderSupportOption, supportDetails?: string | null, createdAtUtc: string, updatedAtUtc?: string | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible: boolean, region: Region, isPrivate: boolean, files: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> } };

export type DeleteTenderDraftByIdMutationVariables = Exact<{
  tenderDraftId: Scalars['NonNegativeInt']['input'];
}>;


export type DeleteTenderDraftByIdMutation = { __typename?: 'Mutation', deleteTenderDraftById: boolean };

export type TenderPreferenceInfoFragment = { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsDiscount: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> };

export type EditTenderPreferenceMutationVariables = Exact<{
  input: EditTenderPreferenceInput;
}>;


export type EditTenderPreferenceMutation = { __typename?: 'Mutation', editTenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsDiscount: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> } };

export type TenderPreferenceByVenueIdQueryVariables = Exact<{
  venueId: Scalars['NonNegativeInt']['input'];
}>;


export type TenderPreferenceByVenueIdQuery = { __typename?: 'Query', tenderPreferenceByVenueId: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsDiscount: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> } };

export type UserInfoFragment = { __typename?: 'User', id: number, firebaseId: string, userType: UserType, email: string, isSalesDemo?: boolean | null, region: Region, status: UserStatus, contactName?: string | null, phoneNumber?: string | null };

export type UserMeInfoFragment = { __typename?: 'UserSelectItem', id: number, firebaseId: string, userType: UserType, email: string, isSalesDemo?: boolean | null, region: Region, status: UserStatus, contactName?: string | null, phoneNumber?: string | null };

export type CompanyUserInfoFragment = { __typename?: 'CompanyUser', userId: number, role: string };

export type UserMeQueryVariables = Exact<{
  input?: InputMaybe<UserMeInput>;
}>;


export type UserMeQuery = { __typename?: 'Query', userMe: { __typename?: 'UserSelectItem', companyCount: number, id: number, firebaseId: string, userType: UserType, email: string, isSalesDemo?: boolean | null, region: Region, status: UserStatus, contactName?: string | null, phoneNumber?: string | null, activeVenue?: { __typename?: 'Venue', id: number, name?: string | null, instagramUrl?: string | null, avatarBucketKey?: string | null, avatarUrl?: string | null, webPageUrl?: string | null, description?: string | null, canCreateTender: boolean, requiresParamountLiquorIntegration: boolean, hasTenders: boolean, stripeCustomerId?: string | null, groupName?: string | null, venueCategoryName?: string | null, venueCategoryId?: number | null, addressId?: number | null, phoneNumber?: string | null, billingName?: string | null, billingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, users: Array<{ __typename?: 'CompanyUser', userId: number, role: string }> } | null, activeBrand?: { __typename?: 'Brand', id: number, name?: string | null, region: Region, groupName?: string | null, subscriptionTier: SubscriptionTier, instagramUrl?: string | null, avatarBucketKey?: string | null, avatarUrl?: string | null, webPageUrl?: string | null, stripeSubscriptionId?: string | null, failedPaymentIntentCounter: number, successFee: number, isAnonymousBidAllowed?: boolean | null, stripeCustomerId?: string | null, addressId?: number | null, isEnterpriseSubscriptionRequestSent: boolean, tradingName?: string | null, phoneNumber?: string | null, vatNumber?: string | null, canSeeOtherBids: boolean, billingName?: string | null, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, isPublished: boolean, defaultVolume?: number | null, defaultPackagingType?: string | null }>, tradingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, billingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, users: Array<{ __typename?: 'CompanyUser', userId: number, role: string }>, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null } };

export type UserExistsQueryVariables = Exact<{
  input: UserExistsInput;
}>;


export type UserExistsQuery = { __typename?: 'Query', userExists: boolean };

export type ClaimVenueAccountMutationVariables = Exact<{
  input: ClaimVenueAccountInput;
}>;


export type ClaimVenueAccountMutation = { __typename?: 'Mutation', claimVenueAccount?: { __typename?: 'UnclaimedVenueAccount', email: string, region: Region, integrationType: IntegrationType, resendAvailableInSeconds?: number | null } | null };

export type SignUpMutationVariables = Exact<{
  input: SignUpInput;
}>;


export type SignUpMutation = { __typename?: 'Mutation', signUp: string };

export type ChangeEmailMutationVariables = Exact<{
  input: ChangeEmailInput;
}>;


export type ChangeEmailMutation = { __typename?: 'Mutation', changeEmail: { __typename?: 'UserSelectItem', id: number, firebaseId: string, userType: UserType, email: string, isSalesDemo?: boolean | null, region: Region, status: UserStatus, contactName?: string | null, phoneNumber?: string | null } };

export type RequestChangeEmailMutationVariables = Exact<{
  emailToChange: Scalars['String']['input'];
}>;


export type RequestChangeEmailMutation = { __typename?: 'Mutation', requestChangeEmail: boolean };

export type ConfirmChangeEmailMutationVariables = Exact<{
  changeEmailToken: Scalars['String']['input'];
}>;


export type ConfirmChangeEmailMutation = { __typename?: 'Mutation', confirmChangeEmail: boolean };

export type IsUserEmailConfirmedQueryVariables = Exact<{ [key: string]: never; }>;


export type IsUserEmailConfirmedQuery = { __typename?: 'Query', isUserEmailConfirmed: boolean };

export type VerifyEmailRequestMutationVariables = Exact<{ [key: string]: never; }>;


export type VerifyEmailRequestMutation = { __typename?: 'Mutation', verifyEmailRequest: boolean };

export type EditUserContactDetailsMutationVariables = Exact<{
  input: EditUserContactDetailsInput;
}>;


export type EditUserContactDetailsMutation = { __typename?: 'Mutation', editUserContactDetails: boolean };

export type PublicUserInfoFragment = { __typename?: 'UserSelectItem', id: number, userType: UserType, email: string, region: Region, status: UserStatus, contactName?: string | null, phoneNumber?: string | null };

export type UsersByIdsQueryVariables = Exact<{
  userIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type UsersByIdsQuery = { __typename?: 'Query', usersByIds: Array<{ __typename?: 'UserSelectItem', id: number, userType: UserType, email: string, region: Region, status: UserStatus, contactName?: string | null, phoneNumber?: string | null }> };

export type UserActionLogInfoFragment = { __typename?: 'UserActionLog', id: number, userId: number, eventName: string, additionalData?: Object | null };

export type AddUserActionLogMutationVariables = Exact<{
  input: UserActionLogInput;
}>;


export type AddUserActionLogMutation = { __typename?: 'Mutation', addUserActionLog: { __typename?: 'UserActionLog', id: number, userId: number, eventName: string, additionalData?: Object | null } };

export type VenueInfoFragment = { __typename?: 'Venue', id: number, name?: string | null, venueCategoryName?: string | null, venueCategoryId?: number | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, requiresParamountLiquorIntegration: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, billingName?: string | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsDiscount: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> }, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, users: Array<{ __typename?: 'CompanyUser', userId: number, role: string }>, billingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null };

export type VenueUserInfoFragment = { __typename?: 'VenueUserItem', userId: number, venueId: number, role?: UserRole | null };

export type UserVenuesByNameQueryVariables = Exact<{
  venueName: Scalars['String']['input'];
}>;


export type UserVenuesByNameQuery = { __typename?: 'Query', userVenuesByName: Array<{ __typename?: 'Venue', id: number, name?: string | null, venueCategoryName?: string | null, venueCategoryId?: number | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, requiresParamountLiquorIntegration: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, billingName?: string | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsDiscount: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> }, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, users: Array<{ __typename?: 'CompanyUser', userId: number, role: string }>, billingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null }> };

export type EditVenueMutationVariables = Exact<{
  input: EditVenueInput;
}>;


export type EditVenueMutation = { __typename?: 'Mutation', editVenue: { __typename?: 'Venue', id: number, name?: string | null, venueCategoryName?: string | null, venueCategoryId?: number | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, requiresParamountLiquorIntegration: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, billingName?: string | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsDiscount: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> }, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, users: Array<{ __typename?: 'CompanyUser', userId: number, role: string }>, billingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } };

export type UserVenuesQueryVariables = Exact<{
  input: UserVenuesInput;
}>;


export type UserVenuesQuery = { __typename?: 'Query', userVenues: { __typename?: 'Venues', totalCount: number, edges: Array<{ __typename?: 'VenueEdge', cursor: string, node: { __typename?: 'Venue', id: number, name?: string | null, venueCategoryName?: string | null, venueCategoryId?: number | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, requiresParamountLiquorIntegration: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, billingName?: string | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsDiscount: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> }, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, users: Array<{ __typename?: 'CompanyUser', userId: number, role: string }>, billingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } }>, pageInfo: { __typename?: 'CursorPageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type SearchVenuesQueryVariables = Exact<{
  input: SearchVenuesInput;
}>;


export type SearchVenuesQuery = { __typename?: 'Query', searchVenues: Array<{ __typename?: 'Venue', id: number, name?: string | null, venueCategoryName?: string | null, venueCategoryId?: number | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, requiresParamountLiquorIntegration: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, billingName?: string | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsDiscount: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> }, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, users: Array<{ __typename?: 'CompanyUser', userId: number, role: string }>, billingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null }> };

export type VenueByIdQueryVariables = Exact<{
  venueId: Scalars['Int']['input'];
}>;


export type VenueByIdQuery = { __typename?: 'Query', venueById: { __typename?: 'Venue', id: number, name?: string | null, venueCategoryName?: string | null, venueCategoryId?: number | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, requiresParamountLiquorIntegration: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, billingName?: string | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsDiscount: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> }, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, users: Array<{ __typename?: 'CompanyUser', userId: number, role: string }>, billingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } };

export type VenueDashboardMetricsByVenueIdQueryVariables = Exact<{
  venueId: Scalars['Int']['input'];
}>;


export type VenueDashboardMetricsByVenueIdQuery = { __typename?: 'Query', venueDashboardMetricsByVenueId: Array<{ __typename?: 'VenueDashboardMetric', type: DashboardMetricType, label: VenueDashboardMetricLabel, value: string }> };

export type DeleteVenueUserMutationVariables = Exact<{
  venueId: Scalars['NonNegativeInt']['input'];
  userId: Scalars['NonNegativeInt']['input'];
}>;


export type DeleteVenueUserMutation = { __typename?: 'Mutation', deleteVenueUser?: { __typename?: 'VenueUserItem', userId: number, venueId: number, role?: UserRole | null } | null };

export type SetVenueUserRoleMutationVariables = Exact<{
  venueId: Scalars['NonNegativeInt']['input'];
  userId: Scalars['NonNegativeInt']['input'];
  role: SetUserRole;
}>;


export type SetVenueUserRoleMutation = { __typename?: 'Mutation', setVenueUserRole?: { __typename?: 'VenueUserItem', userId: number, venueId: number, role?: UserRole | null } | null };

export type VenueUsersQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<VenueUserOrderBy>;
  where?: InputMaybe<VenueUserFilters>;
}>;


export type VenueUsersQuery = { __typename?: 'Query', venueUsers: Array<{ __typename?: 'VenueUserSelectItem', userId: number, role: VenueUserRoleEnum, user?: { __typename?: 'VenueUserUserRelation', id: number, email: string } | null }> };

export type InsertIntoVenueMutationVariables = Exact<{
  input: VenueInsertInput;
}>;


export type InsertIntoVenueMutation = { __typename?: 'Mutation', insertIntoVenue: { __typename?: 'VenueItem', id: number } };

export type UpdateVenueBillingAddressMutationVariables = Exact<{
  id: Scalars['NonNegativeInt']['input'];
  input: AddressInsertInput;
}>;


export type UpdateVenueBillingAddressMutation = { __typename?: 'Mutation', updateVenueBillingAddress?: { __typename?: 'VenueItem', id: number } | null };

export type VenueIntegrationsItemFragment = { __typename?: 'VenueIntegrationsSelectItem', id: number, createdAtUtc: string, updatedAtUtc?: string | null, venueId: number, userId: number, externalUserId: string, externalCompanyId: string, integrationType: VenueIntegrationsIntegrationTypeEnum, metadata?: string | null };

export type VenueIntegrationsQueryVariables = Exact<{
  venueId: Scalars['Int']['input'];
}>;


export type VenueIntegrationsQuery = { __typename?: 'Query', venueIntegrations: Array<{ __typename?: 'VenueIntegrationsSelectItem', id: number, createdAtUtc: string, updatedAtUtc?: string | null, venueId: number, userId: number, externalUserId: string, externalCompanyId: string, integrationType: VenueIntegrationsIntegrationTypeEnum, metadata?: string | null }> };

export type VenueCategoriesQueryVariables = Exact<{
  region: Region;
}>;


export type VenueCategoriesQuery = { __typename?: 'Query', venueCategories: Array<{ __typename?: 'VenueCategory', id: number, name: string, parentId?: number | null, localizationKey: string }> };

export type VenueSettingsInfoFragment = { __typename?: 'VenueSettings', id: number, venueId: number, isNewTenderMailNotificationEnabled: boolean, isNewBidsMailNotificationEnabled: boolean, isBidUpdatedMailNotificationEnabled: boolean, isMyTenderEndedMailNotificationEnabled: boolean, isReTenderMailNotificationEnabled: boolean, isNewTenderInAppNotificationEnabled: boolean, isNewBidsInAppNotificationEnabled: boolean, isBidUpdatedInAppNotificationEnabled: boolean, isMyTenderEndedInAppNotificationEnabled: boolean, isReTenderInAppNotificationEnabled: boolean };

export type VenueSettingsByIdQueryVariables = Exact<{
  venueId: Scalars['Int']['input'];
}>;


export type VenueSettingsByIdQuery = { __typename?: 'Query', venueSettingsByVenueId: { __typename?: 'VenueSettings', id: number, venueId: number, isNewTenderMailNotificationEnabled: boolean, isNewBidsMailNotificationEnabled: boolean, isBidUpdatedMailNotificationEnabled: boolean, isMyTenderEndedMailNotificationEnabled: boolean, isReTenderMailNotificationEnabled: boolean, isNewTenderInAppNotificationEnabled: boolean, isNewBidsInAppNotificationEnabled: boolean, isBidUpdatedInAppNotificationEnabled: boolean, isMyTenderEndedInAppNotificationEnabled: boolean, isReTenderInAppNotificationEnabled: boolean } };

export type EditVenueSettingsMutationVariables = Exact<{
  input: EditVenueSettingsInput;
}>;


export type EditVenueSettingsMutation = { __typename?: 'Mutation', editVenueSettings: { __typename?: 'VenueSettings', id: number, venueId: number, isNewTenderMailNotificationEnabled: boolean, isNewBidsMailNotificationEnabled: boolean, isBidUpdatedMailNotificationEnabled: boolean, isMyTenderEndedMailNotificationEnabled: boolean, isReTenderMailNotificationEnabled: boolean, isNewTenderInAppNotificationEnabled: boolean, isNewBidsInAppNotificationEnabled: boolean, isBidUpdatedInAppNotificationEnabled: boolean, isMyTenderEndedInAppNotificationEnabled: boolean, isReTenderInAppNotificationEnabled: boolean } };

export type WholesalerInfoFragment = { __typename?: 'Wholesaler', id: number, name: string, region: Region };

export type SearchWholesalersQueryVariables = Exact<{
  input: WholesalerSearchInput;
}>;


export type SearchWholesalersQuery = { __typename?: 'Query', searchWholesalers: { __typename?: 'Wholesalers', totalCount: number, edges: Array<{ __typename?: 'WholesalerEdge', cursor: string, node: { __typename?: 'Wholesaler', id: number, name: string, region: Region } }>, pageInfo: { __typename?: 'CursorPageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean } } };

export const CursorPageInfoFragmentDoc = gql`
    fragment CursorPageInfo on CursorPageInfo {
  startCursor
  endCursor
  hasNextPage
  hasPreviousPage
}
    `;
export const OffsetPageInfoFragmentDoc = gql`
    fragment OffsetPageInfo on OffsetPageInfo {
  currentPage
  totalPages
  hasNextPage
  hasPrevPage
}
    `;
export const OffsetPaginationFragmentDoc = gql`
    fragment OffsetPagination on OffsetPagination {
  currentPage
  totalPages
  hasNextPage
  hasPrevPage
  totalCount
}
    `;
export const ProductCategoryInfoFragmentDoc = gql`
    fragment ProductCategoryInfo on ProductCategory {
  id
  name
  parentId
  unitType
  isPublished
  defaultVolume
  defaultPackagingType
}
    `;
export const WholesalerInfoFragmentDoc = gql`
    fragment WholesalerInfo on Wholesaler {
  id
  name
  region
}
    `;
export const ComputedSupportInfoFragmentDoc = gql`
    fragment ComputedSupportInfo on ComputedSupport {
  listingFee
  freeStock
  retro
  marketing
  discount
  total
}
    `;
export const BidInfoFragmentDoc = gql`
    fragment BidInfo on Bid {
  id
  tenderId
  brandId
  userId
  isAnonymous
  productName
  volumeUnits
  productCategory {
    ...ProductCategoryInfo
  }
  wholesalers {
    ...WholesalerInfo
  }
  productCategoryId
  averageWholesalePrice
  productUrl
  supportsListingFee
  listingFeeTotalAmount
  listingFeeNotes
  supportsFreeStock
  freeStockUnitsAmount
  freeStockNotes
  supportsRetroDiscount
  supportsDiscount
  discountAmountPerUnit
  discountNotes
  retroDiscountAmountPerUnit
  retroDiscountNotes
  supportsPosBudget
  posBudgetTotalAmount
  posBudgetNotes
  otherSupport
  rating
  ratingComment
  isRatingOutdated
  ratedAtUtc
  updatedAtUtc
  createdAtUtc
  status
  avatarUrl
  avatarBucketKey
  isListingFeeProvided
  isFreeStockProvided
  isRetroDiscountProvided
  isPosBudgetProvided
  isDiscountProvided
  areWholesalersCompatible
  messagesCount
  isListingFeeReceived
  isFreeStockReceived
  isRetroDiscountReceived
  isPosBudgetReceived
  isDiscountReceived
  netPrice
  netPricePerLitre
  netPricePerEquivalentUnit
  packagingType
  unitType
  unitsPerCase
  volumePerUnit
  isDirectSupplyCompatible
  isAnyWholesalerCompatible
  subscriptionTier
  successFee
  region
  commonBidId
  support {
    ...ComputedSupportInfo
  }
}
    ${ProductCategoryInfoFragmentDoc}
${WholesalerInfoFragmentDoc}
${ComputedSupportInfoFragmentDoc}`;
export const BrandDashboardBidDataFragmentDoc = gql`
    fragment BrandDashboardBidData on Bid {
  averageWholesalePrice
  id
  isFreeStockProvided
  isListingFeeProvided
  isPosBudgetProvided
  isRetroDiscountProvided
  isDiscountProvided
  isFreeStockReceived
  isListingFeeReceived
  isPosBudgetReceived
  isRetroDiscountReceived
  freeStockUnitsAmount
  retroDiscountAmountPerUnit
  discountAmountPerUnit
  supportsFreeStock
  supportsPosBudget
  supportsRetroDiscount
  supportsListingFee
  tenderId
  rating
  volumeUnits
  volumePerUnit
  unitsPerCase
  unitType
  packagingType
  region
  productName
  ratingComment
  commonBidId
  status
  support {
    ...ComputedSupportInfo
  }
}
    ${ComputedSupportInfoFragmentDoc}`;
export const BrandUserInfoFragmentDoc = gql`
    fragment BrandUserInfo on BrandUserItem {
  userId
  brandId
  role
}
    `;
export const BrandIntegrationItemFragmentDoc = gql`
    fragment BrandIntegrationItem on BrandIntegrationsSelectItem {
  id
  createdAtUtc
  updatedAtUtc
  brandId
  userId
  externalUserId
  externalCompanyId
  integrationType
  metadata
}
    `;
export const BrandSettingsInfoFragmentDoc = gql`
    fragment BrandSettingsInfo on BrandSettings {
  id
  brandId
  isRatingProvidedMailNotificationEnabled
  isTenderUpdatedMailNotificationEnabled
  isNewTenderMailNotificationEnabled
  isRatingProvidedInAppNotificationEnabled
  isTenderUpdatedInAppNotificationEnabled
  isNewTenderInAppNotificationEnabled
  isMatchBidsTenderReportMailNotificationEnabled
}
    `;
export const S3FileInfoFragmentDoc = gql`
    fragment S3FileInfo on S3File {
  filename
  bucketKey
  downloadUrl
  fileSizeInKib
}
    `;
export const CommonBidMatchBidFragmentDoc = gql`
    fragment CommonBidMatchBid on CommonBidMatchBidRelation {
  bidId
  credit
  maximumAcceptedDeals
  product {
    bidId
    productId
    externalProductId
  }
  venueCriteria {
    bidId
    regions
    customerTypes
    listingTypeId
    loyaltyLevels
    minimumVolume
    venueTypes
    targetProductCategory
  }
}
    `;
export const CommonBidInfoFragmentDoc = gql`
    fragment CommonBidInfo on CommonBidSelectItem {
  id
  status
  otherSupportAndTerms
  brandId
  region
  isAnonymous
  ratedAtUtc
  updatedAtUtc
  rating
  ratingComment
  supportedWholesalers {
    bidId
    wholesalerId
    wholesaler {
      id
      name
    }
  }
  supports {
    amount
    notes
    supportType
    isProvided
    isReceived
  }
  userId
  user {
    id
    email
    phoneNumber
    contactName
  }
  brand {
    id
    name
    billingName
    avatarBucketKey
    addressId
    phoneNumber
    tradingName
    webPageUrl
    subscriptionTier
    avatarUrl
    address {
      id
      name
    }
    registeredCompany {
      id
      name
      formattedAddress
    }
  }
  product {
    bidId
    name
    productCategoryId
    url
    packagingType
    volumeUnits
    averageWholesalePrice
    isAnyWholesalerCompatible
    isDirectSupplyCompatible
    unitType
    avatarUrl
    avatarBucketKey
    productTemplateId
    unitsPerCase
    volumePerUnit
    attachments {
      ...S3FileInfo
    }
    productCategory {
      id
      localizationKey
      parentCategory {
        id
        localizationKey
      }
    }
  }
  matchBid {
    ...CommonBidMatchBid
  }
  connectBid {
    bidId
    tenderId
    matchBidId
    messageCount
    tender {
      id
      userId
      estimatedVolume
      volumeUnits
      unitType
      venueId
      isAnyWholesalerCompatible
      venue {
        name
      }
    }
    matchBid {
      bidId
      venueCriteria {
        bidId
        regions
        customerTypes
        listingTypeId
        loyaltyLevels
        minimumVolume
        venueTypes
        targetProductCategory
      }
    }
  }
}
    ${S3FileInfoFragmentDoc}
${CommonBidMatchBidFragmentDoc}`;
export const FilterOptionsFragmentDoc = gql`
    fragment FilterOptions on Filter {
  label
  type
  options {
    label
    value
  }
}
    `;
export const InvitationLinkItemFragmentDoc = gql`
    fragment InvitationLinkItem on InvitationLinkItem {
  id
  email
  createdById
  expiresAt
  acceptedById
  status
}
    `;
export const ListingTypeInfoFragmentDoc = gql`
    fragment ListingTypeInfo on ListingTypeSelectItem {
  id
  name
  suggestedTenderLengthInMonths
  suggestedListingLengthInMonths
  order
}
    `;
export const MatchBidInfoFragmentDoc = gql`
    fragment MatchBidInfo on MatchBidSelectItem {
  bidId
  credit
  maximumAcceptedDeals
  product {
    bidId
    productId
    externalProductId
    externalProvider
  }
  venueCriteria {
    bidId
    regions
    customerTypes
    listingTypeId
    loyaltyLevels
    minimumVolume
    venueTypes
    targetProductCategory
  }
  commonBid {
    id
    status
    otherSupportAndTerms
    brandId
    region
    supports {
      amount
      notes
      supportType
    }
    brand {
      id
      name
    }
    supportedWholesalers {
      wholesaler {
        id
        name
      }
    }
    product {
      bidId
      name
      productCategoryId
      url
      packagingType
      volumeUnits
      averageWholesalePrice
      unitType
      unitsPerCase
      volumePerUnit
      avatarBucketKey
      avatarUrl
      isAnyWholesalerCompatible
      isDirectSupplyCompatible
      productTemplateId
      attachments {
        ...S3FileInfo
      }
      productCategory {
        id
        localizationKey
        parentCategory {
          id
          localizationKey
        }
      }
    }
  }
}
    ${S3FileInfoFragmentDoc}`;
export const MessageInfoFragmentDoc = gql`
    fragment MessageInfo on Message {
  id
  bidId
  venueId
  brandId
  text
  createdAtUtc
  updatedAtUtc
}
    `;
export const NotificationInfoFragmentDoc = gql`
    fragment NotificationInfo on Notification {
  id
  category
  createdAtUtc
  isRead
  type
  toId
  toType
  bidId
  tenderId
  bid {
    id
    commonBidId
    brandId
    messagesCount
    avatarUrl
    productName
  }
  message {
    text
  }
  brand {
    name
    avatarUrl
    region
    subscriptionTier
  }
  venue {
    name
    avatarUrl
  }
  tender {
    name
    listingEndsAtUtc
  }
}
    `;
export const MainProductCategoryInfoFragmentDoc = gql`
    fragment MainProductCategoryInfo on MainProductCategory {
  id
  name
  parentId
  unitType
  isPublished
  defaultVolume
  defaultPackagingType
  subCategories {
    id
    name
    parentId
    unitType
    isPublished
    defaultVolume
    defaultPackagingType
  }
}
    `;
export const ProductCategoryTreeInfoFragmentDoc = gql`
    fragment ProductCategoryTreeInfo on TopProductCategory {
  id
  name
  parentId
  unitType
  defaultVolume
  defaultPackagingType
  isPublished
  subCategories {
    ...MainProductCategoryInfo
  }
}
    ${MainProductCategoryInfoFragmentDoc}`;
export const FileInfoFragmentDoc = gql`
    fragment FileInfo on File {
  id
  filename
  bucketKey
  context
  downloadUrl
  fileSizeInKib
}
    `;
export const AddressInfoFragmentDoc = gql`
    fragment AddressInfo on Address {
  id
  name
  coordinates {
    x
    y
  }
  postCode
  placeId
  country
  administrativeAreaLevel1
  administrativeAreaLevel1ShortName
  administrativeAreaLevel2
  administrativeAreLevel2ShortName
  locality
}
    `;
export const RegisteredCompanyInfoFragmentDoc = gql`
    fragment RegisteredCompanyInfo on RegisteredCompany {
  id
  name
  number
  status
  dateOfCreation
  postalCode
  region
  locality
  country
  firstAddressLine
  secondAddressLine
  formattedAddress
  addressId
  address {
    ...AddressInfo
  }
}
    ${AddressInfoFragmentDoc}`;
export const CompanyUserInfoFragmentDoc = gql`
    fragment CompanyUserInfo on CompanyUser {
  userId
  role
}
    `;
export const BrandInfoFragmentDoc = gql`
    fragment BrandInfo on Brand {
  id
  name
  webPageUrl
  instagramUrl
  groupName
  avatarUrl
  avatarBucketKey
  phoneNumber
  isAnonymousBidAllowed
  vatNumber
  vatCompanyName
  vatCountryCode
  vatConsultationNumber
  vatProcessingDate
  complianceCheckDate
  complianceNextDate
  complianceRiskLevel
  complianceConfirmation
  billingName
  isEnterpriseSubscriptionRequestSent
  subscriptionTier
  successFee
  stripeCustomerId
  stripeSubscriptionId
  successFee
  failedPaymentIntentCounter
  region
  canSeeOtherBids
  tradingName
  productCategories {
    ...ProductCategoryInfo
  }
  addressId
  address {
    ...AddressInfo
  }
  registeredCompany {
    ...RegisteredCompanyInfo
  }
  tradingAddress {
    ...AddressInfo
  }
  users {
    ...CompanyUserInfo
  }
  billingAddress {
    ...AddressInfo
  }
}
    ${ProductCategoryInfoFragmentDoc}
${AddressInfoFragmentDoc}
${RegisteredCompanyInfoFragmentDoc}
${CompanyUserInfoFragmentDoc}`;
export const ProductTemplateInfoFragmentDoc = gql`
    fragment ProductTemplateInfo on ProductTemplate {
  id
  brandId
  productCategoryId
  productName
  volumeUnits
  volumePerUnit
  unitsPerCase
  averageWholesalePrice
  status
  productUrl
  externalProductId
  files {
    ...FileInfo
  }
  wholesalers {
    ...WholesalerInfo
  }
  brand {
    ...BrandInfo
  }
  productCategory {
    ...ProductCategoryInfo
  }
  avatarUrl
  avatarBucketKey
  packagingType
  unitType
  isDirectSupplyCompatible
  isAnyWholesalerCompatible
  externalProductId
  externalProvider
  hasEditablePrice
}
    ${FileInfoFragmentDoc}
${WholesalerInfoFragmentDoc}
${BrandInfoFragmentDoc}
${ProductCategoryInfoFragmentDoc}`;
export const RegisteredCompanyWithoutIdInfoFragmentDoc = gql`
    fragment RegisteredCompanyWithoutIdInfo on RegisteredCompanyWithoutId {
  name
  number
  status
  dateOfCreation
  postalCode
  region
  locality
  country
  firstAddressLine
  secondAddressLine
  formattedAddress
}
    `;
export const SubscriptionInfoFragmentDoc = gql`
    fragment SubscriptionInfo on Subscription {
  id
  brandId
  customerId
  createdAtUtc
  currentPeriodEnd
  currentPeriodStart
  isCanceled
  isExpired
  amount
  subscriptionTier
  successFee
  interval
}
    `;
export const UpgradeToBespokeDataInfoFragmentDoc = gql`
    fragment UpgradeToBespokeDataInfo on UpgradeToBespokeData {
  wasSuccessfullyUpdated
  needsRedirect
  redirectUrl
}
    `;
export const InvoiceInfoFragmentDoc = gql`
    fragment InvoiceInfo on Invoice {
  id
  total
  createdAt
  customerId
  pdfUrl
  status
  hostedInvoiceUrl
}
    `;
export const SuccessFeeInvoiceInfoFragmentDoc = gql`
    fragment SuccessFeeInvoiceInfo on SuccessFeeInvoice {
  id
  total
  createdAt
  customerId
  paymentUrl
  status
  pdfUrl
}
    `;
export const SuccessFeeInvoiceListItemInfoFragmentDoc = gql`
    fragment SuccessFeeInvoiceListItemInfo on SuccessFeeInvoiceListItem {
  id
  tenderName
  venueName
  total
  createdAt
  customerId
  paymentUrl
  status
  pdfUrl
  bidUnitType
  packagingType
  tenderUnitType
  successFee
  bidVolumeUnits
  estimatedVolume
  tenderVolumeUnits
  averageWholesaleBidPrice
}
    `;
export const BespokeCheckDataInfoFragmentDoc = gql`
    fragment BespokeCheckDataInfo on BespokeCheckData {
  successFee
  pricePerMonth
}
    `;
export const TenderInfoFragmentDoc = gql`
    fragment TenderInfo on Tender {
  id
  userId
  venueId
  name
  listingStartsAtUtc
  listingEndsAtUtc
  listingTypeId
  tenderStartsAtUtc
  tenderEndsAtUtc
  tenderDetails
  status
  estimatedVolume
  volumeUnits
  volumeDetails
  supportsFreeStock
  supportsDiscount
  supportsListingFee
  supportsPosBudget
  supportsRetroDiscount
  supportDetails
  totalReceivedBids
  createdAtUtc
  updatedAtUtc
  receivedSupportStatus
  packagingType
  unitType
  isDirectSupplyCompatible
  isAnyWholesalerCompatible
  feedback
  region
  isPrivate
}
    `;
export const TenderDraftInfoFragmentDoc = gql`
    fragment TenderDraftInfo on TenderDraft {
  id
  userId
  venueId
  name
  listingStartsAtUtc
  listingEndsAtUtc
  listingTypeId
  tenderStartsAtUtc
  tenderEndsAtUtc
  tenderDetails
  estimatedVolume
  volumeUnits
  volumeDetails
  supportsFreeStock
  supportsListingFee
  supportsPosBudget
  supportsRetroDiscount
  supportsDiscount
  supportDetails
  createdAtUtc
  updatedAtUtc
  packagingType
  unitType
  isDirectSupplyCompatible
  isAnyWholesalerCompatible
  region
  isPrivate
}
    `;
export const UserInfoFragmentDoc = gql`
    fragment UserInfo on User {
  id
  firebaseId
  userType
  email
  isSalesDemo
  region
  status
  contactName
  phoneNumber
}
    `;
export const UserMeInfoFragmentDoc = gql`
    fragment UserMeInfo on UserSelectItem {
  id
  firebaseId
  userType
  email
  isSalesDemo
  region
  status
  contactName
  phoneNumber
}
    `;
export const PublicUserInfoFragmentDoc = gql`
    fragment PublicUserInfo on UserSelectItem {
  id
  userType
  email
  region
  status
  contactName
  phoneNumber
}
    `;
export const UserActionLogInfoFragmentDoc = gql`
    fragment UserActionLogInfo on UserActionLog {
  id
  userId
  eventName
  additionalData
}
    `;
export const TenderPreferenceInfoFragmentDoc = gql`
    fragment TenderPreferenceInfo on TenderPreference {
  id
  venueId
  supportsListingFee
  supportsDiscount
  supportsFreeStock
  supportsRetroDiscount
  supportsPosBudget
  wholesalers {
    ...WholesalerInfo
  }
  supportDetails
  isDirectSupplyCompatible
  isAnyWholesalerCompatible
}
    ${WholesalerInfoFragmentDoc}`;
export const VenueInfoFragmentDoc = gql`
    fragment VenueInfo on Venue {
  id
  name
  venueCategoryName
  venueCategoryId
  addressId
  address {
    ...AddressInfo
  }
  webPageUrl
  instagramUrl
  groupName
  hasTenders
  canCreateTender
  requiresParamountLiquorIntegration
  tenderPreference {
    ...TenderPreferenceInfo
  }
  avatarUrl
  avatarBucketKey
  phoneNumber
  description
  stripeCustomerId
  region
  billingName
  registeredCompany {
    ...RegisteredCompanyInfo
  }
  users {
    ...CompanyUserInfo
  }
  billingAddress {
    ...AddressInfo
  }
}
    ${AddressInfoFragmentDoc}
${TenderPreferenceInfoFragmentDoc}
${RegisteredCompanyInfoFragmentDoc}
${CompanyUserInfoFragmentDoc}`;
export const VenueUserInfoFragmentDoc = gql`
    fragment VenueUserInfo on VenueUserItem {
  userId
  venueId
  role
}
    `;
export const VenueIntegrationsItemFragmentDoc = gql`
    fragment VenueIntegrationsItem on VenueIntegrationsSelectItem {
  id
  createdAtUtc
  updatedAtUtc
  venueId
  userId
  externalUserId
  externalCompanyId
  integrationType
  metadata
}
    `;
export const VenueSettingsInfoFragmentDoc = gql`
    fragment VenueSettingsInfo on VenueSettings {
  id
  venueId
  isNewTenderMailNotificationEnabled
  isNewBidsMailNotificationEnabled
  isBidUpdatedMailNotificationEnabled
  isMyTenderEndedMailNotificationEnabled
  isReTenderMailNotificationEnabled
  isNewTenderInAppNotificationEnabled
  isNewBidsInAppNotificationEnabled
  isBidUpdatedInAppNotificationEnabled
  isMyTenderEndedInAppNotificationEnabled
  isReTenderInAppNotificationEnabled
}
    `;
export const PlacesDocument = gql`
    query Places($input: PlacesInput!) {
  places(input: $input) {
    placeName
    placeId
  }
}
    `;

/**
 * __usePlacesQuery__
 *
 * To run a query within a React component, call `usePlacesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlacesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlacesQuery(baseOptions: Apollo.QueryHookOptions<PlacesQuery, PlacesQueryVariables> & ({ variables: PlacesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlacesQuery, PlacesQueryVariables>(PlacesDocument, options);
      }
export function usePlacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlacesQuery, PlacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlacesQuery, PlacesQueryVariables>(PlacesDocument, options);
        }
export function usePlacesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlacesQuery, PlacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlacesQuery, PlacesQueryVariables>(PlacesDocument, options);
        }
export type PlacesQueryHookResult = ReturnType<typeof usePlacesQuery>;
export type PlacesLazyQueryHookResult = ReturnType<typeof usePlacesLazyQuery>;
export type PlacesSuspenseQueryHookResult = ReturnType<typeof usePlacesSuspenseQuery>;
export type PlacesQueryResult = Apollo.QueryResult<PlacesQuery, PlacesQueryVariables>;
export const AddressWithPostcodeByPlaceIdDocument = gql`
    query AddressWithPostcodeByPlaceId($input: AddressByPlaceIdInput!) {
  addressByPlaceId(input: $input) {
    coordinates {
      lat
      lng
    }
    placeId
    placeName
    postCode
    country
    administrativeAreaLevel1
    administrativeAreaLevel1ShortName
    administrativeAreaLevel2
    administrativeAreLevel2ShortName
    locality
  }
}
    `;

/**
 * __useAddressWithPostcodeByPlaceIdQuery__
 *
 * To run a query within a React component, call `useAddressWithPostcodeByPlaceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressWithPostcodeByPlaceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressWithPostcodeByPlaceIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddressWithPostcodeByPlaceIdQuery(baseOptions: Apollo.QueryHookOptions<AddressWithPostcodeByPlaceIdQuery, AddressWithPostcodeByPlaceIdQueryVariables> & ({ variables: AddressWithPostcodeByPlaceIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddressWithPostcodeByPlaceIdQuery, AddressWithPostcodeByPlaceIdQueryVariables>(AddressWithPostcodeByPlaceIdDocument, options);
      }
export function useAddressWithPostcodeByPlaceIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddressWithPostcodeByPlaceIdQuery, AddressWithPostcodeByPlaceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddressWithPostcodeByPlaceIdQuery, AddressWithPostcodeByPlaceIdQueryVariables>(AddressWithPostcodeByPlaceIdDocument, options);
        }
export function useAddressWithPostcodeByPlaceIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AddressWithPostcodeByPlaceIdQuery, AddressWithPostcodeByPlaceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AddressWithPostcodeByPlaceIdQuery, AddressWithPostcodeByPlaceIdQueryVariables>(AddressWithPostcodeByPlaceIdDocument, options);
        }
export type AddressWithPostcodeByPlaceIdQueryHookResult = ReturnType<typeof useAddressWithPostcodeByPlaceIdQuery>;
export type AddressWithPostcodeByPlaceIdLazyQueryHookResult = ReturnType<typeof useAddressWithPostcodeByPlaceIdLazyQuery>;
export type AddressWithPostcodeByPlaceIdSuspenseQueryHookResult = ReturnType<typeof useAddressWithPostcodeByPlaceIdSuspenseQuery>;
export type AddressWithPostcodeByPlaceIdQueryResult = Apollo.QueryResult<AddressWithPostcodeByPlaceIdQuery, AddressWithPostcodeByPlaceIdQueryVariables>;
export const LocationByCoordinatesDocument = gql`
    query LocationByCoordinates($input: LocationByCoordinatesInput!) {
  locationByCoordinates(input: $input) {
    country
  }
}
    `;

/**
 * __useLocationByCoordinatesQuery__
 *
 * To run a query within a React component, call `useLocationByCoordinatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationByCoordinatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationByCoordinatesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLocationByCoordinatesQuery(baseOptions: Apollo.QueryHookOptions<LocationByCoordinatesQuery, LocationByCoordinatesQueryVariables> & ({ variables: LocationByCoordinatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationByCoordinatesQuery, LocationByCoordinatesQueryVariables>(LocationByCoordinatesDocument, options);
      }
export function useLocationByCoordinatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationByCoordinatesQuery, LocationByCoordinatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationByCoordinatesQuery, LocationByCoordinatesQueryVariables>(LocationByCoordinatesDocument, options);
        }
export function useLocationByCoordinatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocationByCoordinatesQuery, LocationByCoordinatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocationByCoordinatesQuery, LocationByCoordinatesQueryVariables>(LocationByCoordinatesDocument, options);
        }
export type LocationByCoordinatesQueryHookResult = ReturnType<typeof useLocationByCoordinatesQuery>;
export type LocationByCoordinatesLazyQueryHookResult = ReturnType<typeof useLocationByCoordinatesLazyQuery>;
export type LocationByCoordinatesSuspenseQueryHookResult = ReturnType<typeof useLocationByCoordinatesSuspenseQuery>;
export type LocationByCoordinatesQueryResult = Apollo.QueryResult<LocationByCoordinatesQuery, LocationByCoordinatesQueryVariables>;
export const UpdateCompanyAddressDetailsDocument = gql`
    mutation UpdateCompanyAddressDetails($input: UpdateCompanyAddressDetailsInput!) {
  updateCompanyAddressDetails(input: $input)
}
    `;
export type UpdateCompanyAddressDetailsMutationFn = Apollo.MutationFunction<UpdateCompanyAddressDetailsMutation, UpdateCompanyAddressDetailsMutationVariables>;

/**
 * __useUpdateCompanyAddressDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyAddressDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyAddressDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyAddressDetailsMutation, { data, loading, error }] = useUpdateCompanyAddressDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyAddressDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyAddressDetailsMutation, UpdateCompanyAddressDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyAddressDetailsMutation, UpdateCompanyAddressDetailsMutationVariables>(UpdateCompanyAddressDetailsDocument, options);
      }
export type UpdateCompanyAddressDetailsMutationHookResult = ReturnType<typeof useUpdateCompanyAddressDetailsMutation>;
export type UpdateCompanyAddressDetailsMutationResult = Apollo.MutationResult<UpdateCompanyAddressDetailsMutation>;
export type UpdateCompanyAddressDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyAddressDetailsMutation, UpdateCompanyAddressDetailsMutationVariables>;
export const BidByIdDocument = gql`
    query BidById($bidId: Int!) {
  bidById(bidId: $bidId) {
    ...BidInfo
    files {
      ...FileInfo
    }
    brand {
      ...BrandInfo
    }
    user {
      ...UserInfo
    }
    bidRatingFeedbackValues {
      ratingFeedbackValueId
    }
    tender {
      ...TenderInfo
      wholesalers {
        ...WholesalerInfo
      }
      files {
        ...FileInfo
      }
      user {
        ...UserInfo
      }
      venue {
        ...VenueInfo
      }
      listingType {
        ...ListingTypeInfo
      }
      productCategories {
        ...ProductCategoryInfo
      }
    }
  }
}
    ${BidInfoFragmentDoc}
${FileInfoFragmentDoc}
${BrandInfoFragmentDoc}
${UserInfoFragmentDoc}
${TenderInfoFragmentDoc}
${WholesalerInfoFragmentDoc}
${VenueInfoFragmentDoc}
${ListingTypeInfoFragmentDoc}
${ProductCategoryInfoFragmentDoc}`;

/**
 * __useBidByIdQuery__
 *
 * To run a query within a React component, call `useBidByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidByIdQuery({
 *   variables: {
 *      bidId: // value for 'bidId'
 *   },
 * });
 */
export function useBidByIdQuery(baseOptions: Apollo.QueryHookOptions<BidByIdQuery, BidByIdQueryVariables> & ({ variables: BidByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BidByIdQuery, BidByIdQueryVariables>(BidByIdDocument, options);
      }
export function useBidByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BidByIdQuery, BidByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BidByIdQuery, BidByIdQueryVariables>(BidByIdDocument, options);
        }
export function useBidByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BidByIdQuery, BidByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BidByIdQuery, BidByIdQueryVariables>(BidByIdDocument, options);
        }
export type BidByIdQueryHookResult = ReturnType<typeof useBidByIdQuery>;
export type BidByIdLazyQueryHookResult = ReturnType<typeof useBidByIdLazyQuery>;
export type BidByIdSuspenseQueryHookResult = ReturnType<typeof useBidByIdSuspenseQuery>;
export type BidByIdQueryResult = Apollo.QueryResult<BidByIdQuery, BidByIdQueryVariables>;
export const PreviousBidDocument = gql`
    query PreviousBid($brandId: Int!) {
  previousBid(brandId: $brandId) {
    ...BidInfo
  }
}
    ${BidInfoFragmentDoc}`;

/**
 * __usePreviousBidQuery__
 *
 * To run a query within a React component, call `usePreviousBidQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviousBidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviousBidQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function usePreviousBidQuery(baseOptions: Apollo.QueryHookOptions<PreviousBidQuery, PreviousBidQueryVariables> & ({ variables: PreviousBidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviousBidQuery, PreviousBidQueryVariables>(PreviousBidDocument, options);
      }
export function usePreviousBidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviousBidQuery, PreviousBidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviousBidQuery, PreviousBidQueryVariables>(PreviousBidDocument, options);
        }
export function usePreviousBidSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PreviousBidQuery, PreviousBidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PreviousBidQuery, PreviousBidQueryVariables>(PreviousBidDocument, options);
        }
export type PreviousBidQueryHookResult = ReturnType<typeof usePreviousBidQuery>;
export type PreviousBidLazyQueryHookResult = ReturnType<typeof usePreviousBidLazyQuery>;
export type PreviousBidSuspenseQueryHookResult = ReturnType<typeof usePreviousBidSuspenseQuery>;
export type PreviousBidQueryResult = Apollo.QueryResult<PreviousBidQuery, PreviousBidQueryVariables>;
export const BidsForMultiSelectDocument = gql`
    query BidsForMultiSelect($input: BidsInput!) {
  bids(input: $input) {
    data {
      id
      support {
        ...ComputedSupportInfo
      }
    }
  }
}
    ${ComputedSupportInfoFragmentDoc}`;

/**
 * __useBidsForMultiSelectQuery__
 *
 * To run a query within a React component, call `useBidsForMultiSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidsForMultiSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidsForMultiSelectQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBidsForMultiSelectQuery(baseOptions: Apollo.QueryHookOptions<BidsForMultiSelectQuery, BidsForMultiSelectQueryVariables> & ({ variables: BidsForMultiSelectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BidsForMultiSelectQuery, BidsForMultiSelectQueryVariables>(BidsForMultiSelectDocument, options);
      }
export function useBidsForMultiSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BidsForMultiSelectQuery, BidsForMultiSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BidsForMultiSelectQuery, BidsForMultiSelectQueryVariables>(BidsForMultiSelectDocument, options);
        }
export function useBidsForMultiSelectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BidsForMultiSelectQuery, BidsForMultiSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BidsForMultiSelectQuery, BidsForMultiSelectQueryVariables>(BidsForMultiSelectDocument, options);
        }
export type BidsForMultiSelectQueryHookResult = ReturnType<typeof useBidsForMultiSelectQuery>;
export type BidsForMultiSelectLazyQueryHookResult = ReturnType<typeof useBidsForMultiSelectLazyQuery>;
export type BidsForMultiSelectSuspenseQueryHookResult = ReturnType<typeof useBidsForMultiSelectSuspenseQuery>;
export type BidsForMultiSelectQueryResult = Apollo.QueryResult<BidsForMultiSelectQuery, BidsForMultiSelectQueryVariables>;
export const BidsForMultiSelectTableDocument = gql`
    query BidsForMultiSelectTable($input: BidsInput!) {
  bids(input: $input) {
    data {
      id
      tenderId
      productUrl
      productName
      isDirectSupplyCompatible
      areWholesalersCompatible
      isAnyWholesalerCompatible
      averageWholesalePrice
      netPrice
      unitType
      volumePerUnit
      unitsPerCase
      volumeUnits
      packagingType
      region
      retroDiscountAmountPerUnit
      rating
      support {
        ...ComputedSupportInfo
      }
      brand {
        name
      }
      tender {
        id
        name
      }
    }
  }
}
    ${ComputedSupportInfoFragmentDoc}`;

/**
 * __useBidsForMultiSelectTableQuery__
 *
 * To run a query within a React component, call `useBidsForMultiSelectTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidsForMultiSelectTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidsForMultiSelectTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBidsForMultiSelectTableQuery(baseOptions: Apollo.QueryHookOptions<BidsForMultiSelectTableQuery, BidsForMultiSelectTableQueryVariables> & ({ variables: BidsForMultiSelectTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BidsForMultiSelectTableQuery, BidsForMultiSelectTableQueryVariables>(BidsForMultiSelectTableDocument, options);
      }
export function useBidsForMultiSelectTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BidsForMultiSelectTableQuery, BidsForMultiSelectTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BidsForMultiSelectTableQuery, BidsForMultiSelectTableQueryVariables>(BidsForMultiSelectTableDocument, options);
        }
export function useBidsForMultiSelectTableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BidsForMultiSelectTableQuery, BidsForMultiSelectTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BidsForMultiSelectTableQuery, BidsForMultiSelectTableQueryVariables>(BidsForMultiSelectTableDocument, options);
        }
export type BidsForMultiSelectTableQueryHookResult = ReturnType<typeof useBidsForMultiSelectTableQuery>;
export type BidsForMultiSelectTableLazyQueryHookResult = ReturnType<typeof useBidsForMultiSelectTableLazyQuery>;
export type BidsForMultiSelectTableSuspenseQueryHookResult = ReturnType<typeof useBidsForMultiSelectTableSuspenseQuery>;
export type BidsForMultiSelectTableQueryResult = Apollo.QueryResult<BidsForMultiSelectTableQuery, BidsForMultiSelectTableQueryVariables>;
export const BidsDocument = gql`
    query Bids($input: BidsInput!) {
  bids(input: $input) {
    data {
      ...BidInfo
      files {
        ...FileInfo
      }
      brand {
        ...BrandInfo
      }
      user {
        email
        phoneNumber
        contactName
      }
      bidRatingFeedbackValues {
        ratingFeedbackValueId
      }
      tender {
        ...TenderInfo
        listingType {
          ...ListingTypeInfo
        }
      }
    }
    pageInfo {
      ...OffsetPageInfo
    }
    totalCount
  }
}
    ${BidInfoFragmentDoc}
${FileInfoFragmentDoc}
${BrandInfoFragmentDoc}
${TenderInfoFragmentDoc}
${ListingTypeInfoFragmentDoc}
${OffsetPageInfoFragmentDoc}`;

/**
 * __useBidsQuery__
 *
 * To run a query within a React component, call `useBidsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBidsQuery(baseOptions: Apollo.QueryHookOptions<BidsQuery, BidsQueryVariables> & ({ variables: BidsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BidsQuery, BidsQueryVariables>(BidsDocument, options);
      }
export function useBidsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BidsQuery, BidsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BidsQuery, BidsQueryVariables>(BidsDocument, options);
        }
export function useBidsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BidsQuery, BidsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BidsQuery, BidsQueryVariables>(BidsDocument, options);
        }
export type BidsQueryHookResult = ReturnType<typeof useBidsQuery>;
export type BidsLazyQueryHookResult = ReturnType<typeof useBidsLazyQuery>;
export type BidsSuspenseQueryHookResult = ReturnType<typeof useBidsSuspenseQuery>;
export type BidsQueryResult = Apollo.QueryResult<BidsQuery, BidsQueryVariables>;
export const BidIdsForSelectionDocument = gql`
    query BidIdsForSelection($filter: BidsViewFiltersInput!) {
  bidIdsForSelection(filter: $filter)
}
    `;

/**
 * __useBidIdsForSelectionQuery__
 *
 * To run a query within a React component, call `useBidIdsForSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidIdsForSelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidIdsForSelectionQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBidIdsForSelectionQuery(baseOptions: Apollo.QueryHookOptions<BidIdsForSelectionQuery, BidIdsForSelectionQueryVariables> & ({ variables: BidIdsForSelectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BidIdsForSelectionQuery, BidIdsForSelectionQueryVariables>(BidIdsForSelectionDocument, options);
      }
export function useBidIdsForSelectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BidIdsForSelectionQuery, BidIdsForSelectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BidIdsForSelectionQuery, BidIdsForSelectionQueryVariables>(BidIdsForSelectionDocument, options);
        }
export function useBidIdsForSelectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BidIdsForSelectionQuery, BidIdsForSelectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BidIdsForSelectionQuery, BidIdsForSelectionQueryVariables>(BidIdsForSelectionDocument, options);
        }
export type BidIdsForSelectionQueryHookResult = ReturnType<typeof useBidIdsForSelectionQuery>;
export type BidIdsForSelectionLazyQueryHookResult = ReturnType<typeof useBidIdsForSelectionLazyQuery>;
export type BidIdsForSelectionSuspenseQueryHookResult = ReturnType<typeof useBidIdsForSelectionSuspenseQuery>;
export type BidIdsForSelectionQueryResult = Apollo.QueryResult<BidIdsForSelectionQuery, BidIdsForSelectionQueryVariables>;
export const BrandDashboardBidsDocument = gql`
    query BrandDashboardBids($input: BidsInput!) {
  bids(input: $input) {
    data {
      ...BrandDashboardBidData
      tender {
        ...TenderInfo
        wholesalers {
          ...WholesalerInfo
        }
        files {
          ...FileInfo
        }
        venue {
          ...VenueInfo
        }
        listingType {
          ...ListingTypeInfo
        }
        productCategories {
          ...ProductCategoryInfo
        }
      }
    }
    totalCount
    pageInfo {
      ...OffsetPageInfo
    }
  }
}
    ${BrandDashboardBidDataFragmentDoc}
${TenderInfoFragmentDoc}
${WholesalerInfoFragmentDoc}
${FileInfoFragmentDoc}
${VenueInfoFragmentDoc}
${ListingTypeInfoFragmentDoc}
${ProductCategoryInfoFragmentDoc}
${OffsetPageInfoFragmentDoc}`;

/**
 * __useBrandDashboardBidsQuery__
 *
 * To run a query within a React component, call `useBrandDashboardBidsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandDashboardBidsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandDashboardBidsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBrandDashboardBidsQuery(baseOptions: Apollo.QueryHookOptions<BrandDashboardBidsQuery, BrandDashboardBidsQueryVariables> & ({ variables: BrandDashboardBidsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandDashboardBidsQuery, BrandDashboardBidsQueryVariables>(BrandDashboardBidsDocument, options);
      }
export function useBrandDashboardBidsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandDashboardBidsQuery, BrandDashboardBidsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandDashboardBidsQuery, BrandDashboardBidsQueryVariables>(BrandDashboardBidsDocument, options);
        }
export function useBrandDashboardBidsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BrandDashboardBidsQuery, BrandDashboardBidsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrandDashboardBidsQuery, BrandDashboardBidsQueryVariables>(BrandDashboardBidsDocument, options);
        }
export type BrandDashboardBidsQueryHookResult = ReturnType<typeof useBrandDashboardBidsQuery>;
export type BrandDashboardBidsLazyQueryHookResult = ReturnType<typeof useBrandDashboardBidsLazyQuery>;
export type BrandDashboardBidsSuspenseQueryHookResult = ReturnType<typeof useBrandDashboardBidsSuspenseQuery>;
export type BrandDashboardBidsQueryResult = Apollo.QueryResult<BrandDashboardBidsQuery, BrandDashboardBidsQueryVariables>;
export const BrandDashboardPdfDataDocument = gql`
    query BrandDashboardPDFData($bidId: Int!) {
  bidById(bidId: $bidId) {
    ...BidInfo
    brand {
      ...BrandInfo
    }
    user {
      ...UserInfo
    }
    files {
      ...FileInfo
    }
    wholesalers {
      ...WholesalerInfo
    }
    tender {
      ...TenderInfo
      user {
        ...UserInfo
      }
      files {
        ...FileInfo
      }
      venue {
        ...VenueInfo
      }
      listingType {
        ...ListingTypeInfo
      }
      productCategories {
        ...ProductCategoryInfo
      }
    }
  }
}
    ${BidInfoFragmentDoc}
${BrandInfoFragmentDoc}
${UserInfoFragmentDoc}
${FileInfoFragmentDoc}
${WholesalerInfoFragmentDoc}
${TenderInfoFragmentDoc}
${VenueInfoFragmentDoc}
${ListingTypeInfoFragmentDoc}
${ProductCategoryInfoFragmentDoc}`;

/**
 * __useBrandDashboardPdfDataQuery__
 *
 * To run a query within a React component, call `useBrandDashboardPdfDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandDashboardPdfDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandDashboardPdfDataQuery({
 *   variables: {
 *      bidId: // value for 'bidId'
 *   },
 * });
 */
export function useBrandDashboardPdfDataQuery(baseOptions: Apollo.QueryHookOptions<BrandDashboardPdfDataQuery, BrandDashboardPdfDataQueryVariables> & ({ variables: BrandDashboardPdfDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandDashboardPdfDataQuery, BrandDashboardPdfDataQueryVariables>(BrandDashboardPdfDataDocument, options);
      }
export function useBrandDashboardPdfDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandDashboardPdfDataQuery, BrandDashboardPdfDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandDashboardPdfDataQuery, BrandDashboardPdfDataQueryVariables>(BrandDashboardPdfDataDocument, options);
        }
export function useBrandDashboardPdfDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BrandDashboardPdfDataQuery, BrandDashboardPdfDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrandDashboardPdfDataQuery, BrandDashboardPdfDataQueryVariables>(BrandDashboardPdfDataDocument, options);
        }
export type BrandDashboardPdfDataQueryHookResult = ReturnType<typeof useBrandDashboardPdfDataQuery>;
export type BrandDashboardPdfDataLazyQueryHookResult = ReturnType<typeof useBrandDashboardPdfDataLazyQuery>;
export type BrandDashboardPdfDataSuspenseQueryHookResult = ReturnType<typeof useBrandDashboardPdfDataSuspenseQuery>;
export type BrandDashboardPdfDataQueryResult = Apollo.QueryResult<BrandDashboardPdfDataQuery, BrandDashboardPdfDataQueryVariables>;
export const WinningBidsByTenderIdDocument = gql`
    query WinningBidsByTenderId($tenderId: Int!) {
  winningBidsByTenderId(tenderId: $tenderId) {
    ...BidInfo
    brand {
      ...BrandInfo
    }
    user {
      ...UserInfo
    }
    bidRatingFeedbackValues {
      ratingFeedbackValueId
    }
    tender {
      ...TenderInfo
      user {
        ...UserInfo
      }
      wholesalers {
        ...WholesalerInfo
      }
      files {
        ...FileInfo
      }
      venue {
        ...VenueInfo
      }
      listingType {
        ...ListingTypeInfo
      }
      productCategories {
        ...ProductCategoryInfo
      }
    }
    files {
      ...FileInfo
    }
  }
}
    ${BidInfoFragmentDoc}
${BrandInfoFragmentDoc}
${UserInfoFragmentDoc}
${TenderInfoFragmentDoc}
${WholesalerInfoFragmentDoc}
${FileInfoFragmentDoc}
${VenueInfoFragmentDoc}
${ListingTypeInfoFragmentDoc}
${ProductCategoryInfoFragmentDoc}`;

/**
 * __useWinningBidsByTenderIdQuery__
 *
 * To run a query within a React component, call `useWinningBidsByTenderIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useWinningBidsByTenderIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWinningBidsByTenderIdQuery({
 *   variables: {
 *      tenderId: // value for 'tenderId'
 *   },
 * });
 */
export function useWinningBidsByTenderIdQuery(baseOptions: Apollo.QueryHookOptions<WinningBidsByTenderIdQuery, WinningBidsByTenderIdQueryVariables> & ({ variables: WinningBidsByTenderIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WinningBidsByTenderIdQuery, WinningBidsByTenderIdQueryVariables>(WinningBidsByTenderIdDocument, options);
      }
export function useWinningBidsByTenderIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WinningBidsByTenderIdQuery, WinningBidsByTenderIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WinningBidsByTenderIdQuery, WinningBidsByTenderIdQueryVariables>(WinningBidsByTenderIdDocument, options);
        }
export function useWinningBidsByTenderIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WinningBidsByTenderIdQuery, WinningBidsByTenderIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WinningBidsByTenderIdQuery, WinningBidsByTenderIdQueryVariables>(WinningBidsByTenderIdDocument, options);
        }
export type WinningBidsByTenderIdQueryHookResult = ReturnType<typeof useWinningBidsByTenderIdQuery>;
export type WinningBidsByTenderIdLazyQueryHookResult = ReturnType<typeof useWinningBidsByTenderIdLazyQuery>;
export type WinningBidsByTenderIdSuspenseQueryHookResult = ReturnType<typeof useWinningBidsByTenderIdSuspenseQuery>;
export type WinningBidsByTenderIdQueryResult = Apollo.QueryResult<WinningBidsByTenderIdQuery, WinningBidsByTenderIdQueryVariables>;
export const BidsViewFilterOptionsDocument = gql`
    query bidsViewFilterOptions($input: BidsFilterOptionsInput!) {
  bidsViewFilterOptions(input: $input) {
    label
    options {
      label
      value
    }
  }
}
    `;

/**
 * __useBidsViewFilterOptionsQuery__
 *
 * To run a query within a React component, call `useBidsViewFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidsViewFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidsViewFilterOptionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBidsViewFilterOptionsQuery(baseOptions: Apollo.QueryHookOptions<BidsViewFilterOptionsQuery, BidsViewFilterOptionsQueryVariables> & ({ variables: BidsViewFilterOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BidsViewFilterOptionsQuery, BidsViewFilterOptionsQueryVariables>(BidsViewFilterOptionsDocument, options);
      }
export function useBidsViewFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BidsViewFilterOptionsQuery, BidsViewFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BidsViewFilterOptionsQuery, BidsViewFilterOptionsQueryVariables>(BidsViewFilterOptionsDocument, options);
        }
export function useBidsViewFilterOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BidsViewFilterOptionsQuery, BidsViewFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BidsViewFilterOptionsQuery, BidsViewFilterOptionsQueryVariables>(BidsViewFilterOptionsDocument, options);
        }
export type BidsViewFilterOptionsQueryHookResult = ReturnType<typeof useBidsViewFilterOptionsQuery>;
export type BidsViewFilterOptionsLazyQueryHookResult = ReturnType<typeof useBidsViewFilterOptionsLazyQuery>;
export type BidsViewFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useBidsViewFilterOptionsSuspenseQuery>;
export type BidsViewFilterOptionsQueryResult = Apollo.QueryResult<BidsViewFilterOptionsQuery, BidsViewFilterOptionsQueryVariables>;
export const RateBidDocument = gql`
    mutation RateBid($input: CommonBidRateInput!) {
  rateBid(input: $input) {
    id
    tenderId
    userId
    rating
    ratingComment
    bidRatingFeedbackValues {
      ratingFeedbackValueId
    }
    isRatingOutdated
  }
}
    `;
export type RateBidMutationFn = Apollo.MutationFunction<RateBidMutation, RateBidMutationVariables>;

/**
 * __useRateBidMutation__
 *
 * To run a mutation, you first call `useRateBidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRateBidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rateBidMutation, { data, loading, error }] = useRateBidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRateBidMutation(baseOptions?: Apollo.MutationHookOptions<RateBidMutation, RateBidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RateBidMutation, RateBidMutationVariables>(RateBidDocument, options);
      }
export type RateBidMutationHookResult = ReturnType<typeof useRateBidMutation>;
export type RateBidMutationResult = Apollo.MutationResult<RateBidMutation>;
export type RateBidMutationOptions = Apollo.BaseMutationOptions<RateBidMutation, RateBidMutationVariables>;
export const DeleteBidByIdDocument = gql`
    mutation DeleteBidById($bidId: NonNegativeInt!) {
  deleteBidById(bidId: $bidId)
}
    `;
export type DeleteBidByIdMutationFn = Apollo.MutationFunction<DeleteBidByIdMutation, DeleteBidByIdMutationVariables>;

/**
 * __useDeleteBidByIdMutation__
 *
 * To run a mutation, you first call `useDeleteBidByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBidByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBidByIdMutation, { data, loading, error }] = useDeleteBidByIdMutation({
 *   variables: {
 *      bidId: // value for 'bidId'
 *   },
 * });
 */
export function useDeleteBidByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBidByIdMutation, DeleteBidByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBidByIdMutation, DeleteBidByIdMutationVariables>(DeleteBidByIdDocument, options);
      }
export type DeleteBidByIdMutationHookResult = ReturnType<typeof useDeleteBidByIdMutation>;
export type DeleteBidByIdMutationResult = Apollo.MutationResult<DeleteBidByIdMutation>;
export type DeleteBidByIdMutationOptions = Apollo.BaseMutationOptions<DeleteBidByIdMutation, DeleteBidByIdMutationVariables>;
export const InsertIntoConnectBidDocument = gql`
    mutation InsertIntoConnectBid($input: ConnectBidInsertInput!) {
  insertIntoConnectBid(input: $input) {
    bidId
    tenderId
    commonBid {
      id
      successFee
      product {
        volumePerUnit
        unitType
        averageWholesalePrice
      }
      supports {
        amount
        notes
        supportType
      }
    }
  }
}
    `;
export type InsertIntoConnectBidMutationFn = Apollo.MutationFunction<InsertIntoConnectBidMutation, InsertIntoConnectBidMutationVariables>;

/**
 * __useInsertIntoConnectBidMutation__
 *
 * To run a mutation, you first call `useInsertIntoConnectBidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertIntoConnectBidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertIntoConnectBidMutation, { data, loading, error }] = useInsertIntoConnectBidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInsertIntoConnectBidMutation(baseOptions?: Apollo.MutationHookOptions<InsertIntoConnectBidMutation, InsertIntoConnectBidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertIntoConnectBidMutation, InsertIntoConnectBidMutationVariables>(InsertIntoConnectBidDocument, options);
      }
export type InsertIntoConnectBidMutationHookResult = ReturnType<typeof useInsertIntoConnectBidMutation>;
export type InsertIntoConnectBidMutationResult = Apollo.MutationResult<InsertIntoConnectBidMutation>;
export type InsertIntoConnectBidMutationOptions = Apollo.BaseMutationOptions<InsertIntoConnectBidMutation, InsertIntoConnectBidMutationVariables>;
export const EditBidDocument = gql`
    mutation EditBid($input: EditBidInput!) {
  editBid(input: $input) {
    id
  }
}
    `;
export type EditBidMutationFn = Apollo.MutationFunction<EditBidMutation, EditBidMutationVariables>;

/**
 * __useEditBidMutation__
 *
 * To run a mutation, you first call `useEditBidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditBidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editBidMutation, { data, loading, error }] = useEditBidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditBidMutation(baseOptions?: Apollo.MutationHookOptions<EditBidMutation, EditBidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditBidMutation, EditBidMutationVariables>(EditBidDocument, options);
      }
export type EditBidMutationHookResult = ReturnType<typeof useEditBidMutation>;
export type EditBidMutationResult = Apollo.MutationResult<EditBidMutation>;
export type EditBidMutationOptions = Apollo.BaseMutationOptions<EditBidMutation, EditBidMutationVariables>;
export const SampleRequestDocument = gql`
    mutation SampleRequest($input: CommonBidSampleRequestInput!) {
  sampleRequest(input: $input)
}
    `;
export type SampleRequestMutationFn = Apollo.MutationFunction<SampleRequestMutation, SampleRequestMutationVariables>;

/**
 * __useSampleRequestMutation__
 *
 * To run a mutation, you first call `useSampleRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSampleRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sampleRequestMutation, { data, loading, error }] = useSampleRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSampleRequestMutation(baseOptions?: Apollo.MutationHookOptions<SampleRequestMutation, SampleRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SampleRequestMutation, SampleRequestMutationVariables>(SampleRequestDocument, options);
      }
export type SampleRequestMutationHookResult = ReturnType<typeof useSampleRequestMutation>;
export type SampleRequestMutationResult = Apollo.MutationResult<SampleRequestMutation>;
export type SampleRequestMutationOptions = Apollo.BaseMutationOptions<SampleRequestMutation, SampleRequestMutationVariables>;
export const EditBidSupportStatusDocument = gql`
    mutation EditBidSupportStatus($input: EditBidSupportStatusInput!) {
  editBidSupportStatus(input: $input) {
    ...BidInfo
  }
}
    ${BidInfoFragmentDoc}`;
export type EditBidSupportStatusMutationFn = Apollo.MutationFunction<EditBidSupportStatusMutation, EditBidSupportStatusMutationVariables>;

/**
 * __useEditBidSupportStatusMutation__
 *
 * To run a mutation, you first call `useEditBidSupportStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditBidSupportStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editBidSupportStatusMutation, { data, loading, error }] = useEditBidSupportStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditBidSupportStatusMutation(baseOptions?: Apollo.MutationHookOptions<EditBidSupportStatusMutation, EditBidSupportStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditBidSupportStatusMutation, EditBidSupportStatusMutationVariables>(EditBidSupportStatusDocument, options);
      }
export type EditBidSupportStatusMutationHookResult = ReturnType<typeof useEditBidSupportStatusMutation>;
export type EditBidSupportStatusMutationResult = Apollo.MutationResult<EditBidSupportStatusMutation>;
export type EditBidSupportStatusMutationOptions = Apollo.BaseMutationOptions<EditBidSupportStatusMutation, EditBidSupportStatusMutationVariables>;
export const AreWholesalersCompatibleDocument = gql`
    query AreWholesalersCompatible($bidId: NonNegativeInt!) {
  areWholesalersCompatible(bidId: $bidId)
}
    `;

/**
 * __useAreWholesalersCompatibleQuery__
 *
 * To run a query within a React component, call `useAreWholesalersCompatibleQuery` and pass it any options that fit your needs.
 * When your component renders, `useAreWholesalersCompatibleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAreWholesalersCompatibleQuery({
 *   variables: {
 *      bidId: // value for 'bidId'
 *   },
 * });
 */
export function useAreWholesalersCompatibleQuery(baseOptions: Apollo.QueryHookOptions<AreWholesalersCompatibleQuery, AreWholesalersCompatibleQueryVariables> & ({ variables: AreWholesalersCompatibleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AreWholesalersCompatibleQuery, AreWholesalersCompatibleQueryVariables>(AreWholesalersCompatibleDocument, options);
      }
export function useAreWholesalersCompatibleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AreWholesalersCompatibleQuery, AreWholesalersCompatibleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AreWholesalersCompatibleQuery, AreWholesalersCompatibleQueryVariables>(AreWholesalersCompatibleDocument, options);
        }
export function useAreWholesalersCompatibleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AreWholesalersCompatibleQuery, AreWholesalersCompatibleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AreWholesalersCompatibleQuery, AreWholesalersCompatibleQueryVariables>(AreWholesalersCompatibleDocument, options);
        }
export type AreWholesalersCompatibleQueryHookResult = ReturnType<typeof useAreWholesalersCompatibleQuery>;
export type AreWholesalersCompatibleLazyQueryHookResult = ReturnType<typeof useAreWholesalersCompatibleLazyQuery>;
export type AreWholesalersCompatibleSuspenseQueryHookResult = ReturnType<typeof useAreWholesalersCompatibleSuspenseQuery>;
export type AreWholesalersCompatibleQueryResult = Apollo.QueryResult<AreWholesalersCompatibleQuery, AreWholesalersCompatibleQueryVariables>;
export const EditBrandDocument = gql`
    mutation EditBrand($input: EditBrandInput!) {
  editBrand(input: $input) {
    ...BrandInfo
  }
}
    ${BrandInfoFragmentDoc}`;
export type EditBrandMutationFn = Apollo.MutationFunction<EditBrandMutation, EditBrandMutationVariables>;

/**
 * __useEditBrandMutation__
 *
 * To run a mutation, you first call `useEditBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editBrandMutation, { data, loading, error }] = useEditBrandMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditBrandMutation(baseOptions?: Apollo.MutationHookOptions<EditBrandMutation, EditBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditBrandMutation, EditBrandMutationVariables>(EditBrandDocument, options);
      }
export type EditBrandMutationHookResult = ReturnType<typeof useEditBrandMutation>;
export type EditBrandMutationResult = Apollo.MutationResult<EditBrandMutation>;
export type EditBrandMutationOptions = Apollo.BaseMutationOptions<EditBrandMutation, EditBrandMutationVariables>;
export const GetDataFromCompanyVatDocument = gql`
    query GetDataFromCompanyVat($input: GetCompanyVatDetailsInput!) {
  getCompanyVatDetails(input: $input) {
    vatNumber
    vatCompanyName
    vatCountryCode
    vatConsultationNumber
    vatProcessingDate
  }
}
    `;

/**
 * __useGetDataFromCompanyVatQuery__
 *
 * To run a query within a React component, call `useGetDataFromCompanyVatQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataFromCompanyVatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataFromCompanyVatQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDataFromCompanyVatQuery(baseOptions: Apollo.QueryHookOptions<GetDataFromCompanyVatQuery, GetDataFromCompanyVatQueryVariables> & ({ variables: GetDataFromCompanyVatQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataFromCompanyVatQuery, GetDataFromCompanyVatQueryVariables>(GetDataFromCompanyVatDocument, options);
      }
export function useGetDataFromCompanyVatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataFromCompanyVatQuery, GetDataFromCompanyVatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataFromCompanyVatQuery, GetDataFromCompanyVatQueryVariables>(GetDataFromCompanyVatDocument, options);
        }
export function useGetDataFromCompanyVatSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDataFromCompanyVatQuery, GetDataFromCompanyVatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDataFromCompanyVatQuery, GetDataFromCompanyVatQueryVariables>(GetDataFromCompanyVatDocument, options);
        }
export type GetDataFromCompanyVatQueryHookResult = ReturnType<typeof useGetDataFromCompanyVatQuery>;
export type GetDataFromCompanyVatLazyQueryHookResult = ReturnType<typeof useGetDataFromCompanyVatLazyQuery>;
export type GetDataFromCompanyVatSuspenseQueryHookResult = ReturnType<typeof useGetDataFromCompanyVatSuspenseQuery>;
export type GetDataFromCompanyVatQueryResult = Apollo.QueryResult<GetDataFromCompanyVatQuery, GetDataFromCompanyVatQueryVariables>;
export const UserBrandsDocument = gql`
    query UserBrands($input: UserBrandsInput!) {
  userBrands(input: $input) {
    edges {
      node {
        ...BrandInfo
      }
      cursor
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${BrandInfoFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useUserBrandsQuery__
 *
 * To run a query within a React component, call `useUserBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserBrandsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserBrandsQuery(baseOptions: Apollo.QueryHookOptions<UserBrandsQuery, UserBrandsQueryVariables> & ({ variables: UserBrandsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserBrandsQuery, UserBrandsQueryVariables>(UserBrandsDocument, options);
      }
export function useUserBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserBrandsQuery, UserBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserBrandsQuery, UserBrandsQueryVariables>(UserBrandsDocument, options);
        }
export function useUserBrandsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserBrandsQuery, UserBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserBrandsQuery, UserBrandsQueryVariables>(UserBrandsDocument, options);
        }
export type UserBrandsQueryHookResult = ReturnType<typeof useUserBrandsQuery>;
export type UserBrandsLazyQueryHookResult = ReturnType<typeof useUserBrandsLazyQuery>;
export type UserBrandsSuspenseQueryHookResult = ReturnType<typeof useUserBrandsSuspenseQuery>;
export type UserBrandsQueryResult = Apollo.QueryResult<UserBrandsQuery, UserBrandsQueryVariables>;
export const BrandByIdDocument = gql`
    query BrandById($brandId: Int!) {
  brandById(brandId: $brandId) {
    ...BrandInfo
  }
}
    ${BrandInfoFragmentDoc}`;

/**
 * __useBrandByIdQuery__
 *
 * To run a query within a React component, call `useBrandByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandByIdQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useBrandByIdQuery(baseOptions: Apollo.QueryHookOptions<BrandByIdQuery, BrandByIdQueryVariables> & ({ variables: BrandByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandByIdQuery, BrandByIdQueryVariables>(BrandByIdDocument, options);
      }
export function useBrandByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandByIdQuery, BrandByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandByIdQuery, BrandByIdQueryVariables>(BrandByIdDocument, options);
        }
export function useBrandByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BrandByIdQuery, BrandByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrandByIdQuery, BrandByIdQueryVariables>(BrandByIdDocument, options);
        }
export type BrandByIdQueryHookResult = ReturnType<typeof useBrandByIdQuery>;
export type BrandByIdLazyQueryHookResult = ReturnType<typeof useBrandByIdLazyQuery>;
export type BrandByIdSuspenseQueryHookResult = ReturnType<typeof useBrandByIdSuspenseQuery>;
export type BrandByIdQueryResult = Apollo.QueryResult<BrandByIdQuery, BrandByIdQueryVariables>;
export const BrandUsersDocument = gql`
    query BrandUsers($offset: Int, $limit: Int, $orderBy: BrandUserOrderBy, $where: BrandUserFilters) {
  brandUsers(offset: $offset, limit: $limit, orderBy: $orderBy, where: $where) {
    userId
    role
    user {
      id
      email
    }
  }
}
    `;

/**
 * __useBrandUsersQuery__
 *
 * To run a query within a React component, call `useBrandUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandUsersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useBrandUsersQuery(baseOptions?: Apollo.QueryHookOptions<BrandUsersQuery, BrandUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandUsersQuery, BrandUsersQueryVariables>(BrandUsersDocument, options);
      }
export function useBrandUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandUsersQuery, BrandUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandUsersQuery, BrandUsersQueryVariables>(BrandUsersDocument, options);
        }
export function useBrandUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BrandUsersQuery, BrandUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrandUsersQuery, BrandUsersQueryVariables>(BrandUsersDocument, options);
        }
export type BrandUsersQueryHookResult = ReturnType<typeof useBrandUsersQuery>;
export type BrandUsersLazyQueryHookResult = ReturnType<typeof useBrandUsersLazyQuery>;
export type BrandUsersSuspenseQueryHookResult = ReturnType<typeof useBrandUsersSuspenseQuery>;
export type BrandUsersQueryResult = Apollo.QueryResult<BrandUsersQuery, BrandUsersQueryVariables>;
export const DeleteBrandUserDocument = gql`
    mutation DeleteBrandUser($brandId: NonNegativeInt!, $userId: NonNegativeInt!) {
  deleteBrandUser(brandId: $brandId, userId: $userId) {
    ...BrandUserInfo
  }
}
    ${BrandUserInfoFragmentDoc}`;
export type DeleteBrandUserMutationFn = Apollo.MutationFunction<DeleteBrandUserMutation, DeleteBrandUserMutationVariables>;

/**
 * __useDeleteBrandUserMutation__
 *
 * To run a mutation, you first call `useDeleteBrandUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBrandUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBrandUserMutation, { data, loading, error }] = useDeleteBrandUserMutation({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteBrandUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBrandUserMutation, DeleteBrandUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBrandUserMutation, DeleteBrandUserMutationVariables>(DeleteBrandUserDocument, options);
      }
export type DeleteBrandUserMutationHookResult = ReturnType<typeof useDeleteBrandUserMutation>;
export type DeleteBrandUserMutationResult = Apollo.MutationResult<DeleteBrandUserMutation>;
export type DeleteBrandUserMutationOptions = Apollo.BaseMutationOptions<DeleteBrandUserMutation, DeleteBrandUserMutationVariables>;
export const SetBrandUserRoleDocument = gql`
    mutation SetBrandUserRole($brandId: NonNegativeInt!, $userId: NonNegativeInt!, $role: SetUserRole!) {
  setBrandUserRole(brandId: $brandId, userId: $userId, role: $role) {
    ...BrandUserInfo
  }
}
    ${BrandUserInfoFragmentDoc}`;
export type SetBrandUserRoleMutationFn = Apollo.MutationFunction<SetBrandUserRoleMutation, SetBrandUserRoleMutationVariables>;

/**
 * __useSetBrandUserRoleMutation__
 *
 * To run a mutation, you first call `useSetBrandUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBrandUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBrandUserRoleMutation, { data, loading, error }] = useSetBrandUserRoleMutation({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      userId: // value for 'userId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useSetBrandUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<SetBrandUserRoleMutation, SetBrandUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetBrandUserRoleMutation, SetBrandUserRoleMutationVariables>(SetBrandUserRoleDocument, options);
      }
export type SetBrandUserRoleMutationHookResult = ReturnType<typeof useSetBrandUserRoleMutation>;
export type SetBrandUserRoleMutationResult = Apollo.MutationResult<SetBrandUserRoleMutation>;
export type SetBrandUserRoleMutationOptions = Apollo.BaseMutationOptions<SetBrandUserRoleMutation, SetBrandUserRoleMutationVariables>;
export const InsertIntoBrandDocument = gql`
    mutation InsertIntoBrand($input: BrandInsertInput!) {
  insertIntoBrand(input: $input) {
    id
  }
}
    `;
export type InsertIntoBrandMutationFn = Apollo.MutationFunction<InsertIntoBrandMutation, InsertIntoBrandMutationVariables>;

/**
 * __useInsertIntoBrandMutation__
 *
 * To run a mutation, you first call `useInsertIntoBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertIntoBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertIntoBrandMutation, { data, loading, error }] = useInsertIntoBrandMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInsertIntoBrandMutation(baseOptions?: Apollo.MutationHookOptions<InsertIntoBrandMutation, InsertIntoBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertIntoBrandMutation, InsertIntoBrandMutationVariables>(InsertIntoBrandDocument, options);
      }
export type InsertIntoBrandMutationHookResult = ReturnType<typeof useInsertIntoBrandMutation>;
export type InsertIntoBrandMutationResult = Apollo.MutationResult<InsertIntoBrandMutation>;
export type InsertIntoBrandMutationOptions = Apollo.BaseMutationOptions<InsertIntoBrandMutation, InsertIntoBrandMutationVariables>;
export const UpdateBrandBillingAddressDocument = gql`
    mutation UpdateBrandBillingAddress($id: NonNegativeInt!, $input: AddressInsertInput!) {
  updateBrandBillingAddress(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateBrandBillingAddressMutationFn = Apollo.MutationFunction<UpdateBrandBillingAddressMutation, UpdateBrandBillingAddressMutationVariables>;

/**
 * __useUpdateBrandBillingAddressMutation__
 *
 * To run a mutation, you first call `useUpdateBrandBillingAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandBillingAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandBillingAddressMutation, { data, loading, error }] = useUpdateBrandBillingAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBrandBillingAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBrandBillingAddressMutation, UpdateBrandBillingAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBrandBillingAddressMutation, UpdateBrandBillingAddressMutationVariables>(UpdateBrandBillingAddressDocument, options);
      }
export type UpdateBrandBillingAddressMutationHookResult = ReturnType<typeof useUpdateBrandBillingAddressMutation>;
export type UpdateBrandBillingAddressMutationResult = Apollo.MutationResult<UpdateBrandBillingAddressMutation>;
export type UpdateBrandBillingAddressMutationOptions = Apollo.BaseMutationOptions<UpdateBrandBillingAddressMutation, UpdateBrandBillingAddressMutationVariables>;
export const BrandSubscriptionFeaturesDocument = gql`
    query BrandSubscriptionFeatures($brandId: NonNegativeInt!) {
  subscriptionFeatures(brandId: $brandId) {
    type
    value
    brandId
  }
}
    `;

/**
 * __useBrandSubscriptionFeaturesQuery__
 *
 * To run a query within a React component, call `useBrandSubscriptionFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandSubscriptionFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandSubscriptionFeaturesQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useBrandSubscriptionFeaturesQuery(baseOptions: Apollo.QueryHookOptions<BrandSubscriptionFeaturesQuery, BrandSubscriptionFeaturesQueryVariables> & ({ variables: BrandSubscriptionFeaturesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandSubscriptionFeaturesQuery, BrandSubscriptionFeaturesQueryVariables>(BrandSubscriptionFeaturesDocument, options);
      }
export function useBrandSubscriptionFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandSubscriptionFeaturesQuery, BrandSubscriptionFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandSubscriptionFeaturesQuery, BrandSubscriptionFeaturesQueryVariables>(BrandSubscriptionFeaturesDocument, options);
        }
export function useBrandSubscriptionFeaturesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BrandSubscriptionFeaturesQuery, BrandSubscriptionFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrandSubscriptionFeaturesQuery, BrandSubscriptionFeaturesQueryVariables>(BrandSubscriptionFeaturesDocument, options);
        }
export type BrandSubscriptionFeaturesQueryHookResult = ReturnType<typeof useBrandSubscriptionFeaturesQuery>;
export type BrandSubscriptionFeaturesLazyQueryHookResult = ReturnType<typeof useBrandSubscriptionFeaturesLazyQuery>;
export type BrandSubscriptionFeaturesSuspenseQueryHookResult = ReturnType<typeof useBrandSubscriptionFeaturesSuspenseQuery>;
export type BrandSubscriptionFeaturesQueryResult = Apollo.QueryResult<BrandSubscriptionFeaturesQuery, BrandSubscriptionFeaturesQueryVariables>;
export const HasBidsDocument = gql`
    query HasBids($brandId: NonNegativeInt!) {
  hasBids(brandId: $brandId) {
    brandId
    hasBids
  }
}
    `;

/**
 * __useHasBidsQuery__
 *
 * To run a query within a React component, call `useHasBidsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasBidsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasBidsQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useHasBidsQuery(baseOptions: Apollo.QueryHookOptions<HasBidsQuery, HasBidsQueryVariables> & ({ variables: HasBidsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasBidsQuery, HasBidsQueryVariables>(HasBidsDocument, options);
      }
export function useHasBidsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasBidsQuery, HasBidsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasBidsQuery, HasBidsQueryVariables>(HasBidsDocument, options);
        }
export function useHasBidsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HasBidsQuery, HasBidsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HasBidsQuery, HasBidsQueryVariables>(HasBidsDocument, options);
        }
export type HasBidsQueryHookResult = ReturnType<typeof useHasBidsQuery>;
export type HasBidsLazyQueryHookResult = ReturnType<typeof useHasBidsLazyQuery>;
export type HasBidsSuspenseQueryHookResult = ReturnType<typeof useHasBidsSuspenseQuery>;
export type HasBidsQueryResult = Apollo.QueryResult<HasBidsQuery, HasBidsQueryVariables>;
export const BrandIntegrationsDocument = gql`
    query BrandIntegrations($brandId: Int!) {
  brandIntegrations(where: {brandId: {eq: $brandId}}) {
    ...BrandIntegrationItem
  }
}
    ${BrandIntegrationItemFragmentDoc}`;

/**
 * __useBrandIntegrationsQuery__
 *
 * To run a query within a React component, call `useBrandIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandIntegrationsQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useBrandIntegrationsQuery(baseOptions: Apollo.QueryHookOptions<BrandIntegrationsQuery, BrandIntegrationsQueryVariables> & ({ variables: BrandIntegrationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandIntegrationsQuery, BrandIntegrationsQueryVariables>(BrandIntegrationsDocument, options);
      }
export function useBrandIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandIntegrationsQuery, BrandIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandIntegrationsQuery, BrandIntegrationsQueryVariables>(BrandIntegrationsDocument, options);
        }
export function useBrandIntegrationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BrandIntegrationsQuery, BrandIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrandIntegrationsQuery, BrandIntegrationsQueryVariables>(BrandIntegrationsDocument, options);
        }
export type BrandIntegrationsQueryHookResult = ReturnType<typeof useBrandIntegrationsQuery>;
export type BrandIntegrationsLazyQueryHookResult = ReturnType<typeof useBrandIntegrationsLazyQuery>;
export type BrandIntegrationsSuspenseQueryHookResult = ReturnType<typeof useBrandIntegrationsSuspenseQuery>;
export type BrandIntegrationsQueryResult = Apollo.QueryResult<BrandIntegrationsQuery, BrandIntegrationsQueryVariables>;
export const BrandSettingsByBrandIdDocument = gql`
    query BrandSettingsByBrandId($brandId: Int!) {
  brandSettingsByBrandId(brandId: $brandId) {
    ...BrandSettingsInfo
  }
}
    ${BrandSettingsInfoFragmentDoc}`;

/**
 * __useBrandSettingsByBrandIdQuery__
 *
 * To run a query within a React component, call `useBrandSettingsByBrandIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandSettingsByBrandIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandSettingsByBrandIdQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useBrandSettingsByBrandIdQuery(baseOptions: Apollo.QueryHookOptions<BrandSettingsByBrandIdQuery, BrandSettingsByBrandIdQueryVariables> & ({ variables: BrandSettingsByBrandIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandSettingsByBrandIdQuery, BrandSettingsByBrandIdQueryVariables>(BrandSettingsByBrandIdDocument, options);
      }
export function useBrandSettingsByBrandIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandSettingsByBrandIdQuery, BrandSettingsByBrandIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandSettingsByBrandIdQuery, BrandSettingsByBrandIdQueryVariables>(BrandSettingsByBrandIdDocument, options);
        }
export function useBrandSettingsByBrandIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BrandSettingsByBrandIdQuery, BrandSettingsByBrandIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrandSettingsByBrandIdQuery, BrandSettingsByBrandIdQueryVariables>(BrandSettingsByBrandIdDocument, options);
        }
export type BrandSettingsByBrandIdQueryHookResult = ReturnType<typeof useBrandSettingsByBrandIdQuery>;
export type BrandSettingsByBrandIdLazyQueryHookResult = ReturnType<typeof useBrandSettingsByBrandIdLazyQuery>;
export type BrandSettingsByBrandIdSuspenseQueryHookResult = ReturnType<typeof useBrandSettingsByBrandIdSuspenseQuery>;
export type BrandSettingsByBrandIdQueryResult = Apollo.QueryResult<BrandSettingsByBrandIdQuery, BrandSettingsByBrandIdQueryVariables>;
export const EditBrandSettingsDocument = gql`
    mutation EditBrandSettings($input: EditBrandSettingsInput!) {
  editBrandSettings(input: $input) {
    ...BrandSettingsInfo
  }
}
    ${BrandSettingsInfoFragmentDoc}`;
export type EditBrandSettingsMutationFn = Apollo.MutationFunction<EditBrandSettingsMutation, EditBrandSettingsMutationVariables>;

/**
 * __useEditBrandSettingsMutation__
 *
 * To run a mutation, you first call `useEditBrandSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditBrandSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editBrandSettingsMutation, { data, loading, error }] = useEditBrandSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditBrandSettingsMutation(baseOptions?: Apollo.MutationHookOptions<EditBrandSettingsMutation, EditBrandSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditBrandSettingsMutation, EditBrandSettingsMutationVariables>(EditBrandSettingsDocument, options);
      }
export type EditBrandSettingsMutationHookResult = ReturnType<typeof useEditBrandSettingsMutation>;
export type EditBrandSettingsMutationResult = Apollo.MutationResult<EditBrandSettingsMutation>;
export type EditBrandSettingsMutationOptions = Apollo.BaseMutationOptions<EditBrandSettingsMutation, EditBrandSettingsMutationVariables>;
export const CommonBidDocument = gql`
    query CommonBid($offset: Int, $orderBy: CommonBidOrderBy, $where: CommonBidFilters) {
  commonBid(offset: $offset, orderBy: $orderBy, where: $where) {
    ...CommonBidInfo
  }
}
    ${CommonBidInfoFragmentDoc}`;

/**
 * __useCommonBidQuery__
 *
 * To run a query within a React component, call `useCommonBidQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommonBidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommonBidQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCommonBidQuery(baseOptions?: Apollo.QueryHookOptions<CommonBidQuery, CommonBidQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommonBidQuery, CommonBidQueryVariables>(CommonBidDocument, options);
      }
export function useCommonBidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommonBidQuery, CommonBidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommonBidQuery, CommonBidQueryVariables>(CommonBidDocument, options);
        }
export function useCommonBidSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CommonBidQuery, CommonBidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommonBidQuery, CommonBidQueryVariables>(CommonBidDocument, options);
        }
export type CommonBidQueryHookResult = ReturnType<typeof useCommonBidQuery>;
export type CommonBidLazyQueryHookResult = ReturnType<typeof useCommonBidLazyQuery>;
export type CommonBidSuspenseQueryHookResult = ReturnType<typeof useCommonBidSuspenseQuery>;
export type CommonBidQueryResult = Apollo.QueryResult<CommonBidQuery, CommonBidQueryVariables>;
export const BidRatingFeedbackValueDocument = gql`
    query BidRatingFeedbackValue($offset: Int, $limit: Int, $orderBy: BidRatingFeedbackValueOrderBy, $where: BidRatingFeedbackValueFilters) {
  bidRatingFeedbackValue(
    offset: $offset
    limit: $limit
    orderBy: $orderBy
    where: $where
  ) {
    id
    bidId
    ratingFeedbackValueId
  }
}
    `;

/**
 * __useBidRatingFeedbackValueQuery__
 *
 * To run a query within a React component, call `useBidRatingFeedbackValueQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidRatingFeedbackValueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidRatingFeedbackValueQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useBidRatingFeedbackValueQuery(baseOptions?: Apollo.QueryHookOptions<BidRatingFeedbackValueQuery, BidRatingFeedbackValueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BidRatingFeedbackValueQuery, BidRatingFeedbackValueQueryVariables>(BidRatingFeedbackValueDocument, options);
      }
export function useBidRatingFeedbackValueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BidRatingFeedbackValueQuery, BidRatingFeedbackValueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BidRatingFeedbackValueQuery, BidRatingFeedbackValueQueryVariables>(BidRatingFeedbackValueDocument, options);
        }
export function useBidRatingFeedbackValueSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BidRatingFeedbackValueQuery, BidRatingFeedbackValueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BidRatingFeedbackValueQuery, BidRatingFeedbackValueQueryVariables>(BidRatingFeedbackValueDocument, options);
        }
export type BidRatingFeedbackValueQueryHookResult = ReturnType<typeof useBidRatingFeedbackValueQuery>;
export type BidRatingFeedbackValueLazyQueryHookResult = ReturnType<typeof useBidRatingFeedbackValueLazyQuery>;
export type BidRatingFeedbackValueSuspenseQueryHookResult = ReturnType<typeof useBidRatingFeedbackValueSuspenseQuery>;
export type BidRatingFeedbackValueQueryResult = Apollo.QueryResult<BidRatingFeedbackValueQuery, BidRatingFeedbackValueQueryVariables>;
export const BrandDashboardCommonBidsDocument = gql`
    query BrandDashboardCommonBids($pagination: OffsetPaginationInput, $orderBy: CommonBidSortingOptions, $orderDirection: SortDirectionEnum, $where: CommonBidsWithPaginationWhereInput) {
  commonBidsWithPagination(
    pagination: $pagination
    orderBy: $orderBy
    orderDirection: $orderDirection
    where: $where
  ) {
    data {
      id
      status
      type
      region
      connectBid {
        bidId
        tender {
          id
          name
          unitType
          volumeUnits
          estimatedVolume
          venue {
            name
          }
        }
      }
      matchBid {
        bidId
      }
      product {
        bidId
        volumeUnits
        packagingType
        productCategoryId
        unitType
        name
        averageWholesalePrice
        avatarBucketKey
        avatarUrl
        unitsPerCase
        volumePerUnit
      }
      supports {
        amount
        supportType
        isProvided
        isReceived
      }
    }
    pageInfo {
      ...OffsetPagination
    }
  }
}
    ${OffsetPaginationFragmentDoc}`;

/**
 * __useBrandDashboardCommonBidsQuery__
 *
 * To run a query within a React component, call `useBrandDashboardCommonBidsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandDashboardCommonBidsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandDashboardCommonBidsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      orderBy: // value for 'orderBy'
 *      orderDirection: // value for 'orderDirection'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useBrandDashboardCommonBidsQuery(baseOptions?: Apollo.QueryHookOptions<BrandDashboardCommonBidsQuery, BrandDashboardCommonBidsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandDashboardCommonBidsQuery, BrandDashboardCommonBidsQueryVariables>(BrandDashboardCommonBidsDocument, options);
      }
export function useBrandDashboardCommonBidsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandDashboardCommonBidsQuery, BrandDashboardCommonBidsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandDashboardCommonBidsQuery, BrandDashboardCommonBidsQueryVariables>(BrandDashboardCommonBidsDocument, options);
        }
export function useBrandDashboardCommonBidsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BrandDashboardCommonBidsQuery, BrandDashboardCommonBidsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrandDashboardCommonBidsQuery, BrandDashboardCommonBidsQueryVariables>(BrandDashboardCommonBidsDocument, options);
        }
export type BrandDashboardCommonBidsQueryHookResult = ReturnType<typeof useBrandDashboardCommonBidsQuery>;
export type BrandDashboardCommonBidsLazyQueryHookResult = ReturnType<typeof useBrandDashboardCommonBidsLazyQuery>;
export type BrandDashboardCommonBidsSuspenseQueryHookResult = ReturnType<typeof useBrandDashboardCommonBidsSuspenseQuery>;
export type BrandDashboardCommonBidsQueryResult = Apollo.QueryResult<BrandDashboardCommonBidsQuery, BrandDashboardCommonBidsQueryVariables>;
export const WonConnectDealsFilterOptionsDocument = gql`
    query WonConnectDealsFilterOptions($brandId: NonNegativeInt!) {
  wonConnectDealsFilterOptions(brandId: $brandId) {
    label
    options {
      label
      value
    }
  }
}
    `;

/**
 * __useWonConnectDealsFilterOptionsQuery__
 *
 * To run a query within a React component, call `useWonConnectDealsFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWonConnectDealsFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWonConnectDealsFilterOptionsQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useWonConnectDealsFilterOptionsQuery(baseOptions: Apollo.QueryHookOptions<WonConnectDealsFilterOptionsQuery, WonConnectDealsFilterOptionsQueryVariables> & ({ variables: WonConnectDealsFilterOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WonConnectDealsFilterOptionsQuery, WonConnectDealsFilterOptionsQueryVariables>(WonConnectDealsFilterOptionsDocument, options);
      }
export function useWonConnectDealsFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WonConnectDealsFilterOptionsQuery, WonConnectDealsFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WonConnectDealsFilterOptionsQuery, WonConnectDealsFilterOptionsQueryVariables>(WonConnectDealsFilterOptionsDocument, options);
        }
export function useWonConnectDealsFilterOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WonConnectDealsFilterOptionsQuery, WonConnectDealsFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WonConnectDealsFilterOptionsQuery, WonConnectDealsFilterOptionsQueryVariables>(WonConnectDealsFilterOptionsDocument, options);
        }
export type WonConnectDealsFilterOptionsQueryHookResult = ReturnType<typeof useWonConnectDealsFilterOptionsQuery>;
export type WonConnectDealsFilterOptionsLazyQueryHookResult = ReturnType<typeof useWonConnectDealsFilterOptionsLazyQuery>;
export type WonConnectDealsFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useWonConnectDealsFilterOptionsSuspenseQuery>;
export type WonConnectDealsFilterOptionsQueryResult = Apollo.QueryResult<WonConnectDealsFilterOptionsQuery, WonConnectDealsFilterOptionsQueryVariables>;
export const RequestEmailDocument = gql`
    mutation RequestEmail($input: RequestEmailInput!) {
  requestEmail(input: $input)
}
    `;
export type RequestEmailMutationFn = Apollo.MutationFunction<RequestEmailMutation, RequestEmailMutationVariables>;

/**
 * __useRequestEmailMutation__
 *
 * To run a mutation, you first call `useRequestEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestEmailMutation, { data, loading, error }] = useRequestEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestEmailMutation(baseOptions?: Apollo.MutationHookOptions<RequestEmailMutation, RequestEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestEmailMutation, RequestEmailMutationVariables>(RequestEmailDocument, options);
      }
export type RequestEmailMutationHookResult = ReturnType<typeof useRequestEmailMutation>;
export type RequestEmailMutationResult = Apollo.MutationResult<RequestEmailMutation>;
export type RequestEmailMutationOptions = Apollo.BaseMutationOptions<RequestEmailMutation, RequestEmailMutationVariables>;
export const GenerateUploadUrlsDocument = gql`
    mutation GenerateUploadUrls($input: [String!]!) {
  generateUploadUrls(fileNames: $input) {
    filename
    bucketKey
    uploadUrl
  }
}
    `;
export type GenerateUploadUrlsMutationFn = Apollo.MutationFunction<GenerateUploadUrlsMutation, GenerateUploadUrlsMutationVariables>;

/**
 * __useGenerateUploadUrlsMutation__
 *
 * To run a mutation, you first call `useGenerateUploadUrlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUploadUrlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUploadUrlsMutation, { data, loading, error }] = useGenerateUploadUrlsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateUploadUrlsMutation(baseOptions?: Apollo.MutationHookOptions<GenerateUploadUrlsMutation, GenerateUploadUrlsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateUploadUrlsMutation, GenerateUploadUrlsMutationVariables>(GenerateUploadUrlsDocument, options);
      }
export type GenerateUploadUrlsMutationHookResult = ReturnType<typeof useGenerateUploadUrlsMutation>;
export type GenerateUploadUrlsMutationResult = Apollo.MutationResult<GenerateUploadUrlsMutation>;
export type GenerateUploadUrlsMutationOptions = Apollo.BaseMutationOptions<GenerateUploadUrlsMutation, GenerateUploadUrlsMutationVariables>;
export const LinkAccountWithExternalProviderDocument = gql`
    mutation LinkAccountWithExternalProvider($input: LinkAccountWithExternalProviderInput!) {
  linkAccountWithExternalProvider(input: $input)
}
    `;
export type LinkAccountWithExternalProviderMutationFn = Apollo.MutationFunction<LinkAccountWithExternalProviderMutation, LinkAccountWithExternalProviderMutationVariables>;

/**
 * __useLinkAccountWithExternalProviderMutation__
 *
 * To run a mutation, you first call `useLinkAccountWithExternalProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkAccountWithExternalProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkAccountWithExternalProviderMutation, { data, loading, error }] = useLinkAccountWithExternalProviderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkAccountWithExternalProviderMutation(baseOptions?: Apollo.MutationHookOptions<LinkAccountWithExternalProviderMutation, LinkAccountWithExternalProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkAccountWithExternalProviderMutation, LinkAccountWithExternalProviderMutationVariables>(LinkAccountWithExternalProviderDocument, options);
      }
export type LinkAccountWithExternalProviderMutationHookResult = ReturnType<typeof useLinkAccountWithExternalProviderMutation>;
export type LinkAccountWithExternalProviderMutationResult = Apollo.MutationResult<LinkAccountWithExternalProviderMutation>;
export type LinkAccountWithExternalProviderMutationOptions = Apollo.BaseMutationOptions<LinkAccountWithExternalProviderMutation, LinkAccountWithExternalProviderMutationVariables>;
export const UnlinkAccountWithExternalProviderDocument = gql`
    mutation UnlinkAccountWithExternalProvider($input: UnlinkAccountWithExternalProviderInput!) {
  unlinkAccountWithExternalProvider(input: $input)
}
    `;
export type UnlinkAccountWithExternalProviderMutationFn = Apollo.MutationFunction<UnlinkAccountWithExternalProviderMutation, UnlinkAccountWithExternalProviderMutationVariables>;

/**
 * __useUnlinkAccountWithExternalProviderMutation__
 *
 * To run a mutation, you first call `useUnlinkAccountWithExternalProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkAccountWithExternalProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkAccountWithExternalProviderMutation, { data, loading, error }] = useUnlinkAccountWithExternalProviderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlinkAccountWithExternalProviderMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkAccountWithExternalProviderMutation, UnlinkAccountWithExternalProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkAccountWithExternalProviderMutation, UnlinkAccountWithExternalProviderMutationVariables>(UnlinkAccountWithExternalProviderDocument, options);
      }
export type UnlinkAccountWithExternalProviderMutationHookResult = ReturnType<typeof useUnlinkAccountWithExternalProviderMutation>;
export type UnlinkAccountWithExternalProviderMutationResult = Apollo.MutationResult<UnlinkAccountWithExternalProviderMutation>;
export type UnlinkAccountWithExternalProviderMutationOptions = Apollo.BaseMutationOptions<UnlinkAccountWithExternalProviderMutation, UnlinkAccountWithExternalProviderMutationVariables>;
export const IsJwtLinkTokenValidDocument = gql`
    mutation IsJWTLinkTokenValid($token: String!, $integrationType: IntegrationType!) {
  isJWTLinkTokenValid(token: $token, integrationType: $integrationType)
}
    `;
export type IsJwtLinkTokenValidMutationFn = Apollo.MutationFunction<IsJwtLinkTokenValidMutation, IsJwtLinkTokenValidMutationVariables>;

/**
 * __useIsJwtLinkTokenValidMutation__
 *
 * To run a mutation, you first call `useIsJwtLinkTokenValidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIsJwtLinkTokenValidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [isJwtLinkTokenValidMutation, { data, loading, error }] = useIsJwtLinkTokenValidMutation({
 *   variables: {
 *      token: // value for 'token'
 *      integrationType: // value for 'integrationType'
 *   },
 * });
 */
export function useIsJwtLinkTokenValidMutation(baseOptions?: Apollo.MutationHookOptions<IsJwtLinkTokenValidMutation, IsJwtLinkTokenValidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IsJwtLinkTokenValidMutation, IsJwtLinkTokenValidMutationVariables>(IsJwtLinkTokenValidDocument, options);
      }
export type IsJwtLinkTokenValidMutationHookResult = ReturnType<typeof useIsJwtLinkTokenValidMutation>;
export type IsJwtLinkTokenValidMutationResult = Apollo.MutationResult<IsJwtLinkTokenValidMutation>;
export type IsJwtLinkTokenValidMutationOptions = Apollo.BaseMutationOptions<IsJwtLinkTokenValidMutation, IsJwtLinkTokenValidMutationVariables>;
export const VenueInvitationsDocument = gql`
    query VenueInvitations($venueId: NonNegativeInt!, $status: InvitationStatus) {
  invitationsToVenue(id: $venueId, status: $status) {
    ...InvitationLinkItem
  }
}
    ${InvitationLinkItemFragmentDoc}`;

/**
 * __useVenueInvitationsQuery__
 *
 * To run a query within a React component, call `useVenueInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenueInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVenueInvitationsQuery({
 *   variables: {
 *      venueId: // value for 'venueId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useVenueInvitationsQuery(baseOptions: Apollo.QueryHookOptions<VenueInvitationsQuery, VenueInvitationsQueryVariables> & ({ variables: VenueInvitationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VenueInvitationsQuery, VenueInvitationsQueryVariables>(VenueInvitationsDocument, options);
      }
export function useVenueInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VenueInvitationsQuery, VenueInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VenueInvitationsQuery, VenueInvitationsQueryVariables>(VenueInvitationsDocument, options);
        }
export function useVenueInvitationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VenueInvitationsQuery, VenueInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VenueInvitationsQuery, VenueInvitationsQueryVariables>(VenueInvitationsDocument, options);
        }
export type VenueInvitationsQueryHookResult = ReturnType<typeof useVenueInvitationsQuery>;
export type VenueInvitationsLazyQueryHookResult = ReturnType<typeof useVenueInvitationsLazyQuery>;
export type VenueInvitationsSuspenseQueryHookResult = ReturnType<typeof useVenueInvitationsSuspenseQuery>;
export type VenueInvitationsQueryResult = Apollo.QueryResult<VenueInvitationsQuery, VenueInvitationsQueryVariables>;
export const BrandInvitationsDocument = gql`
    query BrandInvitations($brandId: NonNegativeInt!, $status: InvitationStatus) {
  invitationsToBrand(id: $brandId, status: $status) {
    ...InvitationLinkItem
  }
}
    ${InvitationLinkItemFragmentDoc}`;

/**
 * __useBrandInvitationsQuery__
 *
 * To run a query within a React component, call `useBrandInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandInvitationsQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useBrandInvitationsQuery(baseOptions: Apollo.QueryHookOptions<BrandInvitationsQuery, BrandInvitationsQueryVariables> & ({ variables: BrandInvitationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandInvitationsQuery, BrandInvitationsQueryVariables>(BrandInvitationsDocument, options);
      }
export function useBrandInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandInvitationsQuery, BrandInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandInvitationsQuery, BrandInvitationsQueryVariables>(BrandInvitationsDocument, options);
        }
export function useBrandInvitationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BrandInvitationsQuery, BrandInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrandInvitationsQuery, BrandInvitationsQueryVariables>(BrandInvitationsDocument, options);
        }
export type BrandInvitationsQueryHookResult = ReturnType<typeof useBrandInvitationsQuery>;
export type BrandInvitationsLazyQueryHookResult = ReturnType<typeof useBrandInvitationsLazyQuery>;
export type BrandInvitationsSuspenseQueryHookResult = ReturnType<typeof useBrandInvitationsSuspenseQuery>;
export type BrandInvitationsQueryResult = Apollo.QueryResult<BrandInvitationsQuery, BrandInvitationsQueryVariables>;
export const InvitationLinkDocument = gql`
    query InvitationLink($offset: Int, $orderBy: InvitationLinkOrderBy, $where: InvitationLinkFilters) {
  invitationLink(offset: $offset, orderBy: $orderBy, where: $where) {
    id
    email
    expiresAt
    acceptedById
    status
    venueId
    brandId
  }
}
    `;

/**
 * __useInvitationLinkQuery__
 *
 * To run a query within a React component, call `useInvitationLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitationLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitationLinkQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInvitationLinkQuery(baseOptions?: Apollo.QueryHookOptions<InvitationLinkQuery, InvitationLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvitationLinkQuery, InvitationLinkQueryVariables>(InvitationLinkDocument, options);
      }
export function useInvitationLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvitationLinkQuery, InvitationLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvitationLinkQuery, InvitationLinkQueryVariables>(InvitationLinkDocument, options);
        }
export function useInvitationLinkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvitationLinkQuery, InvitationLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvitationLinkQuery, InvitationLinkQueryVariables>(InvitationLinkDocument, options);
        }
export type InvitationLinkQueryHookResult = ReturnType<typeof useInvitationLinkQuery>;
export type InvitationLinkLazyQueryHookResult = ReturnType<typeof useInvitationLinkLazyQuery>;
export type InvitationLinkSuspenseQueryHookResult = ReturnType<typeof useInvitationLinkSuspenseQuery>;
export type InvitationLinkQueryResult = Apollo.QueryResult<InvitationLinkQuery, InvitationLinkQueryVariables>;
export const InviteToBrandDocument = gql`
    mutation InviteToBrand($brandId: NonNegativeInt!, $email: EmailAddress!, $role: UserRole!) {
  inviteToBrand(id: $brandId, email: $email, userRole: $role) {
    ...InvitationLinkItem
  }
}
    ${InvitationLinkItemFragmentDoc}`;
export type InviteToBrandMutationFn = Apollo.MutationFunction<InviteToBrandMutation, InviteToBrandMutationVariables>;

/**
 * __useInviteToBrandMutation__
 *
 * To run a mutation, you first call `useInviteToBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteToBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteToBrandMutation, { data, loading, error }] = useInviteToBrandMutation({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      email: // value for 'email'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useInviteToBrandMutation(baseOptions?: Apollo.MutationHookOptions<InviteToBrandMutation, InviteToBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteToBrandMutation, InviteToBrandMutationVariables>(InviteToBrandDocument, options);
      }
export type InviteToBrandMutationHookResult = ReturnType<typeof useInviteToBrandMutation>;
export type InviteToBrandMutationResult = Apollo.MutationResult<InviteToBrandMutation>;
export type InviteToBrandMutationOptions = Apollo.BaseMutationOptions<InviteToBrandMutation, InviteToBrandMutationVariables>;
export const InviteToVenueDocument = gql`
    mutation inviteToVenue($venueId: NonNegativeInt!, $email: EmailAddress!, $role: UserRole!) {
  inviteToVenue(id: $venueId, email: $email, userRole: $role) {
    ...InvitationLinkItem
  }
}
    ${InvitationLinkItemFragmentDoc}`;
export type InviteToVenueMutationFn = Apollo.MutationFunction<InviteToVenueMutation, InviteToVenueMutationVariables>;

/**
 * __useInviteToVenueMutation__
 *
 * To run a mutation, you first call `useInviteToVenueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteToVenueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteToVenueMutation, { data, loading, error }] = useInviteToVenueMutation({
 *   variables: {
 *      venueId: // value for 'venueId'
 *      email: // value for 'email'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useInviteToVenueMutation(baseOptions?: Apollo.MutationHookOptions<InviteToVenueMutation, InviteToVenueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteToVenueMutation, InviteToVenueMutationVariables>(InviteToVenueDocument, options);
      }
export type InviteToVenueMutationHookResult = ReturnType<typeof useInviteToVenueMutation>;
export type InviteToVenueMutationResult = Apollo.MutationResult<InviteToVenueMutation>;
export type InviteToVenueMutationOptions = Apollo.BaseMutationOptions<InviteToVenueMutation, InviteToVenueMutationVariables>;
export const RemoveInviteToBrandDocument = gql`
    mutation RemoveInviteToBrand($brandId: NonNegativeInt!, $invitationId: UUID!) {
  removeInviteToBrand(id: $brandId, invitationId: $invitationId) {
    ...InvitationLinkItem
  }
}
    ${InvitationLinkItemFragmentDoc}`;
export type RemoveInviteToBrandMutationFn = Apollo.MutationFunction<RemoveInviteToBrandMutation, RemoveInviteToBrandMutationVariables>;

/**
 * __useRemoveInviteToBrandMutation__
 *
 * To run a mutation, you first call `useRemoveInviteToBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveInviteToBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeInviteToBrandMutation, { data, loading, error }] = useRemoveInviteToBrandMutation({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      invitationId: // value for 'invitationId'
 *   },
 * });
 */
export function useRemoveInviteToBrandMutation(baseOptions?: Apollo.MutationHookOptions<RemoveInviteToBrandMutation, RemoveInviteToBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveInviteToBrandMutation, RemoveInviteToBrandMutationVariables>(RemoveInviteToBrandDocument, options);
      }
export type RemoveInviteToBrandMutationHookResult = ReturnType<typeof useRemoveInviteToBrandMutation>;
export type RemoveInviteToBrandMutationResult = Apollo.MutationResult<RemoveInviteToBrandMutation>;
export type RemoveInviteToBrandMutationOptions = Apollo.BaseMutationOptions<RemoveInviteToBrandMutation, RemoveInviteToBrandMutationVariables>;
export const RemoveInviteToVenueDocument = gql`
    mutation RemoveInviteToVenue($venueId: NonNegativeInt!, $invitationId: UUID!) {
  removeInviteToVenue(id: $venueId, invitationId: $invitationId) {
    ...InvitationLinkItem
  }
}
    ${InvitationLinkItemFragmentDoc}`;
export type RemoveInviteToVenueMutationFn = Apollo.MutationFunction<RemoveInviteToVenueMutation, RemoveInviteToVenueMutationVariables>;

/**
 * __useRemoveInviteToVenueMutation__
 *
 * To run a mutation, you first call `useRemoveInviteToVenueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveInviteToVenueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeInviteToVenueMutation, { data, loading, error }] = useRemoveInviteToVenueMutation({
 *   variables: {
 *      venueId: // value for 'venueId'
 *      invitationId: // value for 'invitationId'
 *   },
 * });
 */
export function useRemoveInviteToVenueMutation(baseOptions?: Apollo.MutationHookOptions<RemoveInviteToVenueMutation, RemoveInviteToVenueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveInviteToVenueMutation, RemoveInviteToVenueMutationVariables>(RemoveInviteToVenueDocument, options);
      }
export type RemoveInviteToVenueMutationHookResult = ReturnType<typeof useRemoveInviteToVenueMutation>;
export type RemoveInviteToVenueMutationResult = Apollo.MutationResult<RemoveInviteToVenueMutation>;
export type RemoveInviteToVenueMutationOptions = Apollo.BaseMutationOptions<RemoveInviteToVenueMutation, RemoveInviteToVenueMutationVariables>;
export const AcceptInviteToBrandDocument = gql`
    mutation AcceptInviteToBrand($invitationId: UUID!) {
  acceptInviteToBrand(id: $invitationId) {
    ...InvitationLinkItem
  }
}
    ${InvitationLinkItemFragmentDoc}`;
export type AcceptInviteToBrandMutationFn = Apollo.MutationFunction<AcceptInviteToBrandMutation, AcceptInviteToBrandMutationVariables>;

/**
 * __useAcceptInviteToBrandMutation__
 *
 * To run a mutation, you first call `useAcceptInviteToBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInviteToBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInviteToBrandMutation, { data, loading, error }] = useAcceptInviteToBrandMutation({
 *   variables: {
 *      invitationId: // value for 'invitationId'
 *   },
 * });
 */
export function useAcceptInviteToBrandMutation(baseOptions?: Apollo.MutationHookOptions<AcceptInviteToBrandMutation, AcceptInviteToBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptInviteToBrandMutation, AcceptInviteToBrandMutationVariables>(AcceptInviteToBrandDocument, options);
      }
export type AcceptInviteToBrandMutationHookResult = ReturnType<typeof useAcceptInviteToBrandMutation>;
export type AcceptInviteToBrandMutationResult = Apollo.MutationResult<AcceptInviteToBrandMutation>;
export type AcceptInviteToBrandMutationOptions = Apollo.BaseMutationOptions<AcceptInviteToBrandMutation, AcceptInviteToBrandMutationVariables>;
export const AcceptInviteToVenueDocument = gql`
    mutation AcceptInviteToVenue($invitationId: UUID!) {
  acceptInviteToVenue(id: $invitationId) {
    ...InvitationLinkItem
  }
}
    ${InvitationLinkItemFragmentDoc}`;
export type AcceptInviteToVenueMutationFn = Apollo.MutationFunction<AcceptInviteToVenueMutation, AcceptInviteToVenueMutationVariables>;

/**
 * __useAcceptInviteToVenueMutation__
 *
 * To run a mutation, you first call `useAcceptInviteToVenueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInviteToVenueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInviteToVenueMutation, { data, loading, error }] = useAcceptInviteToVenueMutation({
 *   variables: {
 *      invitationId: // value for 'invitationId'
 *   },
 * });
 */
export function useAcceptInviteToVenueMutation(baseOptions?: Apollo.MutationHookOptions<AcceptInviteToVenueMutation, AcceptInviteToVenueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptInviteToVenueMutation, AcceptInviteToVenueMutationVariables>(AcceptInviteToVenueDocument, options);
      }
export type AcceptInviteToVenueMutationHookResult = ReturnType<typeof useAcceptInviteToVenueMutation>;
export type AcceptInviteToVenueMutationResult = Apollo.MutationResult<AcceptInviteToVenueMutation>;
export type AcceptInviteToVenueMutationOptions = Apollo.BaseMutationOptions<AcceptInviteToVenueMutation, AcceptInviteToVenueMutationVariables>;
export const InvitationLinkRegionDocument = gql`
    query InvitationLinkRegion($invitationLinkId: UUID!) {
  invitationLinkRegion(invitationLinkId: $invitationLinkId)
}
    `;

/**
 * __useInvitationLinkRegionQuery__
 *
 * To run a query within a React component, call `useInvitationLinkRegionQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitationLinkRegionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitationLinkRegionQuery({
 *   variables: {
 *      invitationLinkId: // value for 'invitationLinkId'
 *   },
 * });
 */
export function useInvitationLinkRegionQuery(baseOptions: Apollo.QueryHookOptions<InvitationLinkRegionQuery, InvitationLinkRegionQueryVariables> & ({ variables: InvitationLinkRegionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvitationLinkRegionQuery, InvitationLinkRegionQueryVariables>(InvitationLinkRegionDocument, options);
      }
export function useInvitationLinkRegionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvitationLinkRegionQuery, InvitationLinkRegionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvitationLinkRegionQuery, InvitationLinkRegionQueryVariables>(InvitationLinkRegionDocument, options);
        }
export function useInvitationLinkRegionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvitationLinkRegionQuery, InvitationLinkRegionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvitationLinkRegionQuery, InvitationLinkRegionQueryVariables>(InvitationLinkRegionDocument, options);
        }
export type InvitationLinkRegionQueryHookResult = ReturnType<typeof useInvitationLinkRegionQuery>;
export type InvitationLinkRegionLazyQueryHookResult = ReturnType<typeof useInvitationLinkRegionLazyQuery>;
export type InvitationLinkRegionSuspenseQueryHookResult = ReturnType<typeof useInvitationLinkRegionSuspenseQuery>;
export type InvitationLinkRegionQueryResult = Apollo.QueryResult<InvitationLinkRegionQuery, InvitationLinkRegionQueryVariables>;
export const ListingTypesDocument = gql`
    query ListingTypes($region: Region!) {
  listingTypes(region: $region) {
    ...ListingTypeInfo
  }
}
    ${ListingTypeInfoFragmentDoc}`;

/**
 * __useListingTypesQuery__
 *
 * To run a query within a React component, call `useListingTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingTypesQuery({
 *   variables: {
 *      region: // value for 'region'
 *   },
 * });
 */
export function useListingTypesQuery(baseOptions: Apollo.QueryHookOptions<ListingTypesQuery, ListingTypesQueryVariables> & ({ variables: ListingTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingTypesQuery, ListingTypesQueryVariables>(ListingTypesDocument, options);
      }
export function useListingTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingTypesQuery, ListingTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingTypesQuery, ListingTypesQueryVariables>(ListingTypesDocument, options);
        }
export function useListingTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListingTypesQuery, ListingTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListingTypesQuery, ListingTypesQueryVariables>(ListingTypesDocument, options);
        }
export type ListingTypesQueryHookResult = ReturnType<typeof useListingTypesQuery>;
export type ListingTypesLazyQueryHookResult = ReturnType<typeof useListingTypesLazyQuery>;
export type ListingTypesSuspenseQueryHookResult = ReturnType<typeof useListingTypesSuspenseQuery>;
export type ListingTypesQueryResult = Apollo.QueryResult<ListingTypesQuery, ListingTypesQueryVariables>;
export const GetLiveStatsDocument = gql`
    query GetLiveStats {
  getLiveStats {
    activeTenders
    activeBidGrossMerchandiseValue
    matchBids
  }
}
    `;

/**
 * __useGetLiveStatsQuery__
 *
 * To run a query within a React component, call `useGetLiveStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLiveStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLiveStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLiveStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetLiveStatsQuery, GetLiveStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLiveStatsQuery, GetLiveStatsQueryVariables>(GetLiveStatsDocument, options);
      }
export function useGetLiveStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLiveStatsQuery, GetLiveStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLiveStatsQuery, GetLiveStatsQueryVariables>(GetLiveStatsDocument, options);
        }
export function useGetLiveStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLiveStatsQuery, GetLiveStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLiveStatsQuery, GetLiveStatsQueryVariables>(GetLiveStatsDocument, options);
        }
export type GetLiveStatsQueryHookResult = ReturnType<typeof useGetLiveStatsQuery>;
export type GetLiveStatsLazyQueryHookResult = ReturnType<typeof useGetLiveStatsLazyQuery>;
export type GetLiveStatsSuspenseQueryHookResult = ReturnType<typeof useGetLiveStatsSuspenseQuery>;
export type GetLiveStatsQueryResult = Apollo.QueryResult<GetLiveStatsQuery, GetLiveStatsQueryVariables>;
export const MatchBidFieldDataDocument = gql`
    query MatchBidFieldData($region: Region!) {
  listingTypes(region: $region) {
    id
    name
    suggestedListingLengthInMonths
    order
  }
  venueCategories(region: $region) {
    id
    name
    parentId
    localizationKey
  }
  venueLoyaltyLevels {
    id
    name
  }
  countryRegions(region: $region) {
    id
    name
  }
  customerTypes {
    id
    name
  }
}
    `;

/**
 * __useMatchBidFieldDataQuery__
 *
 * To run a query within a React component, call `useMatchBidFieldDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchBidFieldDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchBidFieldDataQuery({
 *   variables: {
 *      region: // value for 'region'
 *   },
 * });
 */
export function useMatchBidFieldDataQuery(baseOptions: Apollo.QueryHookOptions<MatchBidFieldDataQuery, MatchBidFieldDataQueryVariables> & ({ variables: MatchBidFieldDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchBidFieldDataQuery, MatchBidFieldDataQueryVariables>(MatchBidFieldDataDocument, options);
      }
export function useMatchBidFieldDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchBidFieldDataQuery, MatchBidFieldDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchBidFieldDataQuery, MatchBidFieldDataQueryVariables>(MatchBidFieldDataDocument, options);
        }
export function useMatchBidFieldDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MatchBidFieldDataQuery, MatchBidFieldDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchBidFieldDataQuery, MatchBidFieldDataQueryVariables>(MatchBidFieldDataDocument, options);
        }
export type MatchBidFieldDataQueryHookResult = ReturnType<typeof useMatchBidFieldDataQuery>;
export type MatchBidFieldDataLazyQueryHookResult = ReturnType<typeof useMatchBidFieldDataLazyQuery>;
export type MatchBidFieldDataSuspenseQueryHookResult = ReturnType<typeof useMatchBidFieldDataSuspenseQuery>;
export type MatchBidFieldDataQueryResult = Apollo.QueryResult<MatchBidFieldDataQuery, MatchBidFieldDataQueryVariables>;
export const AddMatchBidDocument = gql`
    mutation AddMatchBid($input: MatchBidInsertInput!) {
  insertIntoMatchBid(input: $input) {
    bidId
    maximumAcceptedDeals
    commonBid {
      product {
        name
        productCategoryId
        attachments {
          ...S3FileInfo
        }
      }
    }
  }
}
    ${S3FileInfoFragmentDoc}`;
export type AddMatchBidMutationFn = Apollo.MutationFunction<AddMatchBidMutation, AddMatchBidMutationVariables>;

/**
 * __useAddMatchBidMutation__
 *
 * To run a mutation, you first call `useAddMatchBidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMatchBidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMatchBidMutation, { data, loading, error }] = useAddMatchBidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMatchBidMutation(baseOptions?: Apollo.MutationHookOptions<AddMatchBidMutation, AddMatchBidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMatchBidMutation, AddMatchBidMutationVariables>(AddMatchBidDocument, options);
      }
export type AddMatchBidMutationHookResult = ReturnType<typeof useAddMatchBidMutation>;
export type AddMatchBidMutationResult = Apollo.MutationResult<AddMatchBidMutation>;
export type AddMatchBidMutationOptions = Apollo.BaseMutationOptions<AddMatchBidMutation, AddMatchBidMutationVariables>;
export const EditMatchBidDocument = gql`
    mutation EditMatchBid($id: NonNegativeInt!, $set: MatchBidInsertInput!) {
  editMatchBid(id: $id, set: $set) {
    bidId
    maximumAcceptedDeals
    commonBid {
      product {
        name
        productCategoryId
        attachments {
          ...S3FileInfo
        }
      }
    }
  }
}
    ${S3FileInfoFragmentDoc}`;
export type EditMatchBidMutationFn = Apollo.MutationFunction<EditMatchBidMutation, EditMatchBidMutationVariables>;

/**
 * __useEditMatchBidMutation__
 *
 * To run a mutation, you first call `useEditMatchBidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMatchBidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMatchBidMutation, { data, loading, error }] = useEditMatchBidMutation({
 *   variables: {
 *      id: // value for 'id'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useEditMatchBidMutation(baseOptions?: Apollo.MutationHookOptions<EditMatchBidMutation, EditMatchBidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditMatchBidMutation, EditMatchBidMutationVariables>(EditMatchBidDocument, options);
      }
export type EditMatchBidMutationHookResult = ReturnType<typeof useEditMatchBidMutation>;
export type EditMatchBidMutationResult = Apollo.MutationResult<EditMatchBidMutation>;
export type EditMatchBidMutationOptions = Apollo.BaseMutationOptions<EditMatchBidMutation, EditMatchBidMutationVariables>;
export const EndMatchBidDocument = gql`
    mutation EndMatchBid($id: NonNegativeInt!, $brandId: NonNegativeInt!) {
  endMatchBidById(bidId: $id, brandId: $brandId)
}
    `;
export type EndMatchBidMutationFn = Apollo.MutationFunction<EndMatchBidMutation, EndMatchBidMutationVariables>;

/**
 * __useEndMatchBidMutation__
 *
 * To run a mutation, you first call `useEndMatchBidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndMatchBidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endMatchBidMutation, { data, loading, error }] = useEndMatchBidMutation({
 *   variables: {
 *      id: // value for 'id'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useEndMatchBidMutation(baseOptions?: Apollo.MutationHookOptions<EndMatchBidMutation, EndMatchBidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EndMatchBidMutation, EndMatchBidMutationVariables>(EndMatchBidDocument, options);
      }
export type EndMatchBidMutationHookResult = ReturnType<typeof useEndMatchBidMutation>;
export type EndMatchBidMutationResult = Apollo.MutationResult<EndMatchBidMutation>;
export type EndMatchBidMutationOptions = Apollo.BaseMutationOptions<EndMatchBidMutation, EndMatchBidMutationVariables>;
export const AcceptMatchBidDocument = gql`
    mutation AcceptMatchBid($bidId: NonNegativeInt!, $venueId: NonNegativeInt!, $price: Float!) {
  acceptMatchBid(bidId: $bidId, venueId: $venueId, price: $price)
}
    `;
export type AcceptMatchBidMutationFn = Apollo.MutationFunction<AcceptMatchBidMutation, AcceptMatchBidMutationVariables>;

/**
 * __useAcceptMatchBidMutation__
 *
 * To run a mutation, you first call `useAcceptMatchBidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptMatchBidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptMatchBidMutation, { data, loading, error }] = useAcceptMatchBidMutation({
 *   variables: {
 *      bidId: // value for 'bidId'
 *      venueId: // value for 'venueId'
 *      price: // value for 'price'
 *   },
 * });
 */
export function useAcceptMatchBidMutation(baseOptions?: Apollo.MutationHookOptions<AcceptMatchBidMutation, AcceptMatchBidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptMatchBidMutation, AcceptMatchBidMutationVariables>(AcceptMatchBidDocument, options);
      }
export type AcceptMatchBidMutationHookResult = ReturnType<typeof useAcceptMatchBidMutation>;
export type AcceptMatchBidMutationResult = Apollo.MutationResult<AcceptMatchBidMutation>;
export type AcceptMatchBidMutationOptions = Apollo.BaseMutationOptions<AcceptMatchBidMutation, AcceptMatchBidMutationVariables>;
export const MatchBidAcceptedDealsCountDocument = gql`
    query MatchBidAcceptedDealsCount($bidIds: [NonNegativeInt!]!) {
  matchBidAcceptedDealsCount(bidIds: $bidIds) {
    count
    bidId
  }
}
    `;

/**
 * __useMatchBidAcceptedDealsCountQuery__
 *
 * To run a query within a React component, call `useMatchBidAcceptedDealsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchBidAcceptedDealsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchBidAcceptedDealsCountQuery({
 *   variables: {
 *      bidIds: // value for 'bidIds'
 *   },
 * });
 */
export function useMatchBidAcceptedDealsCountQuery(baseOptions: Apollo.QueryHookOptions<MatchBidAcceptedDealsCountQuery, MatchBidAcceptedDealsCountQueryVariables> & ({ variables: MatchBidAcceptedDealsCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchBidAcceptedDealsCountQuery, MatchBidAcceptedDealsCountQueryVariables>(MatchBidAcceptedDealsCountDocument, options);
      }
export function useMatchBidAcceptedDealsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchBidAcceptedDealsCountQuery, MatchBidAcceptedDealsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchBidAcceptedDealsCountQuery, MatchBidAcceptedDealsCountQueryVariables>(MatchBidAcceptedDealsCountDocument, options);
        }
export function useMatchBidAcceptedDealsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MatchBidAcceptedDealsCountQuery, MatchBidAcceptedDealsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchBidAcceptedDealsCountQuery, MatchBidAcceptedDealsCountQueryVariables>(MatchBidAcceptedDealsCountDocument, options);
        }
export type MatchBidAcceptedDealsCountQueryHookResult = ReturnType<typeof useMatchBidAcceptedDealsCountQuery>;
export type MatchBidAcceptedDealsCountLazyQueryHookResult = ReturnType<typeof useMatchBidAcceptedDealsCountLazyQuery>;
export type MatchBidAcceptedDealsCountSuspenseQueryHookResult = ReturnType<typeof useMatchBidAcceptedDealsCountSuspenseQuery>;
export type MatchBidAcceptedDealsCountQueryResult = Apollo.QueryResult<MatchBidAcceptedDealsCountQuery, MatchBidAcceptedDealsCountQueryVariables>;
export const MatchBidDocument = gql`
    query MatchBid($offset: Int, $orderBy: MatchBidOrderBy, $where: MatchBidFilters) {
  matchBid(offset: $offset, orderBy: $orderBy, where: $where) {
    ...MatchBidInfo
  }
}
    ${MatchBidInfoFragmentDoc}`;

/**
 * __useMatchBidQuery__
 *
 * To run a query within a React component, call `useMatchBidQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchBidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchBidQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useMatchBidQuery(baseOptions?: Apollo.QueryHookOptions<MatchBidQuery, MatchBidQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchBidQuery, MatchBidQueryVariables>(MatchBidDocument, options);
      }
export function useMatchBidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchBidQuery, MatchBidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchBidQuery, MatchBidQueryVariables>(MatchBidDocument, options);
        }
export function useMatchBidSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MatchBidQuery, MatchBidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchBidQuery, MatchBidQueryVariables>(MatchBidDocument, options);
        }
export type MatchBidQueryHookResult = ReturnType<typeof useMatchBidQuery>;
export type MatchBidLazyQueryHookResult = ReturnType<typeof useMatchBidLazyQuery>;
export type MatchBidSuspenseQueryHookResult = ReturnType<typeof useMatchBidSuspenseQuery>;
export type MatchBidQueryResult = Apollo.QueryResult<MatchBidQuery, MatchBidQueryVariables>;
export const MatchBidsWithPaginationDocument = gql`
    query MatchBidsWithPagination($pagination: OffsetPaginationInput, $orderBy: CommonBidSortingOptions, $orderDirection: SortDirectionEnum, $where: CommonBidsWithPaginationWhereInput, $region: Region!) {
  commonBidsWithPagination(
    pagination: $pagination
    orderBy: $orderBy
    orderDirection: $orderDirection
    where: $where
  ) {
    data {
      id
      status
      matchBid {
        bidId
        maximumAcceptedDeals
        venueCriteria {
          bidId
          regions
          customerTypes
          listingTypeId
          loyaltyLevels
          minimumVolume
          venueTypes
          targetProductCategory
        }
      }
      product {
        bidId
        name
        avatarBucketKey
        avatarUrl
      }
    }
    pageInfo {
      ...OffsetPagination
    }
  }
  matchBidFilterOptions(where: $where) {
    ...FilterOptions
  }
  listingTypes(region: $region) {
    id
    name
  }
  venueCategories(region: $region) {
    id
    name
    parentId
    localizationKey
  }
  venueLoyaltyLevels {
    id
    name
  }
  countryRegions(region: $region) {
    id
    name
  }
  customerTypes {
    id
    name
  }
}
    ${OffsetPaginationFragmentDoc}
${FilterOptionsFragmentDoc}`;

/**
 * __useMatchBidsWithPaginationQuery__
 *
 * To run a query within a React component, call `useMatchBidsWithPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchBidsWithPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchBidsWithPaginationQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      orderBy: // value for 'orderBy'
 *      orderDirection: // value for 'orderDirection'
 *      where: // value for 'where'
 *      region: // value for 'region'
 *   },
 * });
 */
export function useMatchBidsWithPaginationQuery(baseOptions: Apollo.QueryHookOptions<MatchBidsWithPaginationQuery, MatchBidsWithPaginationQueryVariables> & ({ variables: MatchBidsWithPaginationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchBidsWithPaginationQuery, MatchBidsWithPaginationQueryVariables>(MatchBidsWithPaginationDocument, options);
      }
export function useMatchBidsWithPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchBidsWithPaginationQuery, MatchBidsWithPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchBidsWithPaginationQuery, MatchBidsWithPaginationQueryVariables>(MatchBidsWithPaginationDocument, options);
        }
export function useMatchBidsWithPaginationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MatchBidsWithPaginationQuery, MatchBidsWithPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchBidsWithPaginationQuery, MatchBidsWithPaginationQueryVariables>(MatchBidsWithPaginationDocument, options);
        }
export type MatchBidsWithPaginationQueryHookResult = ReturnType<typeof useMatchBidsWithPaginationQuery>;
export type MatchBidsWithPaginationLazyQueryHookResult = ReturnType<typeof useMatchBidsWithPaginationLazyQuery>;
export type MatchBidsWithPaginationSuspenseQueryHookResult = ReturnType<typeof useMatchBidsWithPaginationSuspenseQuery>;
export type MatchBidsWithPaginationQueryResult = Apollo.QueryResult<MatchBidsWithPaginationQuery, MatchBidsWithPaginationQueryVariables>;
export const MatchBidTargetedVenuesByVenueCriteriaDocument = gql`
    query MatchBidTargetedVenuesByVenueCriteria($input: TargetedVenuesByVenueCriteriaInput!) {
  targetedVenuesByVenueCriteria(input: $input) {
    mainCategoryVolume
    detailedCategoryVolume
    targetCustomers
    averageVolumePerListing
  }
}
    `;

/**
 * __useMatchBidTargetedVenuesByVenueCriteriaQuery__
 *
 * To run a query within a React component, call `useMatchBidTargetedVenuesByVenueCriteriaQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchBidTargetedVenuesByVenueCriteriaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchBidTargetedVenuesByVenueCriteriaQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMatchBidTargetedVenuesByVenueCriteriaQuery(baseOptions: Apollo.QueryHookOptions<MatchBidTargetedVenuesByVenueCriteriaQuery, MatchBidTargetedVenuesByVenueCriteriaQueryVariables> & ({ variables: MatchBidTargetedVenuesByVenueCriteriaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchBidTargetedVenuesByVenueCriteriaQuery, MatchBidTargetedVenuesByVenueCriteriaQueryVariables>(MatchBidTargetedVenuesByVenueCriteriaDocument, options);
      }
export function useMatchBidTargetedVenuesByVenueCriteriaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchBidTargetedVenuesByVenueCriteriaQuery, MatchBidTargetedVenuesByVenueCriteriaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchBidTargetedVenuesByVenueCriteriaQuery, MatchBidTargetedVenuesByVenueCriteriaQueryVariables>(MatchBidTargetedVenuesByVenueCriteriaDocument, options);
        }
export function useMatchBidTargetedVenuesByVenueCriteriaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MatchBidTargetedVenuesByVenueCriteriaQuery, MatchBidTargetedVenuesByVenueCriteriaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchBidTargetedVenuesByVenueCriteriaQuery, MatchBidTargetedVenuesByVenueCriteriaQueryVariables>(MatchBidTargetedVenuesByVenueCriteriaDocument, options);
        }
export type MatchBidTargetedVenuesByVenueCriteriaQueryHookResult = ReturnType<typeof useMatchBidTargetedVenuesByVenueCriteriaQuery>;
export type MatchBidTargetedVenuesByVenueCriteriaLazyQueryHookResult = ReturnType<typeof useMatchBidTargetedVenuesByVenueCriteriaLazyQuery>;
export type MatchBidTargetedVenuesByVenueCriteriaSuspenseQueryHookResult = ReturnType<typeof useMatchBidTargetedVenuesByVenueCriteriaSuspenseQuery>;
export type MatchBidTargetedVenuesByVenueCriteriaQueryResult = Apollo.QueryResult<MatchBidTargetedVenuesByVenueCriteriaQuery, MatchBidTargetedVenuesByVenueCriteriaQueryVariables>;
export const MatchDashboardOverviewByBrandIdDocument = gql`
    query MatchDashboardOverviewByBrandId($brandId: NonNegativeInt!) {
  matchDashboardOverviewByBrandId(brandId: $brandId) {
    status
    generatedAtUtc
    hasMatchBids
    match {
      winsCount
      customersCount
      winsLastMonthCount
      portfolioCoveragePercentage
      portfolioCoverageUsedCount
      portfolioCoverageUnusedCount
      bidSetupAllRegionsPercentage
      bidSetupAllVenueTypesPercentage
      bidSetupAllCustomerTypesPercentage
      bidSetupZeroMinVolumePercentage
      topCategories {
        productCategoryId
        productCategoryLocalizationKey
        totalProductsCount
        productsWithBidsCount
        portfolioParticipationPercentage
        matchWinsCount
        shareOfTotalWinsPercentage
        winningDiscountPercentage
      }
      weeklyPerformance {
        weekLabel
        dealsAcceptedCount
        salesAmount
      }
      recommendedActionsText
      performanceCommentaryText
    }
  }
}
    `;

/**
 * __useMatchDashboardOverviewByBrandIdQuery__
 *
 * To run a query within a React component, call `useMatchDashboardOverviewByBrandIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchDashboardOverviewByBrandIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchDashboardOverviewByBrandIdQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useMatchDashboardOverviewByBrandIdQuery(baseOptions: Apollo.QueryHookOptions<MatchDashboardOverviewByBrandIdQuery, MatchDashboardOverviewByBrandIdQueryVariables> & ({ variables: MatchDashboardOverviewByBrandIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchDashboardOverviewByBrandIdQuery, MatchDashboardOverviewByBrandIdQueryVariables>(MatchDashboardOverviewByBrandIdDocument, options);
      }
export function useMatchDashboardOverviewByBrandIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchDashboardOverviewByBrandIdQuery, MatchDashboardOverviewByBrandIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchDashboardOverviewByBrandIdQuery, MatchDashboardOverviewByBrandIdQueryVariables>(MatchDashboardOverviewByBrandIdDocument, options);
        }
export function useMatchDashboardOverviewByBrandIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MatchDashboardOverviewByBrandIdQuery, MatchDashboardOverviewByBrandIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchDashboardOverviewByBrandIdQuery, MatchDashboardOverviewByBrandIdQueryVariables>(MatchDashboardOverviewByBrandIdDocument, options);
        }
export type MatchDashboardOverviewByBrandIdQueryHookResult = ReturnType<typeof useMatchDashboardOverviewByBrandIdQuery>;
export type MatchDashboardOverviewByBrandIdLazyQueryHookResult = ReturnType<typeof useMatchDashboardOverviewByBrandIdLazyQuery>;
export type MatchDashboardOverviewByBrandIdSuspenseQueryHookResult = ReturnType<typeof useMatchDashboardOverviewByBrandIdSuspenseQuery>;
export type MatchDashboardOverviewByBrandIdQueryResult = Apollo.QueryResult<MatchDashboardOverviewByBrandIdQuery, MatchDashboardOverviewByBrandIdQueryVariables>;
export const MatchDashboardConnectStatsByBrandIdDocument = gql`
    query MatchDashboardConnectStatsByBrandId($brandId: NonNegativeInt!) {
  matchDashboardConnectStatsByBrandId(brandId: $brandId) {
    winsCount
    customersCount
    winsLastMonthCount
    estimatedSales
  }
}
    `;

/**
 * __useMatchDashboardConnectStatsByBrandIdQuery__
 *
 * To run a query within a React component, call `useMatchDashboardConnectStatsByBrandIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchDashboardConnectStatsByBrandIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchDashboardConnectStatsByBrandIdQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useMatchDashboardConnectStatsByBrandIdQuery(baseOptions: Apollo.QueryHookOptions<MatchDashboardConnectStatsByBrandIdQuery, MatchDashboardConnectStatsByBrandIdQueryVariables> & ({ variables: MatchDashboardConnectStatsByBrandIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchDashboardConnectStatsByBrandIdQuery, MatchDashboardConnectStatsByBrandIdQueryVariables>(MatchDashboardConnectStatsByBrandIdDocument, options);
      }
export function useMatchDashboardConnectStatsByBrandIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchDashboardConnectStatsByBrandIdQuery, MatchDashboardConnectStatsByBrandIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchDashboardConnectStatsByBrandIdQuery, MatchDashboardConnectStatsByBrandIdQueryVariables>(MatchDashboardConnectStatsByBrandIdDocument, options);
        }
export function useMatchDashboardConnectStatsByBrandIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MatchDashboardConnectStatsByBrandIdQuery, MatchDashboardConnectStatsByBrandIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchDashboardConnectStatsByBrandIdQuery, MatchDashboardConnectStatsByBrandIdQueryVariables>(MatchDashboardConnectStatsByBrandIdDocument, options);
        }
export type MatchDashboardConnectStatsByBrandIdQueryHookResult = ReturnType<typeof useMatchDashboardConnectStatsByBrandIdQuery>;
export type MatchDashboardConnectStatsByBrandIdLazyQueryHookResult = ReturnType<typeof useMatchDashboardConnectStatsByBrandIdLazyQuery>;
export type MatchDashboardConnectStatsByBrandIdSuspenseQueryHookResult = ReturnType<typeof useMatchDashboardConnectStatsByBrandIdSuspenseQuery>;
export type MatchDashboardConnectStatsByBrandIdQueryResult = Apollo.QueryResult<MatchDashboardConnectStatsByBrandIdQuery, MatchDashboardConnectStatsByBrandIdQueryVariables>;
export const MatchTargetCriteriaByBrandIdDocument = gql`
    query MatchTargetCriteriaByBrandId($brandId: NonNegativeInt!) {
  matchTargetCriteriaByBrandId(brandId: $brandId) {
    regions {
      percentageTargetingAll
      meetsRecommendedThreshold
    }
    customerTypes {
      percentageTargetingAll
      meetsRecommendedThreshold
    }
    venueTypes {
      percentageTargetingAll
      meetsRecommendedThreshold
    }
    loyaltyLevels {
      percentageTargetingAll
      meetsRecommendedThreshold
    }
    minimumVolume {
      percentageTargetingAll
      meetsRecommendedThreshold
    }
    listingTypes {
      listingTypeLocalizationKey
      percentageTargetingAll
      meetsRecommendedThreshold
    }
  }
}
    `;

/**
 * __useMatchTargetCriteriaByBrandIdQuery__
 *
 * To run a query within a React component, call `useMatchTargetCriteriaByBrandIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchTargetCriteriaByBrandIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchTargetCriteriaByBrandIdQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useMatchTargetCriteriaByBrandIdQuery(baseOptions: Apollo.QueryHookOptions<MatchTargetCriteriaByBrandIdQuery, MatchTargetCriteriaByBrandIdQueryVariables> & ({ variables: MatchTargetCriteriaByBrandIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchTargetCriteriaByBrandIdQuery, MatchTargetCriteriaByBrandIdQueryVariables>(MatchTargetCriteriaByBrandIdDocument, options);
      }
export function useMatchTargetCriteriaByBrandIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchTargetCriteriaByBrandIdQuery, MatchTargetCriteriaByBrandIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchTargetCriteriaByBrandIdQuery, MatchTargetCriteriaByBrandIdQueryVariables>(MatchTargetCriteriaByBrandIdDocument, options);
        }
export function useMatchTargetCriteriaByBrandIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MatchTargetCriteriaByBrandIdQuery, MatchTargetCriteriaByBrandIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchTargetCriteriaByBrandIdQuery, MatchTargetCriteriaByBrandIdQueryVariables>(MatchTargetCriteriaByBrandIdDocument, options);
        }
export type MatchTargetCriteriaByBrandIdQueryHookResult = ReturnType<typeof useMatchTargetCriteriaByBrandIdQuery>;
export type MatchTargetCriteriaByBrandIdLazyQueryHookResult = ReturnType<typeof useMatchTargetCriteriaByBrandIdLazyQuery>;
export type MatchTargetCriteriaByBrandIdSuspenseQueryHookResult = ReturnType<typeof useMatchTargetCriteriaByBrandIdSuspenseQuery>;
export type MatchTargetCriteriaByBrandIdQueryResult = Apollo.QueryResult<MatchTargetCriteriaByBrandIdQuery, MatchTargetCriteriaByBrandIdQueryVariables>;
export const MatchDealTrackingByBrandDocument = gql`
    query MatchDealTrackingByBrand($brandId: NonNegativeInt!, $limit: NonNegativeInt!, $offset: NonNegativeInt!, $bidIds: [NonNegativeInt!], $venueIds: [NonNegativeInt!], $productTemplateIds: [NonNegativeInt!], $listingTypeLocalizationKeys: [NonEmptyString!], $productCategoryLocalizationKeys: [NonEmptyString!]) {
  matchDealTrackingByBrand(
    brandId: $brandId
    limit: $limit
    offset: $offset
    bidIds: $bidIds
    venueIds: $venueIds
    productTemplateIds: $productTemplateIds
    listingTypeLocalizationKeys: $listingTypeLocalizationKeys
    productCategoryLocalizationKeys: $productCategoryLocalizationKeys
  ) {
    highlights {
      winsCount
      customersPurchasedCount
      totalSales
      totalUnitsPurchased
    }
    data {
      id
      bidId
      venueId
      acceptedAtUtc
      listingEndsAtUtc
      customerName
      customerEmail
      customerPhoneNumber
      productName
      productCategoryLocalizationKey
      listingTypeLocalizationKey
      unitsPurchased
      salesAmount
      unitPrice
      unitsPurchasedSinceAccepted
      supports {
        supportType
        amount
      }
      totalSupport
    }
    pageInfo {
      ...OffsetPagination
    }
  }
}
    ${OffsetPaginationFragmentDoc}`;

/**
 * __useMatchDealTrackingByBrandQuery__
 *
 * To run a query within a React component, call `useMatchDealTrackingByBrandQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchDealTrackingByBrandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchDealTrackingByBrandQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      bidIds: // value for 'bidIds'
 *      venueIds: // value for 'venueIds'
 *      productTemplateIds: // value for 'productTemplateIds'
 *      listingTypeLocalizationKeys: // value for 'listingTypeLocalizationKeys'
 *      productCategoryLocalizationKeys: // value for 'productCategoryLocalizationKeys'
 *   },
 * });
 */
export function useMatchDealTrackingByBrandQuery(baseOptions: Apollo.QueryHookOptions<MatchDealTrackingByBrandQuery, MatchDealTrackingByBrandQueryVariables> & ({ variables: MatchDealTrackingByBrandQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchDealTrackingByBrandQuery, MatchDealTrackingByBrandQueryVariables>(MatchDealTrackingByBrandDocument, options);
      }
export function useMatchDealTrackingByBrandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchDealTrackingByBrandQuery, MatchDealTrackingByBrandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchDealTrackingByBrandQuery, MatchDealTrackingByBrandQueryVariables>(MatchDealTrackingByBrandDocument, options);
        }
export function useMatchDealTrackingByBrandSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MatchDealTrackingByBrandQuery, MatchDealTrackingByBrandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchDealTrackingByBrandQuery, MatchDealTrackingByBrandQueryVariables>(MatchDealTrackingByBrandDocument, options);
        }
export type MatchDealTrackingByBrandQueryHookResult = ReturnType<typeof useMatchDealTrackingByBrandQuery>;
export type MatchDealTrackingByBrandLazyQueryHookResult = ReturnType<typeof useMatchDealTrackingByBrandLazyQuery>;
export type MatchDealTrackingByBrandSuspenseQueryHookResult = ReturnType<typeof useMatchDealTrackingByBrandSuspenseQuery>;
export type MatchDealTrackingByBrandQueryResult = Apollo.QueryResult<MatchDealTrackingByBrandQuery, MatchDealTrackingByBrandQueryVariables>;
export const MatchDealTrackingFilterOptionsDocument = gql`
    query MatchDealTrackingFilterOptions($brandId: NonNegativeInt!) {
  matchDealTrackingFilterOptions(brandId: $brandId) {
    label
    options {
      label
      value
    }
  }
}
    `;

/**
 * __useMatchDealTrackingFilterOptionsQuery__
 *
 * To run a query within a React component, call `useMatchDealTrackingFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchDealTrackingFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchDealTrackingFilterOptionsQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useMatchDealTrackingFilterOptionsQuery(baseOptions: Apollo.QueryHookOptions<MatchDealTrackingFilterOptionsQuery, MatchDealTrackingFilterOptionsQueryVariables> & ({ variables: MatchDealTrackingFilterOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchDealTrackingFilterOptionsQuery, MatchDealTrackingFilterOptionsQueryVariables>(MatchDealTrackingFilterOptionsDocument, options);
      }
export function useMatchDealTrackingFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchDealTrackingFilterOptionsQuery, MatchDealTrackingFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchDealTrackingFilterOptionsQuery, MatchDealTrackingFilterOptionsQueryVariables>(MatchDealTrackingFilterOptionsDocument, options);
        }
export function useMatchDealTrackingFilterOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MatchDealTrackingFilterOptionsQuery, MatchDealTrackingFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchDealTrackingFilterOptionsQuery, MatchDealTrackingFilterOptionsQueryVariables>(MatchDealTrackingFilterOptionsDocument, options);
        }
export type MatchDealTrackingFilterOptionsQueryHookResult = ReturnType<typeof useMatchDealTrackingFilterOptionsQuery>;
export type MatchDealTrackingFilterOptionsLazyQueryHookResult = ReturnType<typeof useMatchDealTrackingFilterOptionsLazyQuery>;
export type MatchDealTrackingFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useMatchDealTrackingFilterOptionsSuspenseQuery>;
export type MatchDealTrackingFilterOptionsQueryResult = Apollo.QueryResult<MatchDealTrackingFilterOptionsQuery, MatchDealTrackingFilterOptionsQueryVariables>;
export const MatchDealTrackingBidPdfDocument = gql`
    query MatchDealTrackingBidPdf($bidId: NonNegativeInt!, $venueId: NonNegativeInt!) {
  matchBidVenuePdf(bidId: $bidId, venueId: $venueId) {
    filename
    content
  }
}
    `;

/**
 * __useMatchDealTrackingBidPdfQuery__
 *
 * To run a query within a React component, call `useMatchDealTrackingBidPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchDealTrackingBidPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchDealTrackingBidPdfQuery({
 *   variables: {
 *      bidId: // value for 'bidId'
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useMatchDealTrackingBidPdfQuery(baseOptions: Apollo.QueryHookOptions<MatchDealTrackingBidPdfQuery, MatchDealTrackingBidPdfQueryVariables> & ({ variables: MatchDealTrackingBidPdfQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchDealTrackingBidPdfQuery, MatchDealTrackingBidPdfQueryVariables>(MatchDealTrackingBidPdfDocument, options);
      }
export function useMatchDealTrackingBidPdfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchDealTrackingBidPdfQuery, MatchDealTrackingBidPdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchDealTrackingBidPdfQuery, MatchDealTrackingBidPdfQueryVariables>(MatchDealTrackingBidPdfDocument, options);
        }
export function useMatchDealTrackingBidPdfSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MatchDealTrackingBidPdfQuery, MatchDealTrackingBidPdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchDealTrackingBidPdfQuery, MatchDealTrackingBidPdfQueryVariables>(MatchDealTrackingBidPdfDocument, options);
        }
export type MatchDealTrackingBidPdfQueryHookResult = ReturnType<typeof useMatchDealTrackingBidPdfQuery>;
export type MatchDealTrackingBidPdfLazyQueryHookResult = ReturnType<typeof useMatchDealTrackingBidPdfLazyQuery>;
export type MatchDealTrackingBidPdfSuspenseQueryHookResult = ReturnType<typeof useMatchDealTrackingBidPdfSuspenseQuery>;
export type MatchDealTrackingBidPdfQueryResult = Apollo.QueryResult<MatchDealTrackingBidPdfQuery, MatchDealTrackingBidPdfQueryVariables>;
export const MatchDashboardOverviewPdfDocument = gql`
    query MatchDashboardOverviewPdf($brandId: NonNegativeInt!) {
  matchDashboardOverviewPdf(brandId: $brandId) {
    filename
    content
  }
}
    `;

/**
 * __useMatchDashboardOverviewPdfQuery__
 *
 * To run a query within a React component, call `useMatchDashboardOverviewPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchDashboardOverviewPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchDashboardOverviewPdfQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useMatchDashboardOverviewPdfQuery(baseOptions: Apollo.QueryHookOptions<MatchDashboardOverviewPdfQuery, MatchDashboardOverviewPdfQueryVariables> & ({ variables: MatchDashboardOverviewPdfQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchDashboardOverviewPdfQuery, MatchDashboardOverviewPdfQueryVariables>(MatchDashboardOverviewPdfDocument, options);
      }
export function useMatchDashboardOverviewPdfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchDashboardOverviewPdfQuery, MatchDashboardOverviewPdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchDashboardOverviewPdfQuery, MatchDashboardOverviewPdfQueryVariables>(MatchDashboardOverviewPdfDocument, options);
        }
export function useMatchDashboardOverviewPdfSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MatchDashboardOverviewPdfQuery, MatchDashboardOverviewPdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchDashboardOverviewPdfQuery, MatchDashboardOverviewPdfQueryVariables>(MatchDashboardOverviewPdfDocument, options);
        }
export type MatchDashboardOverviewPdfQueryHookResult = ReturnType<typeof useMatchDashboardOverviewPdfQuery>;
export type MatchDashboardOverviewPdfLazyQueryHookResult = ReturnType<typeof useMatchDashboardOverviewPdfLazyQuery>;
export type MatchDashboardOverviewPdfSuspenseQueryHookResult = ReturnType<typeof useMatchDashboardOverviewPdfSuspenseQuery>;
export type MatchDashboardOverviewPdfQueryResult = Apollo.QueryResult<MatchDashboardOverviewPdfQuery, MatchDashboardOverviewPdfQueryVariables>;
export const MessagesByBidIdDocument = gql`
    query MessagesByBidId($bidId: Int!) {
  messagesByBidId(bidId: $bidId) {
    ...MessageInfo
    venue {
      id
      name
    }
    brand {
      id
      name
    }
  }
}
    ${MessageInfoFragmentDoc}`;

/**
 * __useMessagesByBidIdQuery__
 *
 * To run a query within a React component, call `useMessagesByBidIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessagesByBidIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagesByBidIdQuery({
 *   variables: {
 *      bidId: // value for 'bidId'
 *   },
 * });
 */
export function useMessagesByBidIdQuery(baseOptions: Apollo.QueryHookOptions<MessagesByBidIdQuery, MessagesByBidIdQueryVariables> & ({ variables: MessagesByBidIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessagesByBidIdQuery, MessagesByBidIdQueryVariables>(MessagesByBidIdDocument, options);
      }
export function useMessagesByBidIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessagesByBidIdQuery, MessagesByBidIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessagesByBidIdQuery, MessagesByBidIdQueryVariables>(MessagesByBidIdDocument, options);
        }
export function useMessagesByBidIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MessagesByBidIdQuery, MessagesByBidIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MessagesByBidIdQuery, MessagesByBidIdQueryVariables>(MessagesByBidIdDocument, options);
        }
export type MessagesByBidIdQueryHookResult = ReturnType<typeof useMessagesByBidIdQuery>;
export type MessagesByBidIdLazyQueryHookResult = ReturnType<typeof useMessagesByBidIdLazyQuery>;
export type MessagesByBidIdSuspenseQueryHookResult = ReturnType<typeof useMessagesByBidIdSuspenseQuery>;
export type MessagesByBidIdQueryResult = Apollo.QueryResult<MessagesByBidIdQuery, MessagesByBidIdQueryVariables>;
export const AddMessageDocument = gql`
    mutation AddMessage($input: AddMessageInput!) {
  addMessage(input: $input) {
    ...MessageInfo
  }
}
    ${MessageInfoFragmentDoc}`;
export type AddMessageMutationFn = Apollo.MutationFunction<AddMessageMutation, AddMessageMutationVariables>;

/**
 * __useAddMessageMutation__
 *
 * To run a mutation, you first call `useAddMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMessageMutation, { data, loading, error }] = useAddMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMessageMutation(baseOptions?: Apollo.MutationHookOptions<AddMessageMutation, AddMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMessageMutation, AddMessageMutationVariables>(AddMessageDocument, options);
      }
export type AddMessageMutationHookResult = ReturnType<typeof useAddMessageMutation>;
export type AddMessageMutationResult = Apollo.MutationResult<AddMessageMutation>;
export type AddMessageMutationOptions = Apollo.BaseMutationOptions<AddMessageMutation, AddMessageMutationVariables>;
export const MarkNotificationAsReadDocument = gql`
    mutation MarkNotificationAsRead($id: Int!) {
  markNotificationAsRead(id: $id) {
    ...NotificationInfo
  }
}
    ${NotificationInfoFragmentDoc}`;
export type MarkNotificationAsReadMutationFn = Apollo.MutationFunction<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;

/**
 * __useMarkNotificationAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationAsReadMutation, { data, loading, error }] = useMarkNotificationAsReadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkNotificationAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>(MarkNotificationAsReadDocument, options);
      }
export type MarkNotificationAsReadMutationHookResult = ReturnType<typeof useMarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationResult = Apollo.MutationResult<MarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationOptions = Apollo.BaseMutationOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;
export const MarkAllNotificationsAsReadDocument = gql`
    mutation MarkAllNotificationsAsRead($input: MarkAllNotificationsAsReadInput!) {
  markAllNotificationsAsRead(input: $input) {
    ...NotificationInfo
  }
}
    ${NotificationInfoFragmentDoc}`;
export type MarkAllNotificationsAsReadMutationFn = Apollo.MutationFunction<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>;

/**
 * __useMarkAllNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllNotificationsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllNotificationsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllNotificationsAsReadMutation, { data, loading, error }] = useMarkAllNotificationsAsReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkAllNotificationsAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>(MarkAllNotificationsAsReadDocument, options);
      }
export type MarkAllNotificationsAsReadMutationHookResult = ReturnType<typeof useMarkAllNotificationsAsReadMutation>;
export type MarkAllNotificationsAsReadMutationResult = Apollo.MutationResult<MarkAllNotificationsAsReadMutation>;
export type MarkAllNotificationsAsReadMutationOptions = Apollo.BaseMutationOptions<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>;
export const CursorNotificationsDocument = gql`
    query CursorNotifications($input: CursorNotificationsInput!) {
  cursorNotifications(input: $input) {
    edges {
      node {
        ...NotificationInfo
      }
      cursor
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
    unreadTotalCount
  }
}
    ${NotificationInfoFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useCursorNotificationsQuery__
 *
 * To run a query within a React component, call `useCursorNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCursorNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCursorNotificationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCursorNotificationsQuery(baseOptions: Apollo.QueryHookOptions<CursorNotificationsQuery, CursorNotificationsQueryVariables> & ({ variables: CursorNotificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CursorNotificationsQuery, CursorNotificationsQueryVariables>(CursorNotificationsDocument, options);
      }
export function useCursorNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CursorNotificationsQuery, CursorNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CursorNotificationsQuery, CursorNotificationsQueryVariables>(CursorNotificationsDocument, options);
        }
export function useCursorNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CursorNotificationsQuery, CursorNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CursorNotificationsQuery, CursorNotificationsQueryVariables>(CursorNotificationsDocument, options);
        }
export type CursorNotificationsQueryHookResult = ReturnType<typeof useCursorNotificationsQuery>;
export type CursorNotificationsLazyQueryHookResult = ReturnType<typeof useCursorNotificationsLazyQuery>;
export type CursorNotificationsSuspenseQueryHookResult = ReturnType<typeof useCursorNotificationsSuspenseQuery>;
export type CursorNotificationsQueryResult = Apollo.QueryResult<CursorNotificationsQuery, CursorNotificationsQueryVariables>;
export const OffsetNotificationsDocument = gql`
    query OffsetNotifications($input: OffsetNotificationsInput!) {
  offsetNotifications(input: $input) {
    data {
      ...NotificationInfo
    }
    pageInfo {
      ...OffsetPageInfo
    }
    totalCount
    unreadTotalCount
  }
}
    ${NotificationInfoFragmentDoc}
${OffsetPageInfoFragmentDoc}`;

/**
 * __useOffsetNotificationsQuery__
 *
 * To run a query within a React component, call `useOffsetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOffsetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOffsetNotificationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOffsetNotificationsQuery(baseOptions: Apollo.QueryHookOptions<OffsetNotificationsQuery, OffsetNotificationsQueryVariables> & ({ variables: OffsetNotificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OffsetNotificationsQuery, OffsetNotificationsQueryVariables>(OffsetNotificationsDocument, options);
      }
export function useOffsetNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OffsetNotificationsQuery, OffsetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OffsetNotificationsQuery, OffsetNotificationsQueryVariables>(OffsetNotificationsDocument, options);
        }
export function useOffsetNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OffsetNotificationsQuery, OffsetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OffsetNotificationsQuery, OffsetNotificationsQueryVariables>(OffsetNotificationsDocument, options);
        }
export type OffsetNotificationsQueryHookResult = ReturnType<typeof useOffsetNotificationsQuery>;
export type OffsetNotificationsLazyQueryHookResult = ReturnType<typeof useOffsetNotificationsLazyQuery>;
export type OffsetNotificationsSuspenseQueryHookResult = ReturnType<typeof useOffsetNotificationsSuspenseQuery>;
export type OffsetNotificationsQueryResult = Apollo.QueryResult<OffsetNotificationsQuery, OffsetNotificationsQueryVariables>;
export const ProductCategoryTreeDocument = gql`
    query ProductCategoryTree {
  productCategoriesTree {
    ...ProductCategoryTreeInfo
  }
}
    ${ProductCategoryTreeInfoFragmentDoc}`;

/**
 * __useProductCategoryTreeQuery__
 *
 * To run a query within a React component, call `useProductCategoryTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCategoryTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCategoryTreeQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductCategoryTreeQuery(baseOptions?: Apollo.QueryHookOptions<ProductCategoryTreeQuery, ProductCategoryTreeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductCategoryTreeQuery, ProductCategoryTreeQueryVariables>(ProductCategoryTreeDocument, options);
      }
export function useProductCategoryTreeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductCategoryTreeQuery, ProductCategoryTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductCategoryTreeQuery, ProductCategoryTreeQueryVariables>(ProductCategoryTreeDocument, options);
        }
export function useProductCategoryTreeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductCategoryTreeQuery, ProductCategoryTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductCategoryTreeQuery, ProductCategoryTreeQueryVariables>(ProductCategoryTreeDocument, options);
        }
export type ProductCategoryTreeQueryHookResult = ReturnType<typeof useProductCategoryTreeQuery>;
export type ProductCategoryTreeLazyQueryHookResult = ReturnType<typeof useProductCategoryTreeLazyQuery>;
export type ProductCategoryTreeSuspenseQueryHookResult = ReturnType<typeof useProductCategoryTreeSuspenseQuery>;
export type ProductCategoryTreeQueryResult = Apollo.QueryResult<ProductCategoryTreeQuery, ProductCategoryTreeQueryVariables>;
export const TopLevelProductCategoryByIdDocument = gql`
    query TopLevelProductCategoryById($productCategoryId: NonNegativeInt!) {
  topLevelProductCategoryById(productCategoryId: $productCategoryId) {
    id
    localizationKey
  }
}
    `;

/**
 * __useTopLevelProductCategoryByIdQuery__
 *
 * To run a query within a React component, call `useTopLevelProductCategoryByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopLevelProductCategoryByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopLevelProductCategoryByIdQuery({
 *   variables: {
 *      productCategoryId: // value for 'productCategoryId'
 *   },
 * });
 */
export function useTopLevelProductCategoryByIdQuery(baseOptions: Apollo.QueryHookOptions<TopLevelProductCategoryByIdQuery, TopLevelProductCategoryByIdQueryVariables> & ({ variables: TopLevelProductCategoryByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopLevelProductCategoryByIdQuery, TopLevelProductCategoryByIdQueryVariables>(TopLevelProductCategoryByIdDocument, options);
      }
export function useTopLevelProductCategoryByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopLevelProductCategoryByIdQuery, TopLevelProductCategoryByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopLevelProductCategoryByIdQuery, TopLevelProductCategoryByIdQueryVariables>(TopLevelProductCategoryByIdDocument, options);
        }
export function useTopLevelProductCategoryByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TopLevelProductCategoryByIdQuery, TopLevelProductCategoryByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TopLevelProductCategoryByIdQuery, TopLevelProductCategoryByIdQueryVariables>(TopLevelProductCategoryByIdDocument, options);
        }
export type TopLevelProductCategoryByIdQueryHookResult = ReturnType<typeof useTopLevelProductCategoryByIdQuery>;
export type TopLevelProductCategoryByIdLazyQueryHookResult = ReturnType<typeof useTopLevelProductCategoryByIdLazyQuery>;
export type TopLevelProductCategoryByIdSuspenseQueryHookResult = ReturnType<typeof useTopLevelProductCategoryByIdSuspenseQuery>;
export type TopLevelProductCategoryByIdQueryResult = Apollo.QueryResult<TopLevelProductCategoryByIdQuery, TopLevelProductCategoryByIdQueryVariables>;
export const ProductCategoriesByIdsDocument = gql`
    query ProductCategoriesByIds($productCategoryIds: [NonNegativeInt!]!) {
  productCategoriesByIds(productCategoryIds: $productCategoryIds) {
    id
    localizationKey
  }
}
    `;

/**
 * __useProductCategoriesByIdsQuery__
 *
 * To run a query within a React component, call `useProductCategoriesByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCategoriesByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCategoriesByIdsQuery({
 *   variables: {
 *      productCategoryIds: // value for 'productCategoryIds'
 *   },
 * });
 */
export function useProductCategoriesByIdsQuery(baseOptions: Apollo.QueryHookOptions<ProductCategoriesByIdsQuery, ProductCategoriesByIdsQueryVariables> & ({ variables: ProductCategoriesByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductCategoriesByIdsQuery, ProductCategoriesByIdsQueryVariables>(ProductCategoriesByIdsDocument, options);
      }
export function useProductCategoriesByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductCategoriesByIdsQuery, ProductCategoriesByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductCategoriesByIdsQuery, ProductCategoriesByIdsQueryVariables>(ProductCategoriesByIdsDocument, options);
        }
export function useProductCategoriesByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductCategoriesByIdsQuery, ProductCategoriesByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductCategoriesByIdsQuery, ProductCategoriesByIdsQueryVariables>(ProductCategoriesByIdsDocument, options);
        }
export type ProductCategoriesByIdsQueryHookResult = ReturnType<typeof useProductCategoriesByIdsQuery>;
export type ProductCategoriesByIdsLazyQueryHookResult = ReturnType<typeof useProductCategoriesByIdsLazyQuery>;
export type ProductCategoriesByIdsSuspenseQueryHookResult = ReturnType<typeof useProductCategoriesByIdsSuspenseQuery>;
export type ProductCategoriesByIdsQueryResult = Apollo.QueryResult<ProductCategoriesByIdsQuery, ProductCategoriesByIdsQueryVariables>;
export const ProductTemplatesByBrandIdDocument = gql`
    query ProductTemplatesByBrandId($input: ProductTemplatesByBrandIdInput!) {
  productTemplatesByBrandId(input: $input) {
    ...ProductTemplateInfo
  }
}
    ${ProductTemplateInfoFragmentDoc}`;

/**
 * __useProductTemplatesByBrandIdQuery__
 *
 * To run a query within a React component, call `useProductTemplatesByBrandIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductTemplatesByBrandIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductTemplatesByBrandIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProductTemplatesByBrandIdQuery(baseOptions: Apollo.QueryHookOptions<ProductTemplatesByBrandIdQuery, ProductTemplatesByBrandIdQueryVariables> & ({ variables: ProductTemplatesByBrandIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductTemplatesByBrandIdQuery, ProductTemplatesByBrandIdQueryVariables>(ProductTemplatesByBrandIdDocument, options);
      }
export function useProductTemplatesByBrandIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductTemplatesByBrandIdQuery, ProductTemplatesByBrandIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductTemplatesByBrandIdQuery, ProductTemplatesByBrandIdQueryVariables>(ProductTemplatesByBrandIdDocument, options);
        }
export function useProductTemplatesByBrandIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductTemplatesByBrandIdQuery, ProductTemplatesByBrandIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductTemplatesByBrandIdQuery, ProductTemplatesByBrandIdQueryVariables>(ProductTemplatesByBrandIdDocument, options);
        }
export type ProductTemplatesByBrandIdQueryHookResult = ReturnType<typeof useProductTemplatesByBrandIdQuery>;
export type ProductTemplatesByBrandIdLazyQueryHookResult = ReturnType<typeof useProductTemplatesByBrandIdLazyQuery>;
export type ProductTemplatesByBrandIdSuspenseQueryHookResult = ReturnType<typeof useProductTemplatesByBrandIdSuspenseQuery>;
export type ProductTemplatesByBrandIdQueryResult = Apollo.QueryResult<ProductTemplatesByBrandIdQuery, ProductTemplatesByBrandIdQueryVariables>;
export const DeleteProductTemplateByIdDocument = gql`
    mutation DeleteProductTemplateById($input: DeleteProductTemplateInput!) {
  deleteProductTemplateById(input: $input)
}
    `;
export type DeleteProductTemplateByIdMutationFn = Apollo.MutationFunction<DeleteProductTemplateByIdMutation, DeleteProductTemplateByIdMutationVariables>;

/**
 * __useDeleteProductTemplateByIdMutation__
 *
 * To run a mutation, you first call `useDeleteProductTemplateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductTemplateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductTemplateByIdMutation, { data, loading, error }] = useDeleteProductTemplateByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteProductTemplateByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductTemplateByIdMutation, DeleteProductTemplateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductTemplateByIdMutation, DeleteProductTemplateByIdMutationVariables>(DeleteProductTemplateByIdDocument, options);
      }
export type DeleteProductTemplateByIdMutationHookResult = ReturnType<typeof useDeleteProductTemplateByIdMutation>;
export type DeleteProductTemplateByIdMutationResult = Apollo.MutationResult<DeleteProductTemplateByIdMutation>;
export type DeleteProductTemplateByIdMutationOptions = Apollo.BaseMutationOptions<DeleteProductTemplateByIdMutation, DeleteProductTemplateByIdMutationVariables>;
export const AddProductTemplateDocument = gql`
    mutation AddProductTemplate($input: AddProductTemplateInput!) {
  addProductTemplate(input: $input) {
    ...ProductTemplateInfo
  }
}
    ${ProductTemplateInfoFragmentDoc}`;
export type AddProductTemplateMutationFn = Apollo.MutationFunction<AddProductTemplateMutation, AddProductTemplateMutationVariables>;

/**
 * __useAddProductTemplateMutation__
 *
 * To run a mutation, you first call `useAddProductTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductTemplateMutation, { data, loading, error }] = useAddProductTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProductTemplateMutation(baseOptions?: Apollo.MutationHookOptions<AddProductTemplateMutation, AddProductTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductTemplateMutation, AddProductTemplateMutationVariables>(AddProductTemplateDocument, options);
      }
export type AddProductTemplateMutationHookResult = ReturnType<typeof useAddProductTemplateMutation>;
export type AddProductTemplateMutationResult = Apollo.MutationResult<AddProductTemplateMutation>;
export type AddProductTemplateMutationOptions = Apollo.BaseMutationOptions<AddProductTemplateMutation, AddProductTemplateMutationVariables>;
export const EditProductTemplateDocument = gql`
    mutation EditProductTemplate($input: EditProductTemplateInput!) {
  editProductTemplate(input: $input) {
    ...ProductTemplateInfo
  }
}
    ${ProductTemplateInfoFragmentDoc}`;
export type EditProductTemplateMutationFn = Apollo.MutationFunction<EditProductTemplateMutation, EditProductTemplateMutationVariables>;

/**
 * __useEditProductTemplateMutation__
 *
 * To run a mutation, you first call `useEditProductTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProductTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProductTemplateMutation, { data, loading, error }] = useEditProductTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditProductTemplateMutation(baseOptions?: Apollo.MutationHookOptions<EditProductTemplateMutation, EditProductTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProductTemplateMutation, EditProductTemplateMutationVariables>(EditProductTemplateDocument, options);
      }
export type EditProductTemplateMutationHookResult = ReturnType<typeof useEditProductTemplateMutation>;
export type EditProductTemplateMutationResult = Apollo.MutationResult<EditProductTemplateMutation>;
export type EditProductTemplateMutationOptions = Apollo.BaseMutationOptions<EditProductTemplateMutation, EditProductTemplateMutationVariables>;
export const ProductUnitDocument = gql`
    query ProductUnit {
  productUnits
}
    `;

/**
 * __useProductUnitQuery__
 *
 * To run a query within a React component, call `useProductUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductUnitQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductUnitQuery(baseOptions?: Apollo.QueryHookOptions<ProductUnitQuery, ProductUnitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductUnitQuery, ProductUnitQueryVariables>(ProductUnitDocument, options);
      }
export function useProductUnitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductUnitQuery, ProductUnitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductUnitQuery, ProductUnitQueryVariables>(ProductUnitDocument, options);
        }
export function useProductUnitSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductUnitQuery, ProductUnitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductUnitQuery, ProductUnitQueryVariables>(ProductUnitDocument, options);
        }
export type ProductUnitQueryHookResult = ReturnType<typeof useProductUnitQuery>;
export type ProductUnitLazyQueryHookResult = ReturnType<typeof useProductUnitLazyQuery>;
export type ProductUnitSuspenseQueryHookResult = ReturnType<typeof useProductUnitSuspenseQuery>;
export type ProductUnitQueryResult = Apollo.QueryResult<ProductUnitQuery, ProductUnitQueryVariables>;
export const ProductPackagingDocument = gql`
    query ProductPackaging {
  productPackaging
}
    `;

/**
 * __useProductPackagingQuery__
 *
 * To run a query within a React component, call `useProductPackagingQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPackagingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPackagingQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductPackagingQuery(baseOptions?: Apollo.QueryHookOptions<ProductPackagingQuery, ProductPackagingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductPackagingQuery, ProductPackagingQueryVariables>(ProductPackagingDocument, options);
      }
export function useProductPackagingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductPackagingQuery, ProductPackagingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductPackagingQuery, ProductPackagingQueryVariables>(ProductPackagingDocument, options);
        }
export function useProductPackagingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductPackagingQuery, ProductPackagingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductPackagingQuery, ProductPackagingQueryVariables>(ProductPackagingDocument, options);
        }
export type ProductPackagingQueryHookResult = ReturnType<typeof useProductPackagingQuery>;
export type ProductPackagingLazyQueryHookResult = ReturnType<typeof useProductPackagingLazyQuery>;
export type ProductPackagingSuspenseQueryHookResult = ReturnType<typeof useProductPackagingSuspenseQuery>;
export type ProductPackagingQueryResult = Apollo.QueryResult<ProductPackagingQuery, ProductPackagingQueryVariables>;
export const ExternalProductLivePriceDocument = gql`
    query ExternalProductLivePrice($brandId: NonNegativeInt!, $venueId: NonNegativeInt!, $productTemplateId: NonNegativeInt!) {
  externalProductLivePrice(
    brandId: $brandId
    venueId: $venueId
    productTemplateId: $productTemplateId
  ) {
    externalProductId
    price
    casePrice
    basePrice
    baseCasePrice
  }
}
    `;

/**
 * __useExternalProductLivePriceQuery__
 *
 * To run a query within a React component, call `useExternalProductLivePriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalProductLivePriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalProductLivePriceQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      venueId: // value for 'venueId'
 *      productTemplateId: // value for 'productTemplateId'
 *   },
 * });
 */
export function useExternalProductLivePriceQuery(baseOptions: Apollo.QueryHookOptions<ExternalProductLivePriceQuery, ExternalProductLivePriceQueryVariables> & ({ variables: ExternalProductLivePriceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExternalProductLivePriceQuery, ExternalProductLivePriceQueryVariables>(ExternalProductLivePriceDocument, options);
      }
export function useExternalProductLivePriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExternalProductLivePriceQuery, ExternalProductLivePriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExternalProductLivePriceQuery, ExternalProductLivePriceQueryVariables>(ExternalProductLivePriceDocument, options);
        }
export function useExternalProductLivePriceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExternalProductLivePriceQuery, ExternalProductLivePriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExternalProductLivePriceQuery, ExternalProductLivePriceQueryVariables>(ExternalProductLivePriceDocument, options);
        }
export type ExternalProductLivePriceQueryHookResult = ReturnType<typeof useExternalProductLivePriceQuery>;
export type ExternalProductLivePriceLazyQueryHookResult = ReturnType<typeof useExternalProductLivePriceLazyQuery>;
export type ExternalProductLivePriceSuspenseQueryHookResult = ReturnType<typeof useExternalProductLivePriceSuspenseQuery>;
export type ExternalProductLivePriceQueryResult = Apollo.QueryResult<ExternalProductLivePriceQuery, ExternalProductLivePriceQueryVariables>;
export const GetDataFromCompanyNumberDocument = gql`
    query GetDataFromCompanyNumber($input: GetDataFromCompanyNumberInput!) {
  getDataFromCompanyNumber(input: $input) {
    ...RegisteredCompanyWithoutIdInfo
  }
}
    ${RegisteredCompanyWithoutIdInfoFragmentDoc}`;

/**
 * __useGetDataFromCompanyNumberQuery__
 *
 * To run a query within a React component, call `useGetDataFromCompanyNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataFromCompanyNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataFromCompanyNumberQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDataFromCompanyNumberQuery(baseOptions: Apollo.QueryHookOptions<GetDataFromCompanyNumberQuery, GetDataFromCompanyNumberQueryVariables> & ({ variables: GetDataFromCompanyNumberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataFromCompanyNumberQuery, GetDataFromCompanyNumberQueryVariables>(GetDataFromCompanyNumberDocument, options);
      }
export function useGetDataFromCompanyNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataFromCompanyNumberQuery, GetDataFromCompanyNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataFromCompanyNumberQuery, GetDataFromCompanyNumberQueryVariables>(GetDataFromCompanyNumberDocument, options);
        }
export function useGetDataFromCompanyNumberSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDataFromCompanyNumberQuery, GetDataFromCompanyNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDataFromCompanyNumberQuery, GetDataFromCompanyNumberQueryVariables>(GetDataFromCompanyNumberDocument, options);
        }
export type GetDataFromCompanyNumberQueryHookResult = ReturnType<typeof useGetDataFromCompanyNumberQuery>;
export type GetDataFromCompanyNumberLazyQueryHookResult = ReturnType<typeof useGetDataFromCompanyNumberLazyQuery>;
export type GetDataFromCompanyNumberSuspenseQueryHookResult = ReturnType<typeof useGetDataFromCompanyNumberSuspenseQuery>;
export type GetDataFromCompanyNumberQueryResult = Apollo.QueryResult<GetDataFromCompanyNumberQuery, GetDataFromCompanyNumberQueryVariables>;
export const CreateStripeCheckoutDocument = gql`
    mutation CreateStripeCheckout($input: CreateStripeCheckoutInput!) {
  createStripeCheckout(input: $input)
}
    `;
export type CreateStripeCheckoutMutationFn = Apollo.MutationFunction<CreateStripeCheckoutMutation, CreateStripeCheckoutMutationVariables>;

/**
 * __useCreateStripeCheckoutMutation__
 *
 * To run a mutation, you first call `useCreateStripeCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStripeCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStripeCheckoutMutation, { data, loading, error }] = useCreateStripeCheckoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStripeCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<CreateStripeCheckoutMutation, CreateStripeCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStripeCheckoutMutation, CreateStripeCheckoutMutationVariables>(CreateStripeCheckoutDocument, options);
      }
export type CreateStripeCheckoutMutationHookResult = ReturnType<typeof useCreateStripeCheckoutMutation>;
export type CreateStripeCheckoutMutationResult = Apollo.MutationResult<CreateStripeCheckoutMutation>;
export type CreateStripeCheckoutMutationOptions = Apollo.BaseMutationOptions<CreateStripeCheckoutMutation, CreateStripeCheckoutMutationVariables>;
export const UpdateSubscriptionDocument = gql`
    mutation UpdateSubscription($input: UpdateSubscriptionInput!) {
  updateSubscription(input: $input)
}
    `;
export type UpdateSubscriptionMutationFn = Apollo.MutationFunction<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;

/**
 * __useUpdateSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionMutation, { data, loading, error }] = useUpdateSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>(UpdateSubscriptionDocument, options);
      }
export type UpdateSubscriptionMutationHookResult = ReturnType<typeof useUpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationResult = Apollo.MutationResult<UpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;
export const SubscriptionDocument = gql`
    query subscription($stripeSubscriptionId: String!, $brandId: NonNegativeInt!) {
  subscription(stripeSubscriptionId: $stripeSubscriptionId, brandId: $brandId) {
    ...SubscriptionInfo
  }
}
    ${SubscriptionInfoFragmentDoc}`;

/**
 * __useSubscriptionQuery__
 *
 * To run a query within a React component, call `useSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionQuery({
 *   variables: {
 *      stripeSubscriptionId: // value for 'stripeSubscriptionId'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useSubscriptionQuery(baseOptions: Apollo.QueryHookOptions<SubscriptionQuery, SubscriptionQueryVariables> & ({ variables: SubscriptionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionQuery, SubscriptionQueryVariables>(SubscriptionDocument, options);
      }
export function useSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionQuery, SubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionQuery, SubscriptionQueryVariables>(SubscriptionDocument, options);
        }
export function useSubscriptionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubscriptionQuery, SubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubscriptionQuery, SubscriptionQueryVariables>(SubscriptionDocument, options);
        }
export type SubscriptionQueryHookResult = ReturnType<typeof useSubscriptionQuery>;
export type SubscriptionLazyQueryHookResult = ReturnType<typeof useSubscriptionLazyQuery>;
export type SubscriptionSuspenseQueryHookResult = ReturnType<typeof useSubscriptionSuspenseQuery>;
export type SubscriptionQueryResult = Apollo.QueryResult<SubscriptionQuery, SubscriptionQueryVariables>;
export const InvoicesDocument = gql`
    query Invoices($stripeCustomerId: String!) {
  invoices(stripeCustomerId: $stripeCustomerId) {
    ...InvoiceInfo
  }
}
    ${InvoiceInfoFragmentDoc}`;

/**
 * __useInvoicesQuery__
 *
 * To run a query within a React component, call `useInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesQuery({
 *   variables: {
 *      stripeCustomerId: // value for 'stripeCustomerId'
 *   },
 * });
 */
export function useInvoicesQuery(baseOptions: Apollo.QueryHookOptions<InvoicesQuery, InvoicesQueryVariables> & ({ variables: InvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
      }
export function useInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicesQuery, InvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
        }
export function useInvoicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvoicesQuery, InvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
        }
export type InvoicesQueryHookResult = ReturnType<typeof useInvoicesQuery>;
export type InvoicesLazyQueryHookResult = ReturnType<typeof useInvoicesLazyQuery>;
export type InvoicesSuspenseQueryHookResult = ReturnType<typeof useInvoicesSuspenseQuery>;
export type InvoicesQueryResult = Apollo.QueryResult<InvoicesQuery, InvoicesQueryVariables>;
export const SuccessFeeInvoiceListDocument = gql`
    query SuccessFeeInvoiceList($userId: Int!) {
  successFeeInvoiceList(userId: $userId) {
    ...SuccessFeeInvoiceListItemInfo
  }
}
    ${SuccessFeeInvoiceListItemInfoFragmentDoc}`;

/**
 * __useSuccessFeeInvoiceListQuery__
 *
 * To run a query within a React component, call `useSuccessFeeInvoiceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuccessFeeInvoiceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuccessFeeInvoiceListQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSuccessFeeInvoiceListQuery(baseOptions: Apollo.QueryHookOptions<SuccessFeeInvoiceListQuery, SuccessFeeInvoiceListQueryVariables> & ({ variables: SuccessFeeInvoiceListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuccessFeeInvoiceListQuery, SuccessFeeInvoiceListQueryVariables>(SuccessFeeInvoiceListDocument, options);
      }
export function useSuccessFeeInvoiceListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuccessFeeInvoiceListQuery, SuccessFeeInvoiceListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuccessFeeInvoiceListQuery, SuccessFeeInvoiceListQueryVariables>(SuccessFeeInvoiceListDocument, options);
        }
export function useSuccessFeeInvoiceListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SuccessFeeInvoiceListQuery, SuccessFeeInvoiceListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuccessFeeInvoiceListQuery, SuccessFeeInvoiceListQueryVariables>(SuccessFeeInvoiceListDocument, options);
        }
export type SuccessFeeInvoiceListQueryHookResult = ReturnType<typeof useSuccessFeeInvoiceListQuery>;
export type SuccessFeeInvoiceListLazyQueryHookResult = ReturnType<typeof useSuccessFeeInvoiceListLazyQuery>;
export type SuccessFeeInvoiceListSuspenseQueryHookResult = ReturnType<typeof useSuccessFeeInvoiceListSuspenseQuery>;
export type SuccessFeeInvoiceListQueryResult = Apollo.QueryResult<SuccessFeeInvoiceListQuery, SuccessFeeInvoiceListQueryVariables>;
export const SuccessFeeInvoiceByIdDocument = gql`
    query SuccessFeeInvoiceById($invoiceId: String!) {
  successFeeInvoiceById(invoiceId: $invoiceId) {
    ...SuccessFeeInvoiceInfo
  }
}
    ${SuccessFeeInvoiceInfoFragmentDoc}`;

/**
 * __useSuccessFeeInvoiceByIdQuery__
 *
 * To run a query within a React component, call `useSuccessFeeInvoiceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuccessFeeInvoiceByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuccessFeeInvoiceByIdQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useSuccessFeeInvoiceByIdQuery(baseOptions: Apollo.QueryHookOptions<SuccessFeeInvoiceByIdQuery, SuccessFeeInvoiceByIdQueryVariables> & ({ variables: SuccessFeeInvoiceByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuccessFeeInvoiceByIdQuery, SuccessFeeInvoiceByIdQueryVariables>(SuccessFeeInvoiceByIdDocument, options);
      }
export function useSuccessFeeInvoiceByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuccessFeeInvoiceByIdQuery, SuccessFeeInvoiceByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuccessFeeInvoiceByIdQuery, SuccessFeeInvoiceByIdQueryVariables>(SuccessFeeInvoiceByIdDocument, options);
        }
export function useSuccessFeeInvoiceByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SuccessFeeInvoiceByIdQuery, SuccessFeeInvoiceByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuccessFeeInvoiceByIdQuery, SuccessFeeInvoiceByIdQueryVariables>(SuccessFeeInvoiceByIdDocument, options);
        }
export type SuccessFeeInvoiceByIdQueryHookResult = ReturnType<typeof useSuccessFeeInvoiceByIdQuery>;
export type SuccessFeeInvoiceByIdLazyQueryHookResult = ReturnType<typeof useSuccessFeeInvoiceByIdLazyQuery>;
export type SuccessFeeInvoiceByIdSuspenseQueryHookResult = ReturnType<typeof useSuccessFeeInvoiceByIdSuspenseQuery>;
export type SuccessFeeInvoiceByIdQueryResult = Apollo.QueryResult<SuccessFeeInvoiceByIdQuery, SuccessFeeInvoiceByIdQueryVariables>;
export const BespokeTokenCheckDocument = gql`
    query BespokeTokenCheck($token: String!) {
  bespokeTokenCheck(token: $token) {
    ...BespokeCheckDataInfo
  }
}
    ${BespokeCheckDataInfoFragmentDoc}`;

/**
 * __useBespokeTokenCheckQuery__
 *
 * To run a query within a React component, call `useBespokeTokenCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useBespokeTokenCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBespokeTokenCheckQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useBespokeTokenCheckQuery(baseOptions: Apollo.QueryHookOptions<BespokeTokenCheckQuery, BespokeTokenCheckQueryVariables> & ({ variables: BespokeTokenCheckQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BespokeTokenCheckQuery, BespokeTokenCheckQueryVariables>(BespokeTokenCheckDocument, options);
      }
export function useBespokeTokenCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BespokeTokenCheckQuery, BespokeTokenCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BespokeTokenCheckQuery, BespokeTokenCheckQueryVariables>(BespokeTokenCheckDocument, options);
        }
export function useBespokeTokenCheckSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BespokeTokenCheckQuery, BespokeTokenCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BespokeTokenCheckQuery, BespokeTokenCheckQueryVariables>(BespokeTokenCheckDocument, options);
        }
export type BespokeTokenCheckQueryHookResult = ReturnType<typeof useBespokeTokenCheckQuery>;
export type BespokeTokenCheckLazyQueryHookResult = ReturnType<typeof useBespokeTokenCheckLazyQuery>;
export type BespokeTokenCheckSuspenseQueryHookResult = ReturnType<typeof useBespokeTokenCheckSuspenseQuery>;
export type BespokeTokenCheckQueryResult = Apollo.QueryResult<BespokeTokenCheckQuery, BespokeTokenCheckQueryVariables>;
export const CanCreateBidDocument = gql`
    query canCreateBid($brandId: NonNegativeInt!) {
  canCreateBid(brandId: $brandId)
}
    `;

/**
 * __useCanCreateBidQuery__
 *
 * To run a query within a React component, call `useCanCreateBidQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanCreateBidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanCreateBidQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useCanCreateBidQuery(baseOptions: Apollo.QueryHookOptions<CanCreateBidQuery, CanCreateBidQueryVariables> & ({ variables: CanCreateBidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanCreateBidQuery, CanCreateBidQueryVariables>(CanCreateBidDocument, options);
      }
export function useCanCreateBidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CanCreateBidQuery, CanCreateBidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanCreateBidQuery, CanCreateBidQueryVariables>(CanCreateBidDocument, options);
        }
export function useCanCreateBidSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CanCreateBidQuery, CanCreateBidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CanCreateBidQuery, CanCreateBidQueryVariables>(CanCreateBidDocument, options);
        }
export type CanCreateBidQueryHookResult = ReturnType<typeof useCanCreateBidQuery>;
export type CanCreateBidLazyQueryHookResult = ReturnType<typeof useCanCreateBidLazyQuery>;
export type CanCreateBidSuspenseQueryHookResult = ReturnType<typeof useCanCreateBidSuspenseQuery>;
export type CanCreateBidQueryResult = Apollo.QueryResult<CanCreateBidQuery, CanCreateBidQueryVariables>;
export const HasActiveSubscriptionDocument = gql`
    query hasActiveSubscription($brandId: NonNegativeInt!) {
  hasActiveSubscription(brandId: $brandId) {
    value
    brandId
  }
}
    `;

/**
 * __useHasActiveSubscriptionQuery__
 *
 * To run a query within a React component, call `useHasActiveSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasActiveSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasActiveSubscriptionQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useHasActiveSubscriptionQuery(baseOptions: Apollo.QueryHookOptions<HasActiveSubscriptionQuery, HasActiveSubscriptionQueryVariables> & ({ variables: HasActiveSubscriptionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasActiveSubscriptionQuery, HasActiveSubscriptionQueryVariables>(HasActiveSubscriptionDocument, options);
      }
export function useHasActiveSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasActiveSubscriptionQuery, HasActiveSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasActiveSubscriptionQuery, HasActiveSubscriptionQueryVariables>(HasActiveSubscriptionDocument, options);
        }
export function useHasActiveSubscriptionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HasActiveSubscriptionQuery, HasActiveSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HasActiveSubscriptionQuery, HasActiveSubscriptionQueryVariables>(HasActiveSubscriptionDocument, options);
        }
export type HasActiveSubscriptionQueryHookResult = ReturnType<typeof useHasActiveSubscriptionQuery>;
export type HasActiveSubscriptionLazyQueryHookResult = ReturnType<typeof useHasActiveSubscriptionLazyQuery>;
export type HasActiveSubscriptionSuspenseQueryHookResult = ReturnType<typeof useHasActiveSubscriptionSuspenseQuery>;
export type HasActiveSubscriptionQueryResult = Apollo.QueryResult<HasActiveSubscriptionQuery, HasActiveSubscriptionQueryVariables>;
export const UpgradeToBespokeDocument = gql`
    mutation UpgradeToBespoke($token: String!) {
  upgradeToBespoke(token: $token) {
    ...UpgradeToBespokeDataInfo
  }
}
    ${UpgradeToBespokeDataInfoFragmentDoc}`;
export type UpgradeToBespokeMutationFn = Apollo.MutationFunction<UpgradeToBespokeMutation, UpgradeToBespokeMutationVariables>;

/**
 * __useUpgradeToBespokeMutation__
 *
 * To run a mutation, you first call `useUpgradeToBespokeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeToBespokeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradeToBespokeMutation, { data, loading, error }] = useUpgradeToBespokeMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useUpgradeToBespokeMutation(baseOptions?: Apollo.MutationHookOptions<UpgradeToBespokeMutation, UpgradeToBespokeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpgradeToBespokeMutation, UpgradeToBespokeMutationVariables>(UpgradeToBespokeDocument, options);
      }
export type UpgradeToBespokeMutationHookResult = ReturnType<typeof useUpgradeToBespokeMutation>;
export type UpgradeToBespokeMutationResult = Apollo.MutationResult<UpgradeToBespokeMutation>;
export type UpgradeToBespokeMutationOptions = Apollo.BaseMutationOptions<UpgradeToBespokeMutation, UpgradeToBespokeMutationVariables>;
export const TenderByIdDocument = gql`
    query TenderById($tenderId: NonNegativeInt!) {
  tenderById(tenderId: $tenderId) {
    ...TenderInfo
    venue {
      ...VenueInfo
    }
    listingTypeId
    productCategories {
      ...ProductCategoryInfo
    }
    listingType {
      ...ListingTypeInfo
    }
    wholesalers {
      ...WholesalerInfo
    }
    totalReceivedBids
    files {
      ...FileInfo
    }
    user {
      ...UserInfo
    }
  }
}
    ${TenderInfoFragmentDoc}
${VenueInfoFragmentDoc}
${ProductCategoryInfoFragmentDoc}
${ListingTypeInfoFragmentDoc}
${WholesalerInfoFragmentDoc}
${FileInfoFragmentDoc}
${UserInfoFragmentDoc}`;

/**
 * __useTenderByIdQuery__
 *
 * To run a query within a React component, call `useTenderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenderByIdQuery({
 *   variables: {
 *      tenderId: // value for 'tenderId'
 *   },
 * });
 */
export function useTenderByIdQuery(baseOptions: Apollo.QueryHookOptions<TenderByIdQuery, TenderByIdQueryVariables> & ({ variables: TenderByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenderByIdQuery, TenderByIdQueryVariables>(TenderByIdDocument, options);
      }
export function useTenderByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenderByIdQuery, TenderByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenderByIdQuery, TenderByIdQueryVariables>(TenderByIdDocument, options);
        }
export function useTenderByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TenderByIdQuery, TenderByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TenderByIdQuery, TenderByIdQueryVariables>(TenderByIdDocument, options);
        }
export type TenderByIdQueryHookResult = ReturnType<typeof useTenderByIdQuery>;
export type TenderByIdLazyQueryHookResult = ReturnType<typeof useTenderByIdLazyQuery>;
export type TenderByIdSuspenseQueryHookResult = ReturnType<typeof useTenderByIdSuspenseQuery>;
export type TenderByIdQueryResult = Apollo.QueryResult<TenderByIdQuery, TenderByIdQueryVariables>;
export const TenderTemplateByTenderIdDocument = gql`
    query TenderTemplateByTenderId($tenderId: NonNegativeInt!) {
  tenderById(tenderId: $tenderId) {
    venueId
    listingTypeId
    tenderDetails
    estimatedVolume
    volumeUnits
    volumeDetails
    supportsFreeStock
    supportsListingFee
    supportsPosBudget
    supportsRetroDiscount
    supportDetails
    listingTypeId
    userId
    packagingType
    unitType
    listingStartsAtUtc
    listingEndsAtUtc
    tenderStartsAtUtc
    tenderEndsAtUtc
    isPrivate
    files {
      ...FileInfo
    }
    productCategories {
      ...ProductCategoryInfo
    }
    listingType {
      ...ListingTypeInfo
    }
    wholesalers {
      ...WholesalerInfo
    }
    region
  }
}
    ${FileInfoFragmentDoc}
${ProductCategoryInfoFragmentDoc}
${ListingTypeInfoFragmentDoc}
${WholesalerInfoFragmentDoc}`;

/**
 * __useTenderTemplateByTenderIdQuery__
 *
 * To run a query within a React component, call `useTenderTemplateByTenderIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenderTemplateByTenderIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenderTemplateByTenderIdQuery({
 *   variables: {
 *      tenderId: // value for 'tenderId'
 *   },
 * });
 */
export function useTenderTemplateByTenderIdQuery(baseOptions: Apollo.QueryHookOptions<TenderTemplateByTenderIdQuery, TenderTemplateByTenderIdQueryVariables> & ({ variables: TenderTemplateByTenderIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenderTemplateByTenderIdQuery, TenderTemplateByTenderIdQueryVariables>(TenderTemplateByTenderIdDocument, options);
      }
export function useTenderTemplateByTenderIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenderTemplateByTenderIdQuery, TenderTemplateByTenderIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenderTemplateByTenderIdQuery, TenderTemplateByTenderIdQueryVariables>(TenderTemplateByTenderIdDocument, options);
        }
export function useTenderTemplateByTenderIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TenderTemplateByTenderIdQuery, TenderTemplateByTenderIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TenderTemplateByTenderIdQuery, TenderTemplateByTenderIdQueryVariables>(TenderTemplateByTenderIdDocument, options);
        }
export type TenderTemplateByTenderIdQueryHookResult = ReturnType<typeof useTenderTemplateByTenderIdQuery>;
export type TenderTemplateByTenderIdLazyQueryHookResult = ReturnType<typeof useTenderTemplateByTenderIdLazyQuery>;
export type TenderTemplateByTenderIdSuspenseQueryHookResult = ReturnType<typeof useTenderTemplateByTenderIdSuspenseQuery>;
export type TenderTemplateByTenderIdQueryResult = Apollo.QueryResult<TenderTemplateByTenderIdQuery, TenderTemplateByTenderIdQueryVariables>;
export const VenueDashboardTendersDocument = gql`
    query VenueDashboardTenders($input: VenueDashboardTendersInput!) {
  venueDashboardTenders(input: $input) {
    data {
      __typename
      ... on Tender {
        id
        status
        venue {
          ...VenueInfo
        }
        listingType {
          ...ListingTypeInfo
        }
        productCategories {
          ...ProductCategoryInfo
        }
        tenderStartsAtUtc
        tenderEndsAtUtc
        listingStartsAtUtc
        listingEndsAtUtc
        name
        estimatedVolume
        volumeUnits
        totalReceivedBids
        receivedSupportStatus
        packagingType
        unitType
        isDirectSupplyCompatible
        region
      }
    }
    totalCount
    pageInfo {
      ...OffsetPageInfo
    }
    data {
      ... on TenderDraft {
        id
        listingType {
          ...ListingTypeInfo
        }
        productCategories {
          ...ProductCategoryInfo
        }
        tenderStartsAtUtc
        tenderEndsAtUtc
        listingStartsAtUtc
        listingEndsAtUtc
        name
        estimatedVolume
        volumeUnits
        draftPackagingType: packagingType
        draftUnitType: unitType
        createdAtUtc
      }
    }
    totalCount
    pageInfo {
      ...OffsetPageInfo
    }
  }
}
    ${VenueInfoFragmentDoc}
${ListingTypeInfoFragmentDoc}
${ProductCategoryInfoFragmentDoc}
${OffsetPageInfoFragmentDoc}`;

/**
 * __useVenueDashboardTendersQuery__
 *
 * To run a query within a React component, call `useVenueDashboardTendersQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenueDashboardTendersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVenueDashboardTendersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVenueDashboardTendersQuery(baseOptions: Apollo.QueryHookOptions<VenueDashboardTendersQuery, VenueDashboardTendersQueryVariables> & ({ variables: VenueDashboardTendersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VenueDashboardTendersQuery, VenueDashboardTendersQueryVariables>(VenueDashboardTendersDocument, options);
      }
export function useVenueDashboardTendersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VenueDashboardTendersQuery, VenueDashboardTendersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VenueDashboardTendersQuery, VenueDashboardTendersQueryVariables>(VenueDashboardTendersDocument, options);
        }
export function useVenueDashboardTendersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VenueDashboardTendersQuery, VenueDashboardTendersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VenueDashboardTendersQuery, VenueDashboardTendersQueryVariables>(VenueDashboardTendersDocument, options);
        }
export type VenueDashboardTendersQueryHookResult = ReturnType<typeof useVenueDashboardTendersQuery>;
export type VenueDashboardTendersLazyQueryHookResult = ReturnType<typeof useVenueDashboardTendersLazyQuery>;
export type VenueDashboardTendersSuspenseQueryHookResult = ReturnType<typeof useVenueDashboardTendersSuspenseQuery>;
export type VenueDashboardTendersQueryResult = Apollo.QueryResult<VenueDashboardTendersQuery, VenueDashboardTendersQueryVariables>;
export const AddTenderDocument = gql`
    mutation AddTender($input: AddTenderInput!) {
  addTender(input: $input) {
    ...TenderInfo
    files {
      ...FileInfo
    }
  }
}
    ${TenderInfoFragmentDoc}
${FileInfoFragmentDoc}`;
export type AddTenderMutationFn = Apollo.MutationFunction<AddTenderMutation, AddTenderMutationVariables>;

/**
 * __useAddTenderMutation__
 *
 * To run a mutation, you first call `useAddTenderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTenderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTenderMutation, { data, loading, error }] = useAddTenderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTenderMutation(baseOptions?: Apollo.MutationHookOptions<AddTenderMutation, AddTenderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTenderMutation, AddTenderMutationVariables>(AddTenderDocument, options);
      }
export type AddTenderMutationHookResult = ReturnType<typeof useAddTenderMutation>;
export type AddTenderMutationResult = Apollo.MutationResult<AddTenderMutation>;
export type AddTenderMutationOptions = Apollo.BaseMutationOptions<AddTenderMutation, AddTenderMutationVariables>;
export const ChooseMultipleTenderWinnersDocument = gql`
    mutation ChooseMultipleTenderWinners($input: ChooseMultipleTenderWinnersInput!) {
  chooseMultipleTenderWinners(input: $input) {
    ...TenderInfo
  }
}
    ${TenderInfoFragmentDoc}`;
export type ChooseMultipleTenderWinnersMutationFn = Apollo.MutationFunction<ChooseMultipleTenderWinnersMutation, ChooseMultipleTenderWinnersMutationVariables>;

/**
 * __useChooseMultipleTenderWinnersMutation__
 *
 * To run a mutation, you first call `useChooseMultipleTenderWinnersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChooseMultipleTenderWinnersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chooseMultipleTenderWinnersMutation, { data, loading, error }] = useChooseMultipleTenderWinnersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChooseMultipleTenderWinnersMutation(baseOptions?: Apollo.MutationHookOptions<ChooseMultipleTenderWinnersMutation, ChooseMultipleTenderWinnersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChooseMultipleTenderWinnersMutation, ChooseMultipleTenderWinnersMutationVariables>(ChooseMultipleTenderWinnersDocument, options);
      }
export type ChooseMultipleTenderWinnersMutationHookResult = ReturnType<typeof useChooseMultipleTenderWinnersMutation>;
export type ChooseMultipleTenderWinnersMutationResult = Apollo.MutationResult<ChooseMultipleTenderWinnersMutation>;
export type ChooseMultipleTenderWinnersMutationOptions = Apollo.BaseMutationOptions<ChooseMultipleTenderWinnersMutation, ChooseMultipleTenderWinnersMutationVariables>;
export const EditTenderDocument = gql`
    mutation EditTender($input: EditTenderInput!) {
  editTender(input: $input) {
    ...TenderInfo
    files {
      ...FileInfo
    }
  }
}
    ${TenderInfoFragmentDoc}
${FileInfoFragmentDoc}`;
export type EditTenderMutationFn = Apollo.MutationFunction<EditTenderMutation, EditTenderMutationVariables>;

/**
 * __useEditTenderMutation__
 *
 * To run a mutation, you first call `useEditTenderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTenderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTenderMutation, { data, loading, error }] = useEditTenderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditTenderMutation(baseOptions?: Apollo.MutationHookOptions<EditTenderMutation, EditTenderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditTenderMutation, EditTenderMutationVariables>(EditTenderDocument, options);
      }
export type EditTenderMutationHookResult = ReturnType<typeof useEditTenderMutation>;
export type EditTenderMutationResult = Apollo.MutationResult<EditTenderMutation>;
export type EditTenderMutationOptions = Apollo.BaseMutationOptions<EditTenderMutation, EditTenderMutationVariables>;
export const TenderListDocument = gql`
    query TenderList($input: TendersInput!) {
  tenderList(input: $input) {
    data {
      id
      venue {
        ...VenueInfo
      }
      listingType {
        ...ListingTypeInfo
      }
      productCategories {
        ...ProductCategoryInfo
      }
      files {
        ...FileInfo
      }
      tenderStartsAtUtc
      tenderEndsAtUtc
      listingStartsAtUtc
      listingEndsAtUtc
      name
      estimatedVolume
      volumeUnits
      totalReceivedBids
      status
      userId
      venueId
      listingTypeId
      receivedSupportStatus
      packagingType
      unitType
      isDirectSupplyCompatible
      region
      isPrivate
    }
    totalCount
    pageInfo {
      ...OffsetPageInfo
    }
  }
}
    ${VenueInfoFragmentDoc}
${ListingTypeInfoFragmentDoc}
${ProductCategoryInfoFragmentDoc}
${FileInfoFragmentDoc}
${OffsetPageInfoFragmentDoc}`;

/**
 * __useTenderListQuery__
 *
 * To run a query within a React component, call `useTenderListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenderListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenderListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTenderListQuery(baseOptions: Apollo.QueryHookOptions<TenderListQuery, TenderListQueryVariables> & ({ variables: TenderListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenderListQuery, TenderListQueryVariables>(TenderListDocument, options);
      }
export function useTenderListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenderListQuery, TenderListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenderListQuery, TenderListQueryVariables>(TenderListDocument, options);
        }
export function useTenderListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TenderListQuery, TenderListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TenderListQuery, TenderListQueryVariables>(TenderListDocument, options);
        }
export type TenderListQueryHookResult = ReturnType<typeof useTenderListQuery>;
export type TenderListLazyQueryHookResult = ReturnType<typeof useTenderListLazyQuery>;
export type TenderListSuspenseQueryHookResult = ReturnType<typeof useTenderListSuspenseQuery>;
export type TenderListQueryResult = Apollo.QueryResult<TenderListQuery, TenderListQueryVariables>;
export const TenderListFilterOptionsDocument = gql`
    query TenderListFilterOptions {
  tenderListFilterOptions {
    ...FilterOptions
  }
}
    ${FilterOptionsFragmentDoc}`;

/**
 * __useTenderListFilterOptionsQuery__
 *
 * To run a query within a React component, call `useTenderListFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenderListFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenderListFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTenderListFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<TenderListFilterOptionsQuery, TenderListFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenderListFilterOptionsQuery, TenderListFilterOptionsQueryVariables>(TenderListFilterOptionsDocument, options);
      }
export function useTenderListFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenderListFilterOptionsQuery, TenderListFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenderListFilterOptionsQuery, TenderListFilterOptionsQueryVariables>(TenderListFilterOptionsDocument, options);
        }
export function useTenderListFilterOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TenderListFilterOptionsQuery, TenderListFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TenderListFilterOptionsQuery, TenderListFilterOptionsQueryVariables>(TenderListFilterOptionsDocument, options);
        }
export type TenderListFilterOptionsQueryHookResult = ReturnType<typeof useTenderListFilterOptionsQuery>;
export type TenderListFilterOptionsLazyQueryHookResult = ReturnType<typeof useTenderListFilterOptionsLazyQuery>;
export type TenderListFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useTenderListFilterOptionsSuspenseQuery>;
export type TenderListFilterOptionsQueryResult = Apollo.QueryResult<TenderListFilterOptionsQuery, TenderListFilterOptionsQueryVariables>;
export const DeleteTenderByIdDocument = gql`
    mutation DeleteTenderById($tenderId: NonNegativeInt!) {
  deleteTenderById(tenderId: $tenderId)
}
    `;
export type DeleteTenderByIdMutationFn = Apollo.MutationFunction<DeleteTenderByIdMutation, DeleteTenderByIdMutationVariables>;

/**
 * __useDeleteTenderByIdMutation__
 *
 * To run a mutation, you first call `useDeleteTenderByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTenderByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTenderByIdMutation, { data, loading, error }] = useDeleteTenderByIdMutation({
 *   variables: {
 *      tenderId: // value for 'tenderId'
 *   },
 * });
 */
export function useDeleteTenderByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTenderByIdMutation, DeleteTenderByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTenderByIdMutation, DeleteTenderByIdMutationVariables>(DeleteTenderByIdDocument, options);
      }
export type DeleteTenderByIdMutationHookResult = ReturnType<typeof useDeleteTenderByIdMutation>;
export type DeleteTenderByIdMutationResult = Apollo.MutationResult<DeleteTenderByIdMutation>;
export type DeleteTenderByIdMutationOptions = Apollo.BaseMutationOptions<DeleteTenderByIdMutation, DeleteTenderByIdMutationVariables>;
export const ChooseWinnerDocument = gql`
    mutation ChooseWinner($input: ChooseWinnerInput!) {
  chooseWinner(input: $input) {
    ...TenderInfo
  }
}
    ${TenderInfoFragmentDoc}`;
export type ChooseWinnerMutationFn = Apollo.MutationFunction<ChooseWinnerMutation, ChooseWinnerMutationVariables>;

/**
 * __useChooseWinnerMutation__
 *
 * To run a mutation, you first call `useChooseWinnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChooseWinnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chooseWinnerMutation, { data, loading, error }] = useChooseWinnerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChooseWinnerMutation(baseOptions?: Apollo.MutationHookOptions<ChooseWinnerMutation, ChooseWinnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChooseWinnerMutation, ChooseWinnerMutationVariables>(ChooseWinnerDocument, options);
      }
export type ChooseWinnerMutationHookResult = ReturnType<typeof useChooseWinnerMutation>;
export type ChooseWinnerMutationResult = Apollo.MutationResult<ChooseWinnerMutation>;
export type ChooseWinnerMutationOptions = Apollo.BaseMutationOptions<ChooseWinnerMutation, ChooseWinnerMutationVariables>;
export const MultipleBidsTendersDocument = gql`
    query MultipleBidsTenders($input: TendersInput!) {
  tenderList(input: $input) {
    data {
      id
      name
      venue {
        ...VenueInfo
      }
      files {
        ...FileInfo
      }
      listingTypeId
      listingType {
        ...ListingTypeInfo
      }
      productCategories {
        ...ProductCategoryInfo
      }
      wholesalers {
        ...WholesalerInfo
      }
      supportsFreeStock
      supportsListingFee
      supportsPosBudget
      supportsRetroDiscount
      supportDetails
      tenderDetails
      volumeDetails
      estimatedVolume
      volumeUnits
      listingEndsAtUtc
      listingStartsAtUtc
      tenderStartsAtUtc
      tenderEndsAtUtc
      hasBrandsBid
      status
      venueId
      totalReceivedBids
      packagingType
      unitType
      isDirectSupplyCompatible
      region
      isPrivate
    }
    totalCount
    pageInfo {
      ...OffsetPageInfo
    }
  }
}
    ${VenueInfoFragmentDoc}
${FileInfoFragmentDoc}
${ListingTypeInfoFragmentDoc}
${ProductCategoryInfoFragmentDoc}
${WholesalerInfoFragmentDoc}
${OffsetPageInfoFragmentDoc}`;

/**
 * __useMultipleBidsTendersQuery__
 *
 * To run a query within a React component, call `useMultipleBidsTendersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMultipleBidsTendersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMultipleBidsTendersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMultipleBidsTendersQuery(baseOptions: Apollo.QueryHookOptions<MultipleBidsTendersQuery, MultipleBidsTendersQueryVariables> & ({ variables: MultipleBidsTendersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MultipleBidsTendersQuery, MultipleBidsTendersQueryVariables>(MultipleBidsTendersDocument, options);
      }
export function useMultipleBidsTendersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MultipleBidsTendersQuery, MultipleBidsTendersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MultipleBidsTendersQuery, MultipleBidsTendersQueryVariables>(MultipleBidsTendersDocument, options);
        }
export function useMultipleBidsTendersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MultipleBidsTendersQuery, MultipleBidsTendersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MultipleBidsTendersQuery, MultipleBidsTendersQueryVariables>(MultipleBidsTendersDocument, options);
        }
export type MultipleBidsTendersQueryHookResult = ReturnType<typeof useMultipleBidsTendersQuery>;
export type MultipleBidsTendersLazyQueryHookResult = ReturnType<typeof useMultipleBidsTendersLazyQuery>;
export type MultipleBidsTendersSuspenseQueryHookResult = ReturnType<typeof useMultipleBidsTendersSuspenseQuery>;
export type MultipleBidsTendersQueryResult = Apollo.QueryResult<MultipleBidsTendersQuery, MultipleBidsTendersQueryVariables>;
export const CompatibleTendersDocument = gql`
    query CompatibleTenders($brandId: NonNegativeInt!, $productCategoryId: NonNegativeInt) {
  compatibleTenders(brandId: $brandId, productCategoryId: $productCategoryId) {
    id
    venue {
      id
      name
      venueCategoryName
    }
    listingType {
      id
      name
    }
    productCategories {
      tenderId
      productCategoryId
    }
    hasBrandBidsInTender(brandId: $brandId)
    tenderStartsAtUtc
    tenderEndsAtUtc
    listingStartsAtUtc
    listingEndsAtUtc
    name
    estimatedVolume
    volumeUnits
    userId
    venueId
    packagingType
    unitType
    region
  }
}
    `;

/**
 * __useCompatibleTendersQuery__
 *
 * To run a query within a React component, call `useCompatibleTendersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompatibleTendersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompatibleTendersQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      productCategoryId: // value for 'productCategoryId'
 *   },
 * });
 */
export function useCompatibleTendersQuery(baseOptions: Apollo.QueryHookOptions<CompatibleTendersQuery, CompatibleTendersQueryVariables> & ({ variables: CompatibleTendersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompatibleTendersQuery, CompatibleTendersQueryVariables>(CompatibleTendersDocument, options);
      }
export function useCompatibleTendersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompatibleTendersQuery, CompatibleTendersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompatibleTendersQuery, CompatibleTendersQueryVariables>(CompatibleTendersDocument, options);
        }
export function useCompatibleTendersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompatibleTendersQuery, CompatibleTendersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompatibleTendersQuery, CompatibleTendersQueryVariables>(CompatibleTendersDocument, options);
        }
export type CompatibleTendersQueryHookResult = ReturnType<typeof useCompatibleTendersQuery>;
export type CompatibleTendersLazyQueryHookResult = ReturnType<typeof useCompatibleTendersLazyQuery>;
export type CompatibleTendersSuspenseQueryHookResult = ReturnType<typeof useCompatibleTendersSuspenseQuery>;
export type CompatibleTendersQueryResult = Apollo.QueryResult<CompatibleTendersQuery, CompatibleTendersQueryVariables>;
export const TopTendersBidsCountMinBoundaryDocument = gql`
    query TopTendersBidsCountMinBoundary {
  topTendersBidsCountMinBoundary
}
    `;

/**
 * __useTopTendersBidsCountMinBoundaryQuery__
 *
 * To run a query within a React component, call `useTopTendersBidsCountMinBoundaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopTendersBidsCountMinBoundaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopTendersBidsCountMinBoundaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useTopTendersBidsCountMinBoundaryQuery(baseOptions?: Apollo.QueryHookOptions<TopTendersBidsCountMinBoundaryQuery, TopTendersBidsCountMinBoundaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopTendersBidsCountMinBoundaryQuery, TopTendersBidsCountMinBoundaryQueryVariables>(TopTendersBidsCountMinBoundaryDocument, options);
      }
export function useTopTendersBidsCountMinBoundaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopTendersBidsCountMinBoundaryQuery, TopTendersBidsCountMinBoundaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopTendersBidsCountMinBoundaryQuery, TopTendersBidsCountMinBoundaryQueryVariables>(TopTendersBidsCountMinBoundaryDocument, options);
        }
export function useTopTendersBidsCountMinBoundarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TopTendersBidsCountMinBoundaryQuery, TopTendersBidsCountMinBoundaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TopTendersBidsCountMinBoundaryQuery, TopTendersBidsCountMinBoundaryQueryVariables>(TopTendersBidsCountMinBoundaryDocument, options);
        }
export type TopTendersBidsCountMinBoundaryQueryHookResult = ReturnType<typeof useTopTendersBidsCountMinBoundaryQuery>;
export type TopTendersBidsCountMinBoundaryLazyQueryHookResult = ReturnType<typeof useTopTendersBidsCountMinBoundaryLazyQuery>;
export type TopTendersBidsCountMinBoundarySuspenseQueryHookResult = ReturnType<typeof useTopTendersBidsCountMinBoundarySuspenseQuery>;
export type TopTendersBidsCountMinBoundaryQueryResult = Apollo.QueryResult<TopTendersBidsCountMinBoundaryQuery, TopTendersBidsCountMinBoundaryQueryVariables>;
export const TenderDraftByIdDocument = gql`
    query TenderDraftById($tenderDraftId: NonNegativeInt!) {
  tenderDraftById(tenderDraftId: $tenderDraftId) {
    ...TenderDraftInfo
    venue {
      ...VenueInfo
    }
    user {
      ...UserInfo
    }
    listingTypeId
    productCategories {
      ...ProductCategoryInfo
    }
    listingType {
      ...ListingTypeInfo
    }
    wholesalers {
      ...WholesalerInfo
    }
    files {
      ...FileInfo
    }
  }
}
    ${TenderDraftInfoFragmentDoc}
${VenueInfoFragmentDoc}
${UserInfoFragmentDoc}
${ProductCategoryInfoFragmentDoc}
${ListingTypeInfoFragmentDoc}
${WholesalerInfoFragmentDoc}
${FileInfoFragmentDoc}`;

/**
 * __useTenderDraftByIdQuery__
 *
 * To run a query within a React component, call `useTenderDraftByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenderDraftByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenderDraftByIdQuery({
 *   variables: {
 *      tenderDraftId: // value for 'tenderDraftId'
 *   },
 * });
 */
export function useTenderDraftByIdQuery(baseOptions: Apollo.QueryHookOptions<TenderDraftByIdQuery, TenderDraftByIdQueryVariables> & ({ variables: TenderDraftByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenderDraftByIdQuery, TenderDraftByIdQueryVariables>(TenderDraftByIdDocument, options);
      }
export function useTenderDraftByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenderDraftByIdQuery, TenderDraftByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenderDraftByIdQuery, TenderDraftByIdQueryVariables>(TenderDraftByIdDocument, options);
        }
export function useTenderDraftByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TenderDraftByIdQuery, TenderDraftByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TenderDraftByIdQuery, TenderDraftByIdQueryVariables>(TenderDraftByIdDocument, options);
        }
export type TenderDraftByIdQueryHookResult = ReturnType<typeof useTenderDraftByIdQuery>;
export type TenderDraftByIdLazyQueryHookResult = ReturnType<typeof useTenderDraftByIdLazyQuery>;
export type TenderDraftByIdSuspenseQueryHookResult = ReturnType<typeof useTenderDraftByIdSuspenseQuery>;
export type TenderDraftByIdQueryResult = Apollo.QueryResult<TenderDraftByIdQuery, TenderDraftByIdQueryVariables>;
export const EditTenderDraftDocument = gql`
    mutation EditTenderDraft($input: EditTenderDraftInput!) {
  editTenderDraft(input: $input) {
    ...TenderDraftInfo
    files {
      ...FileInfo
    }
  }
}
    ${TenderDraftInfoFragmentDoc}
${FileInfoFragmentDoc}`;
export type EditTenderDraftMutationFn = Apollo.MutationFunction<EditTenderDraftMutation, EditTenderDraftMutationVariables>;

/**
 * __useEditTenderDraftMutation__
 *
 * To run a mutation, you first call `useEditTenderDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTenderDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTenderDraftMutation, { data, loading, error }] = useEditTenderDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditTenderDraftMutation(baseOptions?: Apollo.MutationHookOptions<EditTenderDraftMutation, EditTenderDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditTenderDraftMutation, EditTenderDraftMutationVariables>(EditTenderDraftDocument, options);
      }
export type EditTenderDraftMutationHookResult = ReturnType<typeof useEditTenderDraftMutation>;
export type EditTenderDraftMutationResult = Apollo.MutationResult<EditTenderDraftMutation>;
export type EditTenderDraftMutationOptions = Apollo.BaseMutationOptions<EditTenderDraftMutation, EditTenderDraftMutationVariables>;
export const AddTenderDraftDocument = gql`
    mutation AddTenderDraft($input: AddTenderDraftInput!) {
  addTenderDraft(input: $input) {
    ...TenderDraftInfo
    files {
      ...FileInfo
    }
  }
}
    ${TenderDraftInfoFragmentDoc}
${FileInfoFragmentDoc}`;
export type AddTenderDraftMutationFn = Apollo.MutationFunction<AddTenderDraftMutation, AddTenderDraftMutationVariables>;

/**
 * __useAddTenderDraftMutation__
 *
 * To run a mutation, you first call `useAddTenderDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTenderDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTenderDraftMutation, { data, loading, error }] = useAddTenderDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTenderDraftMutation(baseOptions?: Apollo.MutationHookOptions<AddTenderDraftMutation, AddTenderDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTenderDraftMutation, AddTenderDraftMutationVariables>(AddTenderDraftDocument, options);
      }
export type AddTenderDraftMutationHookResult = ReturnType<typeof useAddTenderDraftMutation>;
export type AddTenderDraftMutationResult = Apollo.MutationResult<AddTenderDraftMutation>;
export type AddTenderDraftMutationOptions = Apollo.BaseMutationOptions<AddTenderDraftMutation, AddTenderDraftMutationVariables>;
export const DeleteTenderDraftByIdDocument = gql`
    mutation DeleteTenderDraftById($tenderDraftId: NonNegativeInt!) {
  deleteTenderDraftById(tenderDraftId: $tenderDraftId)
}
    `;
export type DeleteTenderDraftByIdMutationFn = Apollo.MutationFunction<DeleteTenderDraftByIdMutation, DeleteTenderDraftByIdMutationVariables>;

/**
 * __useDeleteTenderDraftByIdMutation__
 *
 * To run a mutation, you first call `useDeleteTenderDraftByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTenderDraftByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTenderDraftByIdMutation, { data, loading, error }] = useDeleteTenderDraftByIdMutation({
 *   variables: {
 *      tenderDraftId: // value for 'tenderDraftId'
 *   },
 * });
 */
export function useDeleteTenderDraftByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTenderDraftByIdMutation, DeleteTenderDraftByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTenderDraftByIdMutation, DeleteTenderDraftByIdMutationVariables>(DeleteTenderDraftByIdDocument, options);
      }
export type DeleteTenderDraftByIdMutationHookResult = ReturnType<typeof useDeleteTenderDraftByIdMutation>;
export type DeleteTenderDraftByIdMutationResult = Apollo.MutationResult<DeleteTenderDraftByIdMutation>;
export type DeleteTenderDraftByIdMutationOptions = Apollo.BaseMutationOptions<DeleteTenderDraftByIdMutation, DeleteTenderDraftByIdMutationVariables>;
export const EditTenderPreferenceDocument = gql`
    mutation EditTenderPreference($input: EditTenderPreferenceInput!) {
  editTenderPreference(input: $input) {
    ...TenderPreferenceInfo
  }
}
    ${TenderPreferenceInfoFragmentDoc}`;
export type EditTenderPreferenceMutationFn = Apollo.MutationFunction<EditTenderPreferenceMutation, EditTenderPreferenceMutationVariables>;

/**
 * __useEditTenderPreferenceMutation__
 *
 * To run a mutation, you first call `useEditTenderPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTenderPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTenderPreferenceMutation, { data, loading, error }] = useEditTenderPreferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditTenderPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<EditTenderPreferenceMutation, EditTenderPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditTenderPreferenceMutation, EditTenderPreferenceMutationVariables>(EditTenderPreferenceDocument, options);
      }
export type EditTenderPreferenceMutationHookResult = ReturnType<typeof useEditTenderPreferenceMutation>;
export type EditTenderPreferenceMutationResult = Apollo.MutationResult<EditTenderPreferenceMutation>;
export type EditTenderPreferenceMutationOptions = Apollo.BaseMutationOptions<EditTenderPreferenceMutation, EditTenderPreferenceMutationVariables>;
export const TenderPreferenceByVenueIdDocument = gql`
    query TenderPreferenceByVenueId($venueId: NonNegativeInt!) {
  tenderPreferenceByVenueId(venueId: $venueId) {
    ...TenderPreferenceInfo
  }
}
    ${TenderPreferenceInfoFragmentDoc}`;

/**
 * __useTenderPreferenceByVenueIdQuery__
 *
 * To run a query within a React component, call `useTenderPreferenceByVenueIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenderPreferenceByVenueIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenderPreferenceByVenueIdQuery({
 *   variables: {
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useTenderPreferenceByVenueIdQuery(baseOptions: Apollo.QueryHookOptions<TenderPreferenceByVenueIdQuery, TenderPreferenceByVenueIdQueryVariables> & ({ variables: TenderPreferenceByVenueIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenderPreferenceByVenueIdQuery, TenderPreferenceByVenueIdQueryVariables>(TenderPreferenceByVenueIdDocument, options);
      }
export function useTenderPreferenceByVenueIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenderPreferenceByVenueIdQuery, TenderPreferenceByVenueIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenderPreferenceByVenueIdQuery, TenderPreferenceByVenueIdQueryVariables>(TenderPreferenceByVenueIdDocument, options);
        }
export function useTenderPreferenceByVenueIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TenderPreferenceByVenueIdQuery, TenderPreferenceByVenueIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TenderPreferenceByVenueIdQuery, TenderPreferenceByVenueIdQueryVariables>(TenderPreferenceByVenueIdDocument, options);
        }
export type TenderPreferenceByVenueIdQueryHookResult = ReturnType<typeof useTenderPreferenceByVenueIdQuery>;
export type TenderPreferenceByVenueIdLazyQueryHookResult = ReturnType<typeof useTenderPreferenceByVenueIdLazyQuery>;
export type TenderPreferenceByVenueIdSuspenseQueryHookResult = ReturnType<typeof useTenderPreferenceByVenueIdSuspenseQuery>;
export type TenderPreferenceByVenueIdQueryResult = Apollo.QueryResult<TenderPreferenceByVenueIdQuery, TenderPreferenceByVenueIdQueryVariables>;
export const UserMeDocument = gql`
    query UserMe($input: UserMeInput) {
  userMe(input: $input) {
    ...UserMeInfo
    companyCount
    activeVenue {
      id
      name
      instagramUrl
      avatarBucketKey
      avatarUrl
      webPageUrl
      description
      canCreateTender
      requiresParamountLiquorIntegration
      hasTenders
      stripeCustomerId
      groupName
      venueCategoryName
      venueCategoryId
      addressId
      phoneNumber
      billingName
      billingAddress {
        ...AddressInfo
      }
      registeredCompany {
        ...RegisteredCompanyInfo
      }
      address {
        ...AddressInfo
      }
      users {
        ...CompanyUserInfo
      }
    }
    activeBrand {
      id
      name
      region
      groupName
      subscriptionTier
      instagramUrl
      avatarBucketKey
      avatarUrl
      webPageUrl
      stripeSubscriptionId
      failedPaymentIntentCounter
      successFee
      isAnonymousBidAllowed
      stripeCustomerId
      addressId
      isEnterpriseSubscriptionRequestSent
      tradingName
      phoneNumber
      vatNumber
      canSeeOtherBids
      billingName
      productCategories {
        ...ProductCategoryInfo
      }
      tradingAddress {
        ...AddressInfo
      }
      registeredCompany {
        ...RegisteredCompanyInfo
      }
      billingAddress {
        ...AddressInfo
      }
      users {
        ...CompanyUserInfo
      }
      address {
        ...AddressInfo
      }
    }
  }
}
    ${UserMeInfoFragmentDoc}
${AddressInfoFragmentDoc}
${RegisteredCompanyInfoFragmentDoc}
${CompanyUserInfoFragmentDoc}
${ProductCategoryInfoFragmentDoc}`;

/**
 * __useUserMeQuery__
 *
 * To run a query within a React component, call `useUserMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserMeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserMeQuery(baseOptions?: Apollo.QueryHookOptions<UserMeQuery, UserMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserMeQuery, UserMeQueryVariables>(UserMeDocument, options);
      }
export function useUserMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserMeQuery, UserMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserMeQuery, UserMeQueryVariables>(UserMeDocument, options);
        }
export function useUserMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserMeQuery, UserMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserMeQuery, UserMeQueryVariables>(UserMeDocument, options);
        }
export type UserMeQueryHookResult = ReturnType<typeof useUserMeQuery>;
export type UserMeLazyQueryHookResult = ReturnType<typeof useUserMeLazyQuery>;
export type UserMeSuspenseQueryHookResult = ReturnType<typeof useUserMeSuspenseQuery>;
export type UserMeQueryResult = Apollo.QueryResult<UserMeQuery, UserMeQueryVariables>;
export const UserExistsDocument = gql`
    query UserExists($input: UserExistsInput!) {
  userExists(input: $input)
}
    `;

/**
 * __useUserExistsQuery__
 *
 * To run a query within a React component, call `useUserExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserExistsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserExistsQuery(baseOptions: Apollo.QueryHookOptions<UserExistsQuery, UserExistsQueryVariables> & ({ variables: UserExistsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserExistsQuery, UserExistsQueryVariables>(UserExistsDocument, options);
      }
export function useUserExistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserExistsQuery, UserExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserExistsQuery, UserExistsQueryVariables>(UserExistsDocument, options);
        }
export function useUserExistsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserExistsQuery, UserExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserExistsQuery, UserExistsQueryVariables>(UserExistsDocument, options);
        }
export type UserExistsQueryHookResult = ReturnType<typeof useUserExistsQuery>;
export type UserExistsLazyQueryHookResult = ReturnType<typeof useUserExistsLazyQuery>;
export type UserExistsSuspenseQueryHookResult = ReturnType<typeof useUserExistsSuspenseQuery>;
export type UserExistsQueryResult = Apollo.QueryResult<UserExistsQuery, UserExistsQueryVariables>;
export const ClaimVenueAccountDocument = gql`
    mutation ClaimVenueAccount($input: ClaimVenueAccountInput!) {
  claimVenueAccount(input: $input) {
    email
    region
    integrationType
    resendAvailableInSeconds
  }
}
    `;
export type ClaimVenueAccountMutationFn = Apollo.MutationFunction<ClaimVenueAccountMutation, ClaimVenueAccountMutationVariables>;

/**
 * __useClaimVenueAccountMutation__
 *
 * To run a mutation, you first call `useClaimVenueAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimVenueAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimVenueAccountMutation, { data, loading, error }] = useClaimVenueAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClaimVenueAccountMutation(baseOptions?: Apollo.MutationHookOptions<ClaimVenueAccountMutation, ClaimVenueAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClaimVenueAccountMutation, ClaimVenueAccountMutationVariables>(ClaimVenueAccountDocument, options);
      }
export type ClaimVenueAccountMutationHookResult = ReturnType<typeof useClaimVenueAccountMutation>;
export type ClaimVenueAccountMutationResult = Apollo.MutationResult<ClaimVenueAccountMutation>;
export type ClaimVenueAccountMutationOptions = Apollo.BaseMutationOptions<ClaimVenueAccountMutation, ClaimVenueAccountMutationVariables>;
export const SignUpDocument = gql`
    mutation SignUp($input: SignUpInput!) {
  signUp(input: $input)
}
    `;
export type SignUpMutationFn = Apollo.MutationFunction<SignUpMutation, SignUpMutationVariables>;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignUpMutation(baseOptions?: Apollo.MutationHookOptions<SignUpMutation, SignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument, options);
      }
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>;
export type SignUpMutationOptions = Apollo.BaseMutationOptions<SignUpMutation, SignUpMutationVariables>;
export const ChangeEmailDocument = gql`
    mutation ChangeEmail($input: ChangeEmailInput!) {
  changeEmail(input: $input) {
    ...UserMeInfo
  }
}
    ${UserMeInfoFragmentDoc}`;
export type ChangeEmailMutationFn = Apollo.MutationFunction<ChangeEmailMutation, ChangeEmailMutationVariables>;

/**
 * __useChangeEmailMutation__
 *
 * To run a mutation, you first call `useChangeEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeEmailMutation, { data, loading, error }] = useChangeEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeEmailMutation(baseOptions?: Apollo.MutationHookOptions<ChangeEmailMutation, ChangeEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeEmailMutation, ChangeEmailMutationVariables>(ChangeEmailDocument, options);
      }
export type ChangeEmailMutationHookResult = ReturnType<typeof useChangeEmailMutation>;
export type ChangeEmailMutationResult = Apollo.MutationResult<ChangeEmailMutation>;
export type ChangeEmailMutationOptions = Apollo.BaseMutationOptions<ChangeEmailMutation, ChangeEmailMutationVariables>;
export const RequestChangeEmailDocument = gql`
    mutation RequestChangeEmail($emailToChange: String!) {
  requestChangeEmail(emailToChange: $emailToChange)
}
    `;
export type RequestChangeEmailMutationFn = Apollo.MutationFunction<RequestChangeEmailMutation, RequestChangeEmailMutationVariables>;

/**
 * __useRequestChangeEmailMutation__
 *
 * To run a mutation, you first call `useRequestChangeEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestChangeEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestChangeEmailMutation, { data, loading, error }] = useRequestChangeEmailMutation({
 *   variables: {
 *      emailToChange: // value for 'emailToChange'
 *   },
 * });
 */
export function useRequestChangeEmailMutation(baseOptions?: Apollo.MutationHookOptions<RequestChangeEmailMutation, RequestChangeEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestChangeEmailMutation, RequestChangeEmailMutationVariables>(RequestChangeEmailDocument, options);
      }
export type RequestChangeEmailMutationHookResult = ReturnType<typeof useRequestChangeEmailMutation>;
export type RequestChangeEmailMutationResult = Apollo.MutationResult<RequestChangeEmailMutation>;
export type RequestChangeEmailMutationOptions = Apollo.BaseMutationOptions<RequestChangeEmailMutation, RequestChangeEmailMutationVariables>;
export const ConfirmChangeEmailDocument = gql`
    mutation ConfirmChangeEmail($changeEmailToken: String!) {
  confirmChangeEmail(changeEmailToken: $changeEmailToken)
}
    `;
export type ConfirmChangeEmailMutationFn = Apollo.MutationFunction<ConfirmChangeEmailMutation, ConfirmChangeEmailMutationVariables>;

/**
 * __useConfirmChangeEmailMutation__
 *
 * To run a mutation, you first call `useConfirmChangeEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmChangeEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmChangeEmailMutation, { data, loading, error }] = useConfirmChangeEmailMutation({
 *   variables: {
 *      changeEmailToken: // value for 'changeEmailToken'
 *   },
 * });
 */
export function useConfirmChangeEmailMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmChangeEmailMutation, ConfirmChangeEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmChangeEmailMutation, ConfirmChangeEmailMutationVariables>(ConfirmChangeEmailDocument, options);
      }
export type ConfirmChangeEmailMutationHookResult = ReturnType<typeof useConfirmChangeEmailMutation>;
export type ConfirmChangeEmailMutationResult = Apollo.MutationResult<ConfirmChangeEmailMutation>;
export type ConfirmChangeEmailMutationOptions = Apollo.BaseMutationOptions<ConfirmChangeEmailMutation, ConfirmChangeEmailMutationVariables>;
export const IsUserEmailConfirmedDocument = gql`
    query IsUserEmailConfirmed {
  isUserEmailConfirmed
}
    `;

/**
 * __useIsUserEmailConfirmedQuery__
 *
 * To run a query within a React component, call `useIsUserEmailConfirmedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsUserEmailConfirmedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsUserEmailConfirmedQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsUserEmailConfirmedQuery(baseOptions?: Apollo.QueryHookOptions<IsUserEmailConfirmedQuery, IsUserEmailConfirmedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsUserEmailConfirmedQuery, IsUserEmailConfirmedQueryVariables>(IsUserEmailConfirmedDocument, options);
      }
export function useIsUserEmailConfirmedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsUserEmailConfirmedQuery, IsUserEmailConfirmedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsUserEmailConfirmedQuery, IsUserEmailConfirmedQueryVariables>(IsUserEmailConfirmedDocument, options);
        }
export function useIsUserEmailConfirmedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IsUserEmailConfirmedQuery, IsUserEmailConfirmedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsUserEmailConfirmedQuery, IsUserEmailConfirmedQueryVariables>(IsUserEmailConfirmedDocument, options);
        }
export type IsUserEmailConfirmedQueryHookResult = ReturnType<typeof useIsUserEmailConfirmedQuery>;
export type IsUserEmailConfirmedLazyQueryHookResult = ReturnType<typeof useIsUserEmailConfirmedLazyQuery>;
export type IsUserEmailConfirmedSuspenseQueryHookResult = ReturnType<typeof useIsUserEmailConfirmedSuspenseQuery>;
export type IsUserEmailConfirmedQueryResult = Apollo.QueryResult<IsUserEmailConfirmedQuery, IsUserEmailConfirmedQueryVariables>;
export const VerifyEmailRequestDocument = gql`
    mutation VerifyEmailRequest {
  verifyEmailRequest
}
    `;
export type VerifyEmailRequestMutationFn = Apollo.MutationFunction<VerifyEmailRequestMutation, VerifyEmailRequestMutationVariables>;

/**
 * __useVerifyEmailRequestMutation__
 *
 * To run a mutation, you first call `useVerifyEmailRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailRequestMutation, { data, loading, error }] = useVerifyEmailRequestMutation({
 *   variables: {
 *   },
 * });
 */
export function useVerifyEmailRequestMutation(baseOptions?: Apollo.MutationHookOptions<VerifyEmailRequestMutation, VerifyEmailRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyEmailRequestMutation, VerifyEmailRequestMutationVariables>(VerifyEmailRequestDocument, options);
      }
export type VerifyEmailRequestMutationHookResult = ReturnType<typeof useVerifyEmailRequestMutation>;
export type VerifyEmailRequestMutationResult = Apollo.MutationResult<VerifyEmailRequestMutation>;
export type VerifyEmailRequestMutationOptions = Apollo.BaseMutationOptions<VerifyEmailRequestMutation, VerifyEmailRequestMutationVariables>;
export const EditUserContactDetailsDocument = gql`
    mutation EditUserContactDetails($input: EditUserContactDetailsInput!) {
  editUserContactDetails(input: $input)
}
    `;
export type EditUserContactDetailsMutationFn = Apollo.MutationFunction<EditUserContactDetailsMutation, EditUserContactDetailsMutationVariables>;

/**
 * __useEditUserContactDetailsMutation__
 *
 * To run a mutation, you first call `useEditUserContactDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUserContactDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUserContactDetailsMutation, { data, loading, error }] = useEditUserContactDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditUserContactDetailsMutation(baseOptions?: Apollo.MutationHookOptions<EditUserContactDetailsMutation, EditUserContactDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditUserContactDetailsMutation, EditUserContactDetailsMutationVariables>(EditUserContactDetailsDocument, options);
      }
export type EditUserContactDetailsMutationHookResult = ReturnType<typeof useEditUserContactDetailsMutation>;
export type EditUserContactDetailsMutationResult = Apollo.MutationResult<EditUserContactDetailsMutation>;
export type EditUserContactDetailsMutationOptions = Apollo.BaseMutationOptions<EditUserContactDetailsMutation, EditUserContactDetailsMutationVariables>;
export const UsersByIdsDocument = gql`
    query UsersByIds($userIds: [Int!]!) {
  usersByIds(userIds: $userIds) {
    ...PublicUserInfo
  }
}
    ${PublicUserInfoFragmentDoc}`;

/**
 * __useUsersByIdsQuery__
 *
 * To run a query within a React component, call `useUsersByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersByIdsQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useUsersByIdsQuery(baseOptions: Apollo.QueryHookOptions<UsersByIdsQuery, UsersByIdsQueryVariables> & ({ variables: UsersByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersByIdsQuery, UsersByIdsQueryVariables>(UsersByIdsDocument, options);
      }
export function useUsersByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersByIdsQuery, UsersByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersByIdsQuery, UsersByIdsQueryVariables>(UsersByIdsDocument, options);
        }
export function useUsersByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UsersByIdsQuery, UsersByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersByIdsQuery, UsersByIdsQueryVariables>(UsersByIdsDocument, options);
        }
export type UsersByIdsQueryHookResult = ReturnType<typeof useUsersByIdsQuery>;
export type UsersByIdsLazyQueryHookResult = ReturnType<typeof useUsersByIdsLazyQuery>;
export type UsersByIdsSuspenseQueryHookResult = ReturnType<typeof useUsersByIdsSuspenseQuery>;
export type UsersByIdsQueryResult = Apollo.QueryResult<UsersByIdsQuery, UsersByIdsQueryVariables>;
export const AddUserActionLogDocument = gql`
    mutation AddUserActionLog($input: UserActionLogInput!) {
  addUserActionLog(input: $input) {
    ...UserActionLogInfo
  }
}
    ${UserActionLogInfoFragmentDoc}`;
export type AddUserActionLogMutationFn = Apollo.MutationFunction<AddUserActionLogMutation, AddUserActionLogMutationVariables>;

/**
 * __useAddUserActionLogMutation__
 *
 * To run a mutation, you first call `useAddUserActionLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserActionLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserActionLogMutation, { data, loading, error }] = useAddUserActionLogMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUserActionLogMutation(baseOptions?: Apollo.MutationHookOptions<AddUserActionLogMutation, AddUserActionLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserActionLogMutation, AddUserActionLogMutationVariables>(AddUserActionLogDocument, options);
      }
export type AddUserActionLogMutationHookResult = ReturnType<typeof useAddUserActionLogMutation>;
export type AddUserActionLogMutationResult = Apollo.MutationResult<AddUserActionLogMutation>;
export type AddUserActionLogMutationOptions = Apollo.BaseMutationOptions<AddUserActionLogMutation, AddUserActionLogMutationVariables>;
export const UserVenuesByNameDocument = gql`
    query UserVenuesByName($venueName: String!) {
  userVenuesByName(venueName: $venueName) {
    ...VenueInfo
  }
}
    ${VenueInfoFragmentDoc}`;

/**
 * __useUserVenuesByNameQuery__
 *
 * To run a query within a React component, call `useUserVenuesByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserVenuesByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserVenuesByNameQuery({
 *   variables: {
 *      venueName: // value for 'venueName'
 *   },
 * });
 */
export function useUserVenuesByNameQuery(baseOptions: Apollo.QueryHookOptions<UserVenuesByNameQuery, UserVenuesByNameQueryVariables> & ({ variables: UserVenuesByNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserVenuesByNameQuery, UserVenuesByNameQueryVariables>(UserVenuesByNameDocument, options);
      }
export function useUserVenuesByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserVenuesByNameQuery, UserVenuesByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserVenuesByNameQuery, UserVenuesByNameQueryVariables>(UserVenuesByNameDocument, options);
        }
export function useUserVenuesByNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserVenuesByNameQuery, UserVenuesByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserVenuesByNameQuery, UserVenuesByNameQueryVariables>(UserVenuesByNameDocument, options);
        }
export type UserVenuesByNameQueryHookResult = ReturnType<typeof useUserVenuesByNameQuery>;
export type UserVenuesByNameLazyQueryHookResult = ReturnType<typeof useUserVenuesByNameLazyQuery>;
export type UserVenuesByNameSuspenseQueryHookResult = ReturnType<typeof useUserVenuesByNameSuspenseQuery>;
export type UserVenuesByNameQueryResult = Apollo.QueryResult<UserVenuesByNameQuery, UserVenuesByNameQueryVariables>;
export const EditVenueDocument = gql`
    mutation EditVenue($input: EditVenueInput!) {
  editVenue(input: $input) {
    ...VenueInfo
  }
}
    ${VenueInfoFragmentDoc}`;
export type EditVenueMutationFn = Apollo.MutationFunction<EditVenueMutation, EditVenueMutationVariables>;

/**
 * __useEditVenueMutation__
 *
 * To run a mutation, you first call `useEditVenueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditVenueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editVenueMutation, { data, loading, error }] = useEditVenueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditVenueMutation(baseOptions?: Apollo.MutationHookOptions<EditVenueMutation, EditVenueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditVenueMutation, EditVenueMutationVariables>(EditVenueDocument, options);
      }
export type EditVenueMutationHookResult = ReturnType<typeof useEditVenueMutation>;
export type EditVenueMutationResult = Apollo.MutationResult<EditVenueMutation>;
export type EditVenueMutationOptions = Apollo.BaseMutationOptions<EditVenueMutation, EditVenueMutationVariables>;
export const UserVenuesDocument = gql`
    query UserVenues($input: UserVenuesInput!) {
  userVenues(input: $input) {
    edges {
      node {
        ...VenueInfo
      }
      cursor
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${VenueInfoFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useUserVenuesQuery__
 *
 * To run a query within a React component, call `useUserVenuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserVenuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserVenuesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserVenuesQuery(baseOptions: Apollo.QueryHookOptions<UserVenuesQuery, UserVenuesQueryVariables> & ({ variables: UserVenuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserVenuesQuery, UserVenuesQueryVariables>(UserVenuesDocument, options);
      }
export function useUserVenuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserVenuesQuery, UserVenuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserVenuesQuery, UserVenuesQueryVariables>(UserVenuesDocument, options);
        }
export function useUserVenuesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserVenuesQuery, UserVenuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserVenuesQuery, UserVenuesQueryVariables>(UserVenuesDocument, options);
        }
export type UserVenuesQueryHookResult = ReturnType<typeof useUserVenuesQuery>;
export type UserVenuesLazyQueryHookResult = ReturnType<typeof useUserVenuesLazyQuery>;
export type UserVenuesSuspenseQueryHookResult = ReturnType<typeof useUserVenuesSuspenseQuery>;
export type UserVenuesQueryResult = Apollo.QueryResult<UserVenuesQuery, UserVenuesQueryVariables>;
export const SearchVenuesDocument = gql`
    query SearchVenues($input: SearchVenuesInput!) {
  searchVenues(input: $input) {
    ...VenueInfo
  }
}
    ${VenueInfoFragmentDoc}`;

/**
 * __useSearchVenuesQuery__
 *
 * To run a query within a React component, call `useSearchVenuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchVenuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchVenuesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchVenuesQuery(baseOptions: Apollo.QueryHookOptions<SearchVenuesQuery, SearchVenuesQueryVariables> & ({ variables: SearchVenuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchVenuesQuery, SearchVenuesQueryVariables>(SearchVenuesDocument, options);
      }
export function useSearchVenuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchVenuesQuery, SearchVenuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchVenuesQuery, SearchVenuesQueryVariables>(SearchVenuesDocument, options);
        }
export function useSearchVenuesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchVenuesQuery, SearchVenuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchVenuesQuery, SearchVenuesQueryVariables>(SearchVenuesDocument, options);
        }
export type SearchVenuesQueryHookResult = ReturnType<typeof useSearchVenuesQuery>;
export type SearchVenuesLazyQueryHookResult = ReturnType<typeof useSearchVenuesLazyQuery>;
export type SearchVenuesSuspenseQueryHookResult = ReturnType<typeof useSearchVenuesSuspenseQuery>;
export type SearchVenuesQueryResult = Apollo.QueryResult<SearchVenuesQuery, SearchVenuesQueryVariables>;
export const VenueByIdDocument = gql`
    query VenueById($venueId: Int!) {
  venueById(venueId: $venueId) {
    ...VenueInfo
  }
}
    ${VenueInfoFragmentDoc}`;

/**
 * __useVenueByIdQuery__
 *
 * To run a query within a React component, call `useVenueByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenueByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVenueByIdQuery({
 *   variables: {
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useVenueByIdQuery(baseOptions: Apollo.QueryHookOptions<VenueByIdQuery, VenueByIdQueryVariables> & ({ variables: VenueByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VenueByIdQuery, VenueByIdQueryVariables>(VenueByIdDocument, options);
      }
export function useVenueByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VenueByIdQuery, VenueByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VenueByIdQuery, VenueByIdQueryVariables>(VenueByIdDocument, options);
        }
export function useVenueByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VenueByIdQuery, VenueByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VenueByIdQuery, VenueByIdQueryVariables>(VenueByIdDocument, options);
        }
export type VenueByIdQueryHookResult = ReturnType<typeof useVenueByIdQuery>;
export type VenueByIdLazyQueryHookResult = ReturnType<typeof useVenueByIdLazyQuery>;
export type VenueByIdSuspenseQueryHookResult = ReturnType<typeof useVenueByIdSuspenseQuery>;
export type VenueByIdQueryResult = Apollo.QueryResult<VenueByIdQuery, VenueByIdQueryVariables>;
export const VenueDashboardMetricsByVenueIdDocument = gql`
    query VenueDashboardMetricsByVenueId($venueId: Int!) {
  venueDashboardMetricsByVenueId(venueId: $venueId) {
    type
    label
    value
  }
}
    `;

/**
 * __useVenueDashboardMetricsByVenueIdQuery__
 *
 * To run a query within a React component, call `useVenueDashboardMetricsByVenueIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenueDashboardMetricsByVenueIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVenueDashboardMetricsByVenueIdQuery({
 *   variables: {
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useVenueDashboardMetricsByVenueIdQuery(baseOptions: Apollo.QueryHookOptions<VenueDashboardMetricsByVenueIdQuery, VenueDashboardMetricsByVenueIdQueryVariables> & ({ variables: VenueDashboardMetricsByVenueIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VenueDashboardMetricsByVenueIdQuery, VenueDashboardMetricsByVenueIdQueryVariables>(VenueDashboardMetricsByVenueIdDocument, options);
      }
export function useVenueDashboardMetricsByVenueIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VenueDashboardMetricsByVenueIdQuery, VenueDashboardMetricsByVenueIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VenueDashboardMetricsByVenueIdQuery, VenueDashboardMetricsByVenueIdQueryVariables>(VenueDashboardMetricsByVenueIdDocument, options);
        }
export function useVenueDashboardMetricsByVenueIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VenueDashboardMetricsByVenueIdQuery, VenueDashboardMetricsByVenueIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VenueDashboardMetricsByVenueIdQuery, VenueDashboardMetricsByVenueIdQueryVariables>(VenueDashboardMetricsByVenueIdDocument, options);
        }
export type VenueDashboardMetricsByVenueIdQueryHookResult = ReturnType<typeof useVenueDashboardMetricsByVenueIdQuery>;
export type VenueDashboardMetricsByVenueIdLazyQueryHookResult = ReturnType<typeof useVenueDashboardMetricsByVenueIdLazyQuery>;
export type VenueDashboardMetricsByVenueIdSuspenseQueryHookResult = ReturnType<typeof useVenueDashboardMetricsByVenueIdSuspenseQuery>;
export type VenueDashboardMetricsByVenueIdQueryResult = Apollo.QueryResult<VenueDashboardMetricsByVenueIdQuery, VenueDashboardMetricsByVenueIdQueryVariables>;
export const DeleteVenueUserDocument = gql`
    mutation DeleteVenueUser($venueId: NonNegativeInt!, $userId: NonNegativeInt!) {
  deleteVenueUser(venueId: $venueId, userId: $userId) {
    ...VenueUserInfo
  }
}
    ${VenueUserInfoFragmentDoc}`;
export type DeleteVenueUserMutationFn = Apollo.MutationFunction<DeleteVenueUserMutation, DeleteVenueUserMutationVariables>;

/**
 * __useDeleteVenueUserMutation__
 *
 * To run a mutation, you first call `useDeleteVenueUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVenueUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVenueUserMutation, { data, loading, error }] = useDeleteVenueUserMutation({
 *   variables: {
 *      venueId: // value for 'venueId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteVenueUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVenueUserMutation, DeleteVenueUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVenueUserMutation, DeleteVenueUserMutationVariables>(DeleteVenueUserDocument, options);
      }
export type DeleteVenueUserMutationHookResult = ReturnType<typeof useDeleteVenueUserMutation>;
export type DeleteVenueUserMutationResult = Apollo.MutationResult<DeleteVenueUserMutation>;
export type DeleteVenueUserMutationOptions = Apollo.BaseMutationOptions<DeleteVenueUserMutation, DeleteVenueUserMutationVariables>;
export const SetVenueUserRoleDocument = gql`
    mutation SetVenueUserRole($venueId: NonNegativeInt!, $userId: NonNegativeInt!, $role: SetUserRole!) {
  setVenueUserRole(venueId: $venueId, userId: $userId, role: $role) {
    ...VenueUserInfo
  }
}
    ${VenueUserInfoFragmentDoc}`;
export type SetVenueUserRoleMutationFn = Apollo.MutationFunction<SetVenueUserRoleMutation, SetVenueUserRoleMutationVariables>;

/**
 * __useSetVenueUserRoleMutation__
 *
 * To run a mutation, you first call `useSetVenueUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetVenueUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setVenueUserRoleMutation, { data, loading, error }] = useSetVenueUserRoleMutation({
 *   variables: {
 *      venueId: // value for 'venueId'
 *      userId: // value for 'userId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useSetVenueUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<SetVenueUserRoleMutation, SetVenueUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetVenueUserRoleMutation, SetVenueUserRoleMutationVariables>(SetVenueUserRoleDocument, options);
      }
export type SetVenueUserRoleMutationHookResult = ReturnType<typeof useSetVenueUserRoleMutation>;
export type SetVenueUserRoleMutationResult = Apollo.MutationResult<SetVenueUserRoleMutation>;
export type SetVenueUserRoleMutationOptions = Apollo.BaseMutationOptions<SetVenueUserRoleMutation, SetVenueUserRoleMutationVariables>;
export const VenueUsersDocument = gql`
    query VenueUsers($offset: Int, $limit: Int, $orderBy: VenueUserOrderBy, $where: VenueUserFilters) {
  venueUsers(offset: $offset, limit: $limit, orderBy: $orderBy, where: $where) {
    userId
    role
    user {
      id
      email
    }
  }
}
    `;

/**
 * __useVenueUsersQuery__
 *
 * To run a query within a React component, call `useVenueUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenueUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVenueUsersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useVenueUsersQuery(baseOptions?: Apollo.QueryHookOptions<VenueUsersQuery, VenueUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VenueUsersQuery, VenueUsersQueryVariables>(VenueUsersDocument, options);
      }
export function useVenueUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VenueUsersQuery, VenueUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VenueUsersQuery, VenueUsersQueryVariables>(VenueUsersDocument, options);
        }
export function useVenueUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VenueUsersQuery, VenueUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VenueUsersQuery, VenueUsersQueryVariables>(VenueUsersDocument, options);
        }
export type VenueUsersQueryHookResult = ReturnType<typeof useVenueUsersQuery>;
export type VenueUsersLazyQueryHookResult = ReturnType<typeof useVenueUsersLazyQuery>;
export type VenueUsersSuspenseQueryHookResult = ReturnType<typeof useVenueUsersSuspenseQuery>;
export type VenueUsersQueryResult = Apollo.QueryResult<VenueUsersQuery, VenueUsersQueryVariables>;
export const InsertIntoVenueDocument = gql`
    mutation InsertIntoVenue($input: VenueInsertInput!) {
  insertIntoVenue(input: $input) {
    id
  }
}
    `;
export type InsertIntoVenueMutationFn = Apollo.MutationFunction<InsertIntoVenueMutation, InsertIntoVenueMutationVariables>;

/**
 * __useInsertIntoVenueMutation__
 *
 * To run a mutation, you first call `useInsertIntoVenueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertIntoVenueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertIntoVenueMutation, { data, loading, error }] = useInsertIntoVenueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInsertIntoVenueMutation(baseOptions?: Apollo.MutationHookOptions<InsertIntoVenueMutation, InsertIntoVenueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertIntoVenueMutation, InsertIntoVenueMutationVariables>(InsertIntoVenueDocument, options);
      }
export type InsertIntoVenueMutationHookResult = ReturnType<typeof useInsertIntoVenueMutation>;
export type InsertIntoVenueMutationResult = Apollo.MutationResult<InsertIntoVenueMutation>;
export type InsertIntoVenueMutationOptions = Apollo.BaseMutationOptions<InsertIntoVenueMutation, InsertIntoVenueMutationVariables>;
export const UpdateVenueBillingAddressDocument = gql`
    mutation UpdateVenueBillingAddress($id: NonNegativeInt!, $input: AddressInsertInput!) {
  updateVenueBillingAddress(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateVenueBillingAddressMutationFn = Apollo.MutationFunction<UpdateVenueBillingAddressMutation, UpdateVenueBillingAddressMutationVariables>;

/**
 * __useUpdateVenueBillingAddressMutation__
 *
 * To run a mutation, you first call `useUpdateVenueBillingAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVenueBillingAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVenueBillingAddressMutation, { data, loading, error }] = useUpdateVenueBillingAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVenueBillingAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVenueBillingAddressMutation, UpdateVenueBillingAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVenueBillingAddressMutation, UpdateVenueBillingAddressMutationVariables>(UpdateVenueBillingAddressDocument, options);
      }
export type UpdateVenueBillingAddressMutationHookResult = ReturnType<typeof useUpdateVenueBillingAddressMutation>;
export type UpdateVenueBillingAddressMutationResult = Apollo.MutationResult<UpdateVenueBillingAddressMutation>;
export type UpdateVenueBillingAddressMutationOptions = Apollo.BaseMutationOptions<UpdateVenueBillingAddressMutation, UpdateVenueBillingAddressMutationVariables>;
export const VenueIntegrationsDocument = gql`
    query VenueIntegrations($venueId: Int!) {
  venueIntegrations(where: {venueId: {eq: $venueId}}) {
    ...VenueIntegrationsItem
  }
}
    ${VenueIntegrationsItemFragmentDoc}`;

/**
 * __useVenueIntegrationsQuery__
 *
 * To run a query within a React component, call `useVenueIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenueIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVenueIntegrationsQuery({
 *   variables: {
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useVenueIntegrationsQuery(baseOptions: Apollo.QueryHookOptions<VenueIntegrationsQuery, VenueIntegrationsQueryVariables> & ({ variables: VenueIntegrationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VenueIntegrationsQuery, VenueIntegrationsQueryVariables>(VenueIntegrationsDocument, options);
      }
export function useVenueIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VenueIntegrationsQuery, VenueIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VenueIntegrationsQuery, VenueIntegrationsQueryVariables>(VenueIntegrationsDocument, options);
        }
export function useVenueIntegrationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VenueIntegrationsQuery, VenueIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VenueIntegrationsQuery, VenueIntegrationsQueryVariables>(VenueIntegrationsDocument, options);
        }
export type VenueIntegrationsQueryHookResult = ReturnType<typeof useVenueIntegrationsQuery>;
export type VenueIntegrationsLazyQueryHookResult = ReturnType<typeof useVenueIntegrationsLazyQuery>;
export type VenueIntegrationsSuspenseQueryHookResult = ReturnType<typeof useVenueIntegrationsSuspenseQuery>;
export type VenueIntegrationsQueryResult = Apollo.QueryResult<VenueIntegrationsQuery, VenueIntegrationsQueryVariables>;
export const VenueCategoriesDocument = gql`
    query VenueCategories($region: Region!) {
  venueCategories(region: $region) {
    id
    name
    parentId
    localizationKey
  }
}
    `;

/**
 * __useVenueCategoriesQuery__
 *
 * To run a query within a React component, call `useVenueCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenueCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVenueCategoriesQuery({
 *   variables: {
 *      region: // value for 'region'
 *   },
 * });
 */
export function useVenueCategoriesQuery(baseOptions: Apollo.QueryHookOptions<VenueCategoriesQuery, VenueCategoriesQueryVariables> & ({ variables: VenueCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VenueCategoriesQuery, VenueCategoriesQueryVariables>(VenueCategoriesDocument, options);
      }
export function useVenueCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VenueCategoriesQuery, VenueCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VenueCategoriesQuery, VenueCategoriesQueryVariables>(VenueCategoriesDocument, options);
        }
export function useVenueCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VenueCategoriesQuery, VenueCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VenueCategoriesQuery, VenueCategoriesQueryVariables>(VenueCategoriesDocument, options);
        }
export type VenueCategoriesQueryHookResult = ReturnType<typeof useVenueCategoriesQuery>;
export type VenueCategoriesLazyQueryHookResult = ReturnType<typeof useVenueCategoriesLazyQuery>;
export type VenueCategoriesSuspenseQueryHookResult = ReturnType<typeof useVenueCategoriesSuspenseQuery>;
export type VenueCategoriesQueryResult = Apollo.QueryResult<VenueCategoriesQuery, VenueCategoriesQueryVariables>;
export const VenueSettingsByIdDocument = gql`
    query VenueSettingsById($venueId: Int!) {
  venueSettingsByVenueId(venueId: $venueId) {
    ...VenueSettingsInfo
  }
}
    ${VenueSettingsInfoFragmentDoc}`;

/**
 * __useVenueSettingsByIdQuery__
 *
 * To run a query within a React component, call `useVenueSettingsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenueSettingsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVenueSettingsByIdQuery({
 *   variables: {
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useVenueSettingsByIdQuery(baseOptions: Apollo.QueryHookOptions<VenueSettingsByIdQuery, VenueSettingsByIdQueryVariables> & ({ variables: VenueSettingsByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VenueSettingsByIdQuery, VenueSettingsByIdQueryVariables>(VenueSettingsByIdDocument, options);
      }
export function useVenueSettingsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VenueSettingsByIdQuery, VenueSettingsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VenueSettingsByIdQuery, VenueSettingsByIdQueryVariables>(VenueSettingsByIdDocument, options);
        }
export function useVenueSettingsByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VenueSettingsByIdQuery, VenueSettingsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VenueSettingsByIdQuery, VenueSettingsByIdQueryVariables>(VenueSettingsByIdDocument, options);
        }
export type VenueSettingsByIdQueryHookResult = ReturnType<typeof useVenueSettingsByIdQuery>;
export type VenueSettingsByIdLazyQueryHookResult = ReturnType<typeof useVenueSettingsByIdLazyQuery>;
export type VenueSettingsByIdSuspenseQueryHookResult = ReturnType<typeof useVenueSettingsByIdSuspenseQuery>;
export type VenueSettingsByIdQueryResult = Apollo.QueryResult<VenueSettingsByIdQuery, VenueSettingsByIdQueryVariables>;
export const EditVenueSettingsDocument = gql`
    mutation EditVenueSettings($input: EditVenueSettingsInput!) {
  editVenueSettings(input: $input) {
    ...VenueSettingsInfo
  }
}
    ${VenueSettingsInfoFragmentDoc}`;
export type EditVenueSettingsMutationFn = Apollo.MutationFunction<EditVenueSettingsMutation, EditVenueSettingsMutationVariables>;

/**
 * __useEditVenueSettingsMutation__
 *
 * To run a mutation, you first call `useEditVenueSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditVenueSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editVenueSettingsMutation, { data, loading, error }] = useEditVenueSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditVenueSettingsMutation(baseOptions?: Apollo.MutationHookOptions<EditVenueSettingsMutation, EditVenueSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditVenueSettingsMutation, EditVenueSettingsMutationVariables>(EditVenueSettingsDocument, options);
      }
export type EditVenueSettingsMutationHookResult = ReturnType<typeof useEditVenueSettingsMutation>;
export type EditVenueSettingsMutationResult = Apollo.MutationResult<EditVenueSettingsMutation>;
export type EditVenueSettingsMutationOptions = Apollo.BaseMutationOptions<EditVenueSettingsMutation, EditVenueSettingsMutationVariables>;
export const SearchWholesalersDocument = gql`
    query SearchWholesalers($input: WholesalerSearchInput!) {
  searchWholesalers(input: $input) {
    edges {
      node {
        ...WholesalerInfo
      }
      cursor
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${WholesalerInfoFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useSearchWholesalersQuery__
 *
 * To run a query within a React component, call `useSearchWholesalersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchWholesalersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchWholesalersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchWholesalersQuery(baseOptions: Apollo.QueryHookOptions<SearchWholesalersQuery, SearchWholesalersQueryVariables> & ({ variables: SearchWholesalersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchWholesalersQuery, SearchWholesalersQueryVariables>(SearchWholesalersDocument, options);
      }
export function useSearchWholesalersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchWholesalersQuery, SearchWholesalersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchWholesalersQuery, SearchWholesalersQueryVariables>(SearchWholesalersDocument, options);
        }
export function useSearchWholesalersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchWholesalersQuery, SearchWholesalersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchWholesalersQuery, SearchWholesalersQueryVariables>(SearchWholesalersDocument, options);
        }
export type SearchWholesalersQueryHookResult = ReturnType<typeof useSearchWholesalersQuery>;
export type SearchWholesalersLazyQueryHookResult = ReturnType<typeof useSearchWholesalersLazyQuery>;
export type SearchWholesalersSuspenseQueryHookResult = ReturnType<typeof useSearchWholesalersSuspenseQuery>;
export type SearchWholesalersQueryResult = Apollo.QueryResult<SearchWholesalersQuery, SearchWholesalersQueryVariables>;